
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Ht4z", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ProjectComponents", () => $c9b480515f9cda8f$export$7fd01c3d9245bc6a);
$parcel$export(module.exports, "default", () => $c9b480515f9cda8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $2ZRPT = parcelRequire("2ZRPT");

var $7xrrJ = parcelRequire("7xrrJ");

var $eI64M = parcelRequire("eI64M");

var $h5RgW = parcelRequire("h5RgW");
var $lB25E = parcelRequire("lB25E");

var $8r1Yz = parcelRequire("8r1Yz");

var $ixwgj = parcelRequire("ixwgj");

var $bhwgQ = parcelRequire("bhwgQ");

var $6M8Uw = parcelRequire("6M8Uw");

var $gd0Sp = parcelRequire("gd0Sp");

var $i2AAM = parcelRequire("i2AAM");
const $c9b480515f9cda8f$export$7fd01c3d9245bc6a = ({ location: location, match: match })=>{
    const prefetchResult = (0, $h5RgW.useResource)((0, $8r1Yz.projectsComponentsResource));
    const projectContext = (0, $h5RgW.useResource)((0, $ixwgj.projectContextResource));
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { projectKey: projectKey } = match.params;
    if ((0, $eI64M.isProjectArchivedCondition)(projectContext.data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, projectKey && projectContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7xrrJ.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i2AAM.default), {
            projectContext: projectContext,
            tenantContext: tenantContext,
            prefetchResult: {
                ...prefetchResult
            },
            query: query,
            onQueryChanged: onQueryChanged
        })) : null);
};
// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
const $c9b480515f9cda8f$var$RouterWrapper = (0, $lB25E.withRouter)($c9b480515f9cda8f$export$7fd01c3d9245bc6a);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c9b480515f9cda8f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6M8Uw.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ZRPT.default), {
        appNameSuffixForV2Event: "project.components",
        appNameForV3OperationalEvent: "componentsProject"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9b480515f9cda8f$var$RouterWrapper, null));

});
parcelRegister("2ZRPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6453ff056d01e90$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
const $a6453ff056d01e90$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a6453ff056d01e90$export$2e2bcd8739ae039 = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: $a6453ff056d01e90$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("7xrrJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3edf44f1a03d51ca$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8a69t = parcelRequire("8a69t");

var $bCV5q = parcelRequire("bCV5q");

var $f7vpa = parcelRequire("f7vpa");

var $gF8M8 = parcelRequire("gF8M8");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3edf44f1a03d51ca$export$2e2bcd8739ae039 = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8a69t.default), {
        location: location,
        queryFromUrl: (0, $f7vpa.queryFromUrl),
        queryToUrl: (0, $gF8M8.queryToUrl),
        defaultQuery: (0, $bCV5q.initialQuery)
    }, children);

});
parcelRegister("8a69t", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2d6021dcf768f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d9Ot4 = parcelRequire("d9Ot4");

var $jG2Eu = parcelRequire("jG2Eu");

var $53ciZ = parcelRequire("53ciZ");

var $lB25E = parcelRequire("lB25E");

var $8jHuS = parcelRequire("8jHuS");

var $1pGxn = parcelRequire("1pGxn");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ef2d6021dcf768f3$export$2e2bcd8739ae039 = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($d9Ot4)))((0, $8jHuS.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1pGxn.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};

});
parcelRegister("d9Ot4", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $9eFtX = parcelRequire("9eFtX");

var $3sthv = parcelRequire("3sthv");

var $hir2i = parcelRequire("hir2i");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $9943437a9aaf123b$var$defaultsDeep = $9eFtX(function(args) {
    args.push(undefined, $3sthv);
    return $5VdlS($hir2i, undefined, args);
});
module.exports = $9943437a9aaf123b$var$defaultsDeep;

});
parcelRegister("3sthv", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $284ab34764b969d3$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($feGjZ(objValue) && $feGjZ(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $eljWd(objValue, srcValue, undefined, $284ab34764b969d3$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $284ab34764b969d3$var$customDefaultsMerge;

});

parcelRegister("hir2i", function(module, exports) {

var $eljWd = parcelRequire("eljWd");

var $3Bqj8 = parcelRequire("3Bqj8");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $c97916e8180d3b9a$var$mergeWith = $3Bqj8(function(object, source, srcIndex, customizer) {
    $eljWd(object, source, srcIndex, customizer);
});
module.exports = $c97916e8180d3b9a$var$mergeWith;

});


parcelRegister("8jHuS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0c9711daed9ec66$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $czx3b = parcelRequire("czx3b");
const $c0c9711daed9ec66$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c0c9711daed9ec66$export$2e2bcd8739ae039 = $c0c9711daed9ec66$var$fromUrlTransformerFactory;

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});


parcelRegister("1pGxn", function(module, exports) {

$parcel$export(module.exports, "AdapterWithState", () => $094acac0772cfbd6$export$2fcc0cb3ae18b63e);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $53ciZ = parcelRequire("53ciZ");
class $094acac0772cfbd6$export$2fcc0cb3ae18b63e extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        };
        this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("bCV5q", function(module, exports) {

$parcel$export(module.exports, "initialQuery", () => $74f3ea086408d3ce$export$8af7177c92ae79e3);

var $2x4ku = parcelRequire("2x4ku");

var $2Mzjc = parcelRequire("2Mzjc");
const $74f3ea086408d3ce$export$8af7177c92ae79e3 = {
    orderField: (0, $2Mzjc.NAME),
    orderDirection: (0, $2x4ku.ASC),
    page: 1,
    filter: ''
};

});
parcelRegister("2x4ku", function(module, exports) {

$parcel$export(module.exports, "ASC", () => $79b52cc06e200d05$export$1dee026a19752d6b);
$parcel$export(module.exports, "DESC", () => $79b52cc06e200d05$export$b6abcf7fa1d94f65);
$parcel$export(module.exports, "ORDER_DIRECTION", () => $79b52cc06e200d05$export$543711d9afc9aac1);
const $79b52cc06e200d05$export$1dee026a19752d6b = 'ASC';
const $79b52cc06e200d05$export$b6abcf7fa1d94f65 = 'DESC';
const $79b52cc06e200d05$export$543711d9afc9aac1 = {
    [$79b52cc06e200d05$export$1dee026a19752d6b]: $79b52cc06e200d05$export$1dee026a19752d6b,
    [$79b52cc06e200d05$export$b6abcf7fa1d94f65]: $79b52cc06e200d05$export$b6abcf7fa1d94f65
};

});

parcelRegister("2Mzjc", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $dfbc9378350d5a9c$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $dfbc9378350d5a9c$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $dfbc9378350d5a9c$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $dfbc9378350d5a9c$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELD", () => $dfbc9378350d5a9c$export$55c82710eb02082c);
const $dfbc9378350d5a9c$export$3c5e605ca7ade9f2 = 'NAME';
const $dfbc9378350d5a9c$export$d44826c816b5619b = 'DESCRIPTION';
const $dfbc9378350d5a9c$export$73dcda99369fd988 = 'LEAD';
const $dfbc9378350d5a9c$export$1c62ab608c48125c = 'ISSUES';
const $dfbc9378350d5a9c$export$55c82710eb02082c = {
    [$dfbc9378350d5a9c$export$3c5e605ca7ade9f2]: $dfbc9378350d5a9c$export$3c5e605ca7ade9f2,
    [$dfbc9378350d5a9c$export$d44826c816b5619b]: $dfbc9378350d5a9c$export$d44826c816b5619b,
    [$dfbc9378350d5a9c$export$73dcda99369fd988]: $dfbc9378350d5a9c$export$73dcda99369fd988,
    [$dfbc9378350d5a9c$export$1c62ab608c48125c]: $dfbc9378350d5a9c$export$1c62ab608c48125c
};

});


parcelRegister("f7vpa", function(module, exports) {

$parcel$export(module.exports, "queryFromUrl", () => $7ef9b3c7c917c9a9$export$34bcc098502c2587);

var $2x4ku = parcelRequire("2x4ku");

var $2Mzjc = parcelRequire("2Mzjc");
const $7ef9b3c7c917c9a9$var$getOrderEntity = (target, value, defaults)=>Object.values(target).includes(value) ? value : defaults;
const $7ef9b3c7c917c9a9$export$dbde9a25ef92ab90 = (field)=>$7ef9b3c7c917c9a9$var$getOrderEntity((0, $2Mzjc.ORDER_FIELD), field, (0, $2Mzjc.ORDER_FIELD).NAME);
const $7ef9b3c7c917c9a9$export$d13e6a6b186c83d7 = (direction)=>$7ef9b3c7c917c9a9$var$getOrderEntity((0, $2x4ku.ORDER_DIRECTION), direction, (0, $2x4ku.ORDER_DIRECTION).DESC);
const $7ef9b3c7c917c9a9$export$aa86da1aa250e687 = (page)=>typeof Number(page) === 'number' && Number(page) >= 1 ? Number(page) : 1;
const $7ef9b3c7c917c9a9$export$34bcc098502c2587 = ({ filter: filter, orderDirection: orderDirection, orderField: orderField, page: page })=>({
        filter: filter || '',
        orderDirection: $7ef9b3c7c917c9a9$export$d13e6a6b186c83d7(orderDirection),
        orderField: $7ef9b3c7c917c9a9$export$dbde9a25ef92ab90(orderField),
        page: $7ef9b3c7c917c9a9$export$aa86da1aa250e687(page)
    });

});

parcelRegister("gF8M8", function(module, exports) {

$parcel$export(module.exports, "queryToUrl", () => $4cf9b70ae39bb256$export$2ecaae24d8b0a6a8);
const $4cf9b70ae39bb256$export$2ecaae24d8b0a6a8 = (query)=>{
    if (query) {
        const { filter: filter, orderDirection: orderDirection, orderField: orderField, page: page } = query;
        return {
            filter: filter,
            orderDirection: orderDirection,
            orderField: orderField,
            page: page
        };
    }
    return {};
};

});


parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("i2AAM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe2540de967dbd3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $8J5kD = parcelRequire("8J5kD");

var $fO5rB = parcelRequire("fO5rB");

var $jqro2 = parcelRequire("jqro2");
const $2fe2540de967dbd3$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: "platform"
    });
var $2fe2540de967dbd3$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $jqro2.default), {
    ProjectDirectoriesApp: $8J5kD.default,
    Updater: $2fe2540de967dbd3$var$Updater
});

});
parcelRegister("8J5kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $04680f11b1d2db68$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $jG2Eu = parcelRequire("jG2Eu");

var $jPfP5 = parcelRequire("jPfP5");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $aR8n6 = parcelRequire("aR8n6");

var $9m9bG = parcelRequire("9m9bG");

var $bCV5q = parcelRequire("bCV5q");

var $kuteD = parcelRequire("kuteD");

var $93eEg = parcelRequire("93eEg");

var $HaB3Y = parcelRequire("HaB3Y");

var $67HZZ = parcelRequire("67HZZ");

var $fnVSJ = parcelRequire("fnVSJ");

var $aLD7K = parcelRequire("aLD7K");

var $aVLWV = parcelRequire("aVLWV");

var $ftoH8 = parcelRequire("ftoH8");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");

var $bt1JN = parcelRequire("bt1JN");
class $04680f11b1d2db68$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            isAdmin: false,
            prefetchedData: null,
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            query: (0, $bCV5q.initialQuery),
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    constructor(props){
        super(props);
        const { locale: locale, baseUrl: baseUrl, projectKey: projectKey, projectId: projectId, projectName: projectName, isAdmin: isAdmin, projectType: projectType, prefetchedData: prefetchedData, query: query, onQueryChanged: onQueryChanged } = props;
        const project = {
            id: projectId,
            key: projectKey,
            name: projectName,
            type: projectType
        };
        const analyticsData = {
            projectType: projectType
        };
        this.store = (0, $67HZZ.default)((0, $HaB3Y.default));
        this.store.dispatch((0, $aVLWV.set)({
            baseUrl: baseUrl,
            isAdmin: isAdmin,
            locale: locale,
            onQueryChanged: onQueryChanged
        }));
        this.store.dispatch((0, $ftoH8.set)(project));
        this.store.dispatch((0, $aLD7K.set)(analyticsData));
        this.store.dispatch((0, $bau7U.setQuery)(query || (0, $bCV5q.initialQuery)));
        if (prefetchedData) this.store.dispatch((0, $fnVSJ.setComponentsPage)(prefetchedData));
        else this.store.dispatch((0, $fnVSJ.getComponentsPageRequest)({
            page: (0, $1FdCJ.getCurrentPage)(this.store.getState()),
            initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).VIEW
        }));
    }
    componentDidUpdate() {
        const { query: query } = this.props;
        if (query && query && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(query, (0, $1FdCJ.getQuery)(this.store.getState()))) this.store.dispatch((0, $bau7U.setQuery)(query));
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m9bG.FlagsDispatcher), {
            mapper: (0, $93eEg.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bt1JN.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jPfP5.default), null))));
    }
}

});
parcelRegister("jPfP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87fa35216d96bc0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $etqm0 = parcelRequire("etqm0");
// eslint-disable-next-line jira/react/no-class-components
class $87fa35216d96bc0f$var$ViewTracker extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return null;
    }
}
const $87fa35216d96bc0f$var$ViewTrackerWithAnalytics = (0, $1ngde.default)({
    componentName: 'view-tracker'
})((0, $2jDha.default)({
    onMount: (createEvent)=>createEvent({
            action: (0, $etqm0.PAGE_EVENT_ACTION)
        }).fire()
})($87fa35216d96bc0f$var$ViewTracker));
var // without onMount={noop} it won't work, defaultProps won't help
// @ts-expect-error - TS2322 - Type '{ onMount: (...args: any[]) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<WithAnalyticsEventsProps, never> & RefAttributes<any> & WithContextProps, "key" | "analyticsContext"> & RefAttributes<...>'.
// eslint-disable-next-line jira/import/no-anonymous-default-export
$87fa35216d96bc0f$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($87fa35216d96bc0f$var$ViewTrackerWithAnalytics, {
        onMount: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    });

});

parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});

parcelRegister("9m9bG", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $002bf7125eab9f2d$export$9e60e3d40b6e758f);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $9IFOX = parcelRequire("9IFOX");
const $002bf7125eab9f2d$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9IFOX.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $k8Qyf.showFlag),
        dismissFlag: (0, $k8Qyf.dismissFlag)
    });

});
parcelRegister("9IFOX", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $d0a959626f60d440$export$ab054a1ef92eeb01);

var $eUqFw = parcelRequire("eUqFw");

var $6Yzg9 = parcelRequire("6Yzg9");
const $d0a959626f60d440$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eUqFw.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eUqFw.useMemo)(()=>(0, $6Yzg9.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("6Yzg9", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $4432f346a9cf5cd1$export$7b259d28468da15b);

var $eUqFw = parcelRequire("eUqFw");

var $3npQj = parcelRequire("3npQj");

var $k8Qyf = parcelRequire("k8Qyf");
const $4432f346a9cf5cd1$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $4432f346a9cf5cd1$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $k8Qyf.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $k8Qyf.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3npQj.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $4432f346a9cf5cd1$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $k8Qyf.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $4432f346a9cf5cd1$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $4432f346a9cf5cd1$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $4432f346a9cf5cd1$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eUqFw.useMemo)(()=>$4432f346a9cf5cd1$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $4432f346a9cf5cd1$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $4432f346a9cf5cd1$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $3npQj.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4432f346a9cf5cd1$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $4432f346a9cf5cd1$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4432f346a9cf5cd1$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $4432f346a9cf5cd1$var$Dispatcher8DefaultStore;
};

});



parcelRegister("kuteD", function(module, exports) {

$parcel$export(module.exports, "FETCH_COMPONENTS_REASON", () => $a6a2601ca2e01575$export$66a91c2022d4732);
const $a6a2601ca2e01575$export$397e49c56ae84012 = 'VIEW';
const $a6a2601ca2e01575$export$8fe76e5b77038f3e = 'FILTERING';
const $a6a2601ca2e01575$export$75081ca35b4dae45 = 'SORTING';
const $a6a2601ca2e01575$export$ceb692a4f4f3a013 = 'COMPONENT_CREATED';
const $a6a2601ca2e01575$export$fa4ff5560bcaba4d = 'COMPONENT_DELETED';
const $a6a2601ca2e01575$export$78216513f47e03b8 = 'COMPONENT_UPDATED';
const $a6a2601ca2e01575$export$66a91c2022d4732 = {
    VIEW: $a6a2601ca2e01575$export$397e49c56ae84012,
    FILTERING: $a6a2601ca2e01575$export$8fe76e5b77038f3e,
    SORTING: $a6a2601ca2e01575$export$75081ca35b4dae45,
    COMPONENT_CREATED: $a6a2601ca2e01575$export$ceb692a4f4f3a013,
    COMPONENT_DELETED: $a6a2601ca2e01575$export$fa4ff5560bcaba4d,
    COMPONENT_UPDATED: $a6a2601ca2e01575$export$78216513f47e03b8
};

});

parcelRegister("93eEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc009c1ebdf4ef7$export$2e2bcd8739ae039);

var $fnVSJ = parcelRequire("fnVSJ");

var $017SQ = parcelRequire("017SQ");

var $l5qyD = parcelRequire("l5qyD");

var $77JFt = parcelRequire("77JFt");

var $1YStw = parcelRequire("1YStw");

var $h3HYE = parcelRequire("h3HYE");

var $b2PYd = parcelRequire("b2PYd");

var $4A52d = parcelRequire("4A52d");
const $8fc009c1ebdf4ef7$var$flagsMapper = (action)=>{
    switch(action.type){
        case 0, $fnVSJ.ADD_COMPONENT_SUCCESS:
            return (0, $l5qyD.default)(action.payload.name);
        case 0, $fnVSJ.ADD_COMPONENT_FAIL:
            return (0, $017SQ.default)();
        case 0, $fnVSJ.DELETE_COMPONENT_SUCCESS:
            return (0, $1YStw.default)(action.payload.component.name);
        case 0, $fnVSJ.DELETE_COMPONENT_FAILURE:
            return (0, $77JFt.default)();
        case 0, $fnVSJ.UPDATE_COMPONENT_SUCCESS:
            return (0, $4A52d.default)(action.payload.componentName);
        case 0, $fnVSJ.UPDATE_COMPONENT_FAIL:
            return (0, $h3HYE.default)();
        case 0, $fnVSJ.INITIATE_UPDATE_COMPONENT_FAIL:
            return (0, $b2PYd.default)();
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $8fc009c1ebdf4ef7$export$2e2bcd8739ae039 = $8fc009c1ebdf4ef7$var$flagsMapper;

});
parcelRegister("fnVSJ", function(module, exports) {

$parcel$export(module.exports, "ADD_COMPONENT_SUCCESS", () => $c0a912267eb4ad5f$export$c183a38d4b59a6d9);
$parcel$export(module.exports, "addComponentSuccess", () => $c0a912267eb4ad5f$export$4d0d7b371036da7e);
$parcel$export(module.exports, "ADD_COMPONENT_FAIL", () => $c0a912267eb4ad5f$export$4fa38ebaaae89345);
$parcel$export(module.exports, "addComponentFail", () => $c0a912267eb4ad5f$export$cb5b2c24e0a5dde9);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT", () => $c0a912267eb4ad5f$export$1c8d8242dfd2faaa);
$parcel$export(module.exports, "initiateUpdateComponent", () => $c0a912267eb4ad5f$export$a82c94a7a4ba9a48);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT_SUCCESS", () => $c0a912267eb4ad5f$export$65b2950c8245ca00);
$parcel$export(module.exports, "initiateUpdateComponentSuccess", () => $c0a912267eb4ad5f$export$f029600573ab2333);
$parcel$export(module.exports, "INITIATE_UPDATE_COMPONENT_FAIL", () => $c0a912267eb4ad5f$export$7c00c0ce897afa48);
$parcel$export(module.exports, "initiateUpdateComponentFail", () => $c0a912267eb4ad5f$export$1e8dcb553d0c7dcf);
$parcel$export(module.exports, "UPDATE_COMPONENT_REQUEST", () => $c0a912267eb4ad5f$export$b676f3c0288df16a);
$parcel$export(module.exports, "updateComponentRequest", () => $c0a912267eb4ad5f$export$9553a85e2bc20da3);
$parcel$export(module.exports, "PATCH_COMPONENT", () => $c0a912267eb4ad5f$export$76d71ef1b430c044);
$parcel$export(module.exports, "patchComponent", () => $c0a912267eb4ad5f$export$c21b0e7ef80ba29f);
$parcel$export(module.exports, "UPDATE_COMPONENT_SUCCESS", () => $c0a912267eb4ad5f$export$543e05e6a6883af);
$parcel$export(module.exports, "updateComponentSuccess", () => $c0a912267eb4ad5f$export$77f1acf01c0045cd);
$parcel$export(module.exports, "UPDATE_COMPONENT_FAIL", () => $c0a912267eb4ad5f$export$8cd0c0bce936b058);
$parcel$export(module.exports, "updateComponentFail", () => $c0a912267eb4ad5f$export$d24cd5f476018727);
$parcel$export(module.exports, "UPDATE_COMPONENT_VALIDATION_FAIL", () => $c0a912267eb4ad5f$export$6c721d766648f32a);
$parcel$export(module.exports, "updateComponentValidationFail", () => $c0a912267eb4ad5f$export$18bef1cc777a2207);
$parcel$export(module.exports, "GET_COMPONENTS_PAGE_REQUEST", () => $c0a912267eb4ad5f$export$61cc82f1967db37b);
$parcel$export(module.exports, "getComponentsPageRequest", () => $c0a912267eb4ad5f$export$af441cb160ff9e19);
$parcel$export(module.exports, "SET_COMPONENTS_PAGE", () => $c0a912267eb4ad5f$export$e0ab2efe830203fb);
$parcel$export(module.exports, "setComponentsPage", () => $c0a912267eb4ad5f$export$4f58aa0a531045ac);
$parcel$export(module.exports, "DELETE_COMPONENT_SUCCESS", () => $c0a912267eb4ad5f$export$da077ae08c543bd0);
$parcel$export(module.exports, "deleteComponentSuccess", () => $c0a912267eb4ad5f$export$8d34c79dac47f8f3);
$parcel$export(module.exports, "DELETE_COMPONENT_FAILURE", () => $c0a912267eb4ad5f$export$cccbe1054a0c3a89);
$parcel$export(module.exports, "deleteComponentFailure", () => $c0a912267eb4ad5f$export$ac7d0962a47d8bf0);
const $c0a912267eb4ad5f$export$c183a38d4b59a6d9 = 'root.ADD_COMPONENT_SUCCESS';
const $c0a912267eb4ad5f$export$4d0d7b371036da7e = (payload)=>({
        type: $c0a912267eb4ad5f$export$c183a38d4b59a6d9,
        payload: payload
    });
const $c0a912267eb4ad5f$export$4fa38ebaaae89345 = 'root.ADD_COMPONENT_FAIL';
const $c0a912267eb4ad5f$export$cb5b2c24e0a5dde9 = ()=>({
        type: $c0a912267eb4ad5f$export$4fa38ebaaae89345
    });
const $c0a912267eb4ad5f$export$1c8d8242dfd2faaa = 'root.INITIATE_UPDATE_COMPONENT';
const $c0a912267eb4ad5f$export$a82c94a7a4ba9a48 = (payload)=>({
        type: $c0a912267eb4ad5f$export$1c8d8242dfd2faaa,
        payload: payload
    });
const $c0a912267eb4ad5f$export$65b2950c8245ca00 = 'root.INITIATE_UPDATE_COMPONENT_SUCCESS';
const $c0a912267eb4ad5f$export$f029600573ab2333 = (payload)=>({
        type: $c0a912267eb4ad5f$export$65b2950c8245ca00,
        payload: payload
    });
const $c0a912267eb4ad5f$export$7c00c0ce897afa48 = 'root.INITIATE_UPDATE_COMPONENT_FAIL';
const $c0a912267eb4ad5f$export$1e8dcb553d0c7dcf = (payload)=>({
        type: $c0a912267eb4ad5f$export$7c00c0ce897afa48,
        payload: payload
    });
const $c0a912267eb4ad5f$export$b676f3c0288df16a = 'root.UPDATE_COMPONENT_REQUEST';
const $c0a912267eb4ad5f$export$9553a85e2bc20da3 = ()=>({
        type: $c0a912267eb4ad5f$export$b676f3c0288df16a
    });
const $c0a912267eb4ad5f$export$76d71ef1b430c044 = 'root.PATCH_COMPONENT';
const $c0a912267eb4ad5f$export$c21b0e7ef80ba29f = (payload)=>({
        type: $c0a912267eb4ad5f$export$76d71ef1b430c044,
        payload: payload
    });
const $c0a912267eb4ad5f$export$543e05e6a6883af = 'root.UPDATE_COMPONENT_SUCCESS';
const $c0a912267eb4ad5f$export$77f1acf01c0045cd = (payload)=>({
        type: $c0a912267eb4ad5f$export$543e05e6a6883af,
        payload: payload
    });
const $c0a912267eb4ad5f$export$8cd0c0bce936b058 = 'root.UPDATE_COMPONENT_FAIL';
const $c0a912267eb4ad5f$export$d24cd5f476018727 = (payload)=>({
        type: $c0a912267eb4ad5f$export$8cd0c0bce936b058,
        payload: payload
    });
const $c0a912267eb4ad5f$export$6c721d766648f32a = 'root.UPDATE_COMPONENT_VALIDATION_FAIL';
const $c0a912267eb4ad5f$export$18bef1cc777a2207 = (payload)=>({
        type: $c0a912267eb4ad5f$export$6c721d766648f32a,
        payload: payload
    });
const $c0a912267eb4ad5f$export$61cc82f1967db37b = 'components.GET_COMPONENTS_PAGE_REQUEST';
const $c0a912267eb4ad5f$export$af441cb160ff9e19 = (payload)=>({
        type: $c0a912267eb4ad5f$export$61cc82f1967db37b,
        payload: payload
    });
const $c0a912267eb4ad5f$export$e0ab2efe830203fb = 'components.SET_COMPONENTS_PAGE';
const $c0a912267eb4ad5f$export$4f58aa0a531045ac = (payload)=>({
        type: $c0a912267eb4ad5f$export$e0ab2efe830203fb,
        payload: payload
    });
const $c0a912267eb4ad5f$export$da077ae08c543bd0 = 'components.DELETE_COMPONENT_SUCCESS';
const $c0a912267eb4ad5f$export$8d34c79dac47f8f3 = (payload)=>({
        type: $c0a912267eb4ad5f$export$da077ae08c543bd0,
        payload: payload
    });
const $c0a912267eb4ad5f$export$cccbe1054a0c3a89 = 'components.DELETE_COMPONENT_FAILURE';
const $c0a912267eb4ad5f$export$ac7d0962a47d8bf0 = (payload)=>({
        type: $c0a912267eb4ad5f$export$cccbe1054a0c3a89,
        payload: payload
    });

});

parcelRegister("017SQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c553fe9fe939e737$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c553fe9fe939e737$var$messages = (0, $90IgZ.defineMessages)({
    componentAdditionFailedTitle: {
        "id": "project-components.flags.component-addition-failed-title",
        "defaultMessage": "We couldn't create the component."
    },
    componentAdditionFailedDescription: {
        "id": "project-components.flags.component-addition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c553fe9fe939e737$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $c553fe9fe939e737$var$messages.componentAdditionFailedTitle,
        description: $c553fe9fe939e737$var$messages.componentAdditionFailedDescription
    });

});

parcelRegister("l5qyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $73724cae8895a59e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $73724cae8895a59e$var$messages = (0, $90IgZ.defineMessages)({
    componentAddedTitle: {
        "id": "project-components.flags.component-added-title",
        "defaultMessage": "{name} added"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$73724cae8895a59e$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $73724cae8895a59e$var$messages.componentAddedTitle,
            {
                name: name
            }
        ]
    });

});

parcelRegister("77JFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $07406e366d12ad67$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $07406e366d12ad67$var$messages = (0, $90IgZ.defineMessages)({
    componentDeletionFailedTitle: {
        "id": "project-components.flags.component-deletion-failed-title",
        "defaultMessage": "We couldn't delete the component"
    },
    componentDeletionFailedDescription: {
        "id": "project-components.flags.component-deletion-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07406e366d12ad67$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $07406e366d12ad67$var$messages.componentDeletionFailedTitle,
        description: $07406e366d12ad67$var$messages.componentDeletionFailedDescription
    });

});

parcelRegister("1YStw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f67734001b1c1b8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $6f67734001b1c1b8$var$messages = (0, $90IgZ.defineMessages)({
    componentDeletedTitle: {
        "id": "project-components.flags.component-deleted-title",
        "defaultMessage": "{name} deleted"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6f67734001b1c1b8$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $6f67734001b1c1b8$var$messages.componentDeletedTitle,
            {
                name: name
            }
        ]
    });

});

parcelRegister("h3HYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ae03ac165d0422$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $87ae03ac165d0422$var$messages = (0, $90IgZ.defineMessages)({
    componentEditionFailedTitle: {
        "id": "project-components.flags.component-edition-failed-title",
        "defaultMessage": "We couldn't edit the component"
    },
    componentEditionFailedDescription: {
        "id": "project-components.flags.component-edition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87ae03ac165d0422$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $87ae03ac165d0422$var$messages.componentEditionFailedTitle,
        description: $87ae03ac165d0422$var$messages.componentEditionFailedDescription
    });

});

parcelRegister("b2PYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e39891f9d88c8c0f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e39891f9d88c8c0f$var$messages = (0, $90IgZ.defineMessages)({
    componentEditionFailedTitle: {
        "id": "project-components.flags.component-edition-failed-title",
        "defaultMessage": "We couldn't edit the component"
    },
    componentEditionFailedDescription: {
        "id": "project-components.flags.component-edition-failed-description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e39891f9d88c8c0f$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        isAutoDismiss: false,
        title: $e39891f9d88c8c0f$var$messages.componentEditionFailedTitle,
        description: $e39891f9d88c8c0f$var$messages.componentEditionFailedDescription
    });

});

parcelRegister("4A52d", function(module, exports) {

$parcel$export(module.exports, "default", () => $96bb01b5ab54173d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $96bb01b5ab54173d$var$messages = (0, $90IgZ.defineMessages)({
    componentEditedTitle: {
        "id": "project-components.flags.component-edited-title",
        "defaultMessage": "{name} updated"
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$96bb01b5ab54173d$export$2e2bcd8739ae039 = (name)=>({
        type: 'success',
        isAutoDismiss: true,
        title: [
            $96bb01b5ab54173d$var$messages.componentEditedTitle,
            {
                name: name
            }
        ]
    });

});


parcelRegister("HaB3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $acc88c5811a333dc$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $f0v2C = parcelRequire("f0v2C");

var $2WphU = parcelRequire("2WphU");

var $1hjS9 = parcelRequire("1hjS9");

var $adw89 = parcelRequire("adw89");

var $fWLEp = parcelRequire("fWLEp");

var $gslJI = parcelRequire("gslJI");
var $acc88c5811a333dc$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $fWLEp.retrieveComponents), (0, $f0v2C.default), (0, $gslJI.updateComponent), (0, $gslJI.initiateUpdateComponent), (0, $2WphU.successfulDelete), (0, $adw89.querySet), (0, $1hjS9.queryPatched));

});
parcelRegister("f0v2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1da116ba03ab8b$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $1FdCJ = parcelRequire("1FdCJ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b1da116ba03ab8b$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $fnVSJ.ADD_COMPONENT_SUCCESS)).mergeMap(()=>(0, $3JafE.Observable).of((0, $fnVSJ.getComponentsPageRequest)({
            page: (0, $1FdCJ.getCurrentPage)(store.getState()),
            initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).COMPONENT_CREATED
        })));

});
parcelRegister("1FdCJ", function(module, exports) {

$parcel$export(module.exports, "getQuery", () => $d8e93980c67cbbd9$export$71eec30d9db46a56);
$parcel$export(module.exports, "getOnQueryChanged", () => $d8e93980c67cbbd9$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getOrderDirection", () => $d8e93980c67cbbd9$export$2e04c020ca8711f5);
$parcel$export(module.exports, "getOrderField", () => $d8e93980c67cbbd9$export$f1954ff3a9ce71ff);
$parcel$export(module.exports, "getFilter", () => $d8e93980c67cbbd9$export$61ec8404f465cd36);
$parcel$export(module.exports, "getCurrentPage", () => $d8e93980c67cbbd9$export$7945ba8eb1c827e6);
$parcel$export(module.exports, "getOrderBy", () => $d8e93980c67cbbd9$export$128f09144c413f07);

var $igneF = parcelRequire("igneF");
const $d8e93980c67cbbd9$export$71eec30d9db46a56 = (state)=>state.query;
const $d8e93980c67cbbd9$export$59e4f8ebf6520bf7 = (state)=>state.context.onQueryChanged;
const $d8e93980c67cbbd9$export$2e04c020ca8711f5 = (state)=>state.query.orderDirection;
const $d8e93980c67cbbd9$export$f1954ff3a9ce71ff = (state)=>state.query.orderField;
const $d8e93980c67cbbd9$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $d8e93980c67cbbd9$export$7945ba8eb1c827e6 = (state)=>state.query.page;
const $d8e93980c67cbbd9$export$128f09144c413f07 = (state)=>(0, $igneF.mapToOrderFetch)($d8e93980c67cbbd9$export$f1954ff3a9ce71ff(state), $d8e93980c67cbbd9$export$2e04c020ca8711f5(state));

});
parcelRegister("igneF", function(module, exports) {

$parcel$export(module.exports, "mapToOrderFetch", () => $9e1ceb5c8f958091$export$6236a5c184fedc41);

var $2x4ku = parcelRequire("2x4ku");

var $2Mzjc = parcelRequire("2Mzjc");
const $9e1ceb5c8f958091$export$cab2635bfaf51f49 = {
    [(0, $2Mzjc.NAME)]: 'name',
    [(0, $2Mzjc.DESCRIPTION)]: 'description',
    [(0, $2Mzjc.LEAD)]: 'lead',
    [(0, $2Mzjc.ISSUES)]: 'issueCount'
};
const $9e1ceb5c8f958091$export$6236a5c184fedc41 = (orderField, orderDirection)=>(orderDirection === (0, $2x4ku.DESC) ? '-' : '+') + $9e1ceb5c8f958091$export$cab2635bfaf51f49[orderField];

});



parcelRegister("2WphU", function(module, exports) {

$parcel$export(module.exports, "successfulDelete", () => $5a79bc09ef4b77aa$export$fb40872e7cc28b47);
parcelRequire("jyKN9");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $cHQhb = parcelRequire("cHQhb");

var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $cXEqp = parcelRequire("cXEqp");

var $1FdCJ = parcelRequire("1FdCJ");

var $ccYHR = parcelRequire("ccYHR");
const $5a79bc09ef4b77aa$export$fb40872e7cc28b47 = (action$, store)=>action$.ofType((0, $fnVSJ.DELETE_COMPONENT_SUCCESS)).mergeMap(()=>{
        const state = store.getState();
        const componentsPerPage = (0, $ccYHR.getItemsOnPage)(state);
        const totalComponents = (0, $cXEqp.getTotalItems)(state);
        const currentPage = (0, $1FdCJ.getCurrentPage)(state);
        const predictedPage = (0, $cHQhb.predictPageToRequestAfterItemDeletion)(componentsPerPage, totalComponents, currentPage);
        return (0, $3JafE.Observable).of((0, $fnVSJ.getComponentsPageRequest)({
            page: predictedPage,
            initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).COMPONENT_DELETED
        }));
    });

});
parcelRegister("cHQhb", function(module, exports) {

$parcel$export(module.exports, "calculateTotalPages", () => $8b6005841936d3cc$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $8b6005841936d3cc$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $8b6005841936d3cc$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $8b6005841936d3cc$export$407c10b4791d7a16);

const $8b6005841936d3cc$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $8b6005841936d3cc$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $8b6005841936d3cc$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $8b6005841936d3cc$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $8b6005841936d3cc$export$407c10b4791d7a16 = (input)=>[
        (0, $44cab0426b6cf0d7$export$1dee026a19752d6b),
        (0, $44cab0426b6cf0d7$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $44cab0426b6cf0d7$export$1dee026a19752d6b = 'ASC';
const $44cab0426b6cf0d7$export$b6abcf7fa1d94f65 = 'DESC';


parcelRegister("cXEqp", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $a267deacdec0089e$export$dd1bc94b04021eeb);
$parcel$export(module.exports, "getIds", () => $a267deacdec0089e$export$24b60fe7179439bc);
$parcel$export(module.exports, "getAris", () => $a267deacdec0089e$export$edc7a71bded50395);
$parcel$export(module.exports, "getName", () => $a267deacdec0089e$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getIssueCount", () => $a267deacdec0089e$export$56d545f19dc75191);
$parcel$export(module.exports, "getLead", () => $a267deacdec0089e$export$97850e2d25587c0d);
$parcel$export(module.exports, "getDescription", () => $a267deacdec0089e$export$67580b1c13935958);
$parcel$export(module.exports, "getDefaultAssignee", () => $a267deacdec0089e$export$725da8bee1e71eb0);
$parcel$export(module.exports, "getComponent", () => $a267deacdec0089e$export$21a8719ce41a1de2);
$parcel$export(module.exports, "getTotalItems", () => $a267deacdec0089e$export$cbc4bdd6c02fac4d);
const $a267deacdec0089e$export$dd1bc94b04021eeb = (state)=>state.components.list.length === 0;
const $a267deacdec0089e$export$24b60fe7179439bc = (state)=>state.components.list;
const $a267deacdec0089e$export$edc7a71bded50395 = (state)=>state.components.listAri;
const $a267deacdec0089e$export$7d9f7e9c1c02b41e = (state, id)=>state.components.byId[id].name;
const $a267deacdec0089e$export$56d545f19dc75191 = (state, id)=>state.components.byId[id].issueCount;
const $a267deacdec0089e$export$97850e2d25587c0d = (state, id)=>state.components.byId[id].lead;
const $a267deacdec0089e$export$67580b1c13935958 = (state, id)=>state.components.byId[id].description;
const $a267deacdec0089e$export$725da8bee1e71eb0 = (state, id)=>state.components.byId[id].defaultAssignee;
const $a267deacdec0089e$export$21a8719ce41a1de2 = (state, id)=>state.components.byId[id];
const $a267deacdec0089e$export$cbc4bdd6c02fac4d = (state)=>state.components.totalItems;

});

parcelRegister("ccYHR", function(module, exports) {

$parcel$export(module.exports, "getItemsOnPage", () => $2969d46af9022f11$export$104aa54211627bc7);
$parcel$export(module.exports, "isLoading", () => $2969d46af9022f11$export$20bb0d907fbbe433);
$parcel$export(module.exports, "getStartAt", () => $2969d46af9022f11$export$d33293070717f977);
$parcel$export(module.exports, "getMaxResults", () => $2969d46af9022f11$export$152d338deb24dc62);
const $2969d46af9022f11$export$104aa54211627bc7 = (state)=>state.ui.page.itemsOnPage;
const $2969d46af9022f11$export$20bb0d907fbbe433 = (state)=>state.ui.page.isLoading;
const $2969d46af9022f11$export$d33293070717f977 = (state, page)=>$2969d46af9022f11$export$104aa54211627bc7(state) * (page - 1);
const $2969d46af9022f11$export$152d338deb24dc62 = (state)=>$2969d46af9022f11$export$104aa54211627bc7(state);

});


parcelRegister("1hjS9", function(module, exports) {

$parcel$export(module.exports, "queryPatched", () => $b5c9b5742139c734$export$290869333b164745);
parcelRequire("8jBvP");
parcelRequire("iects");

var $d9Ot4 = parcelRequire("d9Ot4");

var $3JafE = parcelRequire("3JafE");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");
const $b5c9b5742139c734$export$290869333b164745 = (action$, store)=>action$.ofType((0, $bau7U.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $1FdCJ.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($d9Ot4)))(payload, (0, $1FdCJ.getQuery)(state)));
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("bau7U", function(module, exports) {

$parcel$export(module.exports, "SET_QUERY", () => $cb0cbe86a4e84e7e$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $cb0cbe86a4e84e7e$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $cb0cbe86a4e84e7e$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $cb0cbe86a4e84e7e$export$8a4e224aafd3a2bf);
const $cb0cbe86a4e84e7e$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $cb0cbe86a4e84e7e$export$f3b215b0b382f63b = (payload)=>({
        type: $cb0cbe86a4e84e7e$export$11bcea24b35a126f,
        payload: payload
    });
const $cb0cbe86a4e84e7e$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $cb0cbe86a4e84e7e$export$8a4e224aafd3a2bf = (payload)=>({
        type: $cb0cbe86a4e84e7e$export$403065a1ff0b1663,
        payload: payload
    });

});


parcelRegister("adw89", function(module, exports) {

$parcel$export(module.exports, "querySet", () => $a8dae6b5f46dee2d$export$46c38d4ac3e57dc5);

var $3JafE = parcelRequire("3JafE");
parcelRequire("8jBvP");
parcelRequire("iects");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");
const $a8dae6b5f46dee2d$export$46c38d4ac3e57dc5 = (action$, store)=>action$.ofType((0, $bau7U.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $1FdCJ.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $3JafE.Observable).empty();
    });

});

parcelRegister("fWLEp", function(module, exports) {

$parcel$export(module.exports, "retrieveComponents", () => $0794d84a47d053ff$export$228e895d1b5c79dd);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("5hZYM");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $6crwp = parcelRequire("6crwp");

var $dlLXy = parcelRequire("dlLXy");

var $1FdCJ = parcelRequire("1FdCJ");

var $ccYHR = parcelRequire("ccYHR");

var $6ZTsa = parcelRequire("6ZTsa");

var $ft7kU = parcelRequire("ft7kU");

var $kO1CG = parcelRequire("kO1CG");

var $fnVSJ = parcelRequire("fnVSJ");

var $bG4dy = parcelRequire("bG4dy");

var $7pUSO = parcelRequire("7pUSO");
const $0794d84a47d053ff$export$228e895d1b5c79dd = (action$, store)=>{
    const getComponentsRequestAction$ = action$.ofType((0, $fnVSJ.GET_COMPONENTS_PAGE_REQUEST));
    return getComponentsRequestAction$.mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const page = payload.page;
        const baseUrl = (0, $6crwp.getBaseUrl)(state);
        const projectKey = (0, $dlLXy.getProjectKey)(state);
        const startAt = (0, $ccYHR.getStartAt)(state, page);
        const maxResults = (0, $ccYHR.getMaxResults)(state);
        const orderBy = (0, $1FdCJ.getOrderBy)(state);
        const filter = (0, $1FdCJ.getFilter)(state);
        return (0, $3JafE.Observable).fromPromise((0, $ft7kU.famaCatchAndLogFetchError)((0, $bG4dy.requestComponents)(baseUrl, projectKey, startAt, maxResults, orderBy, filter), (0, $kO1CG.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('retrieveComponents'), (0, $6ZTsa.toErrorMessage)('Error fetching components'))).mergeMap((result)=>// @ts-expect-error - TS2769 - No overload matches this call.
            (0, $3JafE.Observable).of((0, $fnVSJ.setComponentsPage)(result), (0, $7pUSO.set)({
                message: ''
            }))).takeUntil(getComponentsRequestAction$).catch(()=>/*
				 * We are not logging the error here because it was already logged inside famaCatchAndLogFetchError call.
				 */ (0, $3JafE.Observable).of((0, $7pUSO.set)({
                message: 'Error retrieving components'
            })));
    });
};

});
parcelRegister("6crwp", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $1dd2bd892454605f$export$f654b28f82155665);
$parcel$export(module.exports, "isAdmin", () => $1dd2bd892454605f$export$fc970ed23da99565);
$parcel$export(module.exports, "getLocale", () => $1dd2bd892454605f$export$180605366c04f0cd);
const $1dd2bd892454605f$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $1dd2bd892454605f$export$fc970ed23da99565 = (state)=>state.context.isAdmin;
const $1dd2bd892454605f$export$180605366c04f0cd = (state)=>state.context.locale;

});

parcelRegister("dlLXy", function(module, exports) {

$parcel$export(module.exports, "getProjectKey", () => $67b1661e243d0418$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $67b1661e243d0418$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectName", () => $67b1661e243d0418$export$2cd058184eb75757);
$parcel$export(module.exports, "getProjectType", () => $67b1661e243d0418$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectDefaultAssignee", () => $67b1661e243d0418$export$be28a82d4e8d697f);
$parcel$export(module.exports, "getProjectLead", () => $67b1661e243d0418$export$478e7310480ee1ab);
$parcel$export(module.exports, "getProjectLeadName", () => $67b1661e243d0418$export$c5b979a08b55628c);
$parcel$export(module.exports, "isComponentAdminContext", () => $67b1661e243d0418$export$26a3de6cbed85df7);

var $3da0c = parcelRequire("3da0c");
const $67b1661e243d0418$export$3988ae62b71be9a3 = (state)=>state.project;
const $67b1661e243d0418$export$667f2a0f99c75faa = (state)=>state.project.key;
const $67b1661e243d0418$export$89040d072f281f85 = (state)=>state.project.id;
const $67b1661e243d0418$export$2cd058184eb75757 = (state)=>state.project.name;
const $67b1661e243d0418$export$3dd0da95519c1a33 = (state)=>state.project.type;
const $67b1661e243d0418$export$be28a82d4e8d697f = (state)=>state.project.defaultAssignee;
const $67b1661e243d0418$export$478e7310480ee1ab = (state)=>state.project.lead;
const $67b1661e243d0418$export$c5b979a08b55628c = (state)=>state.project.lead && state.project.lead.displayName;
const $67b1661e243d0418$export$26a3de6cbed85df7 = ()=>{
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    const pathname = (0, $3da0c.default)() && (0, $3da0c.default)().pathname || '';
    return pathname.endsWith && pathname.endsWith('/administer-components');
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});


parcelRegister("kO1CG", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $2a9cfd92b05c971b$export$b8b9d90f9e5bd72b);

var $6bYiA = parcelRequire("6bYiA");
const $2a9cfd92b05c971b$export$b8b9d90f9e5bd72b = (0, $6bYiA.toPackageName)('jiraProjectDirectoriesComponents');

});

parcelRegister("bG4dy", function(module, exports) {

$parcel$export(module.exports, "requestComponents", () => $d185e94a12a49c9c$export$7ec8ef4a312fa6eb);
$parcel$export(module.exports, "getPrefetchedData", () => $d185e94a12a49c9c$export$191a95ab818c6ef2);
$parcel$export(module.exports, "requestComponent", () => $d185e94a12a49c9c$export$f20b154a1c4c6494);

var $9NWL9 = parcelRequire("9NWL9");

var $drvg3 = parcelRequire("drvg3");

var $1M0d5 = parcelRequire("1M0d5");

var $igneF = parcelRequire("igneF");

var $6crwp = parcelRequire("6crwp");

var $kimMc = parcelRequire("kimMc");

var $iTAV6 = parcelRequire("iTAV6");
const $d185e94a12a49c9c$export$519b99feca126399 = (baseUrl, projectKey, startAt, maxResults, orderBy, filter)=>{
    const encodedQuery = encodeURIComponent(filter);
    const componentSourceParam = '&componentSource=auto';
    return `${baseUrl}/rest/api/2/project/${projectKey}/component?startAt=${startAt}&maxResults=${maxResults}&orderBy=${orderBy}&query=${encodedQuery}${componentSourceParam}`;
};
const $d185e94a12a49c9c$export$7ec8ef4a312fa6eb = async (baseUrl, projectKey, startAt = (0, $drvg3.START_AT), maxResults = (0, $drvg3.ITEMS_ON_PAGE), orderBy = (0, $drvg3.ORDER), filter = (0, $drvg3.FILTER))=>{
    const fullUrl = $d185e94a12a49c9c$export$519b99feca126399(baseUrl, projectKey, startAt, maxResults, orderBy, filter);
    const response = await fetch(fullUrl, (0, $1M0d5.createOptions)('GET'));
    const json = await response.json();
    if (!response.ok) throw await (0, $9NWL9.getErrorFromResponse)(response, 'Failed to fetch');
    const { values: values, total: total } = json;
    return (0, $iTAV6.transformComponents)(values, total, baseUrl);
};
const $d185e94a12a49c9c$export$191a95ab818c6ef2 = (baseUrl, projectKey, query)=>{
    if (query) {
        const { orderDirection: orderDirection, orderField: orderField, filter: filter, page: page } = query;
        const orderBy = (0, $igneF.mapToOrderFetch)(orderField, orderDirection);
        const maxResults = (0, $drvg3.ITEMS_ON_PAGE);
        const startAt = (page - 1) * maxResults;
        return $d185e94a12a49c9c$export$7ec8ef4a312fa6eb(baseUrl, projectKey, startAt, maxResults, orderBy, filter);
    }
    return $d185e94a12a49c9c$export$7ec8ef4a312fa6eb(baseUrl, projectKey);
};
const $d185e94a12a49c9c$export$2756a9db83f319ac = (id)=>`/rest/api/2/component/${id}`;
const $d185e94a12a49c9c$export$f20b154a1c4c6494 = async (state, id)=>{
    const baseUrl = (0, $6crwp.getBaseUrl)(state);
    const fullUrl = `${baseUrl}${$d185e94a12a49c9c$export$2756a9db83f319ac(id)}`;
    const response = await fetch(fullUrl, (0, $1M0d5.createOptions)('GET'));
    const json = await response.json();
    if (response.ok) return {
        id: id,
        component: (0, $iTAV6.transformComponentObj)(json, baseUrl)
    };
    throw (0, $kimMc.getErrorFromResultJson)(json, response.status);
};

});
parcelRegister("9NWL9", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $c444662561764b49$export$7780d7826aafbede);

var $7byHA = parcelRequire("7byHA");

var $lRmyA = parcelRequire("lRmyA");
const $c444662561764b49$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $lRmyA.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $7byHA.default)(response.status, errorMessage);
};

});

parcelRegister("drvg3", function(module, exports) {

$parcel$export(module.exports, "ITEMS_ON_PAGE", () => $cd45ecaea1f023d3$export$5364831c6b9eb7a3);
$parcel$export(module.exports, "PAGE", () => $cd45ecaea1f023d3$export$d3d35020fa5b54f0);
$parcel$export(module.exports, "FILTER", () => $cd45ecaea1f023d3$export$c1c49903035a02df);
$parcel$export(module.exports, "START_AT", () => $cd45ecaea1f023d3$export$5a3b37e8556e32de);
$parcel$export(module.exports, "ORDER", () => $cd45ecaea1f023d3$export$11e75bce9f7ea886);

var $7INHA = parcelRequire("7INHA");
const $cd45ecaea1f023d3$export$5364831c6b9eb7a3 = 25;
const $cd45ecaea1f023d3$export$d3d35020fa5b54f0 = 1;
const $cd45ecaea1f023d3$export$55c82710eb02082c = (0, $7INHA.NAME);
const $cd45ecaea1f023d3$export$c1c49903035a02df = '';
const $cd45ecaea1f023d3$export$5a3b37e8556e32de = 0;
const $cd45ecaea1f023d3$export$11e75bce9f7ea886 = `+${(0, $7INHA.ORDER_FIELDS)[$cd45ecaea1f023d3$export$55c82710eb02082c]}`;

});
parcelRegister("7INHA", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $4efc4748737be2b1$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $4efc4748737be2b1$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $4efc4748737be2b1$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $4efc4748737be2b1$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELDS", () => $4efc4748737be2b1$export$e6d6c3d190bf100b);
const $4efc4748737be2b1$export$3c5e605ca7ade9f2 = 'NAME';
const $4efc4748737be2b1$export$d44826c816b5619b = 'DESCRIPTION';
const $4efc4748737be2b1$export$73dcda99369fd988 = 'LEAD';
const $4efc4748737be2b1$export$1c62ab608c48125c = 'ISSUES';
const $4efc4748737be2b1$export$e6d6c3d190bf100b = {
    [$4efc4748737be2b1$export$3c5e605ca7ade9f2]: 'name',
    [$4efc4748737be2b1$export$d44826c816b5619b]: 'description',
    [$4efc4748737be2b1$export$73dcda99369fd988]: 'lead',
    [$4efc4748737be2b1$export$1c62ab608c48125c]: 'issueCount'
};

});


parcelRegister("1M0d5", function(module, exports) {

$parcel$export(module.exports, "createOptions", () => $4bb1b8dfca9caf6f$export$830e3e7c910fe629);
const $4bb1b8dfca9caf6f$export$830e3e7c910fe629 = (method, body)=>{
    const stringifiedBody = body ? JSON.stringify(body) : undefined;
    return {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        method: method,
        body: stringifiedBody
    };
};

});

parcelRegister("kimMc", function(module, exports) {

$parcel$export(module.exports, "ComponentValidationError", () => $ddef2ab820eac00b$export$2a0a959ca186c5a2);
$parcel$export(module.exports, "getErrorFromResultJson", () => $ddef2ab820eac00b$export$f94105122c76865e);

var $7EhAs = parcelRequire("7EhAs");
class $ddef2ab820eac00b$export$2a0a959ca186c5a2 extends Error {
    constructor(message, errors){
        super(message);
        this.errors = errors || {};
    }
}
const $ddef2ab820eac00b$export$f94105122c76865e = (resultJson, status)=>{
    const errors = resultJson.errors;
    if (errors && (errors.name || errors.componentLead)) return new $ddef2ab820eac00b$export$2a0a959ca186c5a2('', {
        name: resultJson.errors.name,
        componentLead: resultJson.errors.componentLead
    });
    const errorMessage = resultJson.errorMessages && resultJson.errorMessages[0];
    return new (0, $7EhAs.default)(status, errorMessage);
};

});

parcelRegister("iTAV6", function(module, exports) {

$parcel$export(module.exports, "transformComponentObj", () => $3f73f45037331263$export$f505eac0336ab290);
$parcel$export(module.exports, "transformComponents", () => $3f73f45037331263$export$67cf173cea018455);
const $3f73f45037331263$var$transformLead = (user, baseUrl)=>({
        displayName: user.displayName,
        key: user.key,
        active: user.active,
        accountId: user.accountId,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        // from PK - I could not see this code being used anywhere. Hence not updating to new url.
        profileUrl: `${baseUrl}/jira/people/${user.accountId}`
    });
const $3f73f45037331263$export$f505eac0336ab290 = (item, baseUrl)=>{
    const { name: name, description: description, assigneeType: assigneeType, lead: lead, componentBean: componentBean } = item;
    const { ari: ari, metadata: metadata } = componentBean ?? {};
    return {
        ari: ari,
        metadata: metadata,
        name: name,
        description: description,
        issueCount: item.issueCount ? item.issueCount : 0,
        defaultAssignee: assigneeType,
        lead: lead ? $3f73f45037331263$var$transformLead(lead, baseUrl) : undefined
    };
};
const $3f73f45037331263$export$79ccea7e11af4b35 = (item, baseUrl)=>({
        [item.id]: $3f73f45037331263$export$f505eac0336ab290(item, baseUrl)
    });
const $3f73f45037331263$export$67cf173cea018455 = (components, total, baseUrl)=>{
    const list = components.map((i)=>i.id);
    const listAri = components// Typesafe way to filter out undefined values.
    // Theoretically if global components are turned on, we will _only_ get back components with ARIs.
    // But to keep things happy with Typescript we need to handle undefined case as well.
    .flatMap(({ componentBean: componentBean })=>componentBean?.ari ? [
            componentBean?.ari
        ] : []);
    const byId = Object.assign({}, ...components.map((component)=>$3f73f45037331263$export$79ccea7e11af4b35(component, baseUrl)));
    return {
        byId: byId,
        list: list,
        listAri: listAri,
        total: total
    };
};

});


parcelRegister("7pUSO", function(module, exports) {

$parcel$export(module.exports, "SET", () => $f44c6383c7b36c4f$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $f44c6383c7b36c4f$export$adaa4cf7ef1b65be);
// set
const $f44c6383c7b36c4f$export$5e8f180ef0142226 = 'ui.error.SET';
const $f44c6383c7b36c4f$export$adaa4cf7ef1b65be = (payload)=>({
        type: $f44c6383c7b36c4f$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("gslJI", function(module, exports) {

$parcel$export(module.exports, "initiateUpdateComponent", () => $8977e105fb85ae6b$export$a82c94a7a4ba9a48);
$parcel$export(module.exports, "updateComponent", () => $8977e105fb85ae6b$export$3d375ec46cfe3d13);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("5hZYM");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $5ysFK = parcelRequire("5ysFK");


var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $kimMc = parcelRequire("kimMc");

var $1FdCJ = parcelRequire("1FdCJ");

var $bG4dy = parcelRequire("bG4dy");

var $gKM6p = parcelRequire("gKM6p");

var $35VMj = parcelRequire("35VMj");
const $8977e105fb85ae6b$export$a82c94a7a4ba9a48 = (action$, store)=>{
    const initiateUpdateComponent$ = action$.ofType((0, $fnVSJ.INITIATE_UPDATE_COMPONENT));
    return initiateUpdateComponent$.mergeMap(()=>{
        const id = (0, $35VMj.getId)(store.getState());
        return (0, $3JafE.Observable).fromPromise((0, $bG4dy.requestComponent)(store.getState(), id)).mergeMap((result)=>(0, $3JafE.Observable).of((0, $fnVSJ.initiateUpdateComponentSuccess)(result))).takeUntil(initiateUpdateComponent$).catch((e)=>{
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(e, 'project-components.state.epics.initate.update.component', (0, $3cf121f5a28af65f$export$1089831196ae0f84));
            return (0, $3JafE.Observable).of((0, $fnVSJ.initiateUpdateComponentFail)({
                id: id,
                error: e
            }));
        });
    });
};
const $8977e105fb85ae6b$export$3d375ec46cfe3d13 = (action$, store)=>action$.ofType((0, $fnVSJ.UPDATE_COMPONENT_REQUEST)).mergeMap(()=>(0, $3JafE.Observable).fromPromise((0, $gKM6p.updateComponent)(store.getState())).mergeMap(()=>(0, $3JafE.Observable).of((0, $fnVSJ.updateComponentSuccess)({
                componentName: (0, $35VMj.getEditedComponentName)(store.getState())
            }), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $fnVSJ.getComponentsPageRequest)({
                page: (0, $1FdCJ.getCurrentPage)(store.getState()),
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).COMPONENT_UPDATED
            })))// @ts-expect-error - TS2345 - Argument of type '(error: ComponentRequestError) => Observable<UpdateComponentValidationFailAction> | Observable<UpdateComponentFailAction>' is not assignable to parameter of type '(err: any, caught: Observable<UpdateComponentSuccessAction>) => ObservableInput<UpdateComponentValidationFailAction>'.
        .catch((error)=>{
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, 'project-components.state.epics.update', (0, $3cf121f5a28af65f$export$1089831196ae0f84));
            if (error instanceof (0, $kimMc.ComponentValidationError)) return (0, $3JafE.Observable).of((0, $fnVSJ.updateComponentValidationFail)(error));
            return (0, $3JafE.Observable).of((0, $fnVSJ.updateComponentFail)(error));
        }));

});
parcelRegister("5ysFK", function(module, exports) {

$parcel$export(module.exports, "logSafeErrorWithoutCustomerData", () => $4626a7a97ad42c00$export$c77be5886e7f1d9e);

var $gUUjF = parcelRequire("gUUjF");
const $4626a7a97ad42c00$export$b94ad046ae639a1c = (error, location, suffix, message)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(location, message || error.message, error);
const $4626a7a97ad42c00$export$c77be5886e7f1d9e = (error, location, suffix, message)=>(0, $gUUjF.default).safeErrorWithoutCustomerData(location, message || error.message, error);

});

const $3cf121f5a28af65f$export$1089831196ae0f84 = 'directories.components.error';

parcelRegister("gKM6p", function(module, exports) {

$parcel$export(module.exports, "updateComponent", () => $07b4d0ee8f551109$export$3d375ec46cfe3d13);

var $1M0d5 = parcelRequire("1M0d5");

var $6crwp = parcelRequire("6crwp");

var $kimMc = parcelRequire("kimMc");

var $35VMj = parcelRequire("35VMj");

var $1wHHZ = parcelRequire("1wHHZ");
const $07b4d0ee8f551109$export$d5777c038fb95c3f = (component)=>{
    if (!component) return {};
    const { name: name, lead: lead, defaultAssignee: defaultAssignee, description: description = '' } = component;
    return {
        name: name,
        description: description,
        assigneeType: defaultAssignee,
        leadAccountId: lead && lead.accountId || ''
    };
};
const $07b4d0ee8f551109$export$3d375ec46cfe3d13 = async (state)=>{
    const componentId = (0, $35VMj.getId)(state);
    const component = (0, $35VMj.getEditedComponent)(state);
    const componentDataForRequest = $07b4d0ee8f551109$export$d5777c038fb95c3f(component);
    const fullUrl = `${(0, $6crwp.getBaseUrl)(state)}${(0, $1wHHZ.componentEndpointUrl)(componentId)}`;
    const result = await fetch(fullUrl, (0, $1M0d5.createOptions)('PUT', componentDataForRequest));
    const resultJson = await result.json();
    if (result.ok) return component;
    throw (0, $kimMc.getErrorFromResultJson)(resultJson, result.status);
};

});
parcelRegister("35VMj", function(module, exports) {

$parcel$export(module.exports, "isInitialising", () => $c553b74c9fb50d1a$export$afb304c64a235941);
$parcel$export(module.exports, "isEditing", () => $c553b74c9fb50d1a$export$6ca2a662afed3e7f);
$parcel$export(module.exports, "saveIsInProgress", () => $c553b74c9fb50d1a$export$6d46a811199c63f);
$parcel$export(module.exports, "getId", () => $c553b74c9fb50d1a$export$218c8c3169c024d2);
$parcel$export(module.exports, "getEditedComponent", () => $c553b74c9fb50d1a$export$6fc6dbafd8663a78);
$parcel$export(module.exports, "getEditedComponentName", () => $c553b74c9fb50d1a$export$760bf67a250fa7f1);
$parcel$export(module.exports, "getNameErrorMessage", () => $c553b74c9fb50d1a$export$6222164b63cc3ae9);
const $c553b74c9fb50d1a$export$afb304c64a235941 = (state, id)=>state.ui.edit.initialiseInProgress && state.ui.edit.id === id;
const $c553b74c9fb50d1a$export$6ca2a662afed3e7f = (state)=>!!state.ui.edit.id && !state.ui.edit.initialiseInProgress;
const $c553b74c9fb50d1a$export$6d46a811199c63f = (state)=>state.ui.edit.saveIsInProgress;
const $c553b74c9fb50d1a$export$218c8c3169c024d2 = (state)=>state.ui.edit.id || '';
const $c553b74c9fb50d1a$export$6fc6dbafd8663a78 = (state)=>state.ui.edit.editedComponent;
const $c553b74c9fb50d1a$export$760bf67a250fa7f1 = (state)=>state.ui.edit.editedComponent && state.ui.edit.editedComponent.name || '';
const $c553b74c9fb50d1a$export$6222164b63cc3ae9 = (state)=>state.ui.edit.nameErrorMessage;
const $c553b74c9fb50d1a$export$8802ac508ab8d49a = (state)=>state.ui.edit.leadErrorMessage;

});

parcelRegister("1wHHZ", function(module, exports) {

$parcel$export(module.exports, "componentEndpointUrl", () => $0cc2e71a7e56cfa2$export$e933405cdc2c0965);
const $0cc2e71a7e56cfa2$export$e933405cdc2c0965 = (componentId)=>{
    const componentUrl = componentId ? `/${componentId}` : '';
    return `/rest/api/2/component${componentUrl}`;
};

});




parcelRegister("67HZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $825c6c1617bd8226$export$2e2bcd8739ae039);

var $8FRHo = parcelRequire("8FRHo");

var $82alA = parcelRequire("82alA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$825c6c1617bd8226$export$2e2bcd8739ae039 = (rootEpic, initialState, middlewares = [])=>(0, $8FRHo.default)({
        appName: 'Project components',
        rootReducer: $82alA.default,
        initialState: initialState,
        rootEpic: rootEpic,
        middlewares: middlewares
    });

});
parcelRegister("82alA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea9810447a5c843$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $c6f3X = parcelRequire("c6f3X");

var $gpFO2 = parcelRequire("gpFO2");

var $1XaJf = parcelRequire("1XaJf");

var $hCUVY = parcelRequire("hCUVY");

var $4SL9U = parcelRequire("4SL9U");

var $5yyyc = parcelRequire("5yyyc");
const $9ea9810447a5c843$var$combinedReducer = (0, $huRi7.combineReducers)({
    components: $gpFO2.default,
    project: $hCUVY.default,
    ui: $5yyyc.default,
    context: $1XaJf.default,
    analyticsData: $c6f3X.default,
    query: $4SL9U.default
});
var $9ea9810447a5c843$export$2e2bcd8739ae039 = $9ea9810447a5c843$var$combinedReducer;

});
parcelRegister("c6f3X", function(module, exports) {

$parcel$export(module.exports, "default", () => $c274111e0d506609$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $aLD7K = parcelRequire("aLD7K");
const $c274111e0d506609$export$d4c72bab9d6cc13a = {
    projectType: ''
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c274111e0d506609$export$2e2bcd8739ae039 = (state = $c274111e0d506609$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $aLD7K.SET:
            return (0, $6HC1D.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("aLD7K", function(module, exports) {

$parcel$export(module.exports, "SET", () => $22a8b649da398841$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $22a8b649da398841$export$adaa4cf7ef1b65be);
const $22a8b649da398841$export$5e8f180ef0142226 = 'analytics.SET';
const $22a8b649da398841$export$adaa4cf7ef1b65be = (payload)=>({
        type: $22a8b649da398841$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("gpFO2", function(module, exports) {

$parcel$export(module.exports, "default", () => $aafd59a54f0329a9$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $fnVSJ = parcelRequire("fnVSJ");
const $aafd59a54f0329a9$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    byId: {},
    list: [],
    listAri: [],
    totalItems: 0
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$aafd59a54f0329a9$export$2e2bcd8739ae039 = (state = $aafd59a54f0329a9$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fnVSJ.SET_COMPONENTS_PAGE:
            return (0, $6HC1D.assign)(state, {
                byId: action.payload.byId,
                list: action.payload.list,
                listAri: action.payload.listAri,
                totalItems: action.payload.total
            });
        case 0, $fnVSJ.PATCH_COMPONENT:
            {
                const componentId = action.payload.id;
                const originalComponent = (0, $6HC1D.getIn)(state.byId, [
                    componentId
                ]);
                const patchedComponent = (0, $6HC1D.assign)({}, originalComponent, action.payload.component);
                return (0, $6HC1D.freeze)({
                    ...state,
                    byId: (0, $6HC1D.assoc)(state.byId, componentId, patchedComponent)
                });
            }
        default:
            return state;
    }
};

});

parcelRegister("1XaJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc3e678c35be608$export$2e2bcd8739ae039);

var $jG2Eu = parcelRequire("jG2Eu");

var $ao0hp = parcelRequire("ao0hp");

var $aVLWV = parcelRequire("aVLWV");
const $9bc3e678c35be608$export$d4c72bab9d6cc13a = Object.freeze({
    baseUrl: '',
    isAdmin: false,
    locale: (0, $ao0hp.defaultLocale),
    onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9bc3e678c35be608$export$2e2bcd8739ae039 = (state = $9bc3e678c35be608$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $aVLWV.SET:
            return Object.freeze(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("aVLWV", function(module, exports) {

$parcel$export(module.exports, "SET", () => $a8fb0e6afd018652$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $a8fb0e6afd018652$export$adaa4cf7ef1b65be);
const $a8fb0e6afd018652$export$5e8f180ef0142226 = 'context.SET';
const $a8fb0e6afd018652$export$adaa4cf7ef1b65be = (payload)=>({
        type: $a8fb0e6afd018652$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("hCUVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $546125f98748b9a3$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $7ZZxN = parcelRequire("7ZZxN");

var $ftoH8 = parcelRequire("ftoH8");
const $546125f98748b9a3$export$d4c72bab9d6cc13a = {
    key: '',
    id: -1,
    name: '',
    type: (0, $7ZZxN.CORE_PROJECT)
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$546125f98748b9a3$export$2e2bcd8739ae039 = (state = $546125f98748b9a3$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $ftoH8.SET:
            return (0, $6HC1D.freeze)(action.payload);
        default:
            return state;
    }
};

});
parcelRegister("ftoH8", function(module, exports) {

$parcel$export(module.exports, "SET", () => $bcef68b6d7e7b894$export$5e8f180ef0142226);
$parcel$export(module.exports, "set", () => $bcef68b6d7e7b894$export$adaa4cf7ef1b65be);
const $bcef68b6d7e7b894$export$5e8f180ef0142226 = 'project.SET';
const $bcef68b6d7e7b894$export$adaa4cf7ef1b65be = (payload)=>({
        type: $bcef68b6d7e7b894$export$5e8f180ef0142226,
        payload: payload
    });

});


parcelRegister("4SL9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba5c64ee8c930b$export$2e2bcd8739ae039);

var $bCV5q = parcelRequire("bCV5q");

var $bau7U = parcelRequire("bau7U");
const $ceba5c64ee8c930b$export$d4c72bab9d6cc13a = (0, $bCV5q.initialQuery);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ceba5c64ee8c930b$export$2e2bcd8739ae039 = (state = $ceba5c64ee8c930b$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $bau7U.SET_QUERY:
            return action.payload;
        case 0, $bau7U.PATCH_QUERY:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5yyyc", function(module, exports) {

$parcel$export(module.exports, "default", () => $28202f78f91cfed8$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $ipXsW = parcelRequire("ipXsW");

var $67d6U = parcelRequire("67d6U");

var $dXjcl = parcelRequire("dXjcl");

var $5Lhg8 = parcelRequire("5Lhg8");

var $42Maf = parcelRequire("42Maf");
const $28202f78f91cfed8$export$d4c72bab9d6cc13a = {
    add: (0, $ipXsW.initialState),
    edit: (0, $dXjcl.initialState),
    delete: (0, $67d6U.initialState),
    error: (0, $5Lhg8.initialState),
    page: (0, $42Maf.initialState)
};
const $28202f78f91cfed8$var$combinedReducer = (0, $huRi7.combineReducers)({
    add: $ipXsW.default,
    edit: $dXjcl.default,
    delete: (0, $67d6U.default),
    error: $5Lhg8.default,
    page: $42Maf.default
});
var $28202f78f91cfed8$export$2e2bcd8739ae039 = $28202f78f91cfed8$var$combinedReducer;

});
parcelRegister("ipXsW", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $76d4a44d015aa263$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $76d4a44d015aa263$export$2e2bcd8739ae039);

var $fnVSJ = parcelRequire("fnVSJ");

var $f30UX = parcelRequire("f30UX");
const $76d4a44d015aa263$export$d4c72bab9d6cc13a = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$76d4a44d015aa263$export$2e2bcd8739ae039 = (state = $76d4a44d015aa263$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $f30UX.INITIATE:
            return {
                isOpen: true
            };
        case 0, $fnVSJ.ADD_COMPONENT_SUCCESS:
        case 0, $f30UX.CANCEL:
            return {
                isOpen: false
            };
        default:
            return state;
    }
};

});
parcelRegister("f30UX", function(module, exports) {

$parcel$export(module.exports, "INITIATE", () => $fdbfd71424fdb39e$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $fdbfd71424fdb39e$export$b14c4413e822aa8d);
$parcel$export(module.exports, "CANCEL", () => $fdbfd71424fdb39e$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $fdbfd71424fdb39e$export$70b61ad426ddbe54);
// initiate
const $fdbfd71424fdb39e$export$643daa42aa3148d5 = 'ui.add.INITIATE';
const $fdbfd71424fdb39e$export$b14c4413e822aa8d = ()=>({
        type: $fdbfd71424fdb39e$export$643daa42aa3148d5
    });
const $fdbfd71424fdb39e$export$2b10f4b30fb65583 = 'ui.add.CANCEL';
const $fdbfd71424fdb39e$export$70b61ad426ddbe54 = ()=>({
        type: $fdbfd71424fdb39e$export$2b10f4b30fb65583
    });

});


parcelRegister("67d6U", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $196a8618dd391889$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $196a8618dd391889$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $kFGm5 = parcelRequire("kFGm5");

var $7GXrf = parcelRequire("7GXrf");

var $fnVSJ = parcelRequire("fnVSJ");

var $46XKW = parcelRequire("46XKW");
const $196a8618dd391889$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    componentsBeingDeleted: [],
    spinner: {}
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$196a8618dd391889$export$2e2bcd8739ae039 = (state = $196a8618dd391889$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $46XKW.DELETE_COMPONENT_STARTED:
            return (0, $6HC1D.freeze)({
                ...state,
                spinner: {
                    ...state.spinner,
                    [action.payload.id]: true
                },
                componentsBeingDeleted: [
                    ...state.componentsBeingDeleted,
                    action.payload.id
                ]
            });
        case 0, $46XKW.DELETE_COMPONENT_DIALOG_DISPLAYED:
            return (0, $6HC1D.freeze)({
                ...state,
                spinner: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.spinner, action.payload.id)
            });
        case 0, $fnVSJ.DELETE_COMPONENT_FAILURE:
            {
                const componentsBeingDeleted = action.payload.isDialogOpen ? state.componentsBeingDeleted : (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(state.componentsBeingDeleted, action.payload.id);
                return (0, $6HC1D.assign)(state, {
                    spinner: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.spinner, action.payload.id),
                    componentsBeingDeleted: componentsBeingDeleted
                });
            }
        case 0, $46XKW.DELETE_COMPONENT_CANCEL:
        case 0, $fnVSJ.DELETE_COMPONENT_SUCCESS:
            return (0, $6HC1D.freeze)({
                ...state,
                componentsBeingDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))(state.componentsBeingDeleted, action.payload.id),
                spinner: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state.spinner, action.payload.id)
            });
        default:
            return state;
    }
};

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});

parcelRegister("46XKW", function(module, exports) {

$parcel$export(module.exports, "DELETE_COMPONENT_STARTED", () => $39fb342f9ba92b5d$export$1f324f2a5e0c1e6f);
$parcel$export(module.exports, "deleteComponentStarted", () => $39fb342f9ba92b5d$export$a37e7704966d1adf);
$parcel$export(module.exports, "DELETE_COMPONENT_DIALOG_DISPLAYED", () => $39fb342f9ba92b5d$export$9bfb374019bf36dd);
$parcel$export(module.exports, "deleteComponentDialogDisplayed", () => $39fb342f9ba92b5d$export$e3156991de922d9c);
$parcel$export(module.exports, "DELETE_COMPONENT_CANCEL", () => $39fb342f9ba92b5d$export$1aeaef53ac9bbd05);
$parcel$export(module.exports, "deleteComponentCancel", () => $39fb342f9ba92b5d$export$3a48db21ea62cc77);
const $39fb342f9ba92b5d$export$1f324f2a5e0c1e6f = 'ui.delete.DELETE_COMPONENT_STARTED';
const $39fb342f9ba92b5d$export$a37e7704966d1adf = (payload)=>({
        type: $39fb342f9ba92b5d$export$1f324f2a5e0c1e6f,
        payload: payload
    });
const $39fb342f9ba92b5d$export$9bfb374019bf36dd = 'ui.delete.DELETE_COMPONENT_DIALOG_DISPLAYED';
const $39fb342f9ba92b5d$export$e3156991de922d9c = (payload)=>({
        type: $39fb342f9ba92b5d$export$9bfb374019bf36dd,
        payload: payload
    });
const $39fb342f9ba92b5d$export$1aeaef53ac9bbd05 = 'ui.delete.DELETE_COMPONENT_CANCEL';
const $39fb342f9ba92b5d$export$3a48db21ea62cc77 = (payload)=>({
        type: $39fb342f9ba92b5d$export$1aeaef53ac9bbd05,
        payload: payload
    });

});


parcelRegister("dXjcl", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f41a6e60cc3d48dd$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $f41a6e60cc3d48dd$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $fnVSJ = parcelRequire("fnVSJ");

var $gPlbp = parcelRequire("gPlbp");
const $f41a6e60cc3d48dd$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    saveIsInProgress: false,
    initialiseInProgress: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f41a6e60cc3d48dd$export$2e2bcd8739ae039 = (state = $f41a6e60cc3d48dd$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fnVSJ.INITIATE_UPDATE_COMPONENT:
            return (0, $6HC1D.freeze)({
                initialiseInProgress: true,
                id: action.payload.id,
                saveIsInProgress: false
            });
        case 0, $fnVSJ.INITIATE_UPDATE_COMPONENT_SUCCESS:
            return (0, $6HC1D.assign)(state, {
                initialiseInProgress: false,
                id: action.payload.id,
                editedComponent: action.payload.component,
                saveIsInProgress: false
            });
        case 0, $fnVSJ.INITIATE_UPDATE_COMPONENT_FAIL:
            return (0, $6HC1D.assign)(state, {
                initialiseInProgress: false,
                id: undefined,
                editedComponent: false,
                saveIsInProgress: false
            });
        case 0, $gPlbp.UPDATE_EDITED_COMPONENT:
            return (0, $6HC1D.assign)(state, {
                editedComponent: action.payload.component
            });
        case 0, $gPlbp.CANCEL:
            return (0, $6HC1D.assign)(state, {
                id: undefined,
                editedComponent: undefined,
                saveIsInProgress: false
            });
        case 0, $fnVSJ.UPDATE_COMPONENT_REQUEST:
            return (0, $6HC1D.assign)(state, {
                saveIsInProgress: true,
                nameErrorMessage: undefined,
                leadErrorMessage: undefined
            });
        case 0, $fnVSJ.UPDATE_COMPONENT_SUCCESS:
            return (0, $6HC1D.assign)(state, {
                saveIsInProgress: false,
                id: undefined,
                editedComponent: undefined
            });
        case 0, $fnVSJ.UPDATE_COMPONENT_VALIDATION_FAIL:
            return (0, $6HC1D.assign)(state, {
                nameErrorMessage: action.payload.errors.name,
                leadErrorMessage: action.payload.errors.componentLead,
                saveIsInProgress: false
            });
        case 0, $fnVSJ.UPDATE_COMPONENT_FAIL:
            return (0, $6HC1D.assign)(state, {
                saveIsInProgress: false
            });
        default:
            return state;
    }
};

});
parcelRegister("gPlbp", function(module, exports) {

$parcel$export(module.exports, "UPDATE_EDITED_COMPONENT", () => $0a32927ac2dfd2e0$export$3e160f16eaac1ba0);
$parcel$export(module.exports, "updateEditedComponent", () => $0a32927ac2dfd2e0$export$5e01f454419fe080);
$parcel$export(module.exports, "CANCEL", () => $0a32927ac2dfd2e0$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $0a32927ac2dfd2e0$export$70b61ad426ddbe54);
const $0a32927ac2dfd2e0$export$3e160f16eaac1ba0 = 'ui.edit.UPDATE_EDITED_COMPONENT';
const $0a32927ac2dfd2e0$export$5e01f454419fe080 = (component)=>({
        type: $0a32927ac2dfd2e0$export$3e160f16eaac1ba0,
        payload: {
            component: component
        }
    });
const $0a32927ac2dfd2e0$export$2b10f4b30fb65583 = 'ui.edit.CANCEL';
const $0a32927ac2dfd2e0$export$70b61ad426ddbe54 = ()=>({
        type: $0a32927ac2dfd2e0$export$2b10f4b30fb65583
    });

});


parcelRegister("5Lhg8", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $77c50893b432fd17$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $77c50893b432fd17$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $7pUSO = parcelRequire("7pUSO");
const $77c50893b432fd17$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    message: undefined
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$77c50893b432fd17$export$2e2bcd8739ae039 = (state = $77c50893b432fd17$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $7pUSO.SET:
            return (0, $6HC1D.freeze)({
                message: action.payload.message
            });
        default:
            return state;
    }
};

});

parcelRegister("42Maf", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2a778ed01fb879ff$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $2a778ed01fb879ff$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $drvg3 = parcelRequire("drvg3");

var $fnVSJ = parcelRequire("fnVSJ");

var $7pUSO = parcelRequire("7pUSO");
const $2a778ed01fb879ff$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    isLoading: false,
    itemsOnPage: (0, $drvg3.ITEMS_ON_PAGE),
    currentPage: (0, $drvg3.PAGE)
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a778ed01fb879ff$export$2e2bcd8739ae039 = (state = $2a778ed01fb879ff$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fnVSJ.GET_COMPONENTS_PAGE_REQUEST:
            return (0, $6HC1D.assign)(state, {
                isLoading: true,
                currentPage: action.payload.page
            });
        case 0, $7pUSO.SET:
            return (0, $6HC1D.assign)(state, {
                isLoading: false
            });
        case 0, $fnVSJ.SET_COMPONENTS_PAGE:
            return (0, $6HC1D.assign)(state, {
                isLoading: false
            });
        default:
            return state;
    }
};

});




parcelRegister("bt1JN", function(module, exports) {

$parcel$export(module.exports, "default", () => $33310107c06b67ab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $2CfRQw = parcelRequire("2CfRQw");

var $9DtAw = parcelRequire("9DtAw");
const $33310107c06b67ab$var$containerStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});
class $33310107c06b67ab$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $33310107c06b67ab$var$containerStyles
        }, (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CfRQw.ContentWithGlobalComponentsProperty), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CfRQw.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9DtAw.default), null));
    }
}

});
parcelRegister("2CfRQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0513852b7182f4b8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ContentWithGlobalComponentsProperty", () => $0513852b7182f4b8$export$6822792b9dbc0ad0);

var $lNNXV = parcelRequire("lNNXV");

var $kuteD = parcelRequire("kuteD");

var $cC1QG = parcelRequire("cC1QG");

var $fnVSJ = parcelRequire("fnVSJ");

var $jmbhM = parcelRequire("jmbhM");

var $6crwp = parcelRequire("6crwp");

var $dlLXy = parcelRequire("dlLXy");

var $f30UX = parcelRequire("f30UX");

var $ccYHR = parcelRequire("ccYHR");

var $c6WZq = parcelRequire("c6WZq");

var $9o0VH = parcelRequire("9o0VH");
const $0513852b7182f4b8$var$mapStateToProps = (state)=>({
        status: (0, $c6WZq.getStatus)(state),
        editable: (0, $6crwp.isAdmin)(state),
        analyticsData: (0, $jmbhM.get)(state),
        baseUrl: (0, $6crwp.getBaseUrl)(state),
        projectKey: (0, $dlLXy.getProjectKey)(state),
        projectName: (0, $dlLXy.getProjectName)(state),
        projectType: (0, $dlLXy.getProjectType)(state),
        isAdminContext: (0, $dlLXy.isComponentAdminContext)(),
        // Toggles to `true` inherently when our `refreshComponents` function is
        // invoked. Resolves to `false` when asynchronous actions are finished.
        isLoading: (0, $ccYHR.isLoading)(state)
    });
const $0513852b7182f4b8$var$mapDispatchToProps = {
    onAddComponent: (0, $f30UX.initiate)
};
const $0513852b7182f4b8$var$mapDispatchToPropsGlobalComponentsProperty = (dispatch)=>({
        onAddComponent: ()=>{
            dispatch((0, $f30UX.initiate)());
        },
        // Refresh cached components when toggling between Compass and Jira components..
        refreshComponents: ()=>{
            dispatch((0, $fnVSJ.getComponentsPageRequest)({
                page: 0,
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).VIEW
            }));
        }
    });
var $0513852b7182f4b8$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($0513852b7182f4b8$var$mapStateToProps, $0513852b7182f4b8$var$mapDispatchToProps)((0, $9o0VH.default));
const $0513852b7182f4b8$export$6822792b9dbc0ad0 = (0, $lNNXV.connect)($0513852b7182f4b8$var$mapStateToProps, $0513852b7182f4b8$var$mapDispatchToPropsGlobalComponentsProperty)((0, $cC1QG.withGlobalComponentsProperty)((0, $9o0VH.default)));

});
parcelRegister("cC1QG", function(module, exports) {

$parcel$export(module.exports, "withGlobalComponentsProperty", () => $f184834fd67a4cbd$export$8fb23a61064dd4a6);

var $eUqFw = parcelRequire("eUqFw");

var $l0Tj3 = parcelRequire("l0Tj3");
var $e1gDz = parcelRequire("e1gDz");

var $lvsmG = parcelRequire("lvsmG");

var $0cdA8 = parcelRequire("0cdA8");

var $k8Qyf = parcelRequire("k8Qyf");

var $d6f6c = parcelRequire("d6f6c");

var $hzGxz = parcelRequire("hzGxz");

var $1QqQm = parcelRequire("1QqQm");
const $f184834fd67a4cbd$export$8fb23a61064dd4a6 = (WrappedComponent)=>(props)=>{
        const { projectKey: projectKey, refreshComponents: refreshComponents } = props;
        const { enabled: enabled, loading: loading, error: error, setProperty: setProperty } = (0, $e1gDz.useGlobalComponentsProperty)(projectKey);
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
        const provisionStatus = (0, $lvsmG.useCompassProvisionStatus)();
        const { startPollingBootstrapSyncStatus: startPollingBootstrapSyncStatus, stopPollingBootstrapSyncStatus: stopPollingBootstrapSyncStatus, isSyncInProgress: isSyncInProgress } = (0, $hzGxz.useGetBootstrapSyncStatus)();
        const { loading: permissionsLoading, hasCompassPermissions: hasCompassPermissions } = (0, $l0Tj3.useGetCompassPermissions)();
        (0, $eUqFw.useEffect)(()=>{
            if (!loading && enabled === undefined && error) showFlag({
                type: 'error',
                title: (0, $1QqQm.default).errorFetching
            });
        }, [
            showFlag,
            loading,
            error,
            enabled
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (provisionStatus === 'error') showFlag({
                type: 'error',
                title: (0, $1QqQm.default).errorProvisioning
            });
        }, [
            showFlag,
            provisionStatus
        ]);
        const toggleProperty = (0, $eUqFw.useCallback)((newValue)=>{
            setProperty(newValue).then(()=>{
                if (newValue) startPollingBootstrapSyncStatus();
                else stopPollingBootstrapSyncStatus();
                refreshComponents();
            }).catch(()=>{
                showFlag({
                    type: 'error',
                    title: (0, $1QqQm.default).errorToggling
                });
            });
        }, [
            refreshComponents,
            setProperty,
            showFlag,
            startPollingBootstrapSyncStatus,
            stopPollingBootstrapSyncStatus
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !loading && provisionStatus !== 'loading' && provisionStatus !== 'error' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
            attributes: {
                isCompassProvisioned: provisionStatus === 'provisioned',
                globalComponentsEnabled: enabled
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            packageName: "jiraProjectDirectoriesComponents",
            // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
            teamName: "compass-lodestone",
            id: "globalComponentsPropertyHOC",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            globalComponentsProperty: {
                enabled: enabled,
                hasCompassPermissions: hasCompassPermissions,
                loading: loading || isSyncInProgress || permissionsLoading,
                setProperty: toggleProperty
            }
        })));
    };

});
parcelRegister("l0Tj3", function(module, exports) {

$parcel$export(module.exports, "useGetCompassPermissions", () => $73eea356b24b0a06$export$31f6fe789b504709);

var $eUqFw = parcelRequire("eUqFw");

var $69VZh = parcelRequire("69VZh");
function $73eea356b24b0a06$export$31f6fe789b504709() {
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [hasCompassPermissions, setHasCompassPermissions] = (0, $eUqFw.useState)(false);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    (0, $eUqFw.useEffect)(()=>{
        (0, $69VZh.getCompassPermissions)() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((result)=>{
            if (result.statusCode) setHasCompassPermissions(result.statusCode === 200);
            else setHasCompassPermissions(!!result.entitlements);
        }).catch((e)=>setError(e)).finally(()=>setLoading(false));
    }, []);
    return {
        loading: loading,
        hasCompassPermissions: hasCompassPermissions,
        error: error
    };
}

});
parcelRegister("69VZh", function(module, exports) {

$parcel$export(module.exports, "getCompassPermissions", () => $533110291a72e150$export$a60fbb9830f913a6);

var $lRmyA = parcelRequire("lRmyA");
const $533110291a72e150$var$url = '/gateway/api/compass/v1/entitlements';
const $533110291a72e150$export$a60fbb9830f913a6 = async ()=>{
    try {
        return await (0, $lRmyA.performPostRequest)($533110291a72e150$var$url, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                entitlements: []
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        if (error.statusCode === 403) return error;
        throw error;
    }
};

});


parcelRegister("e1gDz", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $10977af94640a909$export$a070f388fcd93df0);

var $eUqFw = parcelRequire("eUqFw");

var $gyj10 = parcelRequire("gyj10");

var $jD201 = parcelRequire("jD201");
function $10977af94640a909$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [enabled, setEnabled] = (0, $eUqFw.useState)(undefined);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $eUqFw.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eUqFw.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $jD201.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $eUqFw.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $jD201.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $gyj10.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("gyj10", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f5d6a8cf5cca0c$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $3bIxc = parcelRequire("3bIxc");
var $59f5d6a8cf5cca0c$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $3bIxc.props));

});
parcelRegister("jhVpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a98829846b4116$export$2e2bcd8739ae039);

var $kBiqn = parcelRequire("kBiqn");
const $47a98829846b4116$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47a98829846b4116$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $kBiqn.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $47a98829846b4116$var$pNothing,
        update: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $47a98829846b4116$var$pNothing
    };
};

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';



parcelRegister("3bIxc", function(module, exports) {

$parcel$export(module.exports, "props", () => $db1ce1616d9abcdd$export$8128bb6492cf3de7);

const $db1ce1616d9abcdd$var$MAX_RESULTS = 10;
const $db1ce1616d9abcdd$var$CACHE_SIZE = $db1ce1616d9abcdd$var$MAX_RESULTS * 2;
const $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY = 'components';
const $db1ce1616d9abcdd$export$8128bb6492cf3de7 = {
    size: $db1ce1616d9abcdd$var$CACHE_SIZE,
    cacheKey: $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("jD201", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $623baa6e9886872f$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $623baa6e9886872f$export$71702a5b14caff65);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $623baa6e9886872f$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $623baa6e9886872f$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $623baa6e9886872f$var$getProjectId = async (projectKey)=>{
    const project = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $623baa6e9886872f$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $lRmyA.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $guiFP.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $623baa6e9886872f$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $lRmyA.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("lvsmG", function(module, exports) {

$parcel$export(module.exports, "hasCompassBeenProvisioned", () => $208a7df9e038b158$export$f5f769750906cf9c);
$parcel$export(module.exports, "useCompassProvisionStatus", () => $208a7df9e038b158$export$aa74b72c625075d2);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $dWLk9 = parcelRequire("dWLk9");
const $208a7df9e038b158$export$d76f7cdcb363ecda = 'compass';
const $208a7df9e038b158$var$logErrorAndFireAnalytics = (errorMessage)=>{
    const { packageName: packageName, locationId: locationId, message: message, error: error } = errorMessage;
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${packageName}.${locationId}`, message, error);
    (0, $guiFP.default)({
        meta: {
            id: locationId,
            packageName: packageName
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $208a7df9e038b158$var$doOnError = (error)=>{
    $208a7df9e038b158$var$logErrorAndFireAnalytics({
        packageName: 'jiraSoftwareCompassCrossFlowTouchPoint',
        locationId: 'services.license-information.has-compass-been-provisioned',
        message: 'Could not fetch license information.',
        error: error
    });
};
const $208a7df9e038b158$var$getLicenseInformation = (cloudId)=>(0, $lRmyA.performGetRequest)(`/gateway/api/xflow/${cloudId}/license-information`);
const $208a7df9e038b158$export$f5f769750906cf9c = async (cloudId)=>{
    try {
        const data = await $208a7df9e038b158$var$getLicenseInformation(cloudId);
        return data?.products?.[$208a7df9e038b158$export$d76f7cdcb363ecda]?.state === 'ACTIVE';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        $208a7df9e038b158$var$doOnError(err);
        throw err;
    }
};
const $208a7df9e038b158$export$aa74b72c625075d2 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [status, setStatus] = (0, $eUqFw.useState)('loading');
    (0, $eUqFw.useEffect)(()=>{
        const provisionedCheck = async ()=>{
            if (await $208a7df9e038b158$export$f5f769750906cf9c(cloudId)) setStatus('provisioned');
            else setStatus('not-provisioned');
        };
        provisionedCheck().catch(()=>{
            setStatus('error');
        });
    }, [
        cloudId
    ]);
    return status;
};

});

parcelRegister("hzGxz", function(module, exports) {

$parcel$export(module.exports, "useGetBootstrapSyncStatus", () => $732c25f344081705$export$8810d87873b64f44);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $ddlyW = parcelRequire("ddlyW");
const $732c25f344081705$var$REQUEST_TIMEOUT = 2000;
const $732c25f344081705$var$bootstrapSyncUrl = '/rest/internal/1.0/component/sync/compass/status';
const $732c25f344081705$export$8810d87873b64f44 = (pollMax = 10)=>{
    const [error, setError] = (0, $eUqFw.useState)();
    const [bootstrapSyncStatus, setBootstrapSyncStatus] = (0, $eUqFw.useState)(undefined);
    const [isSyncInProgress, setIsSyncInProgress] = (0, $eUqFw.useState)(false);
    const timerRef = (0, $eUqFw.useRef)();
    const pollCount = (0, $eUqFw.useRef)(0);
    const resetRequest = (0, $eUqFw.useCallback)(()=>{
        setIsSyncInProgress(false);
        clearTimeout(timerRef.current);
        pollCount.current = 0;
    }, []);
    const handleError = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (err)=>{
        setError(err);
        resetRequest();
        setBootstrapSyncStatus((0, $ddlyW.requestStatus).ENDED);
        (0, $guiFP.default)({
            meta: {
                id: 'useGetBootstrapSyncStatus',
                packageName: 'jiraProjectDirectoriesComponents',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'compass-lodestone'
            },
            error: err,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        resetRequest
    ]);
    const invokeRequest = (0, $eUqFw.useCallback)(async ()=>(0, $lRmyA.performGetRequestWithRetry)($732c25f344081705$var$bootstrapSyncUrl, {
            retryAttempts: 3
        }), []);
    const startPollingBootstrapSyncStatus = (0, $eUqFw.useCallback)(()=>{
        const reinitiatePoll = (status)=>{
            if (!bootstrapSyncStatus || bootstrapSyncStatus !== (0, $ddlyW.requestStatus).COMPLETED || bootstrapSyncStatus !== (0, $ddlyW.requestStatus).ENDED) {
                setBootstrapSyncStatus(status);
                pollCount.current += 1;
                timerRef.current = setTimeout(startPollingBootstrapSyncStatus, $732c25f344081705$var$REQUEST_TIMEOUT);
            } else clearTimeout(timerRef.current);
        };
        setIsSyncInProgress(true);
        invokeRequest().then((data)=>{
            if (pollCount.current === pollMax) throw new Error('Polling attempts reached');
            // If Compass is not provisioned on a site, the sync status endpoint returns a 200 with no content.
            if (!data) {
                setBootstrapSyncStatus((0, $ddlyW.requestStatus).ENDED);
                resetRequest();
                return;
            }
            const { state: syncState } = data;
            switch(syncState){
                case (0, $ddlyW.requestStatus).COMPLETED:
                    setBootstrapSyncStatus((0, $ddlyW.requestStatus).COMPLETED);
                    resetRequest();
                    break;
                case (0, $ddlyW.requestStatus).IN_PROGESS:
                    reinitiatePoll((0, $ddlyW.requestStatus).IN_PROGESS);
                    break;
                case (0, $ddlyW.requestStatus).NOT_INITIATED:
                    reinitiatePoll((0, $ddlyW.requestStatus).NOT_INITIATED);
                    break;
                default:
                    setBootstrapSyncStatus((0, $ddlyW.requestStatus).ENDED);
                    resetRequest();
                    break;
            }
        }).catch((err)=>{
            handleError(err);
        });
    }, [
        invokeRequest,
        bootstrapSyncStatus,
        pollMax,
        resetRequest,
        handleError
    ]);
    const stopPollingBootstrapSyncStatus = (0, $eUqFw.useCallback)(()=>{
        setBootstrapSyncStatus((0, $ddlyW.requestStatus).ENDED);
        resetRequest();
    }, [
        resetRequest
    ]);
    return {
        error: error,
        isSyncInProgress: isSyncInProgress,
        bootstrapSyncStatus: bootstrapSyncStatus,
        startPollingBootstrapSyncStatus: startPollingBootstrapSyncStatus,
        stopPollingBootstrapSyncStatus: stopPollingBootstrapSyncStatus
    };
};

});
parcelRegister("ddlyW", function(module, exports) {

$parcel$export(module.exports, "requestStatus", () => $efa128204ee31252$export$b623c9d52fb562b0);
const $efa128204ee31252$export$b623c9d52fb562b0 = {
    ENDED: 'ENDED',
    COMPLETED: 'COMPLETED',
    IN_PROGESS: 'IN_PROGRESS',
    NOT_INITIATED: 'NOT_INITIATED'
};

});


parcelRegister("1QqQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec5169d3fd34997c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec5169d3fd34997c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorToggling: {
        "id": "project-directories.components.common.services.with-global-components-property.error-toggling",
        "defaultMessage": "Error updating Global Components Property"
    },
    errorFetching: {
        "id": "project-directories.components.common.services.with-global-components-property.error-fetching",
        "defaultMessage": "Error fetching Global Components Property"
    },
    errorProvisioning: {
        "id": "project-directories.components.common.services.with-global-components-property.error-provisioning",
        "defaultMessage": "Error fetching Compass provisioning state"
    }
});

});


parcelRegister("jmbhM", function(module, exports) {

$parcel$export(module.exports, "get", () => $42ef0d8284a8a042$export$3988ae62b71be9a3);
const $42ef0d8284a8a042$export$3988ae62b71be9a3 = (state)=>state.analyticsData;

});

parcelRegister("c6WZq", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $9667e07316343bc2$export$b70265791d2079d4);

var $cXEqp = parcelRequire("cXEqp");

var $1FdCJ = parcelRequire("1FdCJ");

var $aaRCV = parcelRequire("aaRCV");

var $ccYHR = parcelRequire("ccYHR");
const $9667e07316343bc2$export$b70265791d2079d4 = (state)=>{
    if ((0, $aaRCV.getError)(state).message) return 'error';
    if ((0, $ccYHR.isLoading)(state)) return 'has-components';
    const isFilterEmpty = (0, $1FdCJ.getFilter)(state) === '';
    return (0, $cXEqp.isEmpty)(state) && isFilterEmpty ? 'empty' : 'has-components';
};

});
parcelRegister("aaRCV", function(module, exports) {

$parcel$export(module.exports, "getError", () => $f3e94fe4878ce9c9$export$e1599abf47b5b568);
const $f3e94fe4878ce9c9$export$e1599abf47b5b568 = (state)=>state.ui.error;

});


parcelRegister("9o0VH", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b047d16a676729d$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");

var $7u4fN = parcelRequire("7u4fN");

var $1zbEq = parcelRequire("1zbEq");

var $c76ap = parcelRequire("c76ap");
var $dpXKE = parcelRequire("dpXKE");
var $1YMP9 = parcelRequire("1YMP9");

var $3a8wJ = parcelRequire("3a8wJ");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $heNSb = parcelRequire("heNSb");

var $4ACoF = parcelRequire("4ACoF");

var $giAhk = parcelRequire("giAhk");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7JTqr = parcelRequire("7JTqr");

var $gsRHv = parcelRequire("gsRHv");

var $iS5fI = parcelRequire("iS5fI");
var $bGdP7 = parcelRequire("bGdP7");

var $eWUpw = parcelRequire("eWUpw");

var $l5bSk = parcelRequire("l5bSk");

var $e9GN2 = parcelRequire("e9GN2");

var $09jnB = parcelRequire("09jnB");

var $9dC8o = parcelRequire("9dC8o");

var $cWpHr = parcelRequire("cWpHr");

var $dv6pb = parcelRequire("dv6pb");

var $kyswk = parcelRequire("kyswk");

var $aFjQt = parcelRequire("aFjQt");

var $cPXuY = parcelRequire("cPXuY");

var $6hheN = parcelRequire("6hheN");
function $2b047d16a676729d$var$AppViewOld(props) {
    const { onAddComponent: onAddComponent, status: status, editable: editable, baseUrl: baseUrl, projectKey: projectKey, projectName: projectName, projectType: projectType, intl: { formatMessage: formatMessage }, isAdminContext: isAdminContext, isLoading: isLoading, globalComponentsProperty: globalComponentsProperty = {
        loading: false,
        enabled: false,
        hasCompassPermissions: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setProperty: ()=>{}
    } } = props;
    // https://switcheroo.atlassian.com/changes/jira/compass-components-in-jira-components_xw42u
    const compassComponentsPageReworkEnabled = (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u');
    const isProjectTypeJsw = projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null);
    let content = null;
    let searchBar = null;
    let actions = compassComponentsPageReworkEnabled && isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWpHr.WrappedGlobalComponentsToggleButton), {
        globalComponentsProperty: {
            loading: globalComponentsProperty.loading,
            enabled: globalComponentsProperty.enabled,
            setProperty: globalComponentsProperty.setProperty
        },
        isEditable: editable
    }) : null;
    let createComponentButton = null;
    const statusWithLoading = compassComponentsPageReworkEnabled && (isLoading || globalComponentsProperty.loading) ? 'loading' : status;
    switch(statusWithLoading){
        case 'loading':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv6pb.LoadingState), null);
            break;
        case 'empty':
            if (compassComponentsPageReworkEnabled && globalComponentsProperty.enabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsRHv.CompassEmptyState), {
                projectKey: projectKey
            });
            else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9GN2.default), {
                projectType: projectType
            });
            break;
        case 'has-components':
            if (editable) createComponentButton = compassComponentsPageReworkEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5bSk.default), {
                testId: "project-directories.components.content.create-component-button",
                loading: globalComponentsProperty.loading,
                globalComponentsEnabled: globalComponentsProperty.enabled,
                oldOnAddComponent: onAddComponent,
                projectKey: projectKey
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                onClick: onAddComponent
            }, formatMessage((0, $6hheN.messages).addComponent));
             // check if a user has access to compass, if not show request access state
            if (compassComponentsPageReworkEnabled && globalComponentsProperty.enabled) {
                if (!globalComponentsProperty.hasCompassPermissions) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bGdP7.RequestAccessState), null);
                else // FF on - Compass components
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS5fI.default), {
                    testId: "project-directories.components.content.compass-components-table",
                    projectKey: projectKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyswk.default), null));
            } else {
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFjQt.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyswk.default), null), compassComponentsPageReworkEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eWUpw.CompassTableCrossflowTouchPointWithEC), null) : null);
                searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dC8o.default), null);
            }
            actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2b047d16a676729d$var$ActionsWrapper, null, compassComponentsPageReworkEnabled && isProjectTypeJsw && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWpHr.WrappedGlobalComponentsToggleButton), {
                globalComponentsProperty: {
                    loading: globalComponentsProperty.loading,
                    enabled: globalComponentsProperty.enabled,
                    setProperty: globalComponentsProperty.setProperty
                },
                isEditable: editable
            }), createComponentButton);
            break;
        case 'error':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $09jnB.default), null);
            break;
        default:
            break;
    }
    const pageContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-test-id": "project-directories.components.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), {
        truncateTitle: true,
        breadcrumbs: breadcrumbs,
        actions: actions,
        bottomBar: compassComponentsPageReworkEnabled && isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPXuY.HeaderBottombarContent), {
            isGlobalComponentsEnabled: globalComponentsProperty.enabled,
            searchBar: searchBar,
            formatMessage: formatMessage
        }) : searchBar
    }, formatMessage((0, $6hheN.messages).caption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $heNSb.DocumentTitle), {
        title: formatMessage((0, $6hheN.messages).caption)
    }), content);
    return isAdminContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectType: projectType
    }, pageContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName
    }, pageContent);
}
function $2b047d16a676729d$var$AppViewNew(props) {
    const { onAddComponent: onAddComponent, status: status, editable: editable, projectKey: projectKey, projectType: projectType, isLoading: isLoading, globalComponentsProperty: globalComponentsProperty = {
        loading: false,
        enabled: false,
        hasCompassPermissions: false,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setProperty: ()=>{}
    } } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const compassComponentsPageReworkEnabled = (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u');
    const isProjectTypeJsw = projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    let content = null;
    let searchBar = null;
    let createComponentButton = null;
    const toggleButton = compassComponentsPageReworkEnabled && isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cWpHr.WrappedGlobalComponentsToggleButton), {
        globalComponentsProperty: {
            loading: globalComponentsProperty.loading,
            enabled: globalComponentsProperty.enabled,
            setProperty: globalComponentsProperty.setProperty
        },
        isEditable: editable
    }) : null;
    let actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, toggleButton);
    const statusWithLoading = compassComponentsPageReworkEnabled && (isLoading || globalComponentsProperty.loading) ? 'loading' : status;
    switch(statusWithLoading){
        case 'loading':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv6pb.LoadingState), null);
            break;
        case 'empty':
            if (compassComponentsPageReworkEnabled && globalComponentsProperty.enabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsRHv.CompassEmptyState), {
                projectKey: projectKey
            });
            else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9GN2.default), {
                projectType: projectType
            });
            break;
        case 'has-components':
            if (editable) createComponentButton = compassComponentsPageReworkEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5bSk.default), {
                testId: "project-directories.components.content.create-component-button",
                loading: globalComponentsProperty.loading,
                globalComponentsEnabled: globalComponentsProperty.enabled,
                oldOnAddComponent: onAddComponent,
                projectKey: projectKey
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                onClick: onAddComponent
            }, formatMessage((0, $6hheN.messages).addComponent));
             // check if a user has access to compass, if not show request access state
            if (compassComponentsPageReworkEnabled && globalComponentsProperty.enabled) {
                if (!globalComponentsProperty.hasCompassPermissions) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bGdP7.RequestAccessState), null);
                else // FF on - Compass components
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iS5fI.default), {
                    testId: "project-directories.components.content.compass-components-table",
                    projectKey: projectKey
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyswk.default), null));
            } else {
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aFjQt.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kyswk.default), null), compassComponentsPageReworkEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eWUpw.CompassTableCrossflowTouchPointWithEC), null) : null);
                searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dC8o.default), {
                    ariaLabel: formatMessage((0, $6hheN.messages).filterInputLabel)
                });
            }
            actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, toggleButton, createComponentButton);
            break;
        case 'error':
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $09jnB.default), null);
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testId": "project-directories.components.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ACoF.PageTopBar), {
        actions: actions,
        bottomBar: compassComponentsPageReworkEnabled && isProjectTypeJsw ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cPXuY.HeaderBottombarContent), {
            isGlobalComponentsEnabled: globalComponentsProperty.enabled,
            searchBar: searchBar,
            formatMessage: formatMessage
        })) : searchBar
    }), content);
}
var $2b047d16a676729d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $9zysr.componentWithCondition)((0, $7JTqr.getWillShowNav4), $2b047d16a676729d$var$AppViewNew, (0, $giAhk.injectIntlV2)($2b047d16a676729d$var$AppViewOld));
const $2b047d16a676729d$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_8mocu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");

var $7ZZxN = parcelRequire("7ZZxN");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});



parcelRegister("3a8wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2992b0d4d3fe9569$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hFGUl = parcelRequire("hFGUl");
const $2992b0d4d3fe9569$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2992b0d4d3fe9569$var$ActionsWrapper, null, actions) : null
    });
var $2992b0d4d3fe9569$export$2e2bcd8739ae039 = $2992b0d4d3fe9569$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2992b0d4d3fe9569$var$ActionsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});



parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

var $3fq1f = parcelRequire("3fq1f");
class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("4ACoF", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $d74ce2d0cb0e9587$export$7e5801dc91bf1819);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");

var $3a8wJ = parcelRequire("3a8wJ");

var $7JTqr = parcelRequire("7JTqr");

const $d74ce2d0cb0e9587$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$90c4434a1e138106),
        xcss: [
            $d74ce2d0cb0e9587$var$wrapperStyles,
            wrapAtMd ? $d74ce2d0cb0e9587$var$wrapAtMdStyle : $d74ce2d0cb0e9587$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: (0, $0b51e3566777dd51$export$1742330ac6a668f0),
        xcss: [
            $d74ce2d0cb0e9587$var$actionsBoxStyles,
            wrapAtMd && $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $d74ce2d0cb0e9587$export$7e5801dc91bf1819 = (props)=>(0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d74ce2d0cb0e9587$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3a8wJ.default), props);
const $d74ce2d0cb0e9587$var$noWrapStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'nowrap'
});
const $d74ce2d0cb0e9587$var$wrapAtMdStyle = (0, $1ZAYh.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $4Ywu9.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $d74ce2d0cb0e9587$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $4Ywu9.media).above.md]: {
        gap: 'space.300'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxAtMdStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto',
    [(0, $4Ywu9.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $d74ce2d0cb0e9587$var$actionsBoxStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
const $0b51e3566777dd51$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $0b51e3566777dd51$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';


parcelRegister("gsRHv", function(module, exports) {

$parcel$export(module.exports, "CompassEmptyState", () => $a8bfa4a535565ab5$export$c3891d38ba06b32e);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");

var $0cdA8 = parcelRequire("0cdA8");

var $j3FUN = parcelRequire("j3FUN");

var $bADTA = parcelRequire("bADTA");

var $dv6pb = parcelRequire("dv6pb");

var $lmF6R = parcelRequire("lmF6R");

var $kpE9x = parcelRequire("kpE9x");
const $a8bfa4a535565ab5$var$TEST_ID = 'project-directories.components.compass-empty-state.empty';
const $a8bfa4a535565ab5$export$c3891d38ba06b32e = ({ projectKey: projectKey })=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const [crossFlowComplete, setCrossFlowComplete] = (0, $eUqFw.useState)(false);
    let componentsTableEmptyState;
    const { count: count, loading: loading, error: error } = (0, $bADTA.useCountCompassComponents)({
        skip: !(licensedProducts && licensedProducts.compass || crossFlowComplete)
    });
    // Render empty state if tenant has Compass, OR
    // We've completed cross flow. Licensed products won't be updated until page reload.
    if (licensedProducts && licensedProducts.compass || crossFlowComplete) {
        if (loading) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dv6pb.LoadingState), null);
        else if (error) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpE9x.ComponentsTableEmptyState), {
            testId: $a8bfa4a535565ab5$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            displayMode: "unknown"
        });
        else if (!count) componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpE9x.ComponentsTableEmptyState), {
            testId: $a8bfa4a535565ab5$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            displayMode: "no-components"
        });
        else componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpE9x.ComponentsTableEmptyState), {
            testId: $a8bfa4a535565ab5$var$TEST_ID,
            projectKey: projectKey,
            loading: false,
            componentCount: count,
            displayMode: "no-linked-components"
        });
    } else componentsTableEmptyState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmF6R.default), {
        origin: "project-pages.project-directories.components.view.empty",
        onCrossFlowComplete: ()=>setCrossFlowComplete(true)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "compass-lodestone",
        id: "compassEmptyState",
        sendToPrivacyUnsafeSplunk: true
    }, componentsTableEmptyState);
};

});
parcelRegister("bADTA", function(module, exports) {

$parcel$export(module.exports, "useCountCompassComponents", () => $08836b5bb1af9f69$export$31d633df2827a840);

var $5UFhP = parcelRequire("5UFhP");

var $dWLk9 = parcelRequire("dWLk9");

var $3LMrX = parcelRequire("3LMrX");
const $08836b5bb1af9f69$export$31d633df2827a840 = (props)=>{
    const { skip: skip = false } = props ?? {};
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: data, loading: loading, error: error } = (0, $5UFhP.useFetchQuery)((0, $3LMrX.COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY), {
        cloudId: cloudId,
        query: {
            fieldFilters: [
                {
                    name: 'state',
                    filter: {
                        in: [
                            'ACTIVE'
                        ]
                    }
                }
            ],
            sort: []
        }
    }, {
        fetchPolicy: 'network-only',
        skip: skip
    });
    const count = data?.compass?.searchComponents?.__typename === 'CompassSearchComponentConnection' ? data?.compass?.searchComponents?.totalCount : null;
    return {
        count: count,
        loading: loading,
        error: error
    };
};

});
parcelRegister("5UFhP", function(module, exports) {

$parcel$export(module.exports, "useFetchQuery", () => $43d0ba1f8ff89bcd$export$e0fe68859e28ee42);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $iWLL0 = parcelRequire("iWLL0");
// sounced from https://github.com/apollographql/apollo-client/blob/main/src/react/hooks/utils/useDeepMemo.ts
const $43d0ba1f8ff89bcd$var$useDeepMemo = (memoFn, key)=>{
    const ref = (0, $eUqFw.useRef)();
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    if (!ref.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    return ref.current.value;
};
const $43d0ba1f8ff89bcd$export$e0fe68859e28ee42 = (query, vars, opts)=>{
    const environment = (0, $iWLL0.useRelayEnvironment)();
    const [result, setResult] = (0, $eUqFw.useState)({
        data: null,
        error: null,
        loading: true
    });
    const { data: data, error: error, loading: loading } = result;
    const prevVariables = (0, $eUqFw.useRef)();
    const fetch = (variables, options)=>{
        const { fetchPolicy: fetchPolicy = 'network-only', skip: skip = false } = options || {};
        if (skip || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(prevVariables.current, variables)) return;
        prevVariables.current = variables;
        // Don't trigger re-render if it's intial render
        if (!(loading === true && data == null && error === null)) setResult({
            error: null,
            loading: true,
            data: null
        });
        (0, $iWLL0.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy
        }).toPromise().then((d)=>{
            setResult({
                error: null,
                loading: false,
                // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'null'.
                data: d
            });
        }).catch((e)=>{
            setResult({
                data: null,
                loading: false,
                error: e
            });
        });
    };
    const memo = {
        vars: vars,
        opts: opts
    };
    $43d0ba1f8ff89bcd$var$useDeepMemo(()=>{
        fetch(vars, opts);
    }, memo);
    const nullableData = data == null ? null : data;
    return {
        data: nullableData,
        error: error,
        loading: loading
    };
};

});

parcelRegister("3LMrX", function(module, exports) {

$parcel$export(module.exports, "COUNT_COMPASS_COMPONENTS_QUERY_AGG_RELAY", () => $253f7fdcbb9f7da3$export$e0e019aad11e83aa);

var $lhp5e = parcelRequire("lhp5e");
const $253f7fdcbb9f7da3$export$e0e019aad11e83aa = (0, $lhp5e.default);

});
parcelRegister("lhp5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a42f0cd11b26f6e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<35c66d1fe3da80e6066fb994a448a5b8>>
 * @relayHash 889293ef5047c9583bb7e73bf9000cdd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425
const $3a42f0cd11b26f6e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = [
        {
            "concreteType": "CompassCatalogQueryApi",
            "kind": "LinkedField",
            "name": "compass",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "searchComponents",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                }
                            ],
                            "type": "CompassSearchComponentConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "errorType"
                                        }
                                    ]
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlCountCompassComponentsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlCountCompassComponentsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "f8b97495244323ce817b882721feb04c964f52f443aa636e0a4b01a3fdd3a425",
            "metadata": {},
            "name": "gqlCountCompassComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3a42f0cd11b26f6e$var$node.hash = "db6ce5954b3b32b77dc71734e9b9557b";
var $3a42f0cd11b26f6e$export$2e2bcd8739ae039 = $3a42f0cd11b26f6e$var$node;

});



parcelRegister("dv6pb", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $38bcde7ac371ea52$export$62aa48085237e36f);

var $eUqFw = parcelRequire("eUqFw");

var $c0jFd = parcelRequire("c0jFd");

var $4Bees = parcelRequire("4Bees");
function $38bcde7ac371ea52$export$62aa48085237e36f() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "project-directories.components.content.components-spinner"
    }));
}

});

parcelRegister("lmF6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ae7034fa0bffe7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lrWNg = parcelRequire("lrWNg");

var $plbOU = parcelRequire("plbOU");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3ae7034fa0bffe7$var$CrossFlowTouchPointWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8x3it",
            __cmplp.className
        ])
    });
});
class $c3ae7034fa0bffe7$var$CompassCrossFlow extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            isCompassLicensed: false
        };
    }
    render() {
        const { isCompassLicensed: isCompassLicensed, origin: origin, onCrossFlowComplete: onCrossFlowComplete } = this.props;
        return !isCompassLicensed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $plbOU.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3ae7034fa0bffe7$var$CrossFlowTouchPointWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lrWNg.default), {
            origin: origin,
            eventSource: "jiraComponentsSection",
            onCrossFlowComplete: onCrossFlowComplete
        })));
    }
}
var $c3ae7034fa0bffe7$export$2e2bcd8739ae039 = $c3ae7034fa0bffe7$var$CompassCrossFlow;

});
parcelRegister("lrWNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c178bf1c6010d072$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $fbeIa = parcelRequire("fbeIa");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $bm3mT = parcelRequire("bm3mT");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $d6f6c = parcelRequire("d6f6c");

var $jMP2a = parcelRequire("jMP2a");

var $gd0Sp = parcelRequire("gd0Sp");

var $a0eNT = parcelRequire("a0eNT");

var $leqiz = parcelRequire("leqiz");


var $lvsmG = parcelRequire("lvsmG");

var $fkrrC = parcelRequire("fkrrC");
const $c178bf1c6010d072$var$NewCrossFlowTouchPoint = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { enabled: enabled, onTry: onTry, onLearnMore: onLearnMore } = props;
    if (enabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c178bf1c6010d072$var$ContentWrapper, {
        "data-testid": "compass-cross-flow.ui.empty-state-not-provisioned"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bm3mT.CompassLogo), {
        appearance: "brand",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c178bf1c6010d072$var$TouchPointMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large",
        as: "h2"
    }, formatMessage((0, $fkrrC.default).headLine))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c178bf1c6010d072$var$TouchPointMessageDescriptionWrapper, null, formatMessage((0, $fkrrC.default).callToAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onTry
    }, formatMessage((0, $fkrrC.default).engageMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onLearnMore,
        href: (0, $5989207c38fa1cf4$export$ae684c7694b92c83),
        target: "_blank"
    }, formatMessage((0, $fkrrC.default).learnMoreMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $leqiz.CrossflowImage), null));
    return null;
};
const $c178bf1c6010d072$var$CrossFlowTouchPoint = (props)=>{
    const { origin: origin, eventSource: eventSource, onCrossFlowComplete: onCrossFlowComplete } = props;
    const crossFlow = (0, $fbeIa.useCrossFlow)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { fireInteractedUIEvent: fireInteractedUIEvent, fireViewedUIEvent: fireViewedUIEvent } = (0, $a0eNT.useFireCrossFlowAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!crossFlow.isEnabled) (0, $guiFP.default)({
            error: new Error(crossFlow.reason),
            meta: {
                id: crossFlow.reason,
                packageName: 'jiraCompassCrossFlow'
            }
        });
        else fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'section',
            actionSubjectId: 'tryCompassBanner'
        }, {
            recommendedProductIds: [
                (0, $fbeIa.Targets).COMPASS
            ],
            source: eventSource
        });
    }, [
        crossFlow,
        eventSource,
        fireViewedUIEvent
    ]);
    const onTry = (0, $eUqFw.useCallback)(async (event, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'tryCompassButton'
        }, {
            targetProductId: (0, $fbeIa.Targets).COMPASS,
            recommendedProductIds: [
                (0, $fbeIa.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointTry');
        if (crossFlow.isEnabled) {
            await crossFlow.api.open({
                journey: (0, $fbeIa.Journeys).GET_STARTED,
                targetProduct: (0, $fbeIa.Targets).COMPASS,
                sourceComponent: 'jira-compass-cross-flow-try',
                sourceContext: 'jira'
            });
            // Refresh the Compass Crossflow Touchpoint once Compass is provisioned
            const result = await (0, $lvsmG.hasCompassBeenProvisioned)(cloudId);
            if (result) {
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandComplete', {
                    hasCompassProvisioned: result,
                    origin: origin
                });
                onCrossFlowComplete?.();
            } else (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'compassCrossflow expandIncomplete', {
                hasCompassProvisioned: result,
                origin: origin
            });
        }
    }, [
        cloudId,
        crossFlow,
        origin,
        fireInteractedUIEvent,
        onCrossFlowComplete
    ]);
    const onLearnMore = (0, $eUqFw.useCallback)(async (event, analyticsEvent)=>{
        fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMoreCompassButton'
        }, {
            targetProductId: (0, $fbeIa.Targets).COMPASS,
            recommendedProductIds: [
                (0, $fbeIa.Targets).COMPASS
            ],
            source: 'tryCompassBannerSection'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'compassCrossFlowTouchPointLearnMore');
    }, [
        fireInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        teamName: "compass-lodestone",
        id: "crossFlowTouchPoint",
        packageName: "jiraCompassCrossFlowTouchPoint",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "jiraCompassCrossFlowTouchPoint"
    }), $c178bf1c6010d072$var$NewCrossFlowTouchPoint({
        enabled: crossFlow.isEnabled,
        onTry: onTry,
        onLearnMore: onLearnMore
    }));
};
var $c178bf1c6010d072$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c178bf1c6010d072$var$CrossFlowTouchPoint;
const $c178bf1c6010d072$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4 _1bsbj2pb _syazjjyb _19pkiija",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c178bf1c6010d072$var$TouchPointMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng _ca0qv47k",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c178bf1c6010d072$var$TouchPointMessageDescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _1yt4r2fv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bm3mT", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", () => $48e32c0e97a9b1cc$export$eb7d748e4f9c9676);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $48e32c0e97a9b1cc$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const $48e32c0e97a9b1cc$export$eb7d748e4f9c9676 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $48e32c0e97a9b1cc$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("leqiz", function(module, exports) {

$parcel$export(module.exports, "CrossflowImage", () => $c1fbbf2d4123a6a2$export$d0aa3e19f62b822f);

var $eUqFw = parcelRequire("eUqFw");

var $1q5E9 = parcelRequire("1q5E9");
const $c1fbbf2d4123a6a2$export$d0aa3e19f62b822f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1q5E9.default), {
        alt: "Jira Crossflow",
        width: 457,
        height: 285
    });

});
parcelRegister("1q5E9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de34d78e92b3efb$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $dDA64 = parcelRequire("dDA64");
const $4de34d78e92b3efb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dDA64)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dDA64))
});
var $4de34d78e92b3efb$export$2e2bcd8739ae039 = $4de34d78e92b3efb$var$Illustration;
// for advanced use only
const $4de34d78e92b3efb$export$a179c88182cb9d56 = [
    0,
    0,
    64,
    64
];

});
parcelRegister("dDA64", function(module, exports) {
module.exports = new URL("ui-jsw-compass-crossflow.0545e2c1.svg", import.meta.url).toString();

});



const $5989207c38fa1cf4$export$ae684c7694b92c83 = 'https://www.atlassian.com/software/compass';

parcelRegister("fkrrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bc87f0df3fc9b4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $61bc87f0df3fc9b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    callToAction: {
        "id": "compass-cross-flow.call-to-action",
        "defaultMessage": "Create a comprehensive catalog of software components in Compass, then link them to issues \u2013 so your team can track and reveal the impact of their work on components, and surface information that helps move that work forward."
    },
    engageMessage: {
        "id": "compass-cross-flow.engage-message",
        "defaultMessage": "Try Compass free"
    },
    headLine: {
        "id": "compass-cross-flow.head-line",
        "defaultMessage": "A new way to work on software components "
    },
    learnMoreMessage: {
        "id": "compass-cross-flow.learn-more-message",
        "defaultMessage": "Learn more about Compass"
    }
});

});



parcelRegister("kpE9x", function(module, exports) {

$parcel$export(module.exports, "ComponentsTableEmptyState", () => $c817cc34aa3d4e2c$export$bbd499cf012bf709);
/* components-table-empty-state.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $l5bSk = parcelRequire("l5bSk");

var $4eA10 = parcelRequire("4eA10");

var $bKNJq = parcelRequire("bKNJq");
const $c817cc34aa3d4e2c$var$ISSUES_URL = (projectKey)=>encodeURI(`${window.location.origin}/browse/${projectKey}/issues`);
function $c817cc34aa3d4e2c$export$bbd499cf012bf709({ loading: loading, projectKey: projectKey, testId: testId, componentCount: componentCount, displayMode: displayMode }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const createButtonTestId = testId && `${testId}-create-button`; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'compassComponentsTableEmptyStateLearnMore');
    };
    const EmptyState = displayMode === 'no-linked-components' ? (0, $4eA10.EmptyStateImage) : (0, $4eA10.EmptyStateBlocks);
    const primaryAction = displayMode === 'no-linked-components' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        isLoading: loading,
        href: $c817cc34aa3d4e2c$var$ISSUES_URL(projectKey)
    }, formatMessage((0, $bKNJq.default).gotoIssues)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l5bSk.default), {
        testId: createButtonTestId,
        loading: loading,
        oldOnAddComponent: ()=>{},
        projectKey: projectKey,
        globalComponentsEnabled: true,
        verbose: true
    });
    let heading;
    let body;
    switch(displayMode){
        case 'no-components':
            heading = (0, $bKNJq.default).noComponentsHeading;
            body = (0, $bKNJq.default).noComponentsBody;
            break;
        case 'no-linked-components':
            heading = (0, $bKNJq.default).noLinkedComponentsHeading;
            body = (0, $bKNJq.default).noLinkedComponentsBody;
            break;
        case 'unknown':
            heading = (0, $bKNJq.default).heading;
            body = (0, $bKNJq.default).noComponentsBody;
            break;
        default:
            heading = (0, $bKNJq.default).heading;
            body = (0, $bKNJq.default).noComponentsBody;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "componentsTableEmptyState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        eventName: "viewed componentsTableEmptyState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c817cc34aa3d4e2c$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.400",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(EmptyState, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c817cc34aa3d4e2c$var$Heading, null, formatMessage(heading, {
        componentCount: componentCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c817cc34aa3d4e2c$var$Body, null, formatMessage(body, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.200",
        alignItems: "center"
    }, primaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
        articleId: "6frUzedhV1M0c05JhXMvK0",
        appearance: "link",
        spacing: "none",
        onClick: onClickLearnMore,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            href: "https://support.atlassian.com/jira-software-cloud/docs/link-issues-to-compass-components/",
            onClick: onClickLearnMore,
            target: "_blank",
            spacing: "none",
            appearance: "link"
        }, formatMessage((0, $bKNJq.default).learnMore))
    }, formatMessage((0, $bKNJq.default).learnMore))))))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c817cc34aa3d4e2c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81yal _1bsbbhyd",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c817cc34aa3d4e2c$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48p1pd9 _vwz4gktf _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c817cc34aa3d4e2c$var$Body = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr1ejb _1bsbr5sb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

parcelRegister("l5bSk", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ce190decd4c9b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $8GAdb = parcelRequire("8GAdb");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $cNjEZ = parcelRequire("cNjEZ");
const $49ce190decd4c9b1$var$COMPASS_CREATE_COMPONENT_URL = (projectKey)=>{
    const projectLink = encodeURI(`${window.location.origin}/browse/${projectKey}`);
    return `/compass/home?showCreateComponentModal=true&projectLink=${projectLink}`;
};
function $49ce190decd4c9b1$export$2e2bcd8739ae039({ testId: testId, loading: loading, globalComponentsEnabled: globalComponentsEnabled = false, oldOnAddComponent: oldOnAddComponent, projectKey: projectKey, verbose: verbose = false }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (globalComponentsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: testId,
        isLoading: loading,
        href: $49ce190decd4c9b1$var$COMPASS_CREATE_COMPONENT_URL(projectKey),
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "primary",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createCompassComponent');
        },
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GAdb))), {
            label: formatMessage((0, $cNjEZ.default).addComponent)
        })
    }, formatMessage(verbose ? (0, $cNjEZ.default).addCompassComponent : (0, $cNjEZ.default).addComponent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "compass-lodestone",
        id: "createComponentButton",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        isLoading: loading,
        testId: testId,
        appearance: "primary",
        onClick: oldOnAddComponent
    }, formatMessage((0, $cNjEZ.default).addComponent)));
}

});
parcelRegister("cNjEZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f962f93b933e940c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f962f93b933e940c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addComponent: {
        "id": "project-components.create-component-button.trigger",
        "defaultMessage": "Create component"
    },
    addCompassComponent: {
        "id": "project-components.create-compass-component-button.trigger",
        "defaultMessage": "Create Compass component"
    }
});

});


parcelRegister("4eA10", function(module, exports) {

$parcel$export(module.exports, "EmptyStateBlocks", () => $343ffdc4017c6cef$export$58b6dcfb3ce70686);
$parcel$export(module.exports, "EmptyStateImage", () => $343ffdc4017c6cef$export$a7907bb86a15af4e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $gISog = parcelRequire("gISog");

var $2cWB2 = parcelRequire("2cWB2");
const $343ffdc4017c6cef$export$58b6dcfb3ce70686 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gISog))),
        alt: "",
        width: 171.25
    });
const $343ffdc4017c6cef$var$imageTopMarginStyles = null;
const $343ffdc4017c6cef$export$a7907bb86a15af4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cWB2))),
        alt: "",
        width: 336,
        className: (0, $7JEyt.default)([
            "_19pkpxbi"
        ])
    });

});
parcelRegister("gISog", function(module, exports) {
module.exports = new URL("empty-state-blocks.4f8f7da7.svg", import.meta.url).toString();

});

parcelRegister("2cWB2", function(module, exports) {
module.exports = new URL("issues-highlight.37797bd0.svg", import.meta.url).toString();

});


parcelRegister("bKNJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fef3922b74d1d63$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5fef3922b74d1d63$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "compass-common.components-table-empty-state.heading",
        "defaultMessage": "No Compass components are linked to your project"
    },
    noComponentsHeading: {
        "id": "compass-common.components-table-empty-state.no-components-heading",
        "defaultMessage": "You don't have any software components in Compass"
    },
    noLinkedComponentsHeading: {
        "id": "compass-common.components-table-empty-state.no-linked-components-heading",
        "defaultMessage": "{componentCount, plural, one {You have # software component in Compass, but it is not linked to an issue} other {You have # software components in Compass, but none are linked to issues}}"
    },
    body: {
        "id": "compass-common.components-table-empty-state.body",
        "defaultMessage": "Create a component in Compass, then add it to an issue's <b>Components</b> field. The component and its related information will appear here."
    },
    noComponentsBody: {
        "id": "compass-common.components-table-empty-state.no-components-body",
        "defaultMessage": "Issues can be linked to Compass software components, so you can track and manage the work on your software architecture."
    },
    noLinkedComponentsBody: {
        "id": "compass-common.components-table-empty-state.no-linked-components-body",
        "defaultMessage": "Add a component to an issue\u2019s <b>Components</b> field. Both will appear here, so you can track the work on your software architecture."
    },
    gotoIssues: {
        "id": "compass-common.components-table-empty-state.goto-issues",
        "defaultMessage": "Go to issues"
    },
    learnMore: {
        "id": "compass-common.components-table-empty-state.learn-more",
        "defaultMessage": "Learn more"
    }
});

});



parcelRegister("iS5fI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0884baab1a1a211$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $cXEqp = parcelRequire("cXEqp");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");

var $ccYHR = parcelRequire("ccYHR");

var $1cH8V = parcelRequire("1cH8V");

var $bGdP7 = parcelRequire("bGdP7");
const $e0884baab1a1a211$var$mapStateToProps = (state)=>({
        isPageLoading: (0, $ccYHR.isLoading)(state),
        // Ordered list of IDs returned from backend. Needed for rendering sorted order.
        componentIds: (0, $cXEqp.getIds)(state),
        // Used to quickly fire search query.
        componentAris: (0, $cXEqp.getAris)(state),
        // Needed to retrieve component by ARI and render.
        componentsById: state.components.byId,
        componentCount: (0, $cXEqp.getTotalItems)(state),
        orderField: (0, $1FdCJ.getOrderField)(state),
        orderDirection: (0, $1FdCJ.getOrderDirection)(state)
    });
const $e0884baab1a1a211$var$mapDispatchToProps = (dispatch)=>({
        onSort: ({ key: key, sortOrder: sortOrder })=>{
            dispatch((0, $bau7U.patchQuery)({
                orderDirection: sortOrder,
                orderField: key,
                page: 1
            }));
            dispatch((0, $fnVSJ.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).SORTING
            }));
        }
    });
var $e0884baab1a1a211$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($e0884baab1a1a211$var$mapStateToProps, $e0884baab1a1a211$var$mapDispatchToProps)((0, $1cH8V.default));

});
parcelRegister("1cH8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbb51bf43deb18bb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $clqWl = parcelRequire("clqWl");

var $hI5oG = parcelRequire("hI5oG");

var $aUqTb = parcelRequire("aUqTb");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $7DokK = parcelRequire("7DokK");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $3QLcd = parcelRequire("3QLcd");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $jK1pm = parcelRequire("jK1pm");

var $7INHA = parcelRequire("7INHA");

var $fLiNF = parcelRequire("fLiNF");

var $53rsP = parcelRequire("53rsP");

var $2Y0Ng = parcelRequire("2Y0Ng");

var $bXcTy = parcelRequire("bXcTy");

var $3nYaj = parcelRequire("3nYaj");

var $2Ksba = parcelRequire("2Ksba");

var $lm3iN = parcelRequire("lm3iN");

var $3PIo4 = parcelRequire("3PIo4");

var $kPcWn = parcelRequire("kPcWn");

var $eWSMP = parcelRequire("eWSMP");
const $cbb51bf43deb18bb$var$useGetTeams = (components)=>{
    const [teamInfo, setTeamInfo] = (0, $eUqFw.useState)({});
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    (0, $eUqFw.useEffect)(()=>{
        if (components.length === 0) {
            setTeamInfo({});
            return;
        }
        const ownerIds = Array.from(new Set(components.map((component)=>component?.ownerId).filter(Boolean).map((0, $7DokK.getIdFromAri))));
        if (ownerIds.length === 0) {
            setTeamInfo({});
            return;
        }
        (0, $fLiNF.getTeams)(ownerIds).then((result)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const teamsByAri = Object.fromEntries(result.teams.map((team)=>[
                    team.id,
                    team
                ]));
            setTeamInfo(teamsByAri);
        }).catch((e)=>setError(e));
    }, [
        components
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $guiFP.default)({
            meta: {
                id: 'useGetTeams',
                packageName: 'jiraProjectDirectoriesComponents',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        error
    ]);
    return {
        teamInfo: teamInfo,
        error: error
    };
};
function $cbb51bf43deb18bb$export$2e2bcd8739ae039(props) {
    const { testId: testId, projectKey: projectKey, isPageLoading: isPageLoading, componentIds: componentIds, componentsById: componentsById, componentAris: componentAris, componentCount: componentCount, orderField: orderField, orderDirection: orderDirection, onSort: onSort, children: children } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { components: compassComponents, loading: compassComponentsLoading, error: compassComponentsError } = (0, $53rsP.useGetCompassComponents)(componentAris);
    const loading = (0, $eUqFw.useMemo)(()=>compassComponentsLoading || isPageLoading, [
        compassComponentsLoading,
        isPageLoading
    ]); // Merged list of components in Jira that also exist in Compass.
    // This list is also sorted correctly via Jira.
    const mergedComponents = (0, $eUqFw.useMemo)(()=>{
        if (loading || compassComponents.length === 0) return [];
         // We reduce by `componentIds` as these are in correct sort order from server already.
        return componentIds.reduce((acc, componentId)=>{
            // Get the full Jira component from `componentsById`. We need the ARI and issue count.
            const jiraComponent = componentsById[componentId]; // Find a matching component that exists in Compass with the same ARI.
            const compassComponent = compassComponents.find((curCompassComponent)=>curCompassComponent.id === jiraComponent.ari); // Component exists in compass, we can render it.
            if (compassComponent) acc.push({
                ...compassComponent,
                issueCount: jiraComponent.issueCount
            });
            return acc;
        }, []);
    }, [
        loading,
        componentIds,
        componentsById,
        compassComponents
    ]);
    const { teamInfo: teamInfo } = $cbb51bf43deb18bb$var$useGetTeams(mergedComponents);
    const head = (0, $eUqFw.useMemo)(()=>({
            cells: [
                {
                    key: (0, $7INHA.NAME),
                    content: formatMessage((0, $eWSMP.default).componentHeader),
                    width: 25,
                    isSortable: true
                },
                {
                    key: 'owner-team',
                    content: formatMessage((0, $eWSMP.default).ownerTeamHeader),
                    width: 25,
                    isSortable: false
                },
                {
                    key: 'repository',
                    content: formatMessage((0, $eWSMP.default).repositoryHeader),
                    width: 18,
                    isSortable: false
                },
                {
                    key: 'dependencies',
                    content: formatMessage((0, $eWSMP.default).dependenciesHeader),
                    width: 12,
                    isSortable: false
                },
                {
                    key: 'scorecard',
                    content: formatMessage((0, $eWSMP.default).scorecardHeader),
                    width: 12,
                    isSortable: false
                },
                {
                    key: (0, $7INHA.ISSUES),
                    content: formatMessage((0, $eWSMP.default).issuesHeader),
                    width: 8,
                    isSortable: true
                }
            ]
        }), [
        formatMessage
    ]);
    const rows = mergedComponents.map((component, idx)=>{
        const ownerId = (0, $7DokK.getIdFromAri)(component?.ownerId ?? '');
        return $cbb51bf43deb18bb$var$compassComponentToRow({
            ...component,
            ownerName: teamInfo[ownerId]?.displayName ?? null
        }, projectKey, // Sorting is handled by API.
        orderDirection === 'DESC' ? -(idx + 1) : idx + 1);
    }); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'learnMoreAboutLinkingIssuesToCompassLink');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.500"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small"
    }, formatMessage((0, $eWSMP.default).componentCount, {
        componentCount: componentCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "right-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                padding: "space.200",
                xcss: $cbb51bf43deb18bb$var$tableHeaderStyles
            }, formatMessage((0, $eWSMP.default).componentInfo, {
                // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                bold: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, text),
                link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                        articleId: "6frUzedhV1M0c05JhXMvK0",
                        appearance: "link",
                        spacing: "none",
                        onClick: onClickLearnMore,
                        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                            href: "https://support.atlassian.com/jira-software-cloud/docs/link-issues-to-compass-components/",
                            target: "_blank",
                            appearance: "link",
                            spacing: "none",
                            onClick: onClickLearnMore
                        }, text)
                    }, text)
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                spacing: "compact",
                appearance: "subtle-link",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                    label: ""
                }),
                testId: "project-directories.components.compass-table.add",
                onClick: ()=>setIsOpen(!isOpen),
                ...triggerProps
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbb51bf43deb18bb$var$TableWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
        isFixedSize: true,
        loadingSpinnerSize: "large",
        head: head,
        rows: rows,
        isLoading: loading,
        sortKey: orderField,
        sortOrder: orderDirection,
        onSort: (data, analyticsEvent)=>{
            onSort?.(data);
            if (analyticsEvent) (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'compassComponentsTableSorted', {
                key: data.key,
                sortOrder: data.sortOrder
            });
        },
        emptyView: compassComponentsError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kPcWn.ComponentsTableErrorState), null) : undefined
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "global-components"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents" // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        ,
        teamName: "compass-lodestone",
        id: "compassComponentsTable",
        sendToPrivacyUnsafeSplunk: true
    }, content), !compassComponentsError && children);
}
function $cbb51bf43deb18bb$var$compassComponentToRow(component, projectKey, key) {
    const componentId = (0, $7DokK.getIdFromAri)(component.id);
    const ownerId = component.ownerId ? (0, $7DokK.getIdFromAri)(component?.ownerId ?? '') : undefined;
    return {
        cells: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Y0Ng.default), {
                    componentId: componentId,
                    name: component.name,
                    description: component.description,
                    typeId: component.typeId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ksba.default), {
                    ownerName: component.ownerName,
                    ownerId: ownerId
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lm3iN.RepositoryCell), {
                    repositoryLinks: component.links
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bXcTy.default), {
                    componentId: componentId,
                    inwardRelationships: component.inwardRelationships,
                    outwardRelationships: component.outwardRelationships
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3PIo4.default // Use full component ARI to make scorecards query.
                ), {
                    componentId: component.id,
                    scorecardScores: component.scorecardScores
                }),
                key: key
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3nYaj.default), {
                    projectKey: projectKey,
                    componentName: component.name,
                    issueCount: component.issueCount
                }),
                key: key
            }
        ]
    };
}
const $cbb51bf43deb18bb$var$tableHeaderStyles = (0, $1ZAYh.xcss)({
    width: '417px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cbb51bf43deb18bb$var$TableWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bve41l7n _f96p1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $7cd2847e492d5dd4$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $5Q9wj.default), onSort: providedOnSort = (0, $5Q9wj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $5Q9wj.default), onRankEnd: providedOnRankEnd = (0, $5Q9wj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eUqFw.useState)(false);
    const tableBodyRef = (0, $eUqFw.useRef)(null);
    const onSort = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eUqFw.useEffect)(()=>{
        (0, $fVXMO.validateSortKey)(sortKey, head);
        (0, $fVXMO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
        isLoading: isLoading,
        spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("cxS0I")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTable;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: $1430aaf59e7cbeab$var$captionStyles
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';



parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dXKde))), {
            label: ""
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: ""
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db781ab5297a2cc1540c99d75921a718>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});


parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});

parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");



var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellBaseStylesModernized = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            (0, $XHGTv.fg)('design_system_team_dynamic_table_typography') ? $e23e257a0c447ed4$var$headCellBaseStylesModernized : $e23e257a0c447ed4$var$headCellBaseStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("cxS0I", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("aVYwg")
]).then(()=>parcelRequire('jlg4D'));

});


parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $7f13fdf9f823d771$var$_information = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("h6FFs")));
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $7f13fdf9f823d771$var$_information.default
    }));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = module.exports.default = $7f13fdf9f823d771$var$EditorPanelIcon;

});
parcelRegister("h6FFs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cfc592cc61140d99cb4eaed527408acf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});


parcelRegister("7DokK", function(module, exports) {

$parcel$export(module.exports, "getColorForProgress", () => $58ab428192c64887$export$58950a4b8fb8acf4);
$parcel$export(module.exports, "getScorecardHealthCountsFromScores", () => $58ab428192c64887$export$a64a7643d5a3fae);
$parcel$export(module.exports, "getSummaryText", () => $58ab428192c64887$export$d48af90fda49897);
$parcel$export(module.exports, "getScorecardsSortedByHealth", () => $58ab428192c64887$export$6e2af0614a0d9b67);
$parcel$export(module.exports, "getIdFromAri", () => $58ab428192c64887$export$79640a85913af5aa);


var $84JxC = parcelRequire("84JxC");
const $58ab428192c64887$export$aa91e30498abc411 = {
    FAILING: 0,
    NEEDS_ATTENTION: 50,
    PASSING: 100
};
const $58ab428192c64887$var$COLOR_RANGES = [
    {
        start: $58ab428192c64887$export$aa91e30498abc411.FAILING,
        end: $58ab428192c64887$export$aa91e30498abc411.NEEDS_ATTENTION - 1,
        color: (0, $73a5c9d720aa66e1$exports).R300
    },
    {
        start: $58ab428192c64887$export$aa91e30498abc411.NEEDS_ATTENTION,
        end: $58ab428192c64887$export$aa91e30498abc411.PASSING - 1,
        color: (0, $73a5c9d720aa66e1$exports).Y300
    },
    {
        start: $58ab428192c64887$export$aa91e30498abc411.PASSING,
        end: $58ab428192c64887$export$aa91e30498abc411.PASSING,
        color: (0, $73a5c9d720aa66e1$exports).G300
    }
];
const $58ab428192c64887$export$58950a4b8fb8acf4 = (progress)=>{
    for (const { start: start, end: end, color: color } of $58ab428192c64887$var$COLOR_RANGES){
        if (progress >= start && progress <= end) return color;
    }
    // Default.
    return (0, $73a5c9d720aa66e1$exports).R300;
};
const $58ab428192c64887$export$921f23fa0f13f23e = 90;
const $58ab428192c64887$export$69a1d9a35c04a358 = 50;
const $58ab428192c64887$export$a64a7643d5a3fae = (scorecardScores)=>{
    let failingScorecards = 0;
    let needsAttentionScorecards = 0;
    let totalScorecards = 0;
    scorecardScores.forEach((scorecardScore)=>{
        const totalScore = scorecardScore?.totalScore ?? 0;
        totalScorecards += 1;
        if (totalScore < $58ab428192c64887$export$69a1d9a35c04a358) failingScorecards += 1;
        else if (totalScore >= $58ab428192c64887$export$69a1d9a35c04a358 && totalScore < $58ab428192c64887$export$921f23fa0f13f23e) needsAttentionScorecards += 1;
    });
    return {
        total: totalScorecards,
        passing: totalScorecards - failingScorecards - needsAttentionScorecards,
        needsAttention: needsAttentionScorecards
    };
};
const $58ab428192c64887$export$d48af90fda49897 = (scorecardHealthCount, totalScorecardsCount, formatMessage)=>{
    const { passing: passing } = scorecardHealthCount;
    const { needsAttention: needsAttention } = scorecardHealthCount;
    let numerator = 0;
    let message;
    if (passing === 0 && totalScorecardsCount === 0) message = (0, $84JxC.default).noScorecards;
    else if (passing + needsAttention < totalScorecardsCount) {
        numerator = Math.floor(totalScorecardsCount) - Math.floor(passing) - Math.floor(needsAttention);
        message = (0, $84JxC.default).summaryTextForFailing;
    } else if (needsAttention > 0) {
        numerator = Math.floor(needsAttention);
        message = (0, $84JxC.default).summaryTextForNeedsAttention;
    } else {
        numerator = Math.floor(totalScorecardsCount);
        message = (0, $84JxC.default).summaryTextForHealthy;
    }
    return formatMessage(message, {
        numerator: numerator
    });
};
const $58ab428192c64887$export$6e2af0614a0d9b67 = (scorecards)=>[
        ...scorecards
    ].sort((a, b)=>{
        const aTotalScore = a?.scorecardScore?.totalScore ?? 0;
        const bTotalScore = b?.scorecardScore?.totalScore ?? 0;
        return aTotalScore - bTotalScore;
    });
function $58ab428192c64887$export$79640a85913af5aa(ari) {
    const regex = /\/([\w-]+)$/; // Matches the id at the end of the string
    const match = ari.match(regex);
    return match ? match[1] : '';
}

});
parcelRegister("84JxC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fef52355ba5b93b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8fef52355ba5b93b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noScorecards: {
        "id": "compass-common.common.no-scorecards",
        "defaultMessage": "No scorecards"
    },
    summaryTextForFailing: {
        "id": "compass-common.common.summary-text-for-failing",
        "defaultMessage": "{numerator} {numerator, plural, one {failing} other {failing}}"
    },
    summaryTextForHealthy: {
        "id": "compass-common.common.summary-text-for-healthy",
        "defaultMessage": "All passing"
    },
    summaryTextForNeedsAttention: {
        "id": "compass-common.common.summary-text-for-needs-attention",
        "defaultMessage": "{numerator} {numerator, plural, one {needs} other {need}} attention"
    }
});

});


parcelRegister("fLiNF", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $a3f3f7389dfa8489$export$5a622455e94bac3);

var $lRmyA = parcelRequire("lRmyA");

const $a3f3f7389dfa8489$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v3/teams/withMembers/bulk';
const $a3f3f7389dfa8489$export$5a622455e94bac3 = async (teamIds)=>(0, $lRmyA.performPostRequest)($a3f3f7389dfa8489$var$TEAMS_BULK_REST_API_URL, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(teamIds)
    });

});

parcelRegister("53rsP", function(module, exports) {

$parcel$export(module.exports, "useGetCompassComponents", () => $c2f487373281ffd8$export$79b1cb1316dc1cf9);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $5UFhP = parcelRequire("5UFhP");

var $dWLk9 = parcelRequire("dWLk9");

var $drvg3 = parcelRequire("drvg3");

var $2pjzi = parcelRequire("2pjzi");
const $c2f487373281ffd8$export$79b1cb1316dc1cf9 = (componentAris)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { data: data, loading: loading, error: error } = (0, $5UFhP.useFetchQuery)((0, $2pjzi.SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY), {
        cloudId: cloudId,
        query: {
            first: (0, $drvg3.ITEMS_ON_PAGE),
            fieldFilters: [
                {
                    name: 'entityId',
                    filter: {
                        in: componentAris
                    }
                }
            ]
        }
    }, {
        fetchPolicy: 'network-only'
    });
    const components = (0, $eUqFw.useMemo)(()=>{
        if (data?.compass?.searchComponents?.__typename !== 'CompassSearchComponentConnection') return [];
        return data?.compass?.searchComponents.nodes?.map($c2f487373281ffd8$var$mapNodeToComponent).filter((component)=>component != null) ?? [];
    }, [
        data
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loading && error) (0, $guiFP.default)({
            meta: {
                id: 'useGetCompassComponents',
                packageName: 'jiraProjectDirectoriesComponents',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        loading,
        error
    ]);
    return {
        components: components,
        loading: loading,
        error: error
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c2f487373281ffd8$var$mapNodeToComponent(node) {
    if (!node || !node.component || node.__typename !== 'CompassSearchComponentResult') return null;
    const { component: component } = node;
    let inwardRelationships;
    let outwardRelationships;
    if (component.inwardRelationships.__typename !== 'CompassRelationshipConnection') inwardRelationships = {
        nodes: [],
        pageInfo: {
            hasNextPage: false
        },
        error: component.inwardRelationships.message
    };
    else inwardRelationships = component.inwardRelationships;
    if (component.outwardRelationships.__typename !== 'CompassRelationshipConnection') outwardRelationships = {
        nodes: [],
        pageInfo: {
            hasNextPage: false
        },
        error: component.outwardRelationships.message
    };
    else outwardRelationships = component.outwardRelationships;
    const repositoryLinks = component.links?.reduce((acc, cur)=>{
        if (cur.type === 'REPOSITORY') acc.push(cur);
        return acc;
    }, []) ?? [];
    return {
        id: component.id,
        name: component.name,
        description: component.description,
        typeId: component.typeId,
        ownerId: component.ownerId,
        links: repositoryLinks,
        link: node.link,
        scorecardScores: component.scorecardScores,
        inwardRelationships: inwardRelationships,
        outwardRelationships: outwardRelationships
    };
}

});
parcelRegister("2pjzi", function(module, exports) {

$parcel$export(module.exports, "SEARCH_COMPASS_COMPONENTS_QUERY_AGG_RELAY", () => $a896c24b9e1026f1$export$bd252c97cab4a3b6);

var $fbatU = parcelRequire("fbatU");
const $a896c24b9e1026f1$export$bd252c97cab4a3b6 = (0, $fbatU.default);

});
parcelRegister("fbatU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a242349ca10d0a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d25ab7d51e15750d3649629d32cb272d>>
 * @relayHash 0ca319167a9210dca4cdd2e303b9fad9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e17545780e24c3e43425f3d4066170c5eb00cc407025cd5f396dffe84b03e726
const $9a242349ca10d0a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "query"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "typeId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "ownerId"
    }, v6 = {
        "types": [
            "DEPENDS_ON"
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        v4 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            },
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusCode"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ]
            }
        ],
        "type": "QueryError"
    }, v10 = [
        {
            "concreteType": "CompassCatalogQueryApi",
            "kind": "LinkedField",
            "name": "compass",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "query",
                            "variableName": "query"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "searchComponents",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "CompassSearchComponentResult",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "link"
                                        },
                                        {
                                            "concreteType": "CompassComponent",
                                            "kind": "LinkedField",
                                            "name": "component",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "description"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "CompassLink",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": true,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "CompassScorecardScore",
                                                    "kind": "LinkedField",
                                                    "name": "scorecardScores",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalScore"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "maxTotalScore"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "inwardRelationships",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "query",
                                                            "value": {
                                                                "direction": "INWARD",
                                                                "filters": v6 /*: any*/ ,
                                                                "first": 5
                                                            }
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CompassRelationship",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CompassComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "startNode",
                                                                            "plural": false,
                                                                            "selections": v7 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "CompassRelationshipConnection"
                                                        },
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "relationships(query:{\"direction\":\"INWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                                                },
                                                {
                                                    "alias": "outwardRelationships",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "query",
                                                            "value": {
                                                                "direction": "OUTWARD",
                                                                "filters": v6 /*: any*/ ,
                                                                "first": 5
                                                            }
                                                        }
                                                    ],
                                                    "kind": "LinkedField",
                                                    "name": "relationships",
                                                    "plural": false,
                                                    "selections": [
                                                        v1 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "CompassRelationship",
                                                                    "kind": "LinkedField",
                                                                    "name": "nodes",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "CompassComponent",
                                                                            "kind": "LinkedField",
                                                                            "name": "endNode",
                                                                            "plural": false,
                                                                            "selections": v7 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v8 /*: any*/ 
                                                            ],
                                                            "type": "CompassRelationshipConnection"
                                                        },
                                                        v9 /*: any*/ 
                                                    ],
                                                    "storageKey": "relationships(query:{\"direction\":\"OUTWARD\",\"filters\":{\"types\":[\"DEPENDS_ON\"]},\"first\":5})"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "CompassSearchComponentConnection"
                        },
                        v9 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "id": "e17545780e24c3e43425f3d4066170c5eb00cc407025cd5f396dffe84b03e726",
            "metadata": {},
            "name": "gqlJiraJswComponentsTableComponentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9a242349ca10d0a3$var$node.hash = "e3f6d8c3785a5ee4a1647c50beb44179";
var $9a242349ca10d0a3$export$2e2bcd8739ae039 = $9a242349ca10d0a3$var$node;

});



parcelRegister("2Y0Ng", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c1c513583867d0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $64FeG = parcelRequire("64FeG");

var $jMP2a = parcelRequire("jMP2a");
function $5c1c513583867d0f$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, name: name, description: description, typeId: typeId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: description ?? name
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...tooltipProps,
            testId: "project-directories.components.compass-table.cells.component.link",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $5c1c513583867d0f$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64FeG.ComponentTypeIcon), {
                type: typeId
            })),
            appearance: "link",
            spacing: "none",
            href: `/compass/component/${componentId}`,
            target: "_blank",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'compassComponentLink');
            }
        }, name));
}
const $5c1c513583867d0f$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.150',
    marginRight: 'space.150'
});

});
parcelRegister("64FeG", function(module, exports) {

$parcel$export(module.exports, "ComponentTypeIcon", () => $179fe634ba219aeb$export$cac930aaf0e7232e);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");


var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bSejN = parcelRequire("bSejN");

var $8r9gI = parcelRequire("8r9gI");
const $179fe634ba219aeb$export$cac930aaf0e7232e = (props)=>{
    const { type: type, testId: testId, size: size = 'medium' } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const componentType = (0, $bSejN.default)[type];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage(componentType.name)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8r9gI.ComponentIconBackground), {
        testId: testId,
        type: type,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        label: formatMessage(componentType.name),
        primaryColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$exports).N0})`,
        glyph: componentType.icon
    })));
};

});
parcelRegister("bSejN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c4cd6eff84dab8$export$2e2bcd8739ae039);
// We had to disable the rule, because the "fill" and "stroke" attributes of the svg wanted a token, and there's no token for white
/**
 * This file contains the component types metadata that will need to be used throughout the Compass Frontend.
 * Actual field definitions and its options are fetched using a GraphQL query from the Compass Catalog.
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $48KCt = parcelRequire("48KCt");
const $84c4cd6eff84dab8$export$bace2d8ac2cf2caa = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 17.991c0 .007 14.005.009 14.005.009-.006 0-.005-7.991-.005-7.991C19 10.002 4.995 10 4.995 10 5.001 10 5 17.991 5 17.991ZM3 10.01C3 8.899 3.893 8 4.995 8h14.01C20.107 8 21 8.902 21 10.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 17.991V10.01Z",
        fill: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 8.335c0-.002 2.002-.002 2.002-.002C9 8.333 9 6.665 9 6.665c0 .002-2.002.002-2.002.002C7 6.667 7 8.335 7 8.335Zm-2-1.67C5 5.745 5.898 5 6.998 5h2.004C10.106 5 11 5.749 11 6.665v1.67C11 9.255 10.102 10 9.002 10H6.998C5.894 10 5 9.251 5 8.335v-1.67Zm10 1.67c0-.002 2.002-.002 2.002-.002C17 8.333 17 6.665 17 6.665c0 .002-2.002.002-2.002.002.002 0 .002 1.668.002 1.668Zm-2-1.67C13 5.745 13.898 5 14.998 5h2.004C18.106 5 19 5.749 19 6.665v1.67c0 .92-.898 1.665-1.998 1.665h-2.004C13.894 10 13 9.251 13 8.335v-1.67Z",
        fill: "#fff"
    }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84c4cd6eff84dab8$export$2e2bcd8739ae039 = {
    SERVICE: {
        id: 'SERVICE',
        name: (0, $48KCt.default).service,
        color: (isDarkMode)=>isDarkMode ? '#8F7EE7' : '#6554C0',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.714 5a1.286 1.286 0 1 0 0 2.571 1.286 1.286 0 0 0 0-2.571Zm-3.143.327A3.287 3.287 0 0 1 21 6.286a3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.042h-1.72L9.738 12l2.828 4.714h1.72a1 1 0 0 1 .285.041 3.287 3.287 0 0 1 6.429.96 3.286 3.286 0 0 1-6.43.958 1 1 0 0 1-.284.041H12a1 1 0 0 1-.857-.485L8.005 13H4a1 1 0 0 1 0-2h4.005l3.137-5.229A1 1 0 0 1 12 5.286h2.286a1 1 0 0 1 .285.04Zm3.143 11.101a1.286 1.286 0 1 0 0 2.572 1.286 1.286 0 0 0 0-2.572Z",
                fill: "#fff"
            }))
    },
    LIBRARY: {
        id: 'LIBRARY',
        name: (0, $48KCt.default).library,
        color: (isDarkMode)=>isDarkMode ? '#F5CD47' : '#FF8B00',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.21667 5C5.80834 5 4.66667 6.14167 4.66667 7.55V11H4.05C3.4701 11 3 11.4701 3 12.05C3 12.6299 3.4701 13.1 4.05 13.1H4.66667V16.55C4.66667 17.9583 5.80834 19.1 7.21667 19.1H9.05C9.6299 19.1 10.1 18.6299 10.1 18.05C10.1 17.4701 9.6299 17 9.05 17H7.21667C6.96814 17 6.76667 16.7985 6.76667 16.55V12.05V7.55C6.76667 7.30147 6.96814 7.1 7.21667 7.1H9.05C9.6299 7.1 10.1 6.6299 10.1 6.05C10.1 5.4701 9.6299 5 9.05 5H7.21667ZM16.8833 19.1C18.2917 19.1 19.4333 17.9583 19.4333 16.55V13.1H20.05C20.6299 13.1 21.1 12.6299 21.1 12.05C21.1 11.4701 20.6299 11 20.05 11H19.4333V7.55C19.4333 6.14167 18.2917 5 16.8833 5L15.05 5C14.4701 5 14 5.4701 14 6.05C14 6.6299 14.4701 7.1 15.05 7.1L16.8833 7.1C17.1319 7.1 17.3333 7.30147 17.3333 7.55V12.05L17.3333 16.55C17.3333 16.7985 17.1319 17 16.8833 17H15.05C14.4701 17 14 17.4701 14 18.05C14 18.6299 14.4701 19.1 15.05 19.1H16.8833Z",
                fill: "#fff"
            }))
    },
    APPLICATION: {
        id: 'APPLICATION',
        name: (0, $48KCt.default).application,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#36B37E',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.57 3.105a1 1 0 0 1 .894.001l3.985 2A1 1 0 0 1 17 6v4.375l3.449 1.731A1 1 0 0 1 21 13v5a1 1 0 0 1-.553.895l-4.004 2a1 1 0 0 1-.894 0l-3.55-1.777-3.556 1.777a1 1 0 0 1-.894 0l-3.997-2A1 1 0 0 1 3 18v-5a1 1 0 0 1 .554-.895L7 10.389V6a1 1 0 0 1 .554-.895l4.016-2Zm-3.563 9.017L5 13.619v3.763l2.997 1.5 3.003-1.5V13.62l-2.993-1.498ZM13 13.619v3.763l2.996 1.5 3.004-1.5v-3.765l-2.986-1.499L13 13.619Zm2-3.237V6.617l-2.986-1.499L9 6.619v3.756l3 1.506 3-1.5Z",
                fill: "#fff"
            }))
    },
    CAPABILITY: {
        id: 'CAPABILITY',
        name: (0, $48KCt.default).capability,
        color: (isDarkMode)=>isDarkMode ? '#738496' : '#344563',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-4-inside-4_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "24",
                height: "24",
                rx: "3",
                fill: "#44546F"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.7048 6.76169C10.7048 7.47703 11.2847 8.05693 12 8.05693C12.7154 8.05693 13.2953 7.47703 13.2953 6.76169C13.2953 6.04635 12.7154 5.46646 12 5.46646C11.2847 5.46646 10.7048 6.04635 10.7048 6.76169ZM11.2 9.54498C10.9878 9.48411 10.7856 9.39963 10.5965 9.29457L9.2954 10.5975C9.52591 11.013 9.65718 11.4911 9.65718 12C9.65718 13.599 8.36093 14.8952 6.76194 14.8952C5.16294 14.8952 3.8667 13.599 3.8667 12C3.8667 10.401 5.16294 9.10474 6.76194 9.10474C7.27055 9.10474 7.74854 9.23589 8.16392 9.46622L9.46569 8.1626C9.23572 7.74747 9.1048 7.26987 9.1048 6.76169C9.1048 5.1627 10.401 3.86646 12 3.86646C13.599 3.86646 14.8953 5.1627 14.8953 6.76169C14.8953 7.27051 14.764 7.74867 14.5335 8.16417L15.8358 9.46641C16.2512 9.23596 16.7293 9.10474 17.2381 9.10474C18.8371 9.10474 20.1333 10.401 20.1333 12C20.1333 13.599 18.8371 14.8952 17.2381 14.8952C15.6391 14.8952 14.3429 13.599 14.3429 12C14.3429 11.4913 14.4741 11.0132 14.7044 10.5978L13.402 9.29543C13.2133 9.4001 13.0116 9.48429 12.8 9.545V14.455C14.0099 14.8021 14.8953 15.9168 14.8953 17.2383C14.8953 18.8373 13.599 20.1335 12 20.1335C10.401 20.1335 9.1048 18.8373 9.1048 17.2383C9.1048 15.9168 9.99013 14.8021 11.2 14.455V9.54498ZM11.9931 15.943C11.281 15.9467 10.7048 16.5252 10.7048 17.2383C10.7048 17.9536 11.2847 18.5335 12 18.5335C12.7154 18.5335 13.2953 17.9536 13.2953 17.2383C13.2953 16.5252 12.7191 15.9467 12.0069 15.943C12.0046 15.9431 12.0023 15.9431 12 15.9431C11.9977 15.9431 11.9954 15.9431 11.9931 15.943ZM5.4667 12C5.4667 12.7153 6.0466 13.2952 6.76194 13.2952C7.47728 13.2952 8.05718 12.7153 8.05718 12C8.05718 11.2846 7.47728 10.7047 6.76194 10.7047C6.0466 10.7047 5.4667 11.2846 5.4667 12ZM15.9429 12C15.9429 12.7153 16.5228 13.2952 17.2381 13.2952C17.9534 13.2952 18.5333 12.7153 18.5333 12C18.5333 11.2846 17.9534 10.7047 17.2381 10.7047C16.5228 10.7047 15.9429 11.2846 15.9429 12Z",
                fill: "white"
            }))
    },
    CLOUD_RESOURCE: {
        id: 'CLOUD_RESOURCE',
        name: (0, $48KCt.default).cloudResource,
        color: (isDarkMode)=>isDarkMode ? '#8F7EE7' : '#6554C0',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M6.07585 10.4798C4.70269 10.7573 3.66883 11.9708 3.66883 13.4258C3.66883 15.0857 4.83719 16.4314 6.49712 16.4314M16.6409 16.4314C18.9648 16.4314 20.5 14.5475 20.5 12.2236C20.5 9.89967 18.6161 8.01578 16.2922 8.01578C15.8909 8.01578 15.5027 8.07196 15.1351 8.17688M15.1399 8.18267C14.3348 6.65375 12.7302 5.61133 10.8822 5.61133C8.22631 5.61133 6.07329 7.76435 6.07329 10.4202V10.4803",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M14.1963 16.4036C14.1963 17.8203 13.0479 18.9688 11.6312 18.9688C10.2146 18.9688 9.06612 17.8203 9.06612 16.4036C9.06612 14.987 10.2146 13.8385 11.6312 13.8385C13.0479 13.8385 14.1963 14.987 14.1963 16.4036Z",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    DATA_PIPELINE: {
        id: 'DATA_PIPELINE',
        name: (0, $48KCt.default).dataPipeline,
        color: (isDarkMode)=>isDarkMode ? '#E2483D' : '#FF5630',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M5.42614 8.00584C6.57734 8.45806 7.87717 7.89141 8.32938 6.7402C8.78159 5.589 8.21495 4.28917 7.06374 3.83696C5.91254 3.38475 4.61271 3.95139 4.1605 5.1026C3.70828 6.2538 4.27493 7.55363 5.42614 8.00584Z",
                stroke: "#fff",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M16.9334 20.1997C18.0846 20.6519 19.3844 20.0853 19.8366 18.9341C20.2888 17.7828 19.7222 16.483 18.571 16.0308C17.4198 15.5786 16.12 16.1452 15.6677 17.2964C15.2155 18.4477 15.7822 19.7475 16.9334 20.1997Z",
                stroke: "#fff",
                strokeWidth: "1.7",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M6.24493 8.56055V11.0306C6.24493 11.5829 6.69264 12.0306 7.24493 12.0306H16.0659C16.6182 12.0306 17.0659 12.4784 17.0659 13.0306V15.2116",
                stroke: "#fff",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    MACHINE_LEARNING_MODEL: {
        id: 'MACHINE_LEARNING_MODEL',
        name: (0, $48KCt.default).machineLearningModel,
        color: (isDarkMode)=>isDarkMode ? '#E2483D' : '#FF5630',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M11.8555 3.01807L15.7255 5.31503L19.6497 7.51807L19.5955 12.0181L19.6497 16.5181L15.7255 18.7211L11.8555 21.0181L7.98547 18.7211L4.06124 16.5181L4.11547 12.0181L4.06124 7.51807L7.98547 5.31503L11.8555 3.01807Z",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinejoin: "round"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M4.61222 7.89078L18.8696 16.1906",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M4.85273 16.2901L19.0688 7.95921",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "none",
                d: "M11.7317 20.2989L11.7317 3.24756",
                stroke: "#fff",
                strokeWidth: "1.5"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fill: "#FF5630",
                d: "M10.7933 14.6374C12.1126 15.1556 13.6021 14.5062 14.1203 13.187C14.6385 11.8678 13.9892 10.3782 12.67 9.86003C11.3507 9.34181 9.86119 9.99116 9.34297 11.3104C8.82476 12.6296 9.47411 14.1192 10.7933 14.6374Z",
                stroke: "#fff",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }))
    },
    TEMPLATE: {
        id: 'TEMPLATE',
        name: (0, $48KCt.default).template,
        color: (isDarkMode)=>isDarkMode ? '#42B2D7' : '#00B8DA',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-1-outside-1_2331_289998",
                maskUnits: "userSpaceOnUse",
                x: "3",
                y: "2.99998",
                width: "18",
                height: "18",
                fill: "black"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                fill: "white",
                x: "3",
                y: "2.99998",
                width: "18",
                height: "18"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M14.464 11.4051L18.853 11.405C18.8862 11.405 18.9131 11.432 18.9131 11.4652L18.9131 13.5996C18.9131 13.6328 18.8862 13.6597 18.853 13.6597L14.464 13.6597C14.4307 13.6597 14.4038 13.6328 14.4038 13.5996L14.4038 11.4652C14.4038 11.432 14.4307 11.4051 14.464 11.4051Z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M8.74316 17.8442L8.74317 6.15577C8.74317 5.63419 8.74317 5.3734 8.5922 5.20279C8.57599 5.18447 8.55868 5.16716 8.54036 5.15096C8.36975 4.99998 8.10896 4.99998 7.58738 4.99998C7.0658 4.99999 6.80501 4.99999 6.63439 5.15096C6.61608 5.16717 6.59877 5.18448 6.58256 5.2028C6.43159 5.37341 6.43159 5.6342 6.43159 6.15578L6.43159 17.8442C6.43159 18.3658 6.43159 18.6266 6.58256 18.7972C6.59877 18.8155 6.61608 18.8328 6.6344 18.849C6.805 19 7.06579 19 7.58735 19C8.10894 19 8.36973 19 8.54035 18.849C8.55866 18.8328 8.57598 18.8155 8.59219 18.7972C8.74316 18.6266 8.74316 18.3658 8.74316 17.8442Z"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                d: "M9.89457 6.35349C9.4795 6.35349 9.14302 6.68998 9.14302 7.10505C9.14303 7.52012 9.47951 7.8566 9.89458 7.8566L9.89457 6.35349ZM16.0626 7.10502L16.0626 6.35347L16.0626 7.10502ZM16.8141 7.85657L16.0626 7.85657L16.0626 7.85657L16.8141 7.85657ZM16.0626 10.3539C16.0626 10.7689 16.399 11.1054 16.8141 11.1054C17.2292 11.1054 17.5657 10.7689 17.5657 10.3539L16.0626 10.3539ZM3.99996 6.4679C3.58489 6.46792 3.24843 6.80442 3.24845 7.21949C3.24847 7.63456 3.58497 7.97103 4.00004 7.97101L3.99996 6.4679ZM4.94361 7.97096C5.35868 7.97094 5.69515 7.63444 5.69513 7.21937C5.69511 6.80429 5.35861 6.46783 4.94354 6.46785L4.94361 7.97096ZM9.89458 7.8566L16.0626 7.85658L16.0626 6.35347L9.89457 6.35349L9.89458 7.8566ZM16.0626 7.85657L16.0626 10.3539L17.5657 10.3539L17.5657 7.85657L16.0626 7.85657ZM16.0626 7.85658L16.0626 7.85657L17.5657 7.85657C17.5657 7.02643 16.8927 6.35347 16.0626 6.35347L16.0626 7.85658ZM4.00004 7.97101L4.94361 7.97096L4.94354 6.46785L3.99996 6.4679L4.00004 7.97101ZM18.853 11.405L18.853 9.90194L18.853 11.405ZM14.464 11.4051L14.464 12.9082L14.464 11.4051ZM14.4038 11.4652L12.9007 11.4652L12.9007 11.4652L14.4038 11.4652ZM14.4038 13.5996L15.9069 13.5996L15.9069 13.5996L14.4038 13.5996ZM14.464 13.6597L14.464 15.1628L14.464 15.1628L14.464 13.6597ZM18.853 13.6597L18.853 12.1566L18.853 12.1566L18.853 13.6597ZM18.9131 13.5996L20.4163 13.5996L20.4163 13.5996L18.9131 13.5996ZM18.9131 11.4652L17.41 11.4652L17.41 11.4652L18.9131 11.4652ZM8.74317 6.15577L7.24006 6.15577L7.24006 6.15577L8.74317 6.15577ZM8.74316 17.8442L10.2463 17.8442L10.2463 17.8442L8.74316 17.8442ZM6.43159 17.8442L7.9347 17.8442L7.9347 17.8442L6.43159 17.8442ZM6.43159 6.15578L4.92848 6.15578L4.92848 6.15578L6.43159 6.15578ZM6.58256 5.2028L7.70823 6.19889L7.70825 6.19887L6.58256 5.2028ZM7.58738 4.99998L7.58738 6.50309L7.58738 4.99998ZM6.63439 5.15096L5.6383 4.02529L5.63829 4.0253L6.63439 5.15096ZM8.5922 5.20279L7.46651 6.19887L7.46653 6.19888L8.5922 5.20279ZM8.54036 5.15096L7.54427 6.27663L7.5443 6.27665L8.54036 5.15096ZM7.58735 19L7.58732 20.5031L7.58735 19ZM6.6344 18.849L5.6383 19.9747L5.6383 19.9747L6.6344 18.849ZM6.58256 18.7972L7.70824 17.8011L7.70824 17.8011L6.58256 18.7972ZM8.54035 18.849L9.53642 19.9747L9.53642 19.9747L8.54035 18.849ZM8.59219 18.7972L7.46652 17.8011L7.46652 17.8011L8.59219 18.7972ZM18.853 9.90194L14.4639 9.90195L14.464 12.9082L18.853 12.9081L18.853 9.90194ZM12.9007 11.4652L12.9007 13.5996L15.9069 13.5996L15.9069 11.4652L12.9007 11.4652ZM14.464 15.1628L18.853 15.1628L18.853 12.1566L14.4639 12.1566L14.464 15.1628ZM20.4163 13.5996L20.4163 11.4652L17.41 11.4652L17.41 13.5996L20.4163 13.5996ZM18.853 15.1628C19.7163 15.1628 20.4163 14.463 20.4163 13.5996L17.41 13.5996C17.41 12.8026 18.0561 12.1566 18.853 12.1566L18.853 15.1628ZM12.9007 13.5996C12.9007 14.4629 13.6006 15.1628 14.464 15.1628L14.4639 12.1566C15.2609 12.1566 15.9069 12.8027 15.9069 13.5996L12.9007 13.5996ZM14.4639 9.90195C13.6006 9.90196 12.9007 10.6018 12.9007 11.4652L15.9069 11.4652C15.9069 12.2621 15.2609 12.9082 14.464 12.9082L14.4639 9.90195ZM18.853 12.9081C18.0561 12.9082 17.41 12.2621 17.41 11.4652L20.4163 11.4652C20.4163 10.6018 19.7164 9.90193 18.853 9.90194L18.853 12.9081ZM7.24006 6.15577L7.24006 17.8442L10.2463 17.8442L10.2463 6.15577L7.24006 6.15577ZM7.9347 17.8442L7.93469 6.15578L4.92848 6.15578L4.92848 17.8442L7.9347 17.8442ZM7.93469 6.15578C7.93469 6.0202 7.93478 5.92531 7.93664 5.84611C7.93752 5.80852 7.93868 5.78111 7.9399 5.76104C7.94112 5.74089 7.94214 5.73268 7.94207 5.73321C7.942 5.73377 7.94027 5.74781 7.93493 5.77157C7.9295 5.79569 7.91973 5.83268 7.90261 5.8783C7.88522 5.92465 7.86087 5.97828 7.82715 6.0354C7.79317 6.09297 7.75326 6.148 7.70823 6.19889L5.45689 4.20671C5.09945 4.61065 4.99651 5.05936 4.95885 5.36214C4.92575 5.6282 4.92848 5.93394 4.92848 6.15578L7.93469 6.15578ZM7.58737 3.49688C7.36553 3.49688 7.05979 3.49415 6.79374 3.52725C6.49095 3.56491 6.04224 3.66785 5.6383 4.02529L7.63049 6.27663C7.5796 6.32166 7.52457 6.36157 7.467 6.39555C7.40988 6.42927 7.35625 6.45362 7.30991 6.47101C7.26428 6.48813 7.22729 6.4979 7.20318 6.50333C7.17941 6.50867 7.16537 6.5104 7.16481 6.51047C7.16428 6.51054 7.17249 6.50952 7.19265 6.5083C7.21272 6.50708 7.24013 6.50592 7.27772 6.50504C7.35691 6.50318 7.45181 6.50309 7.58738 6.50309L7.58737 3.49688ZM7.70825 6.19887C7.68392 6.22636 7.65795 6.25233 7.6305 6.27662L5.63829 4.0253C5.57421 4.08201 5.51362 4.1426 5.45688 4.20672L7.70825 6.19887ZM10.2463 6.15577C10.2463 5.93393 10.249 5.62819 10.2159 5.36214C10.1782 5.05935 10.0753 4.61064 9.71786 4.2067L7.46653 6.19888C7.42149 6.14799 7.38159 6.09296 7.3476 6.03539C7.31388 5.97827 7.28953 5.92464 7.27215 5.87829C7.25503 5.83267 7.24525 5.79568 7.23983 5.77156C7.23448 5.74779 7.23275 5.73375 7.23268 5.7332C7.23262 5.73267 7.23364 5.74088 7.23486 5.76103C7.23608 5.7811 7.23723 5.80851 7.23812 5.8461C7.23998 5.9253 7.24006 6.02019 7.24006 6.15577L10.2463 6.15577ZM7.58738 6.50309C7.72296 6.50309 7.81786 6.50318 7.89705 6.50504C7.93464 6.50592 7.96205 6.50708 7.98212 6.50829C8.00227 6.50952 8.01048 6.51053 8.00995 6.51047C8.0094 6.5104 7.99536 6.50867 7.97159 6.50332C7.94747 6.4979 7.91049 6.48812 7.86486 6.471C7.81852 6.45362 7.76489 6.42927 7.70776 6.39555C7.65019 6.36157 7.59516 6.32166 7.54427 6.27663L9.53645 4.02528C9.1325 3.66784 8.6838 3.5649 8.38101 3.52724C8.11495 3.49415 7.80921 3.49688 7.58737 3.49688L7.58738 6.50309ZM9.71788 4.20671C9.66115 4.1426 9.60055 4.08201 9.53643 4.02526L7.5443 6.27665C7.5168 6.25232 7.49083 6.22634 7.46651 6.19887L9.71788 4.20671ZM7.58738 17.4969C7.4518 17.4969 7.35691 17.4968 7.27772 17.4949C7.24013 17.494 7.21272 17.4929 7.19265 17.4917C7.1725 17.4904 7.16429 17.4894 7.16482 17.4895C7.16538 17.4896 7.17942 17.4913 7.20318 17.4966C7.2273 17.5021 7.26428 17.5118 7.30991 17.529C7.35625 17.5463 7.40988 17.5707 7.46701 17.6044C7.52458 17.6384 7.5796 17.6783 7.63049 17.7233L5.6383 19.9747C6.04224 20.3321 6.49093 20.435 6.79371 20.4727C7.05976 20.5058 7.36549 20.5031 7.58732 20.5031L7.58738 17.4969ZM4.92848 17.8442C4.92848 18.066 4.92576 18.3718 4.95885 18.6378C4.99651 18.9406 5.09944 19.3893 5.45687 19.7932L7.70824 17.8011C7.75327 17.852 7.79318 17.907 7.82716 17.9646C7.86088 18.0217 7.88523 18.0753 7.90261 18.1217C7.91973 18.1673 7.92951 18.2043 7.93493 18.2284C7.94027 18.2522 7.942 18.2662 7.94207 18.2668C7.94214 18.2673 7.94112 18.2591 7.9399 18.2389C7.93868 18.2189 7.93752 18.1915 7.93664 18.1539C7.93478 18.0747 7.9347 17.9798 7.9347 17.8442L4.92848 17.8442ZM7.63049 17.7233C7.65797 17.7477 7.68394 17.7736 7.70824 17.8011L5.45687 19.7932C5.51359 19.8573 5.57418 19.9179 5.6383 19.9747L7.63049 17.7233ZM7.58732 20.5031C7.80917 20.5031 8.11491 20.5058 8.38097 20.4727C8.68375 20.4351 9.13246 20.3322 9.53642 19.9747L7.54428 17.7233C7.59517 17.6783 7.65019 17.6384 7.70776 17.6044C7.76489 17.5707 7.81852 17.5464 7.86486 17.529C7.91049 17.5119 7.94748 17.5021 7.97159 17.4967C7.99536 17.4913 8.0094 17.4896 8.00996 17.4895C8.01048 17.4894 8.00227 17.4905 7.98212 17.4917C7.96205 17.4929 7.93464 17.4941 7.89705 17.4949C7.81785 17.4968 7.72296 17.4969 7.58738 17.4969L7.58732 20.5031ZM7.24006 17.8442C7.24006 17.9798 7.23997 18.0747 7.23811 18.1539C7.23723 18.1915 7.23607 18.2189 7.23485 18.2389C7.23363 18.2591 7.23261 18.2673 7.23268 18.2668C7.23275 18.2662 7.23448 18.2522 7.23982 18.2284C7.24525 18.2043 7.25502 18.1673 7.27214 18.1217C7.28953 18.0753 7.31388 18.0217 7.3476 17.9646C7.38158 17.907 7.42149 17.852 7.46652 17.8011L9.71786 19.7933C10.0753 19.3893 10.1782 18.9406 10.2159 18.6378C10.249 18.3718 10.2463 18.066 10.2463 17.8442L7.24006 17.8442ZM9.53642 19.9747C9.60052 19.918 9.66111 19.8574 9.71786 19.7933L7.46652 17.8011C7.49084 17.7736 7.51681 17.7476 7.54427 17.7233L9.53642 19.9747Z",
                fill: "white",
                mask: "url(#path-1-outside-1_2331_289998)"
            }))
    },
    UI_ELEMENT: {
        id: 'UI_ELEMENT',
        name: (0, $48KCt.default).uiElement,
        color: (isDarkMode)=>isDarkMode ? '#F5CD47' : '#FF8B00',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-1-inside-1_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "2.83353",
                y: "13.6489",
                width: "6.97358",
                height: "7.36887",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                fill: "none",
                x: "2.83353",
                y: "13.6489",
                width: "6.97358",
                height: "7.36887",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-1-inside-1_1403_23012)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-2-inside-2_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "2.83353",
                y: "3.01807",
                width: "18.5455",
                height: "8.59702",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                fill: "none",
                x: "2.83353",
                y: "3.01807",
                width: "18.5455",
                height: "8.59702",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-2-inside-2_1403_23012)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-3-inside-3_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                x: "11.5089",
                y: "13.6489",
                width: "9.87006",
                height: "7.36887",
                rx: "1"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                fill: "none",
                x: "11.5089",
                y: "13.6489",
                width: "9.87006",
                height: "7.36887",
                rx: "1",
                stroke: "#fff",
                strokeWidth: "3.2",
                mask: "url(#path-3-inside-3_1403_23012)"
            }))
    },
    WEBSITE: {
        id: 'WEBSITE',
        name: (0, $48KCt.default).website,
        color: (isDarkMode)=>isDarkMode ? '#2ABB7F' : '#36B37E',
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
                id: "path-5-inside-5_1403_23012",
                fill: "white"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
                width: "24",
                height: "24",
                rx: "3",
                fill: "#22A06B"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 18.375C12.8372 18.375 13.6662 18.2101 14.4396 17.8897C15.2131 17.5694 15.9158 17.0998 16.5078 16.5078C17.0998 15.9158 17.5694 15.2131 17.8897 14.4396C18.2101 13.6662 18.375 12.8372 18.375 12C18.375 11.1628 18.2101 10.3338 17.8897 9.56039C17.5694 8.78694 17.0998 8.08417 16.5078 7.49219C15.9158 6.90022 15.2131 6.43064 14.4396 6.11027C13.6662 5.78989 12.8372 5.625 12 5.625C10.3092 5.625 8.68774 6.29665 7.49219 7.49219C6.29665 8.68774 5.625 10.3092 5.625 12C5.625 13.6908 6.29665 15.3123 7.49219 16.5078C8.68774 17.7033 10.3092 18.375 12 18.375ZM11.3625 17.0554C10.1302 16.9017 8.99657 16.303 8.17476 15.372C7.35294 14.441 6.8996 13.2418 6.9 12C6.9 11.6047 6.951 11.2286 7.03387 10.8589L10.0875 13.9125V14.55C10.0875 15.2513 10.6613 15.825 11.3625 15.825V17.0554ZM15.7612 15.4361C15.6804 15.1785 15.5192 14.9535 15.3012 14.7941C15.0833 14.6346 14.82 14.5491 14.55 14.55H13.9125V12.6375C13.9125 12.2869 13.6256 12 13.275 12H9.45V10.725H10.725C11.0756 10.725 11.3625 10.4381 11.3625 10.0875V8.8125H12.6375C13.3387 8.8125 13.9125 8.23875 13.9125 7.5375V7.27612C15.7804 8.03475 17.1 9.86437 17.1 12C17.1 13.326 16.59 14.5309 15.7612 15.4361Z",
                fill: "white"
            }))
    },
    OTHER: {
        id: 'OTHER',
        name: (0, $48KCt.default).other,
        color: (isDarkMode)=>isDarkMode ? '#388BFF' : '#0065FF',
        icon: $84c4cd6eff84dab8$export$bace2d8ac2cf2caa
    }
};

});
parcelRegister("48KCt", function(module, exports) {

$parcel$export(module.exports, "default", () => $018f5be4afe81a2c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $018f5be4afe81a2c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    service: {
        "id": "compass-common.common.component-types-metadata.service",
        "defaultMessage": "Service"
    },
    library: {
        "id": "compass-common.common.component-types-metadata.library",
        "defaultMessage": "Library"
    },
    application: {
        "id": "compass-common.common.component-types-metadata.application",
        "defaultMessage": "Application"
    },
    other: {
        "id": "compass-common.common.component-types-metadata.other",
        "defaultMessage": "Other"
    },
    capability: {
        "id": "compass-common.common.component-types-metadata.capability",
        "defaultMessage": "Capability"
    },
    cloudResource: {
        "id": "compass-common.common.component-types-metadata.cloud-resource",
        "defaultMessage": "Cloud resource"
    },
    dataPipeline: {
        "id": "compass-common.common.component-types-metadata.data-pipeline",
        "defaultMessage": "Data pipeline"
    },
    machineLearningModel: {
        "id": "compass-common.common.component-types-metadata.machine-learning-model",
        "defaultMessage": "Machine learning model"
    },
    template: {
        "id": "compass-common.common.component-types-metadata.template",
        "defaultMessage": "Template"
    },
    uiElement: {
        "id": "compass-common.common.component-types-metadata.ui-element",
        "defaultMessage": "UI element"
    },
    website: {
        "id": "compass-common.common.component-types-metadata.website",
        "defaultMessage": "Website"
    }
});

});


parcelRegister("8r9gI", function(module, exports) {

$parcel$export(module.exports, "ComponentIconBackground", () => $991433c3de72aea3$export$2f11e092dd014dd4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $cAX3Z = parcelRequire("cAX3Z");

var $4q38b = parcelRequire("4q38b");

var $bSejN = parcelRequire("bSejN");
function $991433c3de72aea3$export$2f11e092dd014dd4(props) {
    const { type: type, size: size = 'medium', testId: testId, children: children } = props;
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const isDarkMode = colorMode === 'dark';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($991433c3de72aea3$var$IconBackground, {
        "data-testid": testId,
        size: size,
        color: (0, $bSejN.default)[type].color(isDarkMode)
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $991433c3de72aea3$var$IconBackground = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ke0o0q": (0, $9t7rW.default)((0, $cAX3Z.sizes)[__cmplp.size]),
            "--_xexnhp": (0, $9t7rW.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb4cet _4t3i4cet _bfhk1cj8 _2rko1l7b _1p3rwubq _f2puwubq _1lvewubq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("bXcTy", function(module, exports) {

$parcel$export(module.exports, "default", () => $88428245b92ff197$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $eYuBj = parcelRequire("eYuBj");

var $aRxnX = parcelRequire("aRxnX");
const $88428245b92ff197$var$messages = (0, $90IgZ.defineMessages)({
    noDependencies: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-dependencies",
        "defaultMessage": "No dependencies"
    },
    viewDependencies: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.view-dependencies",
        "defaultMessage": "View dependencies"
    }
});
function $88428245b92ff197$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, inwardRelationships: inwardRelationships, outwardRelationships: outwardRelationships } = props;
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (inwardRelationships.nodes.length === 0 && outwardRelationships.nodes.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYuBj.SubtleText), null, formatMessage($88428245b92ff197$var$messages.noDependencies));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aRxnX.default), {
                testId: "project-directories.components.compass-table.cells.dependencies.popup-wrapper",
                componentId: componentId,
                dependsOn: outwardRelationships,
                dependedOnBy: inwardRelationships
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "link",
                spacing: "none",
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewDependenciesButton');
                    setIsOpen(!isOpen);
                }
            }, formatMessage($88428245b92ff197$var$messages.viewDependencies))
    });
}

});
parcelRegister("eYuBj", function(module, exports) {

$parcel$export(module.exports, "SubtleText", () => $1ab03083aeab79ef$export$474d9b539a9b2a24);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $1ab03083aeab79ef$export$474d9b539a9b2a24 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1n3s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("aRxnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99824497bb9bdc1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hI5oG = parcelRequire("hI5oG");

var $8GAdb = parcelRequire("8GAdb");

var $4Bees = parcelRequire("4Bees");

var $7DokK = parcelRequire("7DokK");

var $fLiNF = parcelRequire("fLiNF");

var $ge5og = parcelRequire("ge5og");
function $e99824497bb9bdc1$export$2e2bcd8739ae039(props) {
    const { testId: testId, componentId: componentId, dependsOn: dependsOn, dependedOnBy: dependedOnBy } = props;
    const [teamNamesById, setTeamNamesById] = (0, $eUqFw.useState)({});
    const [teamsLoading, setTeamsLoading] = (0, $eUqFw.useState)(true);
    (0, $eUqFw.useEffect)(()=>{
        const uniqueOwnerIds = Array.from(new Set([
            ...dependsOn.nodes.flatMap((node)=>node.endNode.ownerId ? [
                    (0, $7DokK.getIdFromAri)(node.endNode.ownerId)
                ] : []),
            ...dependedOnBy.nodes.flatMap((node)=>node.startNode.ownerId ? [
                    (0, $7DokK.getIdFromAri)(node.startNode.ownerId)
                ] : [])
        ]));
        if (uniqueOwnerIds.length > 0) (0, $fLiNF.getTeams)(uniqueOwnerIds).then((teams)=>{
            setTeamNamesById(teams.teams.reduce((acc, curTeam)=>Object.assign(acc, {
                    [curTeam.id]: curTeam.displayName
                }), {}));
        }).catch(()=>setTeamNamesById({})).finally(()=>setTeamsLoading(false));
        else setTeamsLoading(false);
    }, [
        dependsOn,
        dependedOnBy
    ]);
    if (teamsLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$ContentWrapper, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$ContentWrapper, {
        "data-testid": testId
    }, dependsOn.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, "Depends on")), dependsOn.nodes.map((node, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ge5og.default), {
            key: idx,
            node: {
                ...node.endNode
            },
            ownerName: teamNamesById[(0, $7DokK.getIdFromAri)(node.endNode.ownerId ?? '')]
        })), dependsOn.pageInfo.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$ViewMoreLink, {
        componentId: componentId
    })), dependedOnBy.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200"
    }, "Depended on by")), dependedOnBy.nodes.map((node, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ge5og.default), {
            key: idx,
            node: {
                ...node.startNode
            },
            ownerName: teamNamesById[(0, $7DokK.getIdFromAri)(node.startNode.ownerId ?? '')]
        })), dependedOnBy.pageInfo.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$ViewMoreLink, {
        componentId: componentId
    })));
}
const $e99824497bb9bdc1$var$ViewMoreLink = ({ componentId: componentId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e99824497bb9bdc1$var$Link, {
        href: `/compass/component/${componentId}/dependencies`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, "View more ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8GAdb))), {
        label: "",
        size: "small"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e99824497bb9bdc1$var$Section = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $e99824497bb9bdc1$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrutpp _ngc0j3m3",
            __cmplp.className
        ])
    });
});
const $e99824497bb9bdc1$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbk5xz _4t3i1osq _1yt4pxbi",
            __cmplp.className
        ])
    });
});
const $e99824497bb9bdc1$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1ns9 _4cvr1h6o _24rc1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ge5og", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c6964fbbe41e57$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $64FeG = parcelRequire("64FeG");
var $bSejN = parcelRequire("bSejN");
var $7DokK = parcelRequire("7DokK");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $Z4s33 = parcelRequire("Z4s33");
function $59c6964fbbe41e57$var$isIconType(raw) {
    return raw in (0, $bSejN.default);
}
const $59c6964fbbe41e57$var$toComponentType = (raw)=>$59c6964fbbe41e57$var$isIconType(raw) ? raw : 'OTHER';
function $59c6964fbbe41e57$export$2e2bcd8739ae039(props) {
    const { node: node, ownerName: ownerName } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const componentId = (0, $eUqFw.useMemo)(()=>(0, $7DokK.getIdFromAri)(node.id), [
        node.id
    ]);
    const ownedBy = (0, $eUqFw.useMemo)(()=>{
        const componentNameComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59c6964fbbe41e57$var$iconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64FeG.ComponentTypeIcon), {
            type: $59c6964fbbe41e57$var$toComponentType(node.typeId),
            size: "small"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59c6964fbbe41e57$var$Text, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "none",
            href: `/compass/component/${componentId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyComponentLink');
            }
        }, node.name)), "\xa0");
        if ((ownerName?.length ?? 0) > 0) {
            const ownerId = (0, $7DokK.getIdFromAri)(node.ownerId ?? '');
            const teamNameComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                href: `/compass/people/team/${ownerId}`,
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'dependencyOwnerLink');
                }
            }, ownerName));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $Z4s33.default).ownedBy, {
                text: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59c6964fbbe41e57$var$Text, null, chunks),
                componentName: componentNameComponent,
                teamName: teamNameComponent
            }));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $Z4s33.default).noOwner, {
            text: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59c6964fbbe41e57$var$Text, null, chunks),
            componentName: componentNameComponent
        }));
    }, [
        node.ownerId,
        ownerName,
        componentId,
        node.name,
        node.typeId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59c6964fbbe41e57$var$Row, {
        "data-testid": "project-directories.components.compass-table.cells.dependencies.popup-content.depency-row.row"
    }, ownedBy);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59c6964fbbe41e57$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsbk5xz _4t3i1ylp _otyru2gc _2rko1l7b _11q71cs6",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $59c6964fbbe41e57$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1be1 _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $59c6964fbbe41e57$var$iconWrapper = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100'
});

});
parcelRegister("Z4s33", function(module, exports) {

$parcel$export(module.exports, "default", () => $709fa6d2ee034959$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $709fa6d2ee034959$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ownedBy: {
        "id": "project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.owner-new",
        "defaultMessage": "{componentName} <text>owned by</text> {teamName}"
    },
    noOwner: {
        "id": "project-directories.components.compass-table.cells.dependencies.popup-content.dependency-row.no-owner-new",
        "defaultMessage": "{componentName} <text>No owner</text>"
    }
});

});




parcelRegister("3nYaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a3598d9046ae30$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8g5hT = parcelRequire("8g5hT");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $eYuBj = parcelRequire("eYuBj");
const $b7a3598d9046ae30$var$messages = (0, $90IgZ.defineMessages)({
    noIssues: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-issues",
        "defaultMessage": "No issues"
    },
    issueCount: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.issue-count",
        "defaultMessage": "{issueCount, plural, one {# issue} other {# issues}}"
    }
});
function $b7a3598d9046ae30$export$2e2bcd8739ae039(props) {
    const { projectKey: projectKey, componentName: componentName, issueCount: issueCount } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const issuesUrl = (0, $eUqFw.useMemo)(()=>{
        const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND component = ${(0, $8g5hT.toQuotedString)(componentName)}`;
        return (0, $8g5hT.createIssuesUrl)(jql);
    }, [
        projectKey,
        componentName
    ]);
    return issueCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        "data-testid": "project-directories.components.compass-table.cells.issues.link",
        href: issuesUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage($b7a3598d9046ae30$var$messages.issueCount, {
        issueCount: issueCount
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYuBj.SubtleText), null, formatMessage($b7a3598d9046ae30$var$messages.noIssues));
}

});
parcelRegister("8g5hT", function(module, exports) {

$parcel$export(module.exports, "toQuotedString", () => $101afcc0c6282ae9$export$dbeab020a4aa404);
$parcel$export(module.exports, "createIssuesUrl", () => $101afcc0c6282ae9$export$c623a4b2d8c439ab);
const $101afcc0c6282ae9$var$ENCODE_MAP = {
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '"': '\\"',
    "'": "\\'",
    '\\': '\\\\'
};
const $101afcc0c6282ae9$export$946fe289c25510be = (character, ignoredCharacter)=>{
    if (character === ignoredCharacter) return character;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly '\t': "\\t"; readonly '\n': "\\n"; readonly '\r': "\\r"; readonly '"': "\\\""; readonly "'": "\\'"; readonly '\\': "\\\\"; }'.
    return $101afcc0c6282ae9$var$ENCODE_MAP[character] || character;
};
const $101afcc0c6282ae9$export$dbeab020a4aa404 = (parameter)=>{
    let escaped = '';
    for(let position = 0; position < parameter.length; position += 1)escaped += $101afcc0c6282ae9$export$946fe289c25510be(parameter[position], "'");
    return `"${escaped}"`;
};
const $101afcc0c6282ae9$export$c623a4b2d8c439ab = (jql)=>`/issues/?jql=${encodeURIComponent(jql)}`;

});


parcelRegister("2Ksba", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ebbd9089438132$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $eYuBj = parcelRequire("eYuBj");
const $38ebbd9089438132$var$messages = (0, $90IgZ.defineMessages)({
    noOwner: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-owner",
        "defaultMessage": "No owner"
    }
});
function $38ebbd9089438132$export$2e2bcd8739ae039(props) {
    const { ownerName: ownerName, ownerId: ownerId } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return ownerId && ownerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-directories.components.compass-table.cells.owner.link",
        appearance: "link",
        spacing: "none",
        href: `/compass/people/team/${ownerId}`,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'ownerLink');
        }
    }, ownerName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYuBj.SubtleText), null, formatMessage($38ebbd9089438132$var$messages.noOwner));
}

});

parcelRegister("lm3iN", function(module, exports) {

$parcel$export(module.exports, "RepositoryCell", () => $3242d389ef89bea9$export$b9085fe6b12a0b7b);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aml13 = parcelRequire("aml13");

var $hqABm = parcelRequire("hqABm");
var $4bEHq = parcelRequire("4bEHq");

var $2DGq0 = parcelRequire("2DGq0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eYuBj = parcelRequire("eYuBj");

var $gYb4e = parcelRequire("gYb4e");

var $4FVcq = parcelRequire("4FVcq");
const $3242d389ef89bea9$var$RE_BITBUCKET_REPOSITORY = /^https?:\/\/bitbucket\.org\//;
const $3242d389ef89bea9$export$ed662bf1621eb175 = 1;
function $3242d389ef89bea9$export$b9085fe6b12a0b7b({ repositoryLinks: repositoryLinks }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const bubbledRepositoryLinks = (0, $eUqFw.useMemo)(()=>$3242d389ef89bea9$export$37c5febb87944530(repositoryLinks), [
        repositoryLinks
    ]);
    if (bubbledRepositoryLinks.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYuBj.SubtleText), null, formatMessage((0, $gYb4e.default).noRepository));
    const displayedRepositoryLinks = bubbledRepositoryLinks.slice(0, $3242d389ef89bea9$export$ed662bf1621eb175);
    const remainingRepositoryLinks = bubbledRepositoryLinks.slice($3242d389ef89bea9$export$ed662bf1621eb175);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), null, displayedRepositoryLinks.map((link, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3242d389ef89bea9$var$LinkContainer, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2DGq0.CardSSR), {
            testId: "project-directories.components.compass-table.cells.repository.smart-link",
            url: link.url,
            appearance: "inline",
            placeholder: link.name || link.url,
            ui: {
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                clickableContainer: true
            },
            onClick: ()=>{
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'repositoryLink');
            },
            actionOptions: {
                hide: false,
                exclude: [
                    (0, $hqABm.CardAction).ChangeStatusAction
                ]
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
            text: link.name,
            maxLines: 1,
            hideIcon: true
        })), index === displayedRepositoryLinks.length - 1 && remainingRepositoryLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4FVcq.default), {
            repositories: remainingRepositoryLinks
        }))));
}
function $3242d389ef89bea9$export$af662343bda1b144(links) {
    return links.filter((link)=>link.type === 'REPOSITORY');
}
function $3242d389ef89bea9$export$37c5febb87944530(repositoryLinks, sort = true) {
    const bitbucketLinks = repositoryLinks.filter((link)=>$3242d389ef89bea9$var$RE_BITBUCKET_REPOSITORY.test(link.url));
    const remainingLinks = repositoryLinks.filter((link)=>!$3242d389ef89bea9$var$RE_BITBUCKET_REPOSITORY.test(link.url));
    if (sort) {
        const comparator = (a, b)=>{
            if (!!a.name && !b.name) return -1;
            if (!a.name && !!b.name) return 1;
            return (a.name || a.url).localeCompare(b.name || b.url);
        };
        bitbucketLinks.sort(comparator);
        remainingLinks.sort(comparator);
    }
    remainingLinks.unshift(...bitbucketLinks);
    return remainingLinks;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3242d389ef89bea9$var$LinkContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _1reo15vq _18m915vq _116e116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);

var $1l2Nv = parcelRequire("1l2Nv");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.fg)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($1l2Nv)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("1l2Nv", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $0f99ec2102c35890$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $0f99ec2102c35890$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $0f99ec2102c35890$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $0f99ec2102c35890$var$getValidCacheKeyFn(options);
        this._cacheMap = $0f99ec2102c35890$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $0f99ec2102c35890$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $0f99ec2102c35890$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$0f99ec2102c35890$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    } /**
   * The name given to this `DataLoader` instance. Useful for APM tools.
   *
   * Is `null` if not set in the constructor.
   */ ;
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $0f99ec2102c35890$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$0f99ec2102c35890$var$resolvedPromise) $0f99ec2102c35890$var$resolvedPromise = Promise.resolve();
    $0f99ec2102c35890$var$resolvedPromise.then(function() {
        $2fFJv.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $0f99ec2102c35890$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $0f99ec2102c35890$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $0f99ec2102c35890$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $0f99ec2102c35890$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $0f99ec2102c35890$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $0f99ec2102c35890$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$0f99ec2102c35890$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $0f99ec2102c35890$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        $0f99ec2102c35890$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $0f99ec2102c35890$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $0f99ec2102c35890$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $0f99ec2102c35890$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $0f99ec2102c35890$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $0f99ec2102c35890$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $0f99ec2102c35890$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $0f99ec2102c35890$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $0f99ec2102c35890$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $0f99ec2102c35890$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $0f99ec2102c35890$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $0f99ec2102c35890$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("hqABm", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $e9d011026964d0c2$export$f40b7e0b762b928b);
var $e9d011026964d0c2$export$f40b7e0b762b928b;
(function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
})($e9d011026964d0c2$export$f40b7e0b762b928b || ($e9d011026964d0c2$export$f40b7e0b762b928b = {}));

});

parcelRegister("4bEHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d96c71ded8e60f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");

var $caOA9 = parcelRequire("caOA9");

var $dKmeE = parcelRequire("dKmeE");

var $fTNaM = parcelRequire("fTNaM");

var $G9qxY = parcelRequire("G9qxY");

var $fNWSr = parcelRequire("fNWSr");

var $bampN = parcelRequire("bampN");
function $1d96c71ded8e60f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d96c71ded8e60f3$var$_ref = {
    name: "11eaz",
    styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
};
const $1d96c71ded8e60f3$var$getActionStyles = (showOnHover, isOpen)=>{
    if (showOnHover && !isOpen) return $1d96c71ded8e60f3$var$_ref;
};
const $1d96c71ded8e60f3$var$getTitleBlockViewComponent = (status)=>{
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Pending:
        case (0, $caOA9.SmartLinkStatus).Resolving:
            return 0, $G9qxY.default;
        case (0, $caOA9.SmartLinkStatus).Resolved:
            return 0, $dKmeE.default;
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).NotFound:
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return 0, $fTNaM.default;
    }
};
/**
 * Represents a TitleBlock, which is the foundation of Flexible UI.
 * This contains an icon, the link, and any associated metadata and actions in one block.
 * The TitleBlock will also render differently given the state of the smart link.
 * This can be found in the corresponding Resolving, Resolved and Errored views.
 * @public
 * @param {TitleBlockProps} TitleBlockProps
 * @see Block
 * @see TitleBlockResolvingView
 * @see TitleBlockResolvedView
 * @see TitleBlockErroredView
 */ const $1d96c71ded8e60f3$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, $caOA9.SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
    if (hideRetry && props.retry) delete props.retry;
    const [actionDropdownOpen, setActionDropdownOpen] = (0, $eUqFw.useState)(false);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        setActionDropdownOpen(isOpen);
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    const actionGroup = actions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        items: actions,
        visibleButtonsNum: showActionOnHover ? 1 : 2,
        onDropdownOpenChange: onDropdownOpenChange
    });
    const actionStyles = $1d96c71ded8e60f3$var$getActionStyles(showActionOnHover, actionDropdownOpen);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const combinedCss = /*#__PURE__*/ (0, $byn9U.css)(actionStyles, overrideCss);
    const overrideText = !!text ? {
        text: text
    } : {};
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Title), {
        hideTooltip: hideTitleTooltip,
        maxLines: maxLines,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: anchorTarget,
        theme: theme,
        ...overrideText
    });
    const Component = $1d96c71ded8e60f3$var$getTitleBlockViewComponent(status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ...props,
        actionGroup: actionGroup,
        overrideCss: combinedCss,
        testId: testId,
        title: title,
        metadataPosition: metadataPosition,
        hideIcon: hideIcon,
        icon: icon
    });
};
var $1d96c71ded8e60f3$export$2e2bcd8739ae039 = $1d96c71ded8e60f3$var$TitleBlock;

});
parcelRegister("8sbpW", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ae3e58c828553a00$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ae3e58c828553a00$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $lyAeo = parcelRequire("lyAeo");
var $ae3e58c828553a00$export$81a5b494baf0f17c;
(function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
})($ae3e58c828553a00$export$81a5b494baf0f17c || ($ae3e58c828553a00$export$81a5b494baf0f17c = {}));
const $ae3e58c828553a00$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ae3e58c828553a00$var$isNotLeftClick = (event)=>event.button !== 0;
const $ae3e58c828553a00$export$df67f318ded0283c = (onMouseDown)=>{
    return $ae3e58c828553a00$export$5993d3ca6c85f774(onMouseDown, $ae3e58c828553a00$var$isNotLeftClick);
};

});
parcelRegister("lyAeo", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $a830f7743a3fdab2$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $a830f7743a3fdab2$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $bTNMs = parcelRequire("bTNMs");

var $8sbpW = parcelRequire("8sbpW");
const $a830f7743a3fdab2$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $a830f7743a3fdab2$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $a830f7743a3fdab2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $a830f7743a3fdab2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($a830f7743a3fdab2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $a830f7743a3fdab2$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $a830f7743a3fdab2$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $a830f7743a3fdab2$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $a830f7743a3fdab2$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $a830f7743a3fdab2$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $a830f7743a3fdab2$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $a830f7743a3fdab2$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $a830f7743a3fdab2$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            }
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $a830f7743a3fdab2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $a830f7743a3fdab2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $8sbpW.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $8sbpW.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$a830f7743a3fdab2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});

parcelRegister("bTNMs", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a26d6e0cc0b2d68$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $0a26d6e0cc0b2d68$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $0a26d6e0cc0b2d68$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $0a26d6e0cc0b2d68$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $0a26d6e0cc0b2d68$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $0a26d6e0cc0b2d68$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $0a26d6e0cc0b2d68$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $0a26d6e0cc0b2d68$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $0a26d6e0cc0b2d68$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $0a26d6e0cc0b2d68$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $0a26d6e0cc0b2d68$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $0a26d6e0cc0b2d68$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $0a26d6e0cc0b2d68$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $0a26d6e0cc0b2d68$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $0a26d6e0cc0b2d68$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $0a26d6e0cc0b2d68$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $0a26d6e0cc0b2d68$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $0a26d6e0cc0b2d68$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $0a26d6e0cc0b2d68$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $0a26d6e0cc0b2d68$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $0a26d6e0cc0b2d68$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $0a26d6e0cc0b2d68$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $0a26d6e0cc0b2d68$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $0a26d6e0cc0b2d68$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $0a26d6e0cc0b2d68$export$a66dc699502b5d28);

var $hEsGF = parcelRequire("hEsGF");

var $cCvxR = parcelRequire("cCvxR");
const $0a26d6e0cc0b2d68$export$85183a312807388d = 'media';
const $0a26d6e0cc0b2d68$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $0a26d6e0cc0b2d68$export$72af824fa910c33e;
(function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
})($0a26d6e0cc0b2d68$export$72af824fa910c33e || ($0a26d6e0cc0b2d68$export$72af824fa910c33e = {}));
var $0a26d6e0cc0b2d68$export$c89e475f7f7174c2;
(function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
})($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 || ($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 = {}));
const $0a26d6e0cc0b2d68$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $0a26d6e0cc0b2d68$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $0a26d6e0cc0b2d68$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $0a26d6e0cc0b2d68$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $0a26d6e0cc0b2d68$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($0a26d6e0cc0b2d68$export$85183a312807388d);
};
const $0a26d6e0cc0b2d68$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error?.message,
                kind: error?.kind,
                type: error?.type
            } : undefined
        }
    });
const $0a26d6e0cc0b2d68$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure?.duration
        }
    };
};
const $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure?.duration,
            reason: reason
        }
    };
};
const $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $0a26d6e0cc0b2d68$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });

});
parcelRegister("hEsGF", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $c9b3a002aa9f3cfd$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $c9b3a002aa9f3cfd$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $c9b3a002aa9f3cfd$export$185802fd694ee1f5);
const $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable = $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable();
const $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $c9b3a002aa9f3cfd$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $c9b3a002aa9f3cfd$export$1a717feb4df1a945 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $c9b3a002aa9f3cfd$export$de42547d395c8271 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $c9b3a002aa9f3cfd$var$getMark = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $c9b3a002aa9f3cfd$export$185802fd694ee1f5 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measure = $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $c9b3a002aa9f3cfd$var$getMark(id, 'pending');
            const endMark = $c9b3a002aa9f3cfd$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});




parcelRegister("caOA9", function(module, exports) {

$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $0e147ae1cf3527e1$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $0e147ae1cf3527e1$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $0e147ae1cf3527e1$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $0e147ae1cf3527e1$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $0e147ae1cf3527e1$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $0e147ae1cf3527e1$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $0e147ae1cf3527e1$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $0e147ae1cf3527e1$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $0e147ae1cf3527e1$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $0e147ae1cf3527e1$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $0e147ae1cf3527e1$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $0e147ae1cf3527e1$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $0e147ae1cf3527e1$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $0e147ae1cf3527e1$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $0e147ae1cf3527e1$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $0e147ae1cf3527e1$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $0e147ae1cf3527e1$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $0e147ae1cf3527e1$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardDisplay", () => $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804);
const $0e147ae1cf3527e1$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $0e147ae1cf3527e1$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $0e147ae1cf3527e1$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $0e147ae1cf3527e1$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $0e147ae1cf3527e1$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $0e147ae1cf3527e1$export$8910bf86027fe6be;
(function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
})($0e147ae1cf3527e1$export$8910bf86027fe6be || ($0e147ae1cf3527e1$export$8910bf86027fe6be = {}));
var $0e147ae1cf3527e1$export$60831686b0574c86;
(function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
})($0e147ae1cf3527e1$export$60831686b0574c86 || ($0e147ae1cf3527e1$export$60831686b0574c86 = {}));
var $0e147ae1cf3527e1$export$d58e6377644d1dcf;
(function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
})($0e147ae1cf3527e1$export$d58e6377644d1dcf || ($0e147ae1cf3527e1$export$d58e6377644d1dcf = {}));
var $0e147ae1cf3527e1$export$51f13ced115cbdae;
(function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
})($0e147ae1cf3527e1$export$51f13ced115cbdae || ($0e147ae1cf3527e1$export$51f13ced115cbdae = {}));
var $0e147ae1cf3527e1$export$61cff06be26816f;
(function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
})($0e147ae1cf3527e1$export$61cff06be26816f || ($0e147ae1cf3527e1$export$61cff06be26816f = {}));
var $0e147ae1cf3527e1$export$aed0f1e801ad691f;
(function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
})($0e147ae1cf3527e1$export$aed0f1e801ad691f || ($0e147ae1cf3527e1$export$aed0f1e801ad691f = {}));
var $0e147ae1cf3527e1$export$9aafec380d7005da;
(function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
})($0e147ae1cf3527e1$export$9aafec380d7005da || ($0e147ae1cf3527e1$export$9aafec380d7005da = {}));
var $0e147ae1cf3527e1$export$19c60054ee783de6;
(function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
})($0e147ae1cf3527e1$export$19c60054ee783de6 || ($0e147ae1cf3527e1$export$19c60054ee783de6 = {}));
var $0e147ae1cf3527e1$export$d65b168331104a46;
(function(ElementName) {
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["Title"] = "Title";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
})($0e147ae1cf3527e1$export$d65b168331104a46 || ($0e147ae1cf3527e1$export$d65b168331104a46 = {}));
var $0e147ae1cf3527e1$export$9c95d6e1614bad84;
(function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-8954 Internal documentation for deprecation (no external access)}
	 */ ActionName["ViewAction"] = "ViewAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
})($0e147ae1cf3527e1$export$9c95d6e1614bad84 || ($0e147ae1cf3527e1$export$9c95d6e1614bad84 = {}));
var $0e147ae1cf3527e1$export$4871a84b35cf8eb9;
(function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
})($0e147ae1cf3527e1$export$4871a84b35cf8eb9 || ($0e147ae1cf3527e1$export$4871a84b35cf8eb9 = {}));
var $0e147ae1cf3527e1$export$13ff1290a9e22e77;
(function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
})($0e147ae1cf3527e1$export$13ff1290a9e22e77 || ($0e147ae1cf3527e1$export$13ff1290a9e22e77 = {}));
var $0e147ae1cf3527e1$export$483c11740a902fcd;
(function(MediaType) {
    MediaType["Image"] = "image";
})($0e147ae1cf3527e1$export$483c11740a902fcd || ($0e147ae1cf3527e1$export$483c11740a902fcd = {}));
var $0e147ae1cf3527e1$export$f9f4737e25ab90fa;
(function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
})($0e147ae1cf3527e1$export$f9f4737e25ab90fa || ($0e147ae1cf3527e1$export$f9f4737e25ab90fa = {}));
var $0e147ae1cf3527e1$export$6ca4ef8b3dc2c804;
(function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
})($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 || ($0e147ae1cf3527e1$export$6ca4ef8b3dc2c804 = {}));

});

parcelRegister("dKmeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd04caefc73a85e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
function $3bd04caefc73a85e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This renders a fully resolved TitleBlock.
 * This should render when a Smart Link returns a valid response.
 * @see TitleBlock
 */ var $3bd04caefc73a85e$var$_ref = {
    name: "v43pxc",
    styles: "gap:var(--ds-space-050, 0.25rem)"
};
const $3bd04caefc73a85e$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
    const metadataElements = (0, $d2BrZ.renderElementItems)(metadata);
    const subtitleElements = (0, $d2BrZ.renderElementItems)(subtitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        width: (0, $caOA9.SmartLinkWidth).Flexible,
        overrideCss: $3bd04caefc73a85e$var$_ref
    }, title, subtitleElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal
    }, subtitleElements)), metadataElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right,
        position: metadataPosition ?? (0, $caOA9.SmartLinkPosition).Center
    }, metadataElements), actionGroup);
};
var $3bd04caefc73a85e$export$2e2bcd8739ae039 = $3bd04caefc73a85e$var$TitleBlockResolvedView;

});
parcelRegister("bampN", function(module, exports) {

$parcel$export(module.exports, "AssignedTo", () => $706e9ad9ba761081$export$d3af56c23f9e459b);
$parcel$export(module.exports, "AssignedToGroup", () => $706e9ad9ba761081$export$fbd18f11bf3a3444);
$parcel$export(module.exports, "AttachmentCount", () => $706e9ad9ba761081$export$3bc3c9693a40aa);
$parcel$export(module.exports, "AuthorGroup", () => $706e9ad9ba761081$export$2ae2af4435dd6144);
$parcel$export(module.exports, "ChecklistProgress", () => $706e9ad9ba761081$export$5742b38fd5cfe410);
$parcel$export(module.exports, "CollaboratorGroup", () => $706e9ad9ba761081$export$a1e647014985ddb9);
$parcel$export(module.exports, "CommentCount", () => $706e9ad9ba761081$export$f4c1466e6fdd07b);
$parcel$export(module.exports, "CreatedOn", () => $706e9ad9ba761081$export$53ced9403d373871);
$parcel$export(module.exports, "CreatedBy", () => $706e9ad9ba761081$export$db468caedefbb630);
$parcel$export(module.exports, "DueOn", () => $706e9ad9ba761081$export$fea59459cfa1625b);
$parcel$export(module.exports, "LatestCommit", () => $706e9ad9ba761081$export$2aa8c58ab6c8ae64);
$parcel$export(module.exports, "LinkIcon", () => $706e9ad9ba761081$export$69387b41dfc808f7);
$parcel$export(module.exports, "Location", () => $706e9ad9ba761081$export$18a2be9195644f38);
$parcel$export(module.exports, "ModifiedBy", () => $706e9ad9ba761081$export$ebbbdcc68d717b7b);
$parcel$export(module.exports, "ModifiedOn", () => $706e9ad9ba761081$export$a6db3f4240728b58);
$parcel$export(module.exports, "OwnedBy", () => $706e9ad9ba761081$export$fa04b1f8d953704f);
$parcel$export(module.exports, "OwnedByGroup", () => $706e9ad9ba761081$export$90e81c873cca1e90);
$parcel$export(module.exports, "Priority", () => $706e9ad9ba761081$export$300334f671c43555);
$parcel$export(module.exports, "ProgrammingLanguage", () => $706e9ad9ba761081$export$7904b5485bf997ea);
$parcel$export(module.exports, "Provider", () => $706e9ad9ba761081$export$2881499e37b75b9a);
$parcel$export(module.exports, "ReactCount", () => $706e9ad9ba761081$export$f69df2decd5f729e);
$parcel$export(module.exports, "ReadTime", () => $706e9ad9ba761081$export$77dedcd16f070a20);
$parcel$export(module.exports, "SentOn", () => $706e9ad9ba761081$export$897b145a1ed39fe5);
$parcel$export(module.exports, "SourceBranch", () => $706e9ad9ba761081$export$387c3264a8f67d61);
$parcel$export(module.exports, "State", () => $706e9ad9ba761081$export$7254cc27399e90bd);
$parcel$export(module.exports, "SubscriberCount", () => $706e9ad9ba761081$export$cfafe90bba8a54db);
$parcel$export(module.exports, "SubTasksProgress", () => $706e9ad9ba761081$export$d441f34e4c8dd9e7);
$parcel$export(module.exports, "StoryPoints", () => $706e9ad9ba761081$export$634eef04d1a9a575);
$parcel$export(module.exports, "TargetBranch", () => $706e9ad9ba761081$export$b5e4199e062b8f44);
$parcel$export(module.exports, "Title", () => $706e9ad9ba761081$export$f99233281efd08a0);
$parcel$export(module.exports, "ViewCount", () => $706e9ad9ba761081$export$ae2d8be089b6cfe0);
$parcel$export(module.exports, "VoteCount", () => $706e9ad9ba761081$export$b080bef6ed7fa75a);
$parcel$export(module.exports, "Preview", () => (parcelRequire("2mW0Z")).default);
$parcel$export(module.exports, "Snippet", () => (parcelRequire("jtGWU")).default);

var $577Fl = parcelRequire("577Fl");

var $caOA9 = parcelRequire("caOA9");

var $2mW0Z = parcelRequire("2mW0Z");

var $jtGWU = parcelRequire("jtGWU");
const $706e9ad9ba761081$export$d3af56c23f9e459b = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedTo);
const $706e9ad9ba761081$export$fbd18f11bf3a3444 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AssignedToGroup);
const $706e9ad9ba761081$export$3bc3c9693a40aa = (0, $577Fl.createElement)((0, $caOA9.ElementName).AttachmentCount);
const $706e9ad9ba761081$export$2ae2af4435dd6144 = (0, $577Fl.createElement)((0, $caOA9.ElementName).AuthorGroup);
const $706e9ad9ba761081$export$5742b38fd5cfe410 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ChecklistProgress);
const $706e9ad9ba761081$export$a1e647014985ddb9 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CollaboratorGroup);
const $706e9ad9ba761081$export$f4c1466e6fdd07b = (0, $577Fl.createElement)((0, $caOA9.ElementName).CommentCount);
const $706e9ad9ba761081$export$53ced9403d373871 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedOn);
const $706e9ad9ba761081$export$db468caedefbb630 = (0, $577Fl.createElement)((0, $caOA9.ElementName).CreatedBy);
const $706e9ad9ba761081$export$fea59459cfa1625b = (0, $577Fl.createElement)((0, $caOA9.ElementName).DueOn);
const $706e9ad9ba761081$export$2aa8c58ab6c8ae64 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LatestCommit);
const $706e9ad9ba761081$export$69387b41dfc808f7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).LinkIcon);
const $706e9ad9ba761081$export$18a2be9195644f38 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Location);
const $706e9ad9ba761081$export$ebbbdcc68d717b7b = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedBy);
const $706e9ad9ba761081$export$a6db3f4240728b58 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ModifiedOn);
const $706e9ad9ba761081$export$fa04b1f8d953704f = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedBy);
const $706e9ad9ba761081$export$90e81c873cca1e90 = (0, $577Fl.createElement)((0, $caOA9.ElementName).OwnedByGroup);
const $706e9ad9ba761081$export$300334f671c43555 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Priority);
const $706e9ad9ba761081$export$7904b5485bf997ea = (0, $577Fl.createElement)((0, $caOA9.ElementName).ProgrammingLanguage);
const $706e9ad9ba761081$export$2881499e37b75b9a = (0, $577Fl.createElement)((0, $caOA9.ElementName).Provider);
const $706e9ad9ba761081$export$f69df2decd5f729e = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReactCount);
const $706e9ad9ba761081$export$77dedcd16f070a20 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ReadTime);
const $706e9ad9ba761081$export$897b145a1ed39fe5 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SentOn);
const $706e9ad9ba761081$export$387c3264a8f67d61 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SourceBranch);
const $706e9ad9ba761081$export$7254cc27399e90bd = (0, $577Fl.createElement)((0, $caOA9.ElementName).State);
const $706e9ad9ba761081$export$cfafe90bba8a54db = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubscriberCount);
const $706e9ad9ba761081$export$d441f34e4c8dd9e7 = (0, $577Fl.createElement)((0, $caOA9.ElementName).SubTasksProgress);
const $706e9ad9ba761081$export$634eef04d1a9a575 = (0, $577Fl.createElement)((0, $caOA9.ElementName).StoryPoints);
const $706e9ad9ba761081$export$b5e4199e062b8f44 = (0, $577Fl.createElement)((0, $caOA9.ElementName).TargetBranch);
const $706e9ad9ba761081$export$f99233281efd08a0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).Title);
const $706e9ad9ba761081$export$ae2d8be089b6cfe0 = (0, $577Fl.createElement)((0, $caOA9.ElementName).ViewCount);
const $706e9ad9ba761081$export$b080bef6ed7fa75a = (0, $577Fl.createElement)((0, $caOA9.ElementName).VoteCount);

});
parcelRegister("577Fl", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $d123e4d2e9f5aa27$export$c8a8987d4410bf2d);

var $eUqFw = parcelRequire("eUqFw");

var $90IgZ = parcelRequire("90IgZ");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $kIJ39 = parcelRequire("kIJ39");

var $4AAjx = parcelRequire("4AAjx");

var $ecYnC = parcelRequire("ecYnC");

var $1aEBl = parcelRequire("1aEBl");

var $2aeJ6 = parcelRequire("2aeJ6");

var $gsehw = parcelRequire("gsehw");

var $4abrz = parcelRequire("4abrz");

var $iAt1y = parcelRequire("iAt1y");

var $8UE2N = parcelRequire("8UE2N");
const $d123e4d2e9f5aa27$var$elementMappings = {
    [(0, $caOA9.ElementName).AttachmentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Attachment
        }
    },
    [(0, $caOA9.ElementName).AuthorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).ChecklistProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).CheckItem
        }
    },
    [(0, $caOA9.ElementName).CollaboratorGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CommentCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Comment
        }
    },
    [(0, $caOA9.ElementName).ViewCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).View
        }
    },
    [(0, $caOA9.ElementName).ReactCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).React
        }
    },
    [(0, $caOA9.ElementName).VoteCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Vote
        }
    },
    [(0, $caOA9.ElementName).CreatedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).OwnedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedTo]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).AssignedToGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).OwnedByGroup]: {
        component: (0, $1aEBl.default)
    },
    [(0, $caOA9.ElementName).CreatedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).DueOn]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).LatestCommit]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Commit
        }
    },
    [(0, $caOA9.ElementName).LinkIcon]: {
        component: (0, $c2pJy.default)
    },
    [(0, $caOA9.ElementName).ModifiedBy]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).ModifiedOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).Preview]: {
        component: (0, $2aeJ6.default)
    },
    [(0, $caOA9.ElementName).Priority]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ProgrammingLanguage]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).ProgrammingLanguage
        }
    },
    [(0, $caOA9.ElementName).Provider]: {
        component: (0, $ecYnC.default)
    },
    [(0, $caOA9.ElementName).ReadTime]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).SentOn]: {
        component: (0, $iAt1y.default)
    },
    [(0, $caOA9.ElementName).SourceBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).State]: {
        component: (0, $kIJ39.default)
    },
    [(0, $caOA9.ElementName).SubscriberCount]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).Subscriber
        }
    },
    [(0, $caOA9.ElementName).SubTasksProgress]: {
        component: (0, $ecYnC.default),
        props: {
            icon: (0, $caOA9.IconType).SubTasksProgress
        }
    },
    [(0, $caOA9.ElementName).StoryPoints]: {
        component: (0, $8UE2N.default)
    },
    [(0, $caOA9.ElementName).TargetBranch]: {
        component: (0, $gsehw.default)
    },
    [(0, $caOA9.ElementName).Title]: {
        component: (0, $39rqs.default)
    },
    [(0, $caOA9.ElementName).Location]: {
        component: (0, $39rqs.default),
        props: {
            theme: (0, $caOA9.SmartLinkInternalTheme).Grey
        }
    }
};
const $d123e4d2e9f5aa27$var$getContextKey = (name)=>{
    // Attempt to predict context prop name in advance to reduce the amount of
    // code run during runtime
    return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
};
const $d123e4d2e9f5aa27$var$getData = (elementName, contextKey, context)=>{
    if (!context) return undefined;
    const data = context[contextKey];
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
        case (0, $caOA9.ElementName).AuthorGroup:
        case (0, $caOA9.ElementName).CollaboratorGroup:
        case (0, $caOA9.ElementName).OwnedByGroup:
            const AvatarGroupsWithFallback = [
                (0, $caOA9.ElementName).AssignedToGroup
            ];
            const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
            return $d123e4d2e9f5aa27$var$toAvatarGroupProps(data, showFallbackAvatar);
        case (0, $caOA9.ElementName).AttachmentCount:
        case (0, $caOA9.ElementName).ChecklistProgress:
        case (0, $caOA9.ElementName).CommentCount:
        case (0, $caOA9.ElementName).ViewCount:
        case (0, $caOA9.ElementName).ReactCount:
        case (0, $caOA9.ElementName).VoteCount:
        case (0, $caOA9.ElementName).ProgrammingLanguage:
        case (0, $caOA9.ElementName).SubscriberCount:
        case (0, $caOA9.ElementName).LatestCommit:
        case (0, $caOA9.ElementName).SubTasksProgress:
            return $d123e4d2e9f5aa27$var$toBadgeProps(data);
        case (0, $caOA9.ElementName).StoryPoints:
            return $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps(data);
        case (0, $caOA9.ElementName).CreatedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).created_by, context.createdBy);
        case (0, $caOA9.ElementName).AssignedTo:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).assigned_to, context.assignedTo);
        case (0, $caOA9.ElementName).OwnedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).owned_by, context.ownedBy);
        case (0, $caOA9.ElementName).CreatedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('created', context.createdOn);
        case (0, $caOA9.ElementName).DueOn:
            return $d123e4d2e9f5aa27$var$toDateLozengeProps(context.dueOn);
        case (0, $caOA9.ElementName).ModifiedBy:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).modified_by, context.modifiedBy);
        case (0, $caOA9.ElementName).ModifiedOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('modified', context.modifiedOn);
        case (0, $caOA9.ElementName).SentOn:
            return $d123e4d2e9f5aa27$var$toDateTimeProps('sent', context.sentOn);
        case (0, $caOA9.ElementName).ReadTime:
            return $d123e4d2e9f5aa27$var$toFormattedTextProps((0, $4abrz.messages).read_time, data);
        case (0, $caOA9.ElementName).SourceBranch:
        case (0, $caOA9.ElementName).TargetBranch:
            return $d123e4d2e9f5aa27$var$toTextProps(data);
        case (0, $caOA9.ElementName).Title:
            return $d123e4d2e9f5aa27$var$toLinkProps(context.title, context.url);
        default:
            return typeof data === 'object' ? data : undefined;
    }
};
const $d123e4d2e9f5aa27$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
    return items ? {
        items: items
    } : showFallbackAvatar ? {
        items: []
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toBadgeProps = (label)=>{
    return label ? {
        label: label
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toAtlaskitBadgeProps = (value)=>{
    return value ? {
        value: value
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toDateLozengeProps = (dateString)=>{
    if (dateString) {
        const text = Date.parse(dateString) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $90IgZ.FormattedDate), {
            value: new Date(dateString),
            year: "numeric",
            month: "short",
            day: "numeric",
            formatMatcher: "best fit"
        }) : dateString;
        return {
            text: text
        };
    }
};
const $d123e4d2e9f5aa27$var$toDateTimeProps = (type, dateString)=>{
    return dateString ? {
        date: new Date(dateString),
        type: type
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toFormattedTextProps = (descriptor, context)=>{
    return context ? {
        message: {
            descriptor: descriptor,
            values: {
                context: context
            }
        }
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toLinkProps = (text, url)=>{
    return text ? {
        text: text,
        url: url
    } : undefined;
};
const $d123e4d2e9f5aa27$var$toTextProps = (content)=>{
    return content ? {
        content: content
    } : undefined;
};
const $d123e4d2e9f5aa27$export$c8a8987d4410bf2d = (name)=>{
    const { component: BaseElement, props: props } = $d123e4d2e9f5aa27$var$elementMappings[name] || {};
    const contextKey = $d123e4d2e9f5aa27$var$getContextKey(name);
    if (!BaseElement) throw Error(`Element ${name} does not exist.`);
    return (overrides)=>{
        const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
        const data = $d123e4d2e9f5aa27$var$getData(name, contextKey, context);
        return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BaseElement, {
            ...props,
            ...data,
            ...overrides,
            name: name
        }) : null;
    };
};

});
parcelRegister("c2pJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d34755e025af7a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $fBftA = parcelRequire("fBftA");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $h0YJD = parcelRequire("h0YJD");

var $2pE6J = parcelRequire("2pE6J");

var $4z862 = parcelRequire("4z862");
function $13d34755e025af7a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $13d34755e025af7a$var$_ref = {
    name: "1xpq7g4",
    styles: "align-self:flex-start;margin:0"
};
var $13d34755e025af7a$var$_ref2 = {
    name: "qbt5ty",
    styles: "align-self:center"
};
const $13d34755e025af7a$var$getPositionStyles = (position)=>{
    switch(position){
        case (0, $caOA9.SmartLinkPosition).Center:
            return $13d34755e025af7a$var$_ref2;
        case (0, $caOA9.SmartLinkPosition).Top:
        default:
            return $13d34755e025af7a$var$_ref;
    }
};
const $13d34755e025af7a$var$getIconStyles = (position, width)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)($13d34755e025af7a$var$getPositionStyles(position), (0, $4z862.getIconSizeStyles)(width));
const $13d34755e025af7a$var$getCustomRenderStyles = (value)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $4z862.getTruncateStyles)(1, value), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: value,
        textAlign: 'center',
        textOverflow: 'clip',
        WebkitBoxOrient: 'unset',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            margin: 0,
            padding: 0,
            verticalAlign: 'baseline'
        }
    });
const $13d34755e025af7a$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        testId: `${testId}-icon`
    });
};
const $13d34755e025af7a$var$renderDefaultIcon = (label, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
        label: label,
        testId: `${testId}-default`,
        color: "currentColor"
    });
const $13d34755e025af7a$var$renderImageIcon = (defaultIcon, url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        defaultIcon: defaultIcon,
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays an Icon or favicon.
 * @internal
 * @param {IconProps} IconProps - The props necessary for the Icon element.
 * @see LinkIcon
 */ const $13d34755e025af7a$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, $caOA9.SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
    const element = (0, $eUqFw.useMemo)(()=>{
        const defaultIcon = $13d34755e025af7a$var$renderDefaultIcon(label, testId);
        return overrideIcon || render?.() || $13d34755e025af7a$var$renderImageIcon(defaultIcon, url, testId) || $13d34755e025af7a$var$renderAtlaskitIcon(icon, testId) || defaultIcon;
    }, [
        overrideIcon,
        icon,
        label,
        render,
        testId,
        url
    ]);
    const width = (0, $4z862.getIconWidth)(size);
    const styles = $13d34755e025af7a$var$getIconStyles(position, width);
    const renderStyles = render ? $13d34755e025af7a$var$getCustomRenderStyles(width) : undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
        css: [
            styles,
            renderStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-icon": true,
        "data-testid": testId
    }, element);
};
var $13d34755e025af7a$export$2e2bcd8739ae039 = $13d34755e025af7a$var$Icon;

});
parcelRegister("fBftA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70f2b78564f0b7c3236457f67879324e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5b650fc75d7cc02$var$_react = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b5b650fc75d7cc02$var$_link = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("h0HFa")));

var $b5b650fc75d7cc02$var$_link2 = $b5b650fc75d7cc02$var$_interopRequireDefault((parcelRequire("hUwRB")));
function $b5b650fc75d7cc02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5b650fc75d7cc02$var$LinkIcon = (props)=>/*#__PURE__*/ $b5b650fc75d7cc02$var$_react.default.createElement($b5b650fc75d7cc02$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $b5b650fc75d7cc02$var$_link2.default
    }, props));
$b5b650fc75d7cc02$var$LinkIcon.Name = 'LinkIconMigration';
var $b5b650fc75d7cc02$var$_default = module.exports.default = $b5b650fc75d7cc02$var$LinkIcon;

});
parcelRegister("h0HFa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7939ee5038402c5f027adffad929d2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6244e4cd9ddde64$var$_react = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c6244e4cd9ddde64$var$_UNSAFE_baseNew = $c6244e4cd9ddde64$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c6244e4cd9ddde64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6244e4cd9ddde64$var$LinkIcon = (props)=>/*#__PURE__*/ $c6244e4cd9ddde64$var$_react.default.createElement($c6244e4cd9ddde64$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
    }, props));
$c6244e4cd9ddde64$var$LinkIcon.displayName = 'LinkIcon';
var $c6244e4cd9ddde64$var$_default = module.exports.default = $c6244e4cd9ddde64$var$LinkIcon;

});

parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d0a128a0d80d703a$var$_link = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("h0HFa")));
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $d0a128a0d80d703a$var$_link.default
    }));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = module.exports.default = $d0a128a0d80d703a$var$LinkIcon;

});


parcelRegister("h0YJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc7df94b43718706$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");


var $5KT10 = parcelRequire("5KT10");
var $77CtJ = parcelRequire("77CtJ");

var $33pqc = parcelRequire("33pqc");

var $42mVw = parcelRequire("42mVw");

var $caOA9 = parcelRequire("caOA9");





























































// prettier-ignore
const $bc7df94b43718706$var$importIconMapper = {
    [(0, $caOA9.IconType).Archive]: ()=>(parcelRequire("hhmAa")),
    [(0, $caOA9.IconType).Audio]: ()=>(parcelRequire("04uCN")),
    [(0, $caOA9.IconType).Code]: ()=>(parcelRequire("5XXvD")),
    [(0, $caOA9.IconType).Executable]: ()=>(parcelRequire("az87C")),
    [(0, $caOA9.IconType).File]: ()=>Promise.resolve((parcelRequire("hC3Rz"))),
    [(0, $caOA9.IconType).Folder]: ()=>(parcelRequire("IR5Zr")),
    [(0, $caOA9.IconType).Generic]: ()=>Promise.resolve((parcelRequire("hC3Rz"))),
    [(0, $caOA9.IconType).GIF]: ()=>(parcelRequire("a0cSu")),
    [(0, $caOA9.IconType).GoogleDocs]: ()=>(parcelRequire("2Zwb9")),
    [(0, $caOA9.IconType).GoogleForms]: ()=>(parcelRequire("14hrM")),
    [(0, $caOA9.IconType).GoogleSheets]: ()=>(parcelRequire("kENAJ")),
    [(0, $caOA9.IconType).GoogleSlides]: ()=>(parcelRequire("hMCpa")),
    [(0, $caOA9.IconType).Image]: ()=>(parcelRequire("bvjMQ")),
    [(0, $caOA9.IconType).MSExcel]: ()=>(parcelRequire("dsRgj")),
    [(0, $caOA9.IconType).MSPowerpoint]: ()=>(parcelRequire("4xnuT")),
    [(0, $caOA9.IconType).MSWord]: ()=>(parcelRequire("9pS0E")),
    [(0, $caOA9.IconType).PDF]: ()=>(parcelRequire("iqKJJ")),
    [(0, $caOA9.IconType).Presentation]: ()=>Promise.resolve((parcelRequire("iIEQk"))),
    [(0, $caOA9.IconType).Sketch]: ()=>(parcelRequire("eyLKt")),
    [(0, $caOA9.IconType).Spreadsheet]: ()=>Promise.resolve((parcelRequire("kaVAc"))),
    [(0, $caOA9.IconType).Template]: ()=>Promise.resolve((parcelRequire("nzdI3"))),
    [(0, $caOA9.IconType).Video]: ()=>(parcelRequire("bXPYz")),
    // Bitbucket icons
    [(0, $caOA9.IconType).Branch]: ()=>Promise.resolve((parcelRequire("gQa4O"))),
    [(0, $caOA9.IconType).Commit]: ()=>Promise.resolve((parcelRequire("fU2qj"))),
    [(0, $caOA9.IconType).Project]: ()=>Promise.resolve((parcelRequire("iwsIy"))),
    [(0, $caOA9.IconType).PullRequest]: ()=>Promise.resolve((parcelRequire("6VQ7Z"))),
    [(0, $caOA9.IconType).Repo]: ()=>Promise.resolve((parcelRequire("egbU6"))),
    // Jira icons
    [(0, $caOA9.IconType).Bug]: ()=>Promise.resolve((parcelRequire("3YEb9"))),
    [(0, $caOA9.IconType).Change]: ()=>Promise.resolve((parcelRequire("fsJVW"))),
    [(0, $caOA9.IconType).Epic]: ()=>Promise.resolve((parcelRequire("gFrvj"))),
    [(0, $caOA9.IconType).Incident]: ()=>Promise.resolve((parcelRequire("bJZ7m"))),
    [(0, $caOA9.IconType).Problem]: ()=>Promise.resolve((parcelRequire("5cywL"))),
    [(0, $caOA9.IconType).ServiceRequest]: ()=>Promise.resolve((parcelRequire("2NYtj"))),
    [(0, $caOA9.IconType).Story]: ()=>Promise.resolve((parcelRequire("3Fcny"))),
    [(0, $caOA9.IconType).SubTask]: ()=>Promise.resolve((parcelRequire("aJNc8"))),
    [(0, $caOA9.IconType).Task]: ()=>Promise.resolve((parcelRequire("hiUvC"))),
    // Provider icons
    [(0, $caOA9.IconType).Confluence]: ()=>Promise.resolve((parcelRequire("5KT10"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                default: ConfluenceIcon
            })),
    [(0, $caOA9.IconType).Jira]: ()=>Promise.resolve((parcelRequire("77CtJ"))).then(({ JiraIcon: JiraIcon })=>({
                default: JiraIcon
            })),
    // Fallback icons
    [(0, $caOA9.IconType).Default]: ()=>Promise.resolve((parcelRequire("hUwRB"))),
    [(0, $caOA9.IconType).Error]: ()=>Promise.resolve((parcelRequire("96IgR"))),
    [(0, $caOA9.IconType).Forbidden]: ()=>Promise.resolve((parcelRequire("f4A0J"))),
    // Badge
    [(0, $caOA9.IconType).Attachment]: ()=>Promise.resolve((parcelRequire("jUThT"))),
    [(0, $caOA9.IconType).CheckItem]: ()=>(parcelRequire("0zYUH")),
    [(0, $caOA9.IconType).Comment]: ()=>Promise.resolve((parcelRequire("d3vNK"))),
    [(0, $caOA9.IconType).View]: ()=>(parcelRequire("aonoe")),
    [(0, $caOA9.IconType).React]: ()=>(parcelRequire("4J3iF")),
    [(0, $caOA9.IconType).Vote]: ()=>(parcelRequire("3sCdr")),
    [(0, $caOA9.IconType).PriorityBlocker]: ()=>(parcelRequire("6SGL9")),
    [(0, $caOA9.IconType).PriorityCritical]: ()=>(parcelRequire("eXGDS")),
    [(0, $caOA9.IconType).PriorityHigh]: ()=>(parcelRequire("hgVzO")),
    [(0, $caOA9.IconType).PriorityHighest]: ()=>(parcelRequire("mLn3Q")),
    [(0, $caOA9.IconType).PriorityLow]: ()=>(parcelRequire("cLsbI")),
    [(0, $caOA9.IconType).PriorityLowest]: ()=>(parcelRequire("1qbPt")),
    [(0, $caOA9.IconType).PriorityMajor]: ()=>(parcelRequire("5sbHU")),
    [(0, $caOA9.IconType).PriorityMedium]: ()=>(parcelRequire("gLmUj")),
    [(0, $caOA9.IconType).PriorityMinor]: ()=>(parcelRequire("jFzry")),
    [(0, $caOA9.IconType).PriorityTrivial]: ()=>(parcelRequire("hIhZX")),
    [(0, $caOA9.IconType).PriorityUndefined]: ()=>(parcelRequire("hdkC1")),
    [(0, $caOA9.IconType).ProgrammingLanguage]: ()=>Promise.resolve((parcelRequire("2Q5Ee"))),
    [(0, $caOA9.IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("4nce6"))),
    [(0, $caOA9.IconType).SubTasksProgress]: ()=>(parcelRequire("bIh7y"))
};
const $bc7df94b43718706$var$getIconImportFn = (icon)=>$bc7df94b43718706$var$importIconMapper[icon];
const $bc7df94b43718706$var$importIcon = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $bc7df94b43718706$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
    // Check for synchonously loaded icons first for SSR purposes
    switch(icon){
        case (0, $caOA9.IconType).Document:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: label || 'document',
                testId: testId
            });
        case (0, $caOA9.IconType).Blog:
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: label || 'blog',
                testId: testId
            });
    }
    const importFn = $bc7df94b43718706$var$getIconImportFn(icon);
    if (!importFn) return null;
    const ImportedIcon = $bc7df94b43718706$var$importIcon(importFn);
    switch(icon){
        case (0, $caOA9.IconType).Confluence:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Jira:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                appearance: "brand",
                testId: testId
            });
        case (0, $caOA9.IconType).Error:
        case (0, $caOA9.IconType).Forbidden:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId,
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
                label: label,
                testId: testId
            });
    }
};
var $bc7df94b43718706$export$2e2bcd8739ae039 = $bc7df94b43718706$var$AtlaskitIcon;

});
parcelRegister("5KT10", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $bd2fb8be68c26b84$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $bd2fb8be68c26b84$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $bd2fb8be68c26b84$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $bd2fb8be68c26b84$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("33pqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $23955f1f88135281$var$_react = $23955f1f88135281$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $23955f1f88135281$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $23955f1f88135281$var$Document16Icon = (props)=>/*#__PURE__*/ $23955f1f88135281$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 100 2h8a1 1 0 000-2H4zm0 4a1 1 0 000 2h4a1 1 0 000-2H4z"/></svg>`
    }, props, {
        size: 'small'
    }));
$23955f1f88135281$var$Document16Icon.displayName = 'Document16Icon';
var $23955f1f88135281$var$_default = $23955f1f88135281$var$Document16Icon;
module.exports.default = $23955f1f88135281$var$_default;

});

parcelRegister("42mVw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f09221b0a539484$var$_react = $2f09221b0a539484$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2f09221b0a539484$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f09221b0a539484$var$Blog16Icon = (props)=>/*#__PURE__*/ $2f09221b0a539484$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zm7 0a2.5 2.5 0 10-2.37 2.87c-.277.394-.616.815-1.016 1.265a.916.916 0 00-.058 1.147.607.607 0 00.948.043c1.939-2.221 2.77-3.996 2.496-5.325zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$2f09221b0a539484$var$Blog16Icon.displayName = 'Blog16Icon';
var $2f09221b0a539484$var$_default = $2f09221b0a539484$var$Blog16Icon;
module.exports.default = $2f09221b0a539484$var$_default;

});

parcelRegister("hhmAa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("c9j7H").then(()=>parcelRequire('avXTG'));

});

parcelRegister("04uCN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9CNV1").then(()=>parcelRequire('ax6gr'));

});

parcelRegister("5XXvD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kj99S").then(()=>parcelRequire('cu0Sf'));

});

parcelRegister("az87C", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("MsAMf").then(()=>parcelRequire('kRSyE'));

});

parcelRegister("IR5Zr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hqUNL").then(()=>parcelRequire('bXsFc'));

});

parcelRegister("a0cSu", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("81ele").then(()=>parcelRequire('heDum'));

});

parcelRegister("2Zwb9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("f6s74").then(()=>parcelRequire('koIAu'));

});

parcelRegister("14hrM", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3fs5M").then(()=>parcelRequire('7ISrx'));

});

parcelRegister("kENAJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cXU5K").then(()=>parcelRequire('8o5C6'));

});

parcelRegister("hMCpa", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7yNJI").then(()=>parcelRequire('2pi7o'));

});

parcelRegister("bvjMQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cCULL").then(()=>parcelRequire('cOsqE'));

});

parcelRegister("dsRgj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3jhqX").then(()=>parcelRequire('iByLo'));

});

parcelRegister("4xnuT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ifX94").then(()=>parcelRequire('3Xmfm'));

});

parcelRegister("9pS0E", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gnAw0").then(()=>parcelRequire('IXu7C'));

});

parcelRegister("iqKJJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("jD9x7").then(()=>parcelRequire('gZQhT'));

});

parcelRegister("eyLKt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("1bzA4").then(()=>parcelRequire('dCALS'));

});

parcelRegister("bXPYz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dwqKI").then(()=>parcelRequire('8DjS6'));

});

parcelRegister("0zYUH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6F2ZJ").then(()=>parcelRequire('eRawo'));

});

parcelRegister("aonoe", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("NpdOV").then(()=>parcelRequire('jHMvH'));

});

parcelRegister("4J3iF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("YPDkL").then(()=>parcelRequire('fvQWm'));

});

parcelRegister("3sCdr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iWD7v").then(()=>parcelRequire('hL0Qd'));

});

parcelRegister("6SGL9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kvwg1").then(()=>parcelRequire('8nY6X'));

});

parcelRegister("eXGDS", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("yTwnW").then(()=>parcelRequire('eIr2t'));

});

parcelRegister("hgVzO", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9yvg0").then(()=>parcelRequire('hRYdU'));

});

parcelRegister("mLn3Q", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ebVzT").then(()=>parcelRequire('gSFPI'));

});

parcelRegister("cLsbI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aRCDF").then(()=>parcelRequire('h0cb1'));

});

parcelRegister("1qbPt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9VtCD").then(()=>parcelRequire('k3ak7'));

});

parcelRegister("5sbHU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2bZsf").then(()=>parcelRequire('7JgHV'));

});

parcelRegister("gLmUj", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fNIof").then(()=>parcelRequire('fQ2EI'));

});

parcelRegister("jFzry", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hK23s").then(()=>parcelRequire('1psqr'));

});

parcelRegister("hIhZX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("k2MLG").then(()=>parcelRequire('cLW4D'));

});

parcelRegister("hdkC1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("l1hYo")
]).then(()=>parcelRequire('eQuyQ'));

});

parcelRegister("bIh7y", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kr06K").then(()=>parcelRequire('eyI8O'));

});


parcelRegister("2pE6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d21a9774b5a2f1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $cRPaW = parcelRequire("cRPaW");

var $8SIiI = parcelRequire("8SIiI");
const $6d21a9774b5a2f1e$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: url,
        loading: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
            testId: `${testId}-loading`
        }),
        loaded: /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            src: url,
            "data-testid": `${testId}-image`
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
var $6d21a9774b5a2f1e$export$2e2bcd8739ae039 = $6d21a9774b5a2f1e$var$ImageIcon;

});
parcelRegister("cRPaW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $95e221a7f9807f92$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $95e221a7f9807f92$var$React = $95e221a7f9807f92$var$_interopRequireWildcard($eUqFw);
function $95e221a7f9807f92$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $95e221a7f9807f92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $95e221a7f9807f92$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $95e221a7f9807f92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $95e221a7f9807f92$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $95e221a7f9807f92$var$loaded() {
    return {
        isLoaded: true
    };
}
function $95e221a7f9807f92$var$errored() {
    return {
        isErrored: true
    };
}
function $95e221a7f9807f92$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $95e221a7f9807f92$var$ImageRenderer = function(_React$Component) {
    $95e221a7f9807f92$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $95e221a7f9807f92$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $95e221a7f9807f92$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($95e221a7f9807f92$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $95e221a7f9807f92$var$_possibleConstructorReturn(_this, _ret);
    }
    $95e221a7f9807f92$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(this.props, nextProps)) this.setState($95e221a7f9807f92$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($95e221a7f9807f92$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($95e221a7f9807f92$var$React.Component);
module.exports.default = $95e221a7f9807f92$var$ImageRenderer;

});

parcelRegister("8SIiI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9060a2498f61f4f2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $9060a2498f61f4f2$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
    const animationNameStyles = (0, $byn9U.keyframes)({
        '0%': {
            backgroundPosition: '50% 0'
        },
        '100%': {
            backgroundPosition: '-50% 0'
        }
    });
    const styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        borderRadius: '2px',
        userSelect: 'none',
        background: "var(--ds-skeleton-subtle, #f6f7f8)",
        backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '280% 100%',
        display: 'inline-block',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        animationName: animationNameStyles,
        animationTimingFunction: 'linear'
    });
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- needs dynamic css
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: styles,
        "data-testid": testId
    });
};
var $9060a2498f61f4f2$export$2e2bcd8739ae039 = $9060a2498f61f4f2$var$LoadingSkeleton;

});


parcelRegister("4z862", function(module, exports) {

$parcel$export(module.exports, "sizeToButtonSpacing", () => $c5cf90fd8bf8cba5$export$9d642f65a919fb93);
$parcel$export(module.exports, "getFormattedMessage", () => $c5cf90fd8bf8cba5$export$f1aa79f2218fb713);
$parcel$export(module.exports, "getFormattedMessageAsString", () => $c5cf90fd8bf8cba5$export$66ecb50a9dd1768);
$parcel$export(module.exports, "getIconSizeStyles", () => $c5cf90fd8bf8cba5$export$a5dfadfde90ee066);
$parcel$export(module.exports, "getIconWidth", () => $c5cf90fd8bf8cba5$export$fb10bc5609c6347e);
$parcel$export(module.exports, "importIcon", () => $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851);
$parcel$export(module.exports, "getLinkLineHeight", () => $c5cf90fd8bf8cba5$export$1826e889cc97649);
$parcel$export(module.exports, "getLinkSizeStyles", () => $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e);
$parcel$export(module.exports, "getMaxLineHeight", () => $c5cf90fd8bf8cba5$export$a681bd062fee88a5);
$parcel$export(module.exports, "getMaxLines", () => $c5cf90fd8bf8cba5$export$c2293adf1794c09);
$parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", () => $c5cf90fd8bf8cba5$export$475c391af8171fec);
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $c5cf90fd8bf8cba5$export$1af10e3728e3a644);
$parcel$export(module.exports, "getTruncateStyles", () => $c5cf90fd8bf8cba5$export$8847c5561c06da49);
$parcel$export(module.exports, "hasWhiteSpace", () => $c5cf90fd8bf8cba5$export$619e376a425cb759);
$parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", () => $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $c2pJy = parcelRequire("c2pJy");

var $1csi6 = parcelRequire("1csi6");

var $bYKiA = parcelRequire("bYKiA");
const $c5cf90fd8bf8cba5$export$9d642f65a919fb93 = {
    [(0, $caOA9.SmartLinkSize).Small]: 'none',
    [(0, $caOA9.SmartLinkSize).Medium]: 'compact',
    [(0, $caOA9.SmartLinkSize).Large]: 'compact',
    [(0, $caOA9.SmartLinkSize).XLarge]: 'default'
};
const $c5cf90fd8bf8cba5$export$f1aa79f2218fb713 = (message)=>{
    if (message) {
        const { descriptor: descriptor, values: values } = message;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...descriptor,
            values: values
        });
    }
};
const $c5cf90fd8bf8cba5$export$66ecb50a9dd1768 = (intl, message, context)=>{
    const { formatMessage: formatMessage } = intl;
    return message ? formatMessage(message, {
        context: context
    }) : '';
};
const $c5cf90fd8bf8cba5$var$getIconDimensionStyles = (value)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: value,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: value
    });
const $c5cf90fd8bf8cba5$export$a5dfadfde90ee066 = (width)=>{
    const sizeStyles = $c5cf90fd8bf8cba5$var$getIconDimensionStyles(width);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
};
const $c5cf90fd8bf8cba5$export$fb10bc5609c6347e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '2rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.75rem';
    }
};
const $c5cf90fd8bf8cba5$export$6dc831e1a0a7a851 = (importFn)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importFn().then((module)=>module.default),
        loading: ()=>null
    }); // Because we're using dynamic loading here, TS will not be able to infer the type.
};
const $c5cf90fd8bf8cba5$export$1826e889cc97649 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $c5cf90fd8bf8cba5$export$7c3a25542ae9da0e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '1.25rem',
                fontWeight: 400,
                letterSpacing: '-0.008em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Large:
        case (0, $caOA9.SmartLinkSize).Medium:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.875rem',
                fontWeight: 400,
                letterSpacing: '-0.003em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 400,
                letterSpacing: '0em',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                lineHeight: $c5cf90fd8bf8cba5$export$1826e889cc97649(size)
            });
    }
};
const $c5cf90fd8bf8cba5$export$a681bd062fee88a5 = (size)=>{
    // The maximum line height based on all elements in specific size.
    // These heights belongs to AvatarGroup.
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return 1.75;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 1.5;
    }
};
const $c5cf90fd8bf8cba5$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};
const $c5cf90fd8bf8cba5$export$475c391af8171fec = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.100';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.050';
    }
};
const $c5cf90fd8bf8cba5$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 'space.300';
        case (0, $caOA9.SmartLinkSize).Large:
            return 'space.250';
        case (0, $caOA9.SmartLinkSize).Medium:
            return 'space.200';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 'space.100';
    }
};
const $c5cf90fd8bf8cba5$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>/*#__PURE__*/ (0, $byn9U.css)({
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        wordBreak: wordBreak,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        '@supports not (-webkit-line-clamp: 1)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxHeight: `calc(${maxLines} * ${lineHeight})`
        }
    });
const $c5cf90fd8bf8cba5$export$619e376a425cb759 = (str)=>{
    return str.search(/\s/) >= 0;
};
const $c5cf90fd8bf8cba5$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
    const icon = {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
            ...linkIcon,
            size: (0, $caOA9.SmartLinkSize).Large
        }),
        isFlexibleUi: true
    };
    return (0, $1csi6.openEmbedModal)({
        ...props,
        icon: icon,
        // Flex should not send origin as block card. It should be able to support
        // its internal parent components like hover card, block card and
        // itself as a standalone. To be investigated and fix in EDM-7520.
        origin: 'smartLinkCard'
    });
};

});
parcelRegister("1csi6", function(module, exports) {

$parcel$export(module.exports, "openEmbedModal", () => $06a3274b0148278d$export$7859f96cd8cff034);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $3dpxL = parcelRequire("3dpxL");
const $06a3274b0148278d$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $06a3274b0148278d$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($06a3274b0148278d$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $06a3274b0148278d$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("1zJPX"));
    (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Modal.default, {
        ...props,
        iframeName: $06a3274b0148278d$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}

});
parcelRegister("1zJPX", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("ivIPh")
]).then(()=>parcelRequire('2vsut'));

});




parcelRegister("39rqs", function(module, exports) {

$parcel$export(module.exports, "default", () => $105659f25305e8c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8cU5f = parcelRequire("8cU5f");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $8sbpW = parcelRequire("8sbpW");
function $105659f25305e8c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $105659f25305e8c7$var$DEFAULT_MAX_LINES = 2;
const $105659f25305e8c7$var$MAXIMUM_MAX_LINES = 2;
const $105659f25305e8c7$var$MINIMUM_MAX_LINES = 1;
const $105659f25305e8c7$var$containerStyles = {
    name: "mkkf9p",
    styles: "flex:1 1 auto"
};
var $105659f25305e8c7$var$_ref = {
    name: "16ucc2m",
    styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref2 = {
    name: "1glvof",
    styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
};
var $105659f25305e8c7$var$_ref3 = {
    name: "rllj93",
    styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font-size:12px;}"
};
const $105659f25305e8c7$var$getThemeStyles = (theme)=>{
    switch(theme){
        case (0, $caOA9.SmartLinkInternalTheme).Grey:
            // We are being specifc with the CSS selectors to ensure that Confluence overrides
            // do not affect our internal Smart Card styles
            return $105659f25305e8c7$var$_ref3;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        case (0, $caOA9.SmartLinkTheme).Black:
            return $105659f25305e8c7$var$_ref2;
        case (0, $caOA9.SmartLinkTheme).Link:
        default:
            return $105659f25305e8c7$var$_ref;
    }
};
const $105659f25305e8c7$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, (0, $4z862.getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $105659f25305e8c7$var$getThemeStyles(theme));
};
const $105659f25305e8c7$var$getMaxLines = (maxLines)=>{
    if (maxLines > $105659f25305e8c7$var$MAXIMUM_MAX_LINES) return $105659f25305e8c7$var$DEFAULT_MAX_LINES;
    if (maxLines < $105659f25305e8c7$var$MINIMUM_MAX_LINES) return $105659f25305e8c7$var$MINIMUM_MAX_LINES;
    return maxLines;
};
const $105659f25305e8c7$var$withTooltip = (trigger, content, testId)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: content,
        testId: `${testId}-tooltip`,
        tag: "span"
    }, trigger);
/**
 * A base element that represent an anchor.
 * @internal
 * @param {LinkProps} LinkProps - The props necessary for the Link element.
 * @see LinkIcon
 */ const $105659f25305e8c7$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $105659f25305e8c7$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, $caOA9.SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const hasSpace = (0, $eUqFw.useMemo)(()=>text ? (0, $4z862.hasWhiteSpace)(text) : false, [
        text
    ]);
    const anchor = /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $105659f25305e8c7$var$getAnchorStyles(size, theme, $105659f25305e8c7$var$getMaxLines(maxLines), hasSpace),
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-link": true,
        "data-testid": testId,
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: url,
        ...target !== '_self' && {
            target: target
        }
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $105659f25305e8c7$var$containerStyles
    }, hideTooltip || text === undefined ? anchor : $105659f25305e8c7$var$withTooltip(anchor, text, testId));
};
var $105659f25305e8c7$export$2e2bcd8739ae039 = $105659f25305e8c7$var$Link;

});

parcelRegister("kIJ39", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab46ec5e33c2c988$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cCDvW = parcelRequire("cCDvW");

var $4AAjx = parcelRequire("4AAjx");
function $ab46ec5e33c2c988$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ab46ec5e33c2c988$var$styles = {
    name: "cvfhjc",
    styles: "display:inline-flex;line-height:inherit"
};
/**
 * A base element that displays a Lozenge.
 * @internal
 * @param {LozengeProps} LozengeProps - The props necessary for the Lozenge element.
 * @see State
 */ const $ab46ec5e33c2c988$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    if (!text) return null;
    const lozenge = action ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $cCDvW.default), {
        action: action,
        appearance: appearance,
        testId: testId,
        text: text,
        zIndex: ui?.zIndex
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: appearance,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        testId: `${testId}-lozenge`
    }, text);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ab46ec5e33c2c988$var$styles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-lozenge": true,
        "data-testid": testId
    }, lozenge);
};
var $ab46ec5e33c2c988$export$2e2bcd8739ae039 = $ab46ec5e33c2c988$var$Lozenge;

});
parcelRegister("cCDvW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8af307a3451da5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6OfWd = parcelRequire("6OfWd");

var $gNhy0 = parcelRequire("gNhy0");

var $k18Wh = parcelRequire("k18Wh");

var $aiL3q = parcelRequire("aiL3q");

var $fZ5ue = parcelRequire("fZ5ue");

var $2n1yu = parcelRequire("2n1yu");

var $5PFec = parcelRequire("5PFec");

var $af6S8 = parcelRequire("af6S8");

var $gBDMJ = parcelRequire("gBDMJ");

var $8McbT = parcelRequire("8McbT");

var $4AAjx = parcelRequire("4AAjx");

var $bTNMs = parcelRequire("bTNMs");

var $5Oy6H = parcelRequire("5Oy6H");

var $4jHIN = parcelRequire("4jHIN");
const $c8af307a3451da5a$var$validateItems = (items = [], text)=>{
    return items.filter((item)=>item.text !== text);
};
const $c8af307a3451da5a$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
    const [selected, setSelected] = (0, $eUqFw.useState)({
        appearance: appearance,
        text: text
    });
    const [isLoaded, setIsLoaded] = (0, $eUqFw.useState)(false);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [items, setItems] = (0, $eUqFw.useState)();
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)();
    const reload = (0, $af6S8.default)();
    //TODO EDM-6583 Replace usage of useFlexibleUiAnalyticsContext with linking platform analytics context from find team.
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    (0, $eUqFw.useEffect)(()=>{
        setSelected({
            text: text,
            appearance: appearance
        });
    }, [
        text,
        appearance
    ]);
    const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
    const handleOpenChange = (0, $eUqFw.useCallback)(async (args)=>{
        setIsOpen(args.isOpen);
        if (args.isOpen) {
            analytics?.ui.smartLinkLozengeActionClickedEvent();
            analytics?.track.smartLinkQuickActionStarted({
                smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
            });
            if (!isLoaded && action?.read) try {
                setIsLoading(true);
                const responseItems = await invoke(action.read, (0, $2n1yu.default));
                const validItems = typeof text === 'string' ? $c8af307a3451da5a$var$validateItems(responseItems, text) : responseItems;
                setItems(validItems);
                setIsLoaded(true);
                if (validItems?.length === 0) {
                    analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.permissionLoadErrorAnalyticsPayload));
                    setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).noData);
                    setIsLoaded(false);
                }
            } catch (err) {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).unknown);
                setIsLoaded(false);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownLoadErrorAnalyticsPayload));
            } finally{
                setIsLoading(false);
            }
        }
        if (!args.isOpen) setErrorMessage(undefined);
    }, [
        action.read,
        analytics,
        invoke,
        isLoaded,
        text
    ]);
    const trigger = (0, $eUqFw.useCallback)((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gNhy0.default), {
            ...props,
            appearance: selected.appearance,
            isOpen: isOpen,
            testId: testId,
            text: selected.text
        }), [
        selected.appearance,
        selected.text,
        isOpen,
        testId
    ]);
    const handleItemClick = (0, $eUqFw.useCallback)(async (id, text, appearance)=>{
        try {
            analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
            const updateAction = action?.update;
            if (updateAction && id) {
                setIsLoading(true);
                const request = (0, $5PFec.default)(updateAction, id);
                await invoke(request);
                setSelected({
                    appearance: appearance,
                    text: text
                });
                setIsLoading(false);
                setIsLoaded(false);
                setIsOpen(false);
                setItems([]);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: (0, $bTNMs.TrackQuickActionType).StatusUpdate
                });
                if (url) await reload(url, true, undefined, linkId);
            }
        } catch (err) {
            setIsLoading(false);
            if ((0, $8McbT.isInvokeCustomError)(err)) {
                setErrorMessage(err.message);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.validationUpdateErrorAnalyticsPayload));
            } else {
                setErrorMessage((0, $gBDMJ.LozengeActionErrorMessages).updateFailed);
                analytics?.track.smartLinkQuickActionFailed((0, $5Oy6H.unknownUpdateErrorAnalyticsPayload));
            }
        }
    }, [
        action?.update,
        analytics,
        invoke,
        linkId,
        reload,
        url
    ]);
    const dropdownItemGroup = (0, $eUqFw.useMemo)(()=>{
        if (errorMessage) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $k18Wh.default), {
            errorMessage: errorMessage,
            testId: testId,
            url: url,
            previewData: previewData
        });
        if (items && items.length > 0) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4jHIN.default), {
            testId: testId,
            items: items,
            onClick: handleItemClick
        });
    }, [
        errorMessage,
        handleItemClick,
        items,
        previewData,
        testId,
        url
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        testId: testId,
        trigger: trigger,
        zIndex: zIndex
    }, dropdownItemGroup);
};
var $c8af307a3451da5a$export$2e2bcd8739ae039 = (0, $aiL3q.default)($c8af307a3451da5a$var$LozengeAction);

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("gNhy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7635f6bba3760eba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $86Ndv = parcelRequire("86Ndv");

var $bPzws = parcelRequire("bPzws");
const $7635f6bba3760eba$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
    const [isBold, setIsBold] = (0, $eUqFw.useState)(false);
    const onMouseEnter = (0, $eUqFw.useCallback)(()=>setIsBold(true), []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>setIsBold(false), []);
    const lozenge = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
            appearance: appearance,
            isBold: isBold
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $bPzws.triggerLozengeStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", null, text), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "options",
            size: "medium"
        }))), [
        appearance,
        isBold,
        text
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        type: "button",
        ...props,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $bPzws.triggerButtonStyles),
        "data-action-open": isOpen,
        "data-testid": `${testId}--trigger`,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: triggerRef
    }, lozenge);
};
var $7635f6bba3760eba$export$2e2bcd8739ae039 = $7635f6bba3760eba$var$LozengeActionTrigger;

});
parcelRegister("bPzws", function(module, exports) {

$parcel$export(module.exports, "triggerButtonStyles", () => $fc5d2e39c54f8883$export$ae858546f0bfd05c);
$parcel$export(module.exports, "triggerLozengeStyles", () => $fc5d2e39c54f8883$export$5717c7336384f3a6);
$parcel$export(module.exports, "dropdownItemGroupStyles", () => $fc5d2e39c54f8883$export$2c40d814aeff5db);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $fc5d2e39c54f8883$export$ae858546f0bfd05c = /*#__PURE__*/ (0, $byn9U.css)({
    all: 'unset',
    backgroundColor: 'transparent',
    color: 'unset',
    cursor: 'pointer',
    fontFamily: 'unset',
    fontSize: 'unset',
    fontStyle: 'unset',
    fontWeight: 'unset',
    fontVariant: 'unset',
    lineHeight: 0,
    padding: 0,
    textTransform: 'unset',
    border: '2px solid transparent',
    margin: "var(--ds-space-025, 2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
        outline: 'none',
        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
        borderRadius: '5px'
    }
});
const $fc5d2e39c54f8883$export$5717c7336384f3a6 = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "span[role='img']": {
        margin: `${"var(--ds-space-negative-050, -4px)"} ${"var(--ds-space-negative-100, -8px)"} ${"var(--ds-space-negative-050, -4px)"} -1px`
    }
});
const $fc5d2e39c54f8883$export$2c40d814aeff5db = /*#__PURE__*/ (0, $byn9U.css)({
    maxHeight: '300px',
    overflowY: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    button: {
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        minHeight: '28px',
        width: '220px',
        '&:hover': {
            backgroundColor: 'inherit'
        },
        '&:focus, &:focus-visible': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            boxSizing: 'border-box',
            boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
            outline: 'none'
        }
    }
});

});


parcelRegister("k18Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $723d9a69e05743b3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");


var $gw74N = parcelRequire("gw74N");

var $c3mz7 = parcelRequire("c3mz7");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $af6S8 = parcelRequire("af6S8");
const $723d9a69e05743b3$var$MAX_LINE_NUMBER = 8;
const $723d9a69e05743b3$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $723d9a69e05743b3$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
    const reload = (0, $af6S8.default)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const isPreviewAvailable = previewData && previewData.src !== undefined;
    const handlePreviewClose = (0, $eUqFw.useCallback)(()=>{
        if (url) reload(url, true);
    }, [
        reload,
        url
    ]);
    const handlePreviewOpen = (0, $eUqFw.useCallback)(()=>{
        if (isPreviewAvailable) {
            analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
            return (0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                ...previewData,
                analytics: analytics,
                onClose: handlePreviewClose
            });
        }
    }, [
        analytics,
        handlePreviewClose,
        isPreviewAvailable,
        previewData
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.contentStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
            testId: `${testId}-icon`,
            LEGACY_size: "medium",
            color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
            LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`,
            label: 'error',
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            css: (0, $c3mz7.textStyles)(maxLineNumber),
            "data-testid": `${testId}-error-message`
        }, typeof errorMessage === 'string' ? errorMessage : (0, $4z862.getFormattedMessage)(errorMessage))), isPreviewAvailable ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $c3mz7.linkStyles)
        }, /*#__PURE__*/ (0, $byn9U.jsx)("a", {
            target: "_blank",
            "data-testid": `${testId}-open-embed`,
            onClick: handlePreviewOpen
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).open_issue_in_jira))) : null);
    }, [
        errorMessage,
        handlePreviewOpen,
        isPreviewAvailable,
        maxLineNumber,
        testId
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $c3mz7.dropdownItemGroupStyles),
        "data-testid": `${testId}-error-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
        testId: `${testId}-error`
    }, content))));
};
var $723d9a69e05743b3$export$2e2bcd8739ae039 = $723d9a69e05743b3$var$LozengeActionError;

});
parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("c3mz7", function(module, exports) {

$parcel$export(module.exports, "dropdownItemGroupStyles", () => $88f4678df04deb4b$export$2c40d814aeff5db);
$parcel$export(module.exports, "contentStyles", () => $88f4678df04deb4b$export$a38ecc1ac2e6fba);
$parcel$export(module.exports, "linkStyles", () => $88f4678df04deb4b$export$4ea5976125a01ffa);
$parcel$export(module.exports, "textStyles", () => $88f4678df04deb4b$export$6a54c24d15b0f6ba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4z862 = parcelRequire("4z862");
function $88f4678df04deb4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $88f4678df04deb4b$export$2c40d814aeff5db = {
    name: "a7m7l8",
    styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
};
const $88f4678df04deb4b$var$sharedBlockStyles = {
    name: "gx0rja",
    styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
};
const $88f4678df04deb4b$export$a38ecc1ac2e6fba = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, {
    marginTop: "var(--ds-space-025, 2px)",
    alignItems: 'flex-start',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span, > div': {
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`
    }
});
const $88f4678df04deb4b$export$4ea5976125a01ffa = /*#__PURE__*/ (0, $byn9U.css)($88f4678df04deb4b$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
const $88f4678df04deb4b$export$6a54c24d15b0f6ba = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));

});

parcelRegister("4abrz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ebfdcddf6874aaf0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ebfdcddf6874aaf0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});

parcelRegister("4AAjx", function(module, exports) {

$parcel$export(module.exports, "FlexibleUiContext", () => $43db55e8f7afe139$export$ca70b164b615de47);
$parcel$export(module.exports, "useFlexibleUiContext", () => $43db55e8f7afe139$export$61d7957a243df7aa);
$parcel$export(module.exports, "FlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$9296fed6018ca95b);
$parcel$export(module.exports, "useFlexibleUiAnalyticsContext", () => $43db55e8f7afe139$export$80b8dfec38d1d85c);
$parcel$export(module.exports, "FlexibleUiOptionContext", () => $43db55e8f7afe139$export$f7433dbd6c50e26a);
$parcel$export(module.exports, "useFlexibleUiOptionContext", () => $43db55e8f7afe139$export$e6b5ad18b56e8f51);

var $eUqFw = parcelRequire("eUqFw");
const $43db55e8f7afe139$export$ca70b164b615de47 = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$61d7957a243df7aa = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$ca70b164b615de47);
const $43db55e8f7afe139$export$9296fed6018ca95b = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$80b8dfec38d1d85c = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$9296fed6018ca95b);
const $43db55e8f7afe139$export$f7433dbd6c50e26a = (0, $eUqFw.createContext)(undefined);
const $43db55e8f7afe139$export$e6b5ad18b56e8f51 = ()=>(0, $eUqFw.useContext)($43db55e8f7afe139$export$f7433dbd6c50e26a);

});

parcelRegister("af6S8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2997c27397645ece$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2cI4y = parcelRequire("2cI4y");

var $caOA9 = parcelRequire("caOA9");

var $gqldc = parcelRequire("gqldc");

var $fQBSX = parcelRequire("fQBSX");
const $2997c27397645ece$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $fQBSX.default)();
    return (0, $eUqFw.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $2cI4y.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $2997c27397645ece$export$2e2bcd8739ae039 = $2997c27397645ece$var$useResolve;

});
parcelRegister("2cI4y", function(module, exports) {

$parcel$export(module.exports, "startUfoExperience", () => $6dc76d5a97c623dd$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $6dc76d5a97c623dd$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $6dc76d5a97c623dd$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $6dc76d5a97c623dd$export$4084c0df4a03a6af);

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
const $6dc76d5a97c623dd$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
};
const $6dc76d5a97c623dd$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $3yYXq.ExperienceTypes).Experience,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
};
const $6dc76d5a97c623dd$var$ufoExperiences = {
    'smart-link-rendered': new (0, $2kFUE.ConcurrentExperience)('smart-link-rendered', $6dc76d5a97c623dd$var$renderExperience),
    'smart-link-authenticated': new (0, $2kFUE.ConcurrentExperience)('smart-link-authenticated', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-action-invocation': new (0, $2kFUE.ConcurrentExperience)('smart-link-action-invocation', $6dc76d5a97c623dd$var$inlineExperience),
    'smart-link-ai-summary': new (0, $2kFUE.ConcurrentExperience)('smart-link-ai-summary', $6dc76d5a97c623dd$var$aiExperience)
};
const $6dc76d5a97c623dd$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $6dc76d5a97c623dd$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $6dc76d5a97c623dd$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $6dc76d5a97c623dd$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});





parcelRegister("fQBSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1d36093d90197e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6EHO5 = parcelRequire("6EHO5");
var $f9yXU = parcelRequire("f9yXU");
var $4hPjC = parcelRequire("4hPjC");

var $caOA9 = parcelRequire("caOA9");

var $7pH5u = parcelRequire("7pH5u");


var $lEfVV = parcelRequire("lEfVV");

var $gqldc = parcelRequire("gqldc");
const $ae1d36093d90197e$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $eUqFw.useCallback)((url, metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $eUqFw.useCallback)((url, error, response, isMetadataRequest)=>{
        const { details: details } = getState()[url] || {
            status: (0, $caOA9.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If there's no previous data in the store for this URL, then bail
            // out and let the editor handle fallbacks (returns to a blue link).
            if (!hasData && status !== 'resolved') {
                dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
                url: url
            }, details));
        // Handle AuthErrors (user did not have access to resource) -
        // Missing AAID in ASAP claims, or missing UserContext, or 403 from downstream
        } else if (error.kind === 'auth') dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: url
        }, (0, $7pH5u.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $eUqFw.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $4hPjC.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fallback', hostname, (0, $30e664360e28092c$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('fatal', hostname, (0, $30e664360e28092c$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $f9yXU.APIError)('error', hostname, (0, $30e664360e28092c$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $lEfVV.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $ae1d36093d90197e$export$2e2bcd8739ae039 = $ae1d36093d90197e$var$useResponse;

});
parcelRegister("7pH5u", function(module, exports) {

$parcel$export(module.exports, "getEmptyJsonLd", () => $c6847fc9d6f0df43$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $c6847fc9d6f0df43$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $c6847fc9d6f0df43$export$e32193033a594efb);
const $c6847fc9d6f0df43$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $c6847fc9d6f0df43$export$2796a804c6e44f63 = ()=>$c6847fc9d6f0df43$var$emptyData;
const $c6847fc9d6f0df43$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });
const $c6847fc9d6f0df43$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$c6847fc9d6f0df43$var$emptyData
        }
    });

});

const $30e664360e28092c$export$297c39c8b9bfca0 = 'resolving';
const $30e664360e28092c$export$b64a888338c24e0e = 'errored';
const $30e664360e28092c$export$677b6edfa0002c70 = 'fallback';
const $30e664360e28092c$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $30e664360e28092c$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $30e664360e28092c$export$338f7d9ccca1975d = 'Error resolving metadata.';




parcelRegister("aiL3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac18b970e0fdc7f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $ffiyv = parcelRequire("ffiyv");
const $ac18b970e0fdc7f3$var$withErrorBoundary = (Component)=>(props)=>{
        const fallback = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: props?.appearance,
                testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
            }, props?.text), [
            props?.appearance,
            props?.testId,
            props?.text
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props));
    };
var $ac18b970e0fdc7f3$export$2e2bcd8739ae039 = $ac18b970e0fdc7f3$var$withErrorBoundary;

});
parcelRegister("jb3WS", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("eUqFw")));
})(module.exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

});


parcelRegister("fZ5ue", function(module, exports) {

$parcel$export(module.exports, "default", () => $526f1cd6fde31da2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $526f1cd6fde31da2$var$useInvoke = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (req, cb)=>{
        const response = await clientExt.invoke(req);
        return cb ? cb(response) : response;
    }, [
        clientExt
    ]);
};
var $526f1cd6fde31da2$export$2e2bcd8739ae039 = $526f1cd6fde31da2$var$useInvoke;

});
parcelRegister("imCrQ", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkClientExtension", () => $e90617a456d47f08$export$303ede4eed148855);

var $eUqFw = parcelRequire("eUqFw");

var $5LW2w = parcelRequire("5LW2w");

var $cCvxR = parcelRequire("cCvxR");

var $euvAQ = parcelRequire("euvAQ");
const $e90617a456d47f08$export$303ede4eed148855 = (cardClient)=>{
    const resolverUrl = (0, $euvAQ.useResolverUrl)(cardClient);
    const invoke = (0, $eUqFw.useCallback)(async (data)=>{
        try {
            return await (0, $5LW2w.request)('post', `${resolverUrl}/invoke`, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
        } catch (err) {
            // checking if the error is a Response type
            // since we already had a few HOTs caused by comparing with instanceOf',
            // we're verifying the type by the contents
            if (err && err.json && typeof err.json === 'function') {
                const errorBody = await err.json();
                if (errorBody) throw new (0, $cCvxR.InvokeError)(errorBody?.error.message, errorBody?.error.status);
            }
            throw err;
        }
    }, [
        resolverUrl
    ]);
    const relatedUrls = (0, $eUqFw.useCallback)(async (url)=>{
        return await (0, $5LW2w.request)('get', `${resolverUrl}/related-urls?url=${encodeURIComponent(url)}`, undefined, {
            'Cache-Control': 'private'
        }, [
            200
        ]);
    }, [
        resolverUrl
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            invoke: invoke,
            relatedUrls: relatedUrls
        }), [
        invoke,
        relatedUrls
    ]);
};

});
parcelRegister("euvAQ", function(module, exports) {

$parcel$export(module.exports, "useResolverUrl", () => $56f10bb2820b4284$export$d08617a365fbe694);

var $eUqFw = parcelRequire("eUqFw");

var $dUrSu = parcelRequire("dUrSu");
const $56f10bb2820b4284$export$d08617a365fbe694 = (cardClient)=>(0, $eUqFw.useMemo)(()=>(0, $dUrSu.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);

});



parcelRegister("2n1yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8986176ef21b1b25$export$2e2bcd8739ae039);
const $8986176ef21b1b25$var$extractLozengeActionItems = (response)=>{
    const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
            appearance: appearance ?? 'default',
            id: id,
            text: name
        })) ?? [];
    return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
};
var $8986176ef21b1b25$export$2e2bcd8739ae039 = $8986176ef21b1b25$var$extractLozengeActionItems;

});

parcelRegister("5PFec", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf0e102a3fe2298$export$2e2bcd8739ae039);
const $1bf0e102a3fe2298$var$createStatusUpdateRequest = (request, id)=>({
        providerKey: request.providerKey,
        action: {
            ...request.action,
            payload: {
                newStatusId: id
            }
        }
    });
var $1bf0e102a3fe2298$export$2e2bcd8739ae039 = $1bf0e102a3fe2298$var$createStatusUpdateRequest;

});

parcelRegister("gBDMJ", function(module, exports) {

$parcel$export(module.exports, "LozengeActionErrorMessages", () => $7b8be149f9c2eaef$export$4f2e371a667ad688);

var $4abrz = parcelRequire("4abrz");
const $7b8be149f9c2eaef$export$4f2e371a667ad688 = {
    noData: {
        descriptor: (0, $4abrz.messages)['status_change_permission_error']
    },
    unknown: {
        descriptor: (0, $4abrz.messages)['status_change_load_error']
    },
    updateFailed: {
        descriptor: (0, $4abrz.messages)['status_change_update_error']
    }
};

});

parcelRegister("8McbT", function(module, exports) {

$parcel$export(module.exports, "getInvokeFailureReason", () => $1c7a2500ec767744$export$65b3f792dff0bd60);
$parcel$export(module.exports, "isInvokeCustomError", () => $1c7a2500ec767744$export$1694272377fa07d8);

var $bTNMs = parcelRequire("bTNMs");
const $1c7a2500ec767744$export$65b3f792dff0bd60 = (err)=>{
    if (!$1c7a2500ec767744$export$1694272377fa07d8(err)) return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    switch(err?.errorCode){
        case 403:
            return (0, $bTNMs.TrackQuickActionFailureReason).PermissionError;
        default:
            return (0, $bTNMs.TrackQuickActionFailureReason).UnknownError;
    }
};
const $1c7a2500ec767744$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;

});

parcelRegister("5Oy6H", function(module, exports) {

$parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2a568ff99500df53);
$parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$2de2d0ccc17b915f);
$parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$c1c05f9d51f7c467);
$parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", () => $2f5a2618d92e65d0$export$618660b8f2aa87e2);
const $2f5a2618d92e65d0$export$2a568ff99500df53 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$2de2d0ccc17b915f = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'PermissionError',
    step: 'load'
};
const $2f5a2618d92e65d0$export$c1c05f9d51f7c467 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'UnknownError',
    step: 'update'
};
const $2f5a2618d92e65d0$export$618660b8f2aa87e2 = {
    smartLinkActionType: 'StatusUpdate',
    reason: 'ValidationError',
    step: 'update'
};

});

parcelRegister("4jHIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $85a1291c7d9bca32$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $5etYV = parcelRequire("5etYV");

var $bPzws = parcelRequire("bPzws");

var $fEubG = parcelRequire("fEubG");
const $85a1291c7d9bca32$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>// eslint-disable-next-line @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $bPzws.dropdownItemGroupStyles),
        "data-testid": `${testId}-item-group`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), null, items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5etYV.default), {
            ...item,
            key: idx,
            onClick: onClick,
            testId: `${testId}-item-${idx}`
        }))));
var $85a1291c7d9bca32$export$2e2bcd8739ae039 = $85a1291c7d9bca32$var$LozengeActionItemsGroup;

});
parcelRegister("5etYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fefc6a85569ce88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $ffiyv = parcelRequire("ffiyv");
const $4fefc6a85569ce88$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
    const handleClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent dropdown to close on select item.
        // We want to show loading screen.
        e.stopPropagation();
        if (onClick) onClick(id, text, appearance);
    }, [
        appearance,
        id,
        onClick,
        text
    ]);
    const handleMouseEnter = (0, $eUqFw.useCallback)((e)=>{
        e.currentTarget?.firstElementChild?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseEnter: handleMouseEnter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: appearance
    }, text)));
};
var $4fefc6a85569ce88$export$2e2bcd8739ae039 = $4fefc6a85569ce88$var$LozengeActionItem;

});




parcelRegister("ecYnC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fe7a328e3dd330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $2pE6J = parcelRequire("2pE6J");

var $h0YJD = parcelRequire("h0YJD");
function $e3fe7a328e3dd330$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e3fe7a328e3dd330$var$badgeStyles = {
    name: "9qxyko",
    styles: "align-items:center;display:inline-flex;min-width:fit-content"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $e3fe7a328e3dd330$var$iconStyles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, $4z862.getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
const $e3fe7a328e3dd330$var$labelStyles = {
    name: "8loelm",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
};
const $e3fe7a328e3dd330$var$messageMapper = {
    [(0, $caOA9.IconType).PriorityBlocker]: (0, $4abrz.messages).priority_blocker,
    [(0, $caOA9.IconType).PriorityCritical]: (0, $4abrz.messages).priority_critical,
    [(0, $caOA9.IconType).PriorityHigh]: (0, $4abrz.messages).priority_high,
    [(0, $caOA9.IconType).PriorityHighest]: (0, $4abrz.messages).priority_highest,
    [(0, $caOA9.IconType).PriorityLow]: (0, $4abrz.messages).priority_low,
    [(0, $caOA9.IconType).PriorityLowest]: (0, $4abrz.messages).priority_lowest,
    [(0, $caOA9.IconType).PriorityMajor]: (0, $4abrz.messages).priority_major,
    [(0, $caOA9.IconType).PriorityMedium]: (0, $4abrz.messages).priority_medium,
    [(0, $caOA9.IconType).PriorityMinor]: (0, $4abrz.messages).priority_minor,
    [(0, $caOA9.IconType).PriorityTrivial]: (0, $4abrz.messages).priority_trivial,
    [(0, $caOA9.IconType).PriorityUndefined]: (0, $4abrz.messages).priority_undefined
};
const $e3fe7a328e3dd330$var$getFormattedMessageFromIcon = (icon)=>{
    if (icon) {
        const descriptor = $e3fe7a328e3dd330$var$messageMapper[icon];
        if (descriptor) return (0, $4z862.getFormattedMessage)({
            descriptor: descriptor
        });
    }
};
const $e3fe7a328e3dd330$var$renderAtlaskitIcon = (icon, testId)=>{
    if (icon) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $h0YJD.default), {
        icon: icon,
        label: icon,
        testId: `${testId}-icon`
    });
};
const $e3fe7a328e3dd330$var$renderImageIcon = (url, testId)=>{
    if (url) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: testId,
        url: url
    });
};
/**
 * A base element that displays some text with an associated icon.
 * @internal
 * @param {BadgeProps} BadgeProps - The props necessary for the Badge.
 * @see CommentCount
 * @see ViewCount
 * @see ReactCount
 * @see VoteCount
 * @see SubscriberCount
 * @see Priority
 * @see ProgrammingLanguage
 * @see Provider
 */ const $e3fe7a328e3dd330$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
    const formattedMessageOrLabel = $e3fe7a328e3dd330$var$getFormattedMessageFromIcon(icon) || label;
    const badgeIcon = $e3fe7a328e3dd330$var$renderAtlaskitIcon(icon, testId) || $e3fe7a328e3dd330$var$renderImageIcon(url, testId);
    if (!formattedMessageOrLabel || !badgeIcon) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e3fe7a328e3dd330$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-badge": true,
        "data-testid": testId
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$iconStyles
    }, badgeIcon), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e3fe7a328e3dd330$var$labelStyles,
        "data-testid": `${testId}-label`
    }, formattedMessageOrLabel));
};
var $e3fe7a328e3dd330$export$2e2bcd8739ae039 = $e3fe7a328e3dd330$var$Badge;

});

parcelRegister("1aEBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a383934139702b93$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4z862 = parcelRequire("4z862");
function $a383934139702b93$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a383934139702b93$var$MAX_COUNT = 4;
var $a383934139702b93$var$_ref = {
    name: "1brfzli",
    styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
};
const $a383934139702b93$var$getStyles = (size)=>{
    const styles = $a383934139702b93$var$_ref;
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            // Default AK small size
            return styles;
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
            return /*#__PURE__*/ (0, $byn9U.css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
    }
};
const $a383934139702b93$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
    switch(elementName){
        case (0, $caOA9.ElementName).AssignedToGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).assigned_to, personName);
        case (0, $caOA9.ElementName).OwnedByGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).owned_by, personName);
        case (0, $caOA9.ElementName).AuthorGroup:
            return (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).created_by, personName);
        default:
            return personName;
    }
};
/**
 * A base element that displays a group of avatars.
 * @internal
 * @param {AvatarGroupProps} AvatarGroupProps - The props necessary for the AvatarGroup.
 * @see AuthorGroup
 * @see CollaboratorGroup
 */ const $a383934139702b93$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $a383934139702b93$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
    const intl = (0, $5JgJ2.default)();
    const data = (0, $eUqFw.useMemo)(()=>{
        if (!items.length && showFallbackAvatar) switch(name){
            case (0, $caOA9.ElementName).AssignedToGroup:
                return [
                    {
                        name: (0, $4z862.getFormattedMessageAsString)(intl, (0, $4abrz.messages).unassigned)
                    }
                ];
            default:
                return [];
        }
        //show a name prefix if there is one Avatar in a group only
        if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
            return {
                ...person,
                name: $a383934139702b93$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
            };
        });
        return items;
    }, [
        name,
        items,
        showNamePrefix,
        showFallbackAvatar,
        intl
    ]);
    if (!data.length) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $a383934139702b93$var$getStyles(size),
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-avatar-group": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4XQdE.default), {
        maxCount: maxCount,
        appearance: "stack",
        size: "small",
        data: data,
        testId: testId
    }));
};
var $a383934139702b93$export$2e2bcd8739ae039 = $a383934139702b93$var$AvatarGroup;

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor || avatarData.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`}`,
        color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
            color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    isolation: 'isolate',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});



parcelRegister("2aeJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1ea9141ebba5fdb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2pE6J = parcelRequire("2pE6J");
function $f1ea9141ebba5fdb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Media: Image
 * [aspect-ratio: 16 / 9] The context box is fixed to aspect ratio of 16:9.
 * [object-fit: cover] The replaced content is sized to maintain
 * its aspect ratio while filling the element's entire content box.
 * If the object's aspect ratio does not match the aspect ratio of its box,
 * then the object will be clipped to fit.
 * [object-position] Center alignment of the selected replaced element's
 * contents within the element's box.
 */ const $f1ea9141ebba5fdb$var$styles = {
    name: "a50hvv",
    styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
};
/**
 * A base element that displays a Media.
 * @internal
 * @param {MediaProps} MediaProps - The props necessary for the Media element.
 * @see Preview
 */ const $f1ea9141ebba5fdb$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
    if (!type || !url) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $f1ea9141ebba5fdb$var$styles,
            overrideCss
        ],
        "data-smart-element": name,
        "data-smart-element-media": type,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2pE6J.default), {
        testId: `${testId}-image`,
        url: url,
        onError: onError,
        onLoad: onLoad,
        defaultIcon: null
    }));
};
var $f1ea9141ebba5fdb$export$2e2bcd8739ae039 = $f1ea9141ebba5fdb$var$Media;

});

parcelRegister("gsehw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dd937a6ee8e1ad3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");
const $5dd937a6ee8e1ad3$var$getStyles = (maxLines)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines));
/**
 * A base element that displays some Text.
 * @internal
 * @param {TextProps} TextProps - The props necessary for the Text element.
 * @see Title
 */ const $5dd937a6ee8e1ad3$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
    if (!message && !content) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $5dd937a6ee8e1ad3$var$getStyles(maxLines),
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-text": true,
        "data-testid": testId
    }, (0, $4z862.getFormattedMessage)(message) || content);
};
var $5dd937a6ee8e1ad3$export$2e2bcd8739ae039 = $5dd937a6ee8e1ad3$var$Text;

});

parcelRegister("iAt1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $588a9b7e2c02aa74$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $4z862 = parcelRequire("4z862");

var $9KU0P = parcelRequire("9KU0P");

var $4abrz = parcelRequire("4abrz");
const $588a9b7e2c02aa74$var$styles = /*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $4z862.getTruncateStyles)(1));
const $588a9b7e2c02aa74$var$typeToDescriptorMap = {
    created: {
        relative: (0, $4abrz.messages).created_on_relative,
        absolute: (0, $4abrz.messages).created_on_absolute
    },
    modified: {
        relative: (0, $4abrz.messages).modified_on_relative,
        absolute: (0, $4abrz.messages).modified_on_absolute
    },
    sent: {
        relative: (0, $4abrz.messages).sent_on_relative,
        absolute: (0, $4abrz.messages).sent_on_absolute
    }
};
/**
 * A base element that displays an ISO Timestamp in text.
 * @internal
 * @param {DateTimeProps} DateTimeProps - The props necessary for the DateTime element.
 * @see CreatedOn
 * @see ModifiedOn
 * @see SentOn
 */ const $588a9b7e2c02aa74$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
    const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, $5JgJ2.default)();
    if (!type || !date) return null;
    const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
    let context;
    let typeVariant;
    if (isLongerThenWeek) {
        typeVariant = 'absolute';
        context = formatDate(date, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    } else {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(date, Date.now());
        typeVariant = 'relative';
        context = formatRelativeTime(value, unit, {
            numeric: 'auto'
        });
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $588a9b7e2c02aa74$var$styles,
            overrideCss
        ],
        "data-separator": true,
        "data-smart-element": name,
        "data-smart-element-date-time": true,
        "data-testid": testId
    }, text ? `${text} ${context}` : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...$588a9b7e2c02aa74$var$typeToDescriptorMap[type][typeVariant],
        values: {
            context: context
        }
    }));
};
var $588a9b7e2c02aa74$export$2e2bcd8739ae039 = $588a9b7e2c02aa74$var$DateTime;

});

parcelRegister("8UE2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d82cf77148d10f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9nkwJ = parcelRequire("9nkwJ");

var $byn9U = parcelRequire("byn9U");
function $82d82cf77148d10f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $82d82cf77148d10f$var$badgeStyles = {
    name: "qowjig",
    styles: "align-items:center;display:inline-flex"
};
/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */ const $82d82cf77148d10f$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
    if (!value) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $82d82cf77148d10f$var$badgeStyles,
            overrideCss
        ],
        "data-fit-to-content": true,
        "data-smart-element": name,
        "data-smart-element-atlaskit-badge": true,
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9nkwJ.default), null, value));
};
var $82d82cf77148d10f$export$2e2bcd8739ae039 = $82d82cf77148d10f$var$AtlaskitBadge;

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});




parcelRegister("2mW0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dc684baf7d7b3ad$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $2aeJ6 = parcelRequire("2aeJ6");
const $1dc684baf7d7b3ad$var$Preview = (props)=>{
    const { overrideUrl: overrideUrl, ...rest } = props ?? {};
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    const data = overrideUrl ? {
        url: overrideUrl,
        type: (0, $caOA9.MediaType).Image
    } : context?.preview;
    if (!data) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2aeJ6.default), {
        ...rest,
        ...data
    });
};
var $1dc684baf7d7b3ad$export$2e2bcd8739ae039 = $1dc684baf7d7b3ad$var$Preview;

});

parcelRegister("jtGWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f9944feb1da4750$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $gsehw = parcelRequire("gsehw");
const $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES = 3;
const $7f9944feb1da4750$var$getSnippetStyles = (overrideCss)=>/*#__PURE__*/ (0, $byn9U.css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    overrideCss);
const $7f9944feb1da4750$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $7f9944feb1da4750$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gsehw.default), {
        content: overrideContent ?? context?.snippet,
        maxLines: maxLines,
        overrideCss: $7f9944feb1da4750$var$getSnippetStyles(overrideCss),
        ...props
    });
};
var $7f9944feb1da4750$export$2e2bcd8739ae039 = $7f9944feb1da4750$var$SnippetElement;

});


parcelRegister("4sQhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2059b5fdc19a0897$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");
const $2059b5fdc19a0897$var$getBlockStyles = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)((0, $d2BrZ.getBaseStyles)(direction, size), " ", (0, $d2BrZ.highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, $d2BrZ.getGapSize)(size), "rem;}[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, $caOA9.ElementName).TargetBranch, "']+[data-smart-element='", (0, $caOA9.ElementName).SourceBranch, "']:before{content:'\u2190';}");
/**
 * A block represents a collection of elements and actions that are arranged
 * in a row. All elements and actions should be contained within a Block.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $2059b5fdc19a0897$var$Block = ({ children: children, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
    (0, $eUqFw.useEffect)(()=>{
        onRender && onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $2059b5fdc19a0897$var$getBlockStyles(direction, size),
            overrideCss
        ],
        "data-smart-block": true,
        "data-testid": testId,
        onTransitionEnd: onTransitionEnd,
        ref: blockRef
    }, (0, $d2BrZ.renderChildren)(children, size));
};
var $2059b5fdc19a0897$export$2e2bcd8739ae039 = $2059b5fdc19a0897$var$Block;

});
parcelRegister("d2BrZ", function(module, exports) {

$parcel$export(module.exports, "getGapSize", () => $8ab32f415250f7e3$export$ff20be09ae01c52e);
$parcel$export(module.exports, "getBaseStyles", () => $8ab32f415250f7e3$export$bff8031d86bb089);
$parcel$export(module.exports, "highlightRemoveStyles", () => $8ab32f415250f7e3$export$1928241a6f267c0d);
$parcel$export(module.exports, "getActionGroupStyles", () => $8ab32f415250f7e3$export$393b0054595c3748);
$parcel$export(module.exports, "filterActionItems", () => $8ab32f415250f7e3$export$adbd04236f07a7d8);
$parcel$export(module.exports, "renderChildren", () => $8ab32f415250f7e3$export$cd762ccf1a583d69);
$parcel$export(module.exports, "renderElementItems", () => $8ab32f415250f7e3$export$9678d3ca18bd7526);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $bampN = parcelRequire("bampN");

var $6oJXW = parcelRequire("6oJXW");

var $fNWSr = parcelRequire("fNWSr");

var $7GItJ = parcelRequire("7GItJ");
function $8ab32f415250f7e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8ab32f415250f7e3$export$f942619ce67b1a41 = {
    [(0, $caOA9.ElementName).AssignedTo]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AssignedToGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AttachmentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).AuthorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ChecklistProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CollaboratorGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CommentCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).CreatedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).DueOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LatestCommit]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).LinkIcon]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Location]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ModifiedOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedBy]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).OwnedByGroup]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Preview]: [
        'block'
    ],
    [(0, $caOA9.ElementName).Priority]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ProgrammingLanguage]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Provider]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReactCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ReadTime]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Snippet]: [
        'block'
    ],
    [(0, $caOA9.ElementName).SourceBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SentOn]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).State]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubscriberCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).SubTasksProgress]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).StoryPoints]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).TargetBranch]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).Title]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).ViewCount]: [
        'inline'
    ],
    [(0, $caOA9.ElementName).VoteCount]: [
        'inline'
    ]
};
var $8ab32f415250f7e3$var$_ref2 = {
    name: "2rtvke",
    styles: "flex-direction:row;align-items:center"
};
var $8ab32f415250f7e3$var$_ref3 = {
    name: "1ejri1g",
    styles: "flex-direction:column;align-items:flex-start"
};
const $8ab32f415250f7e3$var$getDirectionStyles = (direction)=>{
    switch(direction){
        case (0, $caOA9.SmartLinkDirection).Vertical:
            return $8ab32f415250f7e3$var$_ref3;
        case (0, $caOA9.SmartLinkDirection).Horizontal:
        default:
            return $8ab32f415250f7e3$var$_ref2;
    }
};
const $8ab32f415250f7e3$export$ff20be09ae01c52e = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return 1.25;
        case (0, $caOA9.SmartLinkSize).Large:
            return 1;
        case (0, $caOA9.SmartLinkSize).Medium:
            return 0.5;
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return 0.25;
    }
};
const $8ab32f415250f7e3$export$bff8031d86bb089 = (direction, size)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gap: `${$8ab32f415250f7e3$export$ff20be09ae01c52e(size)}rem`,
        lineHeight: '1rem',
        minWidth: 0,
        overflow: 'hidden'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8ab32f415250f7e3$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
const $8ab32f415250f7e3$export$1928241a6f267c0d = {
    name: "1klm9nt",
    styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
};
const $8ab32f415250f7e3$var$isActionGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $fNWSr.default);
const $8ab32f415250f7e3$var$isElementDisplayValid = (name, display)=>{
    return $8ab32f415250f7e3$export$f942619ce67b1a41[name]?.includes(display) ?? false;
};
const $8ab32f415250f7e3$export$f2c7ad0961800b16 = (children)=>{
    return Boolean(children.type() === null);
};
const $8ab32f415250f7e3$var$isElementOrElementGroup = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && ((0, $6oJXW.isFlexibleUiElement)(node) || node.type === (0, $7GItJ.default));
var $8ab32f415250f7e3$var$_ref = {
    name: "bceqwf",
    styles: "max-height:2rem"
};
const $8ab32f415250f7e3$export$393b0054595c3748 = (size)=>{
    if (size === (0, $caOA9.SmartLinkSize).XLarge) // The biggest height of the action button exceeds the max line-height
    // of the elements causing the action on the block with x-large size to
    // get cut at the bottom.
    return $8ab32f415250f7e3$var$_ref;
};
const $8ab32f415250f7e3$export$adbd04236f07a7d8 = (items = [], context)=>{
    return items.filter((item)=>{
        switch(item.name){
            case (0, $caOA9.ActionName).DeleteAction:
            case (0, $caOA9.ActionName).EditAction:
            case (0, $caOA9.ActionName).CustomAction:
                // Named and custom actions that user defines.
                return Boolean((0, $caOA9.ActionName)[item.name]);
            default:
                // Action that require data from the data context to render.
                if (context?.actions === undefined) return false;
                return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
        }
    });
};
const $8ab32f415250f7e3$export$cd762ccf1a583d69 = (children, size)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if ($8ab32f415250f7e3$var$isElementOrElementGroup(child) || $8ab32f415250f7e3$var$isActionGroup(child)) {
            const node = child;
            const { size: childSize } = node.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(node, {
                size: childSize || size
            });
        }
        return child;
    });
const $8ab32f415250f7e3$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
    const elements = items.reduce((acc, curr, idx)=>{
        const { name: name, ...props } = curr;
        const Element = $bampN[name];
        const typedProps = props;
        if (Element && $8ab32f415250f7e3$var$isElementDisplayValid(name, display)) {
            const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Element, {
                key: idx,
                ...typedProps
            });
            if (!$8ab32f415250f7e3$export$f2c7ad0961800b16(element)) return [
                ...acc,
                element
            ];
        }
        return acc;
    }, []);
    if (elements.length) return elements;
};

});
parcelRegister("6oJXW", function(module, exports) {

$parcel$export(module.exports, "isFlexibleUiCard", () => $7acfde2c70552128$export$3c94e0f4719f5c2a);
$parcel$export(module.exports, "isFlexibleUiTitleBlock", () => $7acfde2c70552128$export$df0092b19156b140);
$parcel$export(module.exports, "isFlexibleUiBlock", () => $7acfde2c70552128$export$b56fc89cf6e7d1e9);
$parcel$export(module.exports, "isFlexibleUiElement", () => $7acfde2c70552128$export$d7fc505bb0bd5756);
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $7acfde2c70552128$export$c0547b4405cae584);

var $eUqFw = parcelRequire("eUqFw");

var $kMn00 = parcelRequire("kMn00");
var $4bEHq = parcelRequire("4bEHq");
var $d9NWW = parcelRequire("d9NWW");
var $kcn2F = parcelRequire("kcn2F");

var $bampN = parcelRequire("bampN");
const $7acfde2c70552128$export$3c94e0f4719f5c2a = (children)=>{
    if (children && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).some((child)=>$7acfde2c70552128$export$df0092b19156b140(child))) return true;
    return false;
};
const $7acfde2c70552128$export$b56fc89cf6e7d1e9 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($kMn00).some((type)=>type === node.type);
const $7acfde2c70552128$export$d7fc505bb0bd5756 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && Object.values($bampN).some((type)=>type === node.type);
const $7acfde2c70552128$export$df0092b19156b140 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $4bEHq.default);
const $7acfde2c70552128$export$c0547b4405cae584 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $d9NWW.default);
const $7acfde2c70552128$export$43edae7b55c79927 = (node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(node) && node.type === (0, $kcn2F.default);

});
parcelRegister("kMn00", function(module, exports) {

$parcel$export(module.exports, "FooterBlock", () => (parcelRequire("kcn2F")).default);
$parcel$export(module.exports, "MetadataBlock", () => (parcelRequire("cIk4w")).default);
$parcel$export(module.exports, "PreviewBlock", () => (parcelRequire("d9NWW")).default);
$parcel$export(module.exports, "SnippetBlock", () => (parcelRequire("bTLTu")).default);
$parcel$export(module.exports, "TitleBlock", () => (parcelRequire("4bEHq")).default);
$parcel$export(module.exports, "CustomBlock", () => (parcelRequire("4sQhG")).default);
$parcel$export(module.exports, "InternalFooterBlock", () => (parcelRequire("fbX7D")).default);
$parcel$export(module.exports, "RelatedUrlsBlock", () => (parcelRequire("8jYmN")).default);
$parcel$export(module.exports, "AISummaryBlock", () => (parcelRequire("h2NbM")).default);
$parcel$export(module.exports, "AIFooterBlock", () => (parcelRequire("jgolE")).default);
$parcel$export(module.exports, "ActionBlock", () => (parcelRequire("5I51G")).default);

var $kcn2F = parcelRequire("kcn2F");

var $cIk4w = parcelRequire("cIk4w");

var $d9NWW = parcelRequire("d9NWW");

var $bTLTu = parcelRequire("bTLTu");

var $4bEHq = parcelRequire("4bEHq");

var $4sQhG = parcelRequire("4sQhG");

var $fbX7D = parcelRequire("fbX7D");

var $8jYmN = parcelRequire("8jYmN");

var $h2NbM = parcelRequire("h2NbM");

var $jgolE = parcelRequire("jgolE");

var $5I51G = parcelRequire("5I51G");

});
parcelRegister("kcn2F", function(module, exports) {

$parcel$export(module.exports, "default", () => $e186a177ed6dee21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fbX7D = parcelRequire("fbX7D");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */ const $e186a177ed6dee21$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbX7D.default), {
        ...props,
        testId: testId
    });
};
var $e186a177ed6dee21$export$2e2bcd8739ae039 = $e186a177ed6dee21$var$FooterBlock;

});
parcelRegister("fbX7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6de85b494ec94f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $bampN = parcelRequire("bampN");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $d2BrZ = parcelRequire("d2BrZ");
const $5c6de85b494ec94f$var$FooterBlockResolvedView = (props)=>{
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $caOA9.SmartLinkSize).Medium, hideProvider: hideProvider } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const hasActions = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(actions, context)?.length > 0, [
        actions,
        context
    ]);
    const onDropdownOpenChange = (0, $eUqFw.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actions && hasActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        testId: "smart-element-group-actions",
        align: (0, $caOA9.SmartLinkAlignment).Right,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        overrideCss: (0, $d2BrZ.getActionGroupStyles)(size),
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: "default"
    })) : null);
};
var $5c6de85b494ec94f$export$2e2bcd8739ae039 = $5c6de85b494ec94f$var$FooterBlockResolvedView;

});
parcelRegister("fNWSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b51d5450dd65dfd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $8cU5f = parcelRequire("8cU5f");

var $6OfWd = parcelRequire("6OfWd");

var $caOA9 = parcelRequire("caOA9");

var $7u4fN = parcelRequire("7u4fN");

var $34Io4 = parcelRequire("34Io4");

var $4z862 = parcelRequire("4z862");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $avp6V = parcelRequire("avp6V");

var $d2BrZ = parcelRequire("d2BrZ");

var $asu8X = parcelRequire("asu8X");
function $7b51d5450dd65dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b51d5450dd65dfd$var$styles = {
    name: "inf63k",
    styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
};
const $7b51d5450dd65dfd$var$renderActionItems = (items = [], size = (0, $caOA9.SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $avp6V.default), {
            item: item,
            key: idx,
            size: size,
            appearance: appearance,
            asDropDownItems: asDropDownItems,
            onActionItemClick: onActionItemClick
        }));
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $7b51d5450dd65dfd$var$ActionGroup = ({ items: items = [], size: size = (0, $caOA9.SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
    (0, $asu8X.di)((0, $6OfWd.default));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const renderableActionItems = (0, $eUqFw.useMemo)(()=>(0, $d2BrZ.filterActionItems)(items, context), [
        context,
        items
    ]);
    const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
    const onOpenChange = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
    }, [
        onDropdownOpenChange
    ]);
    const onActionItemClick = (0, $eUqFw.useCallback)(()=>{
        if (isOpen) onOpenChange({
            isOpen: false
        });
    }, [
        isOpen,
        onOpenChange
    ]);
    const actionButtons = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
        return $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
    }, [
        appearance,
        isMoreThenTwoItems,
        onActionItemClick,
        renderableActionItems,
        size,
        visibleButtonsNum
    ]);
    const moreActionDropdown = (0, $eUqFw.useMemo)(()=>{
        const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
        if (actionItems.length > 0) {
            const spacing = (0, $4z862.sizeToButtonSpacing)[size];
            const moreIcon = /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                label: "more",
                color: "currentColor"
            });
            const formatMessage = /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).more_actions);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
                        content: formatMessage,
                        hideTooltipOnClick: true,
                        testId: "action-group-more-button-tooltip",
                        tag: "span"
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
                        ...props,
                        spacing: spacing,
                        testId: "action-group-more-button",
                        iconBefore: moreIcon,
                        ref: triggerRef
                    })),
                testId: "action-group-dropdown",
                zIndex: ui?.zIndex
            }, $7b51d5450dd65dfd$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
        }
        return null;
    }, [
        appearance,
        isMoreThenTwoItems,
        isOpen,
        onActionItemClick,
        onOpenChange,
        renderableActionItems,
        size,
        ui?.zIndex,
        visibleButtonsNum
    ]);
    return renderableActionItems.length > 0 ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $7b51d5450dd65dfd$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "actions-button-group",
        "data-action-open": isOpen
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, actionButtons, moreActionDropdown)) : null;
};
var $7b51d5450dd65dfd$export$2e2bcd8739ae039 = $7b51d5450dd65dfd$var$ActionGroup;

});
parcelRegister("34Io4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f3e3907f1ddb8ccd2d9276da16185e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23d42d3583f8fd73$var$_react = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $23d42d3583f8fd73$var$_showMoreHorizontal = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("7JXZ0")));

var $23d42d3583f8fd73$var$_more = $23d42d3583f8fd73$var$_interopRequireDefault((parcelRequire("jG1wZ")));
function $23d42d3583f8fd73$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ShowMoreHorizontalIcon.
 * This component is ShowMoreHorizontalIcon, with `UNSAFE_fallbackIcon` set to "MoreIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23d42d3583f8fd73$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $23d42d3583f8fd73$var$_react.default.createElement($23d42d3583f8fd73$var$_showMoreHorizontal.default, Object.assign({
        LEGACY_fallbackIcon: $23d42d3583f8fd73$var$_more.default
    }, props));
$23d42d3583f8fd73$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
var $23d42d3583f8fd73$var$_default = module.exports.default = $23d42d3583f8fd73$var$ShowMoreHorizontalIcon;

});

parcelRegister("avp6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $02b4f62361713a29$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $eJljw = parcelRequire("eJljw");
const $02b4f62361713a29$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
    const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
    const handleOnClick = (0, $eUqFw.useCallback)(()=>{
        if (onActionItemClick) onActionItemClick();
        if (onClick) onClick();
    }, [
        onActionItemClick,
        onClick
    ]);
    const Action = name in $eJljw ? $eJljw[name] : undefined;
    if (!Action) return null;
    const actionProps = {
        ...props
    };
    if (hideContent && !asDropDownItems) actionProps.content = '';
    if (hideIcon) actionProps.icon = undefined;
    if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
        asDropDownItem: asDropDownItems,
        size: size,
        appearance: appearance,
        onClick: handleOnClick,
        isDisabled: isDisabled,
        ...actionProps
    });
};
var $02b4f62361713a29$export$2e2bcd8739ae039 = $02b4f62361713a29$var$ActionGroupItem;

});
parcelRegister("eJljw", function(module, exports) {

$parcel$export(module.exports, "CustomAction", () => (parcelRequire("lLAmK")).default);
$parcel$export(module.exports, "DeleteAction", () => (parcelRequire("6fkrT")).default);
$parcel$export(module.exports, "EditAction", () => (parcelRequire("gui89")).default);
$parcel$export(module.exports, "DownloadAction", () => (parcelRequire("daPVN")).default);
$parcel$export(module.exports, "FollowAction", () => (parcelRequire("iY7WF")).default);
$parcel$export(module.exports, "PreviewAction", () => (parcelRequire("dDX5p")).default);
$parcel$export(module.exports, "CopyLinkAction", () => (parcelRequire("8TjUj")).default);
$parcel$export(module.exports, "AISummaryAction", () => (parcelRequire("e5u7V")).default);
$parcel$export(module.exports, "AutomationAction", () => (parcelRequire("9QQRq")).default);
$parcel$export(module.exports, "ViewRelatedLinksAction", () => (parcelRequire("9razy")).default);

var $lLAmK = parcelRequire("lLAmK");

var $6fkrT = parcelRequire("6fkrT");

var $gui89 = parcelRequire("gui89");

var $daPVN = parcelRequire("daPVN");

var $iY7WF = parcelRequire("iY7WF");

var $dDX5p = parcelRequire("dDX5p");

var $8TjUj = parcelRequire("8TjUj");

var $e5u7V = parcelRequire("e5u7V");

var $9QQRq = parcelRequire("9QQRq");

var $9razy = parcelRequire("9razy");

});
parcelRegister("lLAmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ab2f99cd527f23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $27JBd = parcelRequire("27JBd");

var $48lKs = parcelRequire("48lKs");

var $eh8Nz = parcelRequire("eh8Nz");

var $32zsR = parcelRequire("32zsR");
/**
 * A base action that can be triggered with an on click.
 * @internal
 * @param {ActionProps} ActionProps - The props necessary for the Action.
 */ const $b5ab2f99cd527f23$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
    if (!onClick) return null;
    const isStackItem = as === 'stack-item';
    const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
    const actionIcon = icon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $32zsR.default), {
        asStackItemIcon: isStackItem,
        isDisabled: isDisabled,
        icon: icon,
        size: size,
        testId: testId
    });
    const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
    const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
    if (isStackItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27JBd.default), {
        content: content,
        icon: actionIcon,
        space: spaceInline,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss,
        tooltipOnHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown,
        hideTooltip: hideTooltip
    });
    if (isDropdownItem) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eh8Nz.default), {
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        testId: testId
    });
    const button = /*#__PURE__*/ (0, $byn9U.jsx)((0, $48lKs.default), {
        appearance: appearance,
        content: content,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isLoading: isLoading,
        onClick: onClick,
        overrideCss: overrideCss,
        size: size,
        testId: testId,
        tooltipMessage: tooltipMessage || content,
        isDisabled: isDisabled,
        href: href,
        ariaLabel: ariaLabel
    });
    return Wrapper !== undefined ? /*#__PURE__*/ (0, $byn9U.jsx)(Wrapper, null, button) : button;
};
var $b5ab2f99cd527f23$export$2e2bcd8739ae039 = $b5ab2f99cd527f23$var$Action;

});
parcelRegister("27JBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $885b23cdbf468f5a$export$2e2bcd8739ae039);

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $cVfTe = parcelRequire("cVfTe");
const $885b23cdbf468f5a$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
        ...props,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipMessage || content,
        onHide: tooltipOnHide,
        hideTooltipOnMouseDown: hideTooltipOnMouseDown
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVfTe.default), {
            ...props,
            content: content,
            tooltipProps: tooltipProps
        }));
var $885b23cdbf468f5a$export$2e2bcd8739ae039 = $885b23cdbf468f5a$var$ActionStackItem;

});
parcelRegister("cVfTe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f587baae0a0b39b$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $eUqFw = parcelRequire("eUqFw");

var $4z862 = parcelRequire("4z862");

var $32zsR = parcelRequire("32zsR");
const $6f587baae0a0b39b$var$buttonStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    padding: 'space.050',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
const $6f587baae0a0b39b$var$contentStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    // Replace with font token once it becomes stable (currently alpha)
    // font: 'font.body.small',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '20px'
});
const $6f587baae0a0b39b$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
    const space = spaceOption ?? (0, $4z862.getPrimitivesInlineSpaceBySize)(size);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
    }, [
        isDisabled,
        isLoading,
        onClickCallback
    ]);
    const icon = iconOption && isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $32zsR.default), {
        asStackItemIcon: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            testId: `${testId}-loading`
        }),
        size: size
    }) : iconOption;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: [
            $6f587baae0a0b39b$var$buttonStyles,
            xcss
        ],
        ...tooltipProps,
        onClick: onClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        grow: "fill",
        space: space
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6f587baae0a0b39b$var$contentStyles
    }, content))));
};
var $6f587baae0a0b39b$export$2e2bcd8739ae039 = $6f587baae0a0b39b$var$ActionButton;

});
parcelRegister("32zsR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cdb5dc66621388c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
const $5cdb5dc66621388c$var$getIconWidth = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Medium:
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '1rem';
    }
};
const $5cdb5dc66621388c$var$getIconStyles = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
    });
const $5cdb5dc66621388c$var$stackItemIconSizeStyles = (0, $4z862.getIconSizeStyles)('20px');
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5cdb5dc66621388c$var$stackItemIconStyles = /*#__PURE__*/ (0, $byn9U.css)($5cdb5dc66621388c$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
const $5cdb5dc66621388c$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $5cdb5dc66621388c$var$getIconStyles(isDisabled),
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            asStackItemIcon ? $5cdb5dc66621388c$var$stackItemIconStyles : (0, $4z862.getIconSizeStyles)($5cdb5dc66621388c$var$getIconWidth(size))
        ],
        "data-testid": `${testId}-icon`
    }, icon);
var $5cdb5dc66621388c$export$2e2bcd8739ae039 = $5cdb5dc66621388c$var$ActionIcon;

});



parcelRegister("48lKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e93679c6d64657cb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $7opLA = parcelRequire("7opLA");

var $8cU5f = parcelRequire("8cU5f");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");
function $e93679c6d64657cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e93679c6d64657cb$var$_ref = {
    name: "kaj2cp",
    styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
};
const $e93679c6d64657cb$var$getButtonStyle = (size, iconOnly)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).Large:
            return iconOnly ? $e93679c6d64657cb$var$_ref : '';
        case (0, $caOA9.SmartLinkSize).Small:
            return /*#__PURE__*/ (0, $byn9U.css)({
                fontSize: '0.75rem',
                fontWeight: 500,
                lineHeight: '1rem',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                'button, button:hover, button:focus, button:active': [
                    {
                        lineHeight: '1rem'
                    },
                    iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                ]
            });
        case (0, $caOA9.SmartLinkSize).XLarge:
        case (0, $caOA9.SmartLinkSize).Medium:
        default:
            return '';
    }
};
const $e93679c6d64657cb$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
    const iconOnly = !content;
    const onButtonClick = (0, $eUqFw.useCallback)((handler)=>(e)=>{
            e.preventDefault();
            handler();
        }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $e93679c6d64657cb$var$getButtonStyle(size, iconOnly),
            overrideCss
        ],
        "data-testid": `${testId}-button-wrapper`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipMessage,
        hideTooltipOnClick: true,
        testId: `${testId}-tooltip`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7opLA.default), {
        appearance: appearance,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onButtonClick(onClick),
        spacing: (0, $4z862.sizeToButtonSpacing)[size],
        testId: testId,
        href: href,
        "aria-label": ariaLabel
    }, content)));
};
var $e93679c6d64657cb$export$2e2bcd8739ae039 = $e93679c6d64657cb$var$ActionButton;

});

parcelRegister("eh8Nz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b98a59bc5a7d99$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hD6GJ = parcelRequire("hD6GJ");

var $9A6mL = parcelRequire("9A6mL");
const $b2b98a59bc5a7d99$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemAfter: iconAfter,
        elemBefore: iconBefore,
        isDisabled: isLoading,
        onClick: (0, $9A6mL.handleOnClick)(onClick),
        testId: testId
    }, content);
var $b2b98a59bc5a7d99$export$2e2bcd8739ae039 = $b2b98a59bc5a7d99$var$ActionDropdownItem;

});
parcelRegister("9A6mL", function(module, exports) {

$parcel$export(module.exports, "isCardWithData", () => $4e9a30041ebff1a9$export$f287576685db4026);
$parcel$export(module.exports, "isSpecialEvent", () => $4e9a30041ebff1a9$export$efca2c4705678489);
$parcel$export(module.exports, "getIconForFileType", () => $4e9a30041ebff1a9$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $4e9a30041ebff1a9$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $4e9a30041ebff1a9$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $4e9a30041ebff1a9$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $4e9a30041ebff1a9$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $4e9a30041ebff1a9$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $4e9a30041ebff1a9$export$a238cfe4a10e6279);
$parcel$export(module.exports, "combineFrameStyle", () => $4e9a30041ebff1a9$export$666eb6846f461ee6);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $4e9a30041ebff1a9$export$4470f298c61a79da);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $iednx = parcelRequire("iednx");
const $4e9a30041ebff1a9$export$f287576685db4026 = (props)=>!!props.data;
const $4e9a30041ebff1a9$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($4e9a30041ebff1a9$export$e6c5ffa684aac4d7() || $4e9a30041ebff1a9$export$d8de0cd37d316fdf(evt) || $4e9a30041ebff1a9$export$5b1771037ab7c451(evt));
const $4e9a30041ebff1a9$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $4e9a30041ebff1a9$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
const $4e9a30041ebff1a9$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $4e9a30041ebff1a9$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
    if (!fileMimeType) return;
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label, importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: label,
        testId: "document-file-format-icon"
    });
};
const $4e9a30041ebff1a9$export$371bef29a3733127 = (fileMimeType)=>{
    let icon = $4e9a30041ebff1a9$var$typeToIcon[fileMimeType.toLowerCase()];
    if (!icon) return;
    const [label] = icon;
    return label;
};


















































const $4e9a30041ebff1a9$var$typeToIcon = {
    'text/plain': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.oasis.opendocument.text': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.apple.pages': [
        'Document',
        ()=>Promise.resolve((parcelRequire("33pqc")))
    ],
    'application/vnd.google-apps.document': [
        'Google Doc',
        ()=>(parcelRequire("2Zwb9"))
    ],
    'application/msword': [
        'Word document',
        ()=>(parcelRequire("9pS0E"))
    ],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        'Word document',
        ()=>(parcelRequire("9pS0E"))
    ],
    'application/pdf': [
        'PDF document',
        ()=>(parcelRequire("iqKJJ"))
    ],
    'application/vnd.oasis.opendocument.spreadsheet': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("kaVAc")))
    ],
    'application/vnd.apple.numbers': [
        'Spreadsheet',
        ()=>Promise.resolve((parcelRequire("kaVAc")))
    ],
    'application/vnd.google-apps.spreadsheet': [
        'Google Sheet',
        ()=>(parcelRequire("kENAJ"))
    ],
    'application/vnd.ms-excel': [
        'Excel spreadsheet',
        ()=>(parcelRequire("dsRgj"))
    ],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        'Excel spreadsheet',
        ()=>(parcelRequire("dsRgj"))
    ],
    'application/vnd.oasis.opendocument.presentation': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("iIEQk")))
    ],
    'application/vnd.apple.keynote': [
        'Presentation',
        ()=>Promise.resolve((parcelRequire("iIEQk")))
    ],
    'application/vnd.google-apps.presentation': [
        'Google Slide',
        ()=>(parcelRequire("hMCpa"))
    ],
    'application/vnd.ms-powerpoint': [
        'PowerPoint presentation',
        ()=>(parcelRequire("4xnuT"))
    ],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
        'PowerPoint presentation',
        ()=>(parcelRequire("4xnuT"))
    ],
    'application/vnd.google-apps.form': [
        'Google Form',
        ()=>(parcelRequire("14hrM"))
    ],
    'image/png': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/jpeg': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/bmp': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/webp': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/svg+xml': [
        'Image',
        ()=>(parcelRequire("bvjMQ"))
    ],
    'image/gif': [
        'GIF',
        ()=>(parcelRequire("a0cSu"))
    ],
    'audio/midi': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/mpeg': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/webm': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/ogg': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'audio/wav': [
        'Audio',
        ()=>(parcelRequire("04uCN"))
    ],
    'video/mp4': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/quicktime': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/mov': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/webm': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/ogg': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/x-ms-wmv': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'video/x-msvideo': [
        'Video',
        ()=>(parcelRequire("bXPYz"))
    ],
    'application/zip': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-tar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-gtar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-7z-compressed': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/x-apple-diskimage': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/vnd.rar': [
        'Archive',
        ()=>(parcelRequire("hhmAa"))
    ],
    'application/dmg': [
        'Executable',
        ()=>(parcelRequire("az87C"))
    ],
    'text/css': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'text/html': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'application/javascript': [
        'Source Code',
        ()=>(parcelRequire("5XXvD"))
    ],
    'application/octet-stream': [
        'Binary file',
        ()=>Promise.resolve((parcelRequire("hC3Rz")))
    ],
    'application/invision.prototype': [
        'Prototype',
        ()=>Promise.resolve((parcelRequire("hC3Rz")))
    ],
    // TODO: Figure a way to detect those
    'application/sketch': [
        'Sketch',
        ()=>(parcelRequire("eyLKt"))
    ],
    folder: [
        'Folder',
        ()=>(parcelRequire("IR5Zr"))
    ]
};
const $4e9a30041ebff1a9$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $4e9a30041ebff1a9$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $4e9a30041ebff1a9$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $4e9a30041ebff1a9$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $4e9a30041ebff1a9$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $4e9a30041ebff1a9$export$e772c8ff12451969(interval);
            return $4e9a30041ebff1a9$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $4e9a30041ebff1a9$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $4e9a30041ebff1a9$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $4e9a30041ebff1a9$export$666eb6846f461ee6 = (frameStyle, isFrameVisible)=>{
    if (frameStyle !== undefined) return frameStyle;
    if (isFrameVisible) return 'show';
};
const $4e9a30041ebff1a9$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $iednx.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};

});



parcelRegister("6fkrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2513bc2d127363c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $jWuk1 = parcelRequire("jWuk1");
const $a2513bc2d127363c$var$DeleteAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "Delete"
        }),
        testId: "smart-action-delete-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).delete),
        ...props
    });
var $a2513bc2d127363c$export$2e2bcd8739ae039 = $a2513bc2d127363c$var$DeleteAction;

});

parcelRegister("gui89", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a1b155aa63a7698$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $bZ1Zi = parcelRequire("bZ1Zi");
const $6a1b155aa63a7698$var$EditAction = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZ1Zi))), {
            label: "Edit"
        }),
        testId: "smart-action-edit-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).edit),
        ...props
    });
var $6a1b155aa63a7698$export$2e2bcd8739ae039 = $6a1b155aa63a7698$var$EditAction;

});
parcelRegister("bZ1Zi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b96eef1afb7c03f$var$_react = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $8b96eef1afb7c03f$var$_edit = $8b96eef1afb7c03f$var$_interopRequireDefault((parcelRequire("e5yQJ")));
function $8b96eef1afb7c03f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8b96eef1afb7c03f$var$EditIcon = (props)=>/*#__PURE__*/ $8b96eef1afb7c03f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $8b96eef1afb7c03f$var$_edit.default
    }));
$8b96eef1afb7c03f$var$EditIcon.displayName = 'EditIcon';
var $8b96eef1afb7c03f$var$_default = module.exports.default = $8b96eef1afb7c03f$var$EditIcon;

});
parcelRegister("e5yQJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32c191357b748545769418a2438f72bf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a41c90bad15a5169$var$_react = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a41c90bad15a5169$var$_UNSAFE_baseNew = $a41c90bad15a5169$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a41c90bad15a5169$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a41c90bad15a5169$var$EditIcon = (props)=>/*#__PURE__*/ $a41c90bad15a5169$var$_react.default.createElement($a41c90bad15a5169$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9m-.75-4 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 8.979 9.521c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
    }, props));
$a41c90bad15a5169$var$EditIcon.displayName = 'EditIcon';
var $a41c90bad15a5169$var$_default = module.exports.default = $a41c90bad15a5169$var$EditIcon;

});



parcelRegister("daPVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5689d24bc37939$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9A6mL = parcelRequire("9A6mL");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $i9nBX = parcelRequire("i9nBX");
const $3f5689d24bc37939$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).DownloadAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data?.downloadUrl) {
            invoke({
                actionType: (0, $caOA9.ActionName).DownloadAction,
                actionFn: async ()=>(0, $9A6mL.downloadUrl)(data?.downloadUrl),
                // These values have already been set in analytics context.
                // We only pass these here for ufo experience.
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }
    }, [
        analytics,
        data?.downloadUrl,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const label = isStackItem ? (0, $4abrz.messages).download_file : (0, $4abrz.messages).download;
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).download_description : (0, $4abrz.messages).download;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i9nBX))), {
            label: "Download"
        }),
        onClick: onClick,
        testId: "smart-action-download-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props
    }) : null;
};
var $3f5689d24bc37939$export$2e2bcd8739ae039 = $3f5689d24bc37939$var$DownloadAction;

});
parcelRegister("3SJS1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a127f233fa1a4ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $2cI4y = parcelRequire("2cI4y");
const $5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $5a127f233fa1a4ad$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $eUqFw.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $hEsGF.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $2cI4y.startUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            analytics?.ui.actionClickedEvent({
                actionType: actionType,
                display: display
            });
            // Invoke action
            const result = await actionFn();
            $hEsGF.mark(markName, 'resolved');
            (0, $2cI4y.succeedUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            analytics?.operational.invokeSucceededEvent({
                actionType: actionType,
                display: display
            });
            return result;
        } catch (err) {
            $hEsGF.mark(markName, 'errored');
            (0, $2cI4y.failUfoExperience)($5a127f233fa1a4ad$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            analytics?.operational.invokeFailedEvent({
                actionType: actionType,
                display: display,
                reason: reason
            });
        }
    }, [
        analytics?.operational,
        analytics?.ui
    ]);
var $5a127f233fa1a4ad$export$2e2bcd8739ae039 = $5a127f233fa1a4ad$var$useInvokeClientAction;

});

parcelRegister("i9nBX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d36b61f12f7a705f$var$_react = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d36b61f12f7a705f$var$_download = $d36b61f12f7a705f$var$_interopRequireDefault((parcelRequire("9WkaC")));
function $d36b61f12f7a705f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d36b61f12f7a705f$var$DownloadIcon = (props)=>/*#__PURE__*/ $d36b61f12f7a705f$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $d36b61f12f7a705f$var$_download.default
    }));
$d36b61f12f7a705f$var$DownloadIcon.displayName = 'DownloadIcon';
var $d36b61f12f7a705f$var$_default = module.exports.default = $d36b61f12f7a705f$var$DownloadIcon;

});
parcelRegister("9WkaC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb1ef1149a66571c4f3afc5dc7ecc365>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $73c92d3b66138ed0$var$_react = $73c92d3b66138ed0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $73c92d3b66138ed0$var$_UNSAFE_baseNew = $73c92d3b66138ed0$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $73c92d3b66138ed0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $73c92d3b66138ed0$var$DownloadIcon = (props)=>/*#__PURE__*/ $73c92d3b66138ed0$var$_react.default.createElement($73c92d3b66138ed0$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
    }, props));
$73c92d3b66138ed0$var$DownloadIcon.displayName = 'DownloadIcon';
var $73c92d3b66138ed0$var$_default = module.exports.default = $73c92d3b66138ed0$var$DownloadIcon;

});



parcelRegister("iY7WF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4000632475db60c8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bPnXx = parcelRequire("bPnXx");

var $4z862 = parcelRequire("4z862");

var $5c3rh = parcelRequire("5c3rh");


const $4000632475db60c8$var$importIconMapper = {
    goal: ()=>(parcelRequire("6MTFz")).then(({ GoalIcon: GoalIcon })=>({
                default: GoalIcon
            })),
    projects: ()=>(parcelRequire("aw3dF")).then(({ ProjectsIcon: ProjectsIcon })=>({
                default: ProjectsIcon
            }))
};
const $4000632475db60c8$var$getIcon = (stackIconType)=>{
    const importFn = $4000632475db60c8$var$importIconMapper[stackIconType];
    if (!importFn) return null;
    return (0, $4z862.importIcon)(importFn);
};
const $4000632475db60c8$var$FollowAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.ActionName).FollowAction];
    if (!context || !actionData) return null;
    const { value: value, isProject: isProject, ...data } = actionData;
    const isStackItem = props.as === 'stack-item';
    const message = value ? (0, $4abrz.messages).follow : (0, $4abrz.messages).unfollow;
    const projectMessage = value ? (0, $4abrz.messages).follow_project : (0, $4abrz.messages).unfollow_project;
    const goalMessage = value ? (0, $4abrz.messages).follow_goal : (0, $4abrz.messages).unfollow_goal;
    const stackMessage = isProject ? projectMessage : goalMessage;
    const label = isStackItem ? stackMessage : message;
    const projectTooltipMessage = value ? (0, $4abrz.messages).follow_project_description : (0, $4abrz.messages).unfollow_project_description;
    const goalTooltipMessage = value ? (0, $4abrz.messages).follow_goal_description : (0, $4abrz.messages).unfollow_goal_description;
    const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
    const tooltipMessage = isStackItem ? stackTooltipMessage : message;
    const stackIconType = isProject ? 'projects' : 'goal';
    const ImportedIcon = $4000632475db60c8$var$getIcon(stackIconType);
    const followIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ImportedIcon, {
        label: "Follow",
        testId: `smart-action-follow-action-${stackIconType}-icon`
    });
    const handleError = ()=>{
        const { onError: onErrorCallback } = props;
        const errorMessage = (0, $5c3rh.getFollowActionErrorMessage)(isProject, value);
        onErrorCallback?.({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), errorMessage),
            appearance: 'error'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bPnXx.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), label),
        icon: followIcon,
        testId: "smart-action-follow-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        ...data,
        ...props,
        onError: handleError
    });
};
var $4000632475db60c8$export$2e2bcd8739ae039 = $4000632475db60c8$var$FollowAction;

});
parcelRegister("bPnXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fee58e6cedb3bfa7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fZ5ue = parcelRequire("fZ5ue");

var $8McbT = parcelRequire("8McbT");

var $af6S8 = parcelRequire("af6S8");

var $201mO = parcelRequire("201mO");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");
const $fee58e6cedb3bfa7$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $fZ5ue.default)();
    const reload = (0, $af6S8.default)();
    const handleClick = (0, $eUqFw.useCallback)(async ()=>{
        if (action) {
            const smartLinkActionType = action.action?.actionType;
            try {
                setIsLoading(true);
                analytics?.ui.smartLinkServerActionClickedEvent({
                    smartLinkActionType: smartLinkActionType
                });
                analytics?.track.smartLinkQuickActionStarted({
                    smartLinkActionType: smartLinkActionType
                });
                const request = (0, $201mO.default)(action);
                await invoke(request);
                analytics?.track.smartLinkQuickActionSuccess({
                    smartLinkActionType: smartLinkActionType
                });
                if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                setIsLoading(false);
                if (onClick) onClick();
            } catch (err) {
                setIsLoading(false);
                analytics?.track.smartLinkQuickActionFailed({
                    smartLinkActionType: smartLinkActionType,
                    reason: (0, $8McbT.getInvokeFailureReason)(err)
                });
                onErrorCallback?.();
            }
        }
    }, [
        action,
        analytics?.track,
        analytics?.ui,
        invoke,
        onClick,
        onErrorCallback,
        reload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        ...props,
        isLoading: isLoading,
        onClick: handleClick
    });
};
var $fee58e6cedb3bfa7$export$2e2bcd8739ae039 = $fee58e6cedb3bfa7$var$ServerAction;

});
parcelRegister("201mO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51aec3ddbd0b82b$export$2e2bcd8739ae039);
const $b51aec3ddbd0b82b$var$createInvokeRequest = (request, payload)=>({
        action: {
            ...request.action,
            payload: payload
        },
        providerKey: request.providerKey
    });
var $b51aec3ddbd0b82b$export$2e2bcd8739ae039 = $b51aec3ddbd0b82b$var$createInvokeRequest;

});


parcelRegister("5c3rh", function(module, exports) {

$parcel$export(module.exports, "getFollowActionErrorMessage", () => $caf136fdee970c8a$export$49248678d3914625);

var $4abrz = parcelRequire("4abrz");
const $caf136fdee970c8a$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
    if (isProject && isFollow) return (0, $4abrz.messages).follow_project_error;
    if (isProject && !isFollow) return (0, $4abrz.messages).unfollow_project_error;
    if (!isProject && isFollow) return (0, $4abrz.messages).follow_goal_error;
    if (!isProject && !isFollow) return (0, $4abrz.messages).unfollow_goal_error;
    return (0, $4abrz.messages).generic_error_message;
};

});

parcelRegister("6MTFz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("kGvxd").then(()=>parcelRequire('hSFb0'));

});

parcelRegister("aw3dF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2WhTq").then(()=>parcelRequire('9dFQg'));

});


parcelRegister("dDX5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e249092d4fa8c714$export$2e2bcd8739ae039);

var $22LS1 = parcelRequire("22LS1");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $3SJS1 = parcelRequire("3SJS1");

var $4z862 = parcelRequire("4z862");

var $lLAmK = parcelRequire("lLAmK");
const $e249092d4fa8c714$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).PreviewAction];
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data) invoke({
            actionType: (0, $caOA9.ActionName).PreviewAction,
            actionFn: async ()=>(0, $4z862.openEmbedModalWithFlexibleUiIcon)({
                    download: data?.downloadUrl,
                    extensionKey: analytics?.extensionKey,
                    analytics: analytics,
                    ...data
                }),
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    const isStackItem = props.as === 'stack-item';
    const tooltipMessage = isStackItem ? (0, $4abrz.messages).preview_description : (0, $4abrz.messages).preview_improved;
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-20003
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
            label: "Open preview"
        }),
        onClick: onClick,
        testId: "smart-action-preview-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        hideTooltipOnMouseDown: true,
        ...data,
        ...props
    }) : null;
};
var $e249092d4fa8c714$export$2e2bcd8739ae039 = $e249092d4fa8c714$var$PreviewAction;

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $17d0e6b497755428$var$_growDiagonal = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("8TYN8")));
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
    }, props, {
        newIcon: $17d0e6b497755428$var$_growDiagonal.default
    }));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = module.exports.default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;

});
parcelRegister("8TYN8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a69662d7c3f46d3a483d39154b3f1d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67b29db82a7ea305$var$_react = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $67b29db82a7ea305$var$_UNSAFE_baseNew = $67b29db82a7ea305$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $67b29db82a7ea305$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "GrowDiagonal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67b29db82a7ea305$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $67b29db82a7ea305$var$_react.default.createElement($67b29db82a7ea305$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
    }, props));
$67b29db82a7ea305$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
var $67b29db82a7ea305$var$_default = module.exports.default = $67b29db82a7ea305$var$GrowDiagonalIcon;

});



parcelRegister("8TjUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c2597fe5d03e9fc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $hUwRB = parcelRequire("hUwRB");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $3SJS1 = parcelRequire("3SJS1");
const $8c2597fe5d03e9fc$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const analytics = (0, $4AAjx.useFlexibleUiAnalyticsContext)();
    const invoke = (0, $3SJS1.default)({
        analytics: analytics
    });
    const data = context?.actions?.[(0, $caOA9.ActionName).CopyLinkAction];
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_url_to_clipboard);
    const onClick = (0, $eUqFw.useCallback)(()=>{
        if (data && data.url) invoke({
            actionType: (0, $caOA9.ActionName).CopyLinkAction,
            actionFn: async ()=>{
                await navigator.clipboard.writeText(data.url ?? '');
                setTooltipMessage((0, $4abrz.messages).copied_url_to_clipboard);
            },
            // These values have already been set in analytics context.
            // We only pass these here for ufo experience.
            display: analytics?.display,
            extensionKey: analytics?.extensionKey
        });
        if (onClickCallback) onClickCallback();
    }, [
        analytics,
        data,
        invoke,
        onClickCallback
    ]);
    return data ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_url_to_clipboard),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
            label: "copy url",
            size: "medium"
        }),
        onClick: onClick,
        testId: "smart-action-copy-link-action",
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_url_to_clipboard),
        ...data,
        ...props
    }) : null;
};
var $8c2597fe5d03e9fc$export$2e2bcd8739ae039 = $8c2597fe5d03e9fc$var$CopyLinkAction;

});

parcelRegister("e5u7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $911fbb2dd20043a1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AAjx = parcelRequire("4AAjx");

var $caOA9 = parcelRequire("caOA9");

var $47wdF = parcelRequire("47wdF");
const $911fbb2dd20043a1$var$AISummaryAction = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    return actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $47wdF.AISummaryActionComponent), {
        ...actionData,
        ...props
    }) : null;
};
var $911fbb2dd20043a1$export$2e2bcd8739ae039 = $911fbb2dd20043a1$var$AISummaryAction;

});
parcelRegister("47wdF", function(module, exports) {

$parcel$export(module.exports, "AISummaryActionComponent", () => $b6dae4aa0e47e00e$export$8eed96bc6d982595);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $04PAQ = parcelRequire("04PAQ");

var $b8pNE = parcelRequire("b8pNE");

var $5UoQc = parcelRequire("5UoQc");
const $b6dae4aa0e47e00e$export$8eed96bc6d982595 = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
    const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, $04PAQ.default)(url);
    (0, $eUqFw.useEffect)(()=>{
        onLoadingChange?.(status === 'loading');
    }, [
        onLoadingChange,
        status
    ]);
    return status === 'done' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8pNE.CopySummaryAction), {
        ...props,
        testId: testId,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5UoQc.AISummariseAction), {
        ...props,
        testId: testId,
        summariseUrl: summariseUrl,
        status: status
    });
};

});
parcelRegister("04PAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $060f4b6c56808cdc$export$2e2bcd8739ae039);

var $1qrFi = parcelRequire("1qrFi");
var $lnW6z = parcelRequire("lnW6z");

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");

var $2cI4y = parcelRequire("2cI4y");

var $b81Yi = parcelRequire("b81Yi");

var $jOo8k = parcelRequire("jOo8k");

var $8ru2D = parcelRequire("8ru2D");
const $060f4b6c56808cdc$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
const $060f4b6c56808cdc$var$useAISummaryAction = (url)=>{
    const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, $8ru2D.useAISummaryConfig)();
    const cardState = (0, $b81Yi.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const data = cardState.details?.data;
    const ari = data && (0, $1qrFi.extractAri)(data);
    const dataUrl = data && (0, $lnW6z.extractLink)(data) || '';
    const onStart = (0, $eUqFw.useCallback)((id)=>{
        (0, $2cI4y.startUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, []);
    const onSuccess = (0, $eUqFw.useCallback)((id)=>{
        fireEvent('operational.summary.success', {});
        (0, $2cI4y.succeedUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    const onError = (0, $eUqFw.useCallback)((id, reason)=>{
        /**
			 * Errors should only be counted to the SLO if they are not due to acceptable use violations
			 * HIPAA content detected or exceeding context length.
			 */ const isSloError = reason === undefined ? true : ![
            'ACCEPTABLE_USE_VIOLATIONS',
            'HIPAA_CONTENT_DETECTED',
            'EXCEEDING_CONTEXT_LENGTH_ERROR'
        ].includes(reason);
        fireEvent('operational.summary.failed', {
            reason: reason || null,
            isSloError: isSloError
        });
        (0, $2cI4y.failUfoExperience)($060f4b6c56808cdc$var$EXPERIENCE_NAME, id);
    }, [
        fireEvent
    ]);
    return (0, $jOo8k.useAISummary)({
        url: dataUrl,
        ari: ari,
        product: product,
        envKey: envKey,
        baseUrl: baseUrl,
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
var $060f4b6c56808cdc$export$2e2bcd8739ae039 = $060f4b6c56808cdc$var$useAISummaryAction;

});
parcelRegister("1qrFi", function(module, exports) {

$parcel$export(module.exports, "extractAri", () => $719f58b8f5cece0a$export$be18a6294fd426ec);
const $719f58b8f5cece0a$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
};

});

parcelRegister("lnW6z", function(module, exports) {

$parcel$export(module.exports, "extractLink", () => $798276e7999c5211$export$63f54cf4c5883620);

var $9W7HP = parcelRequire("9W7HP");
const $798276e7999c5211$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $9W7HP.extractUrlFromLinkJsonLd)(url);
    }
};

});

parcelRegister("45sl7", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $20285615fd58f92d$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::3fdfbbdbdb062babb9a2ab4e53454d79>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");


var $dHNAr = parcelRequire("dHNAr");
const $20285615fd58f92d$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireEvent = (0, $eUqFw.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $dHNAr.default)(...params));
        event.fire((0, $1695fa5341c6d031$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
const $1695fa5341c6d031$export$3f072f06b90c3985 = 'media';

parcelRegister("dHNAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9d05577ac8ffe9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::0d08fdca953a1eb1130683499e509165>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $dd9d05577ac8ffe9$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $dd9d05577ac8ffe9$export$2e2bcd8739ae039 = $dd9d05577ac8ffe9$var$createEventPayload;

});


parcelRegister("b81Yi", function(module, exports) {

$parcel$export(module.exports, "useSmartCardState", () => $e9516c66fbd4716f$export$b0444d00ba7313c6);

var $awFmn = parcelRequire("awFmn");

var $gqldc = parcelRequire("gqldc");
const $e9516c66fbd4716f$var$PENDING_STATE = {
    status: 'pending'
};
function $e9516c66fbd4716f$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const cardState = (0, $awFmn.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $e9516c66fbd4716f$var$PENDING_STATE;
}

});

parcelRegister("jOo8k", function(module, exports) {

$parcel$export(module.exports, "useAISummary", () => $8e7665aa4bc9eed3$export$becd8f2eba1bbd96);

var $eUqFw = parcelRequire("eUqFw");

var $iThCc = parcelRequire("iThCc");

var $96eVN = parcelRequire("96eVN");
const $8e7665aa4bc9eed3$export$becd8f2eba1bbd96 = (props)=>{
    const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
    const [state, setState] = (0, $eUqFw.useState)((0, $iThCc.AISummariesStore).get(url)?.state || {
        status: 'ready',
        content: ''
    });
    (0, $eUqFw.useEffect)(()=>{
        //do not create a service for the empty URL string when the link data is not yet available,
        //or the service has already been created and cached.
        if (url && !(0, $iThCc.AISummariesStore).get(url)) (0, $iThCc.AISummariesStore).set(url, new (0, $96eVN.AISummaryService)({
            url: url,
            ari: ari,
            baseUrl: baseUrl,
            product: product,
            envKey: envKey,
            onError: onError,
            onStart: onStart,
            onSuccess: onSuccess
        }));
        //returns function that calls unsubscribe method
        return (0, $iThCc.AISummariesStore).get(url)?.subscribe(setState);
    }, [
        url,
        baseUrl,
        onError,
        onStart,
        onSuccess,
        product,
        ari,
        envKey
    ]);
    const summariseUrl = ()=>{
        return (0, $iThCc.AISummariesStore).get(url)?.summariseUrl();
    };
    return {
        summariseUrl: summariseUrl,
        state: state
    };
};

});
parcelRegister("iThCc", function(module, exports) {

$parcel$export(module.exports, "AISummariesStore", () => $a00dd5447fec502f$export$6979339b6d41707e);

var $6roQF = parcelRequire("6roQF");
const $a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE = 100;
const $a00dd5447fec502f$export$6979339b6d41707e = new (0, $6roQF.LRUMap)($a00dd5447fec502f$var$AI_SUMMARY_CACHE_SIZE);

});

parcelRegister("96eVN", function(module, exports) {

$parcel$export(module.exports, "AISummaryService", () => $4ceaf946d9c480f1$export$73e4b807d5bd74b6);

var $hompL = parcelRequire("hompL");

var $906lw = parcelRequire("906lw");

var $7h3kH = parcelRequire("7h3kH");

var $03QE9 = parcelRequire("03QE9");

var $dUrSu = parcelRequire("dUrSu");
class $4ceaf946d9c480f1$export$73e4b807d5bd74b6 {
    constructor(props){
        this.state = {
            content: '',
            status: 'ready'
        };
        this.subscribedStateSetters = new Set();
        this.getRequestUrl = (envKey, baseUrlOverride)=>{
            const path = 'assist/chat/v1/invoke_agent/stream';
            if (baseUrlOverride || envKey) {
                const baseUrl = baseUrlOverride || (0, $dUrSu.getBaseUrl)(envKey);
                return (0, $7h3kH.addPath)(baseUrl, path);
            }
            return (0, $7h3kH.addPath)('/gateway/api/', path);
        };
        this.fetchStream = async ()=>{
            const payload = {
                recipient_agent_named_id: 'summary_agent',
                agent_input_context: {
                    content_url: this.url,
                    content_ari: this.ari,
                    prompt_id: 'smart_links',
                    summary_output_mimetype: 'text/markdown'
                }
            };
            const options = {
                method: 'POST',
                headers: this.config.headers,
                body: JSON.stringify(payload),
                credentials: 'include'
            };
            const response = await fetch(this.config.requestUrl, options);
            if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
            else return (0, $03QE9.readStream)(response);
        };
        this.config = {
            requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'x-experience-id': 'smart-link',
                'x-product': (0, $7h3kH.getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
            }
        };
        this.url = props.url;
        this.ari = props.ari;
        this.onStart = props.onStart;
        this.onSuccess = props.onSuccess;
        this.onError = props.onError;
    }
    async summariseUrl() {
        this.state = {
            status: 'loading',
            content: ''
        };
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))();
        try {
            this.onStart?.(id);
            const stream = await this.fetchStream();
            let bufferContent = '';
            for await (const chunk of stream){
                if (chunk.type === 'ANSWER_PART') {
                    bufferContent += chunk.message.content;
                    for (const subscriber of this.subscribedStateSetters)subscriber({
                        ...this.state,
                        content: bufferContent
                    });
                }
                //if AI Mate service returns cached summary we get the summary text in one piece as the last message
                if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                if (chunk.type === 'ERROR') throw new Error(chunk?.message?.message_template);
            }
            this.onSuccess?.(id);
            this.state = {
                status: 'done',
                content: bufferContent
            };
        } catch (err) {
            let message = err instanceof Error && this.isExpectedError(err.message) ? err.message : 'UNEXPECTED';
            this.onError?.(id, message);
            this.state = {
                status: 'error',
                content: '',
                error: message
            };
        }
        for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
        return this.state;
    }
    isExpectedError(value) {
        return typeof value === 'string' && (0, $906lw.errorMessages).some((a)=>a === value);
    }
    subscribe(stateSetter) {
        this.subscribedStateSetters.add(stateSetter);
        return ()=>{
            this.subscribedStateSetters.delete(stateSetter);
        };
    }
}

});
parcelRegister("906lw", function(module, exports) {

$parcel$export(module.exports, "errorMessages", () => $5cf044834cb63238$export$d8bd0967cb58683);
const $5cf044834cb63238$export$d8bd0967cb58683 = [
    'NETWORK_ERROR',
    'NO_ANSWER',
    'RATE_LIMIT',
    'NO_AGENT',
    'PLUGIN_ERRORED',
    'OPENAI_RATE_LIMIT_USER_ABUSE',
    'ACCEPTABLE_USE_VIOLATIONS',
    'AI_DISABLED',
    'UNEXPECTED',
    'HIPAA_CONTENT_DETECTED',
    'EXCEEDING_CONTEXT_LENGTH_ERROR'
];

});

parcelRegister("7h3kH", function(module, exports) {

$parcel$export(module.exports, "getBufferReader", () => $b6cc5b1d42af4557$export$f6383c3ea1307da9);
$parcel$export(module.exports, "addPath", () => $b6cc5b1d42af4557$export$4c25481b843feb0b);
$parcel$export(module.exports, "getXProductHeaderValue", () => $b6cc5b1d42af4557$export$ff2962de2b2c930f);
const $b6cc5b1d42af4557$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
const $b6cc5b1d42af4557$export$4c25481b843feb0b = (baseUrl, path)=>{
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
/**
 * Subset of a map of Jira `ProductTypes` to AI Mate expected values
 * See for more info: https://atlassian.slack.com/archives/C066UP0G0G3/p1716341647677829?thread_ts=1716338063.255939&cid=C066UP0G0G3
 */ const $b6cc5b1d42af4557$var$AiMateJiraXProduct = {
    JSM: 'JSM',
    JSW: 'JIRA-SOFTWARE',
    JWM: 'JIRA-CORE',
    JPD: 'JPD'
};
/**
 * Checks if `product` is a Jira related product.
 */ const $b6cc5b1d42af4557$var$isJiraProduct = (product)=>{
    const JIRA_PRODUCTS = [
        'JPD',
        'JSM',
        'JSW',
        'JWM'
    ];
    return product !== undefined && JIRA_PRODUCTS.includes(product);
};
const $b6cc5b1d42af4557$export$ff2962de2b2c930f = (product)=>{
    if ($b6cc5b1d42af4557$var$isJiraProduct(product)) return $b6cc5b1d42af4557$var$AiMateJiraXProduct[product];
    return product;
};

});

parcelRegister("03QE9", function(module, exports) {

$parcel$export(module.exports, "readStream", () => $8a24a33dc932f4e5$export$e45226161c660403);

var $7h3kH = parcelRequire("7h3kH");
async function* $8a24a33dc932f4e5$export$e45226161c660403(response) {
    const reader = (0, $7h3kH.getBufferReader)(response);
    let doneStreaming = false;
    let chunkBuffer = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const processedChunks = `${chunkBuffer}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            chunkBuffer = '';
            for (let chunk of processedChunks)try {
                const jsonChunk = JSON.parse(chunk);
                if (jsonChunk.type === 'ERROR') reader.cancel();
                yield jsonChunk;
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                chunkBuffer = chunk;
            }
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else {
            reader.cancel();
            throw e;
        }
    }
    while (!doneStreaming);
    if (chunkBuffer) {
        const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
        throw error;
    }
}

});



parcelRegister("8ru2D", function(module, exports) {

$parcel$export(module.exports, "useAISummaryConfig", () => $4403e58f54b47af1$export$4480af2c00aa7ebe);

var $gqldc = parcelRequire("gqldc");

var $eUqFw = parcelRequire("eUqFw");
const $4403e58f54b47af1$export$4480af2c00aa7ebe = ()=>{
    const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    return (0, $eUqFw.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            isAdminHubAIEnabled: isAdminHubAIEnabled
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        isAdminHubAIEnabled
    ]);
};

});


parcelRegister("b8pNE", function(module, exports) {

$parcel$export(module.exports, "CopySummaryAction", () => $42b519d5e1f81e55$export$cfa1d3eed9a61059);

var $eUqFw = parcelRequire("eUqFw");

var $dmCPj = parcelRequire("dmCPj");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");
function $42b519d5e1f81e55$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const [tooltipMessage, setTooltipMessage] = (0, $eUqFw.useState)((0, $4abrz.messages).copy_summary_action_description);
    const handleCopySummaryClick = (0, $eUqFw.useCallback)(async ()=>{
        fireEvent('ui.button.clicked.copySummary', {});
        await navigator.clipboard.writeText(content ?? '');
        setTooltipMessage((0, $4abrz.messages).copied_summary_action_description);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).copy_summary_action),
        // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))), {
            label: "Copy Summary"
        }),
        onClick: handleCopySummaryClick,
        testId: `${testId}-copy-summary-action`,
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), tooltipMessage),
        tooltipOnHide: ()=>setTooltipMessage((0, $4abrz.messages).copy_summary_action_description),
        ...props
    });
}

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9bab72963b78cefe$var$_copy = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("dBCpP")));
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
    }, props, {
        newIcon: $9bab72963b78cefe$var$_copy.default
    }));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = module.exports.default = $9bab72963b78cefe$var$CopyIcon;

});
parcelRegister("dBCpP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7c6c8cdb896d771e123a497630ca2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e7c879c9eefdea2$var$_react = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9e7c879c9eefdea2$var$_UNSAFE_baseNew = $9e7c879c9eefdea2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9e7c879c9eefdea2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e7c879c9eefdea2$var$CopyIcon = (props)=>/*#__PURE__*/ $9e7c879c9eefdea2$var$_react.default.createElement($9e7c879c9eefdea2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
    }, props));
$9e7c879c9eefdea2$var$CopyIcon.displayName = 'CopyIcon';
var $9e7c879c9eefdea2$var$_default = module.exports.default = $9e7c879c9eefdea2$var$CopyIcon;

});



parcelRegister("5UoQc", function(module, exports) {

$parcel$export(module.exports, "AISummariseAction", () => $0bc861f7676c4d20$export$75a19de44af58722);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $lLAmK = parcelRequire("lLAmK");

var $fN7pY = parcelRequire("fN7pY");

var $4abrz = parcelRequire("4abrz");

var $45sl7 = parcelRequire("45sl7");

var $exKwM = parcelRequire("exKwM");
function $0bc861f7676c4d20$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onCompleted = (0, $eUqFw.useCallback)((state)=>{
        if (state?.status === 'error') onErrorCallback?.((0, $exKwM.getErrorMessage)(state.error));
    }, [
        onErrorCallback
    ]);
    const handleActionClick = (0, $eUqFw.useCallback)(()=>{
        fireEvent('ui.button.clicked.aiSummary', {});
        fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        });
        summariseUrl()?.then(onCompleted, onCompleted);
        onClickCallback?.();
    }, [
        fireEvent,
        onClickCallback,
        onCompleted,
        summariseUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
            label: "Summarise with AI"
        }),
        onClick: handleActionClick,
        testId: `${testId}-summarise-action`,
        isLoading: status === 'loading',
        tooltipMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summary_action_description),
        ...props
    });
}

});
parcelRegister("fN7pY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c379c2d8e36be306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications
 */ const $c379c2d8e36be306$var$AiIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: "var(--ds-icon, #44546F)"
    })));
var $c379c2d8e36be306$export$2e2bcd8739ae039 = $c379c2d8e36be306$var$AiIcon;

});

parcelRegister("exKwM", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $7d236111ed75f623$export$82f46aa4e6535a45);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hZwiw = parcelRequire("hZwiw");

var $bJ9S9 = parcelRequire("bJ9S9");

var $fv3b5 = parcelRequire("fv3b5");
const $7d236111ed75f623$export$82f46aa4e6535a45 = (error)=>{
    const { message: message, url: url } = (0, $hZwiw.getAISummaryErrorMessage)(error);
    return {
        appearance: 'error',
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bJ9S9.default), {
            reason: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...message,
            values: {
                a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fv3b5.default), {
                        href: url
                    }, chunks)
            }
        }))
    };
};

});
parcelRegister("hZwiw", function(module, exports) {

$parcel$export(module.exports, "getIsAISummaryEnabled", () => $13fbd6746cda9c21$export$d439c74cb206ff29);
$parcel$export(module.exports, "getAISummaryErrorMessage", () => $13fbd6746cda9c21$export$cd2e891d7f87074d);

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $13fbd6746cda9c21$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
const $13fbd6746cda9c21$export$cd2e891d7f87074d = (error)=>{
    switch(error){
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                message: (0, $4abrz.messages).ai_summary_error_acceptable_use_violation,
                url: (0, $caOA9.CONTENT_URL_ACCEPTABLE_USE_POLICY)
            };
        case 'HIPAA_CONTENT_DETECTED':
            return {
                message: (0, $4abrz.messages).ai_summary_error_hipaa_content_detected
            };
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return {
                message: (0, $4abrz.messages).ai_summary_error_exceeding_context_length_error
            };
        default:
            return {
                message: (0, $4abrz.messages).ai_summary_error_generic,
                url: (0, $caOA9.CONTENT_URL_AI_TROUBLESHOOTING)
            };
    }
};

});

parcelRegister("bJ9S9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f231676b33723539$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $f231676b33723539$var$AIEventErrorViewed = ({ reason: reason })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.error.viewed.aiSummary', {
            reason: reason
        });
    }, [
        fireEvent,
        reason
    ]);
    return null;
};
var $f231676b33723539$export$2e2bcd8739ae039 = $f231676b33723539$var$AIEventErrorViewed;

});

parcelRegister("fv3b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed25baefb28285c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");
const $0ed25baefb28285c$var$AILearnMoreAnchor = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: (0, $caOA9.CONTENT_URL_AI),
        target: "_blank",
        rel: "noopener noreferrer",
        ...props
    }, children);
var $0ed25baefb28285c$export$2e2bcd8739ae039 = $0ed25baefb28285c$var$AILearnMoreAnchor;

});





parcelRegister("9QQRq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f1aac8212e0f674$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jgpX5 = parcelRequire("jgpX5");

var $lLAmK = parcelRequire("lLAmK");

var $4AAjx = parcelRequire("4AAjx");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");

var $1tnZc = parcelRequire("1tnZc");

const $8f1aac8212e0f674$var$AutomationModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("aDQEB")));
const $8f1aac8212e0f674$var$AutomationAction = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const { onClick: onClickCallback } = props;
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const automationActionData = context?.actions?.[(0, $caOA9.ActionName).AutomationAction];
    const automationActionOnClick = (0, $eUqFw.useCallback)((automationActionData)=>{
        const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
        fireEvent('ui.button.clicked.automationAction', {});
        const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, $1tnZc.getModalContent)(product, resourceType) || {};
        const automationModalTitle = modalTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), modalTitle) : undefined;
        const automationModalDescription = modalDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...modalDescription,
            values: {
                name: objectName,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks),
                br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
            }
        }) : undefined;
        modal.open(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f1aac8212e0f674$var$AutomationModal, {
            baseAutomationUrl: baseAutomationUrl,
            objectAri: objectAri,
            siteAri: siteAri,
            canManageAutomation: canManageAutomation,
            analyticsSource: analyticsSource,
            modalTitle: automationModalTitle,
            modalDescription: automationModalDescription,
            onClose: ()=>modal.close()
        }));
        onClickCallback?.();
    }, [
        modal,
        onClickCallback,
        fireEvent
    ]);
    if (!automationActionData) return null;
    const automationActionTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_title);
    const automationActionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).automation_action_tooltip);
    const automationActionIconLabel = formatMessage((0, $4abrz.messages).automation_action_icon_label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lLAmK.default), {
        content: automationActionTitle,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgpX5.default), {
            label: automationActionIconLabel
        }),
        testId: "smart-action-automation-action",
        tooltipMessage: automationActionTooltip,
        ...props,
        onClick: ()=>automationActionOnClick(automationActionData)
    }));
};
var $8f1aac8212e0f674$export$2e2bcd8739ae039 = $8f1aac8212e0f674$var$AutomationAction;

});
parcelRegister("jgpX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbd431ca61fafd84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbd431ca61fafd84$var$AutomationManualTriggersGlyph = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        "aria-label": label,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
var $bbd431ca61fafd84$export$2e2bcd8739ae039 = $bbd431ca61fafd84$var$AutomationManualTriggersGlyph;

});

parcelRegister("iNbFo", function(module, exports) {

$parcel$export(module.exports, "SmartLinkModalProvider", () => $6a9669e2457be519$export$bb4eb02a83e1a0f8);
$parcel$export(module.exports, "useSmartLinkModal", () => $6a9669e2457be519$export$1fd7f5f21a6d6cb8);

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $4kwA4 = parcelRequire("4kwA4");
const $6a9669e2457be519$var$FALLBACK_API = {
    open: ()=>{},
    close: ()=>{}
};
const $6a9669e2457be519$export$f4c0a0f23ba57f8c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($6a9669e2457be519$var$FALLBACK_API);
const $6a9669e2457be519$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $eUqFw.useState)(null);
    const api = (0, $eUqFw.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kwA4.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $eUqFw.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $eUqFw.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a9669e2457be519$export$f4c0a0f23ba57f8c.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};
const $6a9669e2457be519$export$1fd7f5f21a6d6cb8 = ()=>(0, $eUqFw.useContext)($6a9669e2457be519$export$f4c0a0f23ba57f8c);

});
parcelRegister("4kwA4", function(module, exports) {

$parcel$export(module.exports, "StopPropagation", () => $7985491467a1c6bf$export$3e100bc08448f36c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
function $7985491467a1c6bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7985491467a1c6bf$var$styles = {
    name: "g32yti",
    styles: "max-height:0;max-width:0;position:absolute"
};
const $7985491467a1c6bf$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $eUqFw.useCallback)((e)=>{
        // Prevent click event inside modal from bubble up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $7985491467a1c6bf$var$styles,
        onClick: onClick
    }, children);
};

});


parcelRegister("1tnZc", function(module, exports) {

$parcel$export(module.exports, "getModalContent", () => $15c366388beaffc3$export$93e707b363eaf5c8);

var $4abrz = parcelRequire("4abrz");
const $15c366388beaffc3$export$93e707b363eaf5c8 = (product, resourceType)=>{
    const modalContentMap = {
        confluence: {
            page: {
                modalTitle: (0, $4abrz.messages).automation_action_confluence_page_modal_title,
                modalDescription: (0, $4abrz.messages).automation_action_confluence_page_modal_description
            }
        }
    };
    return modalContentMap?.[product]?.[resourceType];
};

});

parcelRegister("aDQEB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hKMCy")
]).then(()=>parcelRequire('lRKyt'));

});


parcelRegister("9razy", function(module, exports) {

$parcel$export(module.exports, "default", () => $10dd6358c7ba1901$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lLAmK = parcelRequire("lLAmK");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $4AAjx = parcelRequire("4AAjx");

var $bP3BY = parcelRequire("bP3BY");

var $eUqFw = parcelRequire("eUqFw");

var $iNbFo = parcelRequire("iNbFo");

var $45sl7 = parcelRequire("45sl7");

const $10dd6358c7ba1901$var$RelatedLinksModal = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("dbUjg")));
const $10dd6358c7ba1901$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
    const modal = (0, $iNbFo.useSmartLinkModal)();
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.ViewRelatedLinksAction;
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        const ari = actionData?.ari;
        if (ari) modal.open(/*#__PURE__*/ (0, $byn9U.jsx)($10dd6358c7ba1901$var$RelatedLinksModal, {
            ari: ari,
            showModal: true,
            onClose: ()=>modal.close()
        }));
        fireEvent('ui.button.clicked.relatedLinks', {});
        onClickCallback?.();
    }, [
        actionData?.ari,
        fireEvent,
        modal,
        onClickCallback
    ]);
    return actionData ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $lLAmK.default), {
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).related_links_view_related_urls),
        icon: /*#__PURE__*/ (0, $byn9U.jsx)((0, $bP3BY.default), null),
        onClick: onClick,
        testId: "smart-action-view-related-links-action",
        ariaLabel: "View most recent pages or content types coming from or found on this link",
        ...props
    }) : null;
};
var $10dd6358c7ba1901$export$2e2bcd8739ae039 = $10dd6358c7ba1901$var$ViewRelatedLinksAction;

});
parcelRegister("bP3BY", function(module, exports) {

$parcel$export(module.exports, "default", () => $091bd7b6fd540225$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jfQfF = parcelRequire("jfQfF");
function $091bd7b6fd540225$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $091bd7b6fd540225$var$rotateSvg = {
    name: "9v7l5f",
    styles: "transform:rotate(180deg);display:inline-block"
};
/**
 * ChildIssuesIcon but 180 degrees rotated
 */ const $091bd7b6fd540225$var$RelatedLinksActionIcon = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $091bd7b6fd540225$var$rotateSvg
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
        label: "View recent links..."
    }));
var $091bd7b6fd540225$export$2e2bcd8739ae039 = $091bd7b6fd540225$var$RelatedLinksActionIcon;

});
parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e047f322faad4563$var$_childIssues = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("hudZr")));
function $e047f322faad4563$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
    }, props, {
        newIcon: $e047f322faad4563$var$_childIssues.default
    }));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = module.exports.default = $e047f322faad4563$var$ChildIssuesIcon;

});
parcelRegister("hudZr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84cbfeef7a88f21c194aee533f5af188>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cbb01725e51449c9$var$_react = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cbb01725e51449c9$var$_UNSAFE_baseNew = $cbb01725e51449c9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cbb01725e51449c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cbb01725e51449c9$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $cbb01725e51449c9$var$_react.default.createElement($cbb01725e51449c9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
    }, props));
$cbb01725e51449c9$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $cbb01725e51449c9$var$_default = module.exports.default = $cbb01725e51449c9$var$ChildIssuesIcon;

});



parcelRegister("dbUjg", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("2hmUs"),
    $d1Cng("bCeK4"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("e8loy")
]).then(()=>parcelRequire('ixfFh'));

});





parcelRegister("7GItJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef467f6c35c7534c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4z862 = parcelRequire("4z862");
function $ef467f6c35c7534c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ef467f6c35c7534c$var$_ref = {
    name: "3l7cjm",
    styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
};
var $ef467f6c35c7534c$var$_ref2 = {
    name: "1ofqdyp",
    styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
};
const $ef467f6c35c7534c$var$getAlignmentStyles = (align)=>{
    switch(align){
        case (0, $caOA9.SmartLinkAlignment).Right:
            return $ef467f6c35c7534c$var$_ref2;
        case (0, $caOA9.SmartLinkAlignment).Left:
        default:
            return $ef467f6c35c7534c$var$_ref;
    }
};
const $ef467f6c35c7534c$var$getGapStyles = (size, align)=>{
    const gap = (0, $d2BrZ.getGapSize)(size);
    if (align === (0, $caOA9.SmartLinkAlignment).Right) return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginLeft: `${gap}rem`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:first-child': {
            marginLeft: 'initial'
        }
    });
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            marginRight: `${gap}rem`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:last-child': {
                marginRight: 'initial'
            }
        }
    });
};
const $ef467f6c35c7534c$var$getHorizontalDirectionStyles = (size, align)=>{
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("display:block;vertical-align:middle;", (0, $4z862.getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ef467f6c35c7534c$var$getGapStyles(size, align), ";");
};
const $ef467f6c35c7534c$export$91d118d179d992a4 = (direction, size, align, width, position)=>/*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $d2BrZ.getBaseStyles)(direction, size), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ef467f6c35c7534c$var$getAlignmentStyles(align), "min-width:10%;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    width === (0, $caOA9.SmartLinkWidth).Flexible ? `flex: 1 3;` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    direction === (0, $caOA9.SmartLinkDirection).Horizontal ? $ef467f6c35c7534c$var$getHorizontalDirectionStyles(size, align) : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    position === (0, $caOA9.SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
/**
 * Creates a group of Action components. Accepts an array of Actions, in addition to some styling
 * preferences.
 * @internal
 * @param {ActionGroupProps} ActionGroupProps
 * @see Action
 */ const $ef467f6c35c7534c$var$ElementGroup = ({ align: align = (0, $caOA9.SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, $caOA9.SmartLinkDirection).Horizontal, size: size = (0, $caOA9.SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, $caOA9.SmartLinkWidth).FitToContent, position: position = (0, $caOA9.SmartLinkPosition).Center })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $ef467f6c35c7534c$export$91d118d179d992a4(direction, size, align, width, position),
            overrideCss
        ],
        "data-smart-element-group": true,
        "data-testid": testId
    }, (0, $d2BrZ.renderChildren)(children, size));
var $ef467f6c35c7534c$export$2e2bcd8739ae039 = $ef467f6c35c7534c$var$ElementGroup;

});



parcelRegister("cIk4w", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fdb61e49b433fdb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $d2BrZ = parcelRequire("d2BrZ");

var $4sQhG = parcelRequire("4sQhG");

var $7GItJ = parcelRequire("7GItJ");

var $4z862 = parcelRequire("4z862");
const $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES = 2;
const $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES = 1;
const $6fdb61e49b433fdb$var$getElementGroupStyles = (size, maxLines)=>{
    // MetadataBlock allows metadata elements to be displayed in
    // multiple lines, with maximum of 2 lines.
    // We need the height of the line to be equal on both left and right
    // sides so they line up nicely.
    const lineHeight = (0, $4z862.getMaxLineHeight)(size);
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${lineHeight}rem`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(maxLines, lineHeight + 'rem'));
};
const $6fdb61e49b433fdb$var$getMaxLines = (maxLines)=>{
    if (maxLines > $6fdb61e49b433fdb$var$MAXIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES;
    if (maxLines < $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES) return $6fdb61e49b433fdb$var$MINIMUM_MAX_LINES;
    return maxLines;
};
/**
 * Represents a MetadataBlock, designed to contain groups of metadata in the form of elements.
 * Accepts an array of elements to be shown either primary (left hand side) or secondary (right hand side).
 * @public
 * @param {MetadataBlockProps} MetadataBlockProps
 * @see Block
 */ const $6fdb61e49b433fdb$var$MetadataBlock = ({ maxLines: maxLines = $6fdb61e49b433fdb$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    if (primary.length === 0 && secondary.length === 0 || status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    const primaryElements = (0, $d2BrZ.renderElementItems)(primary);
    const secondaryElements = (0, $d2BrZ.renderElementItems)(secondary);
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const elementGroupStyles = $6fdb61e49b433fdb$var$getElementGroupStyles(size, $6fdb61e49b433fdb$var$getMaxLines(maxLines));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`
    }, primaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Left,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, primaryElements), secondaryElements && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GItJ.default), {
        align: (0, $caOA9.SmartLinkAlignment).Right,
        overrideCss: elementGroupStyles,
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        width: (0, $caOA9.SmartLinkWidth).Flexible
    }, secondaryElements));
};
var $6fdb61e49b433fdb$export$2e2bcd8739ae039 = $6fdb61e49b433fdb$var$MetadataBlock;

});

parcelRegister("d9NWW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0f26c88235b3036$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $l5CPU = parcelRequire("l5CPU");
/**
 * Represents a PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlockProps} PreviewBlock
 * @see Block
 */ const $f0f26c88235b3036$var$PreviewBlock = ({ status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5CPU.default), {
        ...blockProps,
        testId: testId,
        overrideUrl: overrideUrl
    });
};
var $f0f26c88235b3036$export$2e2bcd8739ae039 = $f0f26c88235b3036$var$PreviewBlock;

});
parcelRegister("l5CPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $895a212ba51d5e0c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $2mW0Z = parcelRequire("2mW0Z");
function $895a212ba51d5e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Due to its placement on the left/right and ignoreContainerPadding prop
 * rely on its parent container styling, css variables are declared in
 * <Container /> to preset the base values for the preview block styling.
 *
 * `--container-padding` is the padding of the Container. This value is based
 *   on size and hidePadding.
 * `--container-gap-left` and `--container-gap-right` are the gap or padding of
 *   the Container depending on whether the container has other preview blocks
 *   with left/right positioning.
 * `--preview-block-width` is the size of the preview image in relation to
 *   the Container width when the placement is left/right.
 * @param placement
 * @param ignoreContainerPadding
 */ var $895a212ba51d5e0c$var$_ref = {
    name: "ooh6hm",
    styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
};
const $895a212ba51d5e0c$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
    if (placement === (0, $caOA9.MediaPlacement).Left || placement === (0, $caOA9.MediaPlacement).Right) {
        const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
        // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $byn9U.css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, $caOA9.MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, $caOA9.MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
    }
    if (ignoreContainerPadding) return $895a212ba51d5e0c$var$_ref;
};
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $895a212ba51d5e0c$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
    const [styles, setStyles] = (0, $eUqFw.useState)(overrideCss);
    const updateStyles = (0, $eUqFw.useCallback)(()=>{
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        setStyles(/*#__PURE__*/ (0, $byn9U.css)($895a212ba51d5e0c$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement
    ]);
    (0, $eUqFw.useEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        overrideCss,
        placement,
        updateStyles
    ]);
    const handleOnLoad = (0, $eUqFw.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $eUqFw.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        overrideCss: styles,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2mW0Z.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $895a212ba51d5e0c$export$2e2bcd8739ae039 = $895a212ba51d5e0c$var$PreviewBlockResolvedView;

});


parcelRegister("bTLTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c244300e3064a1f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $jtGWU = parcelRequire("jtGWU");

var $4z862 = parcelRequire("4z862");
const $2c244300e3064a1f$var$DEFAULT_MAX_LINES = 3;
const $2c244300e3064a1f$var$MAXIMUM_MAX_LINES = 6;
const $2c244300e3064a1f$var$MINIMUM_MAX_LINES = 1;
/**
 * Represents a SnippetBlock, which is used to display longer form text content, like descriptions.
 * @public
 * @param {SnippetBlockProps} SnippetBlockProps
 * @see Block
 */ const $2c244300e3064a1f$var$SnippetBlock = ({ maxLines: maxLines = $2c244300e3064a1f$var$DEFAULT_MAX_LINES, status: status = (0, $caOA9.SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $4z862.getMaxLines)(maxLines, $2c244300e3064a1f$var$DEFAULT_MAX_LINES, $2c244300e3064a1f$var$MAXIMUM_MAX_LINES, $2c244300e3064a1f$var$MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-${statusTestId}-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jtGWU.default), {
        maxLines: snippetMaxLines,
        content: text
    }));
};
var $2c244300e3064a1f$export$2e2bcd8739ae039 = $2c244300e3064a1f$var$SnippetBlock;

});

parcelRegister("8jYmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef2bdb59e926ed8a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $bFzGY = parcelRequire("bFzGY");

var $jOVzD = parcelRequire("jOVzD");

var $buene = parcelRequire("buene");

var $44yzk = parcelRequire("44yzk");

var $aguBP = parcelRequire("aguBP");

var $iWItW = parcelRequire("iWItW");
function $ef2bdb59e926ed8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Represents a block to display related resources of a url
 */ var $ef2bdb59e926ed8a$var$_ref = {
    name: "1ftjnda",
    styles: "min-height:1.55rem"
};
const $ef2bdb59e926ed8a$var$RelatedUrlsBlock = ({ testId: testId = 'smart-block-related-urls', url: url, renderers: renderers, ...blockProps })=>{
    (0, $asu8X.di)((0, $jOVzD.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [loadingRelatedUrls, setLoadingRelatedUrls] = (0, $eUqFw.useState)(true);
    const [err, setErr] = (0, $eUqFw.useState)();
    const [relatedUrls, setRelatedUrls] = (0, $eUqFw.useState)();
    const getRelatedUrls = (0, $jOVzD.default)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchRelatedUrls = async ()=>{
            try {
                const relUrls = await getRelatedUrls(url);
                setRelatedUrls(relUrls);
                /**
         * Fire TrackRelatedLinksLoadedEvent
         */ (0, $iWItW.fireRelatedLinksLoadedEvent)(createAnalyticsEvent)({
                    relatedLinksCount: relUrls.resolvedResults?.length ?? 0
                });
            } catch (error) {
                setErr(error);
            }
            setLoadingRelatedUrls(false);
        };
        fetchRelatedUrls();
    }, [
        createAnalyticsEvent,
        getRelatedUrls,
        url
    ]);
    if (loadingRelatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aguBP.RelatedUrlsBlockResolvingView), {
        testId: `${testId}-resolving-view`,
        ...blockProps
    });
    if (relatedUrls) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44yzk.RelatedUrlsResolvedView), {
        renderers: renderers,
        overrideCss: $ef2bdb59e926ed8a$var$_ref,
        testId: `${testId}-resolved-view`,
        relatedUrlsResponse: relatedUrls,
        ...blockProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buene.RelatedUrlsBlockErroredView), {
        err: err,
        testId: `${testId}-errored-view`,
        ...blockProps
    });
};
var $ef2bdb59e926ed8a$export$2e2bcd8739ae039 = $ef2bdb59e926ed8a$var$RelatedUrlsBlock;

});
parcelRegister("jOVzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17b3a7a9d9f04e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $imCrQ = parcelRequire("imCrQ");

var $gqldc = parcelRequire("gqldc");
const $d17b3a7a9d9f04e2$var$useRelatedUrls = ()=>{
    const { connections: connections } = (0, $gqldc.useSmartLinkContext)();
    const clientExt = (0, $imCrQ.useSmartLinkClientExtension)(connections.client);
    return (0, $eUqFw.useCallback)(async (url)=>{
        return await clientExt.relatedUrls(url);
    }, [
        clientExt
    ]);
};
var $d17b3a7a9d9f04e2$export$2e2bcd8739ae039 = $d17b3a7a9d9f04e2$var$useRelatedUrls;

});

parcelRegister("buene", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockErroredView", () => $c113a405c1268075$export$35d9a5df27ecfbf0);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $gsehw = parcelRequire("gsehw");

var $4sQhG = parcelRequire("4sQhG");
const $c113a405c1268075$export$35d9a5df27ecfbf0 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        message: {
            descriptor: (0, $4abrz.messages).generic_error_message
        }
    }));

});

parcelRegister("44yzk", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsResolvedView", () => $a007e2cede3efc31$export$743935ead2c9d445);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");

var $6pyKj = parcelRequire("6pyKj");
const $a007e2cede3efc31$export$743935ead2c9d445 = ({ relatedUrlsResponse: { resolvedResults: resolvedResults }, renderers: renderers, testId: testId, initializeOpened: initializeOpened, ...blockProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, resolvedResults && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pyKj.default), {
        testId: `${testId}-list`,
        renderers: renderers,
        initializeOpened: initializeOpened,
        title: (0, $4abrz.messages).last_mentioned_in,
        resolvedResults: resolvedResults
    }));
};

});
parcelRegister("6pyKj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ccec9f065474826$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $e9T6i = parcelRequire("e9T6i");

var $f1ChA = parcelRequire("f1ChA");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4abrz = parcelRequire("4abrz");

var $4z862 = parcelRequire("4z862");

var $gsehw = parcelRequire("gsehw");

var $gDdZc = parcelRequire("gDdZc");
function $2ccec9f065474826$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2ccec9f065474826$var$_ref = {
    name: "rbkjwc",
    styles: "font-weight:var(--ds-font-weight-medium, 500)"
};
const $2ccec9f065474826$var$RelatedUrlList = ({ resolvedResults: resolvedResults, title: title, renderers: renderers, testId: testId, initializeOpened: initializeOpened })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(initializeOpened);
    const chevronClickHandler = (0, $eUqFw.useCallback)(()=>setIsOpen(!isOpen), [
        isOpen
    ]);
    const ChevronComponent = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($f1ChA))) : (0, (/*@__PURE__*/$parcel$interopDefault($e9T6i)));
    const intl = (0, $5JgJ2.default)();
    return resolvedResults.length > 0 ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        testId: testId,
        xcss: (0, $1ZAYh.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        onClick: chevronClickHandler,
        testId: `${testId}-expand-title`,
        backgroundColor: "color.background.neutral.subtle",
        "aria-expanded": !!isOpen,
        padding: "space.0",
        paddingInlineEnd: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        overrideCss: $2ccec9f065474826$var$_ref,
        message: {
            descriptor: title
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChevronComponent, {
        LEGACY_margin: "0 -4px",
        label: (0, $4z862.getFormattedMessageAsString)(intl, title),
        color: "currentColor"
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gDdZc.default), {
        resolvedResults: resolvedResults,
        testId: testId,
        renderers: renderers
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        testId: testId,
        message: {
            descriptor: (0, $4abrz.messages).related_work_items_not_found
        }
    });
};
var $2ccec9f065474826$export$2e2bcd8739ae039 = $2ccec9f065474826$var$RelatedUrlList;

});
parcelRegister("f1ChA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::72825bd81c3e7ee8ad2525c5c344ccda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af04a522dea9b502$var$_react = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af04a522dea9b502$var$_chevronUp = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("ibyhG")));

var $af04a522dea9b502$var$_chevronUp2 = $af04a522dea9b502$var$_interopRequireDefault((parcelRequire("5xnoX")));
function $af04a522dea9b502$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af04a522dea9b502$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $af04a522dea9b502$var$_react.default.createElement($af04a522dea9b502$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $af04a522dea9b502$var$_chevronUp2.default
    }, props));
$af04a522dea9b502$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $af04a522dea9b502$var$_default = module.exports.default = $af04a522dea9b502$var$ChevronUpIcon;

});
parcelRegister("5xnoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $40822fe6f5908262$var$_react = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $40822fe6f5908262$var$_chevronUp = $40822fe6f5908262$var$_interopRequireDefault((parcelRequire("ibyhG")));
function $40822fe6f5908262$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $40822fe6f5908262$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $40822fe6f5908262$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $40822fe6f5908262$var$_chevronUp.default,
        iconType: "utility"
    }));
$40822fe6f5908262$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $40822fe6f5908262$var$_default = module.exports.default = $40822fe6f5908262$var$ChevronUpIcon;

});


parcelRegister("gDdZc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a454004ca0f579a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $aw5Sy = parcelRequire("aw5Sy");
var $bFzGY = parcelRequire("bFzGY");

var $elJTs = parcelRequire("elJTs");

var $f6EQU = parcelRequire("f6EQU");
const $a454004ca0f579a9$var$ResolvedResultsStack = ({ resolvedResults: resolvedResults, testId: testId, renderers: renderers })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        // This event will fire each time the component is loaded
        (0, $f6EQU.fireRelatedLinksViewedEvent)(createAnalyticsEvent)({
            relatedLinksCount: resolvedResults.length
        });
    }, [
        resolvedResults.length,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.050",
        testId: `${testId}-items-wrapper`,
        as: "ul",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $1ZAYh.xcss)({
            paddingLeft: 'space.0',
            marginTop: 'space.0'
        })
    }, resolvedResults.map((resolvedResults, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6EQU.RelatedUrlItemAnalyticsContext), {
            details: resolvedResults,
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elJTs.default), {
            testId: `${testId}-item`,
            results: resolvedResults,
            renderers: renderers
        }))));
};
const $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            component: 'relatedLinksSection'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a454004ca0f579a9$var$ResolvedResultsStack, props));
};
var $a454004ca0f579a9$export$2e2bcd8739ae039 = $a454004ca0f579a9$var$ResolvedResultsStackWithAnalytics;

});
parcelRegister("elJTs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c7174b4dbac0a44$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");

var $bFzGY = parcelRequire("bFzGY");

var $caOA9 = parcelRequire("caOA9");

var $fsHAt = parcelRequire("fsHAt");

var $c2pJy = parcelRequire("c2pJy");

var $39rqs = parcelRequire("39rqs");

var $lyAeo = parcelRequire("lyAeo");
const $6c7174b4dbac0a44$var$RelatedUrlItem = ({ results: results, renderers: renderers, testId: testId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flexibleDataContext = (0, $eUqFw.useMemo)(()=>(0, $fsHAt.default)({
            response: results,
            renderers: renderers
        }), [
        renderers,
        results
    ]);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        space: "space.050",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c2pJy.default), {
        ...flexibleDataContext?.linkIcon,
        testId: `${testId}-icon`,
        size: (0, $caOA9.SmartLinkSize).Small
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $39rqs.default), {
        testId: `${testId}-link`,
        text: flexibleDataContext?.title,
        url: flexibleDataContext?.url,
        size: (0, $caOA9.SmartLinkSize).Small,
        maxLines: 1,
        onClick: onClick
    }));
};
var $6c7174b4dbac0a44$export$2e2bcd8739ae039 = $6c7174b4dbac0a44$var$RelatedUrlItem;

});
parcelRegister("fsHAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a709dad76fe90a85$export$2e2bcd8739ae039);

var $4zMKr = parcelRequire("4zMKr");

var $8hH6p = parcelRequire("8hH6p");

var $903Mk = parcelRequire("903Mk");

var $fmv4j = parcelRequire("fmv4j");

var $7DLuu = parcelRequire("7DLuu");

var $1qrFi = parcelRequire("1qrFi");
var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $lnW6z = parcelRequire("lnW6z");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $a4gSw = parcelRequire("a4gSw");

var $77p4K = parcelRequire("77p4K");

var $9BBAF = parcelRequire("9BBAF");

var $ket3S = parcelRequire("ket3S");

var $2umDH = parcelRequire("2umDH");

var $asvOI = parcelRequire("asvOI");

var $eywmF = parcelRequire("eywmF");
const $a709dad76fe90a85$var$extractFlexibleUiContext = ({ id: id, renderers: renderers, actionOptions: actionOptions, response: response, aiSummaryConfig: aiSummaryConfig, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const url = (0, $lnW6z.extractLink)(data);
    return {
        // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
        actions: (0, $8hH6p.default)(response, props.url, actionOptions, id, aiSummaryConfig),
        assignedToGroup: (0, $fmv4j.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $fmv4j.extractAttachmentCount)(data),
        authorGroup: (0, $c8AiI.extractPersonCreatedBy)(data),
        ownedByGroup: (0, $dMa80.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $7DLuu.extractPersonsUpdatedBy)(data),
        commentCount: (0, $fmv4j.extractCommentCount)(data),
        viewCount: (0, $fmv4j.extractViewCount)(data),
        reactCount: (0, $fmv4j.extractReactCount)(data),
        voteCount: (0, $fmv4j.extractVoteCount)(data),
        checklistProgress: (0, $fmv4j.extractChecklistProgress)(data),
        createdBy: (0, $fmv4j.extractCreatedBy)(data),
        ownedBy: (0, $fmv4j.extractOwnedBy)(data),
        assignedTo: (0, $fmv4j.extractAssignedTo)(data),
        createdOn: (0, $h1sO6.extractDateCreated)(data),
        dueOn: (0, $fmv4j.extractDueOn)(data),
        viewAction: (0, $eywmF.extractViewAction)(data, actionOptions),
        latestCommit: (0, $asvOI.extractLatestCommit)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response, renderers),
        location: (0, $fmv4j.extractLocation)(data),
        modifiedBy: (0, $fmv4j.extractModifiedBy)(data),
        modifiedOn: (0, $dGfXu.extractDateUpdated)(data),
        preview: (0, $ket3S.default)(data),
        priority: (0, $77p4K.default)(data),
        provider: (0, $9BBAF.default)(data),
        programmingLanguage: (0, $fmv4j.extractProgrammingLanguage)(data),
        readTime: (0, $fmv4j.extractReadTime)(data),
        sentOn: (0, $fmv4j.extractSentOn)(data),
        snippet: (0, $4zMKr.extractSummary)(data) || undefined,
        sourceBranch: (0, $fmv4j.extractSourceBranch)(data),
        state: (0, $2umDH.default)(response, actionOptions, id),
        subscriberCount: (0, $fmv4j.extractSubscriberCount)(data),
        subTasksProgress: (0, $fmv4j.extractSubTasksProgress)(data),
        storyPoints: (0, $fmv4j.extractStoryPoints)(data),
        targetBranch: (0, $fmv4j.extractTargetBranch)(data),
        title: (0, $a4gSw.extractTitle)(data) || url,
        url: url,
        ari: (0, $1qrFi.extractAri)(data)
    };
};
var $a709dad76fe90a85$export$2e2bcd8739ae039 = $a709dad76fe90a85$var$extractFlexibleUiContext;

});
parcelRegister("4zMKr", function(module, exports) {

$parcel$export(module.exports, "extractSummary", () => $03eb7123b442c89e$export$db5a8500f6b6286e);
const $03eb7123b442c89e$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});

parcelRegister("8hH6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $53addcfa7a39f29f$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

var $caOA9 = parcelRequire("caOA9");

var $ehbIu = parcelRequire("ehbIu");

var $RO4Pi = parcelRequire("RO4Pi");

var $amwpE = parcelRequire("amwpE");

var $6qhhh = parcelRequire("6qhhh");

var $zhR2s = parcelRequire("zhR2s");

var $1GqIw = parcelRequire("1GqIw");

var $gK2mf = parcelRequire("gK2mf");
const $53addcfa7a39f29f$var$extractActions = (response, url, actionOptions, id, aiSummaryConfig)=>{
    const data = response.data;
    const action = {
        [(0, $caOA9.ActionName).CopyLinkAction]: (0, $zhR2s.extractCopyLinkAction)(data, actionOptions),
        [(0, $caOA9.ActionName).DownloadAction]: (0, $ehbIu.extractDownloadAction)(data, actionOptions),
        [(0, $caOA9.ActionName).FollowAction]: (0, $6qhhh.default)(response, actionOptions, id),
        [(0, $caOA9.ActionName).PreviewAction]: (0, $RO4Pi.extractPreviewAction)(response, actionOptions),
        [(0, $caOA9.ActionName).AutomationAction]: (0, $1GqIw.extractAutomationAction)(response),
        [(0, $caOA9.InternalActionName).AISummaryAction]: (0, $amwpE.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.smart-card.enable-view-related-urls-action') ? {
            [(0, $caOA9.InternalActionName).ViewRelatedLinksAction]: (0, $gK2mf.extractViewRelatedLinksAction)(response)
        } : {}
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
var $53addcfa7a39f29f$export$2e2bcd8739ae039 = $53addcfa7a39f29f$var$extractActions;

});
parcelRegister("ehbIu", function(module, exports) {

$parcel$export(module.exports, "extractDownloadAction", () => $66eea790b8ba0e58$export$e2076b2e4a490ac5);

var $44Wm8 = parcelRequire("44Wm8");

var $hqABm = parcelRequire("hqABm");

var $e3WTQ = parcelRequire("e3WTQ");

var $lIFl3 = parcelRequire("lIFl3");
const $66eea790b8ba0e58$export$e2076b2e4a490ac5 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions)) return;
    const downloadActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data)
    };
    return;
};

});
parcelRegister("44Wm8", function(module, exports) {

$parcel$export(module.exports, "canShowAction", () => $da2b2293f1c35c89$export$2487b058456cca75);
const $da2b2293f1c35c89$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};

});

parcelRegister("e3WTQ", function(module, exports) {

$parcel$export(module.exports, "getActionsFromJsonLd", () => $20656457f4b723f0$export$8f031784a3a03b23);
$parcel$export(module.exports, "extractClientActions", () => $20656457f4b723f0$export$75be35b463ab3fda);

var $hMDH6 = parcelRequire("hMDH6");

var $dAGi3 = parcelRequire("dAGi3");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $20656457f4b723f0$var$isClientAction = (action)=>[
        'ViewAction',
        'DownloadAction'
    ].indexOf(action['@type']) > -1;
const $20656457f4b723f0$var$getClientAction = (jsonLd, action)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $hMDH6.ViewAction)({
                url: jsonLd.url
            });
        case 'DownloadAction':
            return (0, $dAGi3.DownloadAction)({
                url: jsonLd['atlassian:downloadUrl']
            });
    }
};
const $20656457f4b723f0$var$isActionEnabled = (action, actionOptions)=>{
    switch(action['@type']){
        case 'ViewAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions);
        case 'DownloadAction':
            return (0, $44Wm8.canShowAction)((0, $hqABm.CardAction).DownloadAction, actionOptions);
    }
    return true;
};
const $20656457f4b723f0$var$getClientActionProps = (jsonLd, action, handler)=>{
    const clientAction = $20656457f4b723f0$var$getClientAction(jsonLd, action);
    const clientActionInvokeOpts = {
        type: 'client',
        key: action.identifier,
        action: {
            type: action['@type'],
            promise: clientAction.promise
        }
    };
    // Send client actions through common invocation flow; for analytics
    // and, in future, in order to propagate state changes.
    return {
        ...clientAction,
        promise: ()=>handler(clientActionInvokeOpts)
    };
};
const $20656457f4b723f0$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
function $20656457f4b723f0$export$75be35b463ab3fda(jsonLd, handler, actionOptions) {
    const actions = $20656457f4b723f0$export$8f031784a3a03b23(jsonLd);
    const clientActions = actions.filter((action)=>$20656457f4b723f0$var$isClientAction(action) && $20656457f4b723f0$var$isActionEnabled(action, actionOptions));
    const clientActionImpls = clientActions.map((action)=>$20656457f4b723f0$var$getClientActionProps(jsonLd, action, handler));
    return clientActionImpls;
}

});
parcelRegister("hMDH6", function(module, exports) {

$parcel$export(module.exports, "ViewAction", () => $724f4a3330fcc48e$export$a96f88e1928d92fa);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $724f4a3330fcc48e$export$a96f88e1928d92fa = ({ url: url })=>({
        id: 'view-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).view),
        promise: ()=>(0, $9A6mL.openUrl)(url)
    });

});

parcelRegister("dAGi3", function(module, exports) {

$parcel$export(module.exports, "DownloadAction", () => $15ad76cb67b3a953$export$7a2b423858a679ca);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9A6mL = parcelRequire("9A6mL");
const $15ad76cb67b3a953$export$7a2b423858a679ca = ({ url: url })=>({
        id: 'download-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).download),
        promise: ()=>(0, $9A6mL.downloadUrl)(url)
    });

});


parcelRegister("lIFl3", function(module, exports) {

$parcel$export(module.exports, "extractDownloadUrl", () => $833f00c4d88e64d9$export$9682e3ac9d184e95);
const $833f00c4d88e64d9$export$9682e3ac9d184e95 = (jsonLd)=>{
    if (jsonLd['atlassian:downloadUrl']) return jsonLd['atlassian:downloadUrl'];
};

});


parcelRegister("RO4Pi", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $834bef11f28eb280$export$eba2f3246148e526);

var $lIFl3 = parcelRequire("lIFl3");

var $lnW6z = parcelRequire("lnW6z");
var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $903Mk = parcelRequire("903Mk");

var $dB5lQ = parcelRequire("dB5lQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $834bef11f28eb280$export$eba2f3246148e526 = (response, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).PreviewAction, actionOptions)) return;
    const data = response.data;
    const meta = response.meta;
    const src = (0, $fQDHB.extractPreview)(data, 'web')?.src;
    if (src) return {
        downloadUrl: (0, $lIFl3.extractDownloadUrl)(data),
        providerName: (0, $ebCNT.extractProvider)(data)?.text,
        src: src,
        title: (0, $a4gSw.extractTitle)(data),
        linkIcon: (0, $903Mk.extractLinkIcon)(response),
        url: (0, $lnW6z.extractLink)(data),
        isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
    };
};

});
parcelRegister("ebCNT", function(module, exports) {

$parcel$export(module.exports, "extractProvider", () => $949786e11a712549$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $949786e11a712549$export$6fb636a2ac885215);

var $eUqFw = parcelRequire("eUqFw");

var $5KT10 = parcelRequire("5KT10");

var $77CtJ = parcelRequire("77CtJ");


var $amPw7 = parcelRequire("amPw7");
var $9W7HP = parcelRequire("9W7HP");
const $949786e11a712549$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $949786e11a712549$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $949786e11a712549$var$extractProviderImage(generator.image)
            };
        }
    }
};
const $949786e11a712549$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $91701787b8fb623d$export$cee224b5de4d6d66)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5KT10.ConfluenceIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-deprecated-apis */ size: "xsmall"
        });
        else if (id === (0, $91701787b8fb623d$export$f654d825189934a7)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            appearance: "brand",
            /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ size: "xsmall"
        });
    }
    if (icon) return (0, $amPw7.extractUrlFromIconJsonLd)(icon);
};
const $949786e11a712549$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});
const $91701787b8fb623d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $91701787b8fb623d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $91701787b8fb623d$export$84a73a0383f58180 = 'JiraTask';
const $91701787b8fb623d$export$c6c83963a9378a67 = 'JiraSubTask';
const $91701787b8fb623d$export$58af3c426c111a6d = 'JiraStory';
const $91701787b8fb623d$export$ac9898a63417219e = 'JiraBug';
const $91701787b8fb623d$export$54db5e3fb12e39cd = 'JiraEpic';
const $91701787b8fb623d$export$2f54a5a217202c85 = 'JiraIncident';
const $91701787b8fb623d$export$d097371052bfc411 = 'JiraServiceRequest';
const $91701787b8fb623d$export$efd9452ad16c6676 = 'JiraChange';
const $91701787b8fb623d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $91701787b8fb623d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';

parcelRegister("amPw7", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $8352024242ae3429$export$67f3d92c824fd850);

var $9W7HP = parcelRequire("9W7HP");
const $8352024242ae3429$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(icon.url);
    }
};

});


parcelRegister("a4gSw", function(module, exports) {

$parcel$export(module.exports, "extractTitle", () => $a665721ac2392089$export$b05803156e5015b6);

var $ieJEX = parcelRequire("ieJEX");

var $4yj9H = parcelRequire("4yj9H");
const $a665721ac2392089$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $ieJEX.extractContext)(jsonLd);
    const type = (0, $4yj9H.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};

});
parcelRegister("ieJEX", function(module, exports) {

$parcel$export(module.exports, "extractContext", () => $24c906d1ff23560a$export$efdbd45f3e77a161);

var $4yj9H = parcelRequire("4yj9H");

var $amPw7 = parcelRequire("amPw7");
const $24c906d1ff23560a$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $amPw7.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $4yj9H.extractType)(context)
            };
        }
    }
};

});
parcelRegister("4yj9H", function(module, exports) {

$parcel$export(module.exports, "extractType", () => $b06a91293523bc6e$export$2e9ae379995d99e3);
const $b06a91293523bc6e$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
};

});



parcelRegister("903Mk", function(module, exports) {

$parcel$export(module.exports, "extractLinkIcon", () => $3d22e311bd34cc2d$export$43612bed147eae48);
$parcel$export(module.exports, "extractErrorIcon", () => $3d22e311bd34cc2d$export$bdd29be9b0395931);

var $gaEk5 = parcelRequire("gaEk5");

var $9BBAF = parcelRequire("9BBAF");

var $caOA9 = parcelRequire("caOA9");

var $eYh51 = parcelRequire("eYh51");
const $3d22e311bd34cc2d$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $eYh51.default)(data, renderers);
    return {
        ...(0, $gaEk5.default)(data),
        render: render
    };
};
const $3d22e311bd34cc2d$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $9BBAF.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $caOA9.IconType).Forbidden
            };
        case (0, $caOA9.SmartLinkStatus).NotFound:
            return {
                icon: (0, $caOA9.IconType).Error
            };
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $caOA9.IconType).Default
            };
    }
};

});
parcelRegister("gaEk5", function(module, exports) {

$parcel$export(module.exports, "default", () => $022ee8dc75d3db15$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $60G1O = parcelRequire("60G1O");

var $iTTUV = parcelRequire("iTTUV");

var $WIkzi = parcelRequire("WIkzi");

var $9BBAF = parcelRequire("9BBAF");

var $d5yin = parcelRequire("d5yin");

var $jy3WR = parcelRequire("jy3WR");

var $a4gSw = parcelRequire("a4gSw");

var $2aTcn = parcelRequire("2aTcn");

var $caOA9 = parcelRequire("caOA9");

var $4afqa = parcelRequire("4afqa");
const $022ee8dc75d3db15$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $jy3WR.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $022ee8dc75d3db15$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0] : type;
};
const $022ee8dc75d3db15$var$isJiraProvider = (provider)=>provider === (0, $4DxpJ.JIRA_GENERATOR_ID);
function $022ee8dc75d3db15$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $iTTUV.default)(fileFormat);
    const documentTypeIcon = $022ee8dc75d3db15$var$typeToIconDescriptor({
        type: type,
        label: label,
        providerId: providerId,
        data: data
    }) || (0, $60G1O.default)(type, label);
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $022ee8dc75d3db15$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label || 'Goal'
            };
        case 'atlassian:Project':
            return {
                icon: (0, $caOA9.IconType).Project,
                label: label || 'Project'
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $caOA9.IconType).Commit,
                label: label || 'Commit'
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $caOA9.IconType).PullRequest,
                label: label || 'Pull request'
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $caOA9.IconType).Branch,
                label: label || 'Reference'
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $caOA9.IconType).Repo,
                label: label || 'Repository'
            };
        case 'atlassian:Task':
            const taskLabel = label || 'Task';
            const taskIconDescriptor = {
                icon: (0, $caOA9.IconType).Task,
                label: taskLabel
            };
            if ($022ee8dc75d3db15$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $022ee8dc75d3db15$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $WIkzi.default)(taskType, taskLabel);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $022ee8dc75d3db15$var$extractJsonldDataIcon = (data)=>{
    const label = (0, $a4gSw.extractTitle)(data);
    const type = $022ee8dc75d3db15$var$extractType(data);
    const urlIcon = (0, $d5yin.default)(data.icon, label);
    const providerIcon = (0, $9BBAF.default)(data);
    return $022ee8dc75d3db15$var$chooseIcon({
        urlIcon: urlIcon,
        providerIcon: providerIcon,
        type: type,
        label: label,
        data: data
    });
};
var $022ee8dc75d3db15$export$2e2bcd8739ae039 = $022ee8dc75d3db15$var$extractJsonldDataIcon;

});
parcelRegister("4DxpJ", function(module, exports) {

$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $0689ce76a4c51982$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $0689ce76a4c51982$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $0689ce76a4c51982$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $0689ce76a4c51982$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $0689ce76a4c51982$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $0689ce76a4c51982$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $0689ce76a4c51982$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $0689ce76a4c51982$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $0689ce76a4c51982$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $0689ce76a4c51982$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $0689ce76a4c51982$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $0689ce76a4c51982$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $0689ce76a4c51982$export$fe44ce30fd8d131b);
const $0689ce76a4c51982$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $0689ce76a4c51982$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $0689ce76a4c51982$export$84a73a0383f58180 = 'JiraTask';
const $0689ce76a4c51982$export$c6c83963a9378a67 = 'JiraSubTask';
const $0689ce76a4c51982$export$58af3c426c111a6d = 'JiraStory';
const $0689ce76a4c51982$export$ac9898a63417219e = 'JiraBug';
const $0689ce76a4c51982$export$54db5e3fb12e39cd = 'JiraEpic';
const $0689ce76a4c51982$export$2f54a5a217202c85 = 'JiraIncident';
const $0689ce76a4c51982$export$d097371052bfc411 = 'JiraServiceRequest';
const $0689ce76a4c51982$export$efd9452ad16c6676 = 'JiraChange';
const $0689ce76a4c51982$export$2e7e70abb5d81f67 = 'JiraProblem';
const $0689ce76a4c51982$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $0689ce76a4c51982$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider'
];

});

parcelRegister("60G1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaccd265493698eb$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $aaccd265493698eb$var$extractDocumentTypeIcon = (documentType, label)=>{
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $caOA9.IconType).Blog,
                label: label || 'Blog'
            };
        case 'schema:DigitalDocument':
            return {
                icon: (0, $caOA9.IconType).File,
                label: label || 'File'
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Document'
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: label || 'Presentation'
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: label || 'Spreadsheet'
            };
        case 'atlassian:Template':
            return {
                icon: (0, $caOA9.IconType).Template,
                label: label || 'Template'
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: label || 'Undefined link'
            };
        default:
            return undefined;
    }
};
var $aaccd265493698eb$export$2e2bcd8739ae039 = $aaccd265493698eb$var$extractDocumentTypeIcon;

});

parcelRegister("iTTUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa68e49b5e1b13b$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $cfa68e49b5e1b13b$var$extractFileFormatIcon = (fileFormat)=>{
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return {
                icon: (0, $caOA9.IconType).Folder,
                label: 'Folder'
            };
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return {
                icon: (0, $caOA9.IconType).Document,
                label: 'Document'
            };
        case 'application/pdf':
            return {
                icon: (0, $caOA9.IconType).PDF,
                label: 'PDF document'
            };
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return {
                icon: (0, $caOA9.IconType).Presentation,
                label: 'Presentation'
            };
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return {
                icon: (0, $caOA9.IconType).Spreadsheet,
                label: 'Spreadsheet'
            };
        // Google Drive
        case 'application/vnd.google-apps.document':
            return {
                icon: (0, $caOA9.IconType).GoogleDocs,
                label: 'Google Docs'
            };
        case 'application/vnd.google-apps.form':
            return {
                icon: (0, $caOA9.IconType).GoogleForms,
                label: 'Google Form'
            };
        case 'application/vnd.google-apps.spreadsheet':
            return {
                icon: (0, $caOA9.IconType).GoogleSheets,
                label: 'Google Sheets'
            };
        case 'application/vnd.google-apps.presentation':
            return {
                icon: (0, $caOA9.IconType).GoogleSlides,
                label: 'Google Slides'
            };
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return {
                icon: (0, $caOA9.IconType).MSExcel,
                label: 'Excel spreadsheet'
            };
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return {
                icon: (0, $caOA9.IconType).MSPowerpoint,
                label: 'PowerPoint presentation'
            };
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return {
                icon: (0, $caOA9.IconType).MSWord,
                label: 'Word document'
            };
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return {
                icon: (0, $caOA9.IconType).Image,
                label: 'Image'
            };
        case 'image/gif':
            return {
                icon: (0, $caOA9.IconType).GIF,
                label: 'GIF'
            };
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return {
                icon: (0, $caOA9.IconType).Audio,
                label: 'Audio'
            };
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return {
                icon: (0, $caOA9.IconType).Video,
                label: 'Video'
            };
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return {
                icon: (0, $caOA9.IconType).Code,
                label: 'Source Code'
            };
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return {
                icon: (0, $caOA9.IconType).Archive,
                label: 'Archive'
            };
        case 'application/dmg':
            return {
                icon: (0, $caOA9.IconType).Executable,
                label: 'Executable'
            };
        case 'application/sketch':
            return {
                icon: (0, $caOA9.IconType).Sketch,
                label: 'Sketch'
            };
        case 'application/octet-stream':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Binary file'
            };
        case 'application/invision.prototype':
            return {
                icon: (0, $caOA9.IconType).Generic,
                label: 'Prototype'
            };
        default:
            return undefined;
    }
};
var $cfa68e49b5e1b13b$export$2e2bcd8739ae039 = $cfa68e49b5e1b13b$var$extractFileFormatIcon;

});

parcelRegister("WIkzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a469cd27ea0426c$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");
const $0a469cd27ea0426c$var$extractJiraTaskIcon = (taskType, label = 'Task')=>{
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $caOA9.IconType).Bug,
                label: label
            };
        case 'JiraChange':
            return {
                icon: (0, $caOA9.IconType).Change,
                label: label
            };
        case 'JiraEpic':
            return {
                icon: (0, $caOA9.IconType).Epic,
                label: label
            };
        case 'JiraIncident':
            return {
                icon: (0, $caOA9.IconType).Incident,
                label: label
            };
        case 'JiraProblem':
            return {
                icon: (0, $caOA9.IconType).Problem,
                label: label
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $caOA9.IconType).ServiceRequest,
                label: label
            };
        case 'JiraStory':
            return {
                icon: (0, $caOA9.IconType).Story,
                label: label
            };
        case 'JiraSubTask':
            return {
                icon: (0, $caOA9.IconType).SubTask,
                label: label
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $caOA9.IconType).Task,
                label: label
            };
    }
};
var $0a469cd27ea0426c$export$2e2bcd8739ae039 = $0a469cd27ea0426c$var$extractJiraTaskIcon;

});

parcelRegister("9BBAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a453423411755a2f$export$2e2bcd8739ae039);

var $4DxpJ = parcelRequire("4DxpJ");

var $caOA9 = parcelRequire("caOA9");

var $d5yin = parcelRequire("d5yin");

var $a4gSw = parcelRequire("a4gSw");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $a453423411755a2f$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $a4gSw.extractTitle)(data);
    if (provider === (0, $4DxpJ.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $4DxpJ.JIRA_GENERATOR_ID)) return {
        icon: (0, $caOA9.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $d5yin.default)(icon, label);
};
var $a453423411755a2f$export$2e2bcd8739ae039 = $a453423411755a2f$var$extractProviderIcon;

});
parcelRegister("d5yin", function(module, exports) {

$parcel$export(module.exports, "default", () => $a073a66919740263$export$2e2bcd8739ae039);

var $amPw7 = parcelRequire("amPw7");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $a073a66919740263$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $amPw7.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $a073a66919740263$export$2e2bcd8739ae039 = $a073a66919740263$var$extractUrlIcon;

});


parcelRegister("jy3WR", function(module, exports) {

$parcel$export(module.exports, "extractTaskType", () => $345dc23d744dc954$export$ed3fd59180514d27);

var $amPw7 = parcelRequire("amPw7");
const $345dc23d744dc954$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $amPw7.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("2aTcn", function(module, exports) {

$parcel$export(module.exports, "extractorPriorityMap", () => $52be4013925bc58c$export$e0deaeb4a2dfe2b4);
const $52be4013925bc58c$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("4afqa", function(module, exports) {

$parcel$export(module.exports, "prioritiseIcon", () => $4cb04ba6bb191e3c$export$65e47eb22a387a86);
function $4cb04ba6bb191e3c$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});


parcelRegister("eYh51", function(module, exports) {

$parcel$export(module.exports, "default", () => $4581489debbadb7f$export$2e2bcd8739ae039);
const $4581489debbadb7f$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $4581489debbadb7f$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $4581489debbadb7f$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $4581489debbadb7f$export$2e2bcd8739ae039 = $4581489debbadb7f$var$extractIconRenderer;

});


parcelRegister("dB5lQ", function(module, exports) {

$parcel$export(module.exports, "extractIsSupportTheming", () => $b34c0ba6cc99590f$export$38d755f52cdf4acb);

var $4DxpJ = parcelRequire("4DxpJ");
const $b34c0ba6cc99590f$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $4DxpJ.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});


parcelRegister("amwpE", function(module, exports) {

$parcel$export(module.exports, "extractAISummaryAction", () => $38c5d89c8c4c78d5$export$e7f7a50a8b8932df);

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");

var $hZwiw = parcelRequire("hZwiw");
const $38c5d89c8c4c78d5$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).AISummaryAction, actionOptions) || !(0, $hZwiw.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});

parcelRegister("6qhhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a426c8146558b6e$export$2e2bcd8739ae039);

var $lnW6z = parcelRequire("lnW6z");
var $4yj9H = parcelRequire("4yj9H");

var $cCvxR = parcelRequire("cCvxR");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $6a426c8146558b6e$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    const type = (0, $4yj9H.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $cCvxR.SmartLinkActionType).FollowEntityAction || actionName === (0, $cCvxR.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $lnW6z.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $cCvxR.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6a426c8146558b6e$export$2e2bcd8739ae039 = $6a426c8146558b6e$var$extractFollowAction;

});
parcelRegister("269iK", function(module, exports) {

$parcel$export(module.exports, "getByDefinitionId", () => $7ebbf14b484e98b7$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $7ebbf14b484e98b7$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $7ebbf14b484e98b7$export$218d96312e385949);
$parcel$export(module.exports, "getResourceType", () => $7ebbf14b484e98b7$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getProduct", () => $7ebbf14b484e98b7$export$e2005c9600188ac7);
$parcel$export(module.exports, "getSubproduct", () => $7ebbf14b484e98b7$export$f8fdefc70357968e);
$parcel$export(module.exports, "getServices", () => $7ebbf14b484e98b7$export$a009e3a1163d46fb);
$parcel$export(module.exports, "getStatusDetails", () => $7ebbf14b484e98b7$export$a752a116d184ffbd);
$parcel$export(module.exports, "isFinalState", () => $7ebbf14b484e98b7$export$d590d08942abc17a);
$parcel$export(module.exports, "getCanBeDatasource", () => $7ebbf14b484e98b7$export$ba6d13ab7b87c55c);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $7ebbf14b484e98b7$export$3f9446bb21b945a0);

var $5gJEv = parcelRequire("5gJEv");
const $7ebbf14b484e98b7$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $7ebbf14b484e98b7$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $5gJEv.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $7ebbf14b484e98b7$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $7ebbf14b484e98b7$export$218d96312e385949 = (details)=>details?.meta?.key;
const $7ebbf14b484e98b7$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $7ebbf14b484e98b7$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $7ebbf14b484e98b7$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $7ebbf14b484e98b7$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $7ebbf14b484e98b7$export$ac5d414b1ebfab5a = (details)=>details && $7ebbf14b484e98b7$export$cd41ae544cfc2a65(details) && $7ebbf14b484e98b7$export$795910f5f15a9633(details);
const $7ebbf14b484e98b7$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $7ebbf14b484e98b7$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $7ebbf14b484e98b7$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $7ebbf14b484e98b7$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $7ebbf14b484e98b7$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $7ebbf14b484e98b7$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $7ebbf14b484e98b7$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $7ebbf14b484e98b7$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;

});
parcelRegister("5gJEv", function(module, exports) {

$parcel$export(module.exports, "extractVisitUrl", () => $dbcf37ca341757a3$export$c81497d3681f24f4);
const $dbcf37ca341757a3$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("5cnU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ba438025015c1fd$export$2e2bcd8739ae039);
const $5ba438025015c1fd$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $5ba438025015c1fd$export$2e2bcd8739ae039 = $5ba438025015c1fd$var$extractServerAction;

});


parcelRegister("zhR2s", function(module, exports) {

$parcel$export(module.exports, "extractCopyLinkAction", () => $f482c27c7008fd92$export$5b7ae1fa8fdb83ba);

var $lnW6z = parcelRequire("lnW6z");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $f482c27c7008fd92$export$5b7ae1fa8fdb83ba = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $lnW6z.extractLink)(data);
    if (!url) return;
    return {
        url: url
    };
};

});

parcelRegister("1GqIw", function(module, exports) {

$parcel$export(module.exports, "extractAutomationAction", () => $6447dee659182c27$export$f913cc6abf3ec084);

var $caOA9 = parcelRequire("caOA9");
const $6447dee659182c27$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $caOA9.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("gK2mf", function(module, exports) {

$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $d3a00a758146d92c$export$debae7424a0231b9);

var $1qrFi = parcelRequire("1qrFi");
const $d3a00a758146d92c$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $1qrFi.extractAri)(response.data);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("fmv4j", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $469a01a9f706d88b$export$b68822b76d5d51d5);
$parcel$export(module.exports, "extractDueOn", () => $469a01a9f706d88b$export$ac56bd7a37249b48);
$parcel$export(module.exports, "extractViewCount", () => $469a01a9f706d88b$export$e57334ce4738e29d);
$parcel$export(module.exports, "extractReactCount", () => $469a01a9f706d88b$export$44130aa92252501);
$parcel$export(module.exports, "extractVoteCount", () => $469a01a9f706d88b$export$c8bef3d5e550a3a);
$parcel$export(module.exports, "extractOwnedBy", () => $469a01a9f706d88b$export$75b4b5a156f48ff3);
$parcel$export(module.exports, "extractAssignedTo", () => $469a01a9f706d88b$export$5546969a505305);
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $469a01a9f706d88b$export$edb8a7a44b91274e);
$parcel$export(module.exports, "extractCreatedBy", () => $469a01a9f706d88b$export$69b10d653f96288b);
$parcel$export(module.exports, "extractModifiedBy", () => $469a01a9f706d88b$export$bcb193c84c865ec9);
$parcel$export(module.exports, "extractProgrammingLanguage", () => $469a01a9f706d88b$export$43e54589935a1ff);
$parcel$export(module.exports, "extractSourceBranch", () => $469a01a9f706d88b$export$949ac6a8325b3fdb);
$parcel$export(module.exports, "extractSubscriberCount", () => $469a01a9f706d88b$export$8bd03a7beb5badf1);
$parcel$export(module.exports, "extractAttachmentCount", () => $469a01a9f706d88b$export$65362ff78a97fd8);
$parcel$export(module.exports, "extractTargetBranch", () => $469a01a9f706d88b$export$29b0ac5d2f9890cf);
$parcel$export(module.exports, "extractChecklistProgress", () => $469a01a9f706d88b$export$dd980f9881b65d9c);
$parcel$export(module.exports, "extractLocation", () => $469a01a9f706d88b$export$9df94c77b0746c3c);
$parcel$export(module.exports, "extractSubTasksProgress", () => $469a01a9f706d88b$export$744e3a2674114c1d);
$parcel$export(module.exports, "extractReadTime", () => $469a01a9f706d88b$export$cc4028b2878d0675);
$parcel$export(module.exports, "extractSentOn", () => $469a01a9f706d88b$export$b592ddecae70b61d);
$parcel$export(module.exports, "extractStoryPoints", () => $469a01a9f706d88b$export$bdcea84d1550eb9d);

var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $dMa80 = parcelRequire("dMa80");
var $gd1O9 = parcelRequire("gd1O9");
const $469a01a9f706d88b$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $469a01a9f706d88b$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $469a01a9f706d88b$export$b68822b76d5d51d5 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:commentCount');
const $469a01a9f706d88b$export$ac56bd7a37249b48 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'endTime');
const $469a01a9f706d88b$export$e57334ce4738e29d = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:viewCount');
const $469a01a9f706d88b$export$44130aa92252501 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:reactCount');
const $469a01a9f706d88b$export$c8bef3d5e550a3a = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:voteCount');
const $469a01a9f706d88b$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $dMa80.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$5546969a505305 = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $dlXJJ.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $469a01a9f706d88b$export$69b10d653f96288b = (data)=>{
    const persons = (0, $c8AiI.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $469a01a9f706d88b$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $gd1O9.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $469a01a9f706d88b$export$43e54589935a1ff = (data)=>$469a01a9f706d88b$var$extractValue(data, 'schema:programmingLanguage');
const $469a01a9f706d88b$export$949ac6a8325b3fdb = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeSource']);
const $469a01a9f706d88b$export$8bd03a7beb5badf1 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:subscriberCount');
const $469a01a9f706d88b$export$65362ff78a97fd8 = (data)=>$469a01a9f706d88b$var$extractValue(data, 'atlassian:attachmentCount');
const $469a01a9f706d88b$export$29b0ac5d2f9890cf = (data)=>$469a01a9f706d88b$var$extractLinkName(data['atlassian:mergeDestination']);
const $469a01a9f706d88b$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $469a01a9f706d88b$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $469a01a9f706d88b$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $469a01a9f706d88b$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $469a01a9f706d88b$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $469a01a9f706d88b$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $469a01a9f706d88b$export$cc4028b2878d0675 = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $469a01a9f706d88b$export$b592ddecae70b61d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'dateSent');
};
const $469a01a9f706d88b$export$bdcea84d1550eb9d = (data)=>{
    return $469a01a9f706d88b$var$extractValue(data, 'atlassian:storyPoints');
};

});
parcelRegister("dlXJJ", function(module, exports) {

$parcel$export(module.exports, "extractPersonAssignedTo", () => $eecb0f85fd3e820f$export$38a0979ebf273662);

var $3gIUj = parcelRequire("3gIUj");
const $eecb0f85fd3e820f$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $3gIUj.extractPersonFromJsonLd)(assignedTo);
};

});
parcelRegister("3gIUj", function(module, exports) {

$parcel$export(module.exports, "extractPersonFromJsonLd", () => $2b1bbf71ecf49172$export$c471ae5fddcf1392);

var $amPw7 = parcelRequire("amPw7");
const $2b1bbf71ecf49172$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $amPw7.extractUrlFromIconJsonLd)(person.icon)
        };
    }
};

});


parcelRegister("c8AiI", function(module, exports) {

$parcel$export(module.exports, "extractPersonCreatedBy", () => $62e4f86ca3f5f110$export$a66235cba0c9d11a);

var $3gIUj = parcelRequire("3gIUj");
const $62e4f86ca3f5f110$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("dMa80", function(module, exports) {

$parcel$export(module.exports, "extractPersonOwnedBy", () => $ce0e432e194a4e67$export$19ee667f3f7a6ec3);

var $3gIUj = parcelRequire("3gIUj");
const $ce0e432e194a4e67$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $3gIUj.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $3gIUj.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
};

});

parcelRegister("gd1O9", function(module, exports) {

$parcel$export(module.exports, "extractPersonUpdatedBy", () => $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0);

var $3gIUj = parcelRequire("3gIUj");
const $20f4bd3f1c7a69fa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
};

});


parcelRegister("7DLuu", function(module, exports) {

$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $144ad24fb0523f2d$export$216e4f6aa7c169b8);

var $cx2mN = parcelRequire("cx2mN");
var $3gIUj = parcelRequire("3gIUj");
const $144ad24fb0523f2d$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $cx2mN.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $3gIUj.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("cx2mN", function(module, exports) {

$parcel$export(module.exports, "extractMembers", () => $f6777de4e93b831a$export$6281d080d62a0719);

var $3gIUj = parcelRequire("3gIUj");
const $f6777de4e93b831a$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $3gIUj.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $3gIUj.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
};

});


parcelRegister("h1sO6", function(module, exports) {

$parcel$export(module.exports, "extractDateCreated", () => $b0559218890d0714$export$e1226a5e0bbbf862);
const $b0559218890d0714$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
};

});

parcelRegister("dGfXu", function(module, exports) {

$parcel$export(module.exports, "extractDateUpdated", () => $172490fac0121aa1$export$7fc2f5e6f9d22ae7);
const $172490fac0121aa1$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
};

});

parcelRegister("77p4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e993678abbe0145f$export$2e2bcd8739ae039);

var $caOA9 = parcelRequire("caOA9");

var $amPw7 = parcelRequire("amPw7");
const $e993678abbe0145f$var$priorityMapper = {
    blocker: (0, $caOA9.IconType).PriorityBlocker,
    critical: (0, $caOA9.IconType).PriorityCritical,
    high: (0, $caOA9.IconType).PriorityHigh,
    highest: (0, $caOA9.IconType).PriorityHighest,
    low: (0, $caOA9.IconType).PriorityLow,
    lowest: (0, $caOA9.IconType).PriorityLowest,
    major: (0, $caOA9.IconType).PriorityMajor,
    medium: (0, $caOA9.IconType).PriorityMedium,
    minor: (0, $caOA9.IconType).PriorityMinor,
    trivial: (0, $caOA9.IconType).PriorityTrivial,
    undefined: (0, $caOA9.IconType).PriorityUndefined
};
const $e993678abbe0145f$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $e993678abbe0145f$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $amPw7.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $e993678abbe0145f$export$2e2bcd8739ae039 = $e993678abbe0145f$var$extractPriority;

});

parcelRegister("ket3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd5351f90659454$export$2e2bcd8739ae039);

var $lbKTa = parcelRequire("lbKTa");

var $caOA9 = parcelRequire("caOA9");
const $0bd5351f90659454$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $lbKTa.extractImage)(data);
    return url ? {
        type: (0, $caOA9.MediaType).Image,
        url: url
    } : undefined;
};
var $0bd5351f90659454$export$2e2bcd8739ae039 = $0bd5351f90659454$var$extractPreview;

});
parcelRegister("lbKTa", function(module, exports) {

$parcel$export(module.exports, "extractImage", () => $205a59ce4cd20de1$export$4c753a1297cb9805);

var $9W7HP = parcelRequire("9W7HP");
const $205a59ce4cd20de1$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $9W7HP.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $9W7HP.extractUrlFromLinkJsonLd)(image.url);
        }
    }
};

});


parcelRegister("2umDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ca2df7ccfe49f1$export$2e2bcd8739ae039);

var $i9zl6 = parcelRequire("i9zl6");

var $269iK = parcelRequire("269iK");

var $5cnU7 = parcelRequire("5cnU7");

var $lnW6z = parcelRequire("lnW6z");

var $RO4Pi = parcelRequire("RO4Pi");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $c8ca2df7ccfe49f1$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $c8ca2df7ccfe49f1$var$extractAction = (response, id)=>{
    const extensionKey = (0, $269iK.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $5cnU7.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $lnW6z.extractLink)(data);
    const previewData = response ? (0, $RO4Pi.extractPreviewAction)(response) : null;
    const details = {
        id: id,
        url: url,
        previewData: previewData
    };
    const update = $c8ca2df7ccfe49f1$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $c8ca2df7ccfe49f1$var$extractState = (response, actionOptions, id)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $i9zl6.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $c8ca2df7ccfe49f1$var$extractAction(response, id);
    return {
        ...lozenge,
        action: action
    };
};
var $c8ca2df7ccfe49f1$export$2e2bcd8739ae039 = $c8ca2df7ccfe49f1$var$extractState;

});
parcelRegister("i9zl6", function(module, exports) {

$parcel$export(module.exports, "extractLozenge", () => $f0d2b04ab2e51680$export$e5da155556a77bca);

var $9tMLz = parcelRequire("9tMLz");

var $h8zKt = parcelRequire("h8zKt");

var $dSEZR = parcelRequire("dSEZR");

var $4yj9H = parcelRequire("4yj9H");

var $jy3WR = parcelRequire("jy3WR");
const $f0d2b04ab2e51680$var$DOC_TYPES = [
    'schema:BlogPosting',
    'schema:TextDigitalDocument',
    'schema:DigitalDocument',
    'schema:PresentationDigitalDocument',
    'schema:SpreadsheetDigitalDocument'
];
const $f0d2b04ab2e51680$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $4yj9H.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:SourceCodePullRequest')) return (0, $9tMLz.extractState)(jsonLd);
        else if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $h8zKt.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $dSEZR.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $f0d2b04ab2e51680$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        } else if (type.some((types)=>$f0d2b04ab2e51680$var$DOC_TYPES.includes(types))) {
            const jsonLdDocument = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdDocument);
            return lozengeFromState;
        } else if (type.includes('atlassian:Goal')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:Project')) {
            const jsonLdProject = jsonLd;
            const lozengeFromState = (0, $9tMLz.extractState)(jsonLdProject);
            return lozengeFromState;
        } else if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
    }
};
const $f0d2b04ab2e51680$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $jy3WR.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("9tMLz", function(module, exports) {

$parcel$export(module.exports, "extractState", () => $c909e4d157540c3d$export$5e4074cbce6574c7);

var $BOwLU = parcelRequire("BOwLU");
// Maps accent color short names to their corresponding background and text colors
const $c909e4d157540c3d$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        color: "var(--ds-text-accent-blue, #0055CC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        color: "var(--ds-text-accent-gray, #44546F)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        color: "var(--ds-text-accent-orange, #A54800)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        color: "var(--ds-text-accent-purple, #5E4DB2)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $c909e4d157540c3d$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $BOwLU.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $BOwLU.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $c909e4d157540c3d$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("BOwLU", function(module, exports) {

$parcel$export(module.exports, "isValidAppearance", () => $9ca9d217c185ead7$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $9ca9d217c185ead7$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $9ca9d217c185ead7$export$772610da74ddbc07);
const $9ca9d217c185ead7$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $9ca9d217c185ead7$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $9ca9d217c185ead7$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $9ca9d217c185ead7$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default'
};
const $9ca9d217c185ead7$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("h8zKt", function(module, exports) {

$parcel$export(module.exports, "extractTag", () => $c3a22850fb93f457$export$962a8da34cf78a4f);

var $BOwLU = parcelRequire("BOwLU");
const $c3a22850fb93f457$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($c3a22850fb93f457$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $c3a22850fb93f457$var$extractTagItem(tag);
    }
};
const $c3a22850fb93f457$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $BOwLU.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("dSEZR", function(module, exports) {

$parcel$export(module.exports, "extractTaskStatus", () => $845f51ab32eef1a6$export$7698df1946deda72);
const $845f51ab32eef1a6$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("asvOI", function(module, exports) {

$parcel$export(module.exports, "extractLatestCommit", () => $1458752047a9ffeb$export$f222392162cff0d8);
const $1458752047a9ffeb$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});

parcelRegister("eywmF", function(module, exports) {

$parcel$export(module.exports, "extractViewAction", () => $151b53176fbfdd54$export$96c7e3a7e9c64e85);

var $lnW6z = parcelRequire("lnW6z");

var $e3WTQ = parcelRequire("e3WTQ");

var $hqABm = parcelRequire("hqABm");

var $44Wm8 = parcelRequire("44Wm8");
const $151b53176fbfdd54$export$96c7e3a7e9c64e85 = (data, actionOptions)=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).ViewAction, actionOptions)) return;
    const viewActionExists = (0, $e3WTQ.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (viewActionExists) return {
        viewUrl: (0, $lnW6z.extractLink)(data)
    };
    return undefined;
};

});



parcelRegister("f6EQU", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksViewedEvent", () => $08d93b061d67c6f8$export$b33ea4a8393685d8);
$parcel$export(module.exports, "RelatedUrlItemAnalyticsContext", () => $08d93b061d67c6f8$export$e88153cb3e6fc3fc);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $bTNMs = parcelRequire("bTNMs");
const $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'viewed',
        actionSubject: 'relatedLinks',
        eventType: 'ui',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $08d93b061d67c6f8$export$b33ea4a8393685d8 = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $08d93b061d67c6f8$var$createUiRelatedLinksViewedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $08d93b061d67c6f8$export$e88153cb3e6fc3fc = (props)=>{
    const { children: children, details: details } = props;
    /**
	 * We don't really need the `url` to get the attributes here so set
	 * it to an empty string to just make typescript happy
	 */ const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: ''
    }, details);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes,
            component: 'relatedLink'
        }
    }, children);
};

});
parcelRegister("jfVIr", function(module, exports) {

$parcel$export(module.exports, "getResolvedAttributes", () => $ea95fbff36d57274$export$7243431f5325a7b);

var $4hPjC = parcelRequire("4hPjC");

var $kFGtp = parcelRequire("kFGtp");
const $ea95fbff36d57274$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
    const status = linkStatus ?? (details && (0, $4hPjC.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $kFGtp.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};

});
parcelRegister("kFGtp", function(module, exports) {

$parcel$export(module.exports, "getDisplayCategory", () => $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5);
const $c8d9d9ce9f7c0d20$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});






parcelRegister("aguBP", function(module, exports) {

$parcel$export(module.exports, "RelatedUrlsBlockResolvingView", () => $507d5607706e35a7$export$50a43430722f62f8);

var $eUqFw = parcelRequire("eUqFw");

var $8SIiI = parcelRequire("8SIiI");

var $4sQhG = parcelRequire("4sQhG");
const $507d5607706e35a7$export$50a43430722f62f8 = ({ testId: testId, ...blockProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...blockProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SIiI.default), {
        height: 1.55,
        width: 22
    }));

});

parcelRegister("iWItW", function(module, exports) {

$parcel$export(module.exports, "fireRelatedLinksLoadedEvent", () => $cf9e32bcbac3d864$export$d2852f8792c380fa);

var $bTNMs = parcelRequire("bTNMs");
const $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload = ({ relatedLinksCount: relatedLinksCount })=>({
        action: 'loaded',
        actionSubject: 'relatedLinks',
        eventType: 'track',
        attributes: {
            relatedLinksCount: relatedLinksCount
        }
    });
const $cf9e32bcbac3d864$export$d2852f8792c380fa = (createAnalyticsEvent)=>(attributes)=>{
        const payload = $cf9e32bcbac3d864$var$createTrackRelatedLinksLoadedEventPayload(attributes);
        if (payload) createAnalyticsEvent({
            ...payload
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };

});


parcelRegister("h2NbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fe889a6e310b451$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ayl0W = parcelRequire("ayl0W");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $5fe889a6e310b451$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    if (!actionData?.url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ayl0W.default), {
        ...props,
        testId: testId,
        url: actionData.url
    });
};
var $5fe889a6e310b451$export$2e2bcd8739ae039 = $5fe889a6e310b451$var$AISummaryBlock;

});
parcelRegister("ayl0W", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e07ab863de3221$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4sQhG = parcelRequire("4sQhG");

var $3FvFV = parcelRequire("3FvFV");

var $04PAQ = parcelRequire("04PAQ");

var $4zu6H = parcelRequire("4zu6H");

var $8xb3a = parcelRequire("8xb3a");

var $asu8X = parcelRequire("asu8X");

var $byn9U = parcelRequire("byn9U");
const $04e07ab863de3221$var$AISummaryBlockResolvedView = (props)=>{
    (0, $asu8X.di)((0, $04PAQ.default), (0, $4zu6H.default));
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $04PAQ.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $eUqFw.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        direction: (0, $caOA9.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        /**
   * Enabled for feature discovery to allow box shadow to overflow
   * Cleanup: https://product-fabric.atlassian.net/browse/EDM-8681
   */ overrideCss: (0, $byn9U.css)("overflow:visible;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        props.overrideCss)
    }, status === 'done' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xb3a.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zu6H.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $04e07ab863de3221$export$2e2bcd8739ae039 = $04e07ab863de3221$var$AISummaryBlockResolvedView;

});
parcelRegister("3FvFV", function(module, exports) {

$parcel$export(module.exports, "default", () => $470ec6acac7c72bd$export$2e2bcd8739ae039);

var $b5IAe = parcelRequire("b5IAe");

var $eUqFw = parcelRequire("eUqFw");
const $470ec6acac7c72bd$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $eUqFw.useState)(0);
    const ref = (0, $eUqFw.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $eUqFw.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};
var $470ec6acac7c72bd$export$2e2bcd8739ae039 = $470ec6acac7c72bd$export$6118ed0013927eb2;

});

parcelRegister("4zu6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae60e2ff2b3e6cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $27B3S = parcelRequire("27B3S");

var $byn9U = parcelRequire("byn9U");

var $fRvRW = parcelRequire("fRvRW");
function $aae60e2ff2b3e6cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aae60e2ff2b3e6cc$var$AISummaryCSSStyles = {
    name: "178flxl",
    styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
};
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $aae60e2ff2b3e6cc$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27B3S.default), {
        "data-testid": testId,
        css: [
            $aae60e2ff2b3e6cc$var$AISummaryCSSStyles,
            overrideCss
        ],
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $fRvRW.default)
            }
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $aae60e2ff2b3e6cc$export$2e2bcd8739ae039 = $aae60e2ff2b3e6cc$var$AISummary;

});
parcelRegister("27B3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8fbd7df5541f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $18b8fbd7df5541f7$var$n() {
    return $18b8fbd7df5541f7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var t = arguments[n];
            for(var r in t)Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
    }, $18b8fbd7df5541f7$var$n.apply(this, arguments);
}
const $18b8fbd7df5541f7$var$t = [
    "children",
    "options"
];
var $18b8fbd7df5541f7$export$e0aa44767d8750d5, $18b8fbd7df5541f7$var$i;
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}($18b8fbd7df5541f7$export$e0aa44767d8750d5 || ($18b8fbd7df5541f7$export$e0aa44767d8750d5 = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}($18b8fbd7df5541f7$var$i || ($18b8fbd7df5541f7$var$i = {}));
const $18b8fbd7df5541f7$var$l = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    for: "htmlFor"
}), $18b8fbd7df5541f7$var$o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $18b8fbd7df5541f7$var$c = [
    "style",
    "script"
], $18b8fbd7df5541f7$var$a = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $18b8fbd7df5541f7$var$s = /mailto:/i, $18b8fbd7df5541f7$var$d = /\n{2,}$/, $18b8fbd7df5541f7$var$u = /^( *>[^\n]+(\n[^\n]+)*\n*)+\n{2,}/, $18b8fbd7df5541f7$var$p = /^ *> ?/gm, $18b8fbd7df5541f7$var$f = /^ {2,}\n/, $18b8fbd7df5541f7$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, $18b8fbd7df5541f7$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $18b8fbd7df5541f7$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $18b8fbd7df5541f7$var$k = /^(?:\n *)*\n/, $18b8fbd7df5541f7$var$x = /\r\n?/g, $18b8fbd7df5541f7$var$v = /^\[\^([^\]]+)](:.*)\n/, $18b8fbd7df5541f7$var$b = /^\[\^([^\]]+)]/, $18b8fbd7df5541f7$var$$ = /\f/g, $18b8fbd7df5541f7$var$S = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $18b8fbd7df5541f7$var$w = /^\s*?\[(x|\s)\]/, $18b8fbd7df5541f7$var$C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$E = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $18b8fbd7df5541f7$var$A = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $18b8fbd7df5541f7$var$O = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?([^>]*)\/{0}>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1)[\s\S])*?)<\/\1>\n*/i, $18b8fbd7df5541f7$var$T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $18b8fbd7df5541f7$var$L = /^<!--[\s\S]*?(?:-->)/, $18b8fbd7df5541f7$var$z = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $18b8fbd7df5541f7$var$M = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $18b8fbd7df5541f7$var$I = /^\{.*\}$/, $18b8fbd7df5541f7$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $18b8fbd7df5541f7$var$U = /^<([^ >]+@[^ >]+)>/, $18b8fbd7df5541f7$var$j = /^<([^ >]+:\/[^ >]+)>/, $18b8fbd7df5541f7$var$B = /-([a-z])?/gi, $18b8fbd7df5541f7$var$N = /^(.*\|?.*)\n *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*)\n?/, $18b8fbd7df5541f7$var$H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $18b8fbd7df5541f7$var$D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $18b8fbd7df5541f7$var$_ = /(\[|\])/g, $18b8fbd7df5541f7$var$F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $18b8fbd7df5541f7$var$W = /\t/g, $18b8fbd7df5541f7$var$G = /^ *\| */, $18b8fbd7df5541f7$var$Z = /(^ *\||\| *$)/g, $18b8fbd7df5541f7$var$q = / *$/, $18b8fbd7df5541f7$var$V = /^ *:-+: *$/, $18b8fbd7df5541f7$var$X = /^ *:-+ *$/, $18b8fbd7df5541f7$var$Q = /^ *-+: *$/, $18b8fbd7df5541f7$var$J = /^([*_])\1((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1\1(?!\1)/, $18b8fbd7df5541f7$var$K = /^([*_])((?:\[.*?\][([].*?[)\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~+.*?~+|.)*?)\1(?!\1|\w)/, $18b8fbd7df5541f7$var$Y = /^==((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)==/, $18b8fbd7df5541f7$var$ee = /^~~((?:\[.*?\]|<.*?>(?:.*?<.*?>)?|`.*?`|.)*?)~~/, $18b8fbd7df5541f7$var$ne = /^\\([^0-9A-Za-z\s])/, $18b8fbd7df5541f7$var$te = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $18b8fbd7df5541f7$var$re = /^\n+/, $18b8fbd7df5541f7$var$ie = /^([ \t]*)/, $18b8fbd7df5541f7$var$le = /\\([^\\])/g, $18b8fbd7df5541f7$var$oe = / *\n+$/, $18b8fbd7df5541f7$var$ce = /(?:^|\n)( *)$/, $18b8fbd7df5541f7$var$ae = "(?:\\d+\\.)", $18b8fbd7df5541f7$var$se = "(?:[*+-])";
function $18b8fbd7df5541f7$var$de(e) {
    return "( *)(" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + ") +";
}
const $18b8fbd7df5541f7$var$ue = $18b8fbd7df5541f7$var$de(1), $18b8fbd7df5541f7$var$pe = $18b8fbd7df5541f7$var$de(2);
function $18b8fbd7df5541f7$var$fe(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe));
}
const $18b8fbd7df5541f7$var$he = $18b8fbd7df5541f7$var$fe(1), $18b8fbd7df5541f7$var$me = $18b8fbd7df5541f7$var$fe(2);
function $18b8fbd7df5541f7$var$ge(e) {
    return new RegExp("^" + (1 === e ? $18b8fbd7df5541f7$var$ue : $18b8fbd7df5541f7$var$pe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $18b8fbd7df5541f7$var$ye = $18b8fbd7df5541f7$var$ge(1), $18b8fbd7df5541f7$var$ke = $18b8fbd7df5541f7$var$ge(2);
function $18b8fbd7df5541f7$var$xe(e) {
    const n = 1 === e ? $18b8fbd7df5541f7$var$ae : $18b8fbd7df5541f7$var$se;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $18b8fbd7df5541f7$var$ve = $18b8fbd7df5541f7$var$xe(1), $18b8fbd7df5541f7$var$be = $18b8fbd7df5541f7$var$xe(2);
function $18b8fbd7df5541f7$var$$e(e, n) {
    const t = 1 === n, r = t ? $18b8fbd7df5541f7$var$ve : $18b8fbd7df5541f7$var$be, i = t ? $18b8fbd7df5541f7$var$ye : $18b8fbd7df5541f7$var$ke, l = t ? $18b8fbd7df5541f7$var$he : $18b8fbd7df5541f7$var$me;
    return {
        match (e, n, t) {
            const i = $18b8fbd7df5541f7$var$ce.exec(t);
            return i && (n.list || !n.inline && !n.simple) ? r.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse (e, n, r) {
            const o = t ? +e[2] : void 0, c = e[0].replace($18b8fbd7df5541f7$var$d, "\n").match(i);
            let a = !1;
            return {
                items: c.map(function(e, t) {
                    const i = l.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(o, "").replace(l, ""), d = t === c.length - 1, u = -1 !== s.indexOf("\n\n") || d && a;
                    a = u;
                    const p = r.inline, f = r.list;
                    let h;
                    r.list = !0, u ? (r.inline = !1, h = s.replace($18b8fbd7df5541f7$var$oe, "\n\n")) : (r.inline = !0, h = s.replace($18b8fbd7df5541f7$var$oe, ""));
                    const m = n(h, r);
                    return r.inline = p, r.list = f, m;
                }),
                ordered: t,
                start: o
            };
        },
        render: (n, t, r)=>e(n.ordered ? "ol" : "ul", {
                key: r.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, t(n, r));
            }))
    };
}
const $18b8fbd7df5541f7$var$Se = /^\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$we = /^!\[([^\]]*)]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $18b8fbd7df5541f7$var$Ce = [
    $18b8fbd7df5541f7$var$u,
    $18b8fbd7df5541f7$var$m,
    $18b8fbd7df5541f7$var$g,
    $18b8fbd7df5541f7$var$C,
    $18b8fbd7df5541f7$var$A,
    $18b8fbd7df5541f7$var$E,
    $18b8fbd7df5541f7$var$L,
    $18b8fbd7df5541f7$var$N,
    $18b8fbd7df5541f7$var$ye,
    $18b8fbd7df5541f7$var$ve,
    $18b8fbd7df5541f7$var$ke,
    $18b8fbd7df5541f7$var$be
], $18b8fbd7df5541f7$var$Ee = [
    ...$18b8fbd7df5541f7$var$Ce,
    /^[^\n]+(?:  \n|\n{2,})/,
    $18b8fbd7df5541f7$var$O,
    $18b8fbd7df5541f7$var$M
];
function $18b8fbd7df5541f7$var$Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $18b8fbd7df5541f7$var$Oe(e) {
    return $18b8fbd7df5541f7$var$Q.test(e) ? "right" : $18b8fbd7df5541f7$var$V.test(e) ? "center" : $18b8fbd7df5541f7$var$X.test(e) ? "left" : null;
}
function $18b8fbd7df5541f7$var$Te(e, n, t) {
    const r = t.inTable;
    t.inTable = !0;
    const i = n(e.trim(), t);
    t.inTable = r;
    let l = [
        []
    ];
    return i.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== i.length - 1 && l.push([]) : ("27" !== e.type || null != i[n + 1] && "26" !== i[n + 1].type || (e.text = e.text.replace($18b8fbd7df5541f7$var$q, "")), l[l.length - 1].push(e));
    }), l;
}
function $18b8fbd7df5541f7$var$Le(e, n, t) {
    t.inline = !0;
    const r = $18b8fbd7df5541f7$var$Te(e[1], n, t), i = e[2].replace($18b8fbd7df5541f7$var$Z, "").split("|").map($18b8fbd7df5541f7$var$Oe), l = function(e, n, t) {
        return e.trim().split("\n").map(function(e) {
            return $18b8fbd7df5541f7$var$Te(e, n, t);
        });
    }(e[3], n, t);
    return t.inline = !1, {
        align: i,
        cells: l,
        header: r,
        type: "25"
    };
}
function $18b8fbd7df5541f7$var$ze(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $18b8fbd7df5541f7$var$Me(e) {
    return function(n, t) {
        return t.inline ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Ie(e) {
    return function(n, t) {
        return t.inline || t.simple ? e.exec(n) : null;
    };
}
function $18b8fbd7df5541f7$var$Re(e) {
    return function(n, t) {
        return t.inline || t.simple ? null : e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$Ue(e) {
    return function(n) {
        return e.exec(n);
    };
}
function $18b8fbd7df5541f7$var$je(e, n, t) {
    if (n.inline || n.simple) return null;
    if (t && !t.endsWith("\n")) return null;
    let r = "";
    e.split("\n").every((e)=>!$18b8fbd7df5541f7$var$Ce.some((n)=>n.test(e)) && (r += e + "\n", e.trim()));
    const i = r.trimEnd();
    return "" == i ? null : [
        r,
        i
    ];
}
function $18b8fbd7df5541f7$var$Be(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function $18b8fbd7df5541f7$var$Ne(e) {
    return e.replace($18b8fbd7df5541f7$var$le, "$1");
}
function $18b8fbd7df5541f7$var$He(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !0, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$De(e, n, t) {
    const r = t.inline || !1, i = t.simple || !1;
    t.inline = !1, t.simple = !0;
    const l = e(n, t);
    return t.inline = r, t.simple = i, l;
}
function $18b8fbd7df5541f7$var$Pe(e, n, t) {
    return t.inline = !1, e(n, t);
}
const $18b8fbd7df5541f7$var$_e = (e, n, t)=>({
        children: $18b8fbd7df5541f7$var$He(n, e[1], t)
    });
function $18b8fbd7df5541f7$var$Fe() {
    return {};
}
function $18b8fbd7df5541f7$var$We() {
    return null;
}
function $18b8fbd7df5541f7$var$Ge(...e) {
    return e.filter(Boolean).join(" ");
}
function $18b8fbd7df5541f7$var$Ze(e, n, t) {
    let r = e;
    const i = n.split(".");
    for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
    return r || t;
}
function $18b8fbd7df5541f7$export$69f434acfbdb0b32(t, r = {}) {
    r.overrides = r.overrides || {}, r.slugify = r.slugify || $18b8fbd7df5541f7$var$Ae, r.namedCodesToUnicode = r.namedCodesToUnicode ? $18b8fbd7df5541f7$var$n({}, $18b8fbd7df5541f7$var$o, r.namedCodesToUnicode) : $18b8fbd7df5541f7$var$o;
    const i = r.createElement || $eUqFw.createElement;
    function d(e, t, ...l) {
        const o = $18b8fbd7df5541f7$var$Ze(r.overrides, `${e}.props`, {});
        return i(function(e, n) {
            const t = $18b8fbd7df5541f7$var$Ze(n, e);
            return t ? "function" == typeof t || "object" == typeof t && "render" in t ? t : $18b8fbd7df5541f7$var$Ze(n, `${e}.component`, e) : e;
        }(e, r.overrides), $18b8fbd7df5541f7$var$n({}, t, o, {
            className: $18b8fbd7df5541f7$var$Ge(null == t ? void 0 : t.className, o.className) || void 0
        }), ...l);
    }
    function Z(n) {
        n = n.replace($18b8fbd7df5541f7$var$S, "");
        let t = !1;
        r.forceInline ? t = !0 : r.forceBlock || (t = !1 === $18b8fbd7df5541f7$var$F.test(n));
        const i = oe(le(t ? n : `${n.trimEnd().replace($18b8fbd7df5541f7$var$re, "")}\n\n`, {
            inline: t
        }));
        for(; "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === r.wrapper) return i;
        const l = r.wrapper || (t ? "span" : "div");
        let o;
        if (i.length > 1 || r.forceWrapper) o = i;
        else {
            if (1 === i.length) return o = i[0], "string" == typeof o ? d("span", {
                key: "outer"
            }, o) : o;
            o = null;
        }
        return $eUqFw.createElement(l, {
            key: "outer"
        }, o);
    }
    function q(n) {
        const t = n.match($18b8fbd7df5541f7$var$a);
        return t ? t.reduce(function(n, t, r) {
            const i = t.indexOf("=");
            if (-1 !== i) {
                const o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($18b8fbd7df5541f7$var$z) && (e = e.replace($18b8fbd7df5541f7$var$B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(t.slice(0, i)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(t.slice(i + 1).trim()), a = $18b8fbd7df5541f7$var$l[o] || o, s = n[a] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        const t = n.slice(0, n.indexOf(":"));
                        return e[t.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = n.slice(t.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? $18b8fbd7df5541f7$var$Be(n) : (n.match($18b8fbd7df5541f7$var$I) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof s && ($18b8fbd7df5541f7$var$O.test(s) || $18b8fbd7df5541f7$var$M.test(s)) && (n[a] = $eUqFw.cloneElement(Z(s.trim()), {
                    key: r
                }));
            } else "style" !== t && (n[$18b8fbd7df5541f7$var$l[t] || t] = !0);
            return n;
        }, {}) : null;
    }
    const V = [], X = {}, Q = {
        0: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$u),
            order: 1,
            parse: (e, n, t)=>({
                    children: n(e[0].replace($18b8fbd7df5541f7$var$p, ""), t)
                }),
            render: (e, n, t)=>d("blockquote", {
                    key: t.key
                }, n(e.children, t))
        },
        1: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$f),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("br", {
                    key: t.key
                })
        },
        2: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$h),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: (e, n, t)=>d("hr", {
                    key: t.key
                })
        },
        3: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$g),
            order: 0,
            parse: (e)=>({
                    lang: void 0,
                    text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                }),
            render: (e, t, r)=>d("pre", {
                    key: r.key
                }, d("code", $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    className: e.lang ? `lang-${e.lang}` : ""
                }), e.text))
        },
        4: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$m),
            order: 0,
            parse: (e)=>({
                    attrs: q(e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$y),
            order: 3,
            parse: (e)=>({
                    text: e[2]
                }),
            render: (e, n, t)=>d("code", {
                    key: t.key
                }, e.text)
        },
        6: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$v),
            order: 0,
            parse: (e)=>(V.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            render: $18b8fbd7df5541f7$var$We
        },
        7: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$b),
            order: 1,
            parse: (e)=>({
                    target: `#${r.slugify(e[1])}`,
                    text: e[1]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target)
                }, d("sup", {
                    key: t.key
                }, e.text))
        },
        8: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$w),
            order: 1,
            parse: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            render: (e, n, t)=>d("input", {
                    checked: e.completed,
                    key: t.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            match: $18b8fbd7df5541f7$var$Re(r.enforceAtxHeadings ? $18b8fbd7df5541f7$var$E : $18b8fbd7df5541f7$var$C),
            order: 1,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[2], t),
                    id: r.slugify(e[2]),
                    level: e[1].length
                }),
            render: (e, n, t)=>d(`h${e.level}`, {
                    id: e.id,
                    key: t.key
                }, n(e.children, t))
        },
        10: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$A),
            order: 0,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$He(n, e[1], t),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$O),
            order: 1,
            parse (e, n, t) {
                const [, r] = e[3].match($18b8fbd7df5541f7$var$ie), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), o = (a = l, $18b8fbd7df5541f7$var$Ee.some((e)=>e.test(a)) ? $18b8fbd7df5541f7$var$Pe : $18b8fbd7df5541f7$var$He);
                var a;
                const s = e[1].toLowerCase(), d = -1 !== $18b8fbd7df5541f7$var$c.indexOf(s), u = {
                    attrs: q(e[2]),
                    noInnerParse: d,
                    tag: d ? s : e[1]
                };
                return t.inAnchor = t.inAnchor || "a" === s, d ? u.text = e[3] : u.children = o(n, l, t), t.inAnchor = !1, u;
            },
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({
                    key: r.key
                }, e.attrs), e.text || t(e.children, r))
        },
        13: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$M),
            order: 1,
            parse: (e)=>({
                    attrs: q(e[2] || ""),
                    tag: e[1]
                }),
            render: (e, t, r)=>d(e.tag, $18b8fbd7df5541f7$var$n({}, e.attrs, {
                    key: r.key
                }))
        },
        12: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$L),
            order: 1,
            parse: ()=>({}),
            render: $18b8fbd7df5541f7$var$We
        },
        14: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$we),
            order: 1,
            parse: (e)=>({
                    alt: e[1],
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: $18b8fbd7df5541f7$var$Be(e.target)
                })
        },
        15: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$Se),
            order: 3,
            parse: (e, n, t)=>({
                    children: $18b8fbd7df5541f7$var$De(n, e[1], t),
                    target: $18b8fbd7df5541f7$var$Ne(e[2]),
                    title: e[3]
                }),
            render: (e, n, t)=>d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(e.target),
                    title: e.title
                }, n(e.children, t))
        },
        16: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$j),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    type: "15"
                })
        },
        17: {
            match: (e, n)=>n.inAnchor ? null : $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$R)(e, n),
            order: 0,
            parse: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        18: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$U),
            order: 0,
            parse (e) {
                let n = e[1], t = e[1];
                return $18b8fbd7df5541f7$var$s.test(t) || (t = "mailto:" + t), {
                    children: [
                        {
                            text: n.replace("mailto:", ""),
                            type: "27"
                        }
                    ],
                    target: t,
                    type: "15"
                };
            }
        },
        20: $18b8fbd7df5541f7$var$$e(d, 1),
        33: $18b8fbd7df5541f7$var$$e(d, 2),
        19: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$k),
            order: 3,
            parse: $18b8fbd7df5541f7$var$Fe,
            render: ()=>"\n"
        },
        21: {
            match: $18b8fbd7df5541f7$var$je,
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("p", {
                    key: t.key
                }, n(e.children, t))
        },
        22: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$H),
            order: 0,
            parse: (e)=>(X[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            render: $18b8fbd7df5541f7$var$We
        },
        23: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$D),
            order: 0,
            parse: (e)=>({
                    alt: e[1] || void 0,
                    ref: e[2]
                }),
            render: (e, n, t)=>d("img", {
                    key: t.key,
                    alt: e.alt,
                    src: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                })
        },
        24: {
            match: $18b8fbd7df5541f7$var$Me($18b8fbd7df5541f7$var$P),
            order: 0,
            parse: (e, n, t)=>({
                    children: n(e[1], t),
                    fallbackChildren: n(e[0].replace($18b8fbd7df5541f7$var$_, "\\$1"), t),
                    ref: e[2]
                }),
            render: (e, n, t)=>X[e.ref] ? d("a", {
                    key: t.key,
                    href: $18b8fbd7df5541f7$var$Be(X[e.ref].target),
                    title: X[e.ref].title
                }, n(e.children, t)) : d("span", {
                    key: t.key
                }, n(e.fallbackChildren, t))
        },
        25: {
            match: $18b8fbd7df5541f7$var$Re($18b8fbd7df5541f7$var$N),
            order: 1,
            parse: $18b8fbd7df5541f7$var$Le,
            render: (e, n, t)=>d("table", {
                    key: t.key
                }, d("thead", null, d("tr", null, e.header.map(function(r, i) {
                    return d("th", {
                        key: i,
                        style: $18b8fbd7df5541f7$var$ze(e, i)
                    }, n(r, t));
                }))), d("tbody", null, e.cells.map(function(r, i) {
                    return d("tr", {
                        key: i
                    }, r.map(function(r, i) {
                        return d("td", {
                            key: i,
                            style: $18b8fbd7df5541f7$var$ze(e, i)
                        }, n(r, t));
                    }));
                })))
        },
        26: {
            match: function(e, n) {
                return n.inTable ? (n.inline = !0, $18b8fbd7df5541f7$var$G.exec(e)) : null;
            },
            order: 1,
            parse: function() {
                return {
                    type: "26"
                };
            },
            render: ()=>" | "
        },
        27: {
            match: $18b8fbd7df5541f7$var$Ue($18b8fbd7df5541f7$var$te),
            order: 4,
            parse: (e)=>({
                    text: e[0].replace($18b8fbd7df5541f7$var$T, (e, n)=>r.namedCodesToUnicode[n] ? r.namedCodesToUnicode[n] : e)
                }),
            render: (e)=>e.text
        },
        28: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$J),
            order: 2,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("strong", {
                    key: t.key
                }, n(e.children, t))
        },
        29: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$K),
            order: 3,
            parse: (e, n, t)=>({
                    children: n(e[2], t)
                }),
            render: (e, n, t)=>d("em", {
                    key: t.key
                }, n(e.children, t))
        },
        30: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ne),
            order: 1,
            parse: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$Y),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("mark", {
                    key: t.key
                }, n(e.children, t))
        },
        32: {
            match: $18b8fbd7df5541f7$var$Ie($18b8fbd7df5541f7$var$ee),
            order: 3,
            parse: $18b8fbd7df5541f7$var$_e,
            render: (e, n, t)=>d("del", {
                    key: t.key
                }, n(e.children, t))
        }
    };
    !0 === r.disableParsingRawHTML && (delete Q[11], delete Q[13]);
    const le = function(e) {
        let n = Object.keys(e);
        function t(r, i) {
            let l = [], o = "";
            for(; r;){
                let c = 0;
                for(; c < n.length;){
                    const a = n[c], s = e[a], d = s.match(r, i, o);
                    if (d) {
                        const e = d[0];
                        r = r.substring(e.length);
                        const n = s.parse(d, t, i);
                        null == n.type && (n.type = a), l.push(n), o = e;
                        break;
                    }
                    c++;
                }
            }
            return l;
        }
        return n.sort(function(n, t) {
            let r = e[n].order, i = e[t].order;
            return r !== i ? r - i : 1;
        }), function(e, n) {
            return t(function(e) {
                return e.replace($18b8fbd7df5541f7$var$x, "\n").replace($18b8fbd7df5541f7$var$$, "").replace($18b8fbd7df5541f7$var$W, "    ");
            }(e), n);
        };
    }(Q), oe = (ce = function(e, n) {
        return function(t, r, i) {
            const l = e[t.type].render;
            return n ? n(()=>l(t, r, i), t, r, i) : l(t, r, i);
        };
    }(Q, r.renderRule), function e(n, t = {}) {
        if (Array.isArray(n)) {
            const r = t.key, i = [];
            let l = !1;
            for(let r = 0; r < n.length; r++){
                t.key = r;
                const o = e(n[r], t), c = "string" == typeof o;
                c && l ? i[i.length - 1] += o : null !== o && i.push(o), l = c;
            }
            return t.key = r, i;
        }
        return ce(n, e, t);
    });
    var ce;
    const ae = Z(t);
    return V.length ? d("div", null, ae, d("footer", {
        key: "footer"
    }, V.map(function(e) {
        return d("div", {
            id: r.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, oe(le(e.footnote, {
            inline: !0
        })));
    }))) : ae;
}
var $18b8fbd7df5541f7$export$2e2bcd8739ae039 = (n)=>{
    let { children: r, options: i } = n, l = function(e, n) {
        if (null == e) return {};
        var t, r, i = {}, l = Object.keys(e);
        for(r = 0; r < l.length; r++)n.indexOf(t = l[r]) >= 0 || (i[t] = e[t]);
        return i;
    }(n, $18b8fbd7df5541f7$var$t);
    return $eUqFw.cloneElement($18b8fbd7df5541f7$export$69f434acfbdb0b32(r, i), l);
};

});

parcelRegister("fRvRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $215caff20423c5d7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $215caff20423c5d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $215caff20423c5d7$var$listStyles = {
    name: "k4jzwf",
    styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
};
const $215caff20423c5d7$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        css: $215caff20423c5d7$var$listStyles,
        ...props
    }, children);
var $215caff20423c5d7$export$2e2bcd8739ae039 = $215caff20423c5d7$var$UList;

});


parcelRegister("8xb3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0ebde4df0a9cbc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $45sl7 = parcelRequire("45sl7");
const $bc0ebde4df0a9cbc$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $45sl7.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $bc0ebde4df0a9cbc$export$2e2bcd8739ae039 = $bc0ebde4df0a9cbc$var$AIEventSummaryViewed;

});



parcelRegister("jgolE", function(module, exports) {

$parcel$export(module.exports, "default", () => $64f51aa4942c7ea2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4AgCU = parcelRequire("4AgCU");

var $caOA9 = parcelRequire("caOA9");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $64f51aa4942c7ea2$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
    if (status !== (0, $caOA9.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AgCU.default), {
        ...props,
        testId: testId
    });
};
var $64f51aa4942c7ea2$export$2e2bcd8739ae039 = $64f51aa4942c7ea2$var$AIFooterBlock;

});
parcelRegister("4AgCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ddf1676e35a244$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4sQhG = parcelRequire("4sQhG");

var $bampN = parcelRequire("bampN");

var $caOA9 = parcelRequire("caOA9");

var $7IEJa = parcelRequire("7IEJa");

var $4AAjx = parcelRequire("4AAjx");
const $f4ddf1676e35a244$var$AIFooterBlockResolvedView = (props)=>{
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const actionData = context?.actions?.[(0, $caOA9.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.Provider), {
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7IEJa.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $f4ddf1676e35a244$export$2e2bcd8739ae039 = $f4ddf1676e35a244$var$AIFooterBlockResolvedView;

});
parcelRegister("7IEJa", function(module, exports) {

$parcel$export(module.exports, "AIFooterMetadata", () => $de37226e2d74f64d$export$175228cc2c92b3b6);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $asu8X = parcelRequire("asu8X");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $fN7pY = parcelRequire("fN7pY");

var $f9UoZ = parcelRequire("f9UoZ");

var $4abrz = parcelRequire("4abrz");

var $04PAQ = parcelRequire("04PAQ");
const $de37226e2d74f64d$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    (0, $asu8X.di)((0, $04PAQ.default));
    const { state: { status: status } } = (0, $04PAQ.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9UoZ.InfoIcon), {
            label: "Information",
            size: "small",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fN7pY.default), {
        label: "AI",
        size: "small",
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("f9UoZ", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $73dd1366f48d3276$export$2957fc44b3d2481);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $73dd1366f48d3276$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
        fill: "currentColor"
    }));
const $73dd1366f48d3276$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $73dd1366f48d3276$var$CustomGlyph
    });

});




parcelRegister("5I51G", function(module, exports) {

$parcel$export(module.exports, "default", () => $af32a75a0d93a295$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $4AAjx = parcelRequire("4AAjx");

var $eJljw = parcelRequire("eJljw");

var $4z862 = parcelRequire("4z862");

var $kbWJ8 = parcelRequire("kbWJ8");

var $asu8X = parcelRequire("asu8X");
function $af32a75a0d93a295$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af32a75a0d93a295$var$ignoreContainerPaddingStyles = {
    name: "19m4cma",
    styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
};
const $af32a75a0d93a295$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $af32a75a0d93a295$var$sort = (a, b)=>{
    let idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $af32a75a0d93a295$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $af32a75a0d93a295$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
    (0, $asu8X.di)((0, $kbWJ8.ActionFooter));
    const context = (0, $4AAjx.useFlexibleUiContext)();
    const ui = (0, $4AAjx.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $eUqFw.useState)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const onLoadingChange = (0, $eUqFw.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !ui?.hidePadding ? (0, $4z862.getPrimitivesPaddingSpaceBySize)(ui?.size || (0, $caOA9.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $eUqFw.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback?.(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $eUqFw.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $eUqFw.useMemo)(()=>{
        if (!context?.actions) return;
        const arr = Object.keys(context.actions);
        arr.sort($af32a75a0d93a295$var$sort);
        return arr.map((name)=>{
            const Action = name in $eJljw ? $eJljw[name] : undefined;
            return Action ? /*#__PURE__*/ (0, $byn9U.jsx)(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                xcss: (0, $1ZAYh.xcss)({
                    paddingInline: padding
                }),
                hideTooltip: isLoading
            }) : null;
        });
    }, [
        context?.actions,
        onClick,
        onError,
        padding,
        size,
        spaceInline,
        isLoading,
        onLoadingChange
    ]);
    return actions ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $af32a75a0d93a295$var$ignoreContainerPaddingStyles,
        ref: blockRef,
        "data-testid": testId
    }, actions, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbWJ8.ActionFooter), {
        message: message,
        paddingInline: padding,
        testId: testId
    })) : null;
};
var $af32a75a0d93a295$export$2e2bcd8739ae039 = $af32a75a0d93a295$var$ActionBlock;

});
parcelRegister("kbWJ8", function(module, exports) {

$parcel$export(module.exports, "ActionFooter", () => $9ecf2b3307383602$export$2d2b754ac238f9aa);

var $96IgR = parcelRequire("96IgR");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $eUqFw = parcelRequire("eUqFw");

var $3FvFV = parcelRequire("3FvFV");
const $9ecf2b3307383602$var$containerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    borderRadius: 'border.radius',
    margin: 'space.100',
    marginBottom: 'space.0',
    lineHeight: '20px',
    padding: 'space.075',
    paddingInline: 'space.100',
    width: '100%',
    ':empty': {
        display: 'none'
    }
});
const $9ecf2b3307383602$var$errorStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.danger'
});
const $9ecf2b3307383602$var$titleStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px'
});
const $9ecf2b3307383602$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19716
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                primaryColor: "var(--ds-icon-danger, #C9372C)",
                label: "Error",
                size: "small",
                testId: "action-error-icon"
            }));
        default:
            return null;
    }
};
const $9ecf2b3307383602$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: `${testId}-footer`,
        xcss: [
            $9ecf2b3307383602$var$containerStyles,
            message.appearance === 'error' && $9ecf2b3307383602$var$errorStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3FvFV.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "start",
        grow: "fill",
        space: "space.050"
    }, message.icon || $9ecf2b3307383602$var$getIcon(message.appearance), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $9ecf2b3307383602$var$titleStyles
    }, message.title))));
};

});







parcelRegister("fTNaM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35c62bcc8002acc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8uD7Y = parcelRequire("8uD7Y");

var $byn9U = parcelRequire("byn9U");

var $bampN = parcelRequire("bampN");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $4z862 = parcelRequire("4z862");

var $7GItJ = parcelRequire("7GItJ");
function $d35c62bcc8002acc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d35c62bcc8002acc$var$actionStyles = {
    name: "r982j0",
    styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
};
const $d35c62bcc8002acc$var$getMessageStyles = (size, hasAction)=>{
    const sizeStyles = (0, $4z862.getLinkSizeStyles)(size);
    return /*#__PURE__*/ (0, $byn9U.css)("flex:1 1 auto;justify-content:flex-end;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasAction ? $d35c62bcc8002acc$var$actionStyles : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    sizeStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $4z862.getTruncateStyles)(1, (0, $4z862.getLinkLineHeight)(size)), {
        color: "var(--ds-text-disabled, #6B778C)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
        }
    });
};
/**
 * Represents an Errored TitleBlock view.
 * This will render when a Smart Link did not successfully resolve.
 * This may be a result of a Smart Link not having the correct credentials,
 * or the backend response was errored or malformed.
 * @see TitleBlock
 */ const $d35c62bcc8002acc$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
    const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const hasAction = onClick !== undefined;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-errored-view`
    }, !hideIcon && /*#__PURE__*/ (0, $byn9U.jsx)((0, $bampN.LinkIcon), {
        overrideIcon: icon,
        position: position
    }), title, descriptor && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7GItJ.default), {
        direction: (0, $caOA9.SmartLinkDirection).Horizontal,
        align: (0, $caOA9.SmartLinkAlignment).Right
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: hasAction ? 'has-action' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $d35c62bcc8002acc$var$getMessageStyles(size, hasAction),
        onClick: onClick,
        "data-testid": `${testId}-errored-view-message`,
        tabIndex: hasAction ? 0 : -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...descriptor,
        values: values
    }))), actionGroup);
};
var $d35c62bcc8002acc$export$2e2bcd8739ae039 = $d35c62bcc8002acc$var$TitleBlockErroredView;

});

parcelRegister("G9qxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6e75535fc810aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4sQhG = parcelRequire("4sQhG");

var $caOA9 = parcelRequire("caOA9");

var $8SIiI = parcelRequire("8SIiI");

var $4z862 = parcelRequire("4z862");
/**
 * This represents a TitleBlock for a Smart Link that is currently waiting
 * for a request to finish.
 * This should render when a Smart Link has sent a request.
 * @see TitleBlock
 */ const $1c6e75535fc810aa$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
    const { size: size = (0, $caOA9.SmartLinkSize).Medium } = blockProps;
    const iconWidth = (0, $4z862.getIconWidth)(size);
    const iconStyles = (0, $4z862.getIconSizeStyles)(iconWidth);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...blockProps,
        testId: `${testId}-resolving-view`
    }, !hideIcon && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: iconStyles,
        "data-testid": `${testId}-icon`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        testId: `${testId}-icon-loading`
    })), title, actionGroup);
};
var $1c6e75535fc810aa$export$2e2bcd8739ae039 = $1c6e75535fc810aa$var$TitleBlockResolvingView;

});


parcelRegister("2DGq0", function(module, exports) {

$parcel$export(module.exports, "CardSSR", () => $d0c3c915f91d47b8$export$7b5e1b7f9a325b6);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $jb3WS = parcelRequire("jb3WS");

var $aw5Sy = parcelRequire("aw5Sy");

var $hAdQp = parcelRequire("hAdQp");

var $fsWgj = parcelRequire("fsWgj");

var $bTNMs = parcelRequire("bTNMs");
const $d0c3c915f91d47b8$export$7b5e1b7f9a325b6 = (props)=>{
    const [id] = (0, $eUqFw.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    const cardProps = {
        ...props,
        id: id
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: (0, $bTNMs.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsWgj.LoadingCardLink), cardProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAdQp.CardWithUrlContent), cardProps)));
};

});
parcelRegister("hAdQp", function(module, exports) {

$parcel$export(module.exports, "CardWithUrlContent", () => $ad36ad6e9528d83a$export$7598f5d7c597dd32);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $iNbFo = parcelRequire("iNbFo");

var $9A6mL = parcelRequire("9A6mL");

var $hEsGF = parcelRequire("hEsGF");

var $269iK = parcelRequire("269iK");

var $kzkPi = parcelRequire("kzkPi");

var $0fper = parcelRequire("0fper");

var $cLOfJ = parcelRequire("cLOfJ");

var $lTJB1 = parcelRequire("lTJB1");

var $6oJXW = parcelRequire("6oJXW");

var $kKYlt = parcelRequire("kKYlt");

var $caOA9 = parcelRequire("caOA9");

var $lyAeo = parcelRequire("lyAeo");

var $fck9X = parcelRequire("fck9X");

var $eGeQQ = parcelRequire("eGeQQ");
function $ad36ad6e9528d83a$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, isFrameVisible: isFrameVisible, frameStyle: frameStyleProp, platform: platform, onClick: onClick, appearance: appearance, dispatchAnalytics: dispatchAnalytics, onResolve: onResolve, onError: onError, testId: testId, showActions: showActions, showServerActions: showServerActions, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, analyticsEvents: analyticsEvents, useLegacyBlockCard: useLegacyBlockCard, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // Get state, actions for this card.
    const { state: state, actions: actions, analytics: defaultAnalytics, config: config, renderers: renderers, error: error } = (0, $kzkPi.useSmartLink)(id, url, dispatchAnalytics);
    const analytics = analyticsEvents || defaultAnalytics;
    const definitionId = (0, $269iK.getDefinitionId)(state.details);
    const extensionKey = (0, $269iK.getExtensionKey)(state.details);
    const resourceType = (0, $269iK.getResourceType)(state.details);
    const product = (0, $269iK.getProduct)(state.details);
    const subproduct = (0, $269iK.getSubproduct)(state.details);
    const services = (0, $269iK.getServices)(state.details);
    const canBeDatasource = (0, $269iK.getCanBeDatasource)(state.details);
    let isFlexibleUi = (0, $eUqFw.useMemo)(()=>(0, $6oJXW.isFlexibleUiCard)(children), [
        children
    ]);
    const actionOptions = (0, $fck9X.combineActionOptions)({
        actionOptions: actionOptionsProp,
        showServerActions: showServerActions,
        showActions: showActions,
        platform: platform
    });
    const frameStyle = (0, $9A6mL.combineFrameStyle)(frameStyleProp, isFrameVisible);
    // Setup UI handlers.
    const handleClickWrapper = (0, $eUqFw.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $9A6mL.isSpecialEvent)(event);
        analytics.ui.cardClickedEvent({
            id: id,
            display: isFlexibleUi ? (0, $caOA9.CardDisplay).Flexible : appearance,
            status: state.status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            isModifierKeyPressed: isModifierKeyPressed,
            destinationProduct: product,
            destinationSubproduct: subproduct
        });
        if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $269iK.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isModifierKeyPressed` be true.
            const target = isModifierKeyPressed ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        id,
        url,
        state.details,
        state.status,
        analytics.ui,
        appearance,
        definitionId,
        extensionKey,
        onClick,
        isFlexibleUi,
        product,
        subproduct,
        createAnalyticsEvent
    ]);
    const handleAuthorize = (0, $eUqFw.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $eUqFw.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $eUqFw.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $eUqFw.useEffect)(()=>{
        $hEsGF.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $hEsGF.create(id, state.status);
            analytics.operational.instrument({
                id: id,
                status: state.status,
                definitionId: definitionId,
                extensionKey: extensionKey ?? state.error?.extensionKey,
                resourceType: resourceType,
                error: state.error
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        analytics.operational
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $269iK.isFinalState)(state.status)) analytics.ui.renderSuccessEvent({
            display: isFlexibleUi ? 'flexible' : appearance,
            status: state.status,
            id: id,
            definitionId: definitionId,
            extensionKey: extensionKey,
            canBeDatasource: canBeDatasource
        });
    }, [
        isFlexibleUi,
        appearance,
        state.status,
        url,
        definitionId,
        extensionKey,
        analytics.ui,
        id,
        canBeDatasource
    ]);
    const onIframeDwell = (0, $eUqFw.useCallback)((dwellTime, dwellPercentVisible)=>{
        analytics.ui.iframeDwelledEvent({
            id: id,
            display: isFlexibleUi ? 'flexible' : appearance,
            status: state.status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: product,
            destinationSubproduct: subproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        });
    }, [
        id,
        state.status,
        analytics.ui,
        appearance,
        definitionId,
        extensionKey,
        isFlexibleUi,
        product,
        subproduct
    ]);
    const onIframeFocus = (0, $eUqFw.useCallback)(()=>{
        analytics.ui.iframeFocusedEvent({
            id: id,
            display: isFlexibleUi ? 'flexible' : appearance,
            status: state.status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: product,
            destinationSubproduct: subproduct
        });
    }, [
        id,
        state.status,
        analytics.ui,
        appearance,
        definitionId,
        extensionKey,
        isFlexibleUi,
        product,
        subproduct
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
            id: id,
            cardState: cardState,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            showAuthTooltip: showAuthTooltip,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError,
            analytics: analytics
        }, children);
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cLOfJ.InlineCard), {
                analytics: analytics,
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                showAuthTooltip: showAuthTooltip,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder
            });
        case 'block':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0fper.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleInvoke: handleInvoke,
                handleFrameClick: handleClickWrapper,
                analytics: analytics,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                platform: platform,
                enableFlexibleBlockCard: useLegacyBlockCard !== true
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lTJB1.EmbedCard), {
                id: id,
                url: url,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleInvoke: handleInvoke,
                analytics: analytics,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus
            });
    }
}
const $ad36ad6e9528d83a$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $6oJXW.isFlexibleUiCard)(props.children) ? (0, $caOA9.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iNbFo.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eGeQQ.SmartLinkAnalyticsContext), {
        url: props.url,
        id: props.id,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad36ad6e9528d83a$var$Component, props)));
};

});
parcelRegister("kzkPi", function(module, exports) {

$parcel$export(module.exports, "useSmartLink", () => $f112deea07579e0e$export$9f4e486b1dc3e700);

var $eUqFw = parcelRequire("eUqFw");

var $b81Yi = parcelRequire("b81Yi");

var $ibKIt = parcelRequire("ibKIt");

var $GPm6G = parcelRequire("GPm6G");

var $jtkmg = parcelRequire("jtkmg");

var $4XjK2 = parcelRequire("4XjK2");

var $gqldc = parcelRequire("gqldc");
function $f112deea07579e0e$export$9f4e486b1dc3e700(id, url, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Avoid prop drilling analytics handlers. Continue passing a handler for now if there's already one in place.
	 */ dispatchAnalytics) {
    const state = (0, $b81Yi.useSmartCardState)(url);
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url, dispatchAnalytics, id);
    const actions = (0, $ibKIt.useSmartCardActions)(id, url, analytics);
    const config = (0, $GPm6G.useSmartLinkConfig)();
    const renderers = (0, $4XjK2.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $eUqFw.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        analytics: analytics,
        renderers: renderers,
        error: error
    };
}

});
parcelRegister("ibKIt", function(module, exports) {

$parcel$export(module.exports, "useSmartCardActions", () => $b8e0945b17791722$export$f7c340395f31e832);

var $eUqFw = parcelRequire("eUqFw");

var $6Y4Ff = parcelRequire("6Y4Ff");

var $gqldc = parcelRequire("gqldc");

var $6EHO5 = parcelRequire("6EHO5");

var $269iK = parcelRequire("269iK");

var $caOA9 = parcelRequire("caOA9");

var $af6S8 = parcelRequire("af6S8");

var $3SJS1 = parcelRequire("3SJS1");
const $b8e0945b17791722$export$f7c340395f31e832 = (id, url, analytics)=>{
    const resolveUrl = (0, $af6S8.default)();
    const invokeClientAction = (0, $3SJS1.default)({
        analytics: analytics
    });
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $eUqFw.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $caOA9.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $eUqFw.useCallback)((metadataStatus)=>{
        dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $eUqFw.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $eUqFw.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $6EHO5.cardAction)((0, $6EHO5.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $eUqFw.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $269iK.getDefinitionId)(details);
        if (definitionId) (0, $269iK.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $eUqFw.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $eUqFw.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $269iK.getDefinitionId)(details);
        const extensionKey = (0, $269iK.getExtensionKey)(details);
        const services = (0, $269iK.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') analytics.ui.authEvent({
            display: appearance,
            definitionId: definitionId,
            extensionKey: extensionKey
        });
        if (status === 'forbidden') analytics.ui.authAlternateAccountEvent({
            display: appearance,
            definitionId: definitionId,
            extensionKey: extensionKey
        });
        if (services.length > 0) {
            analytics.screen.authPopupEvent({
                definitionId: definitionId,
                extensionKey: extensionKey
            });
            (0, $6Y4Ff.auth)(services[0].url).then(()=>{
                analytics.track.appAccountConnected({
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                analytics.operational.connectSucceededEvent({
                    id: id,
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                reload();
            }, (err)=>{
                analytics.operational.connectFailedEvent({
                    id: id,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    reason: err.type
                });
                if (err.type === 'auth_window_closed') analytics.ui.closedAuthEvent({
                    display: appearance,
                    definitionId: definitionId,
                    extensionKey: extensionKey
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        analytics.ui,
        analytics.screen,
        analytics.track,
        analytics.operational,
        id,
        reload
    ]);
    const invoke = (0, $eUqFw.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("6Y4Ff", function(module, exports) {

$parcel$export(module.exports, "auth", () => $f8e4a233562063a8$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("dCD3m")).AuthError);

var $dCD3m = parcelRequire("dCD3m");

var $aMNE6 = parcelRequire("aMNE6");
function $f8e4a233562063a8$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $aMNE6.isOfTypeAuthError)(errorType)) reject(new (0, $dCD3m.AuthError)(data.message, errorType));
                    else reject(new (0, $dCD3m.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $dCD3m.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("dCD3m", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $0d7f9acb0a73d09c$export$145273558d58e0ac);
class $0d7f9acb0a73d09c$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message);
        this.message = message;
        this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("aMNE6", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $7b1b7575975439b3$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $7b1b7575975439b3$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});



parcelRegister("GPm6G", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkConfig", () => $0a1b6d7078d2ccbd$export$5d10838c1e539409);

var $gqldc = parcelRequire("gqldc");
const $0a1b6d7078d2ccbd$export$5d10838c1e539409 = ()=>{
    const context = (0, $gqldc.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});

parcelRegister("jtkmg", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkAnalytics", () => $4156fbcb4ce186b5$export$57c7fece972c9472);

var $eUqFw = parcelRequire("eUqFw");

var $cGAGh = parcelRequire("cGAGh");

var $bTNMs = parcelRequire("bTNMs");
var $x8tkc = parcelRequire("x8tkc");

var $2cI4y = parcelRequire("2cI4y");

var $269iK = parcelRequire("269iK");

var $gqldc = parcelRequire("gqldc");

var $bTNMs = parcelRequire("bTNMs");

var $h71BW = parcelRequire("h71BW");
const $4156fbcb4ce186b5$var$applyCommonAttributes = (event, commonAttributes)=>{
    if (event && event.attributes) {
        for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
    }
    return event;
};
const $4156fbcb4ce186b5$export$57c7fece972c9472 = (url, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Overriding the analytics dispatch method is deprecated. Please omit this argument.
	 */ _dispatchAnalytics, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Provide this via the id prop on the `<Card />` component.
	 */ id, /**
	 * @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
	 * Provide this attribute via analytics context.
	 */ defaultLocation)=>{
    const { dispatchAnalytics: dispatchAnalytics } = (0, $h71BW.useDispatchAnalytics)(_dispatchAnalytics);
    const defaultId = id || 'NULL';
    // We don't want to trigger a re-render by using useSmartCardState
    const { store: store } = (0, $gqldc.useSmartLinkContext)();
    const state = store ? (0, $cGAGh.getUrl)(store, url) : undefined;
    const details = state ? state.details : undefined;
    const extractedDefinitionId = (0, $269iK.getDefinitionId)(details);
    const extractedExtensionKey = (0, $269iK.getExtensionKey)(details);
    const extractedResourceType = (0, $269iK.getResourceType)(details);
    const extractedSubproduct = (0, $269iK.getSubproduct)(details);
    const extractedProduct = (0, $269iK.getProduct)(details);
    const extractedStatusDetails = (0, $269iK.getStatusDetails)(details);
    const commonAttributes = (0, $eUqFw.useMemo)(()=>({
            id: defaultId,
            definitionId: extractedDefinitionId,
            extensionKey: extractedExtensionKey,
            resourceType: extractedResourceType,
            destinationObjectType: extractedResourceType,
            destinationSubproduct: extractedSubproduct,
            destinationProduct: extractedProduct,
            location: defaultLocation,
            statusDetails: extractedStatusDetails
        }), [
        defaultId,
        extractedDefinitionId,
        extractedExtensionKey,
        extractedResourceType,
        extractedSubproduct,
        extractedProduct,
        defaultLocation,
        extractedStatusDetails
    ]);
    /** Contains all ui analytics events */ const ui = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with no current authenticated account. (i.e. Connect to Preview).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on the authentication
			 * call to action with a forbidden authenticated account. (i.e. Try another account).
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiAuthAlternateAccountEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user
			 * click a button.
			 * @param data A partial analytics event payload
			 */ buttonClickedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param isModifierKeyPressed Whether a modifier key was pressed when clicking the Smart Link.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiCardClickedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    isModifierKeyPressed: isModifierKeyPressed,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    actionSubjectId: actionSubjectId
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user dwells their cursor on a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @param dwellTime Total seconds that the user has dwelled on this iframe
			 * @param dwellPercentVisible Percentage element was visible at end of dwell
			 * @returns
			 */ iframeDwelledEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeDwelledEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    dwellTime: dwellTime,
                    dwellPercentVisible: dwellPercentVisible
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks or tabs into a Smart Link's iframe.
			 * @param id The unique ID for this Smart Link.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param status What status the Smart Link is currently in (e.g. resolved, unresolved)
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location Where the Smart Link is currently rendered.
			 * @param destinationProduct The product the Smart Link is linked to.
			 * @returns
			 */ iframeFocusedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiIframeFocusedEvent)({
                    id: id,
                    display: display,
                    status: status,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    location: location,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user clicks on a Smart Link action.
			 * Note: This also starts the UFO smart-link-action-invocation experience.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of the action that was clicked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param invokeType @deprecated {@link https://hello.atlassian.net/browse/ENGHEALTH-2681 Internal documentation for deprecation (no external access)}
			 * @returns
			 */ actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiActionClickedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user clicks on a hover preview's "navigate to link" button.
			 * https://product-fabric.atlassian.net/wiki/spaces/EM/pages/3206743323/Analytics+Metrics+-+Hover+Previews
			 * @param previewDisplay What format the preview is in.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 */ hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardOpenLinkClickedEvent)({
                    id: defaultId,
                    previewDisplay: previewDisplay,
                    definitionId: definitionId,
                    extensionKey: extensionKey,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a user closed the authentication window without authenticating after opening it.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiClosedAuthEvent)({
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user close a modal.
			 * @param data A partial analytics event payload
			 */ modalClosedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'closed',
                    actionSubject: 'modal',
                    actionSubjectId: data.actionSubjectId,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'ui'
                }, commonAttributes)),
            /**
			 * This fires an event that represents when a Smart Link was rendered successfully.
			 * Note: this fires even if the Smart Link request errored out.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param canBeDatasource An indicator that shows that a smart link can be converted to a datasource
			 */ renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.succeedUfoExperience)('smart-link-rendered', experienceId, {
                    extensionKey: extensionKey,
                    display: display
                });
                // UFO will disregard this if authentication experience has not yet been started
                (0, $2cI4y.succeedUfoExperience)('smart-link-authenticated', experienceId, {
                    display: display
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderSuccessEvent)({
                    display: display,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    canBeDatasource: canBeDatasource
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                // Start and fail the smart-link-rendered experience. If it has already
                // been started nothing happens.
                (0, $2cI4y.startUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-rendered', experienceId);
                (0, $2cI4y.failUfoExperience)('smart-link-authenticated', experienceId);
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiRenderFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents a hover preview being opened.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardViewedEvent)({
                    id: id,
                    previewDisplay: previewDisplay,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * This fires an event that represents a hover preview being dismissed.
			 * @param hoverDisplay Whether the hover preview was displayed as a card or embed.
			 * @param hoverTime The duration that the user hovered over a Smart Link before the preview was dismissed.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @param previewInvokeMethod How the preview was triggered.
			 * @returns
			 */ hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiHoverCardDismissedEvent)({
                    previewDisplay: previewDisplay,
                    id: id,
                    hoverTime: hoverTime,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    previewInvokeMethod: previewInvokeMethod,
                    status: status
                }), commonAttributes)),
            /**
			 * Fires an event that signifies that a "Learn More" link was clicked on an unauthenticated card
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param location The location where a link is displayed (jiraWebLinks, confluencePages etc)
			 */ learnMoreClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiLearnMoreLinkClickedEvent)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge
			 */ smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge's dropdown item
			 */ smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
            /**
			 * Fires an event that represent a click was performed on a Status Lozenge open preview button
			 */ smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
            smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.uiServerActionClicked)(props), commonAttributes))
        }), [
        dispatchAnalytics,
        commonAttributes,
        defaultId,
        extractedExtensionKey
    ]);
    /** Contains all operational analytics events */ const operational = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event that represents an action being successfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 */ invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeSucceededEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an action being unsuccessfully invoked.
			 * @param id The unique ID for this Smart Link.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param actionType The type of action invoked, e.g. PreviewAction
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param reason The reason the invocation failed.
			 */ invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.invokeFailedEvent)({
                    id: id ?? defaultId,
                    actionType: actionType,
                    display: display,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account successfully being connected via a Smart Link.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 */ connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectSucceededEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event that represents an account unsuccessfully being connected.
			 * @param id The unique ID for this Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param reason The reason why the Smart Link connect account failed.
			 */ connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                const experienceId = id ? id : defaultId;
                (0, $2cI4y.startUfoExperience)('smart-link-authenticated', experienceId, {
                    extensionKey: extensionKey,
                    status: reason
                });
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.connectFailedEvent)({
                    ...commonAttributes,
                    id: experienceId,
                    reason: reason,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            },
            /**
			 * This fires an event which represents a Smart Link request succeeding or failing based on the status.
			 * @param id The unique ID for this Smart Link.
			 * @param status The status of the Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @param resourceType The type of resource that was invoked. This is provider specific (e.g. File, PullRequest).
			 * @param error An error representing why the Smart Link request failed.
			 */ instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                const event = (0, $x8tkc.instrumentEvent)({
                    ...commonAttributes,
                    id: id,
                    status: status,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location,
                    error: error
                });
                if (event) dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes(event, commonAttributes));
            },
            /**
			 * This fires an event that represents when a Smart Link renders unsuccessfuly.
			 * @param display Whether the card was an Inline, Block, Embed or Flexible UI.
			 * @param id The unique ID for this Smart Link.
			 * @param error: An error representing why the Smart Link render failed.
			 * @param errorInfo: Additional details about the error including the stack trace.
			 */ chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.chunkloadFailedEvent)({
                    display: display,
                    error: error,
                    errorInfo: errorInfo,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes));
            }
        }), [
        defaultId,
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all track analytics events */ const track = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents a user connecting their account to view a Smart Link.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ appAccountConnected: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountConnected)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event which represents a user starting the Smart Link connect account process.
			 * @param location a location where the Smart Link auth action was initiated.
			 * @param extensionKey The extensionKey of the Smart Link resolver invoked.
			 * @returns
			 */ appAccountAuthStarted: ({ extensionKey: extensionKey, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackAppAccountAuthStarted)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    location: location
                }), commonAttributes)),
            /**
			 * Removed in EDM-5153: This is an even from an experiment.
			 * @deprecated
			 */ linkUpdated: ()=>{},
            /**
			 * This fires a tracking event before an action invoke api call is made
			 */ smartLinkQuickActionStarted: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionStarted)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call is successful
			 */ smartLinkQuickActionSuccess: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionSuccess)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * This fires a tracking event after an action invoke api call has failed
			 */ smartLinkQuickActionFailed: (props)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackSmartLinkQuickActionFailed)({
                    ...commonAttributes,
                    ...props
                }), commonAttributes)),
            /**
			 * Fires a track event when we call loadMetadata() to get information for a hover card
			 */ hoverCardResolutionStarted: ()=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.trackHoverCardResolutionStarted)({
                    display: 'hoverCardPreview',
                    ...commonAttributes
                }), commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    /** Contains all screen analytics events */ const screen = (0, $eUqFw.useMemo)(()=>({
            /**
			 * This fires an event which represents the connect account page being opened.
			 * @param definitionId The definitionId of the Smart Link resolver invoked.
			 * @param extensionKey The extensionKey of the Smart Link resovler invoked.
			 * @returns
			 */ authPopupEvent: ({ extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes((0, $bTNMs.screenAuthPopupEvent)({
                    ...commonAttributes,
                    extensionKey: extensionKey,
                    definitionId: definitionId,
                    resourceType: resourceType,
                    destinationProduct: destinationProduct,
                    destinationSubproduct: destinationSubproduct,
                    location: location
                }), commonAttributes)),
            /**
			 * This fires an event that represents when a user view a modal.
			 * @param data A partial analytics event payload
			 */ modalViewedEvent: (data)=>dispatchAnalytics($4156fbcb4ce186b5$var$applyCommonAttributes({
                    action: 'viewed',
                    actionSubject: data.name,
                    attributes: {
                        ...(0, $bTNMs.context),
                        ...data.attributes
                    },
                    eventType: 'screen',
                    name: data.name
                }, commonAttributes))
        }), [
        commonAttributes,
        dispatchAnalytics
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            ui: ui,
            operational: operational,
            track: track,
            screen: screen
        }), [
        ui,
        operational,
        track,
        screen
    ]);
};

});
parcelRegister("x8tkc", function(module, exports) {

$parcel$export(module.exports, "instrumentEvent", () => $823c14fa33decb2a$export$860cf9c079ed505);

var $hEsGF = parcelRequire("hEsGF");

var $bTNMs = parcelRequire("bTNMs");
const $823c14fa33decb2a$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
    const measure = (0, $hEsGF.getMeasure)(id, status) || {
        duration: undefined
    };
    if (status === 'resolved') {
        const event = (0, $bTNMs.resolvedEvent)({
            id: id,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    } else if (error?.type !== 'ResolveUnsupportedError') {
        const event = (0, $bTNMs.unresolvedEvent)({
            id: id,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            resourceType: resourceType,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            error: error
        });
        return {
            ...event,
            attributes: {
                ...event.attributes,
                duration: measure.duration
            }
        };
    }
};

});

parcelRegister("h71BW", function(module, exports) {

$parcel$export(module.exports, "useDispatchAnalytics", () => $abd09e159ea44bb9$export$5f37699fba0ba807);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $bTNMs = parcelRequire("bTNMs");
const $abd09e159ea44bb9$export$5f37699fba0ba807 = (handler)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return {
        dispatchAnalytics: (0, $eUqFw.useMemo)(()=>{
            if (handler) return handler;
            return (payload)=>{
                createAnalyticsEvent(payload).fire((0, $bTNMs.ANALYTICS_CHANNEL));
            };
        }, [
            handler,
            createAnalyticsEvent
        ])
    };
};

});


parcelRegister("4XjK2", function(module, exports) {

$parcel$export(module.exports, "useSmartLinkRenderers", () => $eea7a418db70e1c9$export$c3514c024fefef57);

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");
const $eea7a418db70e1c9$export$c3514c024fefef57 = ()=>{
    const context = (0, $gqldc.useSmartLinkContext)();
    let renderers = context?.renderers;
    renderers = (0, $eUqFw.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});


parcelRegister("0fper", function(module, exports) {

$parcel$export(module.exports, "BlockCard", () => $671ae8db7dc5ce70$export$d18ccd25c0d2c6b0);
$parcel$export(module.exports, "BlockCardResolvedView", () => (parcelRequire("ews4K")).ResolvedView);
$parcel$export(module.exports, "BlockCardResolvingView", () => (parcelRequire("gKAQ5")).ResolvingView);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bFzGY = parcelRequire("bFzGY");

var $269iK = parcelRequire("269iK");

var $9Eiuw = parcelRequire("9Eiuw");

var $7pH5u = parcelRequire("7pH5u");

var $8tvRs = parcelRequire("8tvRs");

var $4lXV3 = parcelRequire("4lXV3");

var $453K0 = parcelRequire("453K0");

var $lGrBa = parcelRequire("lGrBa");

var $ews4K = parcelRequire("ews4K");

var $40mAF = parcelRequire("40mAF");

var $gKAQ5 = parcelRequire("gKAQ5");

var $lMSvl = parcelRequire("lMSvl");

var $fBBtb = parcelRequire("fBBtb");

var $2x0O5 = parcelRequire("2x0O5");

var $1QC1T = parcelRequire("1QC1T");

var $3Zd30 = parcelRequire("3Zd30");

var $eNZbA = parcelRequire("eNZbA");

var $gCRIg = parcelRequire("gCRIg");

var $aeAjk = parcelRequire("aeAjk");

var $byn9U = parcelRequire("byn9U");

var $lhgZW = parcelRequire("lhgZW");

var $lFzxK = parcelRequire("lFzxK");
const $671ae8db7dc5ce70$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, handleInvoke: handleInvoke, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, platform: platform, analytics: analytics, enableFlexibleBlockCard: enableFlexibleBlockCard, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const data = details && details.data || (0, $7pH5u.getEmptyJsonLd)();
    const meta = details && details.meta;
    const extensionKey = (0, $269iK.getExtensionKey)(details);
    const extractorOpts = {
        analytics: analytics,
        origin: 'smartLinkCard',
        handleInvoke: handleInvoke,
        extensionKey: extensionKey,
        actionOptions: actionOptions
    };
    if (enableFlexibleBlockCard) {
        const flexibleBlockCardProps = {
            id: id,
            cardState: cardState,
            url: url,
            testId: testId,
            onClick: (event)=>(0, $lhgZW.handleClickCommon)(event, handleFrameClick),
            onError: onError,
            onResolve: onResolve,
            renderers: renderers,
            actionOptions: actionOptions,
            analytics: analytics
        };
        switch(status){
            case 'pending':
            case 'resolving':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1QC1T.default), {
                    ...flexibleBlockCardProps,
                    testId: 'smart-block-resolving-view'
                });
            case 'resolved':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1QC1T.default), flexibleBlockCardProps);
            case 'unauthorized':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3Zd30.default), {
                    ...flexibleBlockCardProps,
                    onAuthorize: handleAuthorize
                });
            case 'forbidden':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gCRIg.default), {
                    ...flexibleBlockCardProps,
                    onAuthorize: handleAuthorize
                });
            case 'not_found':
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eNZbA.default), {
                    ...flexibleBlockCardProps,
                    onAuthorize: handleAuthorize
                });
            case 'fallback':
            case 'errored':
            default:
                if (onError) onError({
                    url: url,
                    status: status
                });
                if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4lXV3.CardLinkView), {
                    link: url,
                    isSelected: isSelected,
                    onClick: handleFrameClick,
                    testId: `${testId}-${status}`
                });
                return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aeAjk.default), {
                    ...flexibleBlockCardProps,
                    onAuthorize: handleAuthorize
                });
        }
    }
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gKAQ5.ResolvingView), {
                testId: testId,
                isSelected: isSelected
            });
        case 'resolved':
            const resolvedViewProps = (0, $9Eiuw.extractBlockProps)(data, meta, extractorOpts, renderers, platform);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url
            });
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ews4K.ResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                testId: testId,
                onClick: handleFrameClick
            });
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorizedViewProps = (0, $9Eiuw.extractBlockProps)(data, meta, extractorOpts);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lMSvl.UnauthorizedView), {
                ...unauthorizedViewProps,
                isSelected: isSelected,
                testId: testId,
                actions: handleAuthorize ? [
                    (0, $453K0.AuthorizeAction)(handleAuthorize)
                ] : [],
                actionOptions: actionOptions,
                onClick: handleFrameClick
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $9Eiuw.extractBlockProps)(data, meta, extractorOpts);
            const cardMetadata = details?.meta ?? (0, $7pH5u.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $8tvRs.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fBBtb.ForbiddenView), {
                ...forbiddenViewProps,
                isSelected: isSelected,
                actions: handleAuthorize ? [
                    (0, $lGrBa.ForbiddenAction)(handleAuthorize)
                ] : [],
                actionOptions: actionOptions,
                onClick: handleFrameClick,
                requestAccessContext: requestAccessContext
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $9Eiuw.extractBlockProps)(data, meta, extractorOpts);
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $40mAF.NotFoundView), {
                ...notFoundViewProps,
                isSelected: isSelected,
                testId: testId,
                onClick: handleFrameClick
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4lXV3.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2x0O5.ErroredView), {
                link: url,
                isSelected: isSelected,
                onRetry: handleErrorRetry,
                onClick: handleFrameClick,
                testId: testId
            });
    }
};

});
parcelRegister("9Eiuw", function(module, exports) {

$parcel$export(module.exports, "extractBlockProps", () => $3d076f209fb5402b$export$183e15864834a0bd);

var $4zMKr = parcelRequire("4zMKr");
var $24j8L = parcelRequire("24j8L");

var $i9zl6 = parcelRequire("i9zl6");

var $s2tJO = parcelRequire("s2tJO");

var $bILit = parcelRequire("bILit");
var $lrB7A = parcelRequire("lrB7A");
var $2W9Up = parcelRequire("2W9Up");
var $cc539 = parcelRequire("cc539");

var $lbKTa = parcelRequire("lbKTa");
var $lnW6z = parcelRequire("lnW6z");
var $cx2mN = parcelRequire("cx2mN");
var $dlXJJ = parcelRequire("dlXJJ");
var $c8AiI = parcelRequire("c8AiI");
var $gd1O9 = parcelRequire("gd1O9");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $eahqC = parcelRequire("eahqC");

var $buT9h = parcelRequire("buT9h");

var $e3WTQ = parcelRequire("e3WTQ");

var $cNILZ = parcelRequire("cNILZ");

var $5fK3A = parcelRequire("5fK3A");
const $3d076f209fb5402b$var$extractBlockIcon = (jsonLd)=>{
    const icon = (0, $s2tJO.extractIcon)(jsonLd);
    if (typeof icon === 'string') return {
        url: icon
    };
    else return {
        icon: icon
    };
};
const $3d076f209fb5402b$var$extractBlockDetails = (jsonLd)=>[
        (0, $lrB7A.extractCommentCount)(jsonLd),
        (0, $2W9Up.extractProgrammingLanguage)(jsonLd),
        (0, $cc539.extractSubscriberCount)(jsonLd),
        (0, $bILit.extractAttachmentCount)(jsonLd)
    ].filter((detail)=>!!detail);
const $3d076f209fb5402b$export$874f983fcd62a981 = (props, jsonLd, opts, platform, meta)=>{
    if (opts) {
        const { handleInvoke: handleInvoke, actionOptions: actionOptions } = opts;
        const actions = (0, $e3WTQ.extractClientActions)(jsonLd, handleInvoke, actionOptions);
        const previewAction = (0, $cNILZ.extractPreviewAction)({
            ...opts,
            viewProps: props,
            jsonLd: jsonLd,
            platform: platform,
            meta: meta
        });
        // The previewAction should always be the last action
        if (previewAction) actions.push(previewAction);
        return actions;
    }
    return [];
};
const $3d076f209fb5402b$export$37f7a7348279b273 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') return (0, $cx2mN.extractMembers)(jsonLd);
    else if (jsonLd['@type'] === 'atlassian:Task') {
        const assignedMembers = (0, $dlXJJ.extractPersonAssignedTo)(jsonLd);
        if (assignedMembers) return [
            assignedMembers
        ];
    } else if (jsonLd['@type'] === 'atlassian:SourceCodePullRequest') return (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
    else {
        const updatedBy = (0, $gd1O9.extractPersonUpdatedBy)(jsonLd);
        let updatedByMembers;
        if (updatedBy) updatedByMembers = [
            updatedBy
        ];
        const createdByMembers = (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
        return updatedByMembers || createdByMembers;
    }
};
const $3d076f209fb5402b$export$183e15864834a0bd = (jsonLd, meta, opts, renderers, platform)=>{
    const props = {
        link: (0, $lnW6z.extractLink)(jsonLd),
        title: (0, $a4gSw.extractTitle)(jsonLd),
        titleTextColor: (0, $24j8L.extractTitleTextColor)(jsonLd),
        lozenge: (0, $i9zl6.extractLozenge)(jsonLd),
        icon: $3d076f209fb5402b$var$extractBlockIcon(jsonLd),
        context: (0, $ebCNT.extractProvider)(jsonLd),
        details: $3d076f209fb5402b$var$extractBlockDetails(jsonLd),
        byline: (0, $4zMKr.extractSummary)(jsonLd) || (0, $eahqC.extractByline)(jsonLd),
        thumbnail: (0, $lbKTa.extractImage)(jsonLd),
        users: $3d076f209fb5402b$export$37f7a7348279b273(jsonLd),
        titlePrefix: (0, $buT9h.extractTitlePrefix)(jsonLd, renderers, 'block'),
        isTrusted: (0, $5fK3A.extractIsTrusted)(meta)
    };
    return {
        ...props,
        actions: $3d076f209fb5402b$export$874f983fcd62a981(props, jsonLd, opts, platform, meta)
    };
};

});
parcelRegister("24j8L", function(module, exports) {

$parcel$export(module.exports, "extractTitleTextColor", () => $3edef14ae51bdf5a$export$a2afc198e9dada1);

var $2aTcn = parcelRequire("2aTcn");

const $3edef14ae51bdf5a$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return `var(--ds-text-danger, ${0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02})`;
            default:
                return undefined;
        }
    }
};

});

parcelRegister("s2tJO", function(module, exports) {

$parcel$export(module.exports, "extractIcon", () => $c16b40392cebfc0c$export$64bdf1f5e49e8626);

var $eUqFw = parcelRequire("eUqFw");

var $iwsIy = parcelRequire("iwsIy");

var $fU2qj = parcelRequire("fU2qj");

var $6VQ7Z = parcelRequire("6VQ7Z");

var $gQa4O = parcelRequire("gQa4O");

var $egbU6 = parcelRequire("egbU6");

var $hiUvC = parcelRequire("hiUvC");

var $9A6mL = parcelRequire("9A6mL");

var $2aTcn = parcelRequire("2aTcn");

var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");
var $amPw7 = parcelRequire("amPw7");

var $36X1C = parcelRequire("36X1C");

var $av1Br = parcelRequire("av1Br");

var $1dx5E = parcelRequire("1dx5E");

var $jy3WR = parcelRequire("jy3WR");

var $4afqa = parcelRequire("4afqa");
const $c16b40392cebfc0c$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type')=>{
    const type = jsonLd['@type'];
    const opts = {
        title: (0, $a4gSw.extractTitle)(jsonLd),
        provider: (0, $ebCNT.extractProvider)(jsonLd),
        fileFormat: (0, $36X1C.extractFileFormat)(jsonLd),
        taskType: (0, $jy3WR.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $amPw7.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $2aTcn.extractorPriorityMap)[b] - (0, $2aTcn.extractorPriorityMap)[a])[0];
        return $c16b40392cebfc0c$var$extractIconByType(highestPriorityType, opts);
    } else return $c16b40392cebfc0c$var$extractIconByType(type, opts);
};
function $c16b40392cebfc0c$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fU2qj))), {
                label: opts.title || 'commit',
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19498
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
                label: opts.title || 'project',
                size: "small",
                testId: "project-icon"
            });
        case 'atlassian:SourceCodePullRequest':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6VQ7Z))), {
                label: opts.title || 'pullRequest',
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gQa4O))), {
                label: opts.title || 'reference',
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($egbU6))), {
                label: opts.title || 'repository',
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                label: opts.title || 'goal',
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $1dx5E.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $c16b40392cebfc0c$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $c16b40392cebfc0c$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $9A6mL.getIconForFileType)(opts.fileFormat) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $c16b40392cebfc0c$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $av1Br.extractIconFromDocument)(type, opts);
        default:
            return $c16b40392cebfc0c$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("fU2qj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b93df738dedd3ac6$var$_react = $b93df738dedd3ac6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b93df738dedd3ac6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b93df738dedd3ac6$var$Commit16Icon = (props)=>/*#__PURE__*/ $b93df738dedd3ac6$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 9a1 1 0 100-2 1 1 0 000 2zm-.986 1.834a3.001 3.001 0 010-5.668A1.007 1.007 0 017 5V3a1 1 0 112 0v2c0 .057-.005.112-.014.166a3.001 3.001 0 010 5.668c.01.054.014.11.014.166v2a1 1 0 01-2 0v-2c0-.057.005-.112.014-.166z"/></svg>`
    }, props, {
        size: "small"
    }));
$b93df738dedd3ac6$var$Commit16Icon.displayName = 'Commit16Icon';
var $b93df738dedd3ac6$var$_default = $b93df738dedd3ac6$var$Commit16Icon;
module.exports.default = $b93df738dedd3ac6$var$_default;

});

parcelRegister("6VQ7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50c080749674b039$var$_react = $50c080749674b039$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50c080749674b039$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50c080749674b039$var$PullRequest16Icon = (props)=>/*#__PURE__*/ $50c080749674b039$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M6.417 6H9a1 1 0 011 1v1a1 1 0 002 0V7a3 3 0 00-3-3H6.415l.294-.295a1 1 0 10-1.413-1.414l-2.003 2a1 1 0 00.001 1.415l2.002 2.001a.999.999 0 001.414-.002.999.999 0 00-.001-1.413L6.417 6zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9 14a2 2 0 100-4 2 2 0 000 4z"/></svg>`
    }, props, {
        size: "small"
    }));
$50c080749674b039$var$PullRequest16Icon.displayName = 'PullRequest16Icon';
var $50c080749674b039$var$_default = $50c080749674b039$var$PullRequest16Icon;
module.exports.default = $50c080749674b039$var$_default;

});

parcelRegister("gQa4O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c42951abc82b6c35$var$_react = $c42951abc82b6c35$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c42951abc82b6c35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c42951abc82b6c35$var$Branch16Icon = (props)=>/*#__PURE__*/ $c42951abc82b6c35$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M10 8.732v.28A1.993 1.993 0 018.002 11l-.004 2A3.995 3.995 0 0012 9.007v-.274a2 2 0 10-2 0zm-4-3a2 2 0 10-2 0v4.536a2 2 0 102 0V5.732zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$c42951abc82b6c35$var$Branch16Icon.displayName = 'Branch16Icon';
var $c42951abc82b6c35$var$_default = $c42951abc82b6c35$var$Branch16Icon;
module.exports.default = $c42951abc82b6c35$var$_default;

});

parcelRegister("egbU6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a61bcb2b0c01b80b$var$_react = $a61bcb2b0c01b80b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a61bcb2b0c01b80b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a61bcb2b0c01b80b$var$Code16Icon = (props)=>/*#__PURE__*/ $a61bcb2b0c01b80b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2.92 4.72L2.34 7.3a.998.998 0 000 1.414l2.58 2.578a1 1 0 001.414-1.416L4.46 8.006l1.873-1.871A1 1 0 104.92 4.72zm4.792 0a.999.999 0 000 1.415l1.874 1.87-1.873 1.87a1 1 0 101.414 1.416l2.58-2.58a1 1 0 000-1.414L11.126 4.72a.996.996 0 00-.706-.292.995.995 0 00-.708.293z"/></svg>`
    }, props, {
        size: "small"
    }));
$a61bcb2b0c01b80b$var$Code16Icon.displayName = 'Code16Icon';
var $a61bcb2b0c01b80b$var$_default = $a61bcb2b0c01b80b$var$Code16Icon;
module.exports.default = $a61bcb2b0c01b80b$var$_default;

});

parcelRegister("hiUvC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c98ff3a06ace07f2$var$_react = $c98ff3a06ace07f2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c98ff3a06ace07f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c98ff3a06ace07f2$var$Task16Icon = (props)=>/*#__PURE__*/ $c98ff3a06ace07f2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3H4.667zM5 5v6h6V5H5z"/></svg>`
    }, props, {
        size: "small"
    }));
$c98ff3a06ace07f2$var$Task16Icon.displayName = 'Task16Icon';
var $c98ff3a06ace07f2$var$_default = $c98ff3a06ace07f2$var$Task16Icon;
module.exports.default = $c98ff3a06ace07f2$var$_default;

});

parcelRegister("36X1C", function(module, exports) {

$parcel$export(module.exports, "extractFileFormat", () => $5af5b408333e6bb6$export$f2d65f02f6888b60);
const $5af5b408333e6bb6$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("av1Br", function(module, exports) {

$parcel$export(module.exports, "extractIconFromDocument", () => $1ec5d72f762200d9$export$25c24c7f577936d3);

var $eUqFw = parcelRequire("eUqFw");

var $42mVw = parcelRequire("42mVw");

var $hC3Rz = parcelRequire("hC3Rz");

var $iIEQk = parcelRequire("iIEQk");

var $kaVAc = parcelRequire("kaVAc");

var $33pqc = parcelRequire("33pqc");

var $68N91 = parcelRequire("68N91");

var $9A6mL = parcelRequire("9A6mL");

var $4afqa = parcelRequire("4afqa");
const $1ec5d72f762200d9$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $1ec5d72f762200d9$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $1ec5d72f762200d9$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $1ec5d72f762200d9$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $9A6mL.getIconForFileType)(opts.fileFormat);
};
const $1ec5d72f762200d9$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42mVw))), {
                label: opts.title || 'blog',
                testId: "blog-icon"
            });
        case 'schema:DigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hC3Rz))), {
                label: opts.title || 'file',
                testId: "file-icon"
            });
        case 'schema:TextDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: opts.title || 'document',
                testId: "document-icon"
            });
        case 'schema:PresentationDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iIEQk))), {
                label: opts.title || 'presentation',
                testId: "presentation-icon"
            });
        case 'schema:SpreadsheetDigitalDocument':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kaVAc))), {
                label: opts.title || 'spreadsheet',
                testId: "spreadsheet-icon"
            });
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($68N91))), {
                color: "currentColor",
                label: opts.title || 'template',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($33pqc))), {
                label: opts.title || 'undefinedLink',
                testId: "document-icon"
            });
    }
};

});
parcelRegister("hC3Rz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cd28fb6529d0fdb1$var$_react = $cd28fb6529d0fdb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cd28fb6529d0fdb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cd28fb6529d0fdb1$var$Generic16Icon = (props)=>/*#__PURE__*/ $cd28fb6529d0fdb1$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.333.333 0 00-.093-.231l-2.164-2.25A1.333 1.333 0 008.782 3H8zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994z"/></svg>`
    }, props, {
        size: 'small'
    }));
$cd28fb6529d0fdb1$var$Generic16Icon.displayName = 'Generic16Icon';
var $cd28fb6529d0fdb1$var$_default = $cd28fb6529d0fdb1$var$Generic16Icon;
module.exports.default = $cd28fb6529d0fdb1$var$_default;

});

parcelRegister("iIEQk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $da0c049bdbf3c329$var$_react = $da0c049bdbf3c329$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $da0c049bdbf3c329$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $da0c049bdbf3c329$var$Presentation16Icon = (props)=>/*#__PURE__*/ $da0c049bdbf3c329$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm10 3a1 1 0 00-1 1v8a1 1 0 002 0V4a1 1 0 00-1-1zM8 6a1 1 0 00-1 1v5a1 1 0 002 0V7a1 1 0 00-1-1zM4 9a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'small'
    }));
$da0c049bdbf3c329$var$Presentation16Icon.displayName = 'Presentation16Icon';
var $da0c049bdbf3c329$var$_default = $da0c049bdbf3c329$var$Presentation16Icon;
module.exports.default = $da0c049bdbf3c329$var$_default;

});

parcelRegister("kaVAc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $eb01688efa6942b0$var$_react = $eb01688efa6942b0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $eb01688efa6942b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $eb01688efa6942b0$var$Spreadsheet16Icon = (props)=>/*#__PURE__*/ $eb01688efa6942b0$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm2 3a1 1 0 100 2h1a1 1 0 100-2H4zm0 4a1 1 0 100 2h1a1 1 0 100-2H4zm0 4a1 1 0 000 2h1a1 1 0 000-2H4zm5-8a1 1 0 100 2h3a1 1 0 000-2H9zm0 4a1 1 0 100 2h3a1 1 0 000-2H9zm0 4a1 1 0 000 2h3a1 1 0 000-2H9z"/></svg>`
    }, props, {
        size: 'small'
    }));
$eb01688efa6942b0$var$Spreadsheet16Icon.displayName = 'Spreadsheet16Icon';
var $eb01688efa6942b0$var$_default = $eb01688efa6942b0$var$Spreadsheet16Icon;
module.exports.default = $eb01688efa6942b0$var$_default;

});

parcelRegister("68N91", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0c53c86e27205ffd8db542fb6733384>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47899c8223940754$var$_react = $47899c8223940754$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $47899c8223940754$var$_page = $47899c8223940754$var$_interopRequireDefault((parcelRequire("20Mcc")));

var $47899c8223940754$var$_documentFilled = $47899c8223940754$var$_interopRequireDefault((parcelRequire("nzdI3")));
function $47899c8223940754$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for PageIcon.
 * This component is PageIcon, with `UNSAFE_fallbackIcon` set to "DocumentFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $47899c8223940754$var$PageIcon = (props)=>/*#__PURE__*/ $47899c8223940754$var$_react.default.createElement($47899c8223940754$var$_page.default, Object.assign({
        LEGACY_fallbackIcon: $47899c8223940754$var$_documentFilled.default
    }, props));
$47899c8223940754$var$PageIcon.Name = 'PageIconMigration';
var $47899c8223940754$var$_default = module.exports.default = $47899c8223940754$var$PageIcon;

});
parcelRegister("20Mcc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cab2bd3bf7f5b1e2b2df4de8af9192f9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1770f78818431634$var$_react = $1770f78818431634$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1770f78818431634$var$_UNSAFE_baseNew = $1770f78818431634$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $1770f78818431634$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1770f78818431634$var$PageIcon = (props)=>/*#__PURE__*/ $1770f78818431634$var$_react.default.createElement($1770f78818431634$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 5.25h8m-8 3.5h6m-7 5.5h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$1770f78818431634$var$PageIcon.displayName = 'PageIcon';
var $1770f78818431634$var$_default = module.exports.default = $1770f78818431634$var$PageIcon;

});

parcelRegister("nzdI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $046d781480b548f9$var$_react = $046d781480b548f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $046d781480b548f9$var$_page = $046d781480b548f9$var$_interopRequireDefault((parcelRequire("20Mcc")));
function $046d781480b548f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $046d781480b548f9$var$DocumentFilledIcon = (props)=>/*#__PURE__*/ $046d781480b548f9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m18.99 8.99.01 1.015V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.275c.469 0 .922.164 1.282.464L18.631 7.7c.227.19.359.471.359.768zM12.02 5 12 8.192a.99.99 0 0 0 .994.991h4z"/></svg>`
    }, props, {
        newIcon: $046d781480b548f9$var$_page.default
    }));
$046d781480b548f9$var$DocumentFilledIcon.displayName = 'DocumentFilledIcon';
var $046d781480b548f9$var$_default = module.exports.default = $046d781480b548f9$var$DocumentFilledIcon;

});



parcelRegister("1dx5E", function(module, exports) {

$parcel$export(module.exports, "extractIconFromTask", () => $4ac251c9d7089865$export$321256ed044e3100);

var $eUqFw = parcelRequire("eUqFw");

var $hiUvC = parcelRequire("hiUvC");

var $aJNc8 = parcelRequire("aJNc8");

var $3Fcny = parcelRequire("3Fcny");

var $3YEb9 = parcelRequire("3YEb9");

var $gFrvj = parcelRequire("gFrvj");

var $bJZ7m = parcelRequire("bJZ7m");

var $2NYtj = parcelRequire("2NYtj");

var $fsJVW = parcelRequire("fsJVW");

var $5cywL = parcelRequire("5cywL");

var $4DxpJ = parcelRequire("4DxpJ");
const $4ac251c9d7089865$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const taskLabel = opts.title || 'task';
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
        label: taskLabel,
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $4DxpJ.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $4DxpJ.JIRA_TASK:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hiUvC))), {
                    label: taskLabel,
                    testId: "jira-task-icon"
                });
            case 0, $4DxpJ.JIRA_SUB_TASK:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aJNc8))), {
                    label: taskLabel,
                    testId: "jira-subtask-icon"
                });
            case 0, $4DxpJ.JIRA_STORY:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Fcny))), {
                    label: taskLabel,
                    testId: "jira-story-icon"
                });
            case 0, $4DxpJ.JIRA_BUG:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3YEb9))), {
                    label: taskLabel,
                    testId: "jira-bug-icon"
                });
            case 0, $4DxpJ.JIRA_EPIC:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFrvj))), {
                    label: taskLabel,
                    testId: "jira-epic-icon"
                });
            case 0, $4DxpJ.JIRA_INCIDENT:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJZ7m))), {
                    label: taskLabel,
                    testId: "jira-incident-icon"
                });
            case 0, $4DxpJ.JIRA_SERVICE_REQUEST:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NYtj))), {
                    label: taskLabel,
                    testId: "jira-service-request-icon"
                });
            case 0, $4DxpJ.JIRA_CHANGE:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsJVW))), {
                    label: taskLabel,
                    testId: "jira-change-icon"
                });
            case 0, $4DxpJ.JIRA_PROBLEM:
                // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19493
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5cywL))), {
                    label: taskLabel,
                    testId: "jira-problem-icon"
                });
            case 0, $4DxpJ.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});
parcelRegister("aJNc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $020474b73d22e170$var$_react = $020474b73d22e170$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $020474b73d22e170$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $020474b73d22e170$var$Subtask16Icon = (props)=>/*#__PURE__*/ $020474b73d22e170$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M9 7V4a1 1 0 00-1-1H4a1 1 0 00-1 1v4a1 1 0 001 1h3v3a1 1 0 001 1h4a1 1 0 001-1V8a1 1 0 00-1-1H9zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0114.006 16H1.994A1.995 1.995 0 010 14.006V1.994zM9 9h2v2H9V9zM5 5h2v2H5V5z"/></svg>`
    }, props, {
        size: "small"
    }));
$020474b73d22e170$var$Subtask16Icon.displayName = 'Subtask16Icon';
var $020474b73d22e170$var$_default = $020474b73d22e170$var$Subtask16Icon;
module.exports.default = $020474b73d22e170$var$_default;

});

parcelRegister("3Fcny", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2aaecda278f48b77$var$_react = $2aaecda278f48b77$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2aaecda278f48b77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2aaecda278f48b77$var$Story16Icon = (props)=>/*#__PURE__*/ $2aaecda278f48b77$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 11l-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426L8 11zm0-2.371l2 1.274V5H6v4.902L8 8.63z"/></svg>`
    }, props, {
        size: "small"
    }));
$2aaecda278f48b77$var$Story16Icon.displayName = 'Story16Icon';
var $2aaecda278f48b77$var$_default = $2aaecda278f48b77$var$Story16Icon;
module.exports.default = $2aaecda278f48b77$var$_default;

});

parcelRegister("3YEb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e5624669878641f$var$_react = $2e5624669878641f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e5624669878641f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e5624669878641f$var$Bug16Icon = (props)=>/*#__PURE__*/ $2e5624669878641f$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 12a4 4 0 100-8 4 4 0 000 8z"/></svg>`
    }, props, {
        size: "small"
    }));
$2e5624669878641f$var$Bug16Icon.displayName = 'Bug16Icon';
var $2e5624669878641f$var$_default = $2e5624669878641f$var$Bug16Icon;
module.exports.default = $2e5624669878641f$var$_default;

});

parcelRegister("gFrvj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c225cf658d24b86a$var$_react = $c225cf658d24b86a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c225cf658d24b86a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c225cf658d24b86a$var$Epic16Icon = (props)=>/*#__PURE__*/ $c225cf658d24b86a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554C0" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm9.912 7.767A.486.486 0 0012 7.5a.5.5 0 00-.5-.5H9V3.5a.495.495 0 00-.872-.327l-.002-.001-3.977 4.973-.008.009-.028.036.002.004A.487.487 0 004 8.5a.5.5 0 00.5.5c.028 0 .051-.011.077-.016H7V12.5a.5.5 0 00.5.5c.124 0 .234-.05.321-.124l.004.001.007-.009c.03-.027.051-.059.074-.092l3.934-4.913c.019-.018.031-.039.047-.06l.027-.033-.002-.003z"/></svg>`
    }, props, {
        size: "small"
    }));
$c225cf658d24b86a$var$Epic16Icon.displayName = 'Epic16Icon';
var $c225cf658d24b86a$var$_default = $c225cf658d24b86a$var$Epic16Icon;
module.exports.default = $c225cf658d24b86a$var$_default;

});

parcelRegister("bJZ7m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $88c34e63e2df12b5$var$_react = $88c34e63e2df12b5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $88c34e63e2df12b5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $88c34e63e2df12b5$var$Incident16Icon = (props)=>/*#__PURE__*/ $88c34e63e2df12b5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M4.785 10h6.43L10.5 8H5.499l-.714 2zM4 11a1 1 0 00-1 1v1h10v-1a1 1 0 00-1-1H4zm1.856-4h4.288L8.942 3.632a1 1 0 00-1.884 0L5.856 7zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$88c34e63e2df12b5$var$Incident16Icon.displayName = 'Incident16Icon';
var $88c34e63e2df12b5$var$_default = $88c34e63e2df12b5$var$Incident16Icon;
module.exports.default = $88c34e63e2df12b5$var$_default;

});

parcelRegister("2NYtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20af10cdef604edb$var$_react = $20af10cdef604edb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20af10cdef604edb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20af10cdef604edb$var$Issue16Icon = (props)=>/*#__PURE__*/ $20af10cdef604edb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684FF" fill-rule="evenodd" d="M2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm1 4a1 1 0 00-1 1v6a1 1 0 001 1h10a1 1 0 001-1V5a1 1 0 00-1-1H3zm1 2v4h8V6H4z"/></svg>`
    }, props, {
        size: "small"
    }));
$20af10cdef604edb$var$Issue16Icon.displayName = 'Issue16Icon';
var $20af10cdef604edb$var$_default = $20af10cdef604edb$var$Issue16Icon;
module.exports.default = $20af10cdef604edb$var$_default;

});

parcelRegister("fsJVW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b41d19f8b49fa534$var$_react = $b41d19f8b49fa534$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b41d19f8b49fa534$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b41d19f8b49fa534$var$Changes16Icon = (props)=>/*#__PURE__*/ $b41d19f8b49fa534$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M10.58 7H5.467l.866-.865A1 1 0 104.92 4.72L2.34 7.3a.998.998 0 000 1.414l2.58 2.578a1 1 0 001.414-1.416L5.456 9h5.134l-.877.876a1 1 0 101.414 1.415l2.58-2.58a1 1 0 000-1.414L11.126 4.72a.996.996 0 00-.706-.292.999.999 0 00-.707 1.707l.866.865zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2z"/></svg>`
    }, props, {
        size: "small"
    }));
$b41d19f8b49fa534$var$Changes16Icon.displayName = 'Changes16Icon';
var $b41d19f8b49fa534$var$_default = $b41d19f8b49fa534$var$Changes16Icon;
module.exports.default = $b41d19f8b49fa534$var$_default;

});

parcelRegister("5cywL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3c98db310910faad$var$_react = $3c98db310910faad$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $3c98db310910faad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $3c98db310910faad$var$Problem16Icon = (props)=>/*#__PURE__*/ $3c98db310910faad$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M5.968 11.446l5.478-5.478a4 4 0 01-5.478 5.478zm-.796-.618zm-.618-.796a4 4 0 015.478-5.478l-5.478 5.478zm6.274-4.86zM2 0h12a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm6 14A6 6 0 108 2a6 6 0 000 12z"/></svg>`
    }, props, {
        size: "small"
    }));
$3c98db310910faad$var$Problem16Icon.displayName = 'Problem16Icon';
var $3c98db310910faad$var$_default = $3c98db310910faad$var$Problem16Icon;
module.exports.default = $3c98db310910faad$var$_default;

});



parcelRegister("bILit", function(module, exports) {

$parcel$export(module.exports, "extractAttachmentCount", () => $abe20e355f69e333$export$65362ff78a97fd8);

var $eUqFw = parcelRequire("eUqFw");


var $cQbvW = parcelRequire("cQbvW");
const $abe20e355f69e333$export$65362ff78a97fd8 = (jsonLd)=>{
    const attachmentCount = jsonLd['atlassian:attachmentCount'];
    if (attachmentCount) return {
        text: attachmentCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQbvW))), {
            LEGACY_size: "small",
            label: "attachments",
            color: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`
        })
    };
};

});
parcelRegister("cQbvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::696780d644f297a474fc4901bdf6f744>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $959345d324230911$var$_react = $959345d324230911$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $959345d324230911$var$_attachment = $959345d324230911$var$_interopRequireDefault((parcelRequire("jzPfj")));

var $959345d324230911$var$_attachment2 = $959345d324230911$var$_interopRequireDefault((parcelRequire("jUThT")));
function $959345d324230911$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AttachmentIcon.
 * This component is AttachmentIcon, with `UNSAFE_fallbackIcon` set to "AttachmentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $959345d324230911$var$AttachmentIcon = (props)=>/*#__PURE__*/ $959345d324230911$var$_react.default.createElement($959345d324230911$var$_attachment.default, Object.assign({
        LEGACY_fallbackIcon: $959345d324230911$var$_attachment2.default
    }, props));
$959345d324230911$var$AttachmentIcon.Name = 'AttachmentIconMigration';
var $959345d324230911$var$_default = module.exports.default = $959345d324230911$var$AttachmentIcon;

});
parcelRegister("jzPfj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932bd55458dbf2b53d7a9e8ea9989eae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e409099bfb489fc2$var$_react = $e409099bfb489fc2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e409099bfb489fc2$var$_UNSAFE_baseNew = $e409099bfb489fc2$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $e409099bfb489fc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Attachment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for attaching files to issues or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e409099bfb489fc2$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e409099bfb489fc2$var$_react.default.createElement($e409099bfb489fc2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.25 4.5 5.75 9a1.414 1.414 0 1 0 2 2l4.5-4.5a2.828 2.828 0 1 0-4-4L3.75 7a4.243 4.243 0 1 0 6 6l2.5-2.5"/>`
    }, props));
$e409099bfb489fc2$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e409099bfb489fc2$var$_default = module.exports.default = $e409099bfb489fc2$var$AttachmentIcon;

});

parcelRegister("jUThT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7fe223acf10e6f6$var$_react = $e7fe223acf10e6f6$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $e7fe223acf10e6f6$var$_attachment = $e7fe223acf10e6f6$var$_interopRequireDefault((parcelRequire("jzPfj")));
function $e7fe223acf10e6f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e7fe223acf10e6f6$var$AttachmentIcon = (props)=>/*#__PURE__*/ $e7fe223acf10e6f6$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.643 17.965c-1.53 1.495-4.016 1.496-5.542.004a3.773 3.773 0 0 1 .002-5.412l7.147-6.985a2.316 2.316 0 0 1 3.233-.003c.893.873.895 2.282.004 3.153l-6.703 6.55a.653.653 0 0 1-.914-.008.62.62 0 0 1 0-.902l6.229-6.087a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0l-6.23 6.087a2.5 2.5 0 0 0 0 3.607 2.643 2.643 0 0 0 3.683.009l6.703-6.55a4.074 4.074 0 0 0-.003-5.859 4.306 4.306 0 0 0-6.002.003l-7.148 6.985a5.655 5.655 0 0 0-.001 8.118c2.29 2.239 6.015 2.238 8.31-.005l6.686-6.533a.94.94 0 0 0 0-1.353.995.995 0 0 0-1.384 0z"/></svg>`
    }, props, {
        newIcon: $e7fe223acf10e6f6$var$_attachment.default
    }));
$e7fe223acf10e6f6$var$AttachmentIcon.displayName = 'AttachmentIcon';
var $e7fe223acf10e6f6$var$_default = module.exports.default = $e7fe223acf10e6f6$var$AttachmentIcon;

});



parcelRegister("lrB7A", function(module, exports) {

$parcel$export(module.exports, "extractCommentCount", () => $5e138b4d3be6aa9d$export$b68822b76d5d51d5);

var $eUqFw = parcelRequire("eUqFw");


var $4oVkp = parcelRequire("4oVkp");
const $5e138b4d3be6aa9d$export$b68822b76d5d51d5 = (jsonLd)=>{
    const commentCount = jsonLd['schema:commentCount'];
    if (commentCount) return {
        text: commentCount.toString(),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4oVkp))), {
            label: "comment-count",
            key: "comments-count-icon",
            LEGACY_size: "small",
            color: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`
        })
    };
};

});
parcelRegister("4oVkp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13008ba0807cc62ccc4e0a46de188caa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3345df7e398fe59d$var$_react = $3345df7e398fe59d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3345df7e398fe59d$var$_comment = $3345df7e398fe59d$var$_interopRequireDefault((parcelRequire("75UoT")));

var $3345df7e398fe59d$var$_comment2 = $3345df7e398fe59d$var$_interopRequireDefault((parcelRequire("d3vNK")));
function $3345df7e398fe59d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CommentIcon.
 * This component is CommentIcon, with `UNSAFE_fallbackIcon` set to "CommentIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3345df7e398fe59d$var$CommentIcon = (props)=>/*#__PURE__*/ $3345df7e398fe59d$var$_react.default.createElement($3345df7e398fe59d$var$_comment.default, Object.assign({
        LEGACY_fallbackIcon: $3345df7e398fe59d$var$_comment2.default
    }, props));
$3345df7e398fe59d$var$CommentIcon.Name = 'CommentIconMigration';
var $3345df7e398fe59d$var$_default = module.exports.default = $3345df7e398fe59d$var$CommentIcon;

});
parcelRegister("75UoT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::16e54766c3ecb23743fd478f54b2afa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52a4bffd3c43d738$var$_react = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $52a4bffd3c43d738$var$_UNSAFE_baseNew = $52a4bffd3c43d738$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $52a4bffd3c43d738$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52a4bffd3c43d738$var$CommentIcon = (props)=>/*#__PURE__*/ $52a4bffd3c43d738$var$_react.default.createElement($52a4bffd3c43d738$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.172.099zm-3.5 2H0a.75.75 0 0 0 1.122.651zM2.625 2h10.75V.5H2.625zM14.5 3.125v8.25H16v-8.25zM13.375 12.5H4.25V14h9.125zm-9.497.099-3.5 2 .744 1.302 3.5-2zM1.5 15.25V3.125H0V15.25zM4 6.5h8V5H4zm0 3h5V8H4zm10.5 1.875c0 .621-.504 1.125-1.125 1.125V14A2.625 2.625 0 0 0 16 11.375zM13.375 2c.621 0 1.125.504 1.125 1.125H16A2.625 2.625 0 0 0 13.375.5zM2.625.5A2.625 2.625 0 0 0 0 3.125h1.5C1.5 2.504 2.004 2 2.625 2z"/>`
    }, props));
$52a4bffd3c43d738$var$CommentIcon.displayName = 'CommentIcon';
var $52a4bffd3c43d738$var$_default = module.exports.default = $52a4bffd3c43d738$var$CommentIcon;

});

parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $98143944cdbffe97$var$_comment = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("75UoT")));
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51s7.002 2.472 7.002 5.51c0 3.039-3.141 5.51-7.002 5.51s-7.002-2.471-7.002-5.51m14.84 7.771v-.001s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.5.5 0 0 0 .164.033.515.515 0 0 0 .474-.716"/><rect width="10" height="2" x="7" y="9" rx="1"/><rect width="5" height="2" x="7" y="12" rx="1"/></g></svg>`
    }, props, {
        newIcon: $98143944cdbffe97$var$_comment.default
    }));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = module.exports.default = $98143944cdbffe97$var$CommentIcon;

});



parcelRegister("2W9Up", function(module, exports) {

$parcel$export(module.exports, "extractProgrammingLanguage", () => $ca70aff3d91540cb$export$43e54589935a1ff);

var $eUqFw = parcelRequire("eUqFw");


var $437eV = parcelRequire("437eV");
const $ca70aff3d91540cb$export$43e54589935a1ff = (jsonLd)=>{
    const programmingLanguage = jsonLd['schema:programmingLanguage'];
    if (programmingLanguage) return {
        text: programmingLanguage,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($437eV))), {
            LEGACY_size: "small",
            label: "code",
            color: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`
        })
    };
};

});
parcelRegister("437eV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c70a91fcdbf5cec90b792081dc0b399>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f2d0edf941ff1b7$var$_react = $2f2d0edf941ff1b7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2f2d0edf941ff1b7$var$_angleBrackets = $2f2d0edf941ff1b7$var$_interopRequireDefault((parcelRequire("2T8GT")));

var $2f2d0edf941ff1b7$var$_code = $2f2d0edf941ff1b7$var$_interopRequireDefault((parcelRequire("2Q5Ee")));
function $2f2d0edf941ff1b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for AngleBracketsIcon.
 * This component is AngleBracketsIcon, with `UNSAFE_fallbackIcon` set to "CodeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2f2d0edf941ff1b7$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $2f2d0edf941ff1b7$var$_react.default.createElement($2f2d0edf941ff1b7$var$_angleBrackets.default, Object.assign({
        LEGACY_fallbackIcon: $2f2d0edf941ff1b7$var$_code.default
    }, props));
$2f2d0edf941ff1b7$var$AngleBracketsIcon.Name = 'AngleBracketsIconMigration';
var $2f2d0edf941ff1b7$var$_default = module.exports.default = $2f2d0edf941ff1b7$var$AngleBracketsIcon;

});
parcelRegister("2T8GT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b4c96cb8810c24998853001387ebb87d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21a775a3f11c2d67$var$_react = $21a775a3f11c2d67$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $21a775a3f11c2d67$var$_UNSAFE_baseNew = $21a775a3f11c2d67$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $21a775a3f11c2d67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AngleBrackets".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: code or source code in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21a775a3f11c2d67$var$AngleBracketsIcon = (props)=>/*#__PURE__*/ $21a775a3f11c2d67$var$_react.default.createElement($21a775a3f11c2d67$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.5 8.75.75 6 4.5 3.25m7 4L15.25 10l-3.75 2.75M11 1.25l-6 13.5"/>`
    }, props));
$21a775a3f11c2d67$var$AngleBracketsIcon.displayName = 'AngleBracketsIcon';
var $21a775a3f11c2d67$var$_default = module.exports.default = $21a775a3f11c2d67$var$AngleBracketsIcon;

});

parcelRegister("2Q5Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2114d1ad49e5b359$var$_react = $2114d1ad49e5b359$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $2114d1ad49e5b359$var$_angleBrackets = $2114d1ad49e5b359$var$_interopRequireDefault((parcelRequire("2T8GT")));
function $2114d1ad49e5b359$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2114d1ad49e5b359$var$CodeIcon = (props)=>/*#__PURE__*/ $2114d1ad49e5b359$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.16 4.06a1 1 0 0 0-1.27.62L8.06 18.73a1 1 0 0 0 1.89.65l4.83-14.04a1 1 0 0 0-.62-1.27m-6.14 8.2-2.58-2.5 2.8-2.72a1 1 0 1 0-1.39-1.44L3.31 9.04a1 1 0 0 0 0 1.44l3.32 3.22a1 1 0 1 0 1.39-1.44m12.22 1.57-3.32-3.22a1 1 0 1 0-1.39 1.44l2.58 2.5-2.8 2.72a1 1 0 1 0 1.39 1.44l3.54-3.43a1 1 0 0 0 0-1.44"/></svg>`
    }, props, {
        newIcon: $2114d1ad49e5b359$var$_angleBrackets.default
    }));
$2114d1ad49e5b359$var$CodeIcon.displayName = 'CodeIcon';
var $2114d1ad49e5b359$var$_default = module.exports.default = $2114d1ad49e5b359$var$CodeIcon;

});



parcelRegister("cc539", function(module, exports) {

$parcel$export(module.exports, "extractSubscriberCount", () => $0355ea046d0d5228$export$8bd03a7beb5badf1);

var $eUqFw = parcelRequire("eUqFw");


var $4nce6 = parcelRequire("4nce6");
const $0355ea046d0d5228$export$8bd03a7beb5badf1 = (jsonLd)=>{
    const subscriberCount = jsonLd['atlassian:subscriberCount'];
    if (subscriberCount) return {
        text: subscriberCount.toString(),
        icon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19499
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            size: "small",
            label: "subscribers",
            primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`
        })
    };
};

});
parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $32f2cb577afb3a41$var$_peopleGroup = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("dd6Uq")));
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
    }, props, {
        newIcon: $32f2cb577afb3a41$var$_peopleGroup.default
    }));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = module.exports.default = $32f2cb577afb3a41$var$PeopleIcon;

});


parcelRegister("eahqC", function(module, exports) {

$parcel$export(module.exports, "extractByline", () => $d692e81450b50c93$export$1bc5d7728bb194e9);

var $eUqFw = parcelRequire("eUqFw");

var $8M1qS = parcelRequire("8M1qS");

var $9KU0P = parcelRequire("9KU0P");

var $h1sO6 = parcelRequire("h1sO6");
var $dGfXu = parcelRequire("dGfXu");
var $c8AiI = parcelRequire("c8AiI");
var $gd1O9 = parcelRequire("gd1O9");
const $d692e81450b50c93$export$1bc5d7728bb194e9 = (jsonLd)=>{
    const updatedAt = (0, $dGfXu.extractDateUpdated)(jsonLd);
    const createdAt = (0, $h1sO6.extractDateCreated)(jsonLd);
    if (updatedAt) {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(new Date(updatedAt).getTime());
        const updatedBy = (0, $gd1O9.extractPersonUpdatedBy)(jsonLd);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Updated ", updatedBy && `by ${updatedBy.name}`, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
            value: value,
            unit: unit
        }));
    } else if (createdAt) {
        const { value: value, unit: unit } = (0, $9KU0P.selectUnit)(new Date(createdAt).getTime());
        const createdBy = (0, $c8AiI.extractPersonCreatedBy)(jsonLd);
        const createdByPerson = $d692e81450b50c93$var$extractFirstPerson(createdBy);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, "Created ", createdByPerson && `by ${createdByPerson.name}`, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
            value: value,
            unit: unit
        }));
    }
};
const $d692e81450b50c93$var$extractFirstPerson = (persons)=>{
    if (persons && persons.length > 0) return persons.shift();
};

});

parcelRegister("buT9h", function(module, exports) {

$parcel$export(module.exports, "extractTitlePrefix", () => $4d38aa6ad60122f5$export$58d9bc37318dfb32);
const $4d38aa6ad60122f5$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $4d38aa6ad60122f5$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $4d38aa6ad60122f5$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});

parcelRegister("cNILZ", function(module, exports) {

$parcel$export(module.exports, "extractPreviewAction", () => $be0d8fa1ca130eb2$export$eba2f3246148e526);

var $hqABm = parcelRequire("hqABm");

var $lIFl3 = parcelRequire("lIFl3");

var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");

var $lFzxK = parcelRequire("lFzxK");

var $caOA9 = parcelRequire("caOA9");

var $dB5lQ = parcelRequire("dB5lQ");

var $44Wm8 = parcelRequire("44Wm8");
const $be0d8fa1ca130eb2$var$getMetadataFromJsonLd = (jsonLd, platform)=>{
    const download = (0, $lIFl3.extractDownloadUrl)(jsonLd);
    const provider = (0, $ebCNT.extractProvider)(jsonLd);
    const preview = (0, $fQDHB.extractPreview)(jsonLd, platform);
    return {
        download: download,
        providerName: provider && provider.text,
        src: preview && preview.src
    };
};
const $be0d8fa1ca130eb2$var$getMetadataFromResolvedProps = (props)=>({
        /* It's fine for content to be undefined, but src is still needed for the link out, even if it's not the source for the iframing */ link: props.link,
        title: props.title,
        details: props.details,
        icon: props.icon,
        url: props.link,
        byline: props.byline,
        isTrusted: props.isTrusted
    });
const $be0d8fa1ca130eb2$var$getInvokeOpts = (key, action, source)=>({
        type: 'client',
        key: key,
        // NB: the preview action is invoked from a block card -
        // the actions on the preview state are invoked from the
        // preview card. Hence, we have a `source` for distinguishing
        // between the two.
        source: source || (0, $caOA9.CardDisplay).EmbedPreview,
        action: {
            type: action,
            promise: ()=>Promise.resolve()
        }
    });
const $be0d8fa1ca130eb2$export$eba2f3246148e526 = ({ extensionKey: extensionKey = 'empty-object-provider', viewProps: viewProps, jsonLd: jsonLd, handleInvoke: handleInvoke, testId: testId, platform: platform, origin: origin, source: source = 'block', analytics: analytics, meta: meta, actionOptions: actionOptions })=>{
    if (!(0, $44Wm8.canShowAction)((0, $hqABm.CardAction).PreviewAction, actionOptions)) return;
    // Extract metadata from view props & raw JSON-LD.
    const metadataFromJsonLd = $be0d8fa1ca130eb2$var$getMetadataFromJsonLd(jsonLd, platform);
    const metadataFromViewProps = $be0d8fa1ca130eb2$var$getMetadataFromResolvedProps(viewProps);
    const metadata = {
        ...metadataFromJsonLd,
        ...metadataFromViewProps
    };
    // Extract preview action only if we have an iframe src.
    if (metadataFromJsonLd.src) {
        // Build action using instrumentation hooks.
        const key = extensionKey;
        const previewAction = (0, $lFzxK.default)({
            ...metadata,
            analytics: analytics,
            extensionKey: extensionKey,
            origin: origin,
            testId: testId,
            isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
        });
        // Setup props to go through proper Redux 'invocation' flow
        // for analytics, further state management if required in future.
        const previewActionProps = $be0d8fa1ca130eb2$var$getInvokeOpts(key, 'PreviewAction', source);
        // - Promise invoked by the action invocation handler; open preview.
        previewActionProps.action.promise = previewAction.promise;
        // - Promise invoked on click of `Preview` on block card; trigger above promise.
        previewAction.promise = ()=>handleInvoke(previewActionProps);
        return previewAction;
    }
};

});
parcelRegister("lFzxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $890039ba319f55f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $1csi6 = parcelRequire("1csi6");
var $890039ba319f55f6$export$2e2bcd8739ae039 = ({ details: details, ...rest })=>({
        id: 'preview-content',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).preview_improved),
        promise: ()=>(0, $1csi6.openEmbedModal)({
                providerName: 'Preview',
                showModal: true,
                onClose: ()=>{},
                ...rest
            })
    });

});


parcelRegister("5fK3A", function(module, exports) {

$parcel$export(module.exports, "extractIsTrusted", () => $f12ece06a3bad4f3$export$4f3ffbb500daac5a);
const $f12ece06a3bad4f3$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};

});


parcelRegister("8tvRs", function(module, exports) {

$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $3c50b4df075e1149$export$846c1540a86749e6);

var $4abrz = parcelRequire("4abrz");

var $lGrBa = parcelRequire("lGrBa");

var $8Wyjt = parcelRequire("8Wyjt");

var $bTNMs = parcelRequire("bTNMs");
const $3c50b4df075e1149$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $8Wyjt.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $lGrBa.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $4abrz.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $lGrBa.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $4abrz.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $lGrBa.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $4abrz.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $lGrBa.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $4abrz.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("lGrBa", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $3d1a270b54bff24e$export$59f8830fb5467e35);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");
const $3d1a270b54bff24e$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $4abrz.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("8Wyjt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a55e9b430ce63e07$export$2e2bcd8739ae039);
const $a55e9b430ce63e07$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $a55e9b430ce63e07$export$2e2bcd8739ae039 = $a55e9b430ce63e07$var$extractHostname;

});


parcelRegister("4lXV3", function(module, exports) {

$parcel$export(module.exports, "CardLinkView", () => $d5d78f84908c43a5$export$ce508304ed2dd145);

var $eUqFw = parcelRequire("eUqFw");

var $8BByu = parcelRequire("8BByu");
class $d5d78f84908c43a5$export$ce508304ed2dd145 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            withoutBackground: true,
            ...this.props
        }, this.props.placeholder || this.props.link);
    }
}

});
parcelRegister("8BByu", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $824e9bb758b8c755$export$b89a827e9254211a);

var $eUqFw = parcelRequire("eUqFw");

var $5IgfK = parcelRequire("5IgfK");

var $8sbpW = parcelRequire("8sbpW");
const $824e9bb758b8c755$export$b89a827e9254211a = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered } = props;
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const isInteractive = Boolean(onClick);
    // Depending on whenever Frame was given onClick or link itself we display span or anchor elements
    const Wrapper = link || onClick ? (0, $5IgfK.WrapperAnchor) : (0, $5IgfK.WrapperSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, {
        href: link,
        withoutBackground: withoutBackground,
        isSelected: isSelected,
        isInteractive: isInteractive,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyPress: handleKeyPress,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        ref: ref,
        isHovered: isHovered
    }, children);
});

});
parcelRegister("5IgfK", function(module, exports) {

$parcel$export(module.exports, "WrapperAnchor", () => $59c993fb46da8057$export$6e4bde711df5c2ab);
$parcel$export(module.exports, "WrapperSpan", () => $59c993fb46da8057$export$8b5c95e985c4ec9a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
const $59c993fb46da8057$var$selectedStyles = {
    cursor: 'pointer',
    boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`,
    outline: 'none',
    userSelect: 'none',
    '&, :hover, :focus, :active': {
        textDecoration: 'none'
    },
    '&:hover': {
        border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`
    }
};
const $59c993fb46da8057$var$isInteractive = ({ isInteractive: isInteractive })=>{
    if (isInteractive) return {
        ':active': {
            backgroundColor: `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`
        },
        ':focus': $59c993fb46da8057$var$selectedStyles
    };
    return undefined;
};
const $59c993fb46da8057$var$isSelected = ({ isSelected: isSelected })=>{
    if (isSelected) return $59c993fb46da8057$var$selectedStyles;
    else return {
        userSelect: 'text'
    };
};
const $59c993fb46da8057$var$hoveredStyles = {
    borderColor: `var(--ds-border-accent-blue, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`
};
const $59c993fb46da8057$var$activeHoveredFocusedStyles = (props)=>{
    if (props.withoutBackground) return undefined;
    return {
        textDecoration: 'none'
    };
};
const $59c993fb46da8057$var$hoveredWihBorderStyles = (props)=>({
        ...$59c993fb46da8057$var$hoveredStyles,
        ...$59c993fb46da8057$var$activeHoveredFocusedStyles(props)
    });
/*
  Inline smart cards should have the following layout:
  ------------------------------------
  | icon | title | action OR lozenge |
  ------------------------------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/ // NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
const $59c993fb46da8057$var$baseWrapperStyles = (props)=>({
        lineHeight: '22px',
        padding: `${"var(--ds-space-025, 2px)"} 0px`,
        ...props.withoutBackground ? {
            paddingLeft: 0,
            marginLeft: "var(--ds-space-negative-025, -2px)"
        } : undefined,
        display: 'inline',
        boxDecorationBreak: 'clone',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        color: `var(--ds-link, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`,
        ...props.withoutBackground ? undefined : {
            backgroundColor: "var(--ds-surface-raised, white)"
        },
        ...$59c993fb46da8057$var$isSelected(props),
        ...props.withoutBackground ? undefined : {
            border: `1px solid ${`var(--ds-border, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`}`
        },
        '&:hover': $59c993fb46da8057$var$hoveredStyles,
        '&, :hover, :focus, :active': $59c993fb46da8057$var$activeHoveredFocusedStyles(props),
        transition: '0.1s all ease-in-out',
        MozUserSelect: 'none',
        // -moz-user-select
        ...props.isHovered ? $59c993fb46da8057$var$hoveredWihBorderStyles(props) : undefined
    });
const $59c993fb46da8057$export$6e4bde711df5c2ab = /*#__PURE__*/ (0, $joBf7.default)("a", {
    target: "e26bri1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$baseWrapperStyles(props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$isInteractive(props)
    }));
$59c993fb46da8057$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
const $59c993fb46da8057$export$8b5c95e985c4ec9a = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e26bri0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$59c993fb46da8057$var$baseWrapperStyles(props)
    }));
$59c993fb46da8057$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';

});



parcelRegister("453K0", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $18940917c64c8340$export$34cef2b72294bd84);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");
const $18940917c64c8340$export$34cef2b72294bd84 = (handler)=>({
        id: 'connect-account',
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).connect_link_account_card),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("ews4K", function(module, exports) {

$parcel$export(module.exports, "ResolvedView", () => $d1e401fbdd327595$export$856bb247960f11e6);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $i5auj = parcelRequire("i5auj");

var $a21qx = parcelRequire("a21qx");

var $1Dpgw = parcelRequire("1Dpgw");

var $jzQEn = parcelRequire("jzQEn");

var $91uny = parcelRequire("91uny");

var $arM7P = parcelRequire("arM7P");

var $kbaOP = parcelRequire("kbaOP");

var $jfcmC = parcelRequire("jfcmC");

var $6RzPC = parcelRequire("6RzPC");

var $9RKnk = parcelRequire("9RKnk");

var $iGdwj = parcelRequire("iGdwj");

var $eQycp = parcelRequire("eQycp");

var $id6M8 = parcelRequire("id6M8");

var $h4o1H = parcelRequire("h4o1H");

var $6RKe7 = parcelRequire("6RKe7");

var $lhgZW = parcelRequire("lhgZW");
function $d1e401fbdd327595$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d1e401fbdd327595$var$styles = {
    name: "1f1m9i6",
    styles: "display:flex;justify-content:space-between;align-items:flex-start"
};
const $d1e401fbdd327595$var$lozengeStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $6RKe7.gs)(2.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};
const $d1e401fbdd327595$export$7b62853ead5e547c = 'block-card-resolved-view';
const $d1e401fbdd327595$export$3f9f9653bc75f33d = 'block-card-resolved-view-by';
const $d1e401fbdd327595$export$856bb247960f11e6 = ({ icon: icon = {}, actions: actions = [], thumbnail: thumbnail, context: context = {
    text: ''
}, title: title = '', titleTextColor: titleTextColor, titlePrefix: titlePrefix, isSelected: isSelected = false, users: users = [], handleAvatarClick: handleAvatarClick = ()=>{}, handleMoreAvatarsClick: handleMoreAvatarsClick = ()=>{}, onClick: onClick = ()=>{}, link: link = '', byline: byline = '', lozenge: lozenge, details: details = [], testId: testId = 'block-card-resolved-view' })=>{
    const resolvedMetadata = details.length > 0 ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $iGdwj.MetadataList), {
        testId: testId ? `${testId}-meta` : undefined,
        items: details
    }) : undefined;
    const resolvedByline = /*#__PURE__*/ (0, $byn9U.jsx)((0, $91uny.Byline), {
        testId: testId ? `${testId}-by` : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d1e401fbdd327595$export$3f9f9653bc75f33d
    }, byline);
    const handleClick = (event)=>(0, $lhgZW.handleClickCommon)(event, onClick);
    const hasActions = actions.length > 0;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        isSelected: isSelected,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d1e401fbdd327595$export$7b62853ead5e547c
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9RKnk.Content), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $d1e401fbdd327595$var$styles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $id6M8.ContentHeader), {
        onClick: handleClick,
        link: link
    }, titlePrefix ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jfcmC.Emoji), {
        emoji: titlePrefix
    }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $6RzPC.Icon), icon), /*#__PURE__*/ (0, $byn9U.jsx)((0, $jzQEn.Name), {
        name: title,
        textColor: titleTextColor
    }), lozenge && /*#__PURE__*/ (0, $byn9U.jsx)((0, $eQycp.LozengeBlockWrapper), {
        css: $d1e401fbdd327595$var$lozengeStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), {
        style: lozenge.style,
        ...lozenge
    }, lozenge.text))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbaOP.CollaboratorList), {
        items: users,
        handleAvatarClick: handleAvatarClick,
        handleMoreAvatarsClick: handleMoreAvatarsClick,
        testId: testId ? `${testId}-collaborator-list` : undefined
    })), resolvedByline, resolvedMetadata), /*#__PURE__*/ (0, $byn9U.jsx)((0, $h4o1H.ContentFooter), {
        hasSpaceBetween: hasActions
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Dpgw.Provider), {
        name: context.text,
        icon: context.icon
    }), hasActions && /*#__PURE__*/ (0, $byn9U.jsx)((0, $arM7P.ActionList), {
        items: actions
    }))), thumbnail ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $a21qx.Thumbnail), {
        src: thumbnail,
        testId: testId ? `${testId}-thumb` : undefined
    }) : null);
};

});
parcelRegister("i5auj", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $95a12c2eb116ae2a$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");


var $6RKe7 = parcelRequire("6RKe7");
function $95a12c2eb116ae2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $95a12c2eb116ae2a$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, $byn9U.jsx)($95a12c2eb116ae2a$export$f862a410248f4f00, props) : /*#__PURE__*/ (0, $byn9U.jsx)($95a12c2eb116ae2a$export$7b360cd785b6c366, props);
const $95a12c2eb116ae2a$var$sharedBaseFrameStyles = {
    name: "8xhv84",
    styles: "width:100%;display:flex"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $95a12c2eb116ae2a$var$sharedFrameStyles = {
    maxWidth: (0, $6RKe7.gs)(95),
    backgroundColor: "var(--ds-surface-raised, white)"
};
const $95a12c2eb116ae2a$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $95a12c2eb116ae2a$var$sharedBaseFrameStyles,
            $95a12c2eb116ae2a$var$sharedFrameStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6RKe7.mq)({
                '&:hover': isHoverable ? {
                    // TODO: https://product-fabric.atlassian.net/browse/DSP-4064
                    backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`,
                    cursor: 'pointer'
                } : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                minHeight: isFluidHeight ? 0 : [
                    (0, $6RKe7.gs)(21),
                    (0, $6RKe7.gs)(15)
                ],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                borderRadius: isSelected ? (0, $6RKe7.br)() : (0, $6RKe7.br)(0.5),
                border: `2px solid ${isSelected ? `var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})` : 'transparent'}`,
                justifyContent: 'space-between',
                overflow: 'hidden',
                boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px ${(0, $73a5c9d720aa66e1$export$7d3359664e8bb0e5)}, 0 0 1px 1px ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)}`})`
            })
        ],
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-trello-do-not-use-override": testId
    }, children);
};
const $95a12c2eb116ae2a$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $95a12c2eb116ae2a$var$sharedBaseFrameStyles,
            $95a12c2eb116ae2a$var$sharedFrameStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6RKe7.mq)({
                '&:hover': isHoverable ? {
                    backgroundColor: `var(--ds-background-neutral-hovered, ${0, $73a5c9d720aa66e1$export$920c0d5c49070351})`
                } : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                borderRadius: isSelected ? (0, $6RKe7.br)() : (0, $6RKe7.br)(0.5),
                border: isSelected ? `2px solid ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}` : '',
                justifyContent: 'center',
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                height: inheritDimensions ? '100%' : (0, $6RKe7.gs)(5),
                backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$8d43898f60b96a82)})`,
                width: [
                    'calc(100% - 16px)',
                    '100%'
                ],
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                padding: [
                    `0px ${(0, $6RKe7.gs)(1)}`,
                    '0'
                ]
            })
        ],
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children);
};

});
parcelRegister("6RKe7", function(module, exports) {

$parcel$export(module.exports, "gs", () => $2ad80bf9733e3748$export$9f835c6300f63430);
$parcel$export(module.exports, "br", () => $2ad80bf9733e3748$export$479ac0420f53ed26);
$parcel$export(module.exports, "mq", () => $2ad80bf9733e3748$export$38e816254073c913);

var $PYkxy = parcelRequire("PYkxy");
// this function is used for spacing, fontsize and line height,
// once design tokens have been established for the all of these categories
// then this function can be replaced with the tokens
const $2ad80bf9733e3748$export$9f835c6300f63430 = (times)=>`${8 * times}px`;
const $2ad80bf9733e3748$export$479ac0420f53ed26 = (times = 1)=>`${3 * times}px`;
const $2ad80bf9733e3748$export$38e816254073c913 = (0, $PYkxy.default)([
    '@media(min-width: 576px)'
]);

});
parcelRegister("PYkxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $09c38fdfec706a00$export$2e2bcd8739ae039);
/* eslint-disable no-param-reassign */ var $09c38fdfec706a00$var$index = function(breakpoints) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, literal = _ref.literal, overlap = _ref.overlap;
    var mq = literal ? breakpoints : [
        '&'
    ].concat(breakpoints);
    function flatten(obj) {
        if (typeof obj !== 'object' || obj == null) return [];
        if (Array.isArray(obj)) return obj.map(flatten);
        var slots = {};
        var objects = {};
        var props = {};
        Object.keys(obj).forEach(function(key) {
            // Check if value is an array, but skip if it looks like a selector.
            // key.indexOf('&') === 0
            var item = obj[key];
            if (!Array.isArray(item) && literal) item = [
                item
            ];
            if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
                var prior = void 0;
                item.forEach(function(v, index) {
                    // Optimize by removing duplicated media query entries
                    // when they are explicitly known to overlap.
                    if (overlap && prior === v) return;
                    if (v == null) // Do not create entries for undefined values as this will
                    // generate empty media media quries
                    return;
                    prior = v;
                    if (index === 0 && !literal) props[key] = v;
                    else if (slots[mq[index]] === undefined) {
                        var _slots$mq$index;
                        slots[mq[index]] = (_slots$mq$index = {}, _slots$mq$index[key] = v, _slots$mq$index);
                    } else slots[mq[index]][key] = v;
                });
            } else if (typeof item === 'object') objects[key] = flatten(item);
            else props[key] = item;
        });
        // Ensure that all slots and then child objects are pushed to the end
        mq.forEach(function(el) {
            if (slots[el]) props[el] = slots[el];
        });
        Object.assign(props, objects);
        return props;
    }
    return function() {
        for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
        return values.map(flatten);
    };
};
var $09c38fdfec706a00$export$2e2bcd8739ae039 = $09c38fdfec706a00$var$index;

});



parcelRegister("a21qx", function(module, exports) {

$parcel$export(module.exports, "Thumbnail", () => $b3614b3c95731605$export$1cd1efc78cb52ca5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6RKe7 = parcelRequire("6RKe7");
function $b3614b3c95731605$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b3614b3c95731605$export$1cd1efc78cb52ca5 = (props)=>{
    return props.color ? /*#__PURE__*/ (0, $byn9U.jsx)($b3614b3c95731605$export$57a4095abbb4e46e, props) : /*#__PURE__*/ (0, $byn9U.jsx)($b3614b3c95731605$export$28b59e433d54443c, props);
};
const $b3614b3c95731605$var$sharedStyles = {
    // The dimensions of the image are set in this manner
    // in order for `flex` to respect this value.
    minWidth: [
        (0, $6RKe7.gs)(13),
        (0, $6RKe7.gs)(20)
    ],
    maxWidth: [
        (0, $6RKe7.gs)(13),
        (0, $6RKe7.gs)(20)
    ]
};
const $b3614b3c95731605$export$28b59e433d54443c = ({ src: src, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $6RKe7.mq)({
            ...$b3614b3c95731605$var$sharedStyles,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            backgroundImage: `url(${src})`
        }),
        "data-testid": testId,
        "data-trello-do-not-use-override": testId
    });
};
const $b3614b3c95731605$var$thumbnailImgStyles = {
    name: "zyuhr9",
    styles: "height:90px;width:90px"
};
const $b3614b3c95731605$export$57a4095abbb4e46e = ({ src: src, color: color, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $6RKe7.mq)({
            ...$b3614b3c95731605$var$sharedStyles,
            backgroundColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }),
        "data-testid": testId,
        "data-trello-do-not-use-override": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        css: $b3614b3c95731605$var$thumbnailImgStyles
    }));
};

});

parcelRegister("1Dpgw", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $09c15a462dc225ac$export$2881499e37b75b9a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $6RKe7 = parcelRequire("6RKe7");
const $09c15a462dc225ac$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $6RKe7.gs)(1.5),
    whiteSpace: 'normal'
});
const $09c15a462dc225ac$var$imgStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $6RKe7.gs)(1.5),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $6RKe7.gs)(1.5)
});
const $09c15a462dc225ac$var$textStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    margin: 0,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $6RKe7.gs)(0.5),
    // EDM-713: fixes copy-paste from renderer to editor for Firefox
    // due to HTML its unwrapping behaviour on paste.
    MozUserSelect: 'none'
});
const $09c15a462dc225ac$export$2881499e37b75b9a = ({ name: name, icon: icon })=>{
    let iconToRender = icon || null;
    if (typeof icon === 'string') iconToRender = /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "smart-link-icon",
        css: $09c15a462dc225ac$var$imgStyles,
        src: icon
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $09c15a462dc225ac$var$wrapperStyles
    }, iconToRender, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $09c15a462dc225ac$var$textStyles
    }, name));
};

});

parcelRegister("jzQEn", function(module, exports) {

$parcel$export(module.exports, "Name", () => $21cefaeb923d0815$export$c7bd411105e2dec3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $6RKe7 = parcelRequire("6RKe7");
const $21cefaeb923d0815$export$a76ed4d75b5db5f = 'block-card-content-header-name';
const $21cefaeb923d0815$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontSize: `${(0, $lcnyw.fontSize)()}px`,
    fontWeight: 500,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: (0, $6RKe7.gs)(2.5),
    // Spec: show max two lines.
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    // Fallback options.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: (0, $6RKe7.gs)(6)
});
const $21cefaeb923d0815$export$c7bd411105e2dec3 = ({ name: name, isLeftPadded: isLeftPadded = true, testId: testId, textColor: textColor })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $21cefaeb923d0815$var$baseStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                marginLeft: isLeftPadded ? (0, $6RKe7.gs)(1) : '0',
                color: textColor ? textColor : 'inherit'
            }
        ],
        "data-testid": testId,
        "data-trello-do-not-use-override": "block-card-content-header-name",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $21cefaeb923d0815$export$a76ed4d75b5db5f
    }, name);
};

});

parcelRegister("91uny", function(module, exports) {

$parcel$export(module.exports, "Byline", () => $9bbac73009ea9374$export$5a6ed0c4143add76);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $6RKe7 = parcelRequire("6RKe7");
function $9bbac73009ea9374$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9bbac73009ea9374$var$baseStyles = {
    name: "utaps0",
    styles: "display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;word-break:break-word;white-space:pre-line;-moz-user-select:none"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $9bbac73009ea9374$var$styles = (0, $6RKe7.mq)({
    fontSize: (0, $6RKe7.gs)(1.5),
    lineHeight: (0, $6RKe7.gs)(2.5),
    color: `${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`}`,
    fontWeight: 'normal',
    marginTop: (0, $6RKe7.gs)(0.5),
    // Fallback options.
    maxHeight: (0, $6RKe7.gs)(5)
});
const $9bbac73009ea9374$export$5a6ed0c4143add76 = ({ text: text, children: children, testId: testId, className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $9bbac73009ea9374$var$baseStyles,
            $9bbac73009ea9374$var$styles
        ],
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, text || children);

});

parcelRegister("arM7P", function(module, exports) {

$parcel$export(module.exports, "ActionList", () => $631d69e50258a002$export$1334b68ecc345cef);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $bLFgh = parcelRequire("bLFgh");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $34Io4 = parcelRequire("34Io4");

var $6TvWl = parcelRequire("6TvWl");

var $6RKe7 = parcelRequire("6RKe7");

var $asu8X = parcelRequire("asu8X");
function $631d69e50258a002$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $631d69e50258a002$var$wrapperStyles = (0, $6RKe7.mq)({
    display: 'flex',
    marginTop: [
        (0, $6RKe7.gs)(2),
        0
    ]
});
const $631d69e50258a002$var$buttonStyles = {
    name: "pit38s",
    styles: "height:auto"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $631d69e50258a002$var$actionsWrapperStyles = {
    marginLeft: (0, $6RKe7.gs)(0.5)
};
const $631d69e50258a002$export$1334b68ecc345cef = ({ items: items })=>{
    (0, $asu8X.di)((0, $6OfWd.default));
    const actionsToShow = items.slice(0, 2);
    const actionsToList = items.slice(2, items.length);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: $631d69e50258a002$var$wrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $bLFgh.default), null, actionsToShow.map((action)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6TvWl.Action), {
            key: action.id,
            ...action
        }))), actionsToList.length ? // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $631d69e50258a002$var$actionsWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6OfWd.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34Io4))), {
                    label: "more",
                    color: "currentColor",
                    spacing: "spacious"
                }),
                ref: triggerRef,
                css: $631d69e50258a002$var$buttonStyles,
                testId: "dropdown-trigger"
            }),
        placement: "right-start"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fEubG.default), {
        testId: "dropdown-menu"
    }, actionsToList.map((actionToList)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hD6GJ.default), {
            key: actionToList.id
        }, actionToList.text))))) : null);
};

});
parcelRegister("6TvWl", function(module, exports) {

$parcel$export(module.exports, "Action", () => $624e19bdec06a00e$export$e19cd5f9376f8cee);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $75KY1 = parcelRequire("75KY1");
function $624e19bdec06a00e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $624e19bdec06a00e$export$9b2f81da42a573bc = 1000;
const $624e19bdec06a00e$var$baseTextStyles = {
    name: "oj0oop",
    styles: "transition:opacity 0.3s"
};
const $624e19bdec06a00e$export$e19cd5f9376f8cee = ({ promise: promise, text: text, buttonAppearance: buttonAppearance = 'default', id: id })=>{
    const [state, setState] = (0, $eUqFw.useState)('init');
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7opLA.default), {
        spacing: "compact",
        appearance: buttonAppearance,
        isLoading: state === 'loading',
        testId: `button-${id}`,
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
            if (state !== 'loading') {
                setState('loading');
                promise().then(()=>{
                    setState('success');
                }).catch(()=>{
                    setState('failure');
                }).finally(()=>{
                    setTimeout(()=>setState('init'), $624e19bdec06a00e$export$9b2f81da42a573bc);
                });
            }
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $624e19bdec06a00e$var$baseTextStyles,
            {
                opacity: state !== 'init' ? 0 : 1
            }
        ]
    }, text), /*#__PURE__*/ (0, $byn9U.jsx)((0, $75KY1.ActionIcon), {
        state: state
    }));
};

});
parcelRegister("75KY1", function(module, exports) {

$parcel$export(module.exports, "ActionIcon", () => $a11f45994501d9aa$export$c8e5c1392561c508);

var $eUqFw = parcelRequire("eUqFw");

var $eFbAH = parcelRequire("eFbAH");

var $8xkEh = parcelRequire("8xkEh");
const $a11f45994501d9aa$export$ce595ec7e5ee3717 = {
    display: 'flex',
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    left: '50%',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '50%',
    transform: 'translate(-50%, -50%)'
};
const $a11f45994501d9aa$export$c8e5c1392561c508 = ({ state: state })=>{
    switch(state){
        case 'init':
        case 'loading':
            return null;
        case 'success':
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "check-icon",
                style: $a11f45994501d9aa$export$ce595ec7e5ee3717
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eFbAH))), {
                LEGACY_size: "small",
                label: "check",
                color: "currentColor"
            })));
        case 'failure':
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "cross-icon",
                style: $a11f45994501d9aa$export$ce595ec7e5ee3717
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
                LEGACY_size: "small",
                label: "check",
                color: "currentColor"
            })));
    }
};

});
parcelRegister("eFbAH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e7784326ea358962ea1a53b732fefa1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aacde2bb64c73451$var$_react = $aacde2bb64c73451$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $aacde2bb64c73451$var$_checkMark = $aacde2bb64c73451$var$_interopRequireDefault((parcelRequire("j52dF")));

var $aacde2bb64c73451$var$_check = $aacde2bb64c73451$var$_interopRequireDefault((parcelRequire("9nt1B")));
function $aacde2bb64c73451$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aacde2bb64c73451$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $aacde2bb64c73451$var$_react.default.createElement($aacde2bb64c73451$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $aacde2bb64c73451$var$_check.default
    }, props));
$aacde2bb64c73451$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $aacde2bb64c73451$var$_default = module.exports.default = $aacde2bb64c73451$var$CheckMarkIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43db9d99c93083272e0c42b874af3704>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});

parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $6d3cc6c41555bcf7$var$_checkMark = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("j52dF")));
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $6d3cc6c41555bcf7$var$_checkMark.default
    }));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = module.exports.default = $6d3cc6c41555bcf7$var$CheckIcon;

});





parcelRegister("kbaOP", function(module, exports) {

$parcel$export(module.exports, "CollaboratorList", () => $ea453f48705bcfa3$export$f2fc18886043eac2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4XQdE = parcelRequire("4XQdE");

var $6RKe7 = parcelRequire("6RKe7");
const $ea453f48705bcfa3$export$f2fc18886043eac2 = ({ items: items, handleAvatarClick: handleAvatarClick = ()=>{}, handleMoreAvatarsClick: handleMoreAvatarsClick = ()=>{}, testId: testId = 'collaborator-list' })=>{
    if (items.length === 0) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $6RKe7.mq)({
            display: [
                'none',
                'inherit'
            ]
        })
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4XQdE.default), {
        maxCount: 4,
        appearance: "stack",
        size: "small",
        data: items,
        onAvatarClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
            handleAvatarClick(event);
        },
        onMoreClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
            handleMoreAvatarsClick(event);
        },
        testId: testId
    })));
};

});

parcelRegister("jfcmC", function(module, exports) {

$parcel$export(module.exports, "Emoji", () => $1d5b017320c4c097$export$56cc48506ff790a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $6RKe7 = parcelRequire("6RKe7");
const $1d5b017320c4c097$var$styles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $6RKe7.gs)(2.5),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $6RKe7.gs)(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: "var(--ds-space-negative-025, -2px)"
});
const $1d5b017320c4c097$export$56cc48506ff790a = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $1d5b017320c4c097$var$styles
    }, emoji);
};

});

parcelRegister("6RzPC", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $24d2f112c4fae656$export$f04a61298a47a40f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $cRPaW = parcelRequire("cRPaW");

var $fBftA = parcelRequire("fBftA");

var $6RKe7 = parcelRequire("6RKe7");
const $24d2f112c4fae656$export$f3ef6db93b5dfd7a = 'block-card-icon-image';
const $24d2f112c4fae656$var$getImageStyles = (isFlexibleUi)=>{
    if (isFlexibleUi) return;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $6RKe7.gs)(2),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $6RKe7.gs)(2)
    });
};
const $24d2f112c4fae656$var$getSpanStyles = (isFlexibleUi)=>{
    if (isFlexibleUi) return;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $6RKe7.gs)(2.5),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $6RKe7.gs)(2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
};
const $24d2f112c4fae656$export$f04a61298a47a40f = ({ url: url, icon: icon, defaultIcon: defaultIcon, testId: testId = 'block-card-icon', isFlexibleUi: isFlexibleUi = false })=>{
    const placeholder = defaultIcon || /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
        label: "link",
        LEGACY_size: "small",
        testId: `${testId}-default`,
        color: "currentColor"
    });
    const image = url && /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: url,
        loaded: /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: $24d2f112c4fae656$var$getImageStyles(isFlexibleUi),
            src: url,
            alt: "",
            "data-testid": `${testId}-image`
        }),
        errored: placeholder
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $24d2f112c4fae656$var$getSpanStyles(isFlexibleUi),
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $24d2f112c4fae656$export$f3ef6db93b5dfd7a
    }, icon || image || placeholder);
};

});

parcelRegister("9RKnk", function(module, exports) {

$parcel$export(module.exports, "Content", () => $c472b4e83f6d98f0$export$7c6e2c02157bb7d2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6RKe7 = parcelRequire("6RKe7");
function $c472b4e83f6d98f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c472b4e83f6d98f0$export$d17e5383afeb158c = 'block-card-content';
const $c472b4e83f6d98f0$var$baseStyles = {
    name: "z5atxi",
    styles: "display:flex;flex-direction:column;flex-grow:1"
};
const $c472b4e83f6d98f0$export$7c6e2c02157bb7d2 = ({ children: children, isCompact: isCompact = false })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $c472b4e83f6d98f0$var$baseStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6RKe7.mq)({
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                padding: isCompact ? (0, $6RKe7.gs)(1) : (0, $6RKe7.gs)(2),
                justifyContent: isCompact ? 'unset' : [
                    'unset',
                    'space-between'
                ]
            })
        ],
        "data-trello-do-not-use-override": "block-card-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $c472b4e83f6d98f0$export$d17e5383afeb158c
    }, children);

});

parcelRegister("iGdwj", function(module, exports) {

$parcel$export(module.exports, "MetadataList", () => $d59dc83db50104b9$export$3e18a603070a78a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $kDiZq = parcelRequire("kDiZq");

var $6RKe7 = parcelRequire("6RKe7");
const $d59dc83db50104b9$export$9747a645aa1216c7 = 'smart-link-metadata-list';
const $d59dc83db50104b9$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $6RKe7.gs)(0.5),
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        marginRight: '0px'
    }
});
const $d59dc83db50104b9$export$3e18a603070a78a = ({ items: items, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $d59dc83db50104b9$var$wrapperStyles,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $d59dc83db50104b9$export$9747a645aa1216c7
    }, items.map((item)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $kDiZq.Metadata), {
            key: item.text,
            ...item
        })));
};

});
parcelRegister("kDiZq", function(module, exports) {

$parcel$export(module.exports, "Metadata", () => $cece4ebf4f6b24b3$export$e7adebdc1ebd2fed);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8cU5f = parcelRequire("8cU5f");

function $cece4ebf4f6b24b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cece4ebf4f6b24b3$var$wrapperStyles = {
    name: "1sm99c1",
    styles: "display:flex;align-items:center;margin-right:var(--ds-space-050, 4px)"
};
const $cece4ebf4f6b24b3$var$imgStyles = {
    name: "1a1mhtb",
    styles: "width:var(--ds-space-100, 8px);height:var(--ds-space-100, 8px)"
};
const $cece4ebf4f6b24b3$var$textStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontSize: "var(--ds-space-150, 12px)",
    color: `${`var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`}`,
    marginRight: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-025, 2px)"
});
const $cece4ebf4f6b24b3$export$e7adebdc1ebd2fed = ({ text: text, icon: icon, iconUrl: iconUrl, tooltip: tooltip })=>{
    let metadataIcon = icon || null;
    if (!metadataIcon && iconUrl) metadataIcon = /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: iconUrl,
        css: $cece4ebf4f6b24b3$var$imgStyles
    });
    const metadata = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $cece4ebf4f6b24b3$var$wrapperStyles
    }, metadataIcon, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $cece4ebf4f6b24b3$var$textStyles
    }, text));
    if (tooltip) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltip
    }, metadata);
    return metadata;
};

});


parcelRegister("eQycp", function(module, exports) {

$parcel$export(module.exports, "LozengeBlockWrapper", () => $33f0fe95ab38a526$export$a16269f205a2f280);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $joBf7 = parcelRequire("joBf7");
function $33f0fe95ab38a526$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $33f0fe95ab38a526$export$a16269f205a2f280 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "ejl2rrx0"
})({
    name: "1ieyid4",
    styles: "& > span{margin-left:var(--ds-space-050, 4px);}"
});

});

parcelRegister("id6M8", function(module, exports) {

$parcel$export(module.exports, "ContentHeader", () => $01c6f294955dd198$export$b52a1b6380889dfe);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");
function $01c6f294955dd198$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $01c6f294955dd198$export$8c59795ed52e92b3 = 'block-card-content-header';
const $01c6f294955dd198$var$styles = {
    name: "zeage1",
    styles: "display:flex;align-items:flex-start;-moz-user-select:none"
};
const $01c6f294955dd198$export$b52a1b6380889dfe = ({ onClick: onClick, link: link, children: children })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        onClick: onClick,
        onMouseDown: onMouseDown,
        href: link,
        target: "_blank",
        css: $01c6f294955dd198$var$styles,
        "data-trello-do-not-use-override": "block-card-content-header",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $01c6f294955dd198$export$8c59795ed52e92b3
    }, children);
};

});

parcelRegister("h4o1H", function(module, exports) {

$parcel$export(module.exports, "ContentFooter", () => $6440ac55616b1b6e$export$8f19479c4e4f4bea);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6RKe7 = parcelRequire("6RKe7");
function $6440ac55616b1b6e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6440ac55616b1b6e$export$889f1c7c5c7ba2f = 'smart-link-content-footer';
const $6440ac55616b1b6e$var$flexStyles = {
    name: "zjik7",
    styles: "display:flex"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6440ac55616b1b6e$var$baseStyles = (0, $6RKe7.mq)({
    flexDirection: [
        'column',
        'row'
    ],
    flexGrow: [
        1,
        'unset'
    ],
    alignItems: [
        'unset',
        'center'
    ],
    marginTop: [
        (0, $6RKe7.gs)(1),
        (0, $6RKe7.gs)(1.5)
    ]
});
const $6440ac55616b1b6e$export$8f19479c4e4f4bea = ({ children: children, hasSpaceBetween: hasSpaceBetween = false })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $6440ac55616b1b6e$var$flexStyles,
            $6440ac55616b1b6e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $6RKe7.mq)({
                justifyContent: [
                    hasSpaceBetween ? 'space-between' : 'flex-end',
                    'space-between'
                ]
            })
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $6440ac55616b1b6e$export$889f1c7c5c7ba2f
    }, children);

});

parcelRegister("lhgZW", function(module, exports) {

$parcel$export(module.exports, "handleClickCommon", () => $4ecc56df6f0f594c$export$9759a67e215c4598);
const $4ecc56df6f0f594c$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});


parcelRegister("40mAF", function(module, exports) {

$parcel$export(module.exports, "NotFoundView", () => $a911e5d02802d691$export$292cf3eedb534521);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");


var $5YsMl = parcelRequire("5YsMl");

var $i5auj = parcelRequire("i5auj");

var $1Dpgw = parcelRequire("1Dpgw");

var $91uny = parcelRequire("91uny");

var $9RKnk = parcelRequire("9RKnk");

var $4abrz = parcelRequire("4abrz");

var $h4o1H = parcelRequire("h4o1H");

var $id6M8 = parcelRequire("id6M8");

var $92bVY = parcelRequire("92bVY");

var $34c7P = parcelRequire("34c7P");

var $lhgZW = parcelRequire("lhgZW");
const $a911e5d02802d691$var$textDescriptionProps = {
    ...(0, $4abrz.messages).not_found_description
};
const $a911e5d02802d691$export$7fbeca230aee4e1a = 'block-card-not-found-view';
const $a911e5d02802d691$export$292cf3eedb534521 = ({ context: context = {
    text: ''
}, isSelected: isSelected = false, testId: testId = 'block-card-not-found-view', link: link = '', onClick: onClick = ()=>{} })=>{
    const handleClick = (event)=>(0, $lhgZW.handleClickCommon)(event, onClick);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        isSelected: isSelected,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $a911e5d02802d691$export$7fbeca230aee4e1a,
        isFluidHeight: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9RKnk.Content), {
        isCompact: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $id6M8.ContentHeader), {
        onClick: handleClick,
        link: link
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $92bVY.Link), {
        url: link,
        testId: testId
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $91uny.Byline), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $34c7P.UnresolvedText), {
        icon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19513
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "not-found-warning-icon",
            size: "small",
            primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
            testId: `${testId}-warning-icon`
        }),
        text: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), $a911e5d02802d691$var$textDescriptionProps)
    }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $h4o1H.ContentFooter), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Dpgw.Provider), {
        name: context.text,
        icon: context.icon
    }))));
};

});
parcelRegister("92bVY", function(module, exports) {

$parcel$export(module.exports, "Link", () => $eec0de18cfec3951$export$a6c7ac8248d6e38a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $eec0de18cfec3951$var$styles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    wordBreak: 'break-all'
});
const $eec0de18cfec3951$export$a6c7ac8248d6e38a = ({ url: url, testId: testId = 'block-card', className: className })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": `${testId}-link`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: $eec0de18cfec3951$var$styles
    }, url);
};

});

parcelRegister("34c7P", function(module, exports) {

$parcel$export(module.exports, "UnresolvedText", () => $32a39ff0395d1174$export$745a896c82c6c0ae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $32a39ff0395d1174$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32a39ff0395d1174$var$styles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $32a39ff0395d1174$export$745a896c82c6c0ae = ({ icon: icon, text: text })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $32a39ff0395d1174$var$styles
    }, icon, text);
};

});


parcelRegister("gKAQ5", function(module, exports) {

$parcel$export(module.exports, "ResolvingView", () => $4a920e1db12780eb$export$ce0bf1439fc5c712);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $nzdI3 = parcelRequire("nzdI3");


var $lcnyw = parcelRequire("lcnyw");

var $i5auj = parcelRequire("i5auj");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $6RKe7 = parcelRequire("6RKe7");
const $4a920e1db12780eb$export$d4b64e3ae38899a3 = 'block-card-resolving-view';
const $4a920e1db12780eb$var$messageStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontSize: `${(0, $lcnyw.fontSize)()}px`,
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$7c87d337fb91a97d)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $6RKe7.gs)(0.5)
});
const $4a920e1db12780eb$export$ce0bf1439fc5c712 = ({ isSelected: isSelected = false, testId: testId = 'block-card-resolving-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $4a920e1db12780eb$export$d4b64e3ae38899a3
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($nzdI3))), {
        size: "small",
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`,
        label: "document-icon"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $4a920e1db12780eb$var$messageStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).loading)));

});

parcelRegister("lMSvl", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedView", () => $07e15c37889b1673$export$31c998bd5e0d6e7b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $i5auj = parcelRequire("i5auj");

var $1Dpgw = parcelRequire("1Dpgw");

var $91uny = parcelRequire("91uny");

var $arM7P = parcelRequire("arM7P");

var $9RKnk = parcelRequire("9RKnk");

var $4abrz = parcelRequire("4abrz");

var $id6M8 = parcelRequire("id6M8");

var $h4o1H = parcelRequire("h4o1H");

var $lhgZW = parcelRequire("lhgZW");

var $92bVY = parcelRequire("92bVY");
const $07e15c37889b1673$var$textBylineProps = {
    ...(0, $4abrz.messages).connect_link_account_card_description
};
const $07e15c37889b1673$export$31c998bd5e0d6e7b = ({ context: context = {
    text: ''
}, isSelected: isSelected = false, actions: actions = [], testId: testId = 'block-card-unauthorized-view', actionOptions: actionOptions, link: link = '', onClick: onClick = ()=>{} })=>{
    const handleClick = (event)=>(0, $lhgZW.handleClickCommon)(event, onClick);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        isSelected: isSelected,
        testId: testId,
        isFluidHeight: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9RKnk.Content), {
        isCompact: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $id6M8.ContentHeader), {
        onClick: handleClick,
        link: link
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $92bVY.Link), {
        url: link,
        testId: testId
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $91uny.Byline), {
        testId: testId ? `${testId}-byline` : undefined,
        text: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
            ...$07e15c37889b1673$var$textBylineProps,
            values: {
                context: context.text
            }
        })
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $h4o1H.ContentFooter), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Dpgw.Provider), {
        name: context.text,
        icon: context.icon
    }), !actionOptions?.hide && /*#__PURE__*/ (0, $byn9U.jsx)((0, $arM7P.ActionList), {
        items: actions
    }))));
};

});

parcelRegister("fBBtb", function(module, exports) {

$parcel$export(module.exports, "ForbiddenView", () => $f4f4dd497aa50dee$export$6b2a37ba74778c1c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");


var $f4A0J = parcelRequire("f4A0J");

var $i5auj = parcelRequire("i5auj");

var $1Dpgw = parcelRequire("1Dpgw");

var $91uny = parcelRequire("91uny");

var $arM7P = parcelRequire("arM7P");

var $9RKnk = parcelRequire("9RKnk");

var $4abrz = parcelRequire("4abrz");

var $h4o1H = parcelRequire("h4o1H");

var $id6M8 = parcelRequire("id6M8");

var $lhgZW = parcelRequire("lhgZW");

var $92bVY = parcelRequire("92bVY");

var $34c7P = parcelRequire("34c7P");
const $f4f4dd497aa50dee$export$a21bb776ab2c28b5 = 'block-card-forbidden-view';
const $f4f4dd497aa50dee$export$e9fa69ca91e22a09 = 'block-card-forbidden-view-link';
const $f4f4dd497aa50dee$export$6b2a37ba74778c1c = ({ context: context = {
    text: ''
}, isSelected: isSelected = false, actions: actions = [], testId: testId = 'block-card-forbidden-view', link: link = '', onClick: onClick = ()=>{}, requestAccessContext: requestAccessContext = {}, actionOptions: actionOptions })=>{
    const handleClick = (event)=>(0, $lhgZW.handleClickCommon)(event, onClick);
    const { action: action, descriptiveMessageKey: descriptiveMessageKey = 'invalid_permissions_description', hostname: hostname = '', buttonDisabled: buttonDisabled } = requestAccessContext;
    const items = action !== undefined && !(buttonDisabled ?? false) ? [
        ...actions,
        action
    ] : actions;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        isSelected: isSelected,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $f4f4dd497aa50dee$export$a21bb776ab2c28b5,
        isFluidHeight: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9RKnk.Content), {
        isCompact: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $id6M8.ContentHeader), {
        onClick: handleClick,
        link: link
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $92bVY.Link), {
        url: link,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $f4f4dd497aa50dee$export$e9fa69ca91e22a09
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $91uny.Byline), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $34c7P.UnresolvedText), {
        icon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19497
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
            label: "forbidden-lock-icon",
            size: "small",
            primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
            testId: `${testId}-lock-icon`
        }),
        text: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
            ...(0, $4abrz.messages)[descriptiveMessageKey],
            values: {
                product: context.text,
                context: context.text,
                hostname: hostname
            }
        })
    }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $h4o1H.ContentFooter), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Dpgw.Provider), {
        name: context.text,
        icon: context.icon
    }), !actionOptions?.hide && /*#__PURE__*/ (0, $byn9U.jsx)((0, $arM7P.ActionList), {
        items: items
    }))));
};

});
parcelRegister("f4A0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d4f449435745cf$var$_react = $02d4f449435745cf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $02d4f449435745cf$var$_lockLocked = $02d4f449435745cf$var$_interopRequireDefault((parcelRequire("gWhpp")));
function $02d4f449435745cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02d4f449435745cf$var$LockFilledIcon = (props)=>/*#__PURE__*/ $02d4f449435745cf$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $02d4f449435745cf$var$_lockLocked.default
    }));
$02d4f449435745cf$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $02d4f449435745cf$var$_default = module.exports.default = $02d4f449435745cf$var$LockFilledIcon;

});
parcelRegister("gWhpp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1d1b3dafeedb3bcbc92be5929839e615>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c54f9120ca8b9e22$var$_react = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c54f9120ca8b9e22$var$_UNSAFE_baseNew = $c54f9120ca8b9e22$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c54f9120ca8b9e22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c54f9120ca8b9e22$var$LockLockedIcon = (props)=>/*#__PURE__*/ $c54f9120ca8b9e22$var$_react.default.createElement($c54f9120ca8b9e22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4.75 7.75H4c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25h-.75m-6.5 0V4a3.25 3.25 0 1 1 6.5 0v3.75m-6.5 0h6.5M8 10v3"/>`
    }, props));
$c54f9120ca8b9e22$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $c54f9120ca8b9e22$var$_default = module.exports.default = $c54f9120ca8b9e22$var$LockLockedIcon;

});



parcelRegister("2x0O5", function(module, exports) {

$parcel$export(module.exports, "ErroredView", () => $2786d7d5b384d843$export$a9b924c62ffba422);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8uD7Y = parcelRequire("8uD7Y");

var $eUqFw = parcelRequire("eUqFw");


var $5YsMl = parcelRequire("5YsMl");

var $i5auj = parcelRequire("i5auj");

var $91uny = parcelRequire("91uny");

var $arM7P = parcelRequire("arM7P");

var $9RKnk = parcelRequire("9RKnk");

var $4abrz = parcelRequire("4abrz");

var $h4o1H = parcelRequire("h4o1H");

var $id6M8 = parcelRequire("id6M8");

var $lhgZW = parcelRequire("lhgZW");

var $92bVY = parcelRequire("92bVY");

var $34c7P = parcelRequire("34c7P");

var $kA3ut = parcelRequire("kA3ut");
const $2786d7d5b384d843$var$textDescriptionProps = {
    ...(0, $4abrz.messages).could_not_load_link
};
const $2786d7d5b384d843$export$38dcd9bf8c681d21 = 'block-card-errored-view';
const $2786d7d5b384d843$export$a9b924c62ffba422 = ({ isSelected: isSelected = false, testId: testId = 'block-card-errored-view', link: link = '', onClick: onClick = ()=>{}, onRetry: onRetry, inheritDimensions: inheritDimensions = false })=>{
    const handleClick = (event)=>(0, $lhgZW.handleClickCommon)(event, onClick);
    const actions = (0, $eUqFw.useMemo)(()=>onRetry ? [
            (0, $kA3ut.RetryAction)(onRetry)
        ] : [], [
        onRetry
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        isSelected: isSelected,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $2786d7d5b384d843$export$38dcd9bf8c681d21,
        isFluidHeight: true,
        inheritDimensions: inheritDimensions
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9RKnk.Content), {
        isCompact: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $id6M8.ContentHeader), {
        onClick: handleClick,
        link: link
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $92bVY.Link), {
        url: link,
        testId: testId
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $91uny.Byline), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $34c7P.UnresolvedText), {
        icon: // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19513
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "errored-warning-icon",
            size: "small",
            primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
            testId: `${testId}-warning-icon`
        }),
        text: /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), $2786d7d5b384d843$var$textDescriptionProps)
    }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $h4o1H.ContentFooter), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $arM7P.ActionList), {
        items: actions
    }))));
};

});
parcelRegister("kA3ut", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $8f7c9940c2023f5d$export$c527d977b53f7537);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");
const $8f7c9940c2023f5d$export$c527d977b53f7537 = (handler)=>({
        id: 'try-again',
        promise: async ()=>handler(),
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).try_again)
    });

});


parcelRegister("1QC1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0138fc340c53ff0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kKYlt = parcelRequire("kKYlt");

var $kcn2F = parcelRequire("kcn2F");
var $cIk4w = parcelRequire("cIk4w");
var $d9NWW = parcelRequire("d9NWW");
var $bTLTu = parcelRequire("bTLTu");
var $4bEHq = parcelRequire("4bEHq");

var $exfcX = parcelRequire("exfcX");

var $caOA9 = parcelRequire("caOA9");

var $iEFE9 = parcelRequire("iEFE9");

var $kzW0D = parcelRequire("kzW0D");
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $0138fc340c53ff0a$var$FlexibleResolvedView = ({ cardState: cardState, onClick: onClick, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, analytics: analytics })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $iEFE9.getSimulatedBetterMetadata)(cardState.details);
    const footerActions = (0, $eUqFw.useMemo)(()=>[
            {
                name: (0, $caOA9.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $caOA9.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $caOA9.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
        analytics: analytics,
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onError: onError,
        onResolve: onResolve,
        actionOptions: actionOptions,
        testId: testId,
        ui: (0, $iEFE9.FlexibleCardUiOptions),
        url: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
        ...(0, $iEFE9.titleBlockOptions),
        metadata: titleMetadata,
        subtitle: [
            {
                name: (0, $caOA9.ElementName).Location
            }
        ],
        metadataPosition: (0, $caOA9.SmartLinkPosition).Top
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: topMetadata,
        maxLines: 1,
        overrideCss: (0, $exfcX.metadataBlockCss)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: bottomMetadata,
        maxLines: 1,
        overrideCss: (0, $exfcX.metadataBlockCss)
    }), !isPreviewBlockErrored ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9NWW.default), {
        ...(0, $iEFE9.PreviewBlockOptions),
        onError: ()=>{
            setIsPreviewBlockErrored(true);
        }
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kcn2F.default), {
        ...(0, $iEFE9.FooterBlockOptions),
        actions: footerActions
    }));
};
var $0138fc340c53ff0a$export$2e2bcd8739ae039 = (0, $kzW0D.withFlexibleUIBlockCardStyle)($0138fc340c53ff0a$var$FlexibleResolvedView);

});
parcelRegister("kKYlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $097b0e074c8851f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $fzEHL = parcelRequire("fzEHL");

var $4AAjx = parcelRequire("4AAjx");

var $fM0Kr = parcelRequire("fM0Kr");

var $8ru2D = parcelRequire("8ru2D");
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $097b0e074c8851f3$var$FlexibleCard = ({ analytics: analytics, appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onError: onError, onResolve: onResolve, renderers: renderers, showAuthTooltip: showAuthTooltip, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url })=>{
    const aiSummaryConfig = (0, $8ru2D.useAISummaryConfig)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const context = (0, $eUqFw.useMemo)(()=>(0, $fM0Kr.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            response: details,
            id: id,
            renderers: renderers,
            actionOptions: actionOptions,
            status: status,
            url: url
        }), [
        aiSummaryConfig,
        details,
        id,
        renderers,
        actionOptions,
        status,
        url
    ]);
    const retry = (0, $fM0Kr.getRetryOptions)(url, status, details, onAuthorize);
    const { title: title } = context || {};
    const analyticsContext = (0, $eUqFw.useMemo)(()=>analytics ? {
            ...analytics,
            display: appearance,
            extensionKey: details?.meta?.key
        } : undefined, [
        analytics,
        appearance,
        details?.meta?.key
    ]);
    (0, $eUqFw.useEffect)(()=>{
        switch(status){
            case (0, $caOA9.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url
                });
                break;
            case (0, $caOA9.SmartLinkStatus).Errored:
            case (0, $caOA9.SmartLinkStatus).Fallback:
            case (0, $caOA9.SmartLinkStatus).Forbidden:
            case (0, $caOA9.SmartLinkStatus).NotFound:
            case (0, $caOA9.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AAjx.FlexibleUiAnalyticsContext).Provider, {
        value: analyticsContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AAjx.FlexibleUiOptionContext).Provider, {
        value: ui
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4AAjx.FlexibleUiContext).Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fzEHL.default), {
        testId: testId,
        ...ui,
        onClick: onClick,
        retry: retry,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        showAuthTooltip: showAuthTooltip,
        status: status
    }, children))));
};
var $097b0e074c8851f3$export$2e2bcd8739ae039 = $097b0e074c8851f3$var$FlexibleCard;

});
parcelRegister("fzEHL", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c35613b0ba2456e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $caOA9 = parcelRequire("caOA9");

var $6oJXW = parcelRequire("6oJXW");

var $4AAjx = parcelRequire("4AAjx");

var $hpCTJ = parcelRequire("hpCTJ");

var $7YoZZ = parcelRequire("7YoZZ");

var $lcwz5 = parcelRequire("lcwz5");


var $asu8X = parcelRequire("asu8X");
function $1c35613b0ba2456e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c35613b0ba2456e$var$elevationStyles = /*#__PURE__*/ (0, $byn9U.css)({
    border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`,
    borderRadius: "var(--ds-border-radius-200, 8px)",
    margin: "var(--ds-space-025, 2px)"
});
const $1c35613b0ba2456e$var$getGap = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.25rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '.5rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.25rem';
    }
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $1c35613b0ba2456e$var$getPadding = (size)=>{
    switch(size){
        case (0, $caOA9.SmartLinkSize).XLarge:
            return '1.5rem';
        case (0, $caOA9.SmartLinkSize).Large:
            return '1.25rem';
        case (0, $caOA9.SmartLinkSize).Medium:
            return '1rem';
        case (0, $caOA9.SmartLinkSize).Small:
        default:
            return '.5rem';
    }
};
const $1c35613b0ba2456e$var$clickableContainerStyles = {
    name: "1ubcigm",
    styles: "a, button, .has-action{position:relative;z-index:1;}"
};
const $1c35613b0ba2456e$var$getContainerPaddingStyles = (size, hidePadding, childrenOptions)=>{
    const padding = hidePadding ? '0rem' : $1c35613b0ba2456e$var$getPadding(size);
    const gap = $1c35613b0ba2456e$var$getGap(size);
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = childrenOptions;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '--container-padding': padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '--container-gap-left': previewOnLeft ? gap : padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '--container-gap-right': previewOnRight ? gap : padding,
        '--preview-block-width': '30%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    previewOnLeft ? `padding-left: calc(var(--preview-block-width) + ${gap});` : '', // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    previewOnRight ? `padding-right: calc(var(--preview-block-width) + ${gap});` : '');
};
const $1c35613b0ba2456e$var$getChildrenOptions = (children, context)=>{
    let options = {};
    if ((0, $lcwz5.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) {
            if ((0, $6oJXW.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $caOA9.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $caOA9.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $1c35613b0ba2456e$export$8947b11ec08f5f9d = (size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions)=>{
    const paddingCss = $1c35613b0ba2456e$var$getContainerPaddingStyles(size, hidePadding, childrenOptions);
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("display:flex;gap:", $1c35613b0ba2456e$var$getGap(size), " 0;flex-direction:column;min-width:0;overflow-x:hidden;position:relative;", hideBackground ? '' : `background-color: ${"var(--ds-surface-raised, #FFFFFF)"};`, " ", paddingCss, " ", hideElevation ? '' : $1c35613b0ba2456e$var$elevationStyles, " ", clickableContainer ? $1c35613b0ba2456e$var$clickableContainerStyles : '', " &:hover~.actions-button-group{opacity:1;}a:focus,.has-action:focus{outline-offset:-2px;}");
};
const $1c35613b0ba2456e$var$renderChildren = (children, containerSize, containerTheme, status, retry, onClick)=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (child)=>{
        // TODO: EDM-6468: Use useFlexibleUiOptionContext for rendering options inside block/element instead
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) && (0, $6oJXW.isFlexibleUiBlock)(child)) {
            const { size: blockSize } = child.props;
            const size = blockSize || containerSize;
            if ((0, $6oJXW.isFlexibleUiTitleBlock)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                onClick: // @ts-expect-error
                onClick,
                retry: retry,
                size: size,
                status: status,
                theme: containerTheme
            });
            // @ts-expect-error
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                size: size,
                status: status
            });
        }
    });
const $1c35613b0ba2456e$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).find((child)=>(0, $6oJXW.isFlexibleUiTitleBlock)(child));
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(block)) return block.props;
};
const $1c35613b0ba2456e$var$getLayeredLink = (testId, context, children, onClick)=>{
    const { title: title, url: url = '' } = context || {};
    const { anchorTarget: target, text: text } = $1c35613b0ba2456e$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hpCTJ.default), {
        onClick: onClick,
        target: target,
        testId: testId,
        text: text || title,
        url: url
    });
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $1c35613b0ba2456e$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hideHoverCardPreviewButton: hideHoverCardPreviewButton = false, hidePadding: hidePadding = false, onClick: onClick, retry: retry, showAuthTooltip: showAuthTooltip = false, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, size: size = (0, $caOA9.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', theme: theme = (0, $caOA9.SmartLinkTheme).Link })=>{
    (0, $asu8X.di)((0, $7YoZZ.default));
    const context = (0, $eUqFw.useContext)((0, $4AAjx.FlexibleUiContext));
    const childrenOptions = $1c35613b0ba2456e$var$getChildrenOptions(children, context);
    const canShowHoverPreview = showHoverPreview && status === 'resolved';
    // `retry` object contains action that can be performed on
    // unresolved link (unauthorized, forbidden, not found, etc.)
    const canShowAuthTooltip = showAuthTooltip && status === 'unauthorized' && retry !== undefined;
    const container = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $1c35613b0ba2456e$export$8947b11ec08f5f9d(size, hideBackground, hideElevation, hidePadding, clickableContainer, childrenOptions),
        "data-smart-link-container": true,
        "data-testid": testId
    }, clickableContainer ? $1c35613b0ba2456e$var$getLayeredLink(testId, context, children, onClick) : null, $1c35613b0ba2456e$var$renderChildren(children, size, theme, status, retry, onClick));
    if (context?.url && (canShowHoverPreview || canShowAuthTooltip)) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7YoZZ.default), {
        hideHoverCardPreviewButton: hideHoverCardPreviewButton,
        isHoverPreview: canShowHoverPreview,
        isAuthTooltip: canShowAuthTooltip,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $1c35613b0ba2456e$export$2e2bcd8739ae039 = $1c35613b0ba2456e$var$Container;

});
parcelRegister("hpCTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7847f320889d9cf9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8sbpW = parcelRequire("8sbpW");
function $7847f320889d9cf9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7847f320889d9cf9$var$styles = {
    name: "1mlo8gi",
    styles: "top:0;right:0;bottom:0;left:0;overflow:hidden;text-indent:100%;white-space:nowrap;a&.layered-link{position:absolute;z-index:0;}&:hover ~ *{.actions-button-group{opacity:1;}}"
};
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $7847f320889d9cf9$var$LayeredLink = ({ onClick: onClick, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $8sbpW.useMouseDownEvent)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "layered-link",
        css: $7847f320889d9cf9$var$styles,
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onMouseDown: onMouseDown,
        target: target,
        tabIndex: -1
    }, text);
};
var $7847f320889d9cf9$export$2e2bcd8739ae039 = $7847f320889d9cf9$var$LayeredLink;

});

parcelRegister("7YoZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d52849f89264e22$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l2663 = parcelRequire("l2663");

var $caOA9 = parcelRequire("caOA9");
const $3d52849f89264e22$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $3d52849f89264e22$var$HoverCardControl = ({ children: children, hideHoverCardPreviewButton: hideHoverCardPreviewButton, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $3d52849f89264e22$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $eUqFw.useState)(true);
    const mouseStopTimer = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $eUqFw.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $eUqFw.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $caOA9.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        hidePreviewButton: hideHoverCardPreviewButton,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`
    }, children));
};
var $3d52849f89264e22$export$2e2bcd8739ae039 = $3d52849f89264e22$var$HoverCardControl;

});
parcelRegister("l2663", function(module, exports) {

$parcel$export(module.exports, "HoverCard", () => $5be32bc41d45e714$export$57a077cc9fbe653e);
$parcel$export(module.exports, "StandaloneHoverCard", () => $5be32bc41d45e714$export$f1f63acbe6ed8fb0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $2jDha = parcelRequire("2jDha");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $jb3WS = parcelRequire("jb3WS");

var $jtkmg = parcelRequire("jtkmg");

var $iNbFo = parcelRequire("iNbFo");

var $kDtPD = parcelRequire("kDtPD");

var $caOA9 = parcelRequire("caOA9");

var $asu8X = parcelRequire("asu8X");
const $5be32bc41d45e714$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $asu8X.di)((0, $kDtPD.HoverCardComponent));
    const { url: url, id: id, children: children } = props;
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url, undefined, id);
    const onError = (0, $eUqFw.useCallback)((error, info)=>{
        analytics.ui.renderFailedEvent({
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            id: id,
            error: error,
            errorInfo: info
        });
    }, [
        analytics.ui,
        id
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jb3WS.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iNbFo.SmartLinkModalProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kDtPD.HoverCardComponent), props, children)));
};
const $5be32bc41d45e714$var$HoverCardWithoutAnalyticsContext = (0, $2jDha.default)()($5be32bc41d45e714$var$HoverCardWithErrorBoundary);
const $5be32bc41d45e714$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($5be32bc41d45e714$var$HoverCardWithoutAnalyticsContext, props);
};
const $5be32bc41d45e714$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($5be32bc41d45e714$export$57a077cc9fbe653e, props);

});
parcelRegister("kDtPD", function(module, exports) {

$parcel$export(module.exports, "HoverCardComponent", () => $33866a187794779b$export$e2173dafa6a751bb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3MV1G = parcelRequire("3MV1G");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $4XjK2 = parcelRequire("4XjK2");

var $b81Yi = parcelRequire("b81Yi");

var $3miv3 = parcelRequire("3miv3");

var $hxNq6 = parcelRequire("hxNq6");

var $lVbJo = parcelRequire("lVbJo");

var $caOA9 = parcelRequire("caOA9");

var $eGeQQ = parcelRequire("eGeQQ");

var $fck9X = parcelRequire("fck9X");

var $ibKIt = parcelRequire("ibKIt");

var $jtkmg = parcelRequire("jtkmg");

var $XHGTv = parcelRequire("XHGTv");
const $33866a187794779b$var$HOVER_CARD_SOURCE = 'smartLinkPreviewHoverCard';
const $33866a187794779b$var$FADE_IN_DELAY = 500;
const $33866a187794779b$var$FADE_OUT_DELAY = 300;
const $33866a187794779b$var$RESOLVE_DELAY = 100;
const $33866a187794779b$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', analyticsHandler: analyticsHandler, canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, hidePreviewButton: hidePreviewButton = false, showServerActions: showServerActions, actionOptions: actionOptionsProp, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $lVbJo.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $33866a187794779b$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const fadeOutTimeoutId = (0, $eUqFw.useRef)();
    const fadeInTimeoutId = (0, $eUqFw.useRef)();
    const resolveTimeOutId = (0, $eUqFw.useRef)();
    const mousePos = (0, $eUqFw.useRef)();
    const popupOffset = (0, $eUqFw.useRef)();
    const parentSpan = (0, $eUqFw.useRef)(null);
    const renderers = (0, $4XjK2.useSmartLinkRenderers)();
    const linkState = (0, $b81Yi.useSmartCardState)(url);
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url, undefined, id);
    const { loadMetadata: loadMetadata } = (0, $ibKIt.useSmartCardActions)(id, url, analytics);
    const actionOptions = (0, $fck9X.combineActionOptions)({
        actionOptions: actionOptionsProp,
        showServerActions: showServerActions,
        hidePreviewButton: hidePreviewButton
    });
    const setMousePosition = (0, $eUqFw.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $lVbJo.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $lVbJo.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const initHideCard = (0, $eUqFw.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $33866a187794779b$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        };
    }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $eUqFw.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus;
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            loadMetadata();
        }, $33866a187794779b$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata
    ]);
    const initShowCard = (0, $eUqFw.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) setIsOpen(true);
            else fadeInTimeoutId.current = setTimeout(()=>{
                setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay
    ]);
    const onActionClick = (0, $eUqFw.useCallback)((actionId)=>{
        if (actionId === (0, $caOA9.ActionName).PreviewAction || actionId === (0, $caOA9.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $eUqFw.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $eUqFw.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $eUqFw.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $eUqFw.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eGeQQ.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            id: id,
            source: $33866a187794779b$var$HOVER_CARD_SOURCE
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $3miv3.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        renderers,
        actionOptions,
        url,
        id
    ]);
    const trigger = (0, $eUqFw.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
            ...triggerProps,
            ...(0, $XHGTv.fg)('platform-hover-card-aria-expanded-a11y-fix') && {
                role: 'button'
            },
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": "hover-card-trigger-wrapper"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: hideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: (0, $hxNq6.default)
    });
};

});
parcelRegister("3miv3", function(module, exports) {

$parcel$export(module.exports, "hoverCardClassName", () => $14e6c0cc2f6d2356$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $14e6c0cc2f6d2356$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $bFzGY = parcelRequire("bFzGY");

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");

var $caOA9 = parcelRequire("caOA9");

var $jtkmg = parcelRequire("jtkmg");

var $269iK = parcelRequire("269iK");

var $9A6mL = parcelRequire("9A6mL");

var $lVbJo = parcelRequire("lVbJo");

var $crquY = parcelRequire("crquY");

var $85lvj = parcelRequire("85lvj");

var $2v0K6 = parcelRequire("2v0K6");

var $iWhYa = parcelRequire("iWhYa");

var $lyAeo = parcelRequire("lyAeo");

var $b81Yi = parcelRequire("b81Yi");

var $Ur3CB = parcelRequire("Ur3CB");

var $NJTzu = parcelRequire("NJTzu");

var $hZwiw = parcelRequire("hZwiw");
const $14e6c0cc2f6d2356$export$34883cbaea18402d = 'smart-links-hover-preview';
const $14e6c0cc2f6d2356$var$HoverCardContent = ({ id: id = '', analytics: _analytics, cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, actionOptions: actionOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const defaultAnalytics = (0, $jtkmg.useSmartLinkAnalytics)(url, undefined, id);
    const analytics = _analytics ?? defaultAnalytics;
    const extensionKey = (0, $eUqFw.useMemo)(()=>(0, $269iK.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $b81Yi.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $gqldc.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $hZwiw.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $269iK.getServices)(linkState.details);
    const statusRef = (0, $eUqFw.useRef)(linkStatus);
    const analyticsRef = (0, $eUqFw.useRef)(analytics);
    (0, $eUqFw.useEffect)(()=>{
        /**
     * Must access current analytics object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (analyticsRef.current !== analytics) analyticsRef.current = analytics;
        if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
    }, [
        analytics,
        linkStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        analyticsRef.current.ui.hoverCardViewedEvent({
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            status: statusRef.current
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            analyticsRef.current.ui.hoverCardDismissedEvent({
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                status: statusRef.current
            });
        };
    }, []);
    const onClick = (0, $eUqFw.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $9A6mL.isSpecialEvent)(event);
        analytics.ui.cardClickedEvent({
            id: id,
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            status: cardState.status,
            isModifierKeyPressed: isModifierKeyPressed,
            actionSubjectId: 'titleGoToLink'
        });
        (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        cardState.status,
        analytics.ui,
        id
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $crquY.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        overrideCss: (0, $lVbJo.titleBlockCss),
        size: (0, $caOA9.SmartLinkSize).Large,
        position: (0, $caOA9.SmartLinkPosition).Center,
        subtitle: subtitle
    };
    const flexibleCardProps = {
        appearance: (0, $caOA9.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        ui: (0, $lVbJo.flexibleUiOptions),
        url: url,
        children: null,
        analytics: analytics
    };
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>e.stopPropagation(), []);
    const getCardView = (cardState)=>{
        if (cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $85lvj.default), {
            flexibleCardProps: flexibleCardProps,
            titleBlockProps: titleBlockProps
        });
        if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2v0K6.default), {
            analytics: analytics,
            extensionKey: extensionKey,
            id: id,
            flexibleCardProps: flexibleCardProps,
            url: url
        });
        if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $Ur3CB.default), {
            flexibleCardProps: flexibleCardProps
        });
        if (cardState.status === 'resolved') return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iWhYa.default), {
            analytics: analytics,
            cardState: cardState,
            extensionKey: extensionKey,
            flexibleCardProps: flexibleCardProps,
            isAISummaryEnabled: isAISummaryEnabled,
            onActionClick: onActionClick,
            titleBlockProps: titleBlockProps,
            url: url
        });
        return null;
    };
    const cardView = getCardView(cardState);
    return cardView ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $NJTzu.default), {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClickStopPropagation,
        isAIEnabled: isAISummaryEnabled,
        url: url
    }, cardView) : null;
};
var $14e6c0cc2f6d2356$export$2e2bcd8739ae039 = $14e6c0cc2f6d2356$var$HoverCardContent;

});
parcelRegister("lVbJo", function(module, exports) {

$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $856efd6cf881538e$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $856efd6cf881538e$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $856efd6cf881538e$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $856efd6cf881538e$export$e7cae8c75d768024);
$parcel$export(module.exports, "separatorCss", () => $856efd6cf881538e$export$a967860c7ee2c3e1);
$parcel$export(module.exports, "HoverCardContainer", () => $856efd6cf881538e$export$f57be4bd7a4d32ec);
$parcel$export(module.exports, "titleBlockCss", () => $856efd6cf881538e$export$ec02d9e26e1aed66);
$parcel$export(module.exports, "getTransitionStyles", () => $856efd6cf881538e$export$cfbcd9a4c0ed32ac);
$parcel$export(module.exports, "popupContainerStyles", () => $856efd6cf881538e$export$40ef6bd85f8ebb71);
$parcel$export(module.exports, "getPreviewBlockStyles", () => $856efd6cf881538e$export$190eda52f0eac4c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $caOA9 = parcelRequire("caOA9");

var $lcnyw = parcelRequire("lcnyw");
function $856efd6cf881538e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $856efd6cf881538e$export$8245b0eaabf3440c = (0, $lcnyw.layers).modal();
const $856efd6cf881538e$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    size: (0, $caOA9.SmartLinkSize).Medium,
    hideHoverCardPreviewButton: false,
    zIndex: $856efd6cf881538e$export$8245b0eaabf3440c + 1
};
const $856efd6cf881538e$export$a0a37c997fbcd678 = 24;
const $856efd6cf881538e$export$337e78d5d001376e = 25;
const $856efd6cf881538e$export$e7cae8c75d768024 = 10;
const $856efd6cf881538e$var$blockGap = '0.5rem';
const $856efd6cf881538e$var$elementGap = '0.5rem';
const $856efd6cf881538e$export$a967860c7ee2c3e1 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '[data-separator] + [data-separator]:before': {
        marginRight: $856efd6cf881538e$var$elementGap
    }
});
const $856efd6cf881538e$export$f57be4bd7a4d32ec = /*#__PURE__*/ (0, $byn9U.css)("background:none;border-width:0;box-sizing:border-box;width:", $856efd6cf881538e$export$337e78d5d001376e, "rem;.", (0, $02e88e077d3b3f54$export$4b2b7d155f69aed4), "{display:none;}");
const $856efd6cf881538e$export$ec02d9e26e1aed66 = /*#__PURE__*/ (0, $byn9U.css)("gap:", $856efd6cf881538e$var$blockGap, ";", $856efd6cf881538e$export$a967860c7ee2c3e1, "[data-smart-element-group]{gap:0.06rem;display:flex;>[data-smart-element-group]{>span{margin-right:", $856efd6cf881538e$var$elementGap, ";}}}[data-smart-element='Title']{font-weight:600;}");
const $856efd6cf881538e$export$cfbcd9a4c0ed32ac = (snippetHeight)=>/*#__PURE__*/ (0, $byn9U.css)({
        transition: 'height 300ms ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${snippetHeight}px`
    });
const $856efd6cf881538e$export$40ef6bd85f8ebb71 = {
    name: "kq493r",
    styles: "border-radius:var(--ds-border-radius-200, 8px);background-color:var(--ds-surface-overlay, white);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))"
};
const $856efd6cf881538e$export$190eda52f0eac4c = (previewHeight)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)(previewHeight ? `height: ${previewHeight}px;` : '', {
        borderTopLeftRadius: "var(--ds-border-radius-200, 8px)",
        borderTopRightRadius: "var(--ds-border-radius-200, 8px)",
        marginBottom: $856efd6cf881538e$var$blockGap
    });

});
const $02e88e077d3b3f54$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';


parcelRegister("crquY", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $9575c987ee374080$export$8548546c0aa631e6);

var $caOA9 = parcelRequire("caOA9");

var $4yj9H = parcelRequire("4yj9H");

var $fmv4j = parcelRequire("fmv4j");
const $9575c987ee374080$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $4yj9H.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $caOA9.ElementName).AuthorGroup,
            (0, $caOA9.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn,
                    (0, $caOA9.ElementName).SubscriberCount,
                    (0, $caOA9.ElementName).State
                ],
                subtitle: [
                    (0, $caOA9.ElementName).SourceBranch,
                    (0, $caOA9.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $caOA9.ElementName).LatestCommit,
                    (0, $caOA9.ElementName).CollaboratorGroup,
                    (0, $caOA9.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $fmv4j.extractOwnedBy)(data) ? (0, $caOA9.ElementName).OwnedByGroup : (0, $caOA9.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $caOA9.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $caOA9.ElementName).ReactCount,
                    (0, $caOA9.ElementName).CommentCount,
                    (0, $caOA9.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $caOA9.ElementName).AssignedToGroup,
                        (0, $caOA9.ElementName).State,
                        (0, $caOA9.ElementName).StoryPoints,
                        (0, $caOA9.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $caOA9.ElementName).CollaboratorGroup,
                    (0, $caOA9.ElementName).State,
                    (0, $caOA9.ElementName).DueOn
                ],
                secondary: [
                    (0, $caOA9.ElementName).ReactCount,
                    (0, $caOA9.ElementName).CommentCount,
                    (0, $caOA9.ElementName).AttachmentCount,
                    (0, $caOA9.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $caOA9.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn,
                    (0, $caOA9.ElementName).State,
                    (0, $caOA9.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).State,
                    (0, $caOA9.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).SentOn
                ],
                tertiary: [
                    (0, $caOA9.ElementName).ReactCount,
                    (0, $caOA9.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $caOA9.ElementName).AuthorGroup,
                    (0, $caOA9.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $9575c987ee374080$var$AvatarGroupsWithNamePrefix = [
    (0, $caOA9.ElementName).AssignedToGroup,
    (0, $caOA9.ElementName).OwnedByGroup,
    (0, $caOA9.ElementName).AuthorGroup
];
const $9575c987ee374080$var$toElementItem = (name)=>{
    const showNamePrefix = $9575c987ee374080$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $9575c987ee374080$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $caOA9.ElementName)).map($9575c987ee374080$var$toElementItem);
};
const $9575c987ee374080$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $9575c987ee374080$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $9575c987ee374080$var$toElementItems(metadata.subtitle),
        primary: $9575c987ee374080$var$toElementItems(primary),
        secondary: $9575c987ee374080$var$toElementItems(metadata.secondary)
    };
};

});

parcelRegister("85lvj", function(module, exports) {

$parcel$export(module.exports, "default", () => $192f1cc4566d6a7d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $8SIiI = parcelRequire("8SIiI");

var $lVbJo = parcelRequire("lVbJo");

var $fCD0G = parcelRequire("fCD0G");

var $fNWSr = parcelRequire("fNWSr");

var $4sQhG = parcelRequire("4sQhG");

var $c2pJy = parcelRequire("c2pJy");
const $192f1cc4566d6a7d$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $lVbJo.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, $byn9U.jsx)((0, $fNWSr.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $fCD0G.loadingViewContainer),
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $fCD0G.skeletonContainer)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4sQhG.default), {
        ...titleBlockProps,
        overrideCss: (0, $fCD0G.titleBlockStyles),
        testId: `${testId}-title-block`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $c2pJy.default), {
        render: ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), null),
        size: size
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $fCD0G.getTitleStyles)(lineHeightRem),
        "data-testid": `${testId}-title`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        height: lineHeightRem
    })), actionGroup), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        width: skeletonWidth,
        height: lineHeightRem
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        width: skeletonWidth,
        height: lineHeightRem * 3
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $8SIiI.default), {
        width: skeletonWidth,
        height: lineHeightRem
    }))));
};
var $192f1cc4566d6a7d$export$2e2bcd8739ae039 = $192f1cc4566d6a7d$var$HoverCardLoadingView;

});
parcelRegister("fCD0G", function(module, exports) {

$parcel$export(module.exports, "loadingViewContainer", () => $de7116d5503ac50c$export$a470e5777446b28);
$parcel$export(module.exports, "skeletonContainer", () => $de7116d5503ac50c$export$e39e8873928166f5);
$parcel$export(module.exports, "getTitleStyles", () => $de7116d5503ac50c$export$83146cf7d1bec659);
$parcel$export(module.exports, "titleBlockStyles", () => $de7116d5503ac50c$export$38125fa6916f5dab);

var $byn9U = parcelRequire("byn9U");
function $de7116d5503ac50c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $de7116d5503ac50c$export$a470e5777446b28 = {
    name: "vl4r61",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-200, 1rem)"
};
const $de7116d5503ac50c$export$e39e8873928166f5 = {
    name: "m407pt",
    styles: "display:flex;flex-direction:column;gap:0.625rem;align-items:center"
};
const $de7116d5503ac50c$export$83146cf7d1bec659 = (height)=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        flex: '1 0 auto',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${height}rem`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        span: {
            width: '100%'
        }
    });
};
const $de7116d5503ac50c$export$38125fa6916f5dab = {
    name: "168etio",
    styles: "width:100%;gap:var(--ds-space-100, 0.5rem)"
};

});


parcelRegister("2v0K6", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e456a96ecd62ea$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $kKYlt = parcelRequire("kKYlt");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");

var $ebCNT = parcelRequire("ebCNT");

var $03mTY = parcelRequire("03mTY");

var $eDeuK = parcelRequire("eDeuK");

var $fNWSr = parcelRequire("fNWSr");

var $bampN = parcelRequire("bampN");

var $caOA9 = parcelRequire("caOA9");

var $ibKIt = parcelRequire("ibKIt");

var $269iK = parcelRequire("269iK");
const $51e456a96ecd62ea$var$HoverCardUnauthorisedView = ({ analytics: analytics, extensionKey: extensionKey, id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const data = cardState.details?.data;
    const providerName = (0, $ebCNT.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $269iK.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $ibKIt.useSmartCardActions)(id, url, analytics);
    const handleAuthorize = (0, $eUqFw.useCallback)(()=>{
        if (authorize) {
            analytics.track.appAccountAuthStarted({
                extensionKey: extensionKey
            });
            authorize((0, $caOA9.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        extensionKey,
        analytics.track
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>[
            {
                name: (0, $caOA9.ActionName).CustomAction,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $4abrz.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $03mTY.titleBlockStyles),
        testId: `${testId}-title`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bampN.LinkIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $03mTY.mainTextStyles),
        testId: `${testId}-content`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDeuK.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported,
        analytics: analytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $03mTY.connectButtonStyles),
        testId: `${testId}-button`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fNWSr.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $51e456a96ecd62ea$export$2e2bcd8739ae039 = $51e456a96ecd62ea$var$HoverCardUnauthorisedView;

});
parcelRegister("03mTY", function(module, exports) {

$parcel$export(module.exports, "connectButtonStyles", () => $02f66405c7d8fa7c$export$e63cb455d3692ef0);
$parcel$export(module.exports, "titleBlockStyles", () => $02f66405c7d8fa7c$export$38125fa6916f5dab);
$parcel$export(module.exports, "mainTextStyles", () => $02f66405c7d8fa7c$export$a8a26925e3db0ef6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $02f66405c7d8fa7c$var$blockGap = '0.5rem';
const $02f66405c7d8fa7c$var$iconGap = '0.5rem';
const $02f66405c7d8fa7c$var$titleFontWeight = '500';
const $02f66405c7d8fa7c$export$e63cb455d3692ef0 = /*#__PURE__*/ (0, $byn9U.css)({
    justifyContent: 'flex-end',
    marginTop: $02f66405c7d8fa7c$var$blockGap
});
const $02f66405c7d8fa7c$export$38125fa6916f5dab = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${$02f66405c7d8fa7c$var$blockGap} ${$02f66405c7d8fa7c$var$iconGap}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
        fontWeight: $02f66405c7d8fa7c$var$titleFontWeight
    }
});
const $02f66405c7d8fa7c$export$a8a26925e3db0ef6 = /*#__PURE__*/ (0, $byn9U.css)({
    marginTop: $02f66405c7d8fa7c$var$blockGap,
    fontSize: '0.75rem'
});

});

parcelRegister("eDeuK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14d0b603118aba1b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $caOA9 = parcelRequire("caOA9");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $14d0b603118aba1b$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content', analytics: analytics })=>{
    const handleLearnMoreClick = (0, $eUqFw.useCallback)(()=>{
        analytics?.ui.learnMoreClickedEvent();
    }, [
        analytics?.ui
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $4abrz.messages).learn_more_about_connecting_account : (0, $4abrz.messages).learn_more_about_smart_links;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages).connect_unauthorised_account_description,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).connect_unauthorised_account_description_no_provider), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: isProductIntegrationSupported ? (0, $caOA9.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $caOA9.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        "data-testid": `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), learnMoreMessage)));
};
var $14d0b603118aba1b$export$2e2bcd8739ae039 = $14d0b603118aba1b$var$UnauthorisedViewContent;

});


parcelRegister("iWhYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $03155fabde6a047b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $caOA9 = parcelRequire("caOA9");

var $269iK = parcelRequire("269iK");

var $kKYlt = parcelRequire("kKYlt");

var $5I51G = parcelRequire("5I51G");
var $jgolE = parcelRequire("jgolE");
var $h2NbM = parcelRequire("h2NbM");
var $cIk4w = parcelRequire("cIk4w");
var $bTLTu = parcelRequire("bTLTu");
var $4bEHq = parcelRequire("4bEHq");

var $crquY = parcelRequire("crquY");

var $fjZxK = parcelRequire("fjZxK");

var $9OsQy = parcelRequire("9OsQy");
const $03155fabde6a047b$var$HoverCardResolvedView = ({ analytics: analytics, cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps })=>{
    const canBeDatasource = (0, $269iK.getCanBeDatasource)(cardState.details);
    (0, $eUqFw.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        analytics.ui.renderSuccessEvent({
            display: (0, $caOA9.CardDisplay).HoverCardPreview,
            status: cardState.status,
            canBeDatasource: canBeDatasource
        });
    }, [
        analytics.ui,
        cardState.status,
        canBeDatasource
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $eUqFw.useMemo)(()=>{
        return (0, $crquY.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const snippetBlockRef = (0, $eUqFw.useRef)(null);
    const onSnippetRender = (0, $eUqFw.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $fjZxK.default)({
        data: data,
        fallbackElementHeight: snippetHeight.current
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        status: (0, $caOA9.SmartLinkStatus).Resolved
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
        ...titleBlockProps,
        metadataPosition: (0, $caOA9.SmartLinkPosition).Top
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cIk4w.default), {
        primary: primary,
        secondary: secondary,
        overrideCss: (0, $9OsQy.metadataBlockCss),
        maxLines: 1,
        size: (0, $caOA9.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2NbM.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet,
        status: (0, $caOA9.SmartLinkStatus).Resolved
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bTLTu.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        overrideCss: (0, $9OsQy.hiddenSnippetStyles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5I51G.default), {
        onClick: onActionClick,
        spaceInline: "space.100"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jgolE.default), null));
};
var $03155fabde6a047b$export$2e2bcd8739ae039 = $03155fabde6a047b$var$HoverCardResolvedView;

});
parcelRegister("fjZxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf1f99a9e4f883d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ket3S = parcelRequire("ket3S");

var $d9NWW = parcelRequire("d9NWW");

var $lVbJo = parcelRequire("lVbJo");
const $ebf1f99a9e4f883d$var$ImagePreview = ({ data: data, fallbackElementHeight: fallbackElementHeight })=>{
    const transitionStarted = (0, $eUqFw.useRef)(false);
    const previewBlockRef = (0, $eUqFw.useRef)(null);
    const [showPreview, setShowPreview] = (0, $eUqFw.useState)(true);
    const [previewCss, setPreviewCss] = (0, $eUqFw.useState)();
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $eUqFw.useCallback)(()=>{
        previewBlockRef.current && setPreviewCss((0, $lVbJo.getPreviewBlockStyles)(previewBlockRef.current?.getBoundingClientRect().height));
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $eUqFw.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setPreviewCss((0, $lVbJo.getTransitionStyles)(fallbackElementHeight));
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $eUqFw.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && data && (0, $ket3S.default)(data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9NWW.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        overrideCss: previewCss,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender
    }) : null;
};
var $ebf1f99a9e4f883d$export$2e2bcd8739ae039 = $ebf1f99a9e4f883d$var$ImagePreview;

});

parcelRegister("9OsQy", function(module, exports) {

$parcel$export(module.exports, "metadataBlockCss", () => $0281bb6549b2b889$export$6d2a8e6ec8eaf792);
$parcel$export(module.exports, "hiddenSnippetStyles", () => $0281bb6549b2b889$export$a0cfecf316f11fd2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lVbJo = parcelRequire("lVbJo");
function $0281bb6549b2b889$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0281bb6549b2b889$var$elementGap = '0.5rem';
const $0281bb6549b2b889$export$6d2a8e6ec8eaf792 = /*#__PURE__*/ (0, $byn9U.css)("gap:0px;[data-smart-element-group]:nth-of-type(1){flex-grow:7;", (0, $lVbJo.separatorCss), ">span{margin-right:", $0281bb6549b2b889$var$elementGap, ";}}[data-smart-element-group]:nth-of-type(2){flex-grow:3;>span{margin-left:", $0281bb6549b2b889$var$elementGap, ";}}[data-smart-element-group]{line-height:1rem;}");
const $0281bb6549b2b889$export$1ede44d22c218cc4 = {
    name: "eqx0xi",
    styles: "height:1.5rem"
};
const $0281bb6549b2b889$export$a0cfecf316f11fd2 = {
    name: "546l7a",
    styles: "visibility:hidden;position:absolute"
};

});


parcelRegister("Ur3CB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd311226ef0fbfa9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $kKYlt = parcelRequire("kKYlt");

var $4abrz = parcelRequire("4abrz");

var $4sQhG = parcelRequire("4sQhG");
var $d9NWW = parcelRequire("d9NWW");

var $7u4fN = parcelRequire("7u4fN");

var $ebCNT = parcelRequire("ebCNT");

var $6PC9Z = parcelRequire("6PC9Z");

var $lVbJo = parcelRequire("lVbJo");

var $8tvRs = parcelRequire("8tvRs");

var $8Wyjt = parcelRequire("8Wyjt");

var $bFzGY = parcelRequire("bFzGY");
const $bd311226ef0fbfa9$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const data = cardState.details?.data;
    const meta = cardState.details?.meta;
    const product = (0, $ebCNT.extractProvider)(data)?.text ?? '';
    const hostname = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, (0, $8Wyjt.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $8tvRs.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9NWW.default), {
        ignoreContainerPadding: true,
        overrideCss: (0, $lVbJo.getPreviewBlockStyles)(),
        testId: testId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $6PC9Z.titleBlockStyles),
        testId: `${testId}-title`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $6PC9Z.mainTextStyles),
        testId: `${testId}-content`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $4abrz.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: (0, $6PC9Z.connectButtonStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $bd311226ef0fbfa9$export$2e2bcd8739ae039 = $bd311226ef0fbfa9$var$HoverCardForbiddenView;

});
parcelRegister("6PC9Z", function(module, exports) {

$parcel$export(module.exports, "titleBlockStyles", () => $e29da529ecbe3399$export$38125fa6916f5dab);
$parcel$export(module.exports, "mainTextStyles", () => $e29da529ecbe3399$export$a8a26925e3db0ef6);
$parcel$export(module.exports, "connectButtonStyles", () => $e29da529ecbe3399$export$e63cb455d3692ef0);

var $byn9U = parcelRequire("byn9U");
function $e29da529ecbe3399$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e29da529ecbe3399$var$titleFontWeight = '600';
const $e29da529ecbe3399$export$38125fa6916f5dab = /*#__PURE__*/ (0, $byn9U.css)({
    justifyContent: 'center',
    fontWeight: $e29da529ecbe3399$var$titleFontWeight,
    marginTop: "var(--ds-space-100, 8px)"
});
const $e29da529ecbe3399$export$a8a26925e3db0ef6 = {
    name: "9ceufl",
    styles: "display:inline;justify-content:center;margin-top:var(--ds-space-0, 0px);font-size:0.75rem;text-align:center"
};
const $e29da529ecbe3399$export$e63cb455d3692ef0 = {
    name: "198gd5p",
    styles: "justify-content:center;margin-top:var(--ds-space-100, 8px)"
};

});


parcelRegister("NJTzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c39b0b8c882ae6a0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $lVbJo = parcelRequire("lVbJo");

var $i2yZR = parcelRequire("i2yZR");

var $3miv3 = parcelRequire("3miv3");

var $04PAQ = parcelRequire("04PAQ");

var $asu8X = parcelRequire("asu8X");
const $c39b0b8c882ae6a0$var$ConnectedAIPrismContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $asu8X.di)((0, $04PAQ.default), (0, $i2yZR.default));
    const { state: { status: status } } = (0, $04PAQ.default)(url);
    const [showPrism, setShowPrism] = (0, $eUqFw.useState)(status === 'loading');
    (0, $eUqFw.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const container = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $3miv3.hoverCardClassName),
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            (0, $lVbJo.HoverCardContainer),
            !isAIEnabled ? (0, $lVbJo.popupContainerStyles) : undefined
        ],
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i2yZR.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $c39b0b8c882ae6a0$var$ContentContainer = ({ children: children, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)($c39b0b8c882ae6a0$var$ConnectedAIPrismContainer, {
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $c39b0b8c882ae6a0$export$2e2bcd8739ae039 = $c39b0b8c882ae6a0$var$ContentContainer;

});
parcelRegister("i2yZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb7014d33f6e1aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4q38b = parcelRequire("4q38b");

var $jLlux = parcelRequire("jLlux");

var $fMafu = parcelRequire("fMafu");

var $lVbJo = parcelRequire("lVbJo");
function $bb7014d33f6e1aba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bb7014d33f6e1aba$var$contentStyles = {
    name: "1u4p2uv",
    styles: "transition:box-shadow 0.5s ease"
};
const $bb7014d33f6e1aba$var$contentStylesPrismVisible = {
    name: "egtvy2",
    styles: "box-shadow:0px 8px 12px rgba(9, 30, 66, 0),0px 0px 1px rgba(9, 30, 66, 0)"
};
const $bb7014d33f6e1aba$var$AIPrism = ({ children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fMafu.default), {
        additionalCss: {
            animatedSvgContainer: /*#__PURE__*/ (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                opacity: isVisible ? 1 : 0,
                transition: 'opacity 0.5s ease'
            })
        },
        palette: (0, $jLlux.AI_BORDER_PALETTE)[colorMode] ?? (0, $jLlux.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lVbJo.popupContainerStyles),
            $bb7014d33f6e1aba$var$contentStyles,
            isVisible ? $bb7014d33f6e1aba$var$contentStylesPrismVisible : undefined
        ]
    }, children));
};
var $bb7014d33f6e1aba$export$2e2bcd8739ae039 = $bb7014d33f6e1aba$var$AIPrism;

});
parcelRegister("jLlux", function(module, exports) {

$parcel$export(module.exports, "INNER_BORDER_RADIUS", () => $def64263c2f98430$export$e9d9825cf6898271);
$parcel$export(module.exports, "OUTER_BORDER_RADIUS", () => $def64263c2f98430$export$2a2ad00ed1dae540);
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $def64263c2f98430$export$23b7b83c7063ccfe);
const $def64263c2f98430$export$e9d9825cf6898271 = 8;
const $def64263c2f98430$export$2a2ad00ed1dae540 = 10;
const $def64263c2f98430$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $def64263c2f98430$export$23b7b83c7063ccfe = {
    dark: {
        blue: $def64263c2f98430$export$3088ed82e2905d1e.blue800,
        teal: $def64263c2f98430$export$3088ed82e2905d1e.teal500,
        yellow: $def64263c2f98430$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $def64263c2f98430$export$3088ed82e2905d1e.blue600,
        teal: $def64263c2f98430$export$3088ed82e2905d1e.teal300,
        yellow: $def64263c2f98430$export$3088ed82e2905d1e.yellow200
    }
};

});

parcelRegister("fMafu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7c91d8a83a09599$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fDt02 = parcelRequire("fDt02");

var $jLlux = parcelRequire("jLlux");
function $b7c91d8a83a09599$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b7c91d8a83a09599$var$borderContainerStyles = {
    name: "hjc7l6",
    styles: "display:flex;position:relative;padding:var(--ds-space-025, 2px);width:fit-content"
};
const $b7c91d8a83a09599$export$a16b2e78d6201b80 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $jLlux.INNER_BORDER_RADIUS),
    flexGrow: 1,
    zIndex: 1 // needs to be more than the svg container at least
});
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $b7c91d8a83a09599$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, additionalCss: additionalCss })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $b7c91d8a83a09599$var$borderContainerStyles,
            additionalCss?.container
        ],
        "data-testid": testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fDt02.default), {
        palette: palette,
        isMoving: isMoving,
        additionalCss: additionalCss?.animatedSvgContainer
    }), isGlowing && /*#__PURE__*/ (0, $byn9U.jsx)((0, $fDt02.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        additionalCss: additionalCss?.animatedSvgContainer
    }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b7c91d8a83a09599$export$a16b2e78d6201b80
    }, children, " "));
var $b7c91d8a83a09599$export$2e2bcd8739ae039 = $b7c91d8a83a09599$var$AIGlowingBorder;

});
parcelRegister("fDt02", function(module, exports) {

$parcel$export(module.exports, "default", () => $507303c4e5cfbc53$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $jLlux = parcelRequire("jLlux");
function $507303c4e5cfbc53$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
let $507303c4e5cfbc53$var$namespaceUUID = 0;
const $507303c4e5cfbc53$var$svgStyles = /*#__PURE__*/ (0, $byn9U.css)({
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $jLlux.OUTER_BORDER_RADIUS)
});
const $507303c4e5cfbc53$var$blurredStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    height: `calc(100% - ${"var(--ds-space-050, 4px)"})`,
    top: "var(--ds-space-050, 4px)",
    left: "var(--ds-space-050, 4px)",
    filter: `blur(${"var(--ds-space-100, 8px)"})`,
    // for safari... : https://stackoverflow.com/a/71353198
    backfaceVisibility: 'hidden',
    transform: 'translate3d(0, 0, 0)'
});
const $507303c4e5cfbc53$var$notBlurredStyles = {
    name: "1nir64p",
    styles: "left:0;top:0;width:100%;height:100%"
};
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $507303c4e5cfbc53$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, additionalCss: additionalCss })=>{
    const svgRef = (0, $eUqFw.useRef)(null);
    const namespaceId = (0, $eUqFw.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $507303c4e5cfbc53$var$namespaceUUID;
        $507303c4e5cfbc53$var$namespaceUUID += 1;
    }
    (0, $eUqFw.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $507303c4e5cfbc53$var$svgStyles,
            isGlowing ? $507303c4e5cfbc53$var$blurredStyles : $507303c4e5cfbc53$var$notBlurredStyles,
            additionalCss
        ],
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("defs", null, /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ (0, $byn9U.jsx)("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ (0, $byn9U.jsx)("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $507303c4e5cfbc53$export$2e2bcd8739ae039 = $507303c4e5cfbc53$var$AnimatedSvgContainer;

});





parcelRegister("hxNq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5de1a9710440709$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $f5de1a9710440709$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...props,
        ref: ref
    }, children));
var $f5de1a9710440709$export$2e2bcd8739ae039 = $f5de1a9710440709$var$CustomPopupContainer;

});

parcelRegister("eGeQQ", function(module, exports) {

$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $5fc5bdbc0f185cb2$export$eaff10f7ec59c455);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $jfVIr = parcelRequire("jfVIr");

var $b81Yi = parcelRequire("b81Yi");

var $6aS3b = parcelRequire("6aS3b");
const $5fc5bdbc0f185cb2$export$eaff10f7ec59c455 = (props)=>{
    const { children: children, url: url, display: display } = props;
    const { details: details, status: status } = (0, $b81Yi.useSmartCardState)(url);
    const attributes = (0, $jfVIr.getResolvedAttributes)({
        url: url
    }, details, status);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aS3b.LinkAnalyticsContext), {
        ...props,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: attributes
        }
    }, children));
};

});
parcelRegister("6aS3b", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $225f130421a19d23$export$9458cdec663b9ff1);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $225f130421a19d23$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});


parcelRegister("fck9X", function(module, exports) {

$parcel$export(module.exports, "combineActionOptions", () => $b6c4b6f4a8e17ca1$export$2ae4cf79c720146a);

var $hqABm = parcelRequire("hqABm");
const $b6c4b6f4a8e17ca1$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, showServerActions: showServerActions, showActions: showActions, platform: platform, hidePreviewButton: hidePreviewButton })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile' || showServerActions === false && showActions === false) return {
        hide: true
    };
    let exclude = [];
    if (hidePreviewButton) exclude = [
        ...exclude,
        (0, $hqABm.CardAction).PreviewAction
    ];
    if (showServerActions && showActions) return {
        hide: false,
        exclude: exclude
    };
    if (showServerActions === false) exclude = [
        ...exclude,
        (0, $hqABm.CardAction).FollowAction,
        (0, $hqABm.CardAction).ChangeStatusAction
    ];
    if (showActions === false) {
        exclude = [
            ...exclude,
            (0, $hqABm.CardAction).DownloadAction,
            (0, $hqABm.CardAction).ViewAction
        ];
        if (!exclude.includes((0, $hqABm.CardAction).PreviewAction)) exclude.push((0, $hqABm.CardAction).PreviewAction);
    }
    return {
        hide: false,
        exclude: exclude
    };
};

});




parcelRegister("lcwz5", function(module, exports) {

$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $499e41af2307ecea$export$783c1bf8fee63f80);
const $499e41af2307ecea$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});


parcelRegister("fM0Kr", function(module, exports) {

$parcel$export(module.exports, "getContextByStatus", () => $046cdf71ac9af491$export$e68aec76e359e401);
$parcel$export(module.exports, "getRetryOptions", () => $046cdf71ac9af491$export$f3d3482baaff4bf6);

var $caOA9 = parcelRequire("caOA9");

var $7pH5u = parcelRequire("7pH5u");

var $8tvRs = parcelRequire("8tvRs");

var $4abrz = parcelRequire("4abrz");

var $fsHAt = parcelRequire("fsHAt");

var $903Mk = parcelRequire("903Mk");

var $9A6mL = parcelRequire("9A6mL");

var $ebCNT = parcelRequire("ebCNT");

var $9BBAF = parcelRequire("9BBAF");

var $ket3S = parcelRequire("ket3S");
const $046cdf71ac9af491$export$e68aec76e359e401 = (params)=>{
    const { response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Pending:
        case (0, $caOA9.SmartLinkStatus).Resolving:
            return {
                title: url,
                url: url
            };
        case (0, $caOA9.SmartLinkStatus).Resolved:
            return (0, $fsHAt.default)(params);
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
        case (0, $caOA9.SmartLinkStatus).Forbidden:
        case (0, $caOA9.SmartLinkStatus).NotFound:
        case (0, $caOA9.SmartLinkStatus).Errored:
        case (0, $caOA9.SmartLinkStatus).Fallback:
        default:
            const preview = (0, $ket3S.default)(response?.data);
            const linkIcon = (0, $903Mk.extractErrorIcon)(response, status);
            const provider = (0, $9BBAF.default)(response?.data);
            return {
                linkIcon: linkIcon,
                title: url,
                url: url,
                provider: provider,
                preview: preview
            };
    }
};
const $046cdf71ac9af491$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return 'join_to_view';
        case 'REQUEST_ACCESS':
            return 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $046cdf71ac9af491$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const data = response && response.data || (0, $7pH5u.getEmptyJsonLd)();
    const provider = (0, $ebCNT.extractProvider)(data);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $caOA9.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $7pH5u.getForbiddenJsonLd)().meta;
            const access = (0, $8tvRs.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $046cdf71ac9af491$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $4abrz.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $9A6mL.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $caOA9.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $4abrz.messages).connect_link_account_card_name,
                onClick: (0, $9A6mL.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $caOA9.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $4abrz.messages).cannot_find_link
            };
    }
};

});


parcelRegister("exfcX", function(module, exports) {

$parcel$export(module.exports, "metadataBlockCss", () => $0d3143786b5030b6$export$6d2a8e6ec8eaf792);
$parcel$export(module.exports, "titleBlockCss", () => $0d3143786b5030b6$export$ec02d9e26e1aed66);
$parcel$export(module.exports, "footerBlockCss", () => $0d3143786b5030b6$export$1ede44d22c218cc4);
$parcel$export(module.exports, "flexibleBlockCardStyle", () => $0d3143786b5030b6$export$230201754c96141f);

var $byn9U = parcelRequire("byn9U");

function $0d3143786b5030b6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0d3143786b5030b6$export$6d2a8e6ec8eaf792 = {
    name: "r8pzyz",
    styles: "span[data-smart-element-avatar-group]{> ul{padding-left:0px;margin-right:var(--ds-space-100, 0.5rem);}}[data-smart-element-group]{line-height:1rem;}"
};
const $0d3143786b5030b6$export$ec02d9e26e1aed66 = {
    name: "1jr9sek",
    styles: "gap:var(--ds-space-100, 0.5em);[data-smart-element='Title']{font-weight:600;}"
};
const $0d3143786b5030b6$export$1ede44d22c218cc4 = {
    name: "177c5pf",
    styles: "height:1.5rem;.actions-button-group{button, button:hover, button:focus, button:active{font-size:0.875rem;}}"
};
const $0d3143786b5030b6$export$230201754c96141f = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > div': {
        borderRadius: "var(--ds-border-radius-200, 8px)",
        border: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`
    }
});

});

parcelRegister("iEFE9", function(module, exports) {

$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $2d0f232b52f9aa42$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $2d0f232b52f9aa42$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $2d0f232b52f9aa42$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $2d0f232b52f9aa42$export$9671929f11bd4ad8);
$parcel$export(module.exports, "FooterBlockOptions", () => $2d0f232b52f9aa42$export$8e358ad69f69f8ff);

var $caOA9 = parcelRequire("caOA9");

var $fmv4j = parcelRequire("fmv4j");

var $269iK = parcelRequire("269iK");

var $exfcX = parcelRequire("exfcX");
const $2d0f232b52f9aa42$var$baseTopMetadata = [
    {
        name: (0, $caOA9.ElementName).ModifiedOn
    },
    {
        name: (0, $caOA9.ElementName).AttachmentCount
    },
    {
        name: (0, $caOA9.ElementName).SubscriberCount
    },
    {
        name: (0, $caOA9.ElementName).VoteCount
    },
    {
        name: (0, $caOA9.ElementName).DueOn
    },
    {
        name: (0, $caOA9.ElementName).ReadTime
    }
];
const $2d0f232b52f9aa42$var$baseBottomMetaData = [
    {
        name: (0, $caOA9.ElementName).ReactCount
    },
    {
        name: (0, $caOA9.ElementName).CommentCount
    },
    {
        name: (0, $caOA9.ElementName).ViewCount
    },
    {
        name: (0, $caOA9.ElementName).Priority
    },
    {
        name: (0, $caOA9.ElementName).SubTasksProgress
    },
    {
        name: (0, $caOA9.ElementName).ChecklistProgress
    }
];
const $2d0f232b52f9aa42$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $269iK.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $caOA9.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $caOA9.ElementName).AuthorGroup
        },
        {
            name: (0, $caOA9.ElementName).CreatedBy
        },
        ...$2d0f232b52f9aa42$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $2d0f232b52f9aa42$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $caOA9.ElementName).LatestCommit
                    },
                    {
                        name: (0, $caOA9.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $caOA9.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $fmv4j.extractOwnedBy)(data) ? [
                    {
                        name: (0, $caOA9.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $caOA9.ElementName).OwnedBy
                    },
                    ...$2d0f232b52f9aa42$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isJiraTask ? [
                    {
                        name: (0, $caOA9.ElementName).AssignedToGroup
                    },
                    {
                        name: (0, $caOA9.ElementName).AssignedTo
                    },
                    {
                        name: (0, $caOA9.ElementName).ModifiedOn
                    }
                ] : [
                    {
                        name: (0, $caOA9.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $caOA9.ElementName).CreatedBy
                    },
                    {
                        name: (0, $caOA9.ElementName).ModifiedOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $caOA9.ElementName).StoryPoints
                    },
                    {
                        name: (0, $caOA9.ElementName).Priority
                    },
                    {
                        name: (0, $caOA9.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $caOA9.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $caOA9.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $caOA9.ElementName).ReactCount
                    },
                    {
                        name: (0, $caOA9.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $caOA9.ElementName).CollaboratorGroup
                    },
                    ...$2d0f232b52f9aa42$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $2d0f232b52f9aa42$export$22ebf74c8bee4708 = {
    hideElevation: true
};
const $2d0f232b52f9aa42$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $caOA9.SmartLinkPosition).Center,
    overrideCss: (0, $exfcX.titleBlockCss),
    hideRetry: true,
    size: (0, $caOA9.SmartLinkSize).Large
};
const $2d0f232b52f9aa42$export$9671929f11bd4ad8 = {
    placement: (0, $caOA9.MediaPlacement).Right,
    ignoreContainerPadding: true
};
const $2d0f232b52f9aa42$export$8e358ad69f69f8ff = {
    overrideCss: (0, $exfcX.footerBlockCss)
};

});

parcelRegister("kzW0D", function(module, exports) {

$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $2f254384fdf8a4ea$export$36ce1a3a446661ab);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $exfcX = parcelRequire("exfcX");
const $2f254384fdf8a4ea$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: (0, $exfcX.flexibleBlockCardStyle)
        }, /*#__PURE__*/ (0, $byn9U.jsx)(FlexibleBlockCardView, props)));
    };

});


parcelRegister("3Zd30", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c923e7d1d4da1c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $269iK = parcelRequire("269iK");

var $4whuQ = parcelRequire("4whuQ");

var $ebCNT = parcelRequire("ebCNT");

var $eDeuK = parcelRequire("eDeuK");

var $4abrz = parcelRequire("4abrz");

var $1WCP5 = parcelRequire("1WCP5");

var $kzW0D = parcelRequire("kzW0D");
function $95c923e7d1d4da1c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $95c923e7d1d4da1c$var$contentStyles = {
    name: "jj11eo",
    styles: "color:var(--ds-text-subtlest, #626F86);margin-top:var(--ds-space-100, 0.5rem);font-size:0.75rem"
};
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $95c923e7d1d4da1c$var$FlexibleUnauthorisedView = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { analytics: analytics, cardState: cardState, onAuthorize: onAuthorize } = props;
    const extensionKey = (0, $269iK.getExtensionKey)(cardState?.details) ?? '';
    const data = cardState.details?.data;
    const providerName = (0, $ebCNT.extractProvider)(data)?.text;
    const isProductIntegrationSupported = (0, $269iK.hasAuthScopeOverrides)(cardState?.details);
    const handleAuthorize = (0, $eUqFw.useCallback)(()=>{
        if (onAuthorize) {
            analytics?.track.appAccountAuthStarted({
                extensionKey: extensionKey
            });
            onAuthorize();
        }
    }, [
        onAuthorize,
        extensionKey,
        analytics?.track
    ]);
    const content = (0, $eUqFw.useMemo)(()=>onAuthorize ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eDeuK.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            analytics: analytics,
            testId: testId
        }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
            ...(0, $4abrz.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        analytics,
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>onAuthorize ? [
            (0, $4whuQ.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1WCP5.default), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $95c923e7d1d4da1c$var$contentStyles,
        "data-testid": `${testId}-content`
    }, content));
};
var $95c923e7d1d4da1c$export$2e2bcd8739ae039 = (0, $kzW0D.withFlexibleUIBlockCardStyle)($95c923e7d1d4da1c$var$FlexibleUnauthorisedView);

});
parcelRegister("4whuQ", function(module, exports) {

$parcel$export(module.exports, "AuthorizeAction", () => $dc92ca0e817b6160$export$34cef2b72294bd84);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $dc92ca0e817b6160$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $caOA9.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $4abrz.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).connect_link_account_card),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});

parcelRegister("1WCP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9abaea4136af8114$export$2e2bcd8739ae039);

var $4sQhG = parcelRequire("4sQhG");
var $fbX7D = parcelRequire("fbX7D");
var $d9NWW = parcelRequire("d9NWW");
var $4bEHq = parcelRequire("4bEHq");

var $eUqFw = parcelRequire("eUqFw");

var $kKYlt = parcelRequire("kKYlt");

var $iEFE9 = parcelRequire("iEFE9");
function $9abaea4136af8114$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9abaea4136af8114$var$customBlockStyles = {
    name: "5dh3r6",
    styles: "align-items:flex-start"
};
const $9abaea4136af8114$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kKYlt.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        testId: testId,
        ui: (0, $iEFE9.FlexibleCardUiOptions),
        url: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
        ...(0, $iEFE9.titleBlockOptions),
        hideIcon: !!title,
        text: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4sQhG.default), {
        overrideCss: $9abaea4136af8114$var$customBlockStyles
    }, children), showPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9NWW.default), (0, $iEFE9.PreviewBlockOptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fbX7D.default), {
        ...(0, $iEFE9.FooterBlockOptions),
        actions: actions,
        testId: "smart-block-card-footer"
    }));
var $9abaea4136af8114$export$2e2bcd8739ae039 = $9abaea4136af8114$var$UnresolvedView;

});


parcelRegister("eNZbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ba6550fc60af$export$2e2bcd8739ae039);

var $fXMW0 = parcelRequire("fXMW0");

var $ebCNT = parcelRequire("ebCNT");


var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4abrz = parcelRequire("4abrz");

var $gsehw = parcelRequire("gsehw");

var $1WCP5 = parcelRequire("1WCP5");

var $kzW0D = parcelRequire("kzW0D");
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $1167ba6550fc60af$var$FlexibleNotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $5JgJ2.default)();
    const { cardState: cardState } = props;
    const product = (0, $eUqFw.useMemo)(()=>{
        const provider = (0, $ebCNT.extractProvider)(cardState?.details?.data);
        return provider?.text ?? '';
    }, [
        cardState?.details?.data
    ]);
    const title = (0, $eUqFw.useMemo)(()=>intl.formatMessage((0, $4abrz.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $eUqFw.useMemo)(()=>({
            descriptor: (0, $4abrz.messages).not_found_description
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WCP5.default), {
        ...props,
        testId: testId,
        title: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXMW0))), {
        label: "not-found-lock-icon",
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        message: description,
        testId: `${testId}-message`,
        maxLines: 3
    }));
};
var $1167ba6550fc60af$export$2e2bcd8739ae039 = (0, $kzW0D.withFlexibleUIBlockCardStyle)($1167ba6550fc60af$var$FlexibleNotFoundView);

});
parcelRegister("fXMW0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b9f253171a9f20fe$var$_react = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $b9f253171a9f20fe$var$_lockLocked = $b9f253171a9f20fe$var$_interopRequireDefault((parcelRequire("gWhpp")));
function $b9f253171a9f20fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b9f253171a9f20fe$var$LockIcon = (props)=>/*#__PURE__*/ $b9f253171a9f20fe$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $b9f253171a9f20fe$var$_lockLocked.default
    }));
$b9f253171a9f20fe$var$LockIcon.displayName = 'LockIcon';
var $b9f253171a9f20fe$var$_default = module.exports.default = $b9f253171a9f20fe$var$LockIcon;

});


parcelRegister("gCRIg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bb749d5fc039da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9tpVZ = parcelRequire("9tpVZ");


var $4abrz = parcelRequire("4abrz");

var $fXMW0 = parcelRequire("fXMW0");

var $5GlEr = parcelRequire("5GlEr");

var $gsehw = parcelRequire("gsehw");

var $7pH5u = parcelRequire("7pH5u");

var $ebCNT = parcelRequire("ebCNT");

var $1WCP5 = parcelRequire("1WCP5");

var $kzW0D = parcelRequire("kzW0D");

var $8tvRs = parcelRequire("8tvRs");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8Wyjt = parcelRequire("8Wyjt");

var $bFzGY = parcelRequire("bFzGY");
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $d0bb749d5fc039da$var$FlexibleForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const intl = (0, $5JgJ2.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $7pH5u.getForbiddenJsonLd)().meta;
    const provider = (0, $ebCNT.extractProvider)(details?.data);
    const providerName = provider?.text || '';
    const messageContext = (0, $eUqFw.useMemo)(()=>{
        const hostname = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, (0, $8Wyjt.default)(url));
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $eUqFw.useMemo)(()=>{
        return (0, $8tvRs.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $eUqFw.useMemo)(()=>{
        const descriptor = (0, $9tpVZ.toMessage)((0, $4abrz.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $5GlEr.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $5GlEr.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WCP5.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fXMW0))), {
        label: "forbidden-lock-icon",
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $9tpVZ.toMessage)((0, $4abrz.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
            values: messageContext
        }
    }));
};
var $d0bb749d5fc039da$export$2e2bcd8739ae039 = (0, $kzW0D.withFlexibleUIBlockCardStyle)($d0bb749d5fc039da$var$FlexibleForbiddenView);

});
parcelRegister("9tpVZ", function(module, exports) {

$parcel$export(module.exports, "toMessage", () => $7e8679ab5e52530e$export$d14c2a6dee946f52);

var $4abrz = parcelRequire("4abrz");
const $7e8679ab5e52530e$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $4abrz.messages)) return (0, $4abrz.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("5GlEr", function(module, exports) {

$parcel$export(module.exports, "ForbiddenAction", () => $53d94de88e16b0d6$export$59f8830fb5467e35);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $53d94de88e16b0d6$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $caOA9.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $4abrz.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("aeAjk", function(module, exports) {

$parcel$export(module.exports, "default", () => $09289f801fb8fffe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4abrz = parcelRequire("4abrz");


var $5YsMl = parcelRequire("5YsMl");

var $dUvZw = parcelRequire("dUvZw");

var $gsehw = parcelRequire("gsehw");

var $1WCP5 = parcelRequire("1WCP5");

var $kzW0D = parcelRequire("kzW0D");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $09289f801fb8fffe$var$FlexibleErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $eUqFw.useMemo)(()=>props.onAuthorize ? [
            (0, $dUvZw.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WCP5.default), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: "errored-warning-icon",
        size: "small",
        primaryColor: `var(--ds-icon-warning, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
        testId: `${testId}-warning-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gsehw.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $4abrz.messages).could_not_load_link
        }
    }));
};
var $09289f801fb8fffe$export$2e2bcd8739ae039 = (0, $kzW0D.withFlexibleUIBlockCardStyle)($09289f801fb8fffe$var$FlexibleErroredView);

});
parcelRegister("dUvZw", function(module, exports) {

$parcel$export(module.exports, "RetryAction", () => $8e4190ad68907045$export$c527d977b53f7537);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $caOA9 = parcelRequire("caOA9");

var $4abrz = parcelRequire("4abrz");
const $8e4190ad68907045$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $caOA9.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).try_again),
        testId: 'smart-action-try-again'
    });

});



parcelRegister("cLOfJ", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $022ddd7313be775f$export$aff6291803939b05);

var $eUqFw = parcelRequire("eUqFw");

var $7pH5u = parcelRequire("7pH5u");

var $eUl4s = parcelRequire("eUl4s");

var $8tvRs = parcelRequire("8tvRs");

var $4lXV3 = parcelRequire("4lXV3");

var $iQsVn = parcelRequire("iQsVn");

var $5ZH9n = parcelRequire("5ZH9n");

var $awzhz = parcelRequire("awzhz");

var $1eUhm = parcelRequire("1eUhm");

var $mw0BG = parcelRequire("mw0BG");

var $ebCNT = parcelRequire("ebCNT");

var $6FBuV = parcelRequire("6FBuV");

var $269iK = parcelRequire("269iK");

var $bFzGY = parcelRequire("bFzGY");

var $caOA9 = parcelRequire("caOA9");
const $022ddd7313be775f$export$aff6291803939b05 = ({ analytics: analytics, id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const cardDetails = details && details.data || (0, $7pH5u.getEmptyJsonLd)();
    const extensionKey = (0, $269iK.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const showHoverPreviewFlag = (0, $6FBuV.useFeatureFlag)('showHoverPreview');
    if (showHoverPreview === undefined && showHoverPreviewFlag !== undefined) showHoverPreview = Boolean(showHoverPreviewFlag);
    const resolvedProps = status === (0, $caOA9.SmartLinkStatus).Resolved ? (0, $eUl4s.extractInlineProps)(cardDetails, renderers, removeTextHighlightingFromTitle) : {};
    (0, $eUqFw.useEffect)(()=>{
        switch(status){
            case (0, $caOA9.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title
                });
                break;
            case (0, $caOA9.SmartLinkStatus).Errored:
            case (0, $caOA9.SmartLinkStatus).Fallback:
            case (0, $caOA9.SmartLinkStatus).Forbidden:
            case (0, $caOA9.SmartLinkStatus).NotFound:
            case (0, $caOA9.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1eUhm.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder
            });
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzhz.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                testId: testIdWithStatus
            });
        case 'unauthorized':
            const provider = (0, $ebCNT.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $mw0BG.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showAuthTooltip: showAuthTooltip,
                id: id,
                analytics: analytics,
                extensionKey: extensionKey
            });
        case 'forbidden':
            const providerForbidden = (0, $ebCNT.extractProvider)(cardDetails);
            const cardMetadata = details?.meta ?? (0, $7pH5u.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $8tvRs.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ZH9n.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview
            });
        case 'not_found':
            const providerNotFound = (0, $ebCNT.extractProvider)(cardDetails);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iQsVn.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lXV3.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view'
            });
    }
};

});
parcelRegister("eUl4s", function(module, exports) {

$parcel$export(module.exports, "extractInlineProps", () => $9d195747b1272bfb$export$68e1703c529dc7e0);

var $24j8L = parcelRequire("24j8L");

var $i9zl6 = parcelRequire("i9zl6");

var $s2tJO = parcelRequire("s2tJO");

var $buT9h = parcelRequire("buT9h");

var $lnW6z = parcelRequire("lnW6z");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");

var $4DxpJ = parcelRequire("4DxpJ");
const $9d195747b1272bfb$export$5c2e09705008937e = (jsonLd)=>{
    const provider = (0, $ebCNT.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $4DxpJ.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $4DxpJ.JIRA_GENERATOR_ID)) return (0, $s2tJO.extractIcon)(jsonLd);
    }
    return (0, $s2tJO.extractIcon)(jsonLd, 'provider');
};
const $9d195747b1272bfb$export$68e1703c529dc7e0 = (jsonLd, renderers, removeTextHighlightingFromTitle)=>({
        link: (0, $lnW6z.extractLink)(jsonLd),
        title: (0, $a4gSw.extractTitle)(jsonLd, removeTextHighlightingFromTitle),
        lozenge: (0, $i9zl6.extractLozenge)(jsonLd),
        icon: $9d195747b1272bfb$export$5c2e09705008937e(jsonLd),
        titleTextColor: (0, $24j8L.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $buT9h.extractTitlePrefix)(jsonLd, renderers, 'inline')
    });

});

parcelRegister("iQsVn", function(module, exports) {

$parcel$export(module.exports, "InlineCardErroredView", () => $c47817e5084d9cbd$export$8ae570c871cdb179);

var $eUqFw = parcelRequire("eUqFw");


var $cRF2H = parcelRequire("cRF2H");

var $7u4fN = parcelRequire("7u4fN");

var $8BByu = parcelRequire("8BByu");

var $3JeIh = parcelRequire("3JeIh");

var $eNGDa = parcelRequire("eNGDa");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $7P5BT = parcelRequire("7P5BT");

var $kG7vW = parcelRequire("kG7vW");

var $l2663 = parcelRequire("l2663");
class $c47817e5084d9cbd$export$8ae570c871cdb179 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message } = this.props;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            testId: testId,
            isSelected: isSelected,
            ref: this.frameRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JeIh.IconAndTitleLayout), {
            icon: icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNGDa.AKIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRF2H))), {
                label: "error",
                LEGACY_size: "small",
                color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
                testId: "errored-view-default-icon"
            })),
            link: url,
            title: url,
            onClick: onClick,
            rightSide: message
        }), this.renderActionButton());
        if (this.props.showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.HoverCard), {
            url: url
        }, content);
        return content;
    }
    constructor(...args){
        super(...args);
        this.frameRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.handleRetry = (event)=>{
            const { onRetry: onRetry } = this.props;
            if (onRetry) {
                event.preventDefault();
                event.stopPropagation();
                onRetry();
            }
        };
        this.renderActionButton = ()=>{
            const { onRetry: onRetry } = this.props;
            const ActionButton = (0, $kG7vW.default)((0, $7u4fN.default), this.frameRef);
            return onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionButton, {
                spacing: "none",
                component: (0, $7P5BT.IconStyledButton),
                onClick: this.handleRetry,
                role: "button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).try_again));
        };
    }
}

});
parcelRegister("cRF2H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b5353aefb8b927c75a9255a7f4f860a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $95da457782830ad9$var$_react = $95da457782830ad9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $95da457782830ad9$var$_error = $95da457782830ad9$var$_interopRequireDefault((parcelRequire("3y3FU")));

var $95da457782830ad9$var$_error2 = $95da457782830ad9$var$_interopRequireDefault((parcelRequire("96IgR")));
function $95da457782830ad9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $95da457782830ad9$var$ErrorIcon = (props)=>/*#__PURE__*/ $95da457782830ad9$var$_react.default.createElement($95da457782830ad9$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $95da457782830ad9$var$_error2.default
    }, props));
$95da457782830ad9$var$ErrorIcon.Name = 'ErrorIconMigration';
var $95da457782830ad9$var$_default = module.exports.default = $95da457782830ad9$var$ErrorIcon;

});
parcelRegister("3y3FU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7a8a196ba35a1e44ea89ac2740db6231>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295765d1df1715f9$var$_react = $295765d1df1715f9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $295765d1df1715f9$var$_UNSAFE_baseNew = $295765d1df1715f9$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $295765d1df1715f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295765d1df1715f9$var$ErrorIcon = (props)=>/*#__PURE__*/ $295765d1df1715f9$var$_react.default.createElement($295765d1df1715f9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$295765d1df1715f9$var$ErrorIcon.displayName = 'ErrorIcon';
var $295765d1df1715f9$var$_default = module.exports.default = $295765d1df1715f9$var$ErrorIcon;

});


parcelRegister("3JeIh", function(module, exports) {

$parcel$export(module.exports, "IconAndTitleLayout", () => $6c1e0e1ae33d1a7e$export$d34be4d513116847);

var $eUqFw = parcelRequire("eUqFw");

var $cRPaW = parcelRequire("cRPaW");

var $eNGDa = parcelRequire("eNGDa");

var $hebmv = parcelRequire("hebmv");

var $fBftA = parcelRequire("fBftA");

var $7P5BT = parcelRequire("7P5BT");

var $XHGTv = parcelRequire("XHGTv");
class $6c1e0e1ae33d1a7e$export$d34be4d513116847 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            rightSideSpacer: true
        };
    }
    renderAtlaskitIcon() {
        const { icon: icon, emoji: emoji } = this.props;
        if (emoji) return (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.EmojiWrapperResized), null, emoji) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.EmojiWrapper), null, emoji);
        if (!icon || typeof icon === 'string') return null;
        return (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconWrapperResized), null, icon) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconWrapper), null, icon);
    }
    renderImageIcon(errored, testId) {
        const { icon: url } = this.props;
        if (!url || typeof url !== 'string') return null;
        const icon = (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNGDa.IconResized), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "smart-link-icon",
            src: url,
            "data-testid": `${testId}-image`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNGDa.Icon), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "smart-link-icon",
            src: url,
            "data-testid": `${testId}-image`
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
            src: url,
            loaded: icon,
            errored: errored,
            loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNGDa.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }
    renderIconPlaceholder(testId) {
        const { defaultIcon: defaultIcon } = this.props;
        if (defaultIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconWrapper), null, defaultIcon);
        return (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconWrapperResized), {
            "data-testid": `${testId}-default`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
            label: "link",
            LEGACY_size: "small",
            testId: `${testId}-default`,
            color: "currentColor"
        }));
    }
    renderIcon(testId) {
        // We render two kinds of icons here:
        // - Image: acquired from either DAC or Teamwork Platform Apps;
        // - Atlaskit Icon: an Atlaskit SVG;
        // Each of these are scaled down to 12x12.
        const icon = this.renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = this.renderIconPlaceholder(testId);
        const image = this.renderImageIcon(placeholder, testId);
        return image || placeholder;
    }
    render() {
        const { children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title' } = this.props;
        const iconPart = (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconPositionWrapper), {
            "data-testid": "icon-position-wrapper"
        }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconEmptyWrapperResized), {
            "data-testid": "icon-empty-wrapper"
        }), this.renderIcon(testId))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconPositionWrapper), null, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconEmptyWrapper), null), this.renderIcon(testId)));
        const titlePart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, iconPart, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.TitleWrapper), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                color: titleTextColor
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $hebmv.TitleWrapperClassName)
        }, title));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconTitleWrapper), {
            style: {
                color: titleColor
            },
            "data-testid": testId
        }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P5BT.LinkAppearance), {
            href: link,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress
        }, titlePart) : titlePart, rightSide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7P5BT.NoLinkAppearance), null, rightSide) : null));
    }
    constructor(...args){
        super(...args);
        this.handleClick = (event)=>{
            const { onClick: onClick } = this.props;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
        this.handleKeyPress = (event)=>{
            const { onClick: onClick } = this.props;
            if (event.key !== ' ' && event.key !== 'Enter') return;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        };
    }
}

});
parcelRegister("eNGDa", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $ffbf5ba5673d0eea$export$f04a61298a47a40f);
$parcel$export(module.exports, "IconResized", () => $ffbf5ba5673d0eea$export$9209c10600644f7);
$parcel$export(module.exports, "AKIconWrapper", () => $ffbf5ba5673d0eea$export$a201b065fc2e76a1);
$parcel$export(module.exports, "Shimmer", () => $ffbf5ba5673d0eea$export$809644b82cfe94b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3ZpiY = parcelRequire("3ZpiY");

var $XHGTv = parcelRequire("XHGTv");

var $eUqFw = parcelRequire("eUqFw");

var $joBf7 = parcelRequire("joBf7");
function $ffbf5ba5673d0eea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffbf5ba5673d0eea$export$f04a61298a47a40f = /*#__PURE__*/ (0, $joBf7.default)("img", {
    target: "e1yrcv6a2"
})({
    name: "15ahtvm",
    styles: "height:14px;width:14px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
const $ffbf5ba5673d0eea$export$9209c10600644f7 = /*#__PURE__*/ (0, $joBf7.default)("img", {
    target: "e1yrcv6a1"
})({
    name: "1k5u7ry",
    styles: "height:16px;width:16px;margin-right:var(--ds-space-050, 4px);border-radius:2px;user-select:none;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
const $ffbf5ba5673d0eea$export$a201b065fc2e76a1 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1yrcv6a0"
})({
    name: "18dmqdk",
    styles: "margin-right:var(--ds-space-negative-025, -2px)"
});
const $ffbf5ba5673d0eea$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ZpiY.SpanSkeleton), {
        width: (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? 16 : 14,
        height: (0, $XHGTv.fg)('linking-platform-increase-inline-card-icon-size') ? 16 : 14,
        borderRadius: 2,
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("3ZpiY", function(module, exports) {

$parcel$export(module.exports, "SpanSkeleton", () => $1ab4073c4afbfed8$export$85d5658002cae6ce);
$parcel$export(module.exports, "Skeleton", () => $1ab4073c4afbfed8$export$8f31e4c4a37b8e9c);

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $joBf7 = parcelRequire("joBf7");
const $1ab4073c4afbfed8$var$placeholderShimmer = (0, $byn9U.keyframes)({
    '0%': {
        backgroundPosition: '-20px 0'
    },
    '100%': {
        backgroundPosition: '60px 0'
    }
});
const $1ab4073c4afbfed8$var$appearanceValues = {
    darkGray: {
        background: `var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`,
        animation: `var(--ds-background-accent-gray-subtle, ${(0, $73a5c9d720aa66e1$export$c2e91cbeada39b8b)})`
    },
    gray: {
        background: `var(--ds-background-accent-gray-subtlest, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        animation: `var(--ds-skeleton, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`
    },
    blue: {
        background: `var(--ds-background-accent-blue-subtlest, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        animation: "var(--ds-background-information-hovered, #cce0ff)"
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ab4073c4afbfed8$var$ShimmerSkeleton = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "e1vpqdnv1"
})("height:", ({ height: height })=>height || 'auto', ";width:", ({ width: width })=>width || 'auto', ";border-radius:", ({ borderRadius: borderRadius })=>borderRadius || 0, ";user-select:none;background:", ({ appearance: appearance = 'gray' })=>$1ab4073c4afbfed8$var$appearanceValues[appearance].background, ";background-image:", ({ appearance: appearance = 'gray' })=>`linear-gradient(
    to right,
    transparent 0%,
   ${$1ab4073c4afbfed8$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`, ";background-repeat:no-repeat;background-size:", ({ height: height, isShimmering: isShimmering })=>isShimmering ? `40px ${height};` : '0px', ";animation:", $1ab4073c4afbfed8$var$placeholderShimmer, " 1s linear infinite forwards;");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ab4073c4afbfed8$var$ShimmerSkeletonSpan = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1vpqdnv0"
})("height:", ({ height: height })=>height || 'auto', ";width:", ({ width: width })=>width || 'auto', ";border-radius:", ({ borderRadius: borderRadius })=>borderRadius || 0, ";user-select:none;background:", ({ appearance: appearance = 'gray' })=>$1ab4073c4afbfed8$var$appearanceValues[appearance].background, ";background-image:", ({ appearance: appearance = 'gray' })=>`linear-gradient(
    to right,
    transparent 0%,
   ${$1ab4073c4afbfed8$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`, ";background-repeat:no-repeat;background-size:", ({ height: height, isShimmering: isShimmering })=>isShimmering ? `40px ${height};` : '0px', ";animation:", $1ab4073c4afbfed8$var$placeholderShimmer, " 1s linear infinite forwards;");
const $1ab4073c4afbfed8$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ab4073c4afbfed8$var$ShimmerSkeletonSpan, {
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
        appearance: appearance,
        isShimmering: isShimmering,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    });
const $1ab4073c4afbfed8$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ab4073c4afbfed8$var$ShimmerSkeleton, {
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        borderRadius: typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius,
        appearance: appearance,
        isShimmering: isShimmering,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    });
var $1ab4073c4afbfed8$export$2e2bcd8739ae039 = $1ab4073c4afbfed8$export$8f31e4c4a37b8e9c;

});


parcelRegister("hebmv", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $d843b28d587a5202$export$be58b4326e23250f);
$parcel$export(module.exports, "IconWrapperResized", () => $d843b28d587a5202$export$fef49492309346c5);
$parcel$export(module.exports, "EmojiWrapper", () => $d843b28d587a5202$export$e31a6cc0a4c97f0e);
$parcel$export(module.exports, "EmojiWrapperResized", () => $d843b28d587a5202$export$2a76857f50b868cf);
$parcel$export(module.exports, "IconTitleWrapper", () => $d843b28d587a5202$export$c73a53738ef9e3f);
$parcel$export(module.exports, "LozengeWrapper", () => $d843b28d587a5202$export$75180efdd3f4d9c2);
$parcel$export(module.exports, "RightIconPositionWrapper", () => $d843b28d587a5202$export$91b164375b8037b5);
$parcel$export(module.exports, "IconPositionWrapper", () => $d843b28d587a5202$export$7291f9f954790243);
$parcel$export(module.exports, "IconEmptyWrapper", () => $d843b28d587a5202$export$ddce81e032b0736e);
$parcel$export(module.exports, "IconEmptyWrapperResized", () => $d843b28d587a5202$export$8d16e65375787e5);
$parcel$export(module.exports, "TitleWrapperClassName", () => $d843b28d587a5202$export$2f5de92a8d4f43bd);
$parcel$export(module.exports, "TitleWrapper", () => $d843b28d587a5202$export$585a3b23e887288b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $joBf7 = parcelRequire("joBf7");
function $d843b28d587a5202$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d843b28d587a5202$export$b993aa7bab57be12 = `
  & > span {
    height: 16px;
    width: 14px;
    position: absolute;
    top: 3px;
    left: 0;
    line-height: 14px;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d843b28d587a5202$export$ded9fa9f58c8840e = `

  & > * > span {
    height: 16px;
    width: 14px;
    position: absolute;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d843b28d587a5202$export$be58b4326e23250f = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu0710"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$b993aa7bab57be12);
const $d843b28d587a5202$export$e2990b1b1e449515 = `
  & > span {
    height: 16px;
    width: 16px;
    position: absolute;
    top: 3px;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d843b28d587a5202$export$7b94901353420f6b = `
  & > * > span {
    height: 16px;
    width: 16px;
    position: absolute;
    left: 0;
    & > svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
const $d843b28d587a5202$export$fef49492309346c5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu079"
})("user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$7b94901353420f6b, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$e2990b1b1e449515);
const $d843b28d587a5202$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu078"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$ded9fa9f58c8840e, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$b993aa7bab57be12);
const $d843b28d587a5202$export$2a76857f50b868cf = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu077"
})("display:inline-block;margin-right:var(--ds-space-025, 2px);user-select:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$7b94901353420f6b, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$d843b28d587a5202$export$e2990b1b1e449515);
const $d843b28d587a5202$export$c73a53738ef9e3f = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu076"
})({
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    boxDecorationBreak: 'clone',
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $d843b28d587a5202$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu075"
})({
    display: 'inline-block',
    verticalAlign: '1px',
    margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-025, 2px)"}`
});
const $d843b28d587a5202$export$91b164375b8037b5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu074"
})({
    name: "11x0xmp",
    styles: "margin-left:var(--ds-space-025, 2px);position:relative;display:inline-block"
});
const $d843b28d587a5202$export$7291f9f954790243 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu073"
})({
    name: "166gprz",
    styles: "margin-right:var(--ds-space-050, 4px);position:relative;display:inline-block"
});
const $d843b28d587a5202$export$ddce81e032b0736e = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu072"
})({
    name: "vehdi",
    styles: "width:14px;height:100%;display:inline-block;opacity:0"
});
const $d843b28d587a5202$export$8d16e65375787e5 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu071"
})({
    name: "1yc74wk",
    styles: "width:16px;height:100%;display:inline-block;opacity:0"
});
const $d843b28d587a5202$export$2f5de92a8d4f43bd = 'smart-link-title-wrapper';
const $d843b28d587a5202$export$585a3b23e887288b = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1a3lu070"
})({
    name: "0",
    styles: ""
});

});

parcelRegister("7P5BT", function(module, exports) {

$parcel$export(module.exports, "IconStyledButton", () => $7a0c64f86ef14157$export$521c8c8542119f15);
$parcel$export(module.exports, "NoLinkAppearance", () => $7a0c64f86ef14157$export$afb2f4f410fd9408);
$parcel$export(module.exports, "LinkAppearance", () => $7a0c64f86ef14157$export$31729deae5f9e85d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766


var $joBf7 = parcelRequire("joBf7");
function $7a0c64f86ef14157$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7a0c64f86ef14157$export$521c8c8542119f15 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1aelec93"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&&': {
        textAlign: 'initial',
        display: 'inline',
        verticalAlign: 'baseline',
        borderRadius: "var(--ds-border-radius-100, 4px)",
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`,
        backgroundClip: 'padding-box',
        boxDecorationBreak: 'clone'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> span': {
        display: 'inline',
        overflow: 'initial',
        textOverflow: 'initial',
        whiteSpace: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            overflow: 'initial',
            textOverflow: 'initial',
            whiteSpace: 'initial'
        }
    }
});
const $7a0c64f86ef14157$export$afb2f4f410fd9408 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1aelec92"
})({
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    marginLeft: "var(--ds-space-050, 4px)"
});
const $7a0c64f86ef14157$export$5c1bdd1e97b19b58 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "e1aelec91"
})({
    name: "1tq8czj",
    styles: "text-transform:lowercase"
});
const $7a0c64f86ef14157$export$31729deae5f9e85d = /*#__PURE__*/ (0, $joBf7.default)("a", {
    target: "e1aelec90"
})({
    color: `var(--ds-link, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '&:hover': {
        textDecoration: 'none'
    }
});

});


parcelRegister("kG7vW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a99f383ba5445f6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var /**
 * This HOC serves as a temporary workaround for controlling the style of a parent component.
 * We do not want the Frame to have a hover state when hovering over the action button.
 * TODO: When Firefox begins supporting the :has()pseudo-selector (e.g "frame:has(button:hover){...}"),
 * it should be used instead and the code should be cleaned up.
 */ $4a99f383ba5445f6$export$2e2bcd8739ae039 = (Button, frameRef)=>(props)=>{
        const setBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.style.borderColor = `${`var(--ds-border, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`}`;
        };
        const removeBorderStyle = ()=>{
            const frameNode = frameRef.current;
            if (frameNode) frameNode.removeAttribute('style');
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Button, {
            ...props,
            onMouseEnter: setBorderStyle,
            onMouseLeave: removeBorderStyle
        });
    };

});


parcelRegister("5ZH9n", function(module, exports) {

$parcel$export(module.exports, "InlineCardForbiddenView", () => $816321eb4e4a5f12$export$ebd227d2573ed3d8);

var $eUqFw = parcelRequire("eUqFw");


var $f4A0J = parcelRequire("f4A0J");

var $7u4fN = parcelRequire("7u4fN");

var $8BByu = parcelRequire("8BByu");

var $3JeIh = parcelRequire("3JeIh");

var $eNGDa = parcelRequire("eNGDa");

var $4abrz = parcelRequire("4abrz");

var $8uD7Y = parcelRequire("8uD7Y");

var $7P5BT = parcelRequire("7P5BT");

var $ffiyv = parcelRequire("ffiyv");

var $hebmv = parcelRequire("hebmv");

var $kG7vW = parcelRequire("kG7vW");

var $l2663 = parcelRequire("l2663");
const $816321eb4e4a5f12$var$FallbackForbiddenIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNGDa.AKIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
    label: "error",
    size: "small",
    primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    testId: "forbidden-view-fallback-icon"
}));
class $816321eb4e4a5f12$export$ebd227d2573ed3d8 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view' } = this.props;
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            testId: testId,
            isSelected: isSelected,
            ref: this.frameRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JeIh.IconAndTitleLayout), {
            icon: icon ? icon : $816321eb4e4a5f12$var$FallbackForbiddenIcon,
            link: url,
            title: url,
            onClick: onClick,
            titleColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        }), this.renderActionButton());
        if (this.props.showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.HoverCard), {
            url: url
        }, content);
        return content;
    }
    constructor(...args){
        super(...args);
        this.frameRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.state = {
            hasRequestAccessContextMessage: !!this.props?.requestAccessContext?.callToActionMessageKey
        };
        this.handleRetry = (event)=>{
            const { onAuthorise: onAuthorise } = this.props;
            event.preventDefault();
            event.stopPropagation();
            if (onAuthorise) onAuthorise();
            else this.props?.requestAccessContext?.action?.promise();
        };
        this.renderForbiddenAccessMessage = ()=>{
            if (this.props?.requestAccessContext?.callToActionMessageKey) {
                const { callToActionMessageKey: callToActionMessageKey } = this.props.requestAccessContext;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $4abrz.messages)[callToActionMessageKey],
                    values: {
                        product: this.props.context
                    }
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).invalid_permissions, (formattedMessage)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formattedMessage);
            }));
        };
        this.renderActionButton = ()=>{
            const { onAuthorise: onAuthorise } = this.props;
            const ActionButton = (0, $kG7vW.default)((0, $7u4fN.default), this.frameRef);
            const accessType = this.props.requestAccessContext?.accessType;
            if (this.state.hasRequestAccessContextMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionButton, {
                spacing: "none",
                onClick: this.handleRetry,
                component: (0, $7P5BT.IconStyledButton),
                testId: "button-connect-other-account",
                role: "button",
                isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
            }, this.renderForbiddenAccessMessage());
            if (onAuthorise) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                spacing: "none",
                onClick: this.handleRetry,
                appearance: "subtle-link",
                testId: "button-connect-other-account",
                role: "button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: 'moved'
            }, this.renderForbiddenAccessMessage())));
            return null;
        };
    }
}

});

parcelRegister("awzhz", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvedView", () => $bb00dafb1e8b29a3$export$6d5912cb4b56390e);

var $eUqFw = parcelRequire("eUqFw");

var $8BByu = parcelRequire("8BByu");

var $ffiyv = parcelRequire("ffiyv");

var $3JeIh = parcelRequire("3JeIh");

var $hebmv = parcelRequire("hebmv");

var $l2663 = parcelRequire("l2663");
class $bb00dafb1e8b29a3$export$6d5912cb4b56390e extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge) return null;
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.LozengeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: lozenge.style,
            isBold: lozenge.isBold
        }, lozenge.text));
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JeIh.IconAndTitleLayout), {
            emoji: titlePrefix,
            icon: icon,
            title: title,
            titleTextColor: titleTextColor
        }), this.renderLozenge());
        if (showHoverPreview && link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions
        }, inlineCardResolvedView);
        return inlineCardResolvedView;
    }
}

});

parcelRegister("1eUhm", function(module, exports) {

$parcel$export(module.exports, "InlineCardResolvingView", () => $8a10dedc1c14eaa4$export$98531adac42f053e);

var $eUqFw = parcelRequire("eUqFw");

var $8BByu = parcelRequire("8BByu");

var $4Bees = parcelRequire("4Bees");

var $3JeIh = parcelRequire("3JeIh");

var $dC0oI = parcelRequire("dC0oI");

var $hebmv = parcelRequire("hebmv");
class $8a10dedc1c14eaa4$export$98531adac42f053e extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder } = this.props;
        if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            withoutBackground: true,
            testId: testId,
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.IconTitleWrapper), null, url, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hebmv.RightIconPositionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC0oI.SpinnerWrapper), {
            className: "inline-resolving-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: 14
        })))));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            testId: testId,
            onClick: onClick,
            isSelected: isSelected,
            link: url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JeIh.IconAndTitleLayout), {
            title: resolvingPlaceholder ?? url,
            titleTextColor: titleTextColor
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dC0oI.SpinnerWrapper), {
            className: "inline-resolving-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: 14
        }))));
    }
}

});
parcelRegister("dC0oI", function(module, exports) {

$parcel$export(module.exports, "SpinnerWrapper", () => $3ca165408fdb63be$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $hebmv = parcelRequire("hebmv");

var $joBf7 = parcelRequire("joBf7");
function $3ca165408fdb63be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ca165408fdb63be$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $joBf7.default)((0, $hebmv.IconTitleWrapper), {
    target: "e15jjudo0"
})({
    name: "13xr8sz",
    styles: "vertical-align:text-bottom;padding:0px"
});

});


parcelRegister("mw0BG", function(module, exports) {

$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $39959ce8076595e7$export$ece47728c0503997);

var $7u4fN = parcelRequire("7u4fN");

var $f4A0J = parcelRequire("f4A0J");


var $kG7vW = parcelRequire("kG7vW");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $8BByu = parcelRequire("8BByu");

var $eNGDa = parcelRequire("eNGDa");

var $3JeIh = parcelRequire("3JeIh");

var $7P5BT = parcelRequire("7P5BT");

var $l2663 = parcelRequire("l2663");
const $39959ce8076595e7$var$FallbackUnauthorizedIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNGDa.AKIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), {
    label: "error",
    size: "small",
    primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
}));
class $39959ce8076595e7$export$ece47728c0503997 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { url: url, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showAuthTooltip: showAuthTooltip = false } = this.props;
        const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BByu.Frame), {
            testId: testId,
            isSelected: isSelected,
            ref: this.frameRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3JeIh.IconAndTitleLayout), {
            icon: icon ? icon : $39959ce8076595e7$var$FallbackUnauthorizedIcon,
            title: url,
            link: url,
            onClick: onClick,
            titleColor: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
        }), this.renderActionButton());
        if (onAuthorise && showAuthTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2663.HoverCard), {
            url: url,
            id: this.props.id
        }, inlineCardUnauthenticatedView);
        return inlineCardUnauthenticatedView;
    }
    constructor(...args){
        super(...args);
        this.frameRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.handleConnectAccount = (event)=>{
            const { analytics: analytics, extensionKey: extensionKey, onAuthorise: onAuthorise } = this.props;
            event.preventDefault();
            event.stopPropagation();
            if (onAuthorise) analytics?.track.appAccountAuthStarted({
                extensionKey: extensionKey
            });
            return onAuthorise();
        };
        this.renderActionButton = ()=>{
            const { onAuthorise: onAuthorise, context: context } = this.props;
            const ActionButton = (0, $kG7vW.default)((0, $7u4fN.default), this.frameRef);
            return onAuthorise ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ActionButton, {
                spacing: "none",
                component: (0, $7P5BT.IconStyledButton),
                onClick: this.handleConnectAccount,
                testId: "button-connect-account"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $4abrz.messages).connect_link_account_card_name,
                values: {
                    context: context
                }
            })) : undefined;
        };
    }
}

});

parcelRegister("6FBuV", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $f95a782975b3869b$export$61acb772777ef35d);

var $gqldc = parcelRequire("gqldc");
function $f95a782975b3869b$export$61acb772777ef35d(featureFlag) {
    const { featureFlags: featureFlags } = (0, $gqldc.useSmartLinkContext)();
    return featureFlags && featureFlags[featureFlag];
}

});


parcelRegister("lTJB1", function(module, exports) {

$parcel$export(module.exports, "EmbedCard", () => $8a8c81179b74e4dd$export$6789d7ecdc77631b);

var $eUqFw = parcelRequire("eUqFw");

var $8tvRs = parcelRequire("8tvRs");

var $eHVdh = parcelRequire("eHVdh");

var $7pH5u = parcelRequire("7pH5u");

var $eUl4s = parcelRequire("eUl4s");

var $9Eiuw = parcelRequire("9Eiuw");

var $269iK = parcelRequire("269iK");
parcelRequire("0fper");
var $ews4K = parcelRequire("ews4K");
var $gKAQ5 = parcelRequire("gKAQ5");

var $awzhz = parcelRequire("awzhz");

var $eaxNb = parcelRequire("eaxNb");

var $19jzv = parcelRequire("19jzv");

var $d01Am = parcelRequire("d01Am");

var $4xRvR = parcelRequire("4xRvR");

var $2xNYE = parcelRequire("2xNYE");

var $bFzGY = parcelRequire("bFzGY");
const $8a8c81179b74e4dd$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ url: url, cardState: { status: status, details: details }, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, analytics: analytics, handleInvoke: handleInvoke, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, iframeUrlType: iframeUrlType, actionOptions: actionOptions }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const data = details && details.data || (0, $7pH5u.getEmptyJsonLd)();
    const meta = details && details.meta;
    const extensionKey = (0, $269iK.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $269iK.hasAuthScopeOverrides)(details);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gKAQ5.ResolvingView), {
                testId: "embed-card-resolving-view",
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
        case 'resolved':
            const resolvedViewProps = (0, $eHVdh.extractEmbedProps)(data, meta, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio
            });
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eaxNb.EmbedCardResolvedView), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                testId: testId
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $eUl4s.extractInlineProps)(data);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $awzhz.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                const resolvedBlockViewProps = (0, $9Eiuw.extractBlockProps)(data, meta, {
                    analytics: analytics,
                    origin: 'smartLinkEmbed',
                    handleInvoke: handleInvoke,
                    extensionKey: extensionKey,
                    actionOptions: actionOptions
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ews4K.ResolvedView), {
                    ...resolvedBlockViewProps,
                    isSelected: isSelected,
                    testId: testId,
                    onClick: handleFrameClick
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $eHVdh.extractEmbedProps)(data, meta, platform);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xNYE.default), {
                analytics: analytics,
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $eHVdh.extractEmbedProps)(data, meta, platform);
            const cardMetadata = details?.meta ?? (0, $7pH5u.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eaxNb.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef
            });
            const forbiddenAccessContext = (0, $8tvRs.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d01Am.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $eHVdh.extractEmbedProps)(data, meta, platform);
            const notFoundAccessContext = details?.meta ? (0, $8tvRs.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4xRvR.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $19jzv.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("eHVdh", function(module, exports) {

$parcel$export(module.exports, "extractEmbedProps", () => $098ac8681507736b$export$d6cf81ca6e68bcc3);

var $lnW6z = parcelRequire("lnW6z");
var $fQDHB = parcelRequire("fQDHB");
var $ebCNT = parcelRequire("ebCNT");
var $a4gSw = parcelRequire("a4gSw");
var $amPw7 = parcelRequire("amPw7");

var $5fK3A = parcelRequire("5fK3A");

var $dB5lQ = parcelRequire("dB5lQ");

var $4afqa = parcelRequire("4afqa");
const $098ac8681507736b$var$extractEmbedPreview = (jsonLd, platform, iframeUrlType)=>{
    const preview = (0, $fQDHB.extractPreview)(jsonLd, platform, iframeUrlType);
    if (preview && preview.src) return {
        ...preview,
        src: preview.src
    };
};
function $098ac8681507736b$var$generateContext(jsonLd) {
    const provider = (0, $ebCNT.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $4afqa.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $amPw7.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $ebCNT.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
const $098ac8681507736b$export$d6cf81ca6e68bcc3 = (jsonLd, meta, platform, iframeUrlType)=>({
        link: (0, $lnW6z.extractLink)(jsonLd) || '',
        title: (0, $a4gSw.extractTitle)(jsonLd),
        context: $098ac8681507736b$var$generateContext(jsonLd),
        preview: $098ac8681507736b$var$extractEmbedPreview(jsonLd, platform, iframeUrlType),
        isTrusted: (0, $5fK3A.extractIsTrusted)(meta),
        isSupportTheming: (0, $dB5lQ.extractIsSupportTheming)(meta)
    });

});

parcelRegister("eaxNb", function(module, exports) {

$parcel$export(module.exports, "EmbedCardResolvedView", () => $fb141f3670ff863a$export$30f3c6c32b384a8b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $fBftA = parcelRequire("fBftA");

var $eXWMG = parcelRequire("eXWMG");

var $51H1k = parcelRequire("51H1k");

var $4p8kg = parcelRequire("4p8kg");

var $4q38b = parcelRequire("4q38b");

var $9A6mL = parcelRequire("9A6mL");
const $fb141f3670ff863a$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ link: link, context: context, onClick: onClick, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, isSupportTheming: isSupportTheming }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
            label: "icon",
            LEGACY_size: "small",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    let icon = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51H1k.ImageIcon), {
            src: src,
            default: linkGlyph
        });
    }, [
        src,
        linkGlyph,
        iconFromContext
    ]);
    const themeState = (0, $4q38b.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $9A6mL.getPreviewUrlWithTheme)(previewUrl, themeState);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eXWMG.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        inheritDimensions: inheritDimensions,
        setOverflow: false
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4p8kg.Frame), {
        url: previewUrl,
        isTrusted: isTrusted,
        testId: testId,
        ref: embedIframeRef,
        onIframeDwell: onIframeDwell,
        onIframeFocus: onIframeFocus,
        title: text
    }));
});

});
parcelRegister("eXWMG", function(module, exports) {

$parcel$export(module.exports, "ExpandedFrame", () => $6526c82edafb1144$export$7b360cd785b6c366);

var $eUqFw = parcelRequire("eUqFw");

var $fZ0gi = parcelRequire("fZ0gi");

var $lhgZW = parcelRequire("lhgZW");

var $8sbpW = parcelRequire("8sbpW");

var $8cU5f = parcelRequire("8cU5f");
const $6526c82edafb1144$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $lhgZW.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $8sbpW.useMouseDownEvent)();
    const renderHeader = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.Header), {
            className: "embed-header",
            frameStyle: frameStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.IconWrapper), {
            isPlaceholder: isPlaceholder
        }, !isPlaceholder && icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.TooltipWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: text,
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.TextWrapper), {
            isPlaceholder: isPlaceholder
        }, !isPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: href,
            onClick: handleClick,
            onMouseDown: handleMouseDown
        }, text)))));
    const renderContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.Content), {
            "data-testid": "embed-content-wrapper",
            allowScrollBar: allowScrollBar,
            removeOverflow: !setOverflow,
            isInteractive: isInteractive(),
            frameStyle: frameStyle,
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: 'false',
            suppressContentEditableWarning: true
        }, children);
    if (!isPlaceholder && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.LinkWrapper), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fZ0gi.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        frameStyle: frameStyle,
        minWidth: minWidth,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        inheritDimensions: inheritDimensions
    }, renderHeader(), renderContent());
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.Wrapper), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $fZ0gi.className),
        isInteractive: isInteractive(),
        isSelected: isSelected,
        minWidth: minWidth,
        frameStyle: frameStyle,
        maxWidth: maxWidth,
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        "data-wrapper-type": "default",
        "data-is-interactive": isInteractive()
    }, renderHeader(), renderContent());
};

});
parcelRegister("fZ0gi", function(module, exports) {

$parcel$export(module.exports, "className", () => $a1a9ae604665a308$export$2913c0c0b5623090);
$parcel$export(module.exports, "LinkWrapper", () => $a1a9ae604665a308$export$ce4b6a469c26f53f);
$parcel$export(module.exports, "Wrapper", () => $a1a9ae604665a308$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "embedHeaderHeight", () => $a1a9ae604665a308$export$8f5a73ba0d077b01);
$parcel$export(module.exports, "Header", () => $a1a9ae604665a308$export$8b251419efc915eb);
$parcel$export(module.exports, "IconWrapper", () => $a1a9ae604665a308$export$be58b4326e23250f);
$parcel$export(module.exports, "TextWrapper", () => $a1a9ae604665a308$export$7c3018f441722857);
$parcel$export(module.exports, "TooltipWrapper", () => $a1a9ae604665a308$export$57a09c4864b20b90);
$parcel$export(module.exports, "Content", () => $a1a9ae604665a308$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "Image", () => $a1a9ae604665a308$export$3e431a229df88919);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lcnyw = parcelRequire("lcnyw");


var $6RKe7 = parcelRequire("6RKe7");

var $joBf7 = parcelRequire("joBf7");
function $a1a9ae604665a308$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1a9ae604665a308$export$2913c0c0b5623090 = 'media-card-frame';
const $a1a9ae604665a308$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-border-radius, 3px)"};
`;
const $a1a9ae604665a308$var$wrapperBorderRadius = `
  border-radius: ${"var(--ds-border-radius-200, 8px)"};
`;
const $a1a9ae604665a308$var$contentBorderRadius = `
  border-radius: ${"var(--ds-border-radius-100, 4px)"};
`;
const $a1a9ae604665a308$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $a1a9ae604665a308$export$638459a7b797c6d9 = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
function $a1a9ae604665a308$var$minWidth({ minWidth: minWidth }) {
    if (minWidth) return `min-width: ${minWidth}px;`;
    else return '';
}
function $a1a9ae604665a308$var$maxWidth({ maxWidth: maxWidth }) {
    if (maxWidth) return `max-width: ${maxWidth}px; margin: 0 auto;`;
    else return 'margin: 0 auto;';
}
function $a1a9ae604665a308$var$getInteractiveStyles({ isInteractive: isInteractive, frameStyle: frameStyle }) {
    return isInteractive ? `
      &:hover {
        ${frameStyle !== 'hide' && $a1a9ae604665a308$var$visibleStyles}

      }
      &:active {
        background-color: ${`var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`};
      }
    ` : '';
}
function $a1a9ae604665a308$var$selected({ isSelected: isSelected, frameStyle: frameStyle }) {
    return isSelected && frameStyle !== 'hide' ? `
    ${$a1a9ae604665a308$var$visibleStyles}
    &::after {
      cursor: pointer;
      box-shadow: 0 0 0 3px ${`var(--ds-border-selected, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`};
      content: '';
      border: none;
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      ${$a1a9ae604665a308$var$wrapperBorderRadius}
    }
    ` : isSelected && frameStyle === 'hide' ? $a1a9ae604665a308$var$contentBorderRadius : '';
}
const $a1a9ae604665a308$var$height = ({ inheritDimensions: inheritDimensions })=>inheritDimensions ? 'height: 100%;' : `height: ${(0, $6RKe7.gs)(54)}`;
const $a1a9ae604665a308$var$wrapperStyles = (props)=>`
  ${$a1a9ae604665a308$var$wrapperBorderRadius}
  ${$a1a9ae604665a308$var$minWidth(props)}
  ${$a1a9ae604665a308$var$maxWidth(props)}
  ${$a1a9ae604665a308$var$getInteractiveStyles(props)}
  ${$a1a9ae604665a308$var$visible(props)}
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
  font-family: ${(0, $lcnyw.fontFamily)()};
  width: 100%;
  user-select: none;
  line-height: initial;
  transition: background 0.3s;
  position: relative;
  ${$a1a9ae604665a308$var$height(props)};
  ${$a1a9ae604665a308$var$selected(props)}

  &:after {
    content: '';
    transition: background 0.3s, box-shadow 0.3s;
    position: absolute;
    height: calc(100% + ${"var(--ds-space-100, 8px)"});
    ${$a1a9ae604665a308$var$wrapperBorderRadius}

    ${$a1a9ae604665a308$var$wrapperSizing(props)}
  }
`;
// if frameStyle !== 'show' then set the width of the frame to be
// 100% of the content +16px and position it left -8px to make it appear
// outside the container
const $a1a9ae604665a308$var$wrapperSizing = ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
    box-sizing: border-box;
    width: 100%;` : `
    width: calc(100% + ${"var(--ds-space-200, 16px)"});
    left: ${"var(--ds-space-negative-100, -8px)"};`;
const $a1a9ae604665a308$var$visibleStyles = `
  &:after {
    border: 1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`};
    background-color: ${"var(--ds-surface-raised, white)"};
  }
  .embed-header {
    opacity: 1;
  }`;
function $a1a9ae604665a308$var$visible({ frameStyle: frameStyle }) {
    return frameStyle === 'show' ? $a1a9ae604665a308$var$visibleStyles : '';
}
const $a1a9ae604665a308$export$ce4b6a469c26f53f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje16"
})((props)=>$a1a9ae604665a308$var$wrapperStyles(props), " &:hover{text-decoration:none;}");
const $a1a9ae604665a308$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje15"
})((props)=>$a1a9ae604665a308$var$wrapperStyles(props), "margin-top:10px;");
const $a1a9ae604665a308$export$8f5a73ba0d077b01 = 32;
const $a1a9ae604665a308$export$8b251419efc915eb = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje14"
})({
    height: `${$a1a9ae604665a308$export$8f5a73ba0d077b01}px`,
    position: 'absolute',
    zIndex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-icon, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    opacity: 0,
    transition: '300ms opacity cubic-bezier(0.15, 1, 0.3, 1)'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
        box-sizing: border-box;
        padding: 0 ${"var(--ds-space-100, 8px)"};
      ` : '');
const $a1a9ae604665a308$export$be58b4326e23250f = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje13"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$7a57f79000377ca2, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$638459a7b797c6d9(16), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isPlaceholder: isPlaceholder })=>{
    if (isPlaceholder) return `
			${''}
      background-color: ${`var(--ds-skeleton, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
    `;
    else return '';
}, "margin-right:var(--ds-space-050, 4px);");
const $a1a9ae604665a308$export$7c3018f441722857 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje12"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isPlaceholder: isPlaceholder })=>{
    if (isPlaceholder) return `
        ${$a1a9ae604665a308$export$7a57f79000377ca2}
        width: 125px;
        height: 12px;
${''}
        background-color: ${`var(--ds-skeleton, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`};
      `;
    else return '';
}, {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    fontSize: '12px',
    lineHeight: '16px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$a5b94313d6908893('none'));
const $a1a9ae604665a308$export$57a09c4864b20b90 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje11"
})({
    name: "d3v9zr",
    styles: "overflow:hidden"
});
const $a1a9ae604665a308$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje10"
})($a1a9ae604665a308$var$contentBorderRadius, ";border:1px solid ", `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`, ";background-color:var(--ds-surface-raised, white);position:absolute;z-index:1;width:100%;transition:box-shadow 0.3s;>.calc-height>div>div{left:unset!important;width:unset!important;height:unset!important;position:initial!important;padding-bottom:unset!important;}>.embed-preview>div{margin:0 auto;}", ({ allowScrollBar: allowScrollBar, removeOverflow: removeOverflow })=>{
    if (removeOverflow) return '';
    return allowScrollBar ? 'overflow: auto;' : 'overflow: hidden;';
}, " ", ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
        width: calc(100% - ${"var(--ds-space-200, 16px)"} - 2px);
        margin: 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"};
      ` : '', " ", ({ frameStyle: frameStyle })=>frameStyle === 'hide' ? 'height: 100%;' : `
        height: calc(100% - ${"var(--ds-space-400, 32px)"});
        top: ${"var(--ds-space-400, 32px)"};
      `, ";");
const $a1a9ae604665a308$export$3e431a229df88919 = /*#__PURE__*/ (0, $joBf7.default)("img", {
    target: "ehaugje9"
})(({ size: size })=>$a1a9ae604665a308$export$638459a7b797c6d9(size), $a1a9ae604665a308$export$7a57f79000377ca2, "overflow:hidden;");
const $a1a9ae604665a308$export$44c5ff44c97c3eb9 = 6;
const $a1a9ae604665a308$export$6ce170286acaa8d3 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje8"
})({
    display: 'flex',
    flexDirection: 'row',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"}`
});
const $a1a9ae604665a308$export$f99233281efd08a0 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje7"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.25,
    maxHeight: `${80}px`,
    overflow: 'hidden'
});
const $a1a9ae604665a308$export$5a6ed0c4143add76 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje6"
})({
    marginTop: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: 16 / 12
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
$a1a9ae604665a308$export$a5b94313d6908893('100%'));
const $a1a9ae604665a308$export$393edc798c47379d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje5"
})({
    marginTop: `calc(${"var(--ds-space-100, 8px)"} - 1px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$73a5c9d720aa66e1$export$7d61b15e0da132af})`,
    fontSize: '12px',
    fontWeight: 'normal',
    lineHeight: 1.5,
    maxHeight: `${54}px`,
    overflow: 'hidden'
});
const $a1a9ae604665a308$export$c2b5f712dd9d455 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje4"
})({
    name: "lvkd1z",
    styles: "margin-top:var(--ds-space-050, 4px)"
});
const $a1a9ae604665a308$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje3"
})($a1a9ae604665a308$export$7a57f79000377ca2, $a1a9ae604665a308$export$638459a7b797c6d9(48), (props)=>({
        float: 'right',
        margin: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${$73a5c9d720aa66e1$export$3e51e8f1440314ba})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundImage: `url(${props.src})`,
        backgroundSize: 'cover'
    }));
const $a1a9ae604665a308$export$106ae874379523d = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje2"
})({
    name: "uv0shy",
    styles: "margin-top:var(--ds-space-100, 8px)"
});
const $a1a9ae604665a308$export$c8223871eecc8f3a = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje1"
})({
    name: "263ie8",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:right;> *{margin-top:var(--ds-space-050, 4px);}> * + *{margin-left:var(--ds-space-050, 4px);}"
});
const $a1a9ae604665a308$export$f1129e9be7945b65 = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ehaugje0"
})({
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: $a1a9ae604665a308$export$44c5ff44c97c3eb9 + 1
});

});


parcelRegister("51H1k", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $52d2273440a73a38$export$4a122bafaa48b23d);

var $eUqFw = parcelRequire("eUqFw");

var $cRPaW = parcelRequire("cRPaW");

var $fZ0gi = parcelRequire("fZ0gi");
const $52d2273440a73a38$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon })=>{
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cRPaW))), {
        src: src,
        loading: defaultIcon,
        loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fZ0gi.Image), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "smart-link-icon",
            src: src,
            alt: alt,
            size: size,
            title: title
        }),
        errored: defaultIcon
    });
};

});

parcelRegister("4p8kg", function(module, exports) {

$parcel$export(module.exports, "Frame", () => $f169b6e819586f86$export$b89a827e9254211a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $9A6mL = parcelRequire("9A6mL");

var $9ecKV = parcelRequire("9ecKV");

var $6YgFd = parcelRequire("6YgFd");
function $f169b6e819586f86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $f169b6e819586f86$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $f169b6e819586f86$var$iframeStyles = {
    name: "1upos0b",
    styles: "border:0;top:0;left:0;width:100%;height:100%;position:relative;overflow:hidden;border-radius:3px"
};
const $f169b6e819586f86$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, title: title }, iframeRef)=>{
    (0, $asu8X.di)((0, $6YgFd.IFrame));
    const [isIframeLoaded, setIframeLoaded] = (0, $eUqFw.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $eUqFw.useState)(false);
    const [isWindowFocused, setWindowFocused] = (0, $eUqFw.useState)(true);
    const ref = (0, $eUqFw.useRef)();
    const mergedRef = $f169b6e819586f86$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $eUqFw.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $eUqFw.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const onBlur = ()=>{
            setWindowFocused(false);
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9ecKV.IframeDwellTracker), {
        isIframeLoaded: isIframeLoaded,
        isMouseOver: isMouseOver,
        isWindowFocused: isWindowFocused,
        iframePercentVisible: percentVisible,
        onIframeDwell: onIframeDwell
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $6YgFd.IFrame), {
        childRef: mergedRef,
        src: url,
        "data-testid": `${testId}-frame`,
        "data-iframe-loaded": isIframeLoaded,
        css: $f169b6e819586f86$var$iframeStyles,
        onMouseEnter: ()=>setMouseOver(true),
        onMouseLeave: ()=>setMouseOver(false),
        allowFullScreen: true,
        scrolling: "yes",
        allow: "autoplay; encrypted-media; clipboard-write",
        onLoad: ()=>{
            setIframeLoaded(true);
        },
        sandbox: (0, $9A6mL.getIframeSandboxAttribute)(isTrusted),
        title: title
    }));
});

});
parcelRegister("9ecKV", function(module, exports) {

$parcel$export(module.exports, "IframeDwellTracker", () => $323701e31ac0a84d$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $323701e31ac0a84d$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $323701e31ac0a84d$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, isWindowFocused: isWindowFocused, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $eUqFw.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $eUqFw.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $eUqFw.useEffect)(()=>{
        if (dwell.time > 0 && $323701e31ac0a84d$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $eUqFw.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        if (isIframeLoaded && isMouseOver && isWindowFocused && iframePercentVisible > 0.75) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isWindowFocused,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});

parcelRegister("6YgFd", function(module, exports) {

$parcel$export(module.exports, "IFrame", () => $a1e0b0ce8fbb2a65$export$b32b5f1ee4493319);

var $eUqFw = parcelRequire("eUqFw");
const $a1e0b0ce8fbb2a65$export$b32b5f1ee4493319 = ({ childRef: childRef, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        ...props,
        ref: childRef
    });
};

});



parcelRegister("19jzv", function(module, exports) {

$parcel$export(module.exports, "EmbedCardErroredView", () => $e32130dd22d6819d$export$6819d845957344e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7u4fN = parcelRequire("7u4fN");

var $gw74N = parcelRequire("gw74N");

var $lcnyw = parcelRequire("lcnyw");


var $i5auj = parcelRequire("i5auj");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $6RKe7 = parcelRequire("6RKe7");
const $e32130dd22d6819d$var$messageStyles = /*#__PURE__*/ (0, $byn9U.css)({
    fontSize: `${(0, $lcnyw.fontSize)()}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $6RKe7.gs)(0.5),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $6RKe7.gs)(0.5),
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    // Fallback options.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxHeight: (0, $6RKe7.gs)(3)
});
const $e32130dd22d6819d$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $i5auj.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gw74N))), {
        LEGACY_size: "small",
        color: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
        label: "error-icon"
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $e32130dd22d6819d$var$messageStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).could_not_load_link)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        testId: "err-view-retry",
        appearance: "link",
        spacing: "none",
        onClick: onRetry
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).try_again)));

});

parcelRegister("d01Am", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9a152021bcb48ae$export$2e2bcd8739ae039);

var $7u4fN = parcelRequire("7u4fN");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9tpVZ = parcelRequire("9tpVZ");

var $5tq9f = parcelRequire("5tq9f");

var $1fLBA = parcelRequire("1fLBA");
const $d9a152021bcb48ae$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $eUqFw.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, hostname)
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
	 * if there is a request access context, but no action to perform, do not show any button.
	 * By default, a "Try another account" button shows, but with request access context, we don't
	 * want to encourage users to try another account, if their request is already pending, etc.
	 */ const button = (0, $eUqFw.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $9tpVZ.toMessage)((0, $4abrz.messages).try_another_account, callToActionMessageKey),
            values: values
        }));
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tq9f.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1fLBA.ForbiddenSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $9tpVZ.toMessage)((0, $4abrz.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $9tpVZ.toMessage)((0, $4abrz.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $d9a152021bcb48ae$export$2e2bcd8739ae039 = $d9a152021bcb48ae$var$ForbiddenView;

});
parcelRegister("5tq9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $36e3c08ceba71e0b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fBftA = parcelRequire("fBftA");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $6RKe7 = parcelRequire("6RKe7");

var $eXWMG = parcelRequire("eXWMG");

var $51H1k = parcelRequire("51H1k");
function $36e3c08ceba71e0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $36e3c08ceba71e0b$var$containerStyles = {
    name: "11llvpy",
    styles: "display:grid;height:inherit"
};
const $36e3c08ceba71e0b$var$contentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    padding: "var(--ds-space-200, 16px)",
    gap: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $6RKe7.gs)(50)
});
const $36e3c08ceba71e0b$var$descriptionStyles = {
    name: "u78g84",
    styles: "font-size:1em;text-align:center"
};
const $36e3c08ceba71e0b$var$imageStyles = {
    name: "ccj8lh",
    styles: "height:120px;width:180px;object-fit:contain;object-position:center center"
};
const $36e3c08ceba71e0b$var$titleStyles = {
    name: "ca0uo8",
    styles: "text-align:center;margin:0;padding:0"
};
const $36e3c08ceba71e0b$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $eUqFw.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51H1k.ImageIcon), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBftA))), {
                label: "icon",
                LEGACY_size: "small",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $eUqFw.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, $byn9U.jsx)("img", {
            css: $36e3c08ceba71e0b$var$imageStyles,
            "data-testid": imageTestId,
            src: imageUrlOrElement
        });
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $36e3c08ceba71e0b$var$imageStyles,
            "data-testid": imageTestId
        }, imageUrlOrElement);
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eXWMG.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $36e3c08ceba71e0b$var$containerStyles,
        "data-testid": `${testId}-unresolved-container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $36e3c08ceba71e0b$var$contentStyles
    }, image, /*#__PURE__*/ (0, $byn9U.jsx)("h2", {
        css: $36e3c08ceba71e0b$var$titleStyles,
        "data-testid": `${testId}-unresolved-title`
    }, title), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $36e3c08ceba71e0b$var$descriptionStyles,
        "data-testid": `${testId}-unresolved-description`
    }, description), button)));
};
var $36e3c08ceba71e0b$export$2e2bcd8739ae039 = $36e3c08ceba71e0b$var$UnresolvedView;

});

parcelRegister("1fLBA", function(module, exports) {

$parcel$export(module.exports, "ForbiddenSVG", () => $00d73f7c28472bee$export$f51768a4e7ff128);

var $eUqFw = parcelRequire("eUqFw");
const $00d73f7c28472bee$export$f51768a4e7ff128 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "a",
        gradientUnits: "userSpaceOnUse",
        x1: "49.4199",
        x2: "122.662",
        y1: "59.7673",
        y2: "59.7673"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#0065ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: ".2188",
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: ".5999",
        stopColor: "#2780ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
        fill: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
        fill: "#ff7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
        fill: "#344563"
    }));

});


parcelRegister("4xRvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab924e6576344f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $9tpVZ = parcelRequire("9tpVZ");

var $5tq9f = parcelRequire("5tq9f");

var $hkx4H = parcelRequire("hkx4H");
const $aab924e6576344f4$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $eUqFw.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tq9f.default), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hkx4H.NotFoundSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $9tpVZ.toMessage)((0, $4abrz.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $9tpVZ.toMessage)((0, $4abrz.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $aab924e6576344f4$export$2e2bcd8739ae039 = $aab924e6576344f4$var$NotFoundView;

});
parcelRegister("hkx4H", function(module, exports) {

$parcel$export(module.exports, "NotFoundSVG", () => $268938076b24b3f5$export$80542c1714a314c8);

var $eUqFw = parcelRequire("eUqFw");
const $268938076b24b3f5$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "1316.98",
        y1: "230.66",
        x2: "1396.36",
        y2: "230.66",
        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#6c798f"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "170.3",
        y1: "897.49",
        x2: "365.15",
        y2: "897.49",
        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.69",
        stopColor: "#fff",
        stopOpacity: "0.1"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("title", null, "Search error"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Objects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#cfd4db",
        d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "_Path_",
        "data-name": "<Path>",
        fill: "url(#linear-gradient)",
        d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#091e42",
        opacity: 0.1,
        d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#344563",
        d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "_Clipping_Path_",
        "data-name": "<Clipping Path>",
        fill: "#deebff",
        d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "_Path_2",
        "data-name": "<Path>",
        fill: "#b2d4ff",
        d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#cce0ff",
        d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "url(#linear-gradient-2)",
        d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        id: "_Path_3",
        "data-name": "<Path>",
        fill: "#5e6c84",
        points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#ffc400",
        d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "#ffc400",
        d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#344563",
        d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
    }))));

});


parcelRegister("2xNYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cab2f09e792bcc2$export$2e2bcd8739ae039);

var $7u4fN = parcelRequire("7u4fN");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4abrz = parcelRequire("4abrz");

var $eDeuK = parcelRequire("eDeuK");

var $5tq9f = parcelRequire("5tq9f");

var $jfHH2 = parcelRequire("jfHH2");
const $2cab2f09e792bcc2$var$UnauthorizedView = ({ analytics: analytics, context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const handleOnAuthorizeClick = (0, $eUqFw.useCallback)(()=>{
        if (onAuthorize) {
            analytics.track.appAccountAuthStarted({
                extensionKey: extensionKey
            });
            onAuthorize();
        }
    }, [
        onAuthorize,
        analytics.track,
        extensionKey
    ]);
    const content = (0, $eUqFw.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $4abrz.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eDeuK.default), {
                    analytics: analytics,
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $4abrz.messages).connect_unauthorised_account_action,
                    values: values
                }))
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $4abrz.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $4abrz.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).unauthorised_account_name_no_provider),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4abrz.messages).unauthorised_account_description_no_provider)
        };
    }, [
        analytics,
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5tq9f.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jfHH2.UnauthorizedSVG), null),
        testId: testId,
        text: context?.text
    });
};
var $2cab2f09e792bcc2$export$2e2bcd8739ae039 = $2cab2f09e792bcc2$var$UnauthorizedView;

});
parcelRegister("jfHH2", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedSVG", () => $8c98f28d05119cce$export$6526edaac83a8c90);

var $eUqFw = parcelRequire("eUqFw");
const $8c98f28d05119cce$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_1375_267)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        transform: "translate(0.870117 0.509766)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
        stroke: "url(#paint0_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
        fill: "#403294"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.25",
        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
        fill: "url(#paint1_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.25",
        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
        fill: "url(#paint2_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
        stroke: "url(#paint3_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.38",
        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
        fill: "url(#paint4_radial_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
        fill: "url(#paint5_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
        fill: "url(#paint6_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
        fill: "url(#paint7_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
        fill: "url(#paint8_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
        fill: "url(#paint9_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
        fill: "url(#paint10_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
        fill: "url(#paint11_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
        fill: "url(#paint12_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
        fill: "url(#paint13_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
        fill: "url(#paint14_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
        fill: "url(#paint15_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
        fill: "url(#paint16_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
        fill: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
        fill: "url(#paint17_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
        fill: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
        fill: "url(#paint18_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_1375_267",
        x1: "141.994",
        y1: "181.192",
        x2: "0.870117",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#C1C7D0",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint1_linear_1375_267",
        x1: "208.292",
        y1: "264.428",
        x2: "0.870117",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint2_linear_1375_267",
        x1: "357.327",
        y1: "264.428",
        x2: "564.748",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint3_linear_1375_267",
        x1: "423.624",
        y1: "181.192",
        x2: "564.748",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1724",
        stopColor: "#076AFF",
        stopOpacity: "0.8007"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.4145",
        stopColor: "#1976FF",
        stopOpacity: "0.5208"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6966",
        stopColor: "#378BFF",
        stopOpacity: "0.1947"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8651",
        stopColor: "#4C9AFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("radialGradient", {
        id: "paint4_radial_1375_267",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(285 99.0229) scale(96.5182)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1584",
        stopColor: "#FFE587",
        stopOpacity: "0.8416"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3589",
        stopColor: "#FFDA57",
        stopOpacity: "0.6411"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5498",
        stopColor: "#FFD031",
        stopOpacity: "0.4502"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.7256",
        stopColor: "#FFC916",
        stopOpacity: "0.2744"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8811",
        stopColor: "#FFC506",
        stopOpacity: "0.1189"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint5_linear_1375_267",
        x1: "346.074",
        y1: "98.8386",
        x2: "423.624",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint6_linear_1375_267",
        x1: "237.087",
        y1: "120.044",
        x2: "276.412",
        y2: "120.044",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint7_linear_1375_267",
        x1: "237.087",
        y1: "75.0106",
        x2: "276.412",
        y2: "75.0106",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint8_linear_1375_267",
        x1: "335.969",
        y1: "146.593",
        x2: "335.969",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint9_linear_1375_267",
        x1: "219.544",
        y1: "98.8386",
        x2: "141.994",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint10_linear_1375_267",
        x1: "229.65",
        y1: "146.593",
        x2: "229.65",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#F4F5F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint11_linear_1375_267",
        x1: "402.858",
        y1: "216.64",
        x2: "421.684",
        y2: "223.492",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8134",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.8713",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint12_linear_1375_267",
        x1: "376.968",
        y1: "157.139",
        x2: "433.936",
        y2: "157.139",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint13_linear_1375_267",
        x1: "289.638",
        y1: "45.0027",
        x2: "289.638",
        y2: "0.510323",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint14_linear_1375_267",
        x1: "262.238",
        y1: "36.2259",
        x2: "272.592",
        y2: "36.2259",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint15_linear_1375_267",
        x1: "259.6",
        y1: "180.859",
        x2: "259.6",
        y2: "141.017",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint16_linear_1375_267",
        x1: "284.971",
        y1: "171.613",
        x2: "284.971",
        y2: "149.45",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint17_linear_1375_267",
        x1: "157.982",
        y1: "221.995",
        x2: "188.627",
        y2: "221.995",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.3435",
        stopColor: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#998DD9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint18_linear_1375_267",
        x1: "163.185",
        y1: "155.517",
        x2: "213.758",
        y2: "155.517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#8777D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_1375_267"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        fill: "white",
        transform: "translate(0.870117 0.509766)"
    }))));

});




parcelRegister("fsWgj", function(module, exports) {

$parcel$export(module.exports, "LoadingCardLink", () => $b64cd29097fd54b5$export$1ca0544321134ad6);

var $eUqFw = parcelRequire("eUqFw");

var $4lXV3 = parcelRequire("4lXV3");

const $b64cd29097fd54b5$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4lXV3.CardLinkView), {
        key: 'lazy-render-key',
        testId: 'lazy-render-placeholder',
        "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
        isSelected: isSelected,
        link: url,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $02e88e077d3b3f54$export$4b2b7d155f69aed4),
        placeholder: placeholder
    });
};

});


parcelRegister("gYb4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $00f061e11a93671e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $00f061e11a93671e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noRepository: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-repository",
        "defaultMessage": "No repositories"
    },
    repositories: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.repositories.popup.heading",
        "defaultMessage": "Repositories"
    }
});

});

parcelRegister("4FVcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc2757374bcfeb1e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $hI5oG = parcelRequire("hI5oG");

var $3MV1G = parcelRequire("3MV1G");

var $lPrVW = parcelRequire("lPrVW");
var $hqABm = parcelRequire("hqABm");
var $4bEHq = parcelRequire("4bEHq");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gYb4e = parcelRequire("gYb4e");
const $fc2757374bcfeb1e$export$f5bfd0a3f83b1bb1 = 99;
const $fc2757374bcfeb1e$var$RepositoriesPopup = ({ repositories: repositories })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    if (repositories.length === 0) return null;
    const list = repositories.slice(0, $fc2757374bcfeb1e$export$f5bfd0a3f83b1bb1);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc2757374bcfeb1e$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc2757374bcfeb1e$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
            level: "h200"
        }, formatMessage((0, $gYb4e.default).repositories))), list.map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc2757374bcfeb1e$var$Row, {
                key: `repository-link[${link.id}]`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc2757374bcfeb1e$var$CardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPrVW.Card), {
                testId: "project-directories.components.compass-table.cells.repository.repository-links-popup.smart-link",
                url: link.url,
                appearance: "inline",
                placeholder: link.name || link.url,
                ui: {
                    hideBackground: true,
                    hideElevation: true,
                    hidePadding: true,
                    clickableContainer: true
                },
                onClick: ()=>{
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'link'
                    });
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'repositoryLink');
                },
                actionOptions: {
                    hide: false,
                    exclude: [
                        (0, $hqABm.CardAction).ChangeStatusAction
                    ]
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4bEHq.default), {
                text: link.name,
                maxLines: 1
            }))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        content: content,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fc2757374bcfeb1e$var$BadgeContainer, {
                ...triggerProps,
                onClick: ()=>{
                    setIsOpen(!isOpen);
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button'
                    });
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'repositoryLinkPopup');
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                testId: "project-directories.components.compass-table.cells.repository.repository-links-popup.badge-button",
                appearance: !isOpen ? undefined : 'primaryInverted'
            }, "+", list.length))
    });
};
var $fc2757374bcfeb1e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fc2757374bcfeb1e$var$RepositoriesPopup;
const $fc2757374bcfeb1e$var$BadgeContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _18s81vvs _ll8p16l4 _1lgi1prw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc2757374bcfeb1e$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb35xw _4t3i1osq _1yt4pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc2757374bcfeb1e$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrutpp _ngc0j3m3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc2757374bcfeb1e$var$CardContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4s8vo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc2757374bcfeb1e$var$Row = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb35xw _4t3i1ylp _otyru2gc _2rko1l7b _11q71cs6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lPrVW", function(module, exports) {

$parcel$export(module.exports, "Card", () => $78a7752e8d5385c2$export$60332b2344f7fe41);

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $en3x5 = parcelRequire("en3x5");

var $6VBvh = parcelRequire("6VBvh");

var $9A6mL = parcelRequire("9A6mL");

var $bTNMs = parcelRequire("bTNMs");

var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");
class $78a7752e8d5385c2$var$PlainCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const content = (0, $9A6mL.isCardWithData)(this.props) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $en3x5.CardWithDataRenderer), this.props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6VBvh.CardWithURLRenderer), this.props);
        return this.props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, content);
    }
}
const $78a7752e8d5385c2$export$60332b2344f7fe41 = (0, $1ngde.default)((0, $bTNMs.context))((0, $2jDha.default)()((0, $2qhQi.default)($78a7752e8d5385c2$var$PlainCard, {
    enforceContext: false
})));

});
parcelRegister("en3x5", function(module, exports) {

$parcel$export(module.exports, "CardWithDataRenderer", () => $d28fa1f36649938a$export$9d0e69e8740e5c1c);

var $eUqFw = parcelRequire("eUqFw");

class $d28fa1f36649938a$export$9d0e69e8740e5c1c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.CardContent = null;
    }
    static moduleImporter(target) {
        (parcelRequire("jPswi")).then((module)=>{
            $d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent = module.CardWithDataContent;
            target.forceUpdate();
        });
    }
    componentDidMount() {
        if ($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent === null) (this.props.importer || $d28fa1f36649938a$export$9d0e69e8740e5c1c.moduleImporter)(this);
    }
    render() {
        const { id: id, appearance: appearance, data: data, isSelected: isSelected, onClick: onClick, onResolve: onResolve, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle } = this.props;
        if (!data) throw new Error('@atlaskit/smart-cards: you are trying to render a card with data, but does not provide any');
        if ($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d28fa1f36649938a$export$9d0e69e8740e5c1c.CardContent, {
            id: id,
            inlinePreloaderStyle: inlinePreloaderStyle,
            appearance: appearance,
            data: data,
            isSelected: isSelected,
            onClick: onClick,
            onResolve: onResolve,
            testId: testId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-card-with-data": true
        });
    }
}

});
parcelRegister("jPswi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("g7aEm")
]).then(()=>parcelRequire('fqHYs'));

});


parcelRegister("6VBvh", function(module, exports) {

$parcel$export(module.exports, "CardWithURLRenderer", () => $aec66ec7aed7ad8a$export$e00a7788e30dc998);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $hEsGF = parcelRequire("hEsGF");

var $jb3WS = parcelRequire("jb3WS");

var $jtkmg = parcelRequire("jtkmg");

var $fsWgj = parcelRequire("fsWgj");

var $9A6mL = parcelRequire("9A6mL");

var $6oJXW = parcelRequire("6oJXW");

var $asu8X = parcelRequire("asu8X");

const $aec66ec7aed7ad8a$export$a7690c318cd6a95e = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(0, $9A6mL.importWithRetry)(()=>(parcelRequire("5SeSf"))));
function $aec66ec7aed7ad8a$export$e00a7788e30dc998(props) {
    (0, $asu8X.di)($aec66ec7aed7ad8a$export$a7690c318cd6a95e);
    const [id] = (0, $eUqFw.useState)(()=>props.id ? props.id : (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))());
    (0, $eUqFw.useEffect)(()=>{
        // ComponentWillUnmount
        return ()=>{
            (0, $hEsGF.clearMarks)(id);
            (0, $hEsGF.clearMeasures)(id);
        };
    }, [
        id
    ]);
    const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, isFrameVisible: isFrameVisible, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, showActions: showActions, showServerActions: showServerActions, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, analyticsEvents: analyticsEvents, placeholder: placeholder, fallbackComponent: fallbackComponent, useLegacyBlockCard: useLegacyBlockCard, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder } = props;
    const analytics = (0, $jtkmg.useSmartLinkAnalytics)(url ?? '', undefined, id);
    const isFlexibleUi = (0, $6oJXW.isFlexibleUiCard)(children);
    const errorHandler = (0, $eUqFw.useCallback)((error, info)=>{
        const { componentStack: componentStack } = info;
        const errorInfo = {
            componentStack: componentStack
        };
        // NB: APIErrors are thrown in response to Object Resolver Service. We do not
        // fire an event for these, as they do not cover failed UI render events.
        // The rest of the errors caught here are unexpected, and correlate
        // to the reliability of the smart-card front-end components.
        // Likewise, chunk loading errors are not caused by a failure of smart-card rendering.
        if (error.name === 'ChunkLoadError') analytics.operational.chunkloadFailedEvent({
            display: appearance,
            error: error,
            errorInfo: errorInfo
        });
        else if (error.name !== 'APIError') analytics.ui.renderFailedEvent({
            display: isFlexibleUi ? 'flexible' : appearance,
            id: id,
            error: error,
            errorInfo: errorInfo
        });
        onError && onError({
            status: 'errored',
            url: url ?? '',
            err: error
        });
    }, [
        analytics.operational,
        analytics.ui,
        appearance,
        id,
        onError,
        url,
        isFlexibleUi
    ]);
    if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
    const defaultFallBackComponent = ()=>null;
    const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
    const ErrorFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FallbackComponent, null);
    const cardWithUrlProps = {
        id: id,
        url: url,
        appearance: appearance,
        onClick: onClick,
        isSelected: isSelected,
        isHovered: isHovered,
        isFrameVisible: isFrameVisible,
        frameStyle: frameStyle,
        container: container,
        onResolve: onResolve,
        onError: onError,
        testId: testId,
        showActions: showActions,
        showServerActions: showServerActions,
        actionOptions: actionOptions,
        inheritDimensions: inheritDimensions,
        platform: platform,
        embedIframeRef: embedIframeRef,
        embedIframeUrlType: embedIframeUrlType,
        inlinePreloaderStyle: inlinePreloaderStyle,
        ui: ui,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        showAuthTooltip: showAuthTooltip,
        analyticsEvents: analyticsEvents,
        placeholder: placeholder,
        useLegacyBlockCard: useLegacyBlockCard,
        removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
        resolvingPlaceholder: resolvingPlaceholder
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb3WS.ErrorBoundary), {
        FallbackComponent: ErrorFallback,
        onError: errorHandler
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsWgj.LoadingCardLink), cardWithUrlProps)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aec66ec7aed7ad8a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
}

});
parcelRegister("5SeSf", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("jvifZ")
]).then(()=>parcelRequire('2lOE6'));

});





parcelRegister("3PIo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e14c3ba89ac26e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fANxH = parcelRequire("fANxH");

var $90IgZ = parcelRequire("90IgZ");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $eYuBj = parcelRequire("eYuBj");
const $92e14c3ba89ac26e$var$messages = (0, $90IgZ.defineMessages)({
    noScorecards: {
        "id": "project-pages-project-directories.components.view.compass-table.cell.no-scorecards",
        "defaultMessage": "No scorecards"
    }
});
function $92e14c3ba89ac26e$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, scorecardScores: scorecardScores } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (scorecardScores.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fANxH.default), {
        componentId: componentId,
        scorecardScores: scorecardScores,
        onClick: (_, analyticsEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'scorecardHealthLozenge');
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eYuBj.SubtleText), null, formatMessage($92e14c3ba89ac26e$var$messages.noScorecards));
}

});
parcelRegister("fANxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c5cbca2fa48a65$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $3MV1G = parcelRequire("3MV1G");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7DokK = parcelRequire("7DokK");

var $cmOhE = parcelRequire("cmOhE");
function $a5c5cbca2fa48a65$export$2e2bcd8739ae039(props) {
    const { componentId: componentId, scorecardScores: scorecardScores, onClick: onClick } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isLozengeHovered, setIsLozengeHovered] = (0, $eUqFw.useState)(false);
    const scorecardHealthCount = (0, $eUqFw.useMemo)(()=>(0, $7DokK.getScorecardHealthCountsFromScores)(scorecardScores), [
        scorecardScores
    ]);
    const summary = (0, $eUqFw.useMemo)(()=>(0, $7DokK.getSummaryText)(scorecardHealthCount, scorecardScores.length, formatMessage), [
        scorecardHealthCount,
        scorecardScores.length,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cmOhE.default), {
                componentId: componentId
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "none",
                onClick: (e, analyticsEvent)=>{
                    setIsOpen(!isOpen);
                    onClick?.(e, analyticsEvent);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                onMouseOver: ()=>{
                    setIsLozengeHovered(true);
                },
                onFocus: ()=>{
                    setIsLozengeHovered(true);
                },
                onMouseLeave: ()=>{
                    setIsLozengeHovered(false);
                },
                onBlur: ()=>{
                    // React uses onFocus and onBlur instead of onFocusIn and onFocusOut.
                    setIsLozengeHovered(false);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                isBold: isLozengeHovered,
                appearance: $a5c5cbca2fa48a65$var$getLozengeStyle(scorecardHealthCount)
            }, summary)))
    });
}
const $a5c5cbca2fa48a65$var$getLozengeStyle = (scorecardHealthCount)=>{
    if (scorecardHealthCount.passing + scorecardHealthCount.needsAttention < scorecardHealthCount.total) return 'removed';
    if (scorecardHealthCount.needsAttention > 0) return 'moved';
    return 'success';
};

});
parcelRegister("cmOhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec37dc126f53358b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $7DokK = parcelRequire("7DokK");

var $5Yb0e = parcelRequire("5Yb0e");

var $7Q0xw = parcelRequire("7Q0xw");

var $hM01o = parcelRequire("hM01o");

var $ebnaI = parcelRequire("ebnaI");

var $8DhCW = parcelRequire("8DhCW");

var $2etQC = parcelRequire("2etQC");
const $ec37dc126f53358b$var$NUMBER_OF_SCORECARDS_TO_DISPLAY = 5;
function $ec37dc126f53358b$export$2e2bcd8739ae039({ testId: testId, componentId: componentId }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { scorecards: scorecards, loading: loading, error: error } = (0, $5Yb0e.useGetComponentScorecards)(componentId);
    const scorecardsSortedByHealth = (0, $eUqFw.useMemo)(()=>(0, $7DokK.getScorecardsSortedByHealth)(scorecards), [
        scorecards
    ]);
    const handleViewMoreClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'scorecardsHealthInfoDetailsViewMore');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ContentWrapper, {
        "data-testid": testId
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebnaI.default), null), !loading && error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM01o.GenericErrorGlyph), {
        "data-testid": `${testId}.generic-error-glyph`
    })), !loading && !error && scorecardsSortedByHealth.slice(0, $ec37dc126f53358b$var$NUMBER_OF_SCORECARDS_TO_DISPLAY).map((scorecard, i)=>{
        const totalScore = scorecard?.scorecardScore?.totalScore ?? 0;
        const { id: scorecardId } = scorecard;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: scorecardId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ScorecardWrapper, {
            "data-testid": `${testId}-scorecard-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ScorecardInfoWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ScorecardName, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ScorecardButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: (_, analyticsEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'scorecardsHealthInfoDetailsScorecardName');
            },
            href: `/compass/scorecard/${(0, $7DokK.getIdFromAri)(scorecardId)}`,
            target: "_blank",
            rel: "noopener noreferrer",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $ec37dc126f53358b$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Q0xw.ScorecardGlyph), null))
        }, scorecard.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$ScorecardScore, null, totalScore, "%")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2etQC.default), {
            progress: totalScore,
            size: "medium",
            testId: `dragonfruit-scorecards.common.ui.progress-bar-${scorecardId}`
        })));
    }), !error && scorecards.length > $ec37dc126f53358b$var$NUMBER_OF_SCORECARDS_TO_DISPLAY && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ec37dc126f53358b$var$LinkWrapper, {
        href: `/compass/component/${(0, $7DokK.getIdFromAri)(componentId)}`,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: handleViewMoreClick
    }, formatMessage((0, $8DhCW.default).viewMore)));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbncxg _1tke1ul9 _1yt4u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ScorecardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_iv8mpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ScorecardInfoWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ScorecardName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _1yyjt94y _sudp1e54",
            __cmplp.className
        ])
    });
});
const $ec37dc126f53358b$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingRight: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ScorecardButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tjq16l4 _9n9ov77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ScorecardScore = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _ca0qv77o _11c81il0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$LinkWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _19pkpxbi _k48pbfng _syaz1fxt _30l31fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ec37dc126f53358b$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5Yb0e", function(module, exports) {

$parcel$export(module.exports, "useGetComponentScorecards", () => $3e1ee3ca5c9b9646$export$be1e628de8d400bd);

var $eUqFw = parcelRequire("eUqFw");

var $5UFhP = parcelRequire("5UFhP");

var $bOnup = parcelRequire("bOnup");
const $3e1ee3ca5c9b9646$export$be1e628de8d400bd = (componentId)=>{
    const { data: data, loading: loading, error: error } = (0, $5UFhP.useFetchQuery)((0, $bOnup.GET_COMPASS_COMPONENTS_SCORECARDS_QUERY), {
        componentId: componentId
    });
    const scorecards = (0, $eUqFw.useMemo)(()=>{
        if (!loading && data?.compass?.component?.__typename === 'CompassComponent') {
            const dataFields = data.compass.component.scorecards ?? [];
            return dataFields?.map((field)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                ({
                    id: field?.id ?? '',
                    name: field?.name ?? '',
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    scorecardScore: {
                        totalScore: field.scorecardScore?.totalScore ?? 0,
                        maxTotalScore: field.scorecardScore?.maxTotalScore ?? 0
                    }
                }));
        }
        return [];
    }, [
        data,
        loading
    ]);
    return {
        scorecards: scorecards,
        loading: loading,
        error: error
    };
};

});
parcelRegister("bOnup", function(module, exports) {

$parcel$export(module.exports, "GET_COMPASS_COMPONENTS_SCORECARDS_QUERY", () => $be6056adb754a02f$export$c0ea2bb8dbfa2db2);

var $jxb57 = parcelRequire("jxb57");
const $be6056adb754a02f$export$c0ea2bb8dbfa2db2 = (0, $jxb57.default);

});
parcelRegister("jxb57", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aeb3210709ffce8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b3837d707aafd2a7f012f61b4f1ee49>>
 * @relayHash f4d93a10161f753ed411c57f86bc98b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 741085e8b23798a8dea5abf455b5ad9a47688f5582ab4767b090a8458bd06bc9
const $0aeb3210709ffce8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "componentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "componentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            {
                "concreteType": "CompassScorecard",
                "kind": "LinkedField",
                "name": "scorecards",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    v3 /*: any*/ ,
                    {
                        "args": [
                            {
                                "fields": [
                                    {
                                        "kind": "Variable",
                                        "name": "componentId",
                                        "variableName": "componentId"
                                    }
                                ],
                                "kind": "ObjectValue",
                                "name": "query"
                            }
                        ],
                        "concreteType": "CompassScorecardScore",
                        "kind": "LinkedField",
                        "name": "scorecardScore",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "totalScore"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "maxTotalScore"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "CompassComponent"
    }, v6 = {
        "kind": "ScalarField",
        "name": "message"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "gqlGetComponentScorecardsQuery",
            "selections": [
                {
                    "concreteType": "CompassCatalogQueryApi",
                    "kind": "LinkedField",
                    "name": "compass",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "gqlGetComponentScorecardsQuery",
            "selections": [
                {
                    "concreteType": "CompassCatalogQueryApi",
                    "kind": "LinkedField",
                    "name": "compass",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "component",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "741085e8b23798a8dea5abf455b5ad9a47688f5582ab4767b090a8458bd06bc9",
            "metadata": {},
            "name": "gqlGetComponentScorecardsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0aeb3210709ffce8$var$node.hash = "bc264e75c2067aab1548341100b3d8c5";
var $0aeb3210709ffce8$export$2e2bcd8739ae039 = $0aeb3210709ffce8$var$node;

});



parcelRegister("7Q0xw", function(module, exports) {

$parcel$export(module.exports, "ScorecardGlyph", () => $2fd23303b2e1b1b2$export$7d48f4d7960794bf);

var $eUqFw = parcelRequire("eUqFw");
function $2fd23303b2e1b1b2$export$7d48f4d7960794bf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16.4188 11.9992C15.6081 14.0027 14.0093 15.603 12.0069 16.4157",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 7L8 11L6 9",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
    }));
}

});

parcelRegister("hM01o", function(module, exports) {

$parcel$export(module.exports, "GenericErrorGlyph", () => $295928a853928524$export$1e65f4e15a4452f7);
// We are disabling the design rules because the "fill" attributes of the svg require a token that is not currently available for white

var $eUqFw = parcelRequire("eUqFw");
function $295928a853928524$export$1e65f4e15a4452f7(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "164",
        height: "212",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        "clip-path": "url(#clip0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white",
        "fill-opacity": "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
        fill: "url(#paint0_linear)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
        fill: "#C1C7D0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.6",
        d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
        fill: "#B3BAC5"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear",
        x1: "26.1692",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        "stop-color": "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.297",
        "stop-color": "#C6CBD4",
        "stop-opacity": "0.8812"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.6301",
        "stop-color": "#D3D7DE",
        "stop-opacity": "0.748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.9795",
        "stop-color": "#E9EBEF",
        "stop-opacity": "0.6082"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        "stop-color": "#EBECF0",
        "stop-opacity": "0.6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.649902 0H163.93V212H0.649902V0Z",
        fill: "white"
    }))));
}

});

parcelRegister("ebnaI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6420357e627b025c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
function $6420357e627b025c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6420357e627b025c$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), props));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6420357e627b025c$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8DhCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $92153a490538437d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $92153a490538437d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewMore: {
        "id": "compass-common.scorecards-health-lozenge.popup-content.view-more",
        "defaultMessage": "View more"
    }
});

});

parcelRegister("2etQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b2a9e5c189d202$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7DokK = parcelRequire("7DokK");
function $83b2a9e5c189d202$export$2e2bcd8739ae039({ testId: testId, progress: progress, size: size = 'small' }) {
    const curProgress = Math.max(0, Math.min(progress, 100));
    const progressColor = (0, $7DokK.getColorForProgress)(curProgress);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83b2a9e5c189d202$var$ProgressBarWrapper, {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83b2a9e5c189d202$var$Bar, {
        "data-testid": testId,
        width: curProgress,
        background: progressColor,
        size: size
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83b2a9e5c189d202$var$ProgressBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7b5v6 _2rko1l7b _1reo15vq _18m915vq _kqswh2mm _1bsb1osq",
            __cmplp.size === 'small' ? "_4t3i1b66" : "_4t3iu2gc",
            __cmplp.className
        ])
    });
});
const $83b2a9e5c189d202$var$Bar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { background: background, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_146l9hq": (0, $9t7rW.default)(__cmplp.background),
            "--_1y04s53": (0, $9t7rW.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _1e0c1ule _kqswstnw _11q71i36 _v564calv _1bsb1mcm",
            __cmplp.size === 'small' ? "_4t3i1b66" : "_4t3iu2gc",
            __cmplp.className
        ])
    });
});

});




parcelRegister("kPcWn", function(module, exports) {

$parcel$export(module.exports, "ComponentsTableErrorState", () => $842c240edd0ea699$export$ac3671872e9d0a72);
/* components-table-error-state.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $5pFmj = parcelRequire("5pFmj");

var $i90hj = parcelRequire("i90hj");
function $842c240edd0ea699$export$ac3671872e9d0a72({ testId: testId }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const reloadButtonTestId = testId && `${testId}-reload-button`;
    const handleReloadClick = (0, $eUqFw.useCallback)((_, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'compassComponentsTableErrorStateReload');
        window.location.reload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($842c240edd0ea699$var$Container, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.400",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $842c240edd0ea699$var$errorStateImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5pFmj.ErrorStateImage), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($842c240edd0ea699$var$Heading, null, formatMessage((0, $i90hj.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $842c240edd0ea699$var$bodyStyles
    }, formatMessage((0, $i90hj.default).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: reloadButtonTestId,
        appearance: "primary",
        onClick: handleReloadClick
    }, formatMessage((0, $i90hj.default).reload)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $842c240edd0ea699$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ogm",
            __cmplp.className
        ])
    });
});
const $842c240edd0ea699$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81doa _k48pni7l _vwz4gktf _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $842c240edd0ea699$var$bodyStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});
const $842c240edd0ea699$var$errorStateImageWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.500'
});

});
parcelRegister("5pFmj", function(module, exports) {

$parcel$export(module.exports, "ErrorStateImage", () => $cfbe4c01265b7946$export$69a679459027c35e);

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $iwvVo = parcelRequire("iwvVo");
const $cfbe4c01265b7946$export$69a679459027c35e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iwvVo))),
        alt: "",
        width: 171.25
    });

});
parcelRegister("iwvVo", function(module, exports) {
module.exports = new URL("error-state.7a6adba2.svg", import.meta.url).toString();

});


parcelRegister("i90hj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b46a174154cac4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b3b46a174154cac4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "compass-common.components-table-error-state.heading-non-final",
        "defaultMessage": "We're having trouble showing Compass components"
    },
    body: {
        "id": "compass-common.components-table-error-state.body-non-final",
        "defaultMessage": "Reloading the page might resolve this issue."
    },
    reload: {
        "id": "compass-common.components-table-empty-state.reload-non-final",
        "defaultMessage": "Reload"
    }
});

});


parcelRegister("eWSMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a06c740e8bbaaf5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a06c740e8bbaaf5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    componentHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.component-head",
        "defaultMessage": "Component"
    },
    ownerTeamHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.owner-team-head",
        "defaultMessage": "Owner team"
    },
    repositoryHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.repository-head",
        "defaultMessage": "Repository"
    },
    dependenciesHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.dependencies-head",
        "defaultMessage": "Dependencies"
    },
    scorecardHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.scorecard-head",
        "defaultMessage": "Scorecards"
    },
    issuesHeader: {
        "id": "project-pages-project-directories.components.view.compass-table.issues-head",
        "defaultMessage": "Issues"
    },
    componentCount: {
        "id": "project-pages-project-directories.components.view.compass-table.component-count",
        "defaultMessage": "{componentCount, plural, one {# component} other {# components}} linked to project"
    },
    componentInfo: {
        "id": "project-pages-project-directories.components.view.compass-table.component-info",
        "defaultMessage": "Compass components appear here when they\u2019re added to an issue\u2019s <bold>Components</bold> field. <link>Learn more</link>"
    }
});

});


parcelRegister("bGdP7", function(module, exports) {

$parcel$export(module.exports, "RequestAccessState", () => $da0c6eb16540cf02$export$bc16bfb757adb731);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");

var $bW292 = parcelRequire("bW292");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $gd0Sp = parcelRequire("gd0Sp");

var $b8o6H = parcelRequire("b8o6H");

var $iLlj2 = parcelRequire("iLlj2");
const $da0c6eb16540cf02$var$COMPASS_SITE_ARI_PREFIX = 'ari:cloud:compass::site';
function $da0c6eb16540cf02$var$compassSiteAriFor(cloudId) {
    return `${$da0c6eb16540cf02$var$COMPASS_SITE_ARI_PREFIX}/${cloudId}`;
}
function $da0c6eb16540cf02$var$getUserUpsellUrl(cloudId) {
    const compassResourceAri = $da0c6eb16540cf02$var$compassSiteAriFor(cloudId);
    const continueUrl = window.location.href;
    return `${(0, $bW292.getATLContextUrl)('id')}/join/user-access?resource=${encodeURIComponent(compassResourceAri)}&continue=${encodeURIComponent(continueUrl)}`;
}
const $da0c6eb16540cf02$export$bc16bfb757adb731 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const upsellUrl = $da0c6eb16540cf02$var$getUserUpsellUrl(cloudId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "componentsTableRequestAccessState"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        eventName: "viewed componentsTableRequestAccessState"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $da0c6eb16540cf02$var$contentStyles,
        alignBlock: "center",
        testId: "project-directories.components.compass-table.request-access-state.request-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b8o6H.RequestAccessImage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da0c6eb16540cf02$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da0c6eb16540cf02$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $iLlj2.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $da0c6eb16540cf02$var$descriptionStyles
    }, formatMessage((0, $iLlj2.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        target: "_blank",
        href: upsellUrl,
        onClick: (_, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'compassRequestAccessUpSell');
        }
    }, formatMessage((0, $iLlj2.default).requestAccessButtonText)))));
};
const $da0c6eb16540cf02$var$contentStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '700px',
    marginTop: 'space.1000',
    marginBottom: 'space.250',
    marginLeft: 'auto',
    marginRight: 'auto'
});
const $da0c6eb16540cf02$var$headingStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.250'
});
const $da0c6eb16540cf02$var$descriptionStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- PLEASE FIX - ENABLING FLAT LINT CONFIG
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    lineHeight: '20px',
    paddingTop: 'space.250',
    paddingBottom: 'space.250'
});
const $da0c6eb16540cf02$var$textStyles = (0, $1ZAYh.xcss)({
    maxWidth: '500px',
    color: 'color.text.subtle'
});

});
parcelRegister("b8o6H", function(module, exports) {

$parcel$export(module.exports, "RequestAccessImage", () => $86dfe913d415d528$export$cb181e9b99786285);

var $eUqFw = parcelRequire("eUqFw");

var $iFmgL = parcelRequire("iFmgL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iLlj2 = parcelRequire("iLlj2");

var $cNcZw = parcelRequire("cNcZw");
const $86dfe913d415d528$export$cb181e9b99786285 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFmgL.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cNcZw))),
        alt: formatMessage((0, $iLlj2.default).requestAccessAltText)
    });
};

});
parcelRegister("iLlj2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e61d0a03b2333b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e61d0a03b2333b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-directories.components.common.request-access.heading",
        "defaultMessage": "You don\u2019t have access to Compass components"
    },
    description: {
        "id": "project-directories.components.common.request-access.description",
        "defaultMessage": "Ask your admin to give you access to Compass, so you can track the work your team is doing on components of your software architecture."
    },
    requestAccessButtonText: {
        "id": "project-directories.components.common.request-access.button-text",
        "defaultMessage": "Request access"
    },
    requestAccessAltText: {
        "id": "project-directories.components.common.request-access.image-alt-text",
        "defaultMessage": "Request access to Compass"
    }
});

});

parcelRegister("cNcZw", function(module, exports) {
module.exports = new URL("request-access-lock.c6207860.svg", import.meta.url).toString();

});




parcelRegister("eWUpw", function(module, exports) {

$parcel$export(module.exports, "CompassTableCrossflowTouchPointWithEC", () => $800cda728baae786$export$6d86b5ae49a52ead);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $eeqbM = parcelRequire("eeqbM");
var $35p9r = parcelRequire("35p9r");

var $plbOU = parcelRequire("plbOU");

var $kvCU2 = parcelRequire("kvCU2");

var $9rkMO = parcelRequire("9rkMO");
const $800cda728baae786$var$CompassTableCrossflowTouchPoint = (props)=>{
    const { isCompassLicensed: isCompassLicensed, origin: origin } = props;
    const [{ hasBeenDismissed: hasBeenDismissed }, { dismiss: dismiss }] = (0, $9rkMO.useTouchPointDismissed)();
    const [{ hasBeenViewed: hasSpotlightBeenViewed }] = (0, $kvCU2.useCompassComponentsSpotlightViewed)();
    const onDismiss = (0, $eUqFw.useCallback)(async ()=>{
        dismiss();
    }, [
        dismiss
    ]);
    // Conditions for when we should render the touch point.
    const shouldRender = (0, $eUqFw.useMemo)(()=>{
        if (isCompassLicensed) // Don't render the touch point if Compass is already provisioned.
        return false;
        if (!hasSpotlightBeenViewed) // Don't render the touch point until user has dismissed our first spotlight.
        return false;
        // Don't render the touch point if a user has already dismissed it.
        return !hasBeenDismissed;
    }, [
        isCompassLicensed,
        hasSpotlightBeenViewed,
        hasBeenDismissed
    ]);
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $plbOU.CrossFlowProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eeqbM.AsyncCompassTableCrossFlowTouchPoint), {
        origin: origin,
        onDismiss: onDismiss
    }))) : null;
};
const $800cda728baae786$export$6d86b5ae49a52ead = (0, $35p9r.withCompassEntitlementCheck)($800cda728baae786$var$CompassTableCrossflowTouchPoint, 'project-pages.project-directories.components.view.table');

});
parcelRegister("eeqbM", function(module, exports) {

$parcel$export(module.exports, "AsyncCompassTableCrossFlowTouchPoint", () => $91bcdd87ef192904$export$a46027b03a0a578b);

var $eUqFw = parcelRequire("eUqFw");

var $1HzcR = parcelRequire("1HzcR");

var $6j4bv = parcelRequire("6j4bv");

var $8mGTI = parcelRequire("8mGTI");
const $91bcdd87ef192904$var$entryPointParams = {};
const $91bcdd87ef192904$export$a46027b03a0a578b = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $8mGTI.asyncCompassTableCrossFlowTouchPoint), $91bcdd87ef192904$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira.compass.table-cross-flow",
        packageName: "jiraCompassCrossFlow",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $91bcdd87ef192904$export$2e2bcd8739ae039 = $91bcdd87ef192904$export$a46027b03a0a578b;

});
parcelRegister("8mGTI", function(module, exports) {

$parcel$export(module.exports, "asyncCompassTableCrossFlowTouchPoint", () => $8eee32ab76d81bc2$export$674e2f56ee41c337);

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $8eee32ab76d81bc2$export$674e2f56ee41c337 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("iXTxz")).then((module)=>module.AsyncCompassTableCrossFlow), {
        moduleId: "95c02303"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iXTxz", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gyl1D").then(()=>parcelRequire('lVyf4'));

});



parcelRegister("35p9r", function(module, exports) {

$parcel$export(module.exports, "withCompassEntitlementCheck", () => $ddbcd39e124eb284$export$f091708323f34577);

var $eUqFw = parcelRequire("eUqFw");

var $j3FUN = parcelRequire("j3FUN");

var $gd0Sp = parcelRequire("gd0Sp");
const $ddbcd39e124eb284$var$isCompassInLicensedProducts = (licensedProducts)=>licensedProducts && licensedProducts.compass || false;
const $ddbcd39e124eb284$export$4cfb87fbb2c1c13f = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const memoisedData = (0, $eUqFw.useMemo)(()=>$ddbcd39e124eb284$var$isCompassInLicensedProducts(licensedProducts), [
        licensedProducts
    ]);
    return {
        isCompassLicensed: memoisedData
    };
};
function $ddbcd39e124eb284$export$f091708323f34577(WrappedComponent, origin) {
    // eslint-disable-next-line jira/react/no-class-components
    return class extends (0, $eUqFw.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { licensedProducts: licensedProducts } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    isCompassLicensed: $ddbcd39e124eb284$var$isCompassInLicensedProducts(licensedProducts),
                    origin: origin,
                    ...this.props
                })));
        }
    };
}

});

parcelRegister("kvCU2", function(module, exports) {

$parcel$export(module.exports, "useCompassComponentsSpotlightViewed", () => $59572c36797add9f$export$3c55ae3693c7bfe9);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $dxcfv = parcelRequire("dxcfv");
const $59572c36797add9f$var$COMPASS_COMPONENTS_NAMESPACE = 'compass-components';
function $59572c36797add9f$export$3c55ae3693c7bfe9() {
    const accountId = (0, $dxcfv.useAccountId)();
    const storageKey = `spotlight-viewed-${accountId}`;
    const storage = (0, $eUqFw.useMemo)(()=>(0, $aZaPn.createLocalStorageProvider)($59572c36797add9f$var$COMPASS_COMPONENTS_NAMESPACE), []);
    const [hasBeenViewed, setHasBeenViewed] = (0, $eUqFw.useState)(storage.get(storageKey));
    const hide = (0, $eUqFw.useCallback)(()=>{
        setHasBeenViewed(true);
        storage.set(storageKey, true);
    }, [
        setHasBeenViewed,
        storage,
        storageKey
    ]);
    const reset = (0, $eUqFw.useCallback)(()=>{
        setHasBeenViewed(false);
        storage.remove(storageKey);
    }, [
        setHasBeenViewed,
        storage,
        storageKey
    ]);
    return [
        {
            hasBeenViewed: hasBeenViewed
        },
        {
            hide: hide,
            reset: reset
        }
    ];
}

});

parcelRegister("9rkMO", function(module, exports) {

$parcel$export(module.exports, "useTouchPointDismissed", () => $b6364f6a60d66493$export$36756169aeb33eb4);

var $eUqFw = parcelRequire("eUqFw");

var $aZaPn = parcelRequire("aZaPn");

var $dxcfv = parcelRequire("dxcfv");
const $b6364f6a60d66493$var$COMPASS_COMPONENTS_NAMESPACE = 'compass-components';
function $b6364f6a60d66493$export$36756169aeb33eb4() {
    const accountId = (0, $dxcfv.useAccountId)();
    const storageKey = `table-crossflow-dismissed-${accountId}`;
    const storage = (0, $eUqFw.useMemo)(()=>(0, $aZaPn.createLocalStorageProvider)($b6364f6a60d66493$var$COMPASS_COMPONENTS_NAMESPACE), []);
    const [hasBeenDismissed, setHasBeenDismissed] = (0, $eUqFw.useState)(storage.get(storageKey));
    const dismiss = (0, $eUqFw.useCallback)(()=>{
        setHasBeenDismissed(true);
        storage.set(storageKey, true);
    }, [
        setHasBeenDismissed,
        storage,
        storageKey
    ]);
    const reset = (0, $eUqFw.useCallback)(()=>{
        setHasBeenDismissed(false);
        storage.remove(storageKey);
    }, [
        setHasBeenDismissed,
        storage,
        storageKey
    ]);
    return [
        {
            hasBeenDismissed: hasBeenDismissed
        },
        {
            dismiss: dismiss,
            reset: reset
        }
    ];
}

});


parcelRegister("e9GN2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fe2257cb1e6d97b$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $jmbhM = parcelRequire("jmbhM");

var $6crwp = parcelRequire("6crwp");

var $f30UX = parcelRequire("f30UX");

var $6LuqJ = parcelRequire("6LuqJ");
const $9fe2257cb1e6d97b$var$mapStateToProps = (state)=>({
        analyticsData: (0, $jmbhM.get)(state),
        canAddComponent: (0, $6crwp.isAdmin)(state)
    });
const $9fe2257cb1e6d97b$var$mapDispatchToProps = {
    onAddComponent: (0, $f30UX.initiate)
};
var $9fe2257cb1e6d97b$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($9fe2257cb1e6d97b$var$mapStateToProps, $9fe2257cb1e6d97b$var$mapDispatchToProps)((0, $6LuqJ.default));

});
parcelRegister("6LuqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $485cd474e53390f7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $7ZZxN = parcelRequire("7ZZxN");

var $3QLcd = parcelRequire("3QLcd");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");

var $6Vxra = parcelRequire("6Vxra");

var $hc0W2 = parcelRequire("hc0W2");
const $485cd474e53390f7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt46z83",
            __cmplp.className
        ])
    });
});
const $485cd474e53390f7$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "project-components.empty-placeholder-nothing-added-yet",
        "defaultMessage": "This project doesn't have any components, yet"
    },
    description: {
        "id": "project-components.empty-placeholder-components-are-subsections",
        "defaultMessage": "Components are subsections of a project. Use them to group issues within a project into smaller parts."
    },
    addComponent: {
        "id": "project-components.empty-placeholder-add-a-component",
        "defaultMessage": "Create component"
    },
    learnMore: {
        "id": "project-components.empty-placeholder-read-more",
        "defaultMessage": "Learn more"
    },
    learnMoreAriaLabelText: {
        "id": "project-components.empty-placeholder-read-more-aria-label-text",
        "defaultMessage": "Learn more about components"
    },
    learnMoreJiraComponentsAriaLabelText: {
        "id": "project-components.empty-placeholder-read-more-jira-components-aria-label-text",
        "defaultMessage": "Learn how to configure Jira components"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $485cd474e53390f7$var$EmptyPlaceholderView extends (0, $eUqFw.PureComponent) {
    renderAddComponentButton() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: this.props.onAddComponent
        }, this.props.intl.formatMessage($485cd474e53390f7$var$messages.addComponent));
    }
    renderLinkButton() {
        let articleId;
        let fallbackLink;
        let learnMoreAriaLabelText;
        if ((0, $6Vxra.isCompassComponentsInJiraComponentsEnabled)() && this.props.projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) {
            // For JSW projects, show the newer Jira Components help articles (which contains references to Compass Components)
            articleId = 'XFBVB5cRw96Y4KvDXxiuM';
            fallbackLink = 'https://support.atlassian.com/jira-software-cloud/docs/configure-jira-components/';
            learnMoreAriaLabelText = $485cd474e53390f7$var$messages.learnMoreJiraComponentsAriaLabelText;
        } else {
            // For non-JSW projects (JSM), show the original Jira Components help articles (Compass Components are not available in JSM)
            articleId = 'kG5jarMna4VfUEbBkegtI';
            fallbackLink = 'https://confluence.atlassian.com/display/ADMINJIRACLOUD/Managing+components';
            learnMoreAriaLabelText = $485cd474e53390f7$var$messages.learnMoreAriaLabelText;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
            "aria-label": this.props.intl.formatMessage(learnMoreAriaLabelText),
            articleId: articleId,
            appearance: "subtle-link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                "aria-label": this.props.intl.formatMessage(learnMoreAriaLabelText),
                appearance: "subtle-link",
                href: fallbackLink,
                target: "_blank"
            }, this.props.intl.formatMessage($485cd474e53390f7$var$messages.learnMore))
        }, this.props.intl.formatMessage($485cd474e53390f7$var$messages.learnMore));
    }
    render() {
        const { canAddComponent: canAddComponent, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($485cd474e53390f7$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hc0W2))),
            size: "narrow",
            header: formatMessage($485cd474e53390f7$var$messages.header),
            description: formatMessage($485cd474e53390f7$var$messages.description),
            primaryAction: !canAddComponent ? null : this.renderAddComponentButton(),
            tertiaryAction: this.renderLinkButton()
        }));
    }
}
var $485cd474e53390f7$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($485cd474e53390f7$var$EmptyPlaceholderView);

});
parcelRegister("6Vxra", function(module, exports) {

$parcel$export(module.exports, "isCompassComponentsInJiraComponentsEnabled", () => $4695c7aa69971010$export$c02192e53ee11ea6);

var $1ybV0 = parcelRequire("1ybV0");
const $4695c7aa69971010$export$c02192e53ee11ea6 = ()=>(0, $1ybV0.ff)('compass-components-in-jira-components_xw42u');

});

parcelRegister("hc0W2", function(module, exports) {
module.exports = new URL("components.37259031.svg", import.meta.url).toString();

});



parcelRegister("09jnB", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ec5a617c06e1eb$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fnVSJ = parcelRequire("fnVSJ");

var $1FdCJ = parcelRequire("1FdCJ");

var $ccYHR = parcelRequire("ccYHR");

var $kitOl = parcelRequire("kitOl");
const $68ec5a617c06e1eb$var$mapStateToProps = (state)=>({
        isLoading: (0, $ccYHR.isLoading)(state),
        currentPage: (0, $1FdCJ.getCurrentPage)(state)
    });
const $68ec5a617c06e1eb$var$mapDispatchToProps = {
    onRetry: (0, $fnVSJ.getComponentsPageRequest)
};
var $68ec5a617c06e1eb$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($68ec5a617c06e1eb$var$mapStateToProps, $68ec5a617c06e1eb$var$mapDispatchToProps)((0, $kitOl.default));

});
parcelRegister("kitOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $044d6f6cc1acf2db$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3NCZx = parcelRequire("3NCZx");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");

var $kuteD = parcelRequire("kuteD");
const $044d6f6cc1acf2db$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "project-components.error-header",
        "defaultMessage": "An error occurred"
    },
    description: {
        "id": "project-components.error-description",
        "defaultMessage": "There was a problem loading your components. Try again or contact your administrator for support."
    }
});
function $044d6f6cc1acf2db$var$ErrorView(props) {
    const { onRetry: onRetry, currentPage: currentPage, isLoading: isLoading, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3NCZx.default), {
        header: formatMessage($044d6f6cc1acf2db$var$messages.header),
        description: formatMessage($044d6f6cc1acf2db$var$messages.description),
        isLoading: isLoading,
        onRetry: ()=>onRetry({
                page: currentPage,
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).VIEW
            })
    });
}
$044d6f6cc1acf2db$var$ErrorView.defaultProps = {
    isLoading: false
};
var $044d6f6cc1acf2db$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($044d6f6cc1acf2db$var$ErrorView);

});
parcelRegister("3NCZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbb1e7780288e8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $220ac = parcelRequire("220ac");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $4zP5Y = parcelRequire("4zP5Y");

var $80J5A = parcelRequire("80J5A");

var $eQdlC = parcelRequire("eQdlC");
function $0cbb1e7780288e8f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($4zP5Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($80J5A)));
    const isAssetConsolidation = (0, $1ybV0.ff)('jfe-asset-consolidation-itsm-agni_po996');
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (isAssetConsolidation) {
        if (renderErrorImage) imageUrl = undefined;
        else imageUrl = fallbackImage;
    } else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        testId: "common-components-error-state.empty-state",
        size: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage
    });
}
$0cbb1e7780288e8f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $eQdlC.default).retry
};
var $0cbb1e7780288e8f$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0cbb1e7780288e8f$export$edf27be85e5f6da0);

});
parcelRegister("4zP5Y", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("80J5A", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("eQdlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc26b353252dab4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8bc26b353252dab4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});




parcelRegister("9dC8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $853859b78300f5b5$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $jmbhM = parcelRequire("jmbhM");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");

var $3vAHb = parcelRequire("3vAHb");
const $853859b78300f5b5$var$mapStateToProps = (state)=>({
        value: (0, $1FdCJ.getFilter)(state),
        analyticsData: (0, $jmbhM.get)(state)
    });
const $853859b78300f5b5$var$mapDispatchToProps = (dispatch)=>({
        onChange: (value)=>{
            dispatch((0, $bau7U.patchQuery)({
                filter: value,
                page: 1
            }));
            dispatch((0, $fnVSJ.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).FILTERING
            }));
        }
    });
var $853859b78300f5b5$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($853859b78300f5b5$var$mapStateToProps, $853859b78300f5b5$var$mapDispatchToProps)((0, $3vAHb.default));

});
parcelRegister("3vAHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d9d020d4ed6e8fc$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $4kxNm = parcelRequire("4kxNm");

var $7JTqr = parcelRequire("7JTqr");
class $5d9d020d4ed6e8fc$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            value: ''
        };
    }
    render() {
        const { value: value = '' } = this.props;
        return (0, $7JTqr.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kxNm.default), {
            value: value,
            onChange: this.onChange,
            ariaLabelText: this.props.ariaLabel
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kxNm.default), {
            value: value,
            onChange: this.onChange
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (value)=>{
            this.props.onChange(value);
        };
    }
}

});
parcelRegister("4kxNm", function(module, exports) {

$parcel$export(module.exports, "default", () => $70243b4457606984$export$2e2bcd8739ae039);

var $2l1Ja = parcelRequire("2l1Ja");
var $70243b4457606984$export$2e2bcd8739ae039 = (0, $2l1Ja.default);

});
parcelRegister("2l1Ja", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdeca50a427435db$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $8Ui86 = parcelRequire("8Ui86");

var $8rQuz = parcelRequire("8rQuz");
const $bdeca50a427435db$export$4c4c11a6ab1f5b09 = 1000;
const $bdeca50a427435db$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((value, callback)=>callback(value), $bdeca50a427435db$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $bdeca50a427435db$var$Filter extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ui86.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: (0, $8rQuz.isVisualRefreshEnabled)()
        });
    }
    constructor(...args){
        super(...args);
        this.prevQueryValue = this.props.value;
        this.prevSearchValue = this.props.value;
        this.handleNewValue = (newValue)=>{
            $bdeca50a427435db$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        };
        this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $bdeca50a427435db$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $bdeca50a427435db$export$2e2bcd8739ae039 = $bdeca50a427435db$var$Filter;

});
parcelRegister("8Ui86", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $02c3e5e2cebd6ff7$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gtzuR = parcelRequire("gtzuR");

var $bFzGY = parcelRequire("bFzGY");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kq9HD = parcelRequire("kq9HD");

var $dAreR = parcelRequire("dAreR");

var $8rQuz = parcelRequire("8rQuz");

var $babBw = parcelRequire("babBw");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $02c3e5e2cebd6ff7$var$className = 'ajs-dirty-warning-exempt';
const $02c3e5e2cebd6ff7$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = {}, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    const [value, setValue] = (0, $eUqFw.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const textInput = (0, $eUqFw.useRef)(null);
    const previousValueRef = (0, $eUqFw.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eUqFw.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eUqFw.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder,
        'aria-describedby': describedById,
        type: 'text',
        // @ts-expect-error - TS2322 - Type '{ 'aria-label': string; 'aria-describedby': string; type: string; 'data-test-id': string; name: string; className: string; placeholder: string; onFocus: (event: React.SyntheticEvent<HTMLInputElement, Event>) => void; ... 9 more ...; maxLength: number | undefined; }' is not assignable to type 'TextfieldProps'.
        'data-test-id': 'searchfield',
        name: 'search',
        className: $02c3e5e2cebd6ff7$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $babBw.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $8rQuz.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dAreR.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kq9HD.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $babBw.messages).clear)
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($02c3e5e2cebd6ff7$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        increasedWidth: increasedWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...textFieldProps,
        testId: testId,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.displayName = 'Search';
$02c3e5e2cebd6ff7$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $02c3e5e2cebd6ff7$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eUqFw.memo)($02c3e5e2cebd6ff7$var$SearchFieldUnmemoized);
$02c3e5e2cebd6ff7$export$b94867ecbd698f21.displayName = 'Search'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02c3e5e2cebd6ff7$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $02c3e5e2cebd6ff7$var$InputWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $9t7rW.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $9t7rW.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $9t7rW.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $9t7rW.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $9t7rW.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $9t7rW.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _v564zpk5 _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _wngi16hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("kq9HD", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $c70659cfee4e098d$export$84038b503874befa);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $02Sz7 = parcelRequire("02Sz7");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $c70659cfee4e098d$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $c70659cfee4e098d$var$wrapperStylesCloseIcon
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($02Sz7)))
    }));
const $c70659cfee4e098d$var$wrapperStylesCloseIcon = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.050'
    }
});

});

parcelRegister("dAreR", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $81537fc79b34b1c4$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $81537fc79b34b1c4$export$8a82bff895521bd9);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $8xkEh = parcelRequire("8xkEh");

var $aB51E = parcelRequire("aB51E");

var $9IsWp = parcelRequire("9IsWp");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1ZAYh = parcelRequire("1ZAYh");
const $81537fc79b34b1c4$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aB51E))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStyles,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStyles
        ]
    }, hasValue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        spacing: "none",
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8xkEh))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $81537fc79b34b1c4$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $81537fc79b34b1c4$var$wrapperStylesBefore,
            onlyIconSpacing && $81537fc79b34b1c4$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9IsWp))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null));
const $81537fc79b34b1c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex'
});
const $81537fc79b34b1c4$var$spacingStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $81537fc79b34b1c4$var$wrapperStylesBefore = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $81537fc79b34b1c4$var$spacingStylesBefore = (0, $1ZAYh.xcss)({
    marginLeft: 'space.075',
    [(0, $4Ywu9.media).above.md]: {
        marginLeft: 'space.100'
    }
});

});

parcelRegister("babBw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1db92d5b4c5e946f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1db92d5b4c5e946f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    }
});

});






parcelRegister("cWpHr", function(module, exports) {

$parcel$export(module.exports, "WrappedGlobalComponentsToggleButton", () => $364797c5c7eb1e87$export$3e1dcbc2cb650833);

var $eUqFw = parcelRequire("eUqFw");

var $7opLA = parcelRequire("7opLA");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $79oeh = parcelRequire("79oeh");

var $aUOg1 = parcelRequire("aUOg1");

var $5zQ3B = parcelRequire("5zQ3B");
function $364797c5c7eb1e87$export$7b6a4d9163c73b70(props) {
    const { testId: testId, loading: loading, enabled: enabled, setProperty: setProperty, isAdminContext: isAdminContext, isOpen: isOpen, toggleOpen: toggleOpen } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>toggleOpen(false),
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5zQ3B.PopupContent), {
                isAdminContext: isAdminContext,
                loading: loading,
                globalComponentsEnabled: !!enabled,
                setGlobalComponentsProperty: setProperty
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
                ...triggerProps,
                testId: testId,
                isLoading: loading,
                isSelected: isOpen,
                onClick: (_, analyticsEvent)=>{
                    (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'globalComponentsToggleButton', {
                        opened: !isOpen
                    });
                    toggleOpen(!isOpen);
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                })
            }, formatMessage((0, $aUOg1.default).productComponents, {
                product: enabled ? 'Compass' : 'Jira'
            }))
    });
}
function $364797c5c7eb1e87$export$3e1dcbc2cb650833(props) {
    const { globalComponentsProperty: globalComponentsProperty, isEditable: isEditable } = props;
    const [isGlobalComponentsPopupOpen, setIsGlobalComponentsPopupOpen] = (0, $eUqFw.useState)(false);
    // https://switcheroo.atlassian.com/ui/gates/1b168ef2-2b46-4911-a34c-48247c85f7b9
    const compassComponentsUpsellAdEnabled = !(0, $eI5EY.fg)('compass-components-upsell-ad');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        fallback: "unmount",
        packageName: "jiraProjectDirectoriesComponents",
        // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
        teamName: "compass-lodestone",
        id: "wrappedGlobalComponentsToggleButton",
        sendToPrivacyUnsafeSplunk: true
    }, compassComponentsUpsellAdEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $79oeh.CompassComponentsSpotlight), {
        testId: "project-directories.components.global-components-toggle-button.compass-components-spotlight",
        targetRadius: 3,
        dialogPlacement: "bottom right",
        isVisible: !globalComponentsProperty?.loading && !globalComponentsProperty?.enabled,
        onDismiss: (_, analyticEvent)=>{
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'compassComponentsSpotlightDismiss');
        },
        onLearnMore: (e, analyticEvent)=>{
            e.stopPropagation();
            setIsGlobalComponentsPopupOpen(true);
            (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'compassComponentSpotlightLearnMore');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($364797c5c7eb1e87$export$7b6a4d9163c73b70, {
        toggleOpen: setIsGlobalComponentsPopupOpen,
        isOpen: isGlobalComponentsPopupOpen,
        testId: "project-directories.components.global-components-toggle-button.compass-global-components-toggle-button",
        isAdminContext: isEditable,
        ...globalComponentsProperty
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($364797c5c7eb1e87$export$7b6a4d9163c73b70, {
        toggleOpen: setIsGlobalComponentsPopupOpen,
        isOpen: isGlobalComponentsPopupOpen,
        testId: "project-directories.components.global-components-toggle-button.compass-global-components-toggle-button",
        isAdminContext: isEditable,
        ...globalComponentsProperty
    }));
}

});
parcelRegister("79oeh", function(module, exports) {

$parcel$export(module.exports, "CompassComponentsSpotlight", () => $097762a1f026c9f6$export$789e02269f603bf7);

var $eUqFw = parcelRequire("eUqFw");

var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kvCU2 = parcelRequire("kvCU2");

var $kpdsp = parcelRequire("kpdsp");
const $097762a1f026c9f6$var$TARGET = 'project-directories.components.compass-components-spotlight.target';
function $097762a1f026c9f6$export$789e02269f603bf7({ isVisible: isVisible = true, onDismiss: onDismiss, onLearnMore: onLearnMore, children: children, ...forwardProps }) {
    const [{ hasBeenViewed: hasBeenViewed }, { hide: hide }] = (0, $kvCU2.useCompassComponentsSpotlightViewed)();
    const handleDismiss = (e, analyticsEvent)=>{
        hide();
        onDismiss?.(e, analyticsEvent);
    };
    const handleLearnMore = (e, analyticsEvent)=>{
        hide();
        onLearnMore?.(e, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: $097762a1f026c9f6$var$TARGET
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isVisible && !hasBeenViewed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "compassComponentsSpotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpdsp.CompassComponentsPopup), {
        target: $097762a1f026c9f6$var$TARGET,
        onDismiss: handleDismiss,
        onLearnMore: handleLearnMore,
        ...forwardProps
    }))));
}

});
parcelRegister("kpdsp", function(module, exports) {

$parcel$export(module.exports, "CompassComponentsPopup", () => $67bbb2265a34fbdd$export$cc486d32c3044612);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ap7vt = parcelRequire("ap7vt");

var $fzA5A = parcelRequire("fzA5A");

var $7Vqa9 = parcelRequire("7Vqa9");
function $67bbb2265a34fbdd$export$cc486d32c3044612({ onLearnMore: onLearnMore, onDismiss: onDismiss, testId: testId, ...forwardProps }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const learnMoreTestId = testId && `${testId}-learn-more`;
    const dismissTestId = testId && `${testId}-dismiss`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ap7vt.JiraSpotlight), {
        ...forwardProps,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fzA5A))),
        dialogWidth: 320,
        actions: [
            {
                text: formatMessage((0, $7Vqa9.default).learnMore),
                onClick: onLearnMore,
                testId: learnMoreTestId
            },
            {
                appearance: 'subtle-link',
                text: formatMessage((0, $7Vqa9.default).dismiss),
                onClick: onDismiss,
                testId: dismissTestId
            }
        ],
        heading: formatMessage((0, $7Vqa9.default).heading),
        testId: testId,
        messageId: "project-directories.components.compass-components-spotlight.compass-components-popup.jira-spotlight",
        messageType: "engagement"
    }, formatMessage((0, $7Vqa9.default).summary));
}

});
parcelRegister("fzA5A", function(module, exports) {
module.exports = new URL("popup-image.c1b1bf07.svg", import.meta.url).toString();

});

parcelRegister("7Vqa9", function(module, exports) {

$parcel$export(module.exports, "default", () => $38bbd11a53d57964$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $38bbd11a53d57964$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-components.compass-components-popup.heading",
        "defaultMessage": "A new way to work on software components"
    },
    summary: {
        "id": "project-components.compass-components-popup.summary",
        "defaultMessage": "Use Compass components to group and track work around pieces of your software architecture."
    },
    learnMore: {
        "id": "project-components.compass-components-popup.learn-more",
        "defaultMessage": "Show me"
    },
    dismiss: {
        "id": "project-components.compass-components-popup.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});



parcelRegister("aUOg1", function(module, exports) {

$parcel$export(module.exports, "default", () => $31605a23f7836d67$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $31605a23f7836d67$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    productComponents: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.product-components",
        "defaultMessage": "{product} components"
    }
});

});

parcelRegister("5zQ3B", function(module, exports) {

$parcel$export(module.exports, "PopupContent", () => $73070f214344c31c$export$2a2c7ba12d3231e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $bULPy = parcelRequire("bULPy");
var $8PFhw = parcelRequire("8PFhw");
var $8BKky = parcelRequire("8BKky");

var $e270j = parcelRequire("e270j");

var $8cU5f = parcelRequire("8cU5f");

var $3QLcd = parcelRequire("3QLcd");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $j6Ykw = parcelRequire("j6Ykw");

var $41By6 = parcelRequire("41By6");
function $73070f214344c31c$export$2a2c7ba12d3231e3(props) {
    const { isAdminContext: isAdminContext, loading: loading, globalComponentsEnabled: globalComponentsEnabled, setGlobalComponentsProperty: setGlobalComponentsProperty } = props;
    const { openGlobalComponentsFeedbackCollector: openGlobalComponentsFeedbackCollector } = (0, $j6Ykw.useCompassComponentsFeedbackCollectorActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const adminAwareToggle = (0, $eUqFw.useMemo)(()=>{
        const toggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
            testId: "project-directories.components.global-components-toggle-button.popup-content.toggle",
            isDisabled: // Only admins can turn on Compass components.
            !isAdminContext || loading,
            isChecked: globalComponentsEnabled,
            onChange: (_, analyticEvent)=>{
                (0, $jMP2a.fireUIAnalytics)(analyticEvent, 'globalComponentsProperty', {
                    value: !globalComponentsEnabled
                });
                setGlobalComponentsProperty(!globalComponentsEnabled); // Request feedback when global components are disabled (i.e. was enabled, becoming disabled).
                if (globalComponentsEnabled) openGlobalComponentsFeedbackCollector({
                    cancelButtonLabel: formatMessage((0, $41By6.default).skipButtonLabel)
                });
            }
        });
        if (isAdminContext) return toggle;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            testId: "project-directories.components.global-components-toggle-button.popup-content.tooltip",
            content: formatMessage((0, $41By6.default).askAdmin)
        }, toggle);
    }, [
        formatMessage,
        loading,
        isAdminContext,
        globalComponentsEnabled,
        setGlobalComponentsProperty,
        openGlobalComponentsFeedbackCollector
    ]);
    const actionHint = (0, $eUqFw.useMemo)(()=>{
        if (globalComponentsEnabled) {
            if (isAdminContext) return (0, $41By6.default).jiraAdminActionHint;
            return (0, $41By6.default).jiraActionHint;
        }
        if (isAdminContext) return (0, $41By6.default).compassAdminActionHint;
        return (0, $41By6.default).compassActionHint;
    }, [
        globalComponentsEnabled,
        isAdminContext
    ]); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickLearnMore = (_, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, globalComponentsEnabled ? 'learnMoreAboutJiraLink' : 'learnMoreAboutCompassLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "globalComponentsTogglePopup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8PFhw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73070f214344c31c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73070f214344c31c$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73070f214344c31c$var$Heading, {
        level: "h500"
    }, formatMessage(globalComponentsEnabled ? (0, $41By6.default).switchToJiraCta : (0, $41By6.default).switchToCompassCta)), adminAwareToggle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73070f214344c31c$var$Body, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73070f214344c31c$var$ComponentsDetails, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...globalComponentsEnabled ? (0, $41By6.default).jiraDescription : (0, $41By6.default).compassDescription,
        values: {
            // @ts-expect-error - Type '(learnMore: string) => JSX.Element' is not assignable to type 'ReactNode'.
            link: (learnMore)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                    articleId: globalComponentsEnabled ? (0, $4de8793669bf0872$export$d519c2877b8b5078) : (0, $4de8793669bf0872$export$46b2089262397762),
                    appearance: "link",
                    spacing: "none",
                    onClick: onClickLearnMore,
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        href: globalComponentsEnabled ? (0, $4de8793669bf0872$export$c0a683dd07e215fe) : (0, $4de8793669bf0872$export$6b933388fae9d233),
                        onClick: onClickLearnMore,
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, learnMore)
                }, learnMore)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($73070f214344c31c$var$SwitchInfo, null, formatMessage(actionHint))))), globalComponentsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        onClick: ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            }), 'compassFeedbackCollector');
            openGlobalComponentsFeedbackCollector();
        }
    }, formatMessage((0, $41By6.default).giveFeedback)))));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73070f214344c31c$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1a2h _1yt4dik7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73070f214344c31c$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _otyrpxbi _tqeh1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73070f214344c31c$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73070f214344c31c$var$Body = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulppxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73070f214344c31c$var$ComponentsDetails = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz10s3 _vwz4gktf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $73070f214344c31c$var$SwitchInfo = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _11c81vlj _vwz477iu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0a5ff21930da1dedae2ce32055ebd4e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de079945bd0ce69f73f9818513d51348>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});


parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4a9a14e2cbd991149ff35fe23cef8b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dfdc599c601af5ad9de21c16ca28508>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform.design-system-team.enable-new-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform.design-system-team.enable-new-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



const $4de8793669bf0872$export$6b933388fae9d233 = 'https://support.atlassian.com/jira-software-cloud/docs/what-are-compass-components/';
const $4de8793669bf0872$export$c0a683dd07e215fe = 'https://support.atlassian.com/jira-software-cloud/docs/what-are-jira-components/';
const $4de8793669bf0872$export$46b2089262397762 = 'vnkvMTEMH9pGdm5r9sTtl';
const $4de8793669bf0872$export$d519c2877b8b5078 = '6PbqxN3PWhkG7F5OE18WqX';

parcelRegister("j6Ykw", function(module, exports) {

$parcel$export(module.exports, "useCompassComponentsFeedbackCollectorActions", () => $26e75056df79180b$export$f2628ebb122d157e);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6YQVc = parcelRequire("6YQVc");

var $41By6 = parcelRequire("41By6");
const $26e75056df79180b$export$f2628ebb122d157e = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const openGlobalComponentsFeedbackCollector = (0, $eUqFw.useCallback)((props)=>{
        openFeedbackCollector({
            feedbackGroupId: (0, $6YQVc.feedback).GLOBAL_COMPONENTS,
            entrypointId: (0, $1c02D.ENTRY_POINT_ID_COMPASS),
            feedbackTitle: formatMessage((0, $41By6.default).feedbackTitle),
            showTypeField: true,
            showDefaultTextFields: true,
            submitButtonLabel: formatMessage((0, $41By6.default).submitButtonLabel),
            feedbackContext: [
                {
                    id: (0, $1c02D.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
                    value: (0, $6YQVc.feedback).LOCATION
                }
            ],
            ...props
        });
    }, [
        formatMessage,
        openFeedbackCollector
    ]);
    return {
        openGlobalComponentsFeedbackCollector: openGlobalComponentsFeedbackCollector
    };
};

});
parcelRegister("6YQVc", function(module, exports) {

$parcel$export(module.exports, "feedback", () => $ccd8dbaf1afc684f$export$2696717cee565f14);
const $ccd8dbaf1afc684f$export$2696717cee565f14 = {
    LOCATION: 'Project Components',
    GLOBAL_COMPONENTS: 'jsw.components.global-components'
};

});

parcelRegister("41By6", function(module, exports) {

$parcel$export(module.exports, "default", () => $30fbe3facbf3a737$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $30fbe3facbf3a737$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    switchToCompassCta: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-compass-cta",
        "defaultMessage": "Switch to Compass components"
    },
    compassDescription: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-description",
        "defaultMessage": "Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more</link>"
    },
    compassAdminActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-admin-action-hint",
        "defaultMessage": "If you switch, you\u2019ll still see read-only Jira components. You can switch back at any time."
    },
    compassActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.compass-action-hint",
        "defaultMessage": "If your admin switches, you\u2019ll still see read-only Jira components."
    },
    switchToJiraCta: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.switch-to-jira-cta",
        "defaultMessage": "Switch to Jira components"
    },
    jiraDescription: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-description",
        "defaultMessage": "Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more</link>"
    },
    jiraAdminActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-admin-action-hint",
        "defaultMessage": "If you switch, you\u2019ll still see read-only Compass components. You can switch back at any time."
    },
    jiraActionHint: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.jira-action-hint",
        "defaultMessage": "If your admin switches, you\u2019ll still see read-only Compass components."
    },
    newLozenge: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.new-lozenge",
        "defaultMessage": "New"
    },
    giveFeedback: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.give-feedback",
        "defaultMessage": "Give feedback"
    },
    askAdmin: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.ask-admin",
        "defaultMessage": "Ask your admin to switch to Compass components."
    },
    feedbackTitle: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.title",
        "defaultMessage": "Give feedback"
    },
    feedbackPlaceholder: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.placeholder",
        "defaultMessage": "Write feedback"
    },
    submitButtonLabel: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.submit-button",
        "defaultMessage": "Submit"
    },
    skipButtonLabel: {
        "id": "project-pages-project-directories.components.view.global-components-toggle-button.popup-content.feedback-collector.skip-button",
        "defaultMessage": "Skip"
    }
});

});




parcelRegister("kyswk", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd87ffc1d30dce7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $jmbhM = parcelRequire("jmbhM");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");

var $2Y1sR = parcelRequire("2Y1sR");

var $ZqLoX = parcelRequire("ZqLoX");
const $ecd87ffc1d30dce7$var$mapStateToProps = (state)=>({
        currentPage: (0, $1FdCJ.getCurrentPage)(state),
        totalPages: (0, $2Y1sR.getTotalPages)(state),
        analyticsData: (0, $jmbhM.get)(state)
    });
const $ecd87ffc1d30dce7$var$mapDispatchToProps = (dispatch)=>({
        onPageChange: (number)=>{
            dispatch((0, $bau7U.patchQuery)({
                page: number
            }));
            return dispatch((0, $fnVSJ.getComponentsPageRequest)({
                page: number,
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).VIEW
            }));
        }
    });
var $ecd87ffc1d30dce7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($ecd87ffc1d30dce7$var$mapStateToProps, $ecd87ffc1d30dce7$var$mapDispatchToProps)((0, $ZqLoX.default));

});
parcelRegister("2Y1sR", function(module, exports) {

$parcel$export(module.exports, "getTotalPages", () => $f5f77ae361274df1$export$652b307566494a6);
$parcel$export(module.exports, "getIssuesUrl", () => $f5f77ae361274df1$export$390b5477b70c6392);

var $8g5hT = parcelRequire("8g5hT");

var $cHQhb = parcelRequire("cHQhb");

var $cXEqp = parcelRequire("cXEqp");

var $dlLXy = parcelRequire("dlLXy");

var $ccYHR = parcelRequire("ccYHR");
const $f5f77ae361274df1$export$652b307566494a6 = (state)=>(0, $cHQhb.calculateTotalPages)((0, $cXEqp.getTotalItems)(state), (0, $ccYHR.getItemsOnPage)(state));
const $f5f77ae361274df1$export$390b5477b70c6392 = (state, componentId)=>{
    if (!(0, $cXEqp.getComponent)(state, componentId)) return '';
    const projectKey = (0, $dlLXy.getProjectKey)(state);
    const componentName = (0, $cXEqp.getName)(state, componentId);
    const jql = `project = ${(0, $8g5hT.toQuotedString)(projectKey)} AND component = ${(0, $8g5hT.toQuotedString)(componentName)}`;
    return (0, $8g5hT.createIssuesUrl)(jql);
};

});

parcelRegister("ZqLoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d17764c052be70d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $iqjbc = parcelRequire("iqjbc");

var $3KPTt = parcelRequire("3KPTt");

var $1ybV0 = parcelRequire("1ybV0");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");
const $2d17764c052be70d$var$messages = (0, $90IgZ.defineMessages)({
    previousButton: {
        "id": "project-components.paginator.previous-button",
        "defaultMessage": "Prev"
    },
    nextButton: {
        "id": "project-components.paginator.next-button",
        "defaultMessage": "Next"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d17764c052be70d$var$Container = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1syuewr-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        marginTop: "var(--ds-space-300, 24px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginBottom: props.isCompassComponentsPageReworkEnabled ? "var(--ds-space-300, 24px)" : 0,
        marginLeft: "var(--ds-space-negative-200, -16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.totalPages <= 1 ? 'none' : 'block'
    }));
// eslint-disable-next-line jira/react/no-class-components
class $2d17764c052be70d$var$PaginatorView extends (0, $eUqFw.PureComponent) {
    render() {
        const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d17764c052be70d$var$Container, {
            totalPages: totalPages,
            // https://switcheroo.atlassian.com/changes/jira/compass-components-in-jira-components_xw42u
            isCompassComponentsPageReworkEnabled: (0, $1ybV0.ff)('compass-components-in-jira-components_xw42u'),
            "data-test-id": "project-directories.components.paginator.container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            testId: "project-directories.components.paginator.pagination",
            selectedIndex: currentPage - 1,
            onChange: this.onPageChange,
            pages: (0, (/*@__PURE__*/$parcel$interopDefault($iqjbc)))(1, totalPages + 1),
            previousLabel: formatMessage($2d17764c052be70d$var$messages.previousButton),
            nextLabel: formatMessage($2d17764c052be70d$var$messages.nextButton)
        }));
    }
    constructor(...args){
        super(...args);
        this.onPageChange = (event, page)=>{
            this.props.onPageChange(page);
        };
    }
}
var $2d17764c052be70d$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($2d17764c052be70d$var$PaginatorView);

});
parcelRegister("iqjbc", function(module, exports) {

var $doiuZ = parcelRequire("doiuZ");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $d699885de2b5454c$var$range = $doiuZ();
module.exports = $d699885de2b5454c$var$range;

});
parcelRegister("doiuZ", function(module, exports) {

var $iVCWR = parcelRequire("iVCWR");

var $3P7i5 = parcelRequire("3P7i5");

var $d0d5X = parcelRequire("d0d5X");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $9bfbddb9d5847b3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $3P7i5(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $d0d5X(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $d0d5X(end);
        step = step === undefined ? start < end ? 1 : -1 : $d0d5X(step);
        return $iVCWR(start, end, step, fromRight);
    };
}
module.exports = $9bfbddb9d5847b3e$var$createRange;

});
parcelRegister("iVCWR", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dc7bc3319622b4d0$var$nativeCeil = Math.ceil, $dc7bc3319622b4d0$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $dc7bc3319622b4d0$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $dc7bc3319622b4d0$var$nativeMax($dc7bc3319622b4d0$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $dc7bc3319622b4d0$var$baseRange;

});





parcelRegister("aFjQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $31194ca2a2247a6f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $kuteD = parcelRequire("kuteD");

var $fnVSJ = parcelRequire("fnVSJ");

var $cXEqp = parcelRequire("cXEqp");

var $6crwp = parcelRequire("6crwp");

var $bau7U = parcelRequire("bau7U");

var $1FdCJ = parcelRequire("1FdCJ");

var $ccYHR = parcelRequire("ccYHR");

var $ev6Q0 = parcelRequire("ev6Q0");
const $31194ca2a2247a6f$var$mapStateToProps = (state)=>({
        componentIds: (0, $cXEqp.getIds)(state),
        isLoading: (0, $ccYHR.isLoading)(state),
        editable: (0, $6crwp.isAdmin)(state),
        orderField: (0, $1FdCJ.getOrderField)(state),
        orderDirection: (0, $1FdCJ.getOrderDirection)(state)
    });
const $31194ca2a2247a6f$var$mapDispatchToProps = (dispatch)=>({
        onSort: ({ key: key, sortOrder: sortOrder })=>{
            dispatch((0, $bau7U.patchQuery)({
                orderDirection: sortOrder,
                orderField: key,
                page: 1
            }));
            dispatch((0, $fnVSJ.getComponentsPageRequest)({
                page: 1,
                initiatedBy: (0, $kuteD.FETCH_COMPONENTS_REASON).SORTING
            }));
        }
    });
var $31194ca2a2247a6f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($31194ca2a2247a6f$var$mapStateToProps, $31194ca2a2247a6f$var$mapDispatchToProps)((0, $ev6Q0.default));

});
parcelRegister("ev6Q0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb814f82a16d849e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $clqWl = parcelRequire("clqWl");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");


var $7INHA = parcelRequire("7INHA");

var $8CjRP = parcelRequire("8CjRP");

var $hELAw = parcelRequire("hELAw");

var $6BbOo = parcelRequire("6BbOo");

var $8q235 = parcelRequire("8q235");

var $2Ryjd = parcelRequire("2Ryjd");

var $iOBgN = parcelRequire("iOBgN");

var $dDiAG = parcelRequire("dDiAG");
const $cb814f82a16d849e$var$TableContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2ws7jp4b _p4liutpp _6aututpp _jrvj1hna _fdle1hna _1vd212x7 _10uc12x7 _v8u71b66 _1gnfze3t _1prjusic _10wbnkob _y4k2usic",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb814f82a16d849e$var$ComponentCellContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91l8a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb814f82a16d849e$var$EmptyLoadingView = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
});
const $cb814f82a16d849e$var$messages = (0, $90IgZ.defineMessages)({
    component: {
        "id": "project-components.table-header-component",
        "defaultMessage": "Component"
    },
    issues: {
        "id": "project-components.table-header-issues",
        "defaultMessage": "Issues"
    },
    lead: {
        "id": "project-components.table-header-lead",
        "defaultMessage": "Component lead"
    },
    description: {
        "id": "project-components.table-header-description",
        "defaultMessage": "Description"
    },
    defaultAssignee: {
        "id": "project-components.table-header-default-assignee",
        "defaultMessage": "Default assignee"
    },
    moreActions: {
        "id": "project-components.table-header-more-actions",
        "defaultMessage": "More actions"
    },
    componentsTableLabel: {
        "id": "project-components.table-components-label",
        "defaultMessage": "Table of components"
    }
});
class $cb814f82a16d849e$var$TableView extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            editable: false,
            isLoading: false,
            orderField: (0, $7INHA.NAME),
            orderDirection: (0, $44763968d5986a8d$export$1dee026a19752d6b)
        };
    }
    render() {
        const { isLoading: isLoading, componentIds: componentIds, editable: editable, onSort: onSort, orderField: orderField, orderDirection: orderDirection, intl: intl } = this.props;
        const { formatMessage: formatMessage } = intl;
        const actionCellHeader = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-test-id": "project-directories.components.table.action-cell-header-container"
        }, formatMessage($cb814f82a16d849e$var$messages.moreActions));
        const headCells = [
            {
                key: (0, $7INHA.NAME),
                content: formatMessage($cb814f82a16d849e$var$messages.component),
                width: 20,
                isSortable: true
            },
            {
                key: (0, $7INHA.DESCRIPTION),
                content: formatMessage($cb814f82a16d849e$var$messages.description),
                width: 30,
                isSortable: true
            },
            {
                key: (0, $7INHA.LEAD),
                content: formatMessage($cb814f82a16d849e$var$messages.lead),
                width: 20,
                isSortable: true
            },
            {
                content: formatMessage($cb814f82a16d849e$var$messages.defaultAssignee),
                width: 15
            },
            {
                key: (0, $7INHA.ISSUES),
                content: formatMessage($cb814f82a16d849e$var$messages.issues),
                width: 10,
                isSortable: true
            },
            {
                content: actionCellHeader,
                width: 6
            }
        ];
        const head = {
            cells: editable ? headCells : headCells.slice(0, headCells.length - 1)
        };
        const rowCells = componentIds.map((componentId, index)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = orderDirection === 'DESC' ? -(index + 1) : index + 1;
            const cells = [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb814f82a16d849e$var$ComponentCellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hELAw.default), {
                        componentId: componentId
                    })),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8q235.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iOBgN.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6BbOo.default), {
                        componentId: componentId
                    }),
                    key: key
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Ryjd.default), {
                        componentId: componentId
                    }),
                    key: key
                }
            ];
            if (editable) // @ts-expect-error - TS2345 - Argument of type '{ content: JSX.Element; }' is not assignable to parameter of type '{ content: JSX.Element; key: number; }'.
            cells.push({
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8CjRP.default), {
                    componentId: componentId
                })
            });
            return {
                cells: cells
            };
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb814f82a16d849e$var$TableContainer, {
            "data-test-id": "project-directories.components.table.table-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
            isFixedSize: true,
            head: head,
            rows: rowCells,
            onSort: onSort,
            sortKey: orderField,
            sortOrder: orderDirection,
            isLoading: isLoading,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb814f82a16d849e$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDiAG.default), null),
            label: formatMessage($cb814f82a16d849e$var$messages.componentsTableLabel)
        }));
    }
}
var $cb814f82a16d849e$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($cb814f82a16d849e$var$TableView);

});
const $44763968d5986a8d$export$1dee026a19752d6b = 'ASC';
const $44763968d5986a8d$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("8CjRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c313f2a0bca548ee$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fnVSJ = parcelRequire("fnVSJ");

var $cXEqp = parcelRequire("cXEqp");

var $46XKW = parcelRequire("46XKW");

var $j0EA8 = parcelRequire("j0EA8");

var $9PRkR = parcelRequire("9PRkR");
const $c313f2a0bca548ee$var$mapStateToProps = (state, ownProps)=>({
        showSpinner: (0, $j0EA8.showSpinner)(state, ownProps.componentId),
        name: (0, $cXEqp.getName)(state, ownProps.componentId)
    });
const $c313f2a0bca548ee$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onEdit: ()=>dispatch((0, $fnVSJ.initiateUpdateComponent)({
                id: ownProps.componentId
            })),
        onDelete: ()=>dispatch((0, $46XKW.deleteComponentStarted)({
                id: ownProps.componentId
            }))
    });
var $c313f2a0bca548ee$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($c313f2a0bca548ee$var$mapStateToProps, $c313f2a0bca548ee$var$mapDispatchToProps)((0, $9PRkR.default));

});
parcelRegister("j0EA8", function(module, exports) {

$parcel$export(module.exports, "showSpinner", () => $d934e9afe90a4296$export$2a7a135fa1ec651f);

var $KFBts = parcelRequire("KFBts");

var $35VMj = parcelRequire("35VMj");
const $d934e9afe90a4296$export$2a7a135fa1ec651f = (state, id)=>{
    if ((0, $35VMj.isInitialising)(state, id)) return true;
    return (0, $KFBts.isSpinnerVisible)(state, id);
};

});
parcelRegister("KFBts", function(module, exports) {

$parcel$export(module.exports, "isSpinnerVisible", () => $b5ca4bc67e0a5d74$export$b0b0e195937a1a6f);
$parcel$export(module.exports, "componentsBeingDeleted", () => $b5ca4bc67e0a5d74$export$fac926d1ed969680);
const $b5ca4bc67e0a5d74$export$b0b0e195937a1a6f = (state, id)=>state.ui.delete.spinner[id];
const $b5ca4bc67e0a5d74$export$fac926d1ed969680 = (state)=>state.ui.delete.componentsBeingDeleted;

});


parcelRegister("9PRkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9300c4f473d5056$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $4Bees = parcelRequire("4Bees");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9300c4f473d5056$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i7vkz _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $a9300c4f473d5056$var$messages = (0, $90IgZ.defineMessages)({
    editAction: {
        "id": "project-components.table-actions-cell-edit",
        "defaultMessage": "Edit"
    },
    deleteAction: {
        "id": "project-components.table-actions-cell-delete",
        "defaultMessage": "Delete"
    },
    moreActions: {
        "id": "project-components.table-header-more-actions",
        "defaultMessage": "More actions for {componentName}"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $a9300c4f473d5056$var$ActionsView extends (0, $eUqFw.PureComponent) {
    render() {
        const { intl: { formatMessage: formatMessage }, name: name } = this.props;
        const IconBefore = this.props.showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a9300c4f473d5056$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
            label: formatMessage($a9300c4f473d5056$var$messages.moreActions, {
                componentName: name
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            shouldRenderToParent: true,
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    iconBefore: IconBefore
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            onClick: this.onEditClicked
        }, formatMessage($a9300c4f473d5056$var$messages.editAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            onClick: this.onDeleteClicked
        }, formatMessage($a9300c4f473d5056$var$messages.deleteAction))));
    }
    constructor(...args){
        super(...args);
        this.onEditClicked = ()=>this.props.onEdit();
        this.onDeleteClicked = ()=>this.props.onDelete();
    }
}
var $a9300c4f473d5056$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($a9300c4f473d5056$var$ActionsView);

});


parcelRegister("hELAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $50618ef12565f43f$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cXEqp = parcelRequire("cXEqp");

var $2Y1sR = parcelRequire("2Y1sR");

var $5rzEK = parcelRequire("5rzEK");
const $50618ef12565f43f$var$mapStateToProps = (state, ownProps)=>({
        name: (0, $cXEqp.getName)(state, ownProps.componentId),
        issuesUrl: (0, $2Y1sR.getIssuesUrl)(state, ownProps.componentId)
    });
var $50618ef12565f43f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($50618ef12565f43f$var$mapStateToProps, {})((0, $5rzEK.default));

});
parcelRegister("5rzEK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1427a10beeea8d91$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k4hZF = parcelRequire("k4hZF");
function $1427a10beeea8d91$export$2e2bcd8739ae039(props) {
    const { name: name, issuesUrl: issuesUrl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4hZF.default), {
        // @ts-expect-error - TS2322 - Type '{ children: string; href: string; externalId: string; "data-test-id": string; }' is not assignable to type 'IntrinsicAttributes & Props'.
        href: issuesUrl,
        externalId: "project-components.table.name-cell",
        "data-test-id": "project-directories.components.table.cell.component.link"
    }, name);
}

});
parcelRegister("k4hZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $28483c16dfdea68b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $28483c16dfdea68b$var$Link(props) {
    const { children: children, ...rest } = props;
    // No need to add analytics props to the anchor tag
    delete rest.externalId;
    delete rest.externalValues;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", rest, children);
}
var $28483c16dfdea68b$export$2e2bcd8739ae039 = $28483c16dfdea68b$var$Link;

});



parcelRegister("6BbOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $adff96838f62dd38$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cXEqp = parcelRequire("cXEqp");

var $7MhsW = parcelRequire("7MhsW");
const $adff96838f62dd38$var$mapStateToProps = (state, ownProps)=>({
        defaultAssignee: (0, $cXEqp.getDefaultAssignee)(state, ownProps.componentId)
    });
var $adff96838f62dd38$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($adff96838f62dd38$var$mapStateToProps, {})((0, $7MhsW.default));

});
parcelRegister("7MhsW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2620cb79b42c23c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jh2R9 = parcelRequire("jh2R9");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");
const $2620cb79b42c23c9$var$messages = (0, $90IgZ.defineMessages)({
    componentLead: {
        "id": "project-components.table-default-assignee-cell-component-lead",
        "defaultMessage": "Component lead"
    },
    projectDefault: {
        "id": "project-components.table-default-assignee-cell-project-default",
        "defaultMessage": "Project default"
    },
    projectLead: {
        "id": "project-components.table-default-assignee-cell-project-lead",
        "defaultMessage": "Project lead"
    },
    unassigned: {
        "id": "project-components.table-default-assignee-cell-unassigned",
        "defaultMessage": "Unassigned"
    }
});
function $2620cb79b42c23c9$var$DefaultAssigneeView(props) {
    const { defaultAssignee: defaultAssignee, intl: { formatMessage: formatMessage } } = props;
    if (!defaultAssignee) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": "project-directories.components.table.cell.default-assignee"
    }, formatMessage($2620cb79b42c23c9$var$messages[(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(defaultAssignee)]));
}
var $2620cb79b42c23c9$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($2620cb79b42c23c9$var$DefaultAssigneeView);

});


parcelRegister("8q235", function(module, exports) {

$parcel$export(module.exports, "default", () => $13dfee478eb8422d$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cXEqp = parcelRequire("cXEqp");

var $6GB7i = parcelRequire("6GB7i");
const $13dfee478eb8422d$var$mapStateToProps = (state, ownProps)=>({
        description: (0, $cXEqp.getDescription)(state, ownProps.componentId)
    });
var $13dfee478eb8422d$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($13dfee478eb8422d$var$mapStateToProps, {})((0, $6GB7i.default));

});
parcelRegister("6GB7i", function(module, exports) {

$parcel$export(module.exports, "default", () => $799778ee771a9f8f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $799778ee771a9f8f$export$2e2bcd8739ae039(props) {
    const { description: description } = props;
    if (!description) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-test-id": "project-directories.components.table.cell.description"
    }, description);
}

});


parcelRegister("2Ryjd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d889e42bb21c37f8$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $cXEqp = parcelRequire("cXEqp");

var $2Y1sR = parcelRequire("2Y1sR");

var $eVzNq = parcelRequire("eVzNq");
const $d889e42bb21c37f8$var$mapStateToProps = (state, ownProps)=>({
        name: (0, $cXEqp.getName)(state, ownProps.componentId),
        number: (0, $cXEqp.getIssueCount)(state, ownProps.componentId),
        issuesUrl: (0, $2Y1sR.getIssuesUrl)(state, ownProps.componentId)
    });
var $d889e42bb21c37f8$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($d889e42bb21c37f8$var$mapStateToProps, {})((0, $eVzNq.default));

});
parcelRegister("eVzNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dadd47a4fbf7921$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k4hZF = parcelRequire("k4hZF");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");
const $0dadd47a4fbf7921$var$messages = (0, $90IgZ.defineMessages)({
    issueCount: {
        "id": "project-components.table-issues-cell-content",
        "defaultMessage": "{number} {number, plural, one {issue} other {issues}}"
    },
    ariaLabel: {
        "id": "project-components.table-issues-cell-content-aria-label",
        "defaultMessage": "{number} {number, plural, one {issue} other {issues}} for {name}"
    }
});
function $0dadd47a4fbf7921$var$IssuesView(props) {
    const { number: number, issuesUrl: issuesUrl, name: name, intl: { formatMessage: formatMessage } } = props;
    const content = formatMessage($0dadd47a4fbf7921$var$messages.issueCount, {
        number: number.toString()
    });
    const ariaLabel = formatMessage($0dadd47a4fbf7921$var$messages.ariaLabel, {
        number: number.toString(),
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4hZF.default), {
        // @ts-expect-error - TS2322 - Type '{ children: string; href: string; externalId: string; }' is not assignable to type 'IntrinsicAttributes & Props'.
        href: issuesUrl,
        externalId: "project-components.table.issues-cell",
        "aria-label": ariaLabel
    }, content);
}
var $0dadd47a4fbf7921$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($0dadd47a4fbf7921$var$IssuesView);

});


parcelRegister("iOBgN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7466335ed57c6db$export$2e2bcd8739ae039);

var $2qhQi = parcelRequire("2qhQi");

var $lNNXV = parcelRequire("lNNXV");

var $cXEqp = parcelRequire("cXEqp");

var $6crwp = parcelRequire("6crwp");

var $losCF = parcelRequire("losCF");
const $b7466335ed57c6db$var$mapStateToProps = (state, ownProps)=>({
        baseUrl: (0, $6crwp.getBaseUrl)(state),
        user: (0, $cXEqp.getLead)(state, ownProps.componentId)
    });
var $b7466335ed57c6db$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($b7466335ed57c6db$var$mapStateToProps, {})((0, $2qhQi.default)((0, $losCF.default)));

});
parcelRegister("losCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fecb25a0ee15081$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $iJlfe = parcelRequire("iJlfe");

var $aFaol = parcelRequire("aFaol");
function $7fecb25a0ee15081$export$2e2bcd8739ae039(props) {
    const { formatMessage: formatMessage } = props.intl;
    if (!props.user) return null;
    const { avatarUrl: avatarUrl, displayName: displayName, profileUrl: profileUrl, active: active } = props.user;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fecb25a0ee15081$var$Link, {
        href: profileUrl,
        "data-test-id": "project-directories.components.table.cell.lead.link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fecb25a0ee15081$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fecb25a0ee15081$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: avatarUrl,
        size: "small",
        key: "avatar"
    })), active === true ? displayName : // @ts-expect-error - TS2769: No overload matches this call.
    formatMessage((0, $aFaol.default).deactivated, {
        userName: displayName,
        status: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fecb25a0ee15081$export$a82073022ded66e8, null, text[0])
    })));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fecb25a0ee15081$var$Wrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1oy1wu6-0"
})({
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    a: {
        display: 'inline-block'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fecb25a0ee15081$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $7fecb25a0ee15081$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f3u2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $7fecb25a0ee15081$export$a82073022ded66e8 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aFaol", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e83a55f2cf9c6d9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6e83a55f2cf9c6d9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deactivated: {
        "id": "project-components.lead.deactivated-status",
        "defaultMessage": "{userName} <status>(Deactivated)</status>"
    }
});

});



parcelRegister("dDiAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c4f64c66213e42$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $220ac = parcelRequire("220ac");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");

var $hNxzx = parcelRequire("hNxzx");
const $24c4f64c66213e42$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "project-components.filter-no-results-nothing-matched-your-search",
        "defaultMessage": "We didn't find any components that matched your search"
    },
    emptyStateMessageDescription: {
        "id": "project-components.filter-no-results-nothing-matched-your-search-description",
        "defaultMessage": "Try using specific component names or terms."
    }
});
function $24c4f64c66213e42$var$EmptyView(props) {
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hNxzx))),
        header: formatMessage($24c4f64c66213e42$var$messages.header),
        description: formatMessage($24c4f64c66213e42$var$messages.emptyStateMessageDescription),
        headingLevel: 2,
        size: "narrow"
    });
}
var $24c4f64c66213e42$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($24c4f64c66213e42$var$EmptyView);

});
parcelRegister("hNxzx", function(module, exports) {
module.exports = new URL("empty.565fbc78.svg", import.meta.url).toString();

});




parcelRegister("cPXuY", function(module, exports) {

$parcel$export(module.exports, "HeaderBottombarContent", () => $ba2cf5f57d4486fb$export$503cbcd19e8ae377);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $3QLcd = parcelRequire("3QLcd");

var $jMP2a = parcelRequire("jMP2a");


var $7CJEq = parcelRequire("7CJEq");
const $ba2cf5f57d4486fb$export$503cbcd19e8ae377 = (props)=>{
    const { isGlobalComponentsEnabled: isGlobalComponentsEnabled, searchBar: searchBar, formatMessage: formatMessage } = props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const learnMoreOnClick = (_, analyticEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticEvent, isGlobalComponentsEnabled ? 'learnMoreAboutCompassComponentsLink' : 'learnMoreAboutJiraComponentsLink');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: isGlobalComponentsEnabled ? 'project-directories.components.content.compass-header-content' : 'project-directories.components.content.jira-header-content',
        xcss: $ba2cf5f57d4486fb$var$compassHeaderTextStyles,
        paddingBlockEnd: "space.300"
    }, formatMessage(isGlobalComponentsEnabled ? (0, $7CJEq.default).headerCompass : (0, $7CJEq.default).headerJira, {
        link: (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3QLcd.default), {
                articleId: isGlobalComponentsEnabled ? (0, $4de8793669bf0872$export$46b2089262397762) : (0, $4de8793669bf0872$export$d519c2877b8b5078),
                appearance: "link",
                onClick: learnMoreOnClick,
                spacing: "none",
                fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    href: isGlobalComponentsEnabled ? (0, $4de8793669bf0872$export$6b933388fae9d233) : (0, $4de8793669bf0872$export$c0a683dd07e215fe),
                    target: "_blank",
                    onClick: learnMoreOnClick,
                    appearance: "link",
                    spacing: "none"
                }, text)
            }, text)
    })), !isGlobalComponentsEnabled && searchBar);
};
const $ba2cf5f57d4486fb$var$compassHeaderTextStyles = (0, $1ZAYh.xcss)({
    width: '611px'
});

});
parcelRegister("7CJEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e68fe47e23195db2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e68fe47e23195db2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    headerCompass: {
        "id": "project-components.compass-header",
        "defaultMessage": "Group and track work around components of your software architecture, cataloged in Compass. <link>Learn more about Compass components</link>"
    },
    headerJira: {
        "id": "project-components.jira-header",
        "defaultMessage": "Group and assign work around features, departments, or workstreams specific to your project. <link>Learn more about Jira Components</link>"
    }
});

});


parcelRegister("6hheN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0789df92809bac31$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0789df92809bac31$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    filterInputLabel: {
        "id": "project.directories.components.header.filterInputLabel",
        "defaultMessage": "Filter components"
    },
    addComponent: {
        "id": "project-components.add-component.trigger",
        "defaultMessage": "Create component"
    },
    caption: {
        "id": "project-components.header-caption",
        "defaultMessage": "Components"
    },
    successFlagTitle: {
        "id": "project-components.add-component.success-flag-title",
        "defaultMessage": "Success"
    },
    successFlagDescription: {
        "id": "project-components.add-component.success-flag-description",
        "defaultMessage": "New component was created successfully"
    }
});

});



parcelRegister("9DtAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab78a85aeb533a6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ey9Sx = parcelRequire("ey9Sx");

var $8v7rm = parcelRequire("8v7rm");

var $2r0Sq = parcelRequire("2r0Sq");
function $dab78a85aeb533a6$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8v7rm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2r0Sq.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ey9Sx.default), null));
}

});
parcelRegister("ey9Sx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6228d84a2f974490$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $KFBts = parcelRequire("KFBts");

var $bn2ux = parcelRequire("bn2ux");
const $6228d84a2f974490$var$mapStateToProps = (state)=>({
        componentsBeingDeleted: (0, $KFBts.componentsBeingDeleted)(state)
    });
var $6228d84a2f974490$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($6228d84a2f974490$var$mapStateToProps, {})((0, $bn2ux.default));

});
parcelRegister("bn2ux", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d7ee2c7c2c8535$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kjaJh = parcelRequire("kjaJh");
function $02d7ee2c7c2c8535$var$ViewComponent(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, props.componentsBeingDeleted.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjaJh.default), {
            id: id,
            key: id
        })));
}
var $02d7ee2c7c2c8535$export$2e2bcd8739ae039 = $02d7ee2c7c2c8535$var$ViewComponent;

});
parcelRegister("kjaJh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6417fae63d2dcfb3$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $fnVSJ = parcelRequire("fnVSJ");

var $jmbhM = parcelRequire("jmbhM");

var $cXEqp = parcelRequire("cXEqp");

var $6crwp = parcelRequire("6crwp");

var $dlLXy = parcelRequire("dlLXy");

var $2Y1sR = parcelRequire("2Y1sR");

var $46XKW = parcelRequire("46XKW");

var $65cqc = parcelRequire("65cqc");
const $6417fae63d2dcfb3$var$mapStateToProps = (state, { id: id })=>({
        component: (0, $cXEqp.getComponent)(state, id),
        projectKey: (0, $dlLXy.getProjectKey)(state),
        baseUrl: (0, $6crwp.getBaseUrl)(state),
        locale: (0, $6crwp.getLocale)(state),
        analyticsData: (0, $jmbhM.get)(state),
        relatedIssueUrl: (0, $2Y1sR.getIssuesUrl)(state, id)
    });
const $6417fae63d2dcfb3$var$mapDispatchToProps = (dispatch, { id: id })=>({
        onPatchComponentIssueCount: (issueCount)=>{
            dispatch((0, $fnVSJ.patchComponent)({
                id: id,
                component: {
                    issueCount: issueCount
                }
            }));
        },
        onDeleteComponentSuccessful: (component)=>{
            dispatch((0, $fnVSJ.deleteComponentSuccess)({
                id: id,
                component: component
            }));
        },
        onDeleteComponentFailure: (error, isDialogOpen)=>{
            dispatch((0, $fnVSJ.deleteComponentFailure)({
                id: id,
                error: error,
                isDialogOpen: isDialogOpen
            }));
        },
        onDeleteDialogDisplay: ()=>{
            dispatch((0, $46XKW.deleteComponentDialogDisplayed)({
                id: id
            }));
        },
        onDeleteDialogCancel: ()=>{
            dispatch((0, $46XKW.deleteComponentCancel)({
                id: id
            }));
        }
    });
var $6417fae63d2dcfb3$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($6417fae63d2dcfb3$var$mapStateToProps, $6417fae63d2dcfb3$var$mapDispatchToProps)((0, $65cqc.default));

});
parcelRegister("65cqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6072d298ac6e8902$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $4jVNL = parcelRequire("4jVNL");
// component name is handled via state because we want to show component name when dialog fades out
// eslint-disable-next-line jira/react/no-class-components
class $6072d298ac6e8902$var$ViewComponent extends (0, $eUqFw.PureComponent) {
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { component: component, relatedIssueUrl: relatedIssueUrl } = nextProps;
        if (component && this.state.component !== component) this.setState({
            component: component
        });
        if (relatedIssueUrl && this.state.url !== relatedIssueUrl) this.setState({
            url: relatedIssueUrl
        });
    }
    render() {
        const { component: { name: name, issueCount: issueCount }, url: url } = this.state;
        const { id: id, locale: locale, projectKey: projectKey, analyticsData: analyticsData, baseUrl: baseUrl, onDeleteComponentFailure: onDeleteComponentFailure, onDeleteDialogDisplay: onDeleteDialogDisplay, onDeleteDialogCancel: onDeleteDialogCancel, onPatchComponentIssueCount: onPatchComponentIssueCount } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jVNL.default), {
            onFail: onDeleteComponentFailure,
            onSuccessful: this.onDeleteComponentSuccessful,
            onDialogDisplay: onDeleteDialogDisplay,
            onIssueCountFetched: onPatchComponentIssueCount,
            onDialogCancel: onDeleteDialogCancel,
            id: id,
            locale: locale,
            analyticsData: analyticsData,
            relatedIssueCount: issueCount,
            relatedIssueUrl: url,
            name: name,
            projectKey: projectKey,
            baseUrl: baseUrl
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            component: this.props.component,
            url: this.props.relatedIssueUrl
        };
        this.onDeleteComponentSuccessful = ()=>{
            this.props.onDeleteComponentSuccessful(this.state.component);
        };
    }
}
var $6072d298ac6e8902$export$2e2bcd8739ae039 = $6072d298ac6e8902$var$ViewComponent;

});
parcelRegister("4jVNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $275d2f427f2449e1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $8dloj = parcelRequire("8dloj");

var $5BRby = parcelRequire("5BRby");

var $aR8n6 = parcelRequire("aR8n6");

var $ibxfK = parcelRequire("ibxfK");

var $5UlZR = parcelRequire("5UlZR");

var $fcZNZ = parcelRequire("fcZNZ");

var $b7bSl = parcelRequire("b7bSl");

var $4tS5d = parcelRequire("4tS5d");
const $275d2f427f2449e1$var$pickContextFromProps = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(props, [
        'id',
        'name',
        'baseUrl',
        'projectKey',
        'locale',
        'analyticsData',
        'relatedIssueCount',
        'relatedIssueUrl'
    ]);
const $275d2f427f2449e1$var$pickCallbackFromProps = (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(props, [
        'onIssueCountFetched',
        'onSuccessful',
        'onFail',
        'onDialogDisplay',
        'onDialogCancel'
    ]);
class $275d2f427f2449e1$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.store = (0, $5UlZR.default)((0, $ibxfK.default), this.props.name);
        this.setAppProps(this.props);
    }
    componentDidMount() {
        this.store.dispatch((0, $b7bSl.deleteComponentRequest)());
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props, nextProps)) this.setAppProps(nextProps);
    }
    setAppProps(props) {
        this.store.dispatch((0, $fcZNZ.setAppProps)({
            context: $275d2f427f2449e1$var$pickContextFromProps(props),
            callbacks: $275d2f427f2449e1$var$pickCallbackFromProps(props)
        }));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4tS5d.default), null)));
    }
}

});
parcelRegister("ibxfK", function(module, exports) {

$parcel$export(module.exports, "default", () => $a20c28c9d3644032$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $axQ3k = parcelRequire("axQ3k");

var $aaSTz = parcelRequire("aaSTz");
const $a20c28c9d3644032$var$rootEpic = (0, $bd1K7.combineEpics)((0, $aaSTz.deleteComponentRequest), (0, $aaSTz.deleteComponentSafe), (0, $aaSTz.deleteComponentConfirmed), (0, $axQ3k.dialogDisplayed), (0, $axQ3k.componentDeleted), (0, $axQ3k.failure), (0, $axQ3k.cancel));
var $a20c28c9d3644032$export$2e2bcd8739ae039 = $a20c28c9d3644032$var$rootEpic;

});
parcelRegister("axQ3k", function(module, exports) {

$parcel$export(module.exports, "dialogDisplayed", () => $78976f5b4df40f9d$export$c57e151085f519af);
$parcel$export(module.exports, "componentDeleted", () => $78976f5b4df40f9d$export$b986928a2f340a61);
$parcel$export(module.exports, "failure", () => $78976f5b4df40f9d$export$af2dba6db4e9e1f0);
$parcel$export(module.exports, "cancel", () => $78976f5b4df40f9d$export$70b61ad426ddbe54);
parcelRequire("8jBvP");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $b7bSl = parcelRequire("b7bSl");

var $7kgGV = parcelRequire("7kgGV");

var $gpLlx = parcelRequire("gpLlx");
const $78976f5b4df40f9d$export$c57e151085f519af = (action$, store)=>action$.ofType((0, $b7bSl.DELETE_COMPONENT_CONFIRMATION)).mergeMap(()=>{
        (0, $7kgGV.onDialogDisplay)(store.getState())();
        return (0, $3JafE.Observable).empty();
    });
const $78976f5b4df40f9d$export$b986928a2f340a61 = (action$, store)=>action$.ofType((0, $b7bSl.DELETE_COMPONENT_SUCCESS)).mergeMap(()=>{
        (0, $7kgGV.onSuccessful)(store.getState())();
        return (0, $3JafE.Observable).empty();
    });
const $78976f5b4df40f9d$export$af2dba6db4e9e1f0 = (action$, store)=>action$.ofType((0, $b7bSl.DELETE_COMPONENT_FAIL)).mergeMap((action)=>{
        const { payload: { error: error } } = action;
        const state = store.getState();
        (0, $7kgGV.onFail)(state)(error, (0, $gpLlx.isDialogOpen)(state));
        return (0, $3JafE.Observable).empty();
    });
const $78976f5b4df40f9d$export$70b61ad426ddbe54 = (action$, store)=>action$.ofType((0, $b7bSl.CANCEL)).mergeMap(()=>{
        (0, $7kgGV.onDialogCancel)(store.getState())();
        return (0, $3JafE.Observable).empty();
    });

});
parcelRegister("b7bSl", function(module, exports) {

$parcel$export(module.exports, "DELETE_COMPONENT_REQUEST", () => $5440985c0de707fa$export$24e2bdb9f02e5fb4);
$parcel$export(module.exports, "deleteComponentRequest", () => $5440985c0de707fa$export$e4a1f64fe436caf8);
$parcel$export(module.exports, "DELETE_COMPONENT_SAFE", () => $5440985c0de707fa$export$38c2b9f6b042ef0f);
$parcel$export(module.exports, "deleteComponentSafe", () => $5440985c0de707fa$export$624d4d9a2c81f4fc);
$parcel$export(module.exports, "DELETE_COMPONENT_CONFIRMATION", () => $5440985c0de707fa$export$b831980d93222685);
$parcel$export(module.exports, "deleteComponentConfirmation", () => $5440985c0de707fa$export$ad2794195cfdcdd1);
$parcel$export(module.exports, "DELETE_COMPONENT_CONFIRMED", () => $5440985c0de707fa$export$ee9d0d88840ce8bd);
$parcel$export(module.exports, "deleteComponentConfirmed", () => $5440985c0de707fa$export$45e8f2bd48b3a662);
$parcel$export(module.exports, "DELETE_COMPONENT_SUCCESS", () => $5440985c0de707fa$export$da077ae08c543bd0);
$parcel$export(module.exports, "deleteComponentSuccess", () => $5440985c0de707fa$export$8d34c79dac47f8f3);
$parcel$export(module.exports, "DELETE_COMPONENT_FAIL", () => $5440985c0de707fa$export$4520c4bcba87d72a);
$parcel$export(module.exports, "deleteComponentFail", () => $5440985c0de707fa$export$5698fe655dd4ff82);
$parcel$export(module.exports, "CANCEL", () => $5440985c0de707fa$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $5440985c0de707fa$export$70b61ad426ddbe54);
const $5440985c0de707fa$export$24e2bdb9f02e5fb4 = 'state.actions.DELETE_COMPONENT_REQUEST';
const $5440985c0de707fa$export$e4a1f64fe436caf8 = ()=>({
        type: $5440985c0de707fa$export$24e2bdb9f02e5fb4
    });
const $5440985c0de707fa$export$38c2b9f6b042ef0f = 'state.actions.DELETE_COMPONENT_SAFE';
const $5440985c0de707fa$export$624d4d9a2c81f4fc = ()=>({
        type: $5440985c0de707fa$export$38c2b9f6b042ef0f
    });
const $5440985c0de707fa$export$b831980d93222685 = 'state.actions.DELETE_COMPONENT_CONFIRMATION';
const $5440985c0de707fa$export$ad2794195cfdcdd1 = ()=>({
        type: $5440985c0de707fa$export$b831980d93222685
    });
const $5440985c0de707fa$export$ee9d0d88840ce8bd = 'state.actions.DELETE_COMPONENT_CONFIRMED';
const $5440985c0de707fa$export$45e8f2bd48b3a662 = (payload)=>({
        type: $5440985c0de707fa$export$ee9d0d88840ce8bd,
        payload: payload
    });
const $5440985c0de707fa$export$da077ae08c543bd0 = 'state.actions.DELETE_COMPONENT_SUCCESS';
const $5440985c0de707fa$export$8d34c79dac47f8f3 = ()=>({
        type: $5440985c0de707fa$export$da077ae08c543bd0
    });
const $5440985c0de707fa$export$4520c4bcba87d72a = 'state.actions.DELETE_COMPONENT_FAIL';
const $5440985c0de707fa$export$5698fe655dd4ff82 = (payload)=>({
        type: $5440985c0de707fa$export$4520c4bcba87d72a,
        payload: payload
    });
const $5440985c0de707fa$export$2b10f4b30fb65583 = 'state.actions.CANCEL';
const $5440985c0de707fa$export$70b61ad426ddbe54 = ()=>({
        type: $5440985c0de707fa$export$2b10f4b30fb65583
    });

});

parcelRegister("7kgGV", function(module, exports) {

$parcel$export(module.exports, "onIssueCountFetched", () => $c7ac9da212a25610$export$363d6ea633d615fc);
$parcel$export(module.exports, "onSuccessful", () => $c7ac9da212a25610$export$d5d6a762d03166fa);
$parcel$export(module.exports, "onFail", () => $c7ac9da212a25610$export$5d3242f81f2f2d43);
$parcel$export(module.exports, "onDialogDisplay", () => $c7ac9da212a25610$export$4a76bd015b2d4167);
$parcel$export(module.exports, "onDialogCancel", () => $c7ac9da212a25610$export$ac3df3705c165fdc);
const $c7ac9da212a25610$export$363d6ea633d615fc = (state)=>state.callbacks.onIssueCountFetched;
const $c7ac9da212a25610$export$d5d6a762d03166fa = (state)=>state.callbacks.onSuccessful;
const $c7ac9da212a25610$export$5d3242f81f2f2d43 = (state)=>state.callbacks.onFail;
const $c7ac9da212a25610$export$4a76bd015b2d4167 = (state)=>state.callbacks.onDialogDisplay;
const $c7ac9da212a25610$export$ac3df3705c165fdc = (state)=>state.callbacks.onDialogCancel;

});

parcelRegister("gpLlx", function(module, exports) {

$parcel$export(module.exports, "isDialogOpen", () => $3683885c765db254$export$61d407d1c7ec6926);
$parcel$export(module.exports, "isInProgress", () => $3683885c765db254$export$350bfa81fecdb6f3);
const $3683885c765db254$export$61d407d1c7ec6926 = (state)=>state.ui.requiresConfirmation;
const $3683885c765db254$export$350bfa81fecdb6f3 = (state)=>state.ui.deleteInProgress;

});


parcelRegister("aaSTz", function(module, exports) {

$parcel$export(module.exports, "deleteComponentRequest", () => $6c1239021d88ac85$export$e4a1f64fe436caf8);
$parcel$export(module.exports, "deleteComponentSafe", () => $6c1239021d88ac85$export$624d4d9a2c81f4fc);
$parcel$export(module.exports, "deleteComponentConfirmed", () => $6c1239021d88ac85$export$45e8f2bd48b3a662);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $3JafE = parcelRequire("3JafE");

var $5ysFK = parcelRequire("5ysFK");


var $M7obw = parcelRequire("M7obw");

var $b7bSl = parcelRequire("b7bSl");

var $7kgGV = parcelRequire("7kgGV");

var $8XItQ = parcelRequire("8XItQ");
const $6c1239021d88ac85$var$LOG_LOCATION = 'project-components.state.epics.delete';
const $6c1239021d88ac85$var$deleteComponentPerform = (moveIssuesTo, store)=>{
    const state = store.getState();
    const baseUrl = (0, $8XItQ.getBaseUrl)(state);
    const id = (0, $8XItQ.getComponentId)(state);
    return (0, $3JafE.Observable).fromPromise((0, $M7obw.deleteComponent)(baseUrl, id, moveIssuesTo)).flatMap(()=>(0, $3JafE.Observable).of((0, $b7bSl.deleteComponentSuccess)())).catch((error)=>{
        (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, $6c1239021d88ac85$var$LOG_LOCATION, (0, $3cf121f5a28af65f$export$1089831196ae0f84));
        return (0, $3JafE.Observable).of((0, $b7bSl.deleteComponentFail)({
            error: error
        }));
    });
};
const $6c1239021d88ac85$export$e4a1f64fe436caf8 = (action$, store)=>action$.ofType((0, $b7bSl.DELETE_COMPONENT_REQUEST)).mergeMap(()=>{
        const id = (0, $8XItQ.getComponentId)(store.getState());
        return (0, $3JafE.Observable).fromPromise((0, $M7obw.getComponentRelatedIssueCount)((0, $8XItQ.getBaseUrl)(store.getState()), id)).mergeMap((result)=>{
            const state = store.getState();
            (0, $7kgGV.onIssueCountFetched)(state)(result.issueCount);
            if (result.issueCount === 0) return (0, $3JafE.Observable).of((0, $b7bSl.deleteComponentSafe)());
            return (0, $3JafE.Observable).of((0, $b7bSl.deleteComponentConfirmation)());
        }).catch((error)=>{
            (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, $6c1239021d88ac85$var$LOG_LOCATION, (0, $3cf121f5a28af65f$export$1089831196ae0f84));
            return (0, $3JafE.Observable).of((0, $b7bSl.deleteComponentFail)({
                error: error
            }));
        });
    });
const $6c1239021d88ac85$export$624d4d9a2c81f4fc = (action$, store)=>action$.ofType((0, $b7bSl.DELETE_COMPONENT_SAFE)).mergeMap(()=>$6c1239021d88ac85$var$deleteComponentPerform(undefined, store));
const $6c1239021d88ac85$export$45e8f2bd48b3a662 = (action$, store)=>action$.ofType((0, $b7bSl.DELETE_COMPONENT_CONFIRMED)).mergeMap((action)=>$6c1239021d88ac85$var$deleteComponentPerform(action.payload, store));

});
parcelRegister("M7obw", function(module, exports) {

$parcel$export(module.exports, "deleteComponent", () => $a0ab65cf9121b91f$export$b131bf5b3493873b);
$parcel$export(module.exports, "getComponentRelatedIssueCount", () => $a0ab65cf9121b91f$export$4adab71254d91864);

var $gyj10 = parcelRequire("gyj10");

var $gUUjF = parcelRequire("gUUjF");

var $7EhAs = parcelRequire("7EhAs");

var $2b8pB = parcelRequire("2b8pB");

var $bv7BK = parcelRequire("bv7BK");
const $a0ab65cf9121b91f$export$b131bf5b3493873b = async (baseUrl, componentId, moveIssuesTo)=>{
    const result = await (0, $bv7BK.deleteComponent)(baseUrl, componentId, moveIssuesTo);
    if (result.ok) {
        try {
            componentId && (0, $gyj10.default).remove(componentId.toString());
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('project-directories.components.cache.remove', error.message);
        }
        return {
            id: componentId
        };
    }
    const error = await (0, $2b8pB.getErrorMessage)(result);
    throw new (0, $7EhAs.default)(result.status, error);
};
const $a0ab65cf9121b91f$export$4adab71254d91864 = async (baseUrl, componentId)=>{
    const result = await (0, $bv7BK.getComponentRelatedIssueCount)(baseUrl, componentId);
    if (result.ok) {
        const json = await result.json();
        return {
            id: componentId,
            issueCount: json.issueCount
        };
    }
    const error = await (0, $2b8pB.getErrorMessage)(result);
    throw new (0, $7EhAs.default)(result.status, error);
};

});
parcelRegister("2b8pB", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", () => $4fb00790b24f4cef$export$82f46aa4e6535a45);
const $4fb00790b24f4cef$export$82f46aa4e6535a45 = async (response)=>{
    try {
        const json = await response.json();
        return json.errorMessages[0] || '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return '';
    }
};

});

parcelRegister("bv7BK", function(module, exports) {

$parcel$export(module.exports, "deleteComponent", () => $ca1b8b7fb8b007f3$export$b131bf5b3493873b);
$parcel$export(module.exports, "getComponentRelatedIssueCount", () => $ca1b8b7fb8b007f3$export$4adab71254d91864);

var $1M0d5 = parcelRequire("1M0d5");
const $ca1b8b7fb8b007f3$var$getUrl = (baseUrl, componentId)=>`${baseUrl}/rest/api/2/component/${componentId}`;
const $ca1b8b7fb8b007f3$export$b131bf5b3493873b = async (baseUrl, componentId, moveIssuesTo)=>{
    const queryString = moveIssuesTo ? `?moveIssuesTo=${moveIssuesTo}` : '';
    const fullUrl = `${$ca1b8b7fb8b007f3$var$getUrl(baseUrl, componentId)}${queryString}`;
    return fetch(fullUrl, (0, $1M0d5.createOptions)('DELETE'));
};
const $ca1b8b7fb8b007f3$export$4adab71254d91864 = async (baseUrl, componentId)=>{
    const fullUrl = `${$ca1b8b7fb8b007f3$var$getUrl(baseUrl, componentId)}/relatedIssueCounts`;
    return fetch(fullUrl, (0, $1M0d5.createOptions)('GET'));
};

});


parcelRegister("8XItQ", function(module, exports) {

$parcel$export(module.exports, "getContext", () => $f955470353b05be7$export$31553aaa555c1514);
$parcel$export(module.exports, "getComponentId", () => $f955470353b05be7$export$19f56ea1d359a013);
$parcel$export(module.exports, "getBaseUrl", () => $f955470353b05be7$export$f654b28f82155665);
const $f955470353b05be7$export$31553aaa555c1514 = (state)=>state.context;
const $f955470353b05be7$export$19f56ea1d359a013 = (state)=>$f955470353b05be7$export$31553aaa555c1514(state).id;
const $f955470353b05be7$export$f654b28f82155665 = (state)=>$f955470353b05be7$export$31553aaa555c1514(state).baseUrl;
const $f955470353b05be7$export$128e6d32dd8f7139 = (state)=>$f955470353b05be7$export$31553aaa555c1514(state).analyticsData;

});



parcelRegister("5UlZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e57f77be4605cd2$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $MYW4e = parcelRequire("MYW4e");

var $bd1K7 = parcelRequire("bd1K7");

var $lfZsG = parcelRequire("lfZsG");

var $czGdf = parcelRequire("czGdf");

var $3QDYk = parcelRequire("3QDYk");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2e57f77be4605cd2$export$2e2bcd8739ae039 = (rootOperation, name)=>{
    const middlewares = [];
    if ((0, $lfZsG.debugEnabled)('redux-logger')) {
        // include logger only for development environment
        // eslint-disable-next-line @typescript-eslint/no-require-imports, @typescript-eslint/no-var-requires
        const { logger: logger } = (parcelRequire("iFajX"));
        middlewares.push(logger);
    }
    return (0, $huRi7.createStore)((0, $MYW4e.enableBatching)((0, $3QDYk.default)), undefined, (0, $czGdf.default)({
        name: `Delete component '${name}'`
    })((0, $huRi7.applyMiddleware)(...middlewares, (0, $bd1K7.createEpicMiddleware)(rootOperation))));
};

});
parcelRegister("3QDYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $57fe1c146bbab0fd$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $4G9sr = parcelRequire("4G9sr");

var $1Ol64 = parcelRequire("1Ol64");

var $9NQxL = parcelRequire("9NQxL");
const $57fe1c146bbab0fd$var$combinedReducer = (0, $huRi7.combineReducers)({
    ui: $9NQxL.default,
    callbacks: $4G9sr.default,
    context: $1Ol64.default
});
var $57fe1c146bbab0fd$export$2e2bcd8739ae039 = $57fe1c146bbab0fd$var$combinedReducer;

});
parcelRegister("4G9sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4aa3e47a95b3049$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $jG2Eu = parcelRequire("jG2Eu");

var $fcZNZ = parcelRequire("fcZNZ");
const $f4aa3e47a95b3049$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    onIssueCountFetched: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onSuccessful: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onFail: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onDialogDisplay: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
    onDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4aa3e47a95b3049$export$2e2bcd8739ae039 = (state = $f4aa3e47a95b3049$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fcZNZ.SET_APP_PROPS:
            return (0, $6HC1D.assign)(state, action.payload.callbacks);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});
parcelRegister("fcZNZ", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $74fa7551e3d034af$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $74fa7551e3d034af$export$cfda7627848a58cd);
const $74fa7551e3d034af$export$8aefe701a6f431e0 = 'state.actions.SET_APP_PROPS';
const $74fa7551e3d034af$export$cfda7627848a58cd = (payload)=>({
        type: $74fa7551e3d034af$export$8aefe701a6f431e0,
        payload: payload
    });

});


parcelRegister("1Ol64", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b63e92133e0428$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $ao0hp = parcelRequire("ao0hp");

var $fcZNZ = parcelRequire("fcZNZ");
const $c6b63e92133e0428$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    id: '',
    name: '',
    locale: (0, $ao0hp.defaultLocale),
    baseUrl: '',
    projectKey: '',
    analyticsData: {
        projectType: ''
    },
    relatedIssueCount: 0,
    relatedIssueUrl: ''
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6b63e92133e0428$export$2e2bcd8739ae039 = (state = $c6b63e92133e0428$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fcZNZ.SET_APP_PROPS:
            return (0, $6HC1D.assign)(state, action.payload.context);
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};

});

parcelRegister("9NQxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cee2ed8c7bfca0c$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $b7bSl = parcelRequire("b7bSl");
const $9cee2ed8c7bfca0c$export$d4c72bab9d6cc13a = (0, $6HC1D.freeze)({
    requiresConfirmation: false,
    deleteInProgress: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9cee2ed8c7bfca0c$export$2e2bcd8739ae039 = (state = $9cee2ed8c7bfca0c$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $b7bSl.CANCEL:
            return (0, $6HC1D.assign)(state, {
                requiresConfirmation: false,
                deleteInProgress: false
            });
        case 0, $b7bSl.DELETE_COMPONENT_FAIL:
            return (0, $6HC1D.assign)(state, {
                deleteInProgress: false
            });
        case 0, $b7bSl.DELETE_COMPONENT_SAFE:
        case 0, $b7bSl.DELETE_COMPONENT_CONFIRMED:
            return (0, $6HC1D.assign)(state, {
                deleteInProgress: true
            });
        case 0, $b7bSl.DELETE_COMPONENT_CONFIRMATION:
            return (0, $6HC1D.assign)(state, {
                requiresConfirmation: true
            });
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});



parcelRegister("4tS5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35aaff0418662a7$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $b7bSl = parcelRequire("b7bSl");

var $8XItQ = parcelRequire("8XItQ");

var $gpLlx = parcelRequire("gpLlx");

var $3XQfI = parcelRequire("3XQfI");
const $a35aaff0418662a7$var$mapStateToProps = (state)=>({
        context: (0, $8XItQ.getContext)(state),
        isDialogOpen: (0, $gpLlx.isDialogOpen)(state),
        isInProgress: (0, $gpLlx.isInProgress)(state)
    });
const $a35aaff0418662a7$var$mapDispatchToProps = (dispatch)=>({
        onCancel: ()=>{
            dispatch((0, $b7bSl.cancel)());
        },
        onConfirm: (moveIssuesTo)=>{
            dispatch((0, $b7bSl.deleteComponentConfirmed)(moveIssuesTo));
        }
    });
var $a35aaff0418662a7$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($a35aaff0418662a7$var$mapStateToProps, $a35aaff0418662a7$var$mapDispatchToProps)((0, $3XQfI.default));

});
parcelRegister("3XQfI", function(module, exports) {

$parcel$export(module.exports, "default", () => $37267946956ba776$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $hnuwz = parcelRequire("hnuwz");

var $4Bees = parcelRequire("4Bees");

var $kGQen = parcelRequire("kGQen");

var $bSjuI = parcelRequire("bSjuI");

var $giAhk = parcelRequire("giAhk");

var $bhDR2 = parcelRequire("bhDR2");
class $37267946956ba776$var$ViewComponent extends (0, $eUqFw.Component) {
    getMoveIssuesTo() {
        const { shouldSwap: shouldSwap, swapComponent: swapComponent } = this.state;
        if (shouldSwap && swapComponent) return swapComponent.id;
        return undefined;
    }
    isDeleteDisabled() {
        if (this.state.shouldSwap) return !this.state.swapComponent;
        return this.props.isInProgress;
    }
    render() {
        const { context: { baseUrl: baseUrl, projectKey: projectKey, id: componentId, relatedIssueCount: relatedIssueCount, relatedIssueUrl: relatedIssueUrl, name: name }, onCancel: onCancel, isDialogOpen: isDialogOpen, intl: { formatMessage: formatMessage } } = this.props;
        const { shouldSwap: shouldSwap } = this.state;
        const dialogDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: relatedIssueUrl
        }, formatMessage((0, $bhDR2.default).deleteComponentWarningLink, {
            relatedIssueCount: relatedIssueCount
        })), ' ', formatMessage((0, $bhDR2.default).deleteComponentWillAffectIssues, {
            relatedIssueCount: relatedIssueCount
        }), ' ', formatMessage((0, $bhDR2.default).deleteComponentYouCanChangeIssues, {
            relatedIssueCount: relatedIssueCount
        }));
        if (!isDialogOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
            width: "medium",
            onClose: onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
            appearance: "danger",
            isMultiline: false
        }, formatMessage((0, $bhDR2.default).headerNew, {
            component: name
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, dialogDescription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $37267946956ba776$var$deleteOptionsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            name: "swap-option-swap",
            isChecked: shouldSwap,
            onChange: this.onSwapComponentsSelected,
            label: formatMessage((0, $bhDR2.default).changeComponentRadio)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($37267946956ba776$var$ComponentPickerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSjuI.default), {
            baseUrl: baseUrl,
            projectKeyOrId: projectKey,
            ignore: [
                componentId
            ],
            placeholder: formatMessage((0, $bhDR2.default).componentPickerPlaceholder),
            onSelected: this.onSwapComponentChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            name: "swap-option-remove",
            isChecked: !shouldSwap,
            onChange: this.onRemoveComponentFromIssuesSelected,
            label: formatMessage((0, $bhDR2.default).removeComponentRadio)
        }))), this.renderFooter())));
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldSwap: true,
            swapComponent: undefined
        };
        this.onPrimaryClick = ()=>{
            const moveIssuesTo = this.getMoveIssuesTo();
            this.props.onConfirm(moveIssuesTo);
        };
        this.onSwapComponentsSelected = ()=>{
            this.setState({
                shouldSwap: true
            });
        };
        this.onRemoveComponentFromIssuesSelected = ()=>{
            this.setState({
                shouldSwap: false
            });
        };
        this.onSwapComponentChange = (components)=>{
            this.setState({
                swapComponent: components && components[0]
            });
        };
        this.renderFooter = ()=>{
            const { isInProgress: isInProgress, onCancel: onCancel, intl: { formatMessage: formatMessage } } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($37267946956ba776$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($37267946956ba776$var$ButtonsContainer, null, isInProgress && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $37267946956ba776$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "subtle-link",
                isDisabled: isInProgress,
                onClick: onCancel
            }, formatMessage((0, $bhDR2.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "danger",
                type: "submit",
                isDisabled: this.isDeleteDisabled(),
                onClick: this.onPrimaryClick
            }, formatMessage((0, $bhDR2.default).deleteButton)))));
        };
    }
}
var $37267946956ba776$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($37267946956ba776$var$ViewComponent);
const $37267946956ba776$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $37267946956ba776$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.200'
});
const $37267946956ba776$var$deleteOptionsContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37267946956ba776$var$FooterContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $37267946956ba776$var$ComponentPickerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv _18s811d5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

const $306a59ce4e6b6146$var$packageName = "platform-pkg";
const $306a59ce4e6b6146$var$packageVersion = "0.0.0-use.local";
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});

parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});



parcelRegister("bSjuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $419190de630ee690$export$2e2bcd8739ae039);

var $03s9a = parcelRequire("03s9a");
var $419190de630ee690$export$2e2bcd8739ae039 = (0, $03s9a.default);

});
parcelRegister("03s9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58fc85fdd0f6d33$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $eydoe = parcelRequire("eydoe");

var $lDnwy = parcelRequire("lDnwy");

var $giAhk = parcelRequire("giAhk");

var $kFCTM = parcelRequire("kFCTM");

var $jDI3D = parcelRequire("jDI3D");
const $c58fc85fdd0f6d33$var$optionFromComponent = (component)=>({
        value: component.id,
        label: component.name
    });
const $c58fc85fdd0f6d33$var$componentFromOption = (option)=>({
        id: option.value,
        name: option.label
    });
const $c58fc85fdd0f6d33$var$hasSameComponentIds = (newComponents, oldComponents)=>{
    if (newComponents === undefined || oldComponents === undefined) return newComponents === oldComponents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eydoe)))(newComponents, oldComponents, 'id').length === 0;
};
class $c58fc85fdd0f6d33$export$893706da3f9272af extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isMulti: false,
            isClearableWithCrossIcon: false,
            selectedComponents: undefined,
            label: '',
            placeholder: '',
            ignore: [],
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!$c58fc85fdd0f6d33$var$hasSameComponentIds(props.selectedComponents, state.prevSelectedComponents)) return {
            ...state,
            selectedComponents: props.selectedComponents,
            prevSelectedComponentIds: props.selectedComponents
        };
        return null;
    }
    componentDidMount() {
        const { selectedComponents: selectedComponents } = this.state;
        if (selectedComponents && selectedComponents.some((x)=>!x.name)) this.fetchAndUpdateComponents(selectedComponents);
    }
    componentDidUpdate() {
        const { selectedComponents: selectedComponents } = this.state;
        if (selectedComponents && selectedComponents.some((x)=>!x.name)) this.fetchAndUpdateComponents(selectedComponents);
    }
    fetchAndUpdateComponents(selectedComponents) {
        const fillInSelectedComponents = (filledInComponents)=>{
            // Update the state only in case the component list wasn't changed
            if ($c58fc85fdd0f6d33$var$hasSameComponentIds(this.state.selectedComponents, selectedComponents)) {
                this.setState({
                    selectedComponents: filledInComponents
                });
                this.props.onSelected(filledInComponents);
            }
        };
        (0, $kFCTM.requestComponentObjects)(selectedComponents.map((x)=>x.id)).then(fillInSelectedComponents).catch(()=>fillInSelectedComponents(selectedComponents.filter((x)=>x.name)));
    }
    render() {
        const { label: label, placeholder: placeholder, isRequired: isRequired, isDisabled: isDisabled, isClearableWithCrossIcon: isClearableWithCrossIcon, isMulti: isMulti, intl: intl } = this.props;
        const selectedComponents = this.state.selectedComponents?.filter((x)=>x.name);
        const pickerProps = {
            label: label,
            placeholder: placeholder,
            isRequired: isRequired,
            isDisabled: isDisabled,
            isClearableWithCrossIcon: isClearableWithCrossIcon,
            errorMessage: intl.formatMessage((0, $jDI3D.default).error),
            options: this.renderOptions,
            ...isMulti ? {
                value: selectedComponents?.map($c58fc85fdd0f6d33$var$optionFromComponent),
                isMulti: true,
                onMultiSelected: this.onMultiSelected
            } : {
                value: selectedComponents && selectedComponents[0] && $c58fc85fdd0f6d33$var$optionFromComponent(selectedComponents[0]),
                isMulti: false,
                onSelected: this.onSelected
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lDnwy.Picker), {
            intl: intl,
            ...pickerProps
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            selectedComponents: this.props.selectedComponents,
            prevSelectedComponents: this.props.selectedComponents
        };
        this.onMultiSelected = (selectedOptions)=>{
            if (selectedOptions) {
                this.setState({
                    selectedComponents: selectedOptions.map($c58fc85fdd0f6d33$var$componentFromOption)
                });
                this.props.onSelected(selectedOptions.map($c58fc85fdd0f6d33$var$componentFromOption));
            } else {
                this.setState({
                    selectedComponents: undefined
                });
                this.props.onSelected(undefined);
            }
        };
        this.onSelected = (selectedOption)=>{
            this.onMultiSelected(selectedOption && [
                selectedOption
            ]);
        };
        this.renderOptions = (filter)=>// @ts-expect-error - TS2349 - This expression is not callable.
            (0, $kFCTM.requestComponentOptions)(this.props.projectKeyOrId, this.props.isMulti ? this.props.ignore.concat(this.state.selectedComponents?.map((x)=>x.id) || []) : this.props.ignore, filter);
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'typeof ComponentPicker' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
$c58fc85fdd0f6d33$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($c58fc85fdd0f6d33$export$893706da3f9272af);

});
parcelRegister("eydoe", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $a5Cec = parcelRequire("a5Cec");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.xor` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which by which they're compared. The order of result values is determined
 * by the order they occur in the arrays. The iteratee is invoked with one
 * argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2, 3.4]
 *
 * // The `_.property` iteratee shorthand.
 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */ var $a97ea0a0ece36144$var$xorBy = $9eFtX(function(arrays) {
    var iteratee = $iTvqy(arrays);
    if ($cRpul(iteratee)) iteratee = undefined;
    return $a5Cec($904yO(arrays, $cRpul), $7qARj(iteratee, 2));
});
module.exports = $a97ea0a0ece36144$var$xorBy;

});
parcelRegister("a5Cec", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $42tFs = parcelRequire("42tFs");
/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */ function $7588064e955aa173$var$baseXor(arrays, iteratee, comparator) {
    var length = arrays.length;
    if (length < 2) return length ? $42tFs(arrays[0]) : [];
    var index = -1, result = Array(length);
    while(++index < length){
        var array = arrays[index], othIndex = -1;
        while(++othIndex < length)if (othIndex != index) result[index] = $fa0Ox(result[index] || array, arrays[othIndex], iteratee, comparator);
    }
    return $42tFs($hKE3p(result, 1), iteratee, comparator);
}
module.exports = $7588064e955aa173$var$baseXor;

});


parcelRegister("lDnwy", function(module, exports) {

$parcel$export(module.exports, "getOptionBaseStyles", () => $2d2d94270c4a127f$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $2d2d94270c4a127f$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $2d2d94270c4a127f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $bbaTG = parcelRequire("bbaTG");

var $29yDk = parcelRequire("29yDk");

var $1ZpeU = parcelRequire("1ZpeU");
var $jvznW = parcelRequire("jvznW");
var $jQxSL = parcelRequire("jQxSL");
var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");


var $8cU5f = parcelRequire("8cU5f");

var $3Hawu = parcelRequire("3Hawu");

var $8BJaJ = parcelRequire("8BJaJ");

var $c9TLT = parcelRequire("c9TLT");

var $dzpl6 = parcelRequire("dzpl6");

var $giAhk = parcelRequire("giAhk");

var $9JyRh = parcelRequire("9JyRh");
const $2d2d94270c4a127f$export$3a3072dd741f354b = 500;
const $2d2d94270c4a127f$var$Clear = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ...props,
        theme: (0, $dzpl6.getTheme)({
            buttonStyles: {
                link: {
                    borderRadius: 0,
                    borderBottom: `${(0, $c9TLT.gridSize) * 0.25}px solid ${`var(--ds-background-accent-gray-subtler, ${(0, $73a5c9d720aa66e1$exports).N40})`}`,
                    height: 'auto',
                    /*
       * Button doesn't have any top/bottom padding so moving it up a bit using a negative margin
       * is the most convenient way to fix its appearance inside the dropdown menu which has its own padding.
       */ marginTop: `-${(0, $c9TLT.gridSize) * 0.7}px`,
                    marginBottom: "var(--ds-space-050, 4px)",
                    textAlign: 'left'
                }
            }
        })
    });
const $2d2d94270c4a127f$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$exports).N90})`,
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $2d2d94270c4a127f$export$ba25329847403e11 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: '',
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props); // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        };
        this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        };
        this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        };
        this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        };
        this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        };
        this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        };
        this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        };
        this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            });
        this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        };
        this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        };
        this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$Clear, {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $9JyRh.default).clearSelected)), menuListProps.children));
        };
        this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d2d94270c4a127f$var$StyledValueContainer, {
                "data-testid": "common-components-picker.base.react-dnd-and-select-focus-bug-fix",
                onClick: onValueContainerClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props));
        };
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $2d2d94270c4a127f$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eUqFw.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $1ZpeU.default) : (0, $28t3A.default);
        if (isAsync) return 0, $3Hawu.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $jvznW.default) : (0, $5wCDk.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        };
        const MenuList = {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $9JyRh.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>formatMessage((0, $9JyRh.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $9JyRh.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : document.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $c9TLT.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$2d2d94270c4a127f$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    })
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BJaJ.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            options: isAsync ? undefined : this.props.options
        })));
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'typeof Picker' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
$2d2d94270c4a127f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($2d2d94270c4a127f$export$ba25329847403e11);
const $2d2d94270c4a127f$var$StyledValueContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1ZpeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $724bfa4358c46735$export$2e2bcd8739ae039);

var $03F4S = parcelRequire("03F4S");

var $5FjBr = parcelRequire("5FjBr");
const $724bfa4358c46735$var$AsyncCreatableSelect = (0, $5FjBr.default)((0, $03F4S.default));
var $724bfa4358c46735$export$2e2bcd8739ae039 = $724bfa4358c46735$var$AsyncCreatableSelect;

});
parcelRegister("03F4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $00b02518902b6778$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $3IL7Z = parcelRequire("3IL7Z");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $00b02518902b6778$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagerProps = (0, $3IL7Z.u)(props);
    var creatableProps = (0, $7IqRg.u)(stateManagerProps);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $00b02518902b6778$export$2e2bcd8739ae039 = $00b02518902b6778$var$AsyncCreatableSelect;

});
parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});


parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad28cd61177420a3a122a1d9ec17dac3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e96175d8a517ba5c9c43627285ce1cee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e3245a4cda5405cbe39cdb10fb1ac0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});




parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("jvznW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a632e850af918cb2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $bVKeg = parcelRequire("bVKeg");
const $a632e850af918cb2$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $bVKeg.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $a632e850af918cb2$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($a632e850af918cb2$var$CheckboxSelectInternal);
var $a632e850af918cb2$export$2e2bcd8739ae039 = $a632e850af918cb2$var$CheckboxSelect;

});
parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});


parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hSJ9G = parcelRequire("hSJ9G");

var $c6Z6Z = parcelRequire("c6Z6Z");

function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::028a0c4c28d56d22cc99e0300c383380>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});



parcelRegister("28t3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab404645f53318b$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $5FjBr = parcelRequire("5FjBr");
const $2ab404645f53318b$var$CreatableSelect = (0, $5FjBr.default)((0, $lOwgQ.default));
var $2ab404645f53318b$export$2e2bcd8739ae039 = $2ab404645f53318b$var$CreatableSelect;

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});


parcelRegister("3Hawu", function(module, exports) {

$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $7680050c258e1266$export$ee664e5add893f9);

var $fm9CZ = parcelRequire("fm9CZ");

var $eGI9v = parcelRequire("eGI9v");
const $7680050c258e1266$export$ee664e5add893f9 = (0, $eGI9v.default)('select', {
    onChange: 'changed'
})((0, $fm9CZ.default));

});
parcelRegister("fm9CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14ede2f273d8bdb$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $5FjBr = parcelRequire("5FjBr");
const $a14ede2f273d8bdb$var$AsyncSelect = (0, $5FjBr.default)((0, $hgTYM.default));
var $a14ede2f273d8bdb$export$2e2bcd8739ae039 = $a14ede2f273d8bdb$var$AsyncSelect;

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});



parcelRegister("8BJaJ", function(module, exports) {

$parcel$export(module.exports, "FieldLabel", () => $816236d547316819$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");

var $c9TLT = parcelRequire("c9TLT");
const $816236d547316819$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$LabelText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($816236d547316819$var$RequiredIndicator, {
        role: "presentation"
    }, "*") : null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $816236d547316819$var$LabelText = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-9kgl5s-0"
})`${(0, $4lTFP.h200)()} display:block;font-family:${(0, $c9TLT.fontFamily)};margin:0;${(0, $kwce8.css)({
    padding: `${"var(--ds-space-250, 20px)"} 0px ${"var(--ds-space-050, 4px)"} 0px`
})}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $816236d547316819$var$RequiredIndicator = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "sc-9kgl5s-1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$exports).R400})`,
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    paddingLeft: "var(--ds-space-025, 2px)"
});
$816236d547316819$var$RequiredIndicator.displayName = 'RequiredIndicator';

});

parcelRegister("dzpl6", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $55e2e88bfdce03b8$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $55e2e88bfdce03b8$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $73a5c9d720aa66e1$exports).P400,
            '> span': {
                color: (0, $73a5c9d720aa66e1$exports).N0
            }
        }
    };
    return theme;
};
const $55e2e88bfdce03b8$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $55e2e88bfdce03b8$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $55e2e88bfdce03b8$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("9JyRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dd98b27101186e6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4dd98b27101186e6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});

});


parcelRegister("kFCTM", function(module, exports) {

$parcel$export(module.exports, "requestComponentOptions", () => $620a59b41cea90a4$export$b17a6324e2e1c7f7);
$parcel$export(module.exports, "requestComponentObjects", () => $620a59b41cea90a4$export$57acaec04cc6f107);

var $5beyC = parcelRequire("5beyC");

var $jlk5P = parcelRequire("jlk5P");
const $620a59b41cea90a4$export$b17a6324e2e1c7f7 = (projectKeyOrId, ignore, filter)=>(0, $5beyC.getComponents)(projectKeyOrId, filter, ignore).then((data)=>(0, $jlk5P.transformToOptions)(data, ignore));
const $620a59b41cea90a4$export$57acaec04cc6f107 = (componentIds)=>Promise.allSettled(componentIds.map((0, $5beyC.getComponent))).then((results)=>results.flatMap((x)=>x.status === 'fulfilled' ? [
                (0, $jlk5P.transformToComponent)(x.value)
            ] : []));

});
parcelRegister("5beyC", function(module, exports) {

$parcel$export(module.exports, "MAX_RESULTS", () => $0417d87df71f5e1e$export$f6b2881bc1090cea);
$parcel$export(module.exports, "getComponents", () => $0417d87df71f5e1e$export$4e811121b221213b);
$parcel$export(module.exports, "getComponent", () => $0417d87df71f5e1e$export$21a8719ce41a1de2);

var $2OdyW = parcelRequire("2OdyW");
const $0417d87df71f5e1e$export$f6b2881bc1090cea = 5;
const $0417d87df71f5e1e$export$4aa7fe68c5163f3d = (baseUrl, projectKeyOrId)=>`${baseUrl}/rest/api/2/project/${projectKeyOrId}/component`;
const $0417d87df71f5e1e$export$7b8ce8b3873e394d = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/component`;
const $0417d87df71f5e1e$export$5f0555d9912ed84 = (filter, ignore)=>`startAt=0&maxResults=${$0417d87df71f5e1e$export$f6b2881bc1090cea + ignore.length}&query=${encodeURIComponent(filter)}`;
const $0417d87df71f5e1e$export$1adc93310c566826 = (baseUrl, projectKeyOrId, filter, ignore)=>`${$0417d87df71f5e1e$export$4aa7fe68c5163f3d(baseUrl, projectKeyOrId)}?${$0417d87df71f5e1e$export$5f0555d9912ed84(filter, ignore)}`;
const $0417d87df71f5e1e$export$379bde45c66d6bf3 = (projectKeyOrId, filter, ignore)=>`${$0417d87df71f5e1e$export$7b8ce8b3873e394d(projectKeyOrId)}?${$0417d87df71f5e1e$export$5f0555d9912ed84(filter, ignore)}`;
const $0417d87df71f5e1e$export$e1462d7e65c4432f = (baseUrl, projectKeyOrId, filter, ignore)=>(0, $2OdyW.default)($0417d87df71f5e1e$export$1adc93310c566826(baseUrl, projectKeyOrId, filter, ignore));
const $0417d87df71f5e1e$export$4e811121b221213b = (projectKeyOrId, filter, ignore)=>(0, $2OdyW.default)($0417d87df71f5e1e$export$379bde45c66d6bf3(projectKeyOrId, filter, ignore));
const $0417d87df71f5e1e$export$2b0e03bdc48b0fb8 = (componentId)=>`/rest/api/3/component/${componentId}`;
const $0417d87df71f5e1e$export$21a8719ce41a1de2 = (componentId)=>(0, $2OdyW.default)($0417d87df71f5e1e$export$2b0e03bdc48b0fb8(componentId));

});

parcelRegister("jlk5P", function(module, exports) {

$parcel$export(module.exports, "transformToComponent", () => $399c7149d1173e9a$export$4db7477f39e92dcc);
$parcel$export(module.exports, "transformToOptions", () => $399c7149d1173e9a$export$899758961952c638);

var $5beyC = parcelRequire("5beyC");
const $399c7149d1173e9a$var$transformOption = (component)=>({
        value: component.id,
        label: component.name
    });
const $399c7149d1173e9a$export$4db7477f39e92dcc = ({ id: id, name: name })=>({
        id: id,
        name: name
    });
const $399c7149d1173e9a$export$899758961952c638 = (data, ignore)=>{
    const { values: values } = data;
    return values.filter((value)=>!ignore.includes(value.id)).map($399c7149d1173e9a$var$transformOption).slice(0, (0, $5beyC.MAX_RESULTS));
};

});


parcelRegister("jDI3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $aeea10e93260eeb0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aeea10e93260eeb0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    error: {
        "id": "component-picker.error",
        "defaultMessage": "We couldn't retrieve components"
    }
});

});



parcelRegister("bhDR2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c140695494a911a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // eslint-disable-next-line formatjs/no-multiple-plurals
$c140695494a911a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    headerNew: {
        "id": "project-directories.components.delete.header-new",
        "defaultMessage": "Delete {component} component"
    },
    deleteButton: {
        "id": "project-directories.components.delete.delete-button",
        "defaultMessage": "Delete"
    },
    cancelButton: {
        "id": "project-directories.components.delete.cancel-button",
        "defaultMessage": "Cancel"
    },
    deleteComponentCount: {
        "id": "project-directories.components.delete.delete-component-count",
        "defaultMessage": "{count} {count, plural, one {issue} other {issues}}"
    },
    deleteComponentRestMessage: {
        "id": "project-directories.components.delete.delete-component-rest-message",
        "defaultMessage": " use this component. You can change {count, plural, one {its} other {their}} component to another in this project or remove the component from {count, plural, one {this issue} other {these issues}}."
    },
    deleteComponentWarningLink: {
        "id": "project-directories.components.delete.delete-component-warning-link",
        "defaultMessage": "{relatedIssueCount, plural, one {There is 1 issue} other {There are {relatedIssueCount} issues}} using this component."
    },
    deleteComponentWillAffectIssues: {
        "id": "project-directories.components.delete.delete-component-will-affect-issues",
        "defaultMessage": "Deleting this component will affect {relatedIssueCount, plural, one {this issue} other {these issues}}."
    },
    deleteComponentYouCanChangeIssues: {
        "id": "project-directories.components.delete.delete-component-you-can-change-issues",
        "defaultMessage": "You can change the component or remove the component {relatedIssueCount, plural, one {from this issue} other {from these issues}}."
    },
    changeComponentRadio: {
        "id": "project-directories.components.delete.change-component-radio",
        "defaultMessage": "Change current issues to component"
    },
    removeComponentRadio: {
        "id": "project-directories.components.delete.remove-component-radio",
        "defaultMessage": "Remove component from all issues."
    },
    componentPickerPlaceholder: {
        "id": "project-directories.components.delete.component-picker-placeholder",
        "defaultMessage": "Select component"
    }
});

});








parcelRegister("8v7rm", function(module, exports) {

$parcel$export(module.exports, "default", () => $09c42ab0d6e3044c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lNNXV = parcelRequire("lNNXV");

var $dlxK4 = parcelRequire("dlxK4");

var $fnVSJ = parcelRequire("fnVSJ");

var $6crwp = parcelRequire("6crwp");

var $dlLXy = parcelRequire("dlLXy");

var $f30UX = parcelRequire("f30UX");

var $jCqop = parcelRequire("jCqop");
function $09c42ab0d6e3044c$var$AddModal(props) {
    const { locale: locale, baseUrl: baseUrl, projectId: projectId, projectKey: projectKey, projectDefaultAssignee: projectDefaultAssignee, projectLead: projectLead, onClose: onClose, onComplete: onComplete, onError: onError, isDialogOpen: isDialogOpen } = props;
    if (!isDialogOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dlxK4.default), {
        locale: locale,
        baseUrl: baseUrl,
        projectId: projectId,
        projectKey: projectKey,
        projectDefaultAssignee: projectDefaultAssignee,
        projectLead: projectLead,
        onClose: onClose,
        onComplete: onComplete,
        onError: onError
    });
}
const $09c42ab0d6e3044c$var$mapStateToProps = (state)=>({
        locale: (0, $6crwp.getLocale)(state),
        baseUrl: (0, $6crwp.getBaseUrl)(state),
        isDialogOpen: (0, $jCqop.isOpen)(state),
        projectId: (0, $dlLXy.getProjectId)(state),
        projectKey: (0, $dlLXy.getProjectKey)(state),
        projectDefaultAssignee: (0, $dlLXy.getProjectDefaultAssignee)(state),
        projectLead: (0, $dlLXy.getProjectLead)(state)
    });
const $09c42ab0d6e3044c$var$mapDispatchToProps = {
    onClose: (0, $f30UX.cancel),
    onComplete: (0, $fnVSJ.addComponentSuccess),
    onError: (0, $fnVSJ.addComponentFail)
};
var $09c42ab0d6e3044c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($09c42ab0d6e3044c$var$mapStateToProps, $09c42ab0d6e3044c$var$mapDispatchToProps)($09c42ab0d6e3044c$var$AddModal);

});
parcelRegister("dlxK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $91edd18aaa444f34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $aR8n6 = parcelRequire("aR8n6");

var $aHIDr = parcelRequire("aHIDr");

var $d1zDS = parcelRequire("d1zDS");

var $lRsfE = parcelRequire("lRsfE");

var $csoRE = parcelRequire("csoRE");

var $72wvI = parcelRequire("72wvI");
class $91edd18aaa444f34$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            projectDefaultAssignee: undefined,
            projectLead: undefined
        };
    }
    constructor(props){
        super(props);
        // @ts-expect-error - TS2554 - Expected 2-3 arguments, but got 1.
        this.store = (0, $lRsfE.default)((0, $aHIDr.default));
        this.initializeProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.initializeProps(nextProps);
    }
    initializeProps(props) {
        this.store.dispatch((0, $csoRE.setAppProps)(props));
        (0, $d1zDS.setBaseUrl)(props.baseUrl);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: "unhandled",
            packageName: "jiraProjectDirectoriesComponents",
            teamName: "morphinecake",
            sendToPrivacyUnsafeSplunk: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $72wvI.default), null))));
    }
}

});
parcelRegister("aHIDr", function(module, exports) {

$parcel$export(module.exports, "default", () => $251102c9c53c73b6$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $3DiFN = parcelRequire("3DiFN");
var $251102c9c53c73b6$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $3DiFN.onSave), (0, $3DiFN.onClose), (0, $3DiFN.onComplete), (0, $3DiFN.onError));

});
parcelRegister("3DiFN", function(module, exports) {

$parcel$export(module.exports, "onClose", () => $a6c796886fb63570$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "onComplete", () => $a6c796886fb63570$export$e82b76dc89ff0f64);
$parcel$export(module.exports, "onError", () => $a6c796886fb63570$export$2288787135a8f66e);
$parcel$export(module.exports, "onSave", () => $a6c796886fb63570$export$87b124fe38894ca4);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("8jBvP");
parcelRequire("1Lcr1");
parcelRequire("iects");

var $3JafE = parcelRequire("3JafE");

var $5ysFK = parcelRequire("5ysFK");

var $7byHA = parcelRequire("7byHA");


var $hrX5R = parcelRequire("hrX5R");

var $csoRE = parcelRequire("csoRE");

var $h38fM = parcelRequire("h38fM");
const $a6c796886fb63570$var$LOG_LOCATION = 'project-components.state.epics.create';
const $a6c796886fb63570$var$epicOf = (type, handler)=>(action$, store)=>action$.ofType(type).mergeMap((action)=>handler(action, store.getState()));
const $a6c796886fb63570$export$f312d3bc7ef841a8 = $a6c796886fb63570$var$epicOf((0, $csoRE.CANCEL), (action, state)=>{
    (0, $h38fM.getOnClose)(state)();
    return (0, $3JafE.Observable).empty();
});
const $a6c796886fb63570$export$e82b76dc89ff0f64 = $a6c796886fb63570$var$epicOf((0, $csoRE.SUCCESS), ({ payload: payload }, state)=>{
    (0, $h38fM.getOnComplete)(state)(payload);
    return (0, $3JafE.Observable).empty();
});
const $a6c796886fb63570$export$2288787135a8f66e = $a6c796886fb63570$var$epicOf((0, $csoRE.FAILURE), (action, state)=>{
    (0, $h38fM.getOnError)(state)();
    return (0, $3JafE.Observable).empty();
});
const $a6c796886fb63570$export$87b124fe38894ca4 = $a6c796886fb63570$var$epicOf((0, $csoRE.SAVE), (action, state)=>{
    const projectId = (0, $h38fM.getProjectId)(state);
    const projectKey = (0, $h38fM.getProjectKey)(state);
    const component = (0, $h38fM.getComponent)(state);
    return (0, $3JafE.Observable).fromPromise((0, $hrX5R.create)(projectId, projectKey, component)).mergeMap((createdComponent)=>(0, $3JafE.Observable).of((0, $csoRE.success)(createdComponent)))// @ts-expect-error - TS2345 - Argument of type '(error: any) => Observable<ValidationFailureAction> | Observable<FailureAction>' is not assignable to parameter of type '(err: any, caught: Observable<SuccessAction>) => ObservableInput<ValidationFailureAction>'.
    .catch((error)=>{
        (0, $5ysFK.logSafeErrorWithoutCustomerData)(error, $a6c796886fb63570$var$LOG_LOCATION, (0, $3cf121f5a28af65f$export$1089831196ae0f84));
        if (error instanceof (0, $7byHA.ValidationError)) return (0, $3JafE.Observable).of((0, $csoRE.validationFailure)(error.errors));
        return (0, $3JafE.Observable).of((0, $csoRE.failure)());
    });
});

});
parcelRegister("hrX5R", function(module, exports) {

$parcel$export(module.exports, "create", () => $5ebca458157740e1$export$185802fd694ee1f5);

var $8FheY = parcelRequire("8FheY");

var $1HTHS = parcelRequire("1HTHS");

var $a0I6t = parcelRequire("a0I6t");

var $d1zDS = parcelRequire("d1zDS");
const $5ebca458157740e1$export$185802fd694ee1f5 = (projectId, projectKey, component)=>{
    const { name: name, description: description, lead: lead, defaultAssignee: defaultAssignee } = component;
    const componentLeadField = lead && {
        leadAccountId: lead.accountId
    };
    const payload = {
        name: name,
        description: description,
        assigneeType: defaultAssignee,
        project: projectKey,
        projectId: projectId,
        ...componentLeadField
    };
    return (0, $8FheY.default)((0, $1HTHS.create)((0, $d1zDS.getBaseUrl)(), payload), (0, $a0I6t.transformComponent), projectKey);
};

});
parcelRegister("8FheY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e831c5db5bdaf1ba$export$2e2bcd8739ae039);

var $8blac = parcelRequire("8blac");

var $8dloj = parcelRequire("8dloj");

var $1LYxF = parcelRequire("1LYxF");

var $gyj10 = parcelRequire("gyj10");

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e831c5db5bdaf1ba$export$2e2bcd8739ae039 = (promise, transformer, projectKey)=>promise.then((response)=>Promise.all([
            response.ok,
            response.json()
        ])) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .then(([ok, json])=>{
        if (ok) {
            const component = transformer(json);
            if (component.id !== undefined) {
                const newComponent = {
                    ...component,
                    projectKey: projectKey
                };
                try {
                    (0, $gyj10.default).set(component.id.toString(), newComponent);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('project-directories.components.cache.set', error.message);
                }
            }
            return component;
        }
        const errors = (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(json.errors, [
            'name',
            'componentLead'
        ]);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(errors)) {
            const fieldErrors = (0, (/*@__PURE__*/$parcel$interopDefault($1LYxF)))(errors).map(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            ([field, error])=>({
                    field: field,
                    error: error
                }));
            throw new (0, $7byHA.ValidationError)('Validation error', fieldErrors);
        }
        throw new Error(`Request failed with a json response but cannot extract validation errors: ${JSON.stringify(json)}`);
    }).catch((e)=>{
        throw e instanceof Error ? e : new Error(e);
    });

});
parcelRegister("1LYxF", function(module, exports) {

var $f0Qik = parcelRequire("f0Qik");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */ var $14a9249b93e30822$var$toPairs = $f0Qik($8nrDO);
module.exports = $14a9249b93e30822$var$toPairs;

});
parcelRegister("f0Qik", function(module, exports) {

var $4dCzV = parcelRequire("4dCzV");

var $fjnSB = parcelRequire("fjnSB");

var $c1eMI = parcelRequire("c1eMI");

var $2AxbH = parcelRequire("2AxbH");
/** `Object#toString` result references. */ var $aedf6bba724c18f3$var$mapTag = '[object Map]', $aedf6bba724c18f3$var$setTag = '[object Set]';
/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */ function $aedf6bba724c18f3$var$createToPairs(keysFunc) {
    return function(object) {
        var tag = $fjnSB(object);
        if (tag == $aedf6bba724c18f3$var$mapTag) return $c1eMI(object);
        if (tag == $aedf6bba724c18f3$var$setTag) return $2AxbH(object);
        return $4dCzV(object, keysFunc(object));
    };
}
module.exports = $aedf6bba724c18f3$var$createToPairs;

});
parcelRegister("4dCzV", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");
/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */ function $31264d32be0bf953$var$baseToPairs(object, props) {
    return $kJvGp(props, function(key) {
        return [
            key,
            object[key]
        ];
    });
}
module.exports = $31264d32be0bf953$var$baseToPairs;

});

parcelRegister("2AxbH", function(module, exports) {
/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */ function $1e28aff43f3b3e8e$var$setToPairs(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = [
            value,
            value
        ];
    });
    return result;
}
module.exports = $1e28aff43f3b3e8e$var$setToPairs;

});




parcelRegister("1HTHS", function(module, exports) {

$parcel$export(module.exports, "create", () => $9d07492037ee4dfb$export$185802fd694ee1f5);

var $1M0d5 = parcelRequire("1M0d5");
const $9d07492037ee4dfb$export$94df0e59ebebf4a7 = (baseUrl)=>`${baseUrl}/rest/api/2/component`;
const $9d07492037ee4dfb$export$185802fd694ee1f5 = (baseUrl, payload)=>fetch($9d07492037ee4dfb$export$94df0e59ebebf4a7(baseUrl), (0, $1M0d5.createOptions)('POST', payload));

});

parcelRegister("a0I6t", function(module, exports) {

$parcel$export(module.exports, "transformComponent", () => $3fbc470928ea4f1a$export$79ccea7e11af4b35);
const $3fbc470928ea4f1a$export$79ccea7e11af4b35 = (component)=>{
    const { id: id, name: name, self: self } = component;
    return {
        id: id,
        name: name,
        self: self
    };
};

});

parcelRegister("d1zDS", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $8eedaacf5c8f9888$export$f654b28f82155665);
$parcel$export(module.exports, "setBaseUrl", () => $8eedaacf5c8f9888$export$9c999f676138fa5b);
let $8eedaacf5c8f9888$var$baseUrl = '';
const $8eedaacf5c8f9888$export$f654b28f82155665 = ()=>$8eedaacf5c8f9888$var$baseUrl;
const $8eedaacf5c8f9888$export$9c999f676138fa5b = (url)=>{
    $8eedaacf5c8f9888$var$baseUrl = url;
};

});


parcelRegister("csoRE", function(module, exports) {

$parcel$export(module.exports, "SET_APP_PROPS", () => $4e4e5569381ad911$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $4e4e5569381ad911$export$cfda7627848a58cd);
$parcel$export(module.exports, "SAVE", () => $4e4e5569381ad911$export$f9ec4afc4535638b);
$parcel$export(module.exports, "save", () => $4e4e5569381ad911$export$a1544dad697b423d);
$parcel$export(module.exports, "CANCEL", () => $4e4e5569381ad911$export$2b10f4b30fb65583);
$parcel$export(module.exports, "cancel", () => $4e4e5569381ad911$export$70b61ad426ddbe54);
$parcel$export(module.exports, "UPDATE", () => $4e4e5569381ad911$export$e271b26eefe41db8);
$parcel$export(module.exports, "update", () => $4e4e5569381ad911$export$722fbec263ad908a);
$parcel$export(module.exports, "SUCCESS", () => $4e4e5569381ad911$export$638cc6e36b2a737a);
$parcel$export(module.exports, "success", () => $4e4e5569381ad911$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "VALIDATION_FAILURE", () => $4e4e5569381ad911$export$f73e519c8b2ca03a);
$parcel$export(module.exports, "validationFailure", () => $4e4e5569381ad911$export$ad2c1d94a94ea0c1);
$parcel$export(module.exports, "FAILURE", () => $4e4e5569381ad911$export$5b1e245d5eac107);
$parcel$export(module.exports, "failure", () => $4e4e5569381ad911$export$af2dba6db4e9e1f0);
const $4e4e5569381ad911$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $4e4e5569381ad911$export$cfda7627848a58cd = (payload)=>({
        type: $4e4e5569381ad911$export$8aefe701a6f431e0,
        payload: payload
    });
const $4e4e5569381ad911$export$f9ec4afc4535638b = 'state.SAVE';
const $4e4e5569381ad911$export$a1544dad697b423d = ()=>({
        type: $4e4e5569381ad911$export$f9ec4afc4535638b
    });
const $4e4e5569381ad911$export$2b10f4b30fb65583 = 'state.CANCEL';
const $4e4e5569381ad911$export$70b61ad426ddbe54 = ()=>({
        type: $4e4e5569381ad911$export$2b10f4b30fb65583
    });
const $4e4e5569381ad911$export$e271b26eefe41db8 = 'state.UPDATE';
const $4e4e5569381ad911$export$722fbec263ad908a = (payload)=>({
        type: $4e4e5569381ad911$export$e271b26eefe41db8,
        payload: payload
    });
const $4e4e5569381ad911$export$638cc6e36b2a737a = 'state.SUCCESS';
const $4e4e5569381ad911$export$fe7c49d056ea1d88 = (payload)=>({
        type: $4e4e5569381ad911$export$638cc6e36b2a737a,
        payload: payload
    });
const $4e4e5569381ad911$export$f73e519c8b2ca03a = 'state.VALIDATION_FAILURE';
const $4e4e5569381ad911$export$ad2c1d94a94ea0c1 = (payload)=>({
        type: $4e4e5569381ad911$export$f73e519c8b2ca03a,
        payload: payload
    });
const $4e4e5569381ad911$export$5b1e245d5eac107 = 'state.FAILURE';
const $4e4e5569381ad911$export$af2dba6db4e9e1f0 = ()=>({
        type: $4e4e5569381ad911$export$5b1e245d5eac107
    });

});

parcelRegister("h38fM", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $b68674c9405587a4$export$f654b28f82155665);
$parcel$export(module.exports, "getProjectKey", () => $b68674c9405587a4$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $b68674c9405587a4$export$89040d072f281f85);
$parcel$export(module.exports, "getProjectDefaultAssignee", () => $b68674c9405587a4$export$be28a82d4e8d697f);
$parcel$export(module.exports, "getProjectLeadName", () => $b68674c9405587a4$export$c5b979a08b55628c);
$parcel$export(module.exports, "getOnClose", () => $b68674c9405587a4$export$87f3187c49e686c);
$parcel$export(module.exports, "getOnComplete", () => $b68674c9405587a4$export$a92edfca0b454563);
$parcel$export(module.exports, "getOnError", () => $b68674c9405587a4$export$60888e2ed0df5dfd);
$parcel$export(module.exports, "getComponent", () => $b68674c9405587a4$export$21a8719ce41a1de2);
$parcel$export(module.exports, "getName", () => $b68674c9405587a4$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getDescription", () => $b68674c9405587a4$export$67580b1c13935958);
$parcel$export(module.exports, "getDefaultAssignee", () => $b68674c9405587a4$export$725da8bee1e71eb0);
$parcel$export(module.exports, "getLead", () => $b68674c9405587a4$export$97850e2d25587c0d);
$parcel$export(module.exports, "getNameErrorMessage", () => $b68674c9405587a4$export$6222164b63cc3ae9);
$parcel$export(module.exports, "isSaving", () => $b68674c9405587a4$export$3b51d1dcee070cea);
$parcel$export(module.exports, "canSubmit", () => $b68674c9405587a4$export$f5bccce225aa614b);
const $b68674c9405587a4$export$f654b28f82155665 = (state)=>state.appProps.baseUrl;
const $b68674c9405587a4$export$667f2a0f99c75faa = (state)=>state.appProps.projectKey;
const $b68674c9405587a4$export$89040d072f281f85 = (state)=>state.appProps.projectId;
const $b68674c9405587a4$export$be28a82d4e8d697f = (state)=>state.appProps.projectDefaultAssignee;
const $b68674c9405587a4$export$c5b979a08b55628c = (state)=>state.appProps.projectLead ? state.appProps.projectLead.displayName : '';
const $b68674c9405587a4$export$87f3187c49e686c = (state)=>state.appProps.onClose;
const $b68674c9405587a4$export$a92edfca0b454563 = (state)=>state.appProps.onComplete;
const $b68674c9405587a4$export$60888e2ed0df5dfd = (state)=>state.appProps.onError;
const $b68674c9405587a4$export$21a8719ce41a1de2 = (state)=>state.component;
const $b68674c9405587a4$export$7d9f7e9c1c02b41e = (state)=>state.component.name;
const $b68674c9405587a4$export$67580b1c13935958 = (state)=>state.component.description;
const $b68674c9405587a4$export$725da8bee1e71eb0 = (state)=>state.component.defaultAssignee;
const $b68674c9405587a4$export$97850e2d25587c0d = (state)=>state.component.lead;
const $b68674c9405587a4$export$6222164b63cc3ae9 = (state)=>state.errors.name;
const $b68674c9405587a4$export$8802ac508ab8d49a = (state)=>state.errors.componentLead;
const $b68674c9405587a4$export$3b51d1dcee070cea = (state)=>state.isSaving;
const $b68674c9405587a4$export$f5bccce225aa614b = (state)=>!$b68674c9405587a4$export$3b51d1dcee070cea(state) && !!$b68674c9405587a4$export$7d9f7e9c1c02b41e(state).trim();

});



parcelRegister("lRsfE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cabae4f3b91a9ee$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $bd1K7 = parcelRequire("bd1K7");

var $czGdf = parcelRequire("czGdf");

var $1aSlv = parcelRequire("1aSlv");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6cabae4f3b91a9ee$export$2e2bcd8739ae039 = (rootEpic, initialState, middlewares = [])=>(0, $huRi7.createStore)((0, $1aSlv.default), initialState, (0, $czGdf.default)({
        name: 'Create component modal'
    })((0, $huRi7.applyMiddleware)(...middlewares, (0, $bd1K7.createEpicMiddleware)(rootEpic))));

});
parcelRegister("1aSlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d89f7674d8f546$export$2e2bcd8739ae039);

var $8i1R8 = parcelRequire("8i1R8");

var $jG2Eu = parcelRequire("jG2Eu");

var $ao0hp = parcelRequire("ao0hp");

var $6vrw7 = parcelRequire("6vrw7");


var $csoRE = parcelRequire("csoRE");
const $11d89f7674d8f546$var$defaultState = {
    appProps: {
        baseUrl: '',
        locale: (0, $ao0hp.defaultLocale),
        projectId: NaN,
        projectKey: (0, $6vrw7.toProjectKey)(''),
        projectDefaultAssignee: undefined,
        projectLead: undefined,
        onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    },
    isSaving: false,
    component: {
        name: '',
        description: '',
        defaultAssignee: (0, $622bb9f08cd0771a$export$dfc4824370fdf2e8),
        lead: undefined
    },
    errors: {
        name: '',
        componentLead: ''
    }
};
const $11d89f7674d8f546$var$getFieldError = (payload, field)=>{
    const result = (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(payload, {
        field: field
    }) || {};
    // @ts-expect-error - TS2339 - Property 'error' does not exist on type '{}'.
    return result.error || '';
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$11d89f7674d8f546$export$2e2bcd8739ae039 = (state = $11d89f7674d8f546$var$defaultState, action)=>{
    switch(action.type){
        case 0, $csoRE.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $csoRE.UPDATE:
            return {
                ...state,
                component: action.payload
            };
        case 0, $csoRE.SAVE:
            return {
                ...state,
                isSaving: true,
                errors: {
                    name: '',
                    componentLead: ''
                }
            };
        case 0, $csoRE.VALIDATION_FAILURE:
            return {
                ...state,
                isSaving: false,
                errors: {
                    name: $11d89f7674d8f546$var$getFieldError(action.payload, 'name'),
                    componentLead: $11d89f7674d8f546$var$getFieldError(action.payload, 'componentLead')
                }
            };
        case 0, $csoRE.FAILURE:
        case 0, $csoRE.CANCEL:
        case 0, $csoRE.SUCCESS:
            return {
                ...state,
                isSaving: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});


const $622bb9f08cd0771a$export$e141a3d44fafd179 = 'COMPONENT_LEAD';
const $622bb9f08cd0771a$export$dfc4824370fdf2e8 = 'PROJECT_DEFAULT';
const $622bb9f08cd0771a$export$3c83461db52a5dd6 = 'PROJECT_LEAD';
const $622bb9f08cd0771a$export$3f4d79509888a8a1 = 'UNASSIGNED';



parcelRegister("72wvI", function(module, exports) {

$parcel$export(module.exports, "default", () => $25f680dfbc84d20c$export$2e2bcd8739ae039);

var $lNNXV = parcelRequire("lNNXV");

var $csoRE = parcelRequire("csoRE");

var $h38fM = parcelRequire("h38fM");

var $4aLjo = parcelRequire("4aLjo");
const $25f680dfbc84d20c$var$mapStateToProps = (state)=>({
        baseUrl: (0, $h38fM.getBaseUrl)(state),
        isSaving: (0, $h38fM.isSaving)(state),
        canSubmit: (0, $h38fM.canSubmit)(state),
        projectDefaultAssignee: (0, $h38fM.getProjectDefaultAssignee)(state),
        projectLeadName: (0, $h38fM.getProjectLeadName)(state),
        name: (0, $h38fM.getName)(state),
        description: (0, $h38fM.getDescription)(state),
        lead: (0, $h38fM.getLead)(state),
        defaultAssignee: (0, $h38fM.getDefaultAssignee)(state),
        nameErrorMessage: (0, $h38fM.getNameErrorMessage)(state)
    });
const $25f680dfbc84d20c$var$mapDispatchToProps = {
    onCancel: (0, $csoRE.cancel),
    onConfirm: (0, $csoRE.save),
    onUpdateComponent: (0, $csoRE.update)
};
var $25f680dfbc84d20c$export$2e2bcd8739ae039 = (0, $lNNXV.connect)($25f680dfbc84d20c$var$mapStateToProps, $25f680dfbc84d20c$var$mapDispatchToProps)((0, $4aLjo.default));

});
parcelRegister("4aLjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9cb8ca70a69b0b5$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $kGQen = parcelRequire("kGQen");

var $1ybV0 = parcelRequire("1ybV0");

var $giAhk = parcelRequire("giAhk");

var $3mypZ = parcelRequire("3mypZ");

var $em4oR = parcelRequire("em4oR");
const $f9cb8ca70a69b0b5$var$Header = ({ intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, formatMessage((0, $1ybV0.ff)('compass-components-in-jira-components_xw42u') ? (0, $em4oR.default).globalComponentsHeader : (0, $em4oR.default).header));
const $f9cb8ca70a69b0b5$var$Footer = ({ intl: { formatMessage: formatMessage }, isSaving: isSaving, canSubmit: canSubmit, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f9cb8ca70a69b0b5$var$ButtonsContainer, null, isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $f9cb8ca70a69b0b5$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        type: "submit",
        onClick: onConfirm,
        isDisabled: !canSubmit,
        externalId: "project-components.item.add"
    }, formatMessage((0, $em4oR.default).saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onCancel,
        isDisabled: isSaving
    }, formatMessage((0, $em4oR.default).cancelButton))));
function $f9cb8ca70a69b0b5$var$CreateModal(props) {
    const { baseUrl: baseUrl, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName, isSaving: isSaving, canSubmit: canSubmit, name: name, description: description, lead: lead, defaultAssignee: defaultAssignee, intl: intl, onConfirm: onConfirm, onCancel: onCancel, onUpdateComponent: onUpdateComponent, nameErrorMessage: nameErrorMessage } = props;
    // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const HeaderComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f9cb8ca70a69b0b5$var$Header, {
            intl: intl
        }); // Unstable components cause bugs and performance problems - please fix this! go/unstable-components
    // eslint-disable-next-line react/no-unstable-nested-components
    const FooterComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f9cb8ca70a69b0b5$var$Footer, {
            intl: intl,
            isSaving: isSaving,
            canSubmit: canSubmit,
            onConfirm: onConfirm,
            onCancel: onCancel
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        autoFocus: true,
        onClose: onCancel,
        width: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeaderComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mypZ.default), {
        baseUrl: baseUrl,
        onUpdateComponent: onUpdateComponent,
        projectDefaultAssignee: projectDefaultAssignee,
        projectLeadName: projectLeadName,
        name: name,
        description: description,
        lead: lead,
        defaultAssignee: defaultAssignee,
        nameErrorMessage: nameErrorMessage
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FooterComponent, null)));
}
var $f9cb8ca70a69b0b5$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($f9cb8ca70a69b0b5$var$CreateModal);
const $f9cb8ca70a69b0b5$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f9cb8ca70a69b0b5$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3mypZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d64cff7194a329$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $aYQ0Q = parcelRequire("aYQ0Q");
var $jeetE = parcelRequire("jeetE");

var $cf2Y4 = parcelRequire("cf2Y4");

var $giAhk = parcelRequire("giAhk");

var $1z7HR = parcelRequire("1z7HR");

var $2tPWX = parcelRequire("2tPWX");

var $dvOud = parcelRequire("dvOud");
// eslint-disable-next-line jira/react/no-class-components
class $69d64cff7194a329$var$ModalCommonContent extends (0, $eUqFw.PureComponent) {
    componentDidUpdate(prevProps) {
        if (this.props.nameErrorMessage && !prevProps.nameErrorMessage) // do it a little bit later to avoid animation clipping
        setTimeout(()=>{
            if (this.nameFieldInstance) this.nameFieldInstance.focus();
        });
    }
    inputChange(update) {
        const { name: name, description: description, lead: lead, defaultAssignee: defaultAssignee, onUpdateComponent: onUpdateComponent } = this.props;
        const oldComponent = {
            name: name,
            description: description,
            lead: lead,
            defaultAssignee: defaultAssignee
        };
        const newComponent = {
            ...oldComponent,
            ...update
        };
        onUpdateComponent(newComponent);
    }
    generateLeadWithStatus(lead) {
        const { formatMessage: formatMessage } = this.props.intl;
        if (lead && lead.active === false) return {
            ...lead,
            displayName: formatMessage((0, $dvOud.default).deactivated, {
                userName: lead.displayName
            })
        };
        return lead;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, nameErrorMessage: nameErrorMessage, baseUrl: baseUrl, projectLeadName: projectLeadName, projectDefaultAssignee: projectDefaultAssignee, name: name, description: description, lead: lead, defaultAssignee: defaultAssignee } = this.props;
        const isInvalid = !!nameErrorMessage;
        const selectedLead = this.generateLeadWithStatus(lead);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-test-id": "project-directories.components.common.components.configuration"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYQ0Q.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
            "aria-hidden": "true"
        }, formatMessage((0, $dvOud.default).requiredFieldsInformMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "component-name",
            isRequired: true,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69d64cff7194a329$var$FieldLabelWrapper, null, formatMessage((0, $dvOud.default).componentName))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                ...fieldProps,
                autoFocus: true,
                onChange: this.onChangeComponentName,
                value: name,
                isInvalid: isInvalid,
                "aria-invalid": isInvalid,
                maxLength: 255,
                ref: (instance)=>{
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    this.nameFieldInstance = instance;
                }
            }), nameErrorMessage !== undefined && nameErrorMessage !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, nameErrorMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "component-description",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($69d64cff7194a329$var$FieldLabelWrapper, null, formatMessage((0, $dvOud.default).description))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                ...fieldProps,
                onChange: this.onChangeComponentDescription,
                value: description
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1z7HR.default), {
            label: formatMessage((0, $dvOud.default).componentLead),
            placeholder: formatMessage((0, $dvOud.default).componentLeadPlaceholder),
            selectedUser: selectedLead,
            baseUrl: baseUrl,
            onChange: this.onLeadSelected,
            shouldFitContainer: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2tPWX.default), {
            label: formatMessage((0, $dvOud.default).defaultAssignee),
            projectDefaultAssignee: projectDefaultAssignee,
            projectLeadName: projectLeadName,
            componentLeadName: lead && lead.displayName,
            onSelected: this.onAssigneeChange,
            value: defaultAssignee
        }));
    }
    constructor(...args){
        super(...args);
        this.onChangeComponentName = (e)=>{
            this.inputChange({
                name: e.target.value
            });
        };
        this.onChangeComponentDescription = (e)=>{
            this.inputChange({
                description: e.target.value
            });
        };
        this.onLeadSelected = (user)=>{
            this.inputChange({
                lead: user ? {
                    accountId: user.accountId,
                    displayName: user.displayName,
                    avatarUrl: user.avatarUrl,
                    /*
                        This is hardcoded to true as user from the user picker does not return its status.
                        Since user picker is always returning the active user, it should be safe to hard code to be active user.
                         */ active: true
                } : undefined
            });
        };
        this.onAssigneeChange = (assignee)=>{
            this.inputChange({
                defaultAssignee: assignee
            });
        };
    }
}
var $69d64cff7194a329$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($69d64cff7194a329$var$ModalCommonContent);
const $69d64cff7194a329$var$FieldLabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");


var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($8d7fd15aabd72279$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $8d7fd15aabd72279$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $fbef6921e18df378$var$_success = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("50qGm")));
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $fbef6921e18df378$var$_success.default
    }));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = module.exports.default = $fbef6921e18df378$var$EditorSuccessIcon;

});
parcelRegister("50qGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a280b44c69b6de4f4f93ebdb24542b07>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a51a662974016bc$var$_react = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $3a51a662974016bc$var$_UNSAFE_baseNew = $3a51a662974016bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $3a51a662974016bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a51a662974016bc$var$SuccessIcon = (props)=>/*#__PURE__*/ $3a51a662974016bc$var$_react.default.createElement($3a51a662974016bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$3a51a662974016bc$var$SuccessIcon.displayName = 'SuccessIcon';
var $3a51a662974016bc$var$_default = module.exports.default = $3a51a662974016bc$var$SuccessIcon;

});


parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});


parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $7dbb02f7c217159b$var$fieldsetLabelStyles
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("aYQ0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ae6dd46b7e11ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $97ae6dd46b7e11ec$var$formHeaderContentStyles = (0, $1ZAYh.xcss)({
    minWidth: '100%',
    marginBlockStart: 'space.100'
});
const $97ae6dd46b7e11ec$var$formHeaderDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $97ae6dd46b7e11ec$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "large"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $97ae6dd46b7e11ec$var$formHeaderDescriptionStyles
    }, description), children && /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $97ae6dd46b7e11ec$var$formHeaderContentStyles
    }, children));
};
var $97ae6dd46b7e11ec$export$2e2bcd8739ae039 = $97ae6dd46b7e11ec$var$FormHeader;

});

parcelRegister("1z7HR", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf400646c328c99$export$2e2bcd8739ae039);

var $eGI9v = parcelRequire("eGI9v");

var $5dL6f = parcelRequire("5dL6f");
var $caf400646c328c99$export$2e2bcd8739ae039 = (0, $eGI9v.default)('UserPicker', {
    onChange: 'changed'
})((0, $5dL6f.default));

});
parcelRegister("5dL6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e927252db23c4d1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $7WQpd = parcelRequire("7WQpd");

var $gUUjF = parcelRequire("gUUjF");

var $giAhk = parcelRequire("giAhk");

var $7mqCH = parcelRequire("7mqCH");

var $7o3es = parcelRequire("7o3es");
class $3e927252db23c4d1$export$83e0c73b09b3a9cd extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props);
        this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        };
        this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        };
        /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            });
        this.fetchOptions = (query)=>{
            const { baseUrl: baseUrl, suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $7mqCH.requestUsers)(baseUrl, query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $7mqCH.requestUser)(baseUrl, suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $gUUjF.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $7mqCH.requestUser)(this.props.baseUrl, accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, baseUrl: baseUrl, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $7o3es.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7WQpd.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $7o3es.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $7o3es.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width
        });
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'typeof UserPicker' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
$3e927252db23c4d1$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($3e927252db23c4d1$export$83e0c73b09b3a9cd);

});
parcelRegister("7WQpd", function(module, exports) {

$parcel$export(module.exports, "PickerWithAvatar", () => $4293d92e3354fa2f$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $4293d92e3354fa2f$export$3d409af828769e2e);
$parcel$export(module.exports, "default", () => (parcelRequire("lDnwy")).default);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $eGI9v = parcelRequire("eGI9v");

var $lDnwy = parcelRequire("lDnwy");

var $fWkih = parcelRequire("fWkih");
const $4293d92e3354fa2f$export$e6b8a87858f7afd1 = (0, $fWkih.default);
const $4293d92e3354fa2f$export$3d409af828769e2e = (0, $eGI9v.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $fWkih.default));
const $4293d92e3354fa2f$export$d8d9f25d80d89b16 = (0, $eGI9v.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $lDnwy.default));

});
parcelRegister("fWkih", function(module, exports) {

$parcel$export(module.exports, "default", () => $3205cc66838bfd20$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $lDnwy = parcelRequire("lDnwy");
class $3205cc66838bfd20$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lDnwy.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            canShowAvatar: true
        };
        this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        };
        this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        };
        this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3205cc66838bfd20$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3205cc66838bfd20$var$AvatarWrapper, null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3205cc66838bfd20$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3205cc66838bfd20$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $3205cc66838bfd20$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _vwz4kb7n",
            __cmplp.className
        ])
    });
});
const $3205cc66838bfd20$var$LabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7mqCH", function(module, exports) {

$parcel$export(module.exports, "requestUser", () => $2b9e2da6b481eb13$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $2b9e2da6b481eb13$export$55b721778f931cc1);

var $7fbGD = parcelRequire("7fbGD");

var $ltbBS = parcelRequire("ltbBS");
const $2b9e2da6b481eb13$export$949646a1c1731536 = (baseUrl, accountId)=>(0, $7fbGD.getUser)(baseUrl, accountId).then((0, $ltbBS.transformUser));
const $2b9e2da6b481eb13$export$55b721778f931cc1 = (baseUrl, query)=>(0, $7fbGD.getUsers)(baseUrl, query).then((0, $ltbBS.transformUsers));

});
parcelRegister("7fbGD", function(module, exports) {

$parcel$export(module.exports, "getUser", () => $b509d9265f3a19b0$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $b509d9265f3a19b0$export$925a4945a6cd0f3e);

var $2OdyW = parcelRequire("2OdyW");
const $b509d9265f3a19b0$export$e45b57f6c6c40475 = 5;
const $b509d9265f3a19b0$export$7eaa662f51e316ae = (baseUrl)=>`${baseUrl}/rest/api/2/user`;
const $b509d9265f3a19b0$export$8df721f926f55c9a = (baseUrl, accountId = '')=>`${$b509d9265f3a19b0$export$7eaa662f51e316ae(baseUrl)}?accountId=${encodeURIComponent(accountId)}`;
const $b509d9265f3a19b0$export$715964ba85b11e2b = (baseUrl)=>`${baseUrl}/rest/api/2/user/picker`;
const $b509d9265f3a19b0$export$977bdbd87001f83 = (baseUrl, query = '')=>`${$b509d9265f3a19b0$export$715964ba85b11e2b(baseUrl)}?showAvatar=true&maxResults=${$b509d9265f3a19b0$export$e45b57f6c6c40475}&query=${query}`;
const $b509d9265f3a19b0$export$7cbf767827cd68ba = (baseUrl, accountId = '')=>(0, $2OdyW.default)($b509d9265f3a19b0$export$8df721f926f55c9a(baseUrl, accountId));
const $b509d9265f3a19b0$export$925a4945a6cd0f3e = (baseUrl, query = '')=>(0, $2OdyW.default)($b509d9265f3a19b0$export$977bdbd87001f83(baseUrl, query));

});

parcelRegister("ltbBS", function(module, exports) {

$parcel$export(module.exports, "transformUser", () => $e9b01cbdb137f2c9$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $e9b01cbdb137f2c9$export$fb8c90bfc4beaa59);
const $e9b01cbdb137f2c9$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $e9b01cbdb137f2c9$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("7o3es", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3c26dcfd4dec9ee$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a3c26dcfd4dec9ee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});

});



parcelRegister("2tPWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $04329487ae90493e$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8i1R8 = parcelRequire("8i1R8");

var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $c9TLT = parcelRequire("c9TLT");

var $giAhk = parcelRequire("giAhk");


var $7OyiG = parcelRequire("7OyiG");
const $04329487ae90493e$var$getAssigneeItems = (props)=>{
    const { intl: { formatMessage: formatMessage }, componentLeadName: componentLeadName, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName } = props;
    const unassignedMessage = formatMessage((0, $7OyiG.default).assigneeUnassigned);
    const projectLeadMessage = formatMessage((0, $7OyiG.default).assigneeProjectLead);
    const projectDefaultMessage = formatMessage((0, $7OyiG.default).assigneeProjectDefault);
    return [
        {
            value: (0, $622bb9f08cd0771a$export$e141a3d44fafd179),
            label: formatMessage((0, $7OyiG.default).assigneeTypeWithDetails, {
                assigneeType: formatMessage((0, $7OyiG.default).assigneeComponentLead),
                displayName: componentLeadName || unassignedMessage
            })
        },
        {
            value: (0, $622bb9f08cd0771a$export$dfc4824370fdf2e8),
            label: projectDefaultAssignee ? formatMessage((0, $7OyiG.default).assigneeTypeWithDetails, {
                assigneeType: projectDefaultMessage,
                displayName: projectDefaultAssignee === (0, $622bb9f08cd0771a$export$3f4d79509888a8a1) ? unassignedMessage : projectLeadMessage
            }) : projectDefaultMessage
        },
        {
            value: (0, $622bb9f08cd0771a$export$3c83461db52a5dd6),
            label: projectLeadName ? formatMessage((0, $7OyiG.default).assigneeTypeWithDetails, {
                assigneeType: projectLeadMessage,
                displayName: projectLeadName
            }) : projectLeadMessage
        },
        {
            value: (0, $622bb9f08cd0771a$export$3f4d79509888a8a1),
            label: unassignedMessage
        }
    ];
};
const $04329487ae90493e$var$getAssigneeItemByValue = (props, value)=>{
    const futureAssigneeItems = $04329487ae90493e$var$getAssigneeItems(props);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8i1R8)))(futureAssigneeItems, (i)=>i.value === value);
}; // eslint-disable-next-line jira/react/no-class-components
class $04329487ae90493e$export$935c4082cfb74cb6 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            label: ''
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const selectedItem = prevState.selectedItem;
        const nextState = {
            value: nextProps.value,
            componentLeadName: nextProps.componentLeadName
        };
        if (prevState.value !== nextProps.value) {
            if (!selectedItem || nextProps.value !== selectedItem.value) nextState.selectedItem = $04329487ae90493e$var$getAssigneeItemByValue(nextProps, nextProps.value);
        } else if (selectedItem && prevState.componentLeadName !== nextProps.componentLeadName) {
            const updatedCurrentSelection = $04329487ae90493e$var$getAssigneeItemByValue(nextProps, selectedItem.value);
            if (updatedCurrentSelection && updatedCurrentSelection.label !== selectedItem.label) nextState.selectedItem = updatedCurrentSelection;
        }
        return nextState;
    }
    constructor(props){
        super(props);
        this.onSelected = (selected)=>{
            this.setState({
                selectedItem: selected,
                isOpen: false
            });
            this.props.onSelected(selected.value);
        };
        this.onMenuOpenHandler = ()=>this.setState({
                isOpen: true
            });
        this.onMenuCloseHandler = ()=>this.setState({
                isOpen: false
            });
        this.state = {
            selectedItem: props.value ? $04329487ae90493e$var$getAssigneeItemByValue(props, props.value) : undefined,
            isOpen: false
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage }, label: label } = this.props;
        const { selectedItem: selectedItem, isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "component-assignee",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04329487ae90493e$var$FieldLabelWrapper, null, label)
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                inputId: fieldProps.id,
                noOptionsMessage: ()=>formatMessage((0, $7OyiG.default).noMatches),
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, $c9TLT.layers).modal
                        })
                },
                placeholder: formatMessage((0, $7OyiG.default).placeholder),
                options: $04329487ae90493e$var$getAssigneeItems(this.props),
                onChange: this.onSelected,
                value: selectedItem,
                menuIsOpen: isOpen,
                onMenuOpen: this.onMenuOpenHandler,
                onMenuClose: this.onMenuCloseHandler
            }));
    }
}
var // @ts-expect-error - TS2345 - Argument of type 'typeof AssigneeSelect' is not assignable to parameter of type 'ComponentType<Record<any, any>>'.
$04329487ae90493e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $giAhk.injectIntlV2)($04329487ae90493e$export$935c4082cfb74cb6);
const $04329487ae90493e$var$FieldLabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _19pkutpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7OyiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb32f1643073332a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bb32f1643073332a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "project-components.component-assignee-placeholder",
        "defaultMessage": "Default assignee"
    },
    noMatches: {
        "id": "project-components.component-assignee-no-matches",
        "defaultMessage": "No Matches"
    },
    assigneeTypeWithDetails: {
        "id": "project-components.component-assignee-type-with-details",
        "defaultMessage": "{assigneeType} ({displayName})"
    },
    assigneeComponentLead: {
        "id": "project-components.assignee-component-lead",
        "defaultMessage": "Component lead"
    },
    assigneeProjectDefault: {
        "id": "project-components.assignee-project-default",
        "defaultMessage": "Project default"
    },
    assigneeProjectLead: {
        "id": "project-components.assignee-project-lead",
        "defaultMessage": "Project lead"
    },
    assigneeUnassigned: {
        "id": "project-components.assignee-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("dvOud", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fbe13e7350621db$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2fbe13e7350621db$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    componentName: {
        "id": "project-components.edit-modal-dialog-component-name-label",
        "defaultMessage": "Name"
    },
    componentLead: {
        "id": "project-components.edit-modal-dialog-component-lead-label",
        "defaultMessage": "Component lead"
    },
    componentLeadPlaceholder: {
        "id": "project-components.edit-modal-dialog-component-lead-placeholder",
        "defaultMessage": "Select person"
    },
    description: {
        "id": "project-components.edit-modal-dialog-description-label",
        "defaultMessage": "Description"
    },
    defaultAssignee: {
        "id": "project-components.edit-modal-dialog-default-assignee-label",
        "defaultMessage": "Default assignee"
    },
    deactivated: {
        "id": "project-components.edit-modal-dialog-deactivated-status-label",
        "defaultMessage": "{userName} (Deactivated)"
    },
    requiredFieldsInformMessage: {
        "id": "project-components.edit-modal-dialog-required-field-inform-text-message",
        "defaultMessage": "Required fields are marked with an asterisk"
    }
});

});


parcelRegister("em4oR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e198685cae46ae33$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e198685cae46ae33$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    globalComponentsHeader: {
        "id": "project-directories.components.create-modal.global-components-header",
        "defaultMessage": "Create Jira component"
    },
    header: {
        "id": "project-directories.components.create-modal.header",
        "defaultMessage": "Create component"
    },
    saveButton: {
        "id": "project-directories.components.create-modal.save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "project-directories.components.create-modal.cancel-button",
        "defaultMessage": "Cancel"
    }
});

});




parcelRegister("jCqop", function(module, exports) {

$parcel$export(module.exports, "isOpen", () => $45af185a5c59b718$export$ea0830439c7fc698);
const $45af185a5c59b718$export$ea0830439c7fc698 = (state)=>state.ui.add.isOpen;

});


parcelRegister("2r0Sq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a20a6ed69f18aa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $kGQen = parcelRequire("kGQen");

var $90IgZ = parcelRequire("90IgZ");
var $giAhk = parcelRequire("giAhk");

var $lNNXV = parcelRequire("lNNXV");

var $3mypZ = parcelRequire("3mypZ");

var $fnVSJ = parcelRequire("fnVSJ");

var $6crwp = parcelRequire("6crwp");

var $dlLXy = parcelRequire("dlLXy");

var $gPlbp = parcelRequire("gPlbp");

var $35VMj = parcelRequire("35VMj");
const $b7a20a6ed69f18aa$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7a20a6ed69f18aa$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $b7a20a6ed69f18aa$var$messages = (0, $90IgZ.defineMessages)({
    header: {
        "id": "project-components.dialogs-edit-header",
        "defaultMessage": "Edit component"
    },
    saveButton: {
        "id": "project-components.dialogs-edit-save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "project-components.dialogs-edit-cancel-button",
        "defaultMessage": "Cancel"
    }
});
class $b7a20a6ed69f18aa$export$97b20acb2862c69e extends (0, $eUqFw.Component) {
    render() {
        const { baseUrl: baseUrl, component: component, projectDefaultAssignee: projectDefaultAssignee, projectLeadName: projectLeadName, onCancel: onCancel, nameErrorMessage: nameErrorMessage, isDialogOpen: isDialogOpen } = this.props;
        if (!isDialogOpen || !component) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
            onClose: onCancel,
            width: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, this.renderHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3mypZ.default), {
            baseUrl: baseUrl,
            name: component.name,
            description: component.description,
            lead: component.lead,
            defaultAssignee: component.defaultAssignee,
            onUpdateComponent: this.onUpdateComponent,
            projectDefaultAssignee: projectDefaultAssignee,
            projectLeadName: projectLeadName,
            nameErrorMessage: nameErrorMessage
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, this.renderFooter()))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isSaveDisabled: false
        };
        this.onUpdateComponent = (component)=>{
            const isSaveDisabled = !component.name || !component.name.trim();
            this.setState({
                isSaveDisabled: isSaveDisabled
            });
            this.props.onUpdateComponent(component);
        };
        this.renderHeader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("h2", null, this.props.intl.formatMessage($b7a20a6ed69f18aa$var$messages.header));
        this.renderFooter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7a20a6ed69f18aa$var$ButtonsContainer, null, this.props.isSaving && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b7a20a6ed69f18aa$var$spinnerContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "primary",
                type: "submit",
                onClick: this.props.onConfirm,
                isDisabled: this.props.isSaving || this.state.isSaveDisabled
            }, this.props.intl.formatMessage($b7a20a6ed69f18aa$var$messages.saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "subtle-link",
                onClick: this.props.onCancel,
                isDisabled: this.props.isSaving
            }, this.props.intl.formatMessage($b7a20a6ed69f18aa$var$messages.cancelButton)));
    }
}
const $b7a20a6ed69f18aa$var$mapStateToProps = (state)=>({
        baseUrl: (0, $6crwp.getBaseUrl)(state),
        isDialogOpen: (0, $35VMj.isEditing)(state),
        isSaving: (0, $35VMj.saveIsInProgress)(state),
        projectDefaultAssignee: (0, $dlLXy.getProjectDefaultAssignee)(state),
        projectLeadName: (0, $dlLXy.getProjectLeadName)(state),
        component: (0, $35VMj.getEditedComponent)(state),
        nameErrorMessage: (0, $35VMj.getNameErrorMessage)(state)
    });
const $b7a20a6ed69f18aa$var$mapDispatchToProps = {
    onCancel: (0, $gPlbp.cancel),
    onConfirm: (0, $fnVSJ.updateComponentRequest),
    onUpdateComponent: (0, $gPlbp.updateEditedComponent)
};
const $b7a20a6ed69f18aa$var$Connected = (0, $lNNXV.connect)($b7a20a6ed69f18aa$var$mapStateToProps, $b7a20a6ed69f18aa$var$mapDispatchToProps)((0, $giAhk.injectIntlV2)($b7a20a6ed69f18aa$export$97b20acb2862c69e));
var $b7a20a6ed69f18aa$export$2e2bcd8739ae039 = $b7a20a6ed69f18aa$var$Connected;

});




parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("jqro2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7abe2924c156517$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hFmdR = parcelRequire("hFmdR");

var $fee69 = parcelRequire("fee69");

var $aR8n6 = parcelRequire("aR8n6");


var $5yh8X = parcelRequire("5yh8X");

var $7vf5z = parcelRequire("7vf5z");

var $9pZ9R = parcelRequire("9pZ9R");

var $g9zGt = parcelRequire("g9zGt");

var $iJHZm = parcelRequire("iJHZm");

var $jK1pm = parcelRequire("jK1pm");

var $4QWEf = parcelRequire("4QWEf");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b7abe2924c156517$var$noop = ()=>{};
function $b7abe2924c156517$var$ProjectComponents({ Updater: Updater, ProjectDirectoriesApp: ProjectDirectoriesApp, tenantContext: tenantContext, projectContext: projectContext, prefetchResult: prefetchResult, query: query, onQueryChanged: onQueryChanged }) {
    const { error: prefetchError, data: data } = prefetchResult;
    const { data: project } = projectContext;
    if (prefetchError) // @ts-expect-error - react-resource-router types return Record<string,any> but ErrorFlagRenderer only accepts Errors
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
        id: "project-components",
        error: prefetchError
    });
    if (!data || !(project && project.projectKey)) return null;
    const { isAdmin: isAdmin, baseUrl: baseUrl, locale: locale } = tenantContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9zGt.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "project-components-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectComponents",
        teamName: "morphinecake",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectDirectoriesApp, {
        baseUrl: baseUrl,
        locale: locale,
        projectKey: project.projectKey,
        projectId: project.projectId,
        projectName: project.projectName,
        projectType: project.projectType,
        isAdmin: isAdmin || project.isProjectAdmin === true || false,
        prefetchedData: data,
        onUnmount: $b7abe2924c156517$var$noop,
        query: query,
        onQueryChanged: onQueryChanged
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        metricKey: "jira.project.components",
        metric: (0, $4QWEf.projectComponentsPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $5yh8X.appBundleReadyMark),
            (0, $5yh8X.prefetchApiReadyMark)
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pZ9R.default), {
        baseUrl: baseUrl,
        projectKey: project.projectKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null))));
}
var $b7abe2924c156517$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('project-components', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($b7abe2924c156517$var$ProjectComponents);

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9pZ9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2461c5190afbae$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $lgxha = parcelRequire("lgxha");

var $lRmyA = parcelRequire("lRmyA");
const $fe2461c5190afbae$export$fa156a01818e3239 = (baseUrl, projectKey)=>(0, $lRmyA.performPostRequest)(`${baseUrl}/rest/internal/2/project/${projectKey}/recent`).catch((e)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('spa-apps.common.src.add-project-to-history', 'Cannot set recent project', e);
    });
const $fe2461c5190afbae$var$AddProjectToHistory = ({ baseUrl: baseUrl, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: ()=>$fe2461c5190afbae$export$fa156a01818e3239(baseUrl, projectKey)
    });
var $fe2461c5190afbae$export$2e2bcd8739ae039 = $fe2461c5190afbae$var$AddProjectToHistory;

});

parcelRegister("g9zGt", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $ac12849d4f958630$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $ac12849d4f958630$export$6d1402fb58384e4f);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $ac12849d4f958630$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $ac12849d4f958630$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.500"
    }, children);
const $ac12849d4f958630$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: hideMargin ? $ac12849d4f958630$var$pageLayoutWithoutMarginStyles : $ac12849d4f958630$var$pageLayoutWithMarginStyles
    }, children);
const $ac12849d4f958630$var$scrollablePageStyles = (0, $1ZAYh.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $ac12849d4f958630$var$pageLayoutWithoutMarginStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0'
});
const $ac12849d4f958630$var$pageLayoutWithMarginStyles = (0, $1ZAYh.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});

});

parcelRegister("4QWEf", function(module, exports) {

$parcel$export(module.exports, "projectComponentsPageLoad", () => $136e7754739c20a5$export$4b4575b030c402bb);

var $lNfG4 = parcelRequire("lNfG4");
const $136e7754739c20a5$export$4b4575b030c402bb = (0, $lNfG4.metrics).pageLoad({
    key: 'project-components',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-project-components.c186221a.js.map
